import _asyncToGenerator from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/usr/src/app/www/node_modules/@babel/runtime/regenerator/index.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/esnext.global-this.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var gt = Object.defineProperty,
    vi = Object.defineProperties;
var Ni = Object.getOwnPropertyDescriptors;
var to = Object.getOwnPropertySymbols;
var ir = Object.prototype.hasOwnProperty,
    sr = Object.prototype.propertyIsEnumerable;

var ar = function ar(t, r, i) {
  return r in t ? gt(t, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : t[r] = i;
},
    n = function n(t, r) {
  for (var i in r || (r = {})) {
    ir.call(r, i) && ar(t, i, r[i]);
  }

  if (to) {
    var _iterator = _createForOfIteratorHelper(to(r)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var i = _step.value;
        sr.call(r, i) && ar(t, i, r[i]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    $1 = function $1(t, r) {
  return vi(t, Ni(r));
};

var s = function s(t, r) {
  return gt(t, "name", {
    value: r,
    configurable: !0
  });
};

var m = function m(t, r) {
  var i = {};

  for (var o in t) {
    ir.call(t, o) && r.indexOf(o) < 0 && (i[o] = t[o]);
  }

  if (t != null && to) {
    var _iterator2 = _createForOfIteratorHelper(to(t)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var o = _step2.value;
        r.indexOf(o) < 0 && sr.call(t, o) && (i[o] = t[o]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return i;
};

var nr = function nr(t, r) {
  for (var i in r) {
    gt(t, i, {
      get: r[i],
      enumerable: !0
    });
  }
};

import * as e from "react";
var xi = {};
nr(xi, {
  AmplifyProvider: function AmplifyProvider() {
    return Zi;
  },
  Authenticator: function Authenticator() {
    return S1;
  },
  useAuthenticator: function useAuthenticator() {
    return N;
  },
  withAuthenticator: function withAuthenticator() {
    return Mi;
  }
});
import * as he from "react";
import { createTheme as bi } from "@aws-amplify/ui";
import * as mr from "react";
import { defaultTheme as yi } from "@aws-amplify/ui";
var pe = mr.createContext({
  theme: yi
});

function Zi(_ref) {
  var t = _ref.children,
      r = _ref.colorMode,
      i = _ref.theme;
  var o = bi(i),
      f = o.name,
      C = o.cssText;
  return he.useEffect(function () {
    if (document && document.documentElement) {
      var g = document.documentElement.getAttribute("data-amplify-theme"),
          u = document.documentElement.getAttribute("data-amplify-color-mode");
      return document.documentElement.setAttribute("data-amplify-theme", f), document.documentElement.setAttribute("data-amplify-color-mode", r || ""), s(function () {
        document.documentElement.setAttribute("data-amplify-theme", g), document.documentElement.setAttribute("data-amplify-color-mode", u);
      }, "cleanup");
    }
  }, [f, r]), he.createElement(pe.Provider, {
    value: {
      theme: o
    }
  }, he.createElement("div", {
    "data-amplify-theme": f,
    "data-amplify-color-mode": r
  }, t), typeof i == "undefined" ? null : he.createElement("style", {
    id: "amplify-theme-".concat(f),
    dangerouslySetInnerHTML: {
      __html: C
    }
  }));
}

s(Zi, "AmplifyProvider");
import * as d1 from "react";
import * as V1 from "react";
import { createAuthenticatorMachine as Bi, getSendEventAliases as Wi, getServiceContextFacade as ki, listenToAuthHub as Di } from "@aws-amplify/ui";
import { useSelector as Pi, useInterpret as Si } from "@xstate/react";
import ji from "lodash/isEmpty";
var cr = s(function (t, r) {
  return t.length !== r.length ? !1 : t.every(function (i, o) {
    return i === r[o];
  });
}, "areArraysEqual");
var lr = s(function (t) {
  var r = new FormData(t.target);
  return Object.fromEntries(r);
}, "getFormDataFromEvent");
var ut = V1.createContext({}),
    wt = s(function (_ref2) {
  var t = _ref2.children;
  var r = V1.useContext(ut),
      o = {
    service: Si(Bi)
  },
      f = ji(r) ? o : r,
      C = f.service.send;
  return V1.useEffect(function () {
    return Di(C);
  }, []), V1.createElement(ut.Provider, {
    value: f
  }, t);
}, "Provider"),
    N = s(function (t) {
  var _V1$useContext = V1.useContext(ut),
      r = _V1$useContext.service,
      i = r.send,
      o = V1.useMemo(function () {
    return Wi(i);
  }, [r]),
      f = s(function (w) {
    return n(n({}, o), ki(w));
  }, "getFacade"),
      u = Pi(r, s(function (w) {
    return w;
  }, "xstateSelector"), s(function (w, d) {
    if (!t) return !1;
    var V = f(w),
        H = f(d),
        M = t(V),
        x = t(H);
    return cr(M, x);
  }, "comparator"));

  return $1(n({}, f(u)), {
    _state: u,
    _send: i
  });
}, "useAuthenticator");
import * as w1 from "react";
import { translate as v1 } from "@aws-amplify/ui";
import { useCallback as dt } from "react";

function T() {
  var _N2 = N(),
      t = _N2.submitForm,
      r = _N2.updateBlur,
      i = _N2.updateForm,
      o = dt(function (_ref3) {
    var g = _ref3.target.name;
    r({
      name: g
    });
  }, [r]),
      f = dt(function (_ref4) {
    var _ref4$target = _ref4.target,
        g = _ref4$target.checked,
        u = _ref4$target.name,
        w = _ref4$target.type,
        d = _ref4$target.value;
    i({
      name: u,
      value: w === "checkbox" && !g ? void 0 : d
    });
  }, [i]),
      C = dt(function (g) {
    g.preventDefault(), t(lr(g));
  }, [t]);

  return {
    handleBlur: o,
    handleChange: f,
    handleSubmit: C
  };
}

s(T, "useFormHandlers");
import * as mt from "react";
import * as t1 from "react";
import { translate as eo, hasTranslation as iK } from "@aws-amplify/ui";
import { FederatedIdentityProviders as ro, translate as io } from "@aws-amplify/ui";
var Yi = s(function () {
  return e.createElement("svg", {
    "aria-label": "Apple icon",
    className: "amplify-icon federated-sign-in-icon",
    fill: "#000",
    preserveAspectRatio: "xMidYMid",
    stroke: "#000",
    strokeWidth: "0",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z"
  }));
}, "AppleIcon"),
    Fi = s(function () {
  return e.createElement("svg", {
    "aria-label": "Google icon",
    className: "amplify-icon federated-sign-in-icon",
    viewBox: "0 0 256 262",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, e.createElement("path", {
    d: "M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027",
    fill: "#4285F4"
  }), e.createElement("path", {
    d: "M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1",
    fill: "#34A853"
  }), e.createElement("path", {
    d: "M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782",
    fill: "#FBBC05"
  }), e.createElement("path", {
    d: "M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251",
    fill: "#EB4335"
  }));
}, "GoogleIcon"),
    Ti = s(function () {
  return e.createElement(fe, {
    className: "federated-sign-in-icon",
    ariaLabel: "Facebook icon",
    viewBox: {
      minX: 0,
      minY: 0,
      width: 279,
      height: 538
    },
    pathData: "M82.3409742,538 L82.3409742,292.936652 L0,292.936652 L0,196.990154 L82.2410458,196.990154 L82.2410458,126.4295 C82.2410458,44.575144 132.205229,0 205.252865,0 C240.227794,0 270.306232,2.59855099 279,3.79788222 L279,89.2502322 L228.536175,89.2502322 C188.964542,89.2502322 181.270057,108.139699 181.270057,135.824262 L181.270057,196.89021 L276.202006,196.89021 L263.810888,292.836708 L181.16913,292.836708 L181.16913,538 L82.3409742,538 Z",
    fill: "#1877F2"
  });
}, "FacebookIcon"),
    Ai = s(function () {
  return e.createElement("svg", {
    "aria-label": "Amazon icon",
    className: "amplify-icon federated-sign-in-icon",
    viewBox: "0 0 243 264",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, e.createElement("path", {
    d: "M230.826 208.039C227.468 203.683 208.551 205.982 200.056 206.998C197.471 207.321 197.076 205.042 199.407 203.405C214.475 192.665 239.201 195.766 242.082 199.364C244.966 202.982 241.337 228.071 227.173 240.049C225.001 241.888 222.93 240.904 223.898 238.468C227.077 230.431 234.205 212.419 230.826 208.039ZM123.769 264C71.0234 264 39.0764 241.955 14.7853 217.542C9.97339 212.706 3.71799 206.296 0.311513 200.691C-1.09773 198.372 2.59096 195.022 5.04421 196.844C35.239 219.268 79.1012 239.538 122.53 239.538C151.82 239.538 188.046 227.47 217.669 214.868C222.147 212.966 222.147 219.18 221.512 221.061C221.183 222.032 206.515 236.221 186.247 247.047C167.304 257.166 143.397 264 123.769 264Z",
    fill: "#F2541B"
  }), e.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.943 111.185C142.943 124.756 143.268 136.054 136.406 148.123C130.856 157.913 122.027 163.95 112.222 163.95C98.8288 163.95 90.9806 153.772 90.9806 138.693C90.9806 109.036 117.677 103.647 142.943 103.647V111.185ZM178.166 196.081C175.858 198.15 171.635 198.22 169.914 196.894C157.974 187.684 149.89 173.688 149.89 173.688C130.706 193.156 117.127 199 92.2879 199C62.8772 199 40 180.905 40 144.729C40 116.461 55.3552 97.2408 77.2563 87.823C96.2094 79.5256 122.684 78.0173 142.943 75.7517C142.943 75.7517 144.633 53.933 138.699 45.9806C134.098 39.8163 126.272 36.9329 119.089 36.9329C106.127 36.8829 93.61 43.9051 91.1262 57.4188C90.4136 61.2829 87.5533 64.5261 84.54 64.206L51.0823 60.5922C48.5156 60.2951 45.0381 57.6639 45.8636 53.3081C53.644 12.3684 90.7373 0 123.989 0C140.983 0 163.21 4.51651 176.608 17.3349C193.597 33.1648 191.969 54.2755 191.969 77.2722V131.51C191.969 147.835 198.768 154.987 205.151 163.775C207.376 166.953 207.886 170.714 205.04 173.032C197.902 178.999 178.166 196.081 178.166 196.081Z",
    fill: "#F2541B"
  }));
}, "AmazonIcon"),
    Te = s(function (t) {
  var r = t.icon,
      i = t.provider,
      o = t.text,
      _N3 = N(),
      f = _N3._send,
      C = s(function (u) {
    u.preventDefault(), f({
      type: "FEDERATED_SIGN_IN",
      data: {
        provider: i
      }
    });
  }, "handleClick"),
      g;

  return r === "facebook" ? g = e.createElement(Ti, null) : r === "google" ? g = e.createElement(Fi, null) : r === "amazon" ? g = e.createElement(Ai, null) : r === "apple" && (g = e.createElement(Yi, null)), e.createElement(Z, {
    onClick: C,
    className: "federated-sign-in-button",
    fontWeight: "normal",
    gap: "1rem"
  }, g, e.createElement(G, {
    as: "span"
  }, o));
}, "FederatedSignInButton");

function so() {
  var _N4 = N(),
      t = _N4._state,
      r = _N4.route,
      _t$context$config$soc = t.context.config.socialProviders,
      i = _t$context$config$soc === void 0 ? [] : _t$context$config$soc;

  if (i.length === 0) return null;
  var o = r === "signUp" ? "Up" : "In";
  return e.createElement(I, {
    direction: "column",
    padding: "0 0 1rem 0",
    className: "federated-sign-in-container"
  }, i.map(function (f) {
    switch (f) {
      case "amazon":
        return e.createElement(Te, {
          icon: "amazon",
          key: f,
          provider: ro.Amazon,
          text: io("Sign ".concat(o, " with Amazon"))
        });

      case "apple":
        return e.createElement(Te, {
          icon: "apple",
          key: f,
          provider: ro.Apple,
          text: io("Sign ".concat(o, " with Apple"))
        });

      case "facebook":
        return e.createElement(Te, {
          icon: "facebook",
          key: f,
          provider: ro.Facebook,
          text: io("Sign ".concat(o, " with Facebook"))
        });

      case "google":
        return e.createElement(Te, {
          icon: "google",
          key: f,
          provider: ro.Google,
          text: io("Sign ".concat(o, " with Google"))
        });

      default:
        console.error("Authenicator does not support ".concat(f, ". Please open an issue: https://github.com/aws-amplify/amplify-ui/issues/choose"));
    }
  }), e.createElement(Ce, {
    size: "small",
    label: "or"
  }));
}

s(so, "FederatedSignIn");
import { translate as uuo } from "@aws-amplify/ui";
var li = {};
nr(li, {
  Alert: function Alert() {
    return Ve;
  },
  Badge: function Badge() {
    return lo;
  },
  Button: function Button() {
    return Z;
  },
  ButtonGroup: function ButtonGroup() {
    return He;
  },
  Card: function Card() {
    return ho;
  },
  CheckboxField: function CheckboxField() {
    return Mo;
  },
  Collection: function Collection() {
    return No;
  },
  ComponentClassNames: function ComponentClassNames() {
    return a;
  },
  ComponentClassObject: function ComponentClassObject() {
    return Vt;
  },
  ComponentPropsToStylePropsMap: function ComponentPropsToStylePropsMap() {
    return Ae;
  },
  ComponentPropsToStylePropsMapKeys: function ComponentPropsToStylePropsMapKeys() {
    return Ei;
  },
  Divider: function Divider() {
    return Ce;
  },
  Expander: function Expander() {
    return bo;
  },
  ExpanderItem: function ExpanderItem() {
    return Zo;
  },
  FieldGroupIcon: function FieldGroupIcon() {
    return xe;
  },
  FieldGroupIconButton: function FieldGroupIconButton() {
    return M1;
  },
  Flex: function Flex() {
    return I;
  },
  Grid: function Grid() {
    return Le;
  },
  Heading: function Heading() {
    return U;
  },
  Icon: function Icon() {
    return fe;
  },
  Icon360: function Icon360() {
    return fs;
  },
  Icon3dRotation: function Icon3dRotation() {
    return gs;
  },
  Icon4k: function Icon4k() {
    return ws;
  },
  Icon5g: function Icon5g() {
    return Vs;
  },
  Icon6FtApart: function Icon6FtApart() {
    return Ms;
  },
  IconAcUnit: function IconAcUnit() {
    return Is;
  },
  IconAccessAlarm: function IconAccessAlarm() {
    return vs;
  },
  IconAccessAlarms: function IconAccessAlarms() {
    return ys;
  },
  IconAccessTime: function IconAccessTime() {
    return Zs;
  },
  IconAccessibility: function IconAccessibility() {
    return Ds;
  },
  IconAccessibilityNew: function IconAccessibilityNew() {
    return Ws;
  },
  IconAccessible: function IconAccessible() {
    return Ys;
  },
  IconAccessibleForward: function IconAccessibleForward() {
    return Ss;
  },
  IconAccountBalance: function IconAccountBalance() {
    return Es;
  },
  IconAccountBalanceWallet: function IconAccountBalanceWallet() {
    return Ts;
  },
  IconAccountBox: function IconAccountBox() {
    return _s;
  },
  IconAccountCircle: function IconAccountCircle() {
    return Us;
  },
  IconAccountTree: function IconAccountTree() {
    return Xs;
  },
  IconAdUnits: function IconAdUnits() {
    return qs;
  },
  IconAdb: function IconAdb() {
    return Js;
  },
  IconAdd: function IconAdd() {
    return Nt;
  },
  IconAddAPhoto: function IconAddAPhoto() {
    return Rs;
  },
  IconAddAlarm: function IconAddAlarm() {
    return oa;
  },
  IconAddAlert: function IconAddAlert() {
    return ra;
  },
  IconAddBox: function IconAddBox() {
    return sa;
  },
  IconAddBusiness: function IconAddBusiness() {
    return na;
  },
  IconAddCircle: function IconAddCircle() {
    return pa;
  },
  IconAddCircleOutline: function IconAddCircleOutline() {
    return ca;
  },
  IconAddComment: function IconAddComment() {
    return fa;
  },
  IconAddIcCall: function IconAddIcCall() {
    return ga;
  },
  IconAddLocation: function IconAddLocation() {
    return Va;
  },
  IconAddLocationAlt: function IconAddLocationAlt() {
    return wa;
  },
  IconAddPhotoAlternate: function IconAddPhotoAlternate() {
    return Ma;
  },
  IconAddRoad: function IconAddRoad() {
    return Ia;
  },
  IconAddShoppingCart: function IconAddShoppingCart() {
    return va;
  },
  IconAddTask: function IconAddTask() {
    return ya;
  },
  IconAddToHomeScreen: function IconAddToHomeScreen() {
    return Za;
  },
  IconAddToPhotos: function IconAddToPhotos() {
    return Wa;
  },
  IconAddToQueue: function IconAddToQueue() {
    return Da;
  },
  IconAddchart: function IconAddchart() {
    return ja;
  },
  IconAdjust: function IconAdjust() {
    return Fa;
  },
  IconAdminPanelSettings: function IconAdminPanelSettings() {
    return Aa;
  },
  IconAgriculture: function IconAgriculture() {
    return Oa;
  },
  IconAirlineSeatFlat: function IconAirlineSeatFlat() {
    return za;
  },
  IconAirlineSeatFlatAngled: function IconAirlineSeatFlatAngled() {
    return Ga;
  },
  IconAirlineSeatIndividualSuite: function IconAirlineSeatIndividualSuite() {
    return Ka;
  },
  IconAirlineSeatLegroomExtra: function IconAirlineSeatLegroomExtra() {
    return Qa;
  },
  IconAirlineSeatLegroomNormal: function IconAirlineSeatLegroomNormal() {
    return $a;
  },
  IconAirlineSeatLegroomReduced: function IconAirlineSeatLegroomReduced() {
    return en;
  },
  IconAirlineSeatReclineExtra: function IconAirlineSeatReclineExtra() {
    return tn;
  },
  IconAirlineSeatReclineNormal: function IconAirlineSeatReclineNormal() {
    return sn;
  },
  IconAirplanemodeActive: function IconAirplanemodeActive() {
    return nn;
  },
  IconAirplanemodeInactive: function IconAirplanemodeInactive() {
    return cn;
  },
  IconAirplay: function IconAirplay() {
    return pn;
  },
  IconAirportShuttle: function IconAirportShuttle() {
    return fn;
  },
  IconAlarm: function IconAlarm() {
    return Mn;
  },
  IconAlarmAdd: function IconAlarmAdd() {
    return gn;
  },
  IconAlarmOff: function IconAlarmOff() {
    return wn;
  },
  IconAlarmOn: function IconAlarmOn() {
    return Vn;
  },
  IconAlbum: function IconAlbum() {
    return In;
  },
  IconAllInbox: function IconAllInbox() {
    return vn;
  },
  IconAllInclusive: function IconAllInclusive() {
    return yn;
  },
  IconAllOut: function IconAllOut() {
    return Zn;
  },
  IconAltRoute: function IconAltRoute() {
    return Wn;
  },
  IconAlternateEmail: function IconAlternateEmail() {
    return Dn;
  },
  IconAmpStories: function IconAmpStories() {
    return Sn;
  },
  IconAnalytics: function IconAnalytics() {
    return Yn;
  },
  IconAnchor: function IconAnchor() {
    return Tn;
  },
  IconAndroid: function IconAndroid() {
    return En;
  },
  IconAnnouncement: function IconAnnouncement() {
    return _n;
  },
  IconApartment: function IconApartment() {
    return Un;
  },
  IconApi: function IconApi() {
    return Xn;
  },
  IconAppBlocking: function IconAppBlocking() {
    return qn;
  },
  IconAppSettingsAlt: function IconAppSettingsAlt() {
    return Jn;
  },
  IconApps: function IconApps() {
    return Rn;
  },
  IconArchitecture: function IconArchitecture() {
    return o2;
  },
  IconArchive: function IconArchive() {
    return r2;
  },
  IconArrowBack: function IconArrowBack() {
    return n2;
  },
  IconArrowBackIos: function IconArrowBackIos() {
    return s2;
  },
  IconArrowCircleDown: function IconArrowCircleDown() {
    return c2;
  },
  IconArrowCircleUp: function IconArrowCircleUp() {
    return p2;
  },
  IconArrowDownward: function IconArrowDownward() {
    return f2;
  },
  IconArrowDropDown: function IconArrowDropDown() {
    return w2;
  },
  IconArrowDropDownCircle: function IconArrowDropDownCircle() {
    return g2;
  },
  IconArrowDropUp: function IconArrowDropUp() {
    return V2;
  },
  IconArrowForward: function IconArrowForward() {
    return I2;
  },
  IconArrowForwardIos: function IconArrowForwardIos() {
    return M2;
  },
  IconArrowLeft: function IconArrowLeft() {
    return v2;
  },
  IconArrowRight: function IconArrowRight() {
    return Z2;
  },
  IconArrowRightAlt: function IconArrowRightAlt() {
    return y2;
  },
  IconArrowUpward: function IconArrowUpward() {
    return W2;
  },
  IconArtTrack: function IconArtTrack() {
    return D2;
  },
  IconArticle: function IconArticle() {
    return S2;
  },
  IconAspectRatio: function IconAspectRatio() {
    return Y2;
  },
  IconAssessment: function IconAssessment() {
    return T2;
  },
  IconAssignment: function IconAssignment() {
    return J2;
  },
  IconAssignmentInd: function IconAssignmentInd() {
    return E2;
  },
  IconAssignmentLate: function IconAssignmentLate() {
    return _2;
  },
  IconAssignmentReturn: function IconAssignmentReturn() {
    return U2;
  },
  IconAssignmentReturned: function IconAssignmentReturned() {
    return X2;
  },
  IconAssignmentTurnedIn: function IconAssignmentTurnedIn() {
    return q2;
  },
  IconAssistant: function IconAssistant() {
    return om;
  },
  IconAssistantPhoto: function IconAssistantPhoto() {
    return R2;
  },
  IconAtm: function IconAtm() {
    return rm;
  },
  IconAttachEmail: function IconAttachEmail() {
    return sm;
  },
  IconAttachFile: function IconAttachFile() {
    return nm;
  },
  IconAttachMoney: function IconAttachMoney() {
    return cm;
  },
  IconAttachment: function IconAttachment() {
    return pm;
  },
  IconAttribution: function IconAttribution() {
    return fm;
  },
  IconAudiotrack: function IconAudiotrack() {
    return gm;
  },
  IconAutoDelete: function IconAutoDelete() {
    return wm;
  },
  IconAutorenew: function IconAutorenew() {
    return Vm;
  },
  IconAvTimer: function IconAvTimer() {
    return Mm;
  },
  IconBabyChangingStation: function IconBabyChangingStation() {
    return Im;
  },
  IconBackpack: function IconBackpack() {
    return vm;
  },
  IconBackspace: function IconBackspace() {
    return ym;
  },
  IconBackup: function IconBackup() {
    return Wm;
  },
  IconBackupTable: function IconBackupTable() {
    return Zm;
  },
  IconBallot: function IconBallot() {
    return Dm;
  },
  IconBarChart: function IconBarChart() {
    return Sm;
  },
  IconBatchPrediction: function IconBatchPrediction() {
    return Ym;
  },
  IconBathtub: function IconBathtub() {
    return Tm;
  },
  IconBatteryAlert: function IconBatteryAlert() {
    return Em;
  },
  IconBatteryChargingFull: function IconBatteryChargingFull() {
    return _m;
  },
  IconBatteryFull: function IconBatteryFull() {
    return Um;
  },
  IconBatteryStd: function IconBatteryStd() {
    return Xm;
  },
  IconBatteryUnknown: function IconBatteryUnknown() {
    return qm;
  },
  IconBeachAccess: function IconBeachAccess() {
    return Jm;
  },
  IconBedtime: function IconBedtime() {
    return Rm;
  },
  IconBeenhere: function IconBeenhere() {
    return oc;
  },
  IconBento: function IconBento() {
    return rc;
  },
  IconBikeScooter: function IconBikeScooter() {
    return sc;
  },
  IconBiotech: function IconBiotech() {
    return nc;
  },
  IconBlock: function IconBlock() {
    return cc;
  },
  IconBluetooth: function IconBluetooth() {
    return Vc;
  },
  IconBluetoothAudio: function IconBluetoothAudio() {
    return pc;
  },
  IconBluetoothConnected: function IconBluetoothConnected() {
    return fc;
  },
  IconBluetoothDisabled: function IconBluetoothDisabled() {
    return gc;
  },
  IconBluetoothSearching: function IconBluetoothSearching() {
    return wc;
  },
  IconBlurCircular: function IconBlurCircular() {
    return Mc;
  },
  IconBlurLinear: function IconBlurLinear() {
    return Ic;
  },
  IconBlurOff: function IconBlurOff() {
    return vc;
  },
  IconBlurOn: function IconBlurOn() {
    return yc;
  },
  IconBook: function IconBook() {
    return Wc;
  },
  IconBookOnline: function IconBookOnline() {
    return Zc;
  },
  IconBookmark: function IconBookmark() {
    return Sc;
  },
  IconBookmarkBorder: function IconBookmarkBorder() {
    return Dc;
  },
  IconBookmarks: function IconBookmarks() {
    return Yc;
  },
  IconBorderAll: function IconBorderAll() {
    return Tc;
  },
  IconBorderBottom: function IconBorderBottom() {
    return Ec;
  },
  IconBorderClear: function IconBorderClear() {
    return _c;
  },
  IconBorderHorizontal: function IconBorderHorizontal() {
    return Uc;
  },
  IconBorderInner: function IconBorderInner() {
    return Xc;
  },
  IconBorderLeft: function IconBorderLeft() {
    return qc;
  },
  IconBorderOuter: function IconBorderOuter() {
    return Jc;
  },
  IconBorderRight: function IconBorderRight() {
    return Rc;
  },
  IconBorderStyle: function IconBorderStyle() {
    return o9;
  },
  IconBorderTop: function IconBorderTop() {
    return r9;
  },
  IconBorderVertical: function IconBorderVertical() {
    return s9;
  },
  IconBrandingWatermark: function IconBrandingWatermark() {
    return n9;
  },
  IconBrightnessAuto: function IconBrightnessAuto() {
    return I9;
  },
  IconBrightnessHigh: function IconBrightnessHigh() {
    return v9;
  },
  IconBrightnessLow: function IconBrightnessLow() {
    return y9;
  },
  IconBrightnessMedium: function IconBrightnessMedium() {
    return Z9;
  },
  IconBrightness_1: function IconBrightness_1() {
    return c9;
  },
  IconBrightness_2: function IconBrightness_2() {
    return p9;
  },
  IconBrightness_3: function IconBrightness_3() {
    return f9;
  },
  IconBrightness_4: function IconBrightness_4() {
    return g9;
  },
  IconBrightness_5: function IconBrightness_5() {
    return w9;
  },
  IconBrightness_6: function IconBrightness_6() {
    return V9;
  },
  IconBrightness_7: function IconBrightness_7() {
    return M9;
  },
  IconBrokenImage: function IconBrokenImage() {
    return W9;
  },
  IconBrowserNotSupported: function IconBrowserNotSupported() {
    return D9;
  },
  IconBrush: function IconBrush() {
    return S9;
  },
  IconBubbleChart: function IconBubbleChart() {
    return Y9;
  },
  IconBugReport: function IconBugReport() {
    return T9;
  },
  IconBuild: function IconBuild() {
    return _9;
  },
  IconBuildCircle: function IconBuildCircle() {
    return E9;
  },
  IconBurstMode: function IconBurstMode() {
    return U9;
  },
  IconBusiness: function IconBusiness() {
    return q9;
  },
  IconBusinessCenter: function IconBusinessCenter() {
    return X9;
  },
  IconCached: function IconCached() {
    return J9;
  },
  IconCake: function IconCake() {
    return R9;
  },
  IconCalculate: function IconCalculate() {
    return o0;
  },
  IconCalendarToday: function IconCalendarToday() {
    return r0;
  },
  IconCalendarViewDay: function IconCalendarViewDay() {
    return s0;
  },
  IconCall: function IconCall() {
    return I0;
  },
  IconCallEnd: function IconCallEnd() {
    return n0;
  },
  IconCallMade: function IconCallMade() {
    return c0;
  },
  IconCallMerge: function IconCallMerge() {
    return p0;
  },
  IconCallMissed: function IconCallMissed() {
    return g0;
  },
  IconCallMissedOutgoing: function IconCallMissedOutgoing() {
    return f0;
  },
  IconCallReceived: function IconCallReceived() {
    return w0;
  },
  IconCallSplit: function IconCallSplit() {
    return V0;
  },
  IconCallToAction: function IconCallToAction() {
    return M0;
  },
  IconCamera: function IconCamera() {
    return S0;
  },
  IconCameraAlt: function IconCameraAlt() {
    return v0;
  },
  IconCameraEnhance: function IconCameraEnhance() {
    return y0;
  },
  IconCameraFront: function IconCameraFront() {
    return Z0;
  },
  IconCameraRear: function IconCameraRear() {
    return W0;
  },
  IconCameraRoll: function IconCameraRoll() {
    return D0;
  },
  IconCampaign: function IconCampaign() {
    return Y0;
  },
  IconCancel: function IconCancel() {
    return _0;
  },
  IconCancelPresentation: function IconCancelPresentation() {
    return T0;
  },
  IconCancelScheduleSend: function IconCancelScheduleSend() {
    return E0;
  },
  IconCardGiftcard: function IconCardGiftcard() {
    return U0;
  },
  IconCardMembership: function IconCardMembership() {
    return X0;
  },
  IconCardTravel: function IconCardTravel() {
    return q0;
  },
  IconCarpenter: function IconCarpenter() {
    return J0;
  },
  IconCasino: function IconCasino() {
    return R0;
  },
  IconCast: function IconCast() {
    return sl;
  },
  IconCastConnected: function IconCastConnected() {
    return ol;
  },
  IconCastForEducation: function IconCastForEducation() {
    return rl;
  },
  IconCategory: function IconCategory() {
    return nl;
  },
  IconCenterFocusStrong: function IconCenterFocusStrong() {
    return cl;
  },
  IconCenterFocusWeak: function IconCenterFocusWeak() {
    return pl;
  },
  IconChangeHistory: function IconChangeHistory() {
    return fl;
  },
  IconChargingStation: function IconChargingStation() {
    return gl;
  },
  IconChat: function IconChat() {
    return Ml;
  },
  IconChatBubble: function IconChatBubble() {
    return Vl;
  },
  IconChatBubbleOutline: function IconChatBubbleOutline() {
    return wl;
  },
  IconCheck: function IconCheck() {
    return bt;
  },
  IconCheckBox: function IconCheckBox() {
    return vl;
  },
  IconCheckBoxOutlineBlank: function IconCheckBoxOutlineBlank() {
    return Il;
  },
  IconCheckCircle: function IconCheckCircle() {
    return yt;
  },
  IconCheckCircleOutline: function IconCheckCircleOutline() {
    return yl;
  },
  IconCheckroom: function IconCheckroom() {
    return Wl;
  },
  IconChevronLeft: function IconChevronLeft() {
    return Zt;
  },
  IconChevronRight: function IconChevronRight() {
    return Bt;
  },
  IconChildCare: function IconChildCare() {
    return Sl;
  },
  IconChildFriendly: function IconChildFriendly() {
    return Yl;
  },
  IconChromeReaderMode: function IconChromeReaderMode() {
    return Tl;
  },
  IconClass: function IconClass() {
    return El;
  },
  IconCleanHands: function IconCleanHands() {
    return _l;
  },
  IconCleaningServices: function IconCleaningServices() {
    return Ul;
  },
  IconClear: function IconClear() {
    return ql;
  },
  IconClearAll: function IconClearAll() {
    return Xl;
  },
  IconClose: function IconClose() {
    return _e;
  },
  IconCloseFullscreen: function IconCloseFullscreen() {
    return Jl;
  },
  IconClosedCaption: function IconClosedCaption() {
    return tp;
  },
  IconClosedCaptionDisabled: function IconClosedCaptionDisabled() {
    return ep;
  },
  IconCloud: function IconCloud() {
    return up;
  },
  IconCloudCircle: function IconCloudCircle() {
    return ip;
  },
  IconCloudDone: function IconCloudDone() {
    return ap;
  },
  IconCloudDownload: function IconCloudDownload() {
    return mp;
  },
  IconCloudOff: function IconCloudOff() {
    return lp;
  },
  IconCloudQueue: function IconCloudQueue() {
    return hp;
  },
  IconCloudUpload: function IconCloudUpload() {
    return Cp;
  },
  IconCode: function IconCode() {
    return dp;
  },
  IconCollections: function IconCollections() {
    return xp;
  },
  IconCollectionsBookmark: function IconCollectionsBookmark() {
    return Hp;
  },
  IconColorLens: function IconColorLens() {
    return Lp;
  },
  IconColorize: function IconColorize() {
    return Np;
  },
  IconComment: function IconComment() {
    return Bp;
  },
  IconCommentBank: function IconCommentBank() {
    return bp;
  },
  IconCommute: function IconCommute() {
    return kp;
  },
  IconCompare: function IconCompare() {
    return jp;
  },
  IconCompareArrows: function IconCompareArrows() {
    return Pp;
  },
  IconCompassCalibration: function IconCompassCalibration() {
    return Fp;
  },
  IconComputer: function IconComputer() {
    return Ap;
  },
  IconConfirmationNumber: function IconConfirmationNumber() {
    return Op;
  },
  IconConnectWithoutContact: function IconConnectWithoutContact() {
    return Gp;
  },
  IconConstruction: function IconConstruction() {
    return zp;
  },
  IconContactMail: function IconContactMail() {
    return Kp;
  },
  IconContactPage: function IconContactPage() {
    return Qp;
  },
  IconContactPhone: function IconContactPhone() {
    return $p;
  },
  IconContactSupport: function IconContactSupport() {
    return e5;
  },
  IconContactless: function IconContactless() {
    return t5;
  },
  IconContacts: function IconContacts() {
    return i5;
  },
  IconContentCopy: function IconContentCopy() {
    return a5;
  },
  IconContentCut: function IconContentCut() {
    return m5;
  },
  IconContentPaste: function IconContentPaste() {
    return l5;
  },
  IconControlCamera: function IconControlCamera() {
    return h5;
  },
  IconControlPoint: function IconControlPoint() {
    return u5;
  },
  IconControlPointDuplicate: function IconControlPointDuplicate() {
    return C5;
  },
  IconCopyright: function IconCopyright() {
    return d5;
  },
  IconCoronavirus: function IconCoronavirus() {
    return H5;
  },
  IconCorporateFare: function IconCorporateFare() {
    return x5;
  },
  IconCountertops: function IconCountertops() {
    return L5;
  },
  IconCreate: function IconCreate() {
    return b5;
  },
  IconCreateNewFolder: function IconCreateNewFolder() {
    return N5;
  },
  IconCreditCard: function IconCreditCard() {
    return B5;
  },
  IconCrop: function IconCrop() {
    return e4;
  },
  IconCropDin: function IconCropDin() {
    return A5;
  },
  IconCropFree: function IconCropFree() {
    return O5;
  },
  IconCropLandscape: function IconCropLandscape() {
    return G5;
  },
  IconCropOriginal: function IconCropOriginal() {
    return z5;
  },
  IconCropPortrait: function IconCropPortrait() {
    return K5;
  },
  IconCropRotate: function IconCropRotate() {
    return Q5;
  },
  IconCropSquare: function IconCropSquare() {
    return $5;
  },
  IconCrop_16_9: function IconCrop_16_9() {
    return k5;
  },
  IconCrop_3_2: function IconCrop_3_2() {
    return P5;
  },
  IconCrop_5_4: function IconCrop_5_4() {
    return j5;
  },
  IconCrop_7_5: function IconCrop_7_5() {
    return F5;
  },
  IconDashboard: function IconDashboard() {
    return t4;
  },
  IconDataUsage: function IconDataUsage() {
    return i4;
  },
  IconDateRange: function IconDateRange() {
    return a4;
  },
  IconDeck: function IconDeck() {
    return m4;
  },
  IconDehaze: function IconDehaze() {
    return l4;
  },
  IconDelete: function IconDelete() {
    return d4;
  },
  IconDeleteForever: function IconDeleteForever() {
    return h4;
  },
  IconDeleteOutline: function IconDeleteOutline() {
    return C4;
  },
  IconDeleteSweep: function IconDeleteSweep() {
    return u4;
  },
  IconDepartureBoard: function IconDepartureBoard() {
    return H4;
  },
  IconDescription: function IconDescription() {
    return x4;
  },
  IconDesignServices: function IconDesignServices() {
    return L4;
  },
  IconDesktopAccessDisabled: function IconDesktopAccessDisabled() {
    return N4;
  },
  IconDesktopMac: function IconDesktopMac() {
    return b4;
  },
  IconDesktopWindows: function IconDesktopWindows() {
    return B4;
  },
  IconDetails: function IconDetails() {
    return k4;
  },
  IconDeveloperBoard: function IconDeveloperBoard() {
    return P4;
  },
  IconDeveloperMode: function IconDeveloperMode() {
    return j4;
  },
  IconDeviceHub: function IconDeviceHub() {
    return F4;
  },
  IconDeviceUnknown: function IconDeviceUnknown() {
    return A4;
  },
  IconDevices: function IconDevices() {
    return G4;
  },
  IconDevicesOther: function IconDevicesOther() {
    return O4;
  },
  IconDialerSip: function IconDialerSip() {
    return z4;
  },
  IconDialpad: function IconDialpad() {
    return K4;
  },
  IconDirections: function IconDirections() {
    return uh;
  },
  IconDirectionsBike: function IconDirectionsBike() {
    return Q4;
  },
  IconDirectionsBoat: function IconDirectionsBoat() {
    return $4;
  },
  IconDirectionsBus: function IconDirectionsBus() {
    return eh;
  },
  IconDirectionsCar: function IconDirectionsCar() {
    return th;
  },
  IconDirectionsOff: function IconDirectionsOff() {
    return ih;
  },
  IconDirectionsRailway: function IconDirectionsRailway() {
    return ah;
  },
  IconDirectionsRun: function IconDirectionsRun() {
    return mh;
  },
  IconDirectionsSubway: function IconDirectionsSubway() {
    return lh;
  },
  IconDirectionsTransit: function IconDirectionsTransit() {
    return hh;
  },
  IconDirectionsWalk: function IconDirectionsWalk() {
    return Ch;
  },
  IconDisabledByDefault: function IconDisabledByDefault() {
    return dh;
  },
  IconDiscFull: function IconDiscFull() {
    return Hh;
  },
  IconDns: function IconDns() {
    return xh;
  },
  IconDoDisturb: function IconDoDisturb() {
    return Bh;
  },
  IconDoDisturbAlt: function IconDoDisturbAlt() {
    return Lh;
  },
  IconDoDisturbOff: function IconDoDisturbOff() {
    return Nh;
  },
  IconDoDisturbOn: function IconDoDisturbOn() {
    return bh;
  },
  IconDoNotStep: function IconDoNotStep() {
    return kh;
  },
  IconDoNotTouch: function IconDoNotTouch() {
    return Ph;
  },
  IconDock: function IconDock() {
    return jh;
  },
  IconDomain: function IconDomain() {
    return Oh;
  },
  IconDomainDisabled: function IconDomainDisabled() {
    return Fh;
  },
  IconDomainVerification: function IconDomainVerification() {
    return Ah;
  },
  IconDone: function IconDone() {
    return Kh;
  },
  IconDoneAll: function IconDoneAll() {
    return Gh;
  },
  IconDoneOutline: function IconDoneOutline() {
    return zh;
  },
  IconDonutLarge: function IconDonutLarge() {
    return Qh;
  },
  IconDonutSmall: function IconDonutSmall() {
    return $h;
  },
  IconDoubleArrow: function IconDoubleArrow() {
    return e3;
  },
  IconDownload: function IconDownload() {
    return i3;
  },
  IconDownloadDone: function IconDownloadDone() {
    return t3;
  },
  IconDrafts: function IconDrafts() {
    return a3;
  },
  IconDragHandle: function IconDragHandle() {
    return m3;
  },
  IconDragIndicator: function IconDragIndicator() {
    return l3;
  },
  IconDriveEta: function IconDriveEta() {
    return h3;
  },
  IconDry: function IconDry() {
    return C3;
  },
  IconDuo: function IconDuo() {
    return u3;
  },
  IconDvr: function IconDvr() {
    return d3;
  },
  IconDynamicFeed: function IconDynamicFeed() {
    return H3;
  },
  IconDynamicForm: function IconDynamicForm() {
    return x3;
  },
  IconEast: function IconEast() {
    return L3;
  },
  IconEco: function IconEco() {
    return N3;
  },
  IconEdit: function IconEdit() {
    return P3;
  },
  IconEditAttributes: function IconEditAttributes() {
    return b3;
  },
  IconEditLocation: function IconEditLocation() {
    return B3;
  },
  IconEditRoad: function IconEditRoad() {
    return k3;
  },
  IconEject: function IconEject() {
    return j3;
  },
  IconElderly: function IconElderly() {
    return F3;
  },
  IconElectricBike: function IconElectricBike() {
    return A3;
  },
  IconElectricCar: function IconElectricCar() {
    return O3;
  },
  IconElectricMoped: function IconElectricMoped() {
    return G3;
  },
  IconElectricScooter: function IconElectricScooter() {
    return z3;
  },
  IconElectricalServices: function IconElectricalServices() {
    return K3;
  },
  IconElevator: function IconElevator() {
    return Q3;
  },
  IconEmail: function IconEmail() {
    return $3;
  },
  IconEmojiEmotions: function IconEmojiEmotions() {
    return e8;
  },
  IconEmojiEvents: function IconEmojiEvents() {
    return t8;
  },
  IconEmojiFlags: function IconEmojiFlags() {
    return i8;
  },
  IconEmojiFoodBeverage: function IconEmojiFoodBeverage() {
    return a8;
  },
  IconEmojiNature: function IconEmojiNature() {
    return m8;
  },
  IconEmojiObjects: function IconEmojiObjects() {
    return l8;
  },
  IconEmojiPeople: function IconEmojiPeople() {
    return h8;
  },
  IconEmojiSymbols: function IconEmojiSymbols() {
    return C8;
  },
  IconEmojiTransportation: function IconEmojiTransportation() {
    return u8;
  },
  IconEngineering: function IconEngineering() {
    return d8;
  },
  IconEnhancedEncryption: function IconEnhancedEncryption() {
    return H8;
  },
  IconEqualizer: function IconEqualizer() {
    return x8;
  },
  IconError: function IconError() {
    return Wt;
  },
  IconErrorOutline: function IconErrorOutline() {
    return L8;
  },
  IconEscalator: function IconEscalator() {
    return Z8;
  },
  IconEscalatorWarning: function IconEscalatorWarning() {
    return y8;
  },
  IconEuro: function IconEuro() {
    return D8;
  },
  IconEuroSymbol: function IconEuroSymbol() {
    return W8;
  },
  IconEvStation: function IconEvStation() {
    return S8;
  },
  IconEvent: function IconEvent() {
    return U8;
  },
  IconEventAvailable: function IconEventAvailable() {
    return Y8;
  },
  IconEventBusy: function IconEventBusy() {
    return T8;
  },
  IconEventNote: function IconEventNote() {
    return E8;
  },
  IconEventSeat: function IconEventSeat() {
    return _8;
  },
  IconExitToApp: function IconExitToApp() {
    return X8;
  },
  IconExpandLess: function IconExpandLess() {
    return q8;
  },
  IconExpandMore: function IconExpandMore() {
    return Ge;
  },
  IconExplicit: function IconExplicit() {
    return $8;
  },
  IconExplore: function IconExplore() {
    return t7;
  },
  IconExploreOff: function IconExploreOff() {
    return e7;
  },
  IconExposure: function IconExposure() {
    return C7;
  },
  IconExposureNeg_1: function IconExposureNeg_1() {
    return i7;
  },
  IconExposureNeg_2: function IconExposureNeg_2() {
    return a7;
  },
  IconExposurePlus_1: function IconExposurePlus_1() {
    return m7;
  },
  IconExposurePlus_2: function IconExposurePlus_2() {
    return l7;
  },
  IconExposureZero: function IconExposureZero() {
    return h7;
  },
  IconExtension: function IconExtension() {
    return u7;
  },
  IconFace: function IconFace() {
    return H7;
  },
  IconFaceUnlock: function IconFaceUnlock() {
    return d7;
  },
  IconFacebook: function IconFacebook() {
    return x7;
  },
  IconFactCheck: function IconFactCheck() {
    return L7;
  },
  IconFamilyRestroom: function IconFamilyRestroom() {
    return N7;
  },
  IconFastForward: function IconFastForward() {
    return b7;
  },
  IconFastRewind: function IconFastRewind() {
    return B7;
  },
  IconFastfood: function IconFastfood() {
    return k7;
  },
  IconFavorite: function IconFavorite() {
    return j7;
  },
  IconFavoriteBorder: function IconFavoriteBorder() {
    return P7;
  },
  IconFeaturedPlayList: function IconFeaturedPlayList() {
    return F7;
  },
  IconFeaturedVideo: function IconFeaturedVideo() {
    return A7;
  },
  IconFeedback: function IconFeedback() {
    return O7;
  },
  IconFence: function IconFence() {
    return G7;
  },
  IconFiberDvr: function IconFiberDvr() {
    return z7;
  },
  IconFiberManualRecord: function IconFiberManualRecord() {
    return K7;
  },
  IconFiberNew: function IconFiberNew() {
    return Q7;
  },
  IconFiberPin: function IconFiberPin() {
    return $7;
  },
  IconFiberSmartRecord: function IconFiberSmartRecord() {
    return e6;
  },
  IconFileCopy: function IconFileCopy() {
    return t6;
  },
  IconFilter: function IconFilter() {
    return G6;
  },
  IconFilterAlt: function IconFilterAlt() {
    return L6;
  },
  IconFilterBAndW: function IconFilterBAndW() {
    return N6;
  },
  IconFilterCenterFocus: function IconFilterCenterFocus() {
    return b6;
  },
  IconFilterDrama: function IconFilterDrama() {
    return B6;
  },
  IconFilterFrames: function IconFilterFrames() {
    return k6;
  },
  IconFilterHdr: function IconFilterHdr() {
    return P6;
  },
  IconFilterList: function IconFilterList() {
    return j6;
  },
  IconFilterNone: function IconFilterNone() {
    return F6;
  },
  IconFilterTiltShift: function IconFilterTiltShift() {
    return A6;
  },
  IconFilterVintage: function IconFilterVintage() {
    return O6;
  },
  IconFilter_1: function IconFilter_1() {
    return i6;
  },
  IconFilter_2: function IconFilter_2() {
    return a6;
  },
  IconFilter_3: function IconFilter_3() {
    return m6;
  },
  IconFilter_4: function IconFilter_4() {
    return l6;
  },
  IconFilter_5: function IconFilter_5() {
    return h6;
  },
  IconFilter_6: function IconFilter_6() {
    return C6;
  },
  IconFilter_7: function IconFilter_7() {
    return u6;
  },
  IconFilter_8: function IconFilter_8() {
    return d6;
  },
  IconFilter_9: function IconFilter_9() {
    return x6;
  },
  IconFilter_9Plus: function IconFilter_9Plus() {
    return H6;
  },
  IconFindInPage: function IconFindInPage() {
    return z6;
  },
  IconFindReplace: function IconFindReplace() {
    return K6;
  },
  IconFingerprint: function IconFingerprint() {
    return Q6;
  },
  IconFireExtinguisher: function IconFireExtinguisher() {
    return $6;
  },
  IconFireplace: function IconFireplace() {
    return ef;
  },
  IconFirstPage: function IconFirstPage() {
    return tf;
  },
  IconFitnessCenter: function IconFitnessCenter() {
    return sf;
  },
  IconFlag: function IconFlag() {
    return nf;
  },
  IconFlaky: function IconFlaky() {
    return cf;
  },
  IconFlare: function IconFlare() {
    return pf;
  },
  IconFlashAuto: function IconFlashAuto() {
    return ff;
  },
  IconFlashOff: function IconFlashOff() {
    return gf;
  },
  IconFlashOn: function IconFlashOn() {
    return wf;
  },
  IconFlight: function IconFlight() {
    return If;
  },
  IconFlightLand: function IconFlightLand() {
    return Vf;
  },
  IconFlightTakeoff: function IconFlightTakeoff() {
    return Mf;
  },
  IconFlip: function IconFlip() {
    return Df;
  },
  IconFlipCameraAndroid: function IconFlipCameraAndroid() {
    return vf;
  },
  IconFlipCameraIos: function IconFlipCameraIos() {
    return yf;
  },
  IconFlipToBack: function IconFlipToBack() {
    return Zf;
  },
  IconFlipToFront: function IconFlipToFront() {
    return Wf;
  },
  IconFolder: function IconFolder() {
    return Ef;
  },
  IconFolderOpen: function IconFolderOpen() {
    return Sf;
  },
  IconFolderShared: function IconFolderShared() {
    return Yf;
  },
  IconFolderSpecial: function IconFolderSpecial() {
    return Tf;
  },
  IconFollowTheSigns: function IconFollowTheSigns() {
    return _f;
  },
  IconFontDownload: function IconFontDownload() {
    return Uf;
  },
  IconFoodBank: function IconFoodBank() {
    return Xf;
  },
  IconFormatAlignCenter: function IconFormatAlignCenter() {
    return qf;
  },
  IconFormatAlignJustify: function IconFormatAlignJustify() {
    return Jf;
  },
  IconFormatAlignLeft: function IconFormatAlignLeft() {
    return Rf;
  },
  IconFormatAlignRight: function IconFormatAlignRight() {
    return oC;
  },
  IconFormatBold: function IconFormatBold() {
    return rC;
  },
  IconFormatClear: function IconFormatClear() {
    return sC;
  },
  IconFormatColorReset: function IconFormatColorReset() {
    return nC;
  },
  IconFormatIndentDecrease: function IconFormatIndentDecrease() {
    return cC;
  },
  IconFormatIndentIncrease: function IconFormatIndentIncrease() {
    return pC;
  },
  IconFormatItalic: function IconFormatItalic() {
    return fC;
  },
  IconFormatLineSpacing: function IconFormatLineSpacing() {
    return gC;
  },
  IconFormatListBulleted: function IconFormatListBulleted() {
    return wC;
  },
  IconFormatListNumbered: function IconFormatListNumbered() {
    return MC;
  },
  IconFormatListNumberedRtl: function IconFormatListNumberedRtl() {
    return VC;
  },
  IconFormatPaint: function IconFormatPaint() {
    return IC;
  },
  IconFormatQuote: function IconFormatQuote() {
    return vC;
  },
  IconFormatShapes: function IconFormatShapes() {
    return yC;
  },
  IconFormatSize: function IconFormatSize() {
    return ZC;
  },
  IconFormatStrikethrough: function IconFormatStrikethrough() {
    return WC;
  },
  IconFormatTextdirectionLToR: function IconFormatTextdirectionLToR() {
    return DC;
  },
  IconFormatTextdirectionRToL: function IconFormatTextdirectionRToL() {
    return SC;
  },
  IconFormatUnderlined: function IconFormatUnderlined() {
    return YC;
  },
  IconForum: function IconForum() {
    return TC;
  },
  IconForward: function IconForward() {
    return qC;
  },
  IconForwardToInbox: function IconForwardToInbox() {
    return XC;
  },
  IconForward_10: function IconForward_10() {
    return EC;
  },
  IconForward_30: function IconForward_30() {
    return _C;
  },
  IconForward_5: function IconForward_5() {
    return UC;
  },
  IconFoundation: function IconFoundation() {
    return JC;
  },
  IconFreeBreakfast: function IconFreeBreakfast() {
    return RC;
  },
  IconFullscreen: function IconFullscreen() {
    return rg;
  },
  IconFullscreenExit: function IconFullscreenExit() {
    return og;
  },
  IconFunctions: function IconFunctions() {
    return sg;
  },
  IconGTranslate: function IconGTranslate() {
    return ng;
  },
  IconGamepad: function IconGamepad() {
    return cg;
  },
  IconGames: function IconGames() {
    return pg;
  },
  IconGavel: function IconGavel() {
    return fg;
  },
  IconGesture: function IconGesture() {
    return gg;
  },
  IconGetApp: function IconGetApp() {
    return wg;
  },
  IconGif: function IconGif() {
    return Vg;
  },
  IconGolfCourse: function IconGolfCourse() {
    return Mg;
  },
  IconGpsFixed: function IconGpsFixed() {
    return Ig;
  },
  IconGpsNotFixed: function IconGpsNotFixed() {
    return vg;
  },
  IconGpsOff: function IconGpsOff() {
    return yg;
  },
  IconGrade: function IconGrade() {
    return Zg;
  },
  IconGradient: function IconGradient() {
    return Wg;
  },
  IconGrading: function IconGrading() {
    return Dg;
  },
  IconGrain: function IconGrain() {
    return Sg;
  },
  IconGraphicEq: function IconGraphicEq() {
    return Yg;
  },
  IconGrass: function IconGrass() {
    return Tg;
  },
  IconGridOff: function IconGridOff() {
    return Eg;
  },
  IconGridOn: function IconGridOn() {
    return _g;
  },
  IconGroup: function IconGroup() {
    return qg;
  },
  IconGroupAdd: function IconGroupAdd() {
    return Ug;
  },
  IconGroupWork: function IconGroupWork() {
    return Xg;
  },
  IconGroups: function IconGroups() {
    return Jg;
  },
  IconHandyman: function IconHandyman() {
    return Rg;
  },
  IconHd: function IconHd() {
    return ou;
  },
  IconHdrOff: function IconHdrOff() {
    return ru;
  },
  IconHdrOn: function IconHdrOn() {
    return su;
  },
  IconHdrStrong: function IconHdrStrong() {
    return nu;
  },
  IconHdrWeak: function IconHdrWeak() {
    return cu;
  },
  IconHeadset: function IconHeadset() {
    return fu;
  },
  IconHeadsetMic: function IconHeadsetMic() {
    return pu;
  },
  IconHealing: function IconHealing() {
    return gu;
  },
  IconHearing: function IconHearing() {
    return Vu;
  },
  IconHearingDisabled: function IconHearingDisabled() {
    return wu;
  },
  IconHeight: function IconHeight() {
    return Mu;
  },
  IconHelp: function IconHelp() {
    return yu;
  },
  IconHelpCenter: function IconHelpCenter() {
    return Iu;
  },
  IconHelpOutline: function IconHelpOutline() {
    return vu;
  },
  IconHighQuality: function IconHighQuality() {
    return Zu;
  },
  IconHighlight: function IconHighlight() {
    return Su;
  },
  IconHighlightAlt: function IconHighlightAlt() {
    return Wu;
  },
  IconHighlightOff: function IconHighlightOff() {
    return Du;
  },
  IconHistory: function IconHistory() {
    return Eu;
  },
  IconHistoryEdu: function IconHistoryEdu() {
    return Yu;
  },
  IconHistoryToggleOff: function IconHistoryToggleOff() {
    return Tu;
  },
  IconHome: function IconHome() {
    return Xu;
  },
  IconHomeRepairService: function IconHomeRepairService() {
    return _u;
  },
  IconHomeWork: function IconHomeWork() {
    return Uu;
  },
  IconHorizontalRule: function IconHorizontalRule() {
    return qu;
  },
  IconHorizontalSplit: function IconHorizontalSplit() {
    return Ju;
  },
  IconHotTub: function IconHotTub() {
    return Ru;
  },
  IconHotel: function IconHotel() {
    return ow;
  },
  IconHourglassBottom: function IconHourglassBottom() {
    return rw;
  },
  IconHourglassDisabled: function IconHourglassDisabled() {
    return sw;
  },
  IconHourglassEmpty: function IconHourglassEmpty() {
    return nw;
  },
  IconHourglassFull: function IconHourglassFull() {
    return cw;
  },
  IconHourglassTop: function IconHourglassTop() {
    return pw;
  },
  IconHouse: function IconHouse() {
    return gw;
  },
  IconHouseSiding: function IconHouseSiding() {
    return fw;
  },
  IconHowToReg: function IconHowToReg() {
    return ww;
  },
  IconHowToVote: function IconHowToVote() {
    return Vw;
  },
  IconHttp: function IconHttp() {
    return Mw;
  },
  IconHttps: function IconHttps() {
    return Iw;
  },
  IconHvac: function IconHvac() {
    return vw;
  },
  IconImage: function IconImage() {
    return Dw;
  },
  IconImageAspectRatio: function IconImageAspectRatio() {
    return yw;
  },
  IconImageNotSupported: function IconImageNotSupported() {
    return Zw;
  },
  IconImageSearch: function IconImageSearch() {
    return Ww;
  },
  IconImportContacts: function IconImportContacts() {
    return Sw;
  },
  IconImportExport: function IconImportExport() {
    return Yw;
  },
  IconImportantDevices: function IconImportantDevices() {
    return Tw;
  },
  IconInbox: function IconInbox() {
    return Ew;
  },
  IconIndeterminateCheckBox: function IconIndeterminateCheckBox() {
    return _w;
  },
  IconInfo: function IconInfo() {
    return kt;
  },
  IconInput: function IconInput() {
    return zw;
  },
  IconInsertChart: function IconInsertChart() {
    return Qw;
  },
  IconInsertChartOutlined: function IconInsertChartOutlined() {
    return Kw;
  },
  IconInsertComment: function IconInsertComment() {
    return $w;
  },
  IconInsertDriveFile: function IconInsertDriveFile() {
    return ed;
  },
  IconInsertEmoticon: function IconInsertEmoticon() {
    return td;
  },
  IconInsertInvitation: function IconInsertInvitation() {
    return id;
  },
  IconInsertLink: function IconInsertLink() {
    return ad;
  },
  IconInsertPhoto: function IconInsertPhoto() {
    return md;
  },
  IconInsights: function IconInsights() {
    return ld;
  },
  IconIntegrationInstructions: function IconIntegrationInstructions() {
    return hd;
  },
  IconInvertColors: function IconInvertColors() {
    return ud;
  },
  IconInvertColorsOff: function IconInvertColorsOff() {
    return Cd;
  },
  IconIso: function IconIso() {
    return dd;
  },
  IconKeyboard: function IconKeyboard() {
    return Ad;
  },
  IconKeyboardArrowDown: function IconKeyboardArrowDown() {
    return Hd;
  },
  IconKeyboardArrowLeft: function IconKeyboardArrowLeft() {
    return xd;
  },
  IconKeyboardArrowRight: function IconKeyboardArrowRight() {
    return Ld;
  },
  IconKeyboardArrowUp: function IconKeyboardArrowUp() {
    return Nd;
  },
  IconKeyboardBackspace: function IconKeyboardBackspace() {
    return bd;
  },
  IconKeyboardCapslock: function IconKeyboardCapslock() {
    return Bd;
  },
  IconKeyboardHide: function IconKeyboardHide() {
    return kd;
  },
  IconKeyboardReturn: function IconKeyboardReturn() {
    return Pd;
  },
  IconKeyboardTab: function IconKeyboardTab() {
    return jd;
  },
  IconKeyboardVoice: function IconKeyboardVoice() {
    return Fd;
  },
  IconKingBed: function IconKingBed() {
    return Od;
  },
  IconKitchen: function IconKitchen() {
    return Gd;
  },
  IconLabel: function IconLabel() {
    return Qd;
  },
  IconLabelImportant: function IconLabelImportant() {
    return zd;
  },
  IconLabelOff: function IconLabelOff() {
    return Kd;
  },
  IconLandscape: function IconLandscape() {
    return $d;
  },
  IconLanguage: function IconLanguage() {
    return eV;
  },
  IconLaptop: function IconLaptop() {
    return mV;
  },
  IconLaptopChromebook: function IconLaptopChromebook() {
    return tV;
  },
  IconLaptopMac: function IconLaptopMac() {
    return iV;
  },
  IconLaptopWindows: function IconLaptopWindows() {
    return aV;
  },
  IconLastPage: function IconLastPage() {
    return lV;
  },
  IconLaunch: function IconLaunch() {
    return hV;
  },
  IconLayers: function IconLayers() {
    return uV;
  },
  IconLayersClear: function IconLayersClear() {
    return CV;
  },
  IconLeaderboard: function IconLeaderboard() {
    return dV;
  },
  IconLeakAdd: function IconLeakAdd() {
    return HV;
  },
  IconLeakRemove: function IconLeakRemove() {
    return xV;
  },
  IconLegendToggle: function IconLegendToggle() {
    return LV;
  },
  IconLens: function IconLens() {
    return NV;
  },
  IconLibraryAdd: function IconLibraryAdd() {
    return BV;
  },
  IconLibraryAddCheck: function IconLibraryAddCheck() {
    return bV;
  },
  IconLibraryBooks: function IconLibraryBooks() {
    return kV;
  },
  IconLibraryMusic: function IconLibraryMusic() {
    return PV;
  },
  IconLightbulb: function IconLightbulb() {
    return jV;
  },
  IconLineStyle: function IconLineStyle() {
    return FV;
  },
  IconLineWeight: function IconLineWeight() {
    return AV;
  },
  IconLinearScale: function IconLinearScale() {
    return OV;
  },
  IconLink: function IconLink() {
    return zV;
  },
  IconLinkOff: function IconLinkOff() {
    return GV;
  },
  IconLinkedCamera: function IconLinkedCamera() {
    return KV;
  },
  IconList: function IconList() {
    return $V;
  },
  IconListAlt: function IconListAlt() {
    return QV;
  },
  IconLiveHelp: function IconLiveHelp() {
    return eH;
  },
  IconLiveTv: function IconLiveTv() {
    return tH;
  },
  IconLocalActivity: function IconLocalActivity() {
    return iH;
  },
  IconLocalAirport: function IconLocalAirport() {
    return aH;
  },
  IconLocalAtm: function IconLocalAtm() {
    return mH;
  },
  IconLocalBar: function IconLocalBar() {
    return lH;
  },
  IconLocalCafe: function IconLocalCafe() {
    return hH;
  },
  IconLocalCarWash: function IconLocalCarWash() {
    return CH;
  },
  IconLocalConvenienceStore: function IconLocalConvenienceStore() {
    return uH;
  },
  IconLocalDining: function IconLocalDining() {
    return dH;
  },
  IconLocalDrink: function IconLocalDrink() {
    return HH;
  },
  IconLocalFireDepartment: function IconLocalFireDepartment() {
    return xH;
  },
  IconLocalFlorist: function IconLocalFlorist() {
    return LH;
  },
  IconLocalGasStation: function IconLocalGasStation() {
    return NH;
  },
  IconLocalGroceryStore: function IconLocalGroceryStore() {
    return bH;
  },
  IconLocalHospital: function IconLocalHospital() {
    return BH;
  },
  IconLocalHotel: function IconLocalHotel() {
    return kH;
  },
  IconLocalLaundryService: function IconLocalLaundryService() {
    return PH;
  },
  IconLocalLibrary: function IconLocalLibrary() {
    return jH;
  },
  IconLocalMall: function IconLocalMall() {
    return FH;
  },
  IconLocalMovies: function IconLocalMovies() {
    return AH;
  },
  IconLocalOffer: function IconLocalOffer() {
    return OH;
  },
  IconLocalParking: function IconLocalParking() {
    return GH;
  },
  IconLocalPharmacy: function IconLocalPharmacy() {
    return zH;
  },
  IconLocalPhone: function IconLocalPhone() {
    return KH;
  },
  IconLocalPizza: function IconLocalPizza() {
    return QH;
  },
  IconLocalPlay: function IconLocalPlay() {
    return $H;
  },
  IconLocalPolice: function IconLocalPolice() {
    return eM;
  },
  IconLocalPostOffice: function IconLocalPostOffice() {
    return tM;
  },
  IconLocalPrintshop: function IconLocalPrintshop() {
    return iM;
  },
  IconLocalSee: function IconLocalSee() {
    return aM;
  },
  IconLocalShipping: function IconLocalShipping() {
    return mM;
  },
  IconLocalTaxi: function IconLocalTaxi() {
    return lM;
  },
  IconLocationCity: function IconLocationCity() {
    return hM;
  },
  IconLocationDisabled: function IconLocationDisabled() {
    return CM;
  },
  IconLocationOff: function IconLocationOff() {
    return uM;
  },
  IconLocationOn: function IconLocationOn() {
    return dM;
  },
  IconLocationSearching: function IconLocationSearching() {
    return HM;
  },
  IconLock: function IconLock() {
    return LM;
  },
  IconLockOpen: function IconLockOpen() {
    return xM;
  },
  IconLogin: function IconLogin() {
    return NM;
  },
  IconLooks: function IconLooks() {
    return AM;
  },
  IconLooksOne: function IconLooksOne() {
    return jM;
  },
  IconLooksTwo: function IconLooksTwo() {
    return FM;
  },
  IconLooks_3: function IconLooks_3() {
    return bM;
  },
  IconLooks_4: function IconLooks_4() {
    return BM;
  },
  IconLooks_5: function IconLooks_5() {
    return kM;
  },
  IconLooks_6: function IconLooks_6() {
    return PM;
  },
  IconLoop: function IconLoop() {
    return OM;
  },
  IconLoupe: function IconLoupe() {
    return GM;
  },
  IconLowPriority: function IconLowPriority() {
    return zM;
  },
  IconLoyalty: function IconLoyalty() {
    return KM;
  },
  IconLuggage: function IconLuggage() {
    return QM;
  },
  IconMail: function IconMail() {
    return ex;
  },
  IconMailOutline: function IconMailOutline() {
    return $M;
  },
  IconMap: function IconMap() {
    return tx;
  },
  IconMapsUgc: function IconMapsUgc() {
    return ix;
  },
  IconMarkChatRead: function IconMarkChatRead() {
    return ax;
  },
  IconMarkChatUnread: function IconMarkChatUnread() {
    return mx;
  },
  IconMarkEmailRead: function IconMarkEmailRead() {
    return lx;
  },
  IconMarkEmailUnread: function IconMarkEmailUnread() {
    return hx;
  },
  IconMarkunread: function IconMarkunread() {
    return ux;
  },
  IconMarkunreadMailbox: function IconMarkunreadMailbox() {
    return Cx;
  },
  IconMasks: function IconMasks() {
    return dx;
  },
  IconMaximize: function IconMaximize() {
    return Hx;
  },
  IconMediation: function IconMediation() {
    return xx;
  },
  IconMedicalServices: function IconMedicalServices() {
    return Lx;
  },
  IconMeetingRoom: function IconMeetingRoom() {
    return Nx;
  },
  IconMemory: function IconMemory() {
    return bx;
  },
  IconMenu: function IconMenu() {
    return Dt;
  },
  IconMenuBook: function IconMenuBook() {
    return Bx;
  },
  IconMenuOpen: function IconMenuOpen() {
    return kx;
  },
  IconMergeType: function IconMergeType() {
    return Sx;
  },
  IconMessage: function IconMessage() {
    return Yx;
  },
  IconMic: function IconMic() {
    return _x;
  },
  IconMicNone: function IconMicNone() {
    return Tx;
  },
  IconMicOff: function IconMicOff() {
    return Ex;
  },
  IconMicrowave: function IconMicrowave() {
    return Ux;
  },
  IconMilitaryTech: function IconMilitaryTech() {
    return Xx;
  },
  IconMinimize: function IconMinimize() {
    return qx;
  },
  IconMiscellaneousServices: function IconMiscellaneousServices() {
    return Jx;
  },
  IconMissedVideoCall: function IconMissedVideoCall() {
    return Rx;
  },
  IconMms: function IconMms() {
    return oI;
  },
  IconMobileFriendly: function IconMobileFriendly() {
    return rI;
  },
  IconMobileOff: function IconMobileOff() {
    return sI;
  },
  IconMobileScreenShare: function IconMobileScreenShare() {
    return nI;
  },
  IconMode: function IconMode() {
    return pI;
  },
  IconModeComment: function IconModeComment() {
    return cI;
  },
  IconModelTraining: function IconModelTraining() {
    return fI;
  },
  IconMonetizationOn: function IconMonetizationOn() {
    return gI;
  },
  IconMoney: function IconMoney() {
    return MI;
  },
  IconMoneyOff: function IconMoneyOff() {
    return VI;
  },
  IconMoneyOffCsred: function IconMoneyOffCsred() {
    return wI;
  },
  IconMonochromePhotos: function IconMonochromePhotos() {
    return II;
  },
  IconMood: function IconMood() {
    return yI;
  },
  IconMoodBad: function IconMoodBad() {
    return vI;
  },
  IconMoped: function IconMoped() {
    return ZI;
  },
  IconMore: function IconMore() {
    return YI;
  },
  IconMoreHoriz: function IconMoreHoriz() {
    return WI;
  },
  IconMoreTime: function IconMoreTime() {
    return DI;
  },
  IconMoreVert: function IconMoreVert() {
    return SI;
  },
  IconMotionPhotosOn: function IconMotionPhotosOn() {
    return TI;
  },
  IconMotionPhotosPause: function IconMotionPhotosPause() {
    return EI;
  },
  IconMotionPhotosPaused: function IconMotionPhotosPaused() {
    return _I;
  },
  IconMouse: function IconMouse() {
    return UI;
  },
  IconMoveToInbox: function IconMoveToInbox() {
    return XI;
  },
  IconMovie: function IconMovie() {
    return RI;
  },
  IconMovieCreation: function IconMovieCreation() {
    return qI;
  },
  IconMovieFilter: function IconMovieFilter() {
    return JI;
  },
  IconMultilineChart: function IconMultilineChart() {
    return oL;
  },
  IconMultipleStop: function IconMultipleStop() {
    return rL;
  },
  IconMuseum: function IconMuseum() {
    return sL;
  },
  IconMusicNote: function IconMusicNote() {
    return nL;
  },
  IconMusicOff: function IconMusicOff() {
    return cL;
  },
  IconMusicVideo: function IconMusicVideo() {
    return pL;
  },
  IconMyLocation: function IconMyLocation() {
    return fL;
  },
  IconNat: function IconNat() {
    return gL;
  },
  IconNature: function IconNature() {
    return VL;
  },
  IconNaturePeople: function IconNaturePeople() {
    return wL;
  },
  IconNavigateBefore: function IconNavigateBefore() {
    return ML;
  },
  IconNavigateNext: function IconNavigateNext() {
    return IL;
  },
  IconNavigation: function IconNavigation() {
    return vL;
  },
  IconNearMe: function IconNearMe() {
    return ZL;
  },
  IconNearMeDisabled: function IconNearMeDisabled() {
    return yL;
  },
  IconNetworkCheck: function IconNetworkCheck() {
    return WL;
  },
  IconNetworkLocked: function IconNetworkLocked() {
    return DL;
  },
  IconNewReleases: function IconNewReleases() {
    return SL;
  },
  IconNextPlan: function IconNextPlan() {
    return YL;
  },
  IconNextWeek: function IconNextWeek() {
    return TL;
  },
  IconNfc: function IconNfc() {
    return EL;
  },
  IconNightShelter: function IconNightShelter() {
    return _L;
  },
  IconNightsStay: function IconNightsStay() {
    return UL;
  },
  IconNoBackpack: function IconNoBackpack() {
    return XL;
  },
  IconNoCell: function IconNoCell() {
    return qL;
  },
  IconNoDrinks: function IconNoDrinks() {
    return JL;
  },
  IconNoEncryption: function IconNoEncryption() {
    return ov;
  },
  IconNoEncryptionGmailerrorred: function IconNoEncryptionGmailerrorred() {
    return RL;
  },
  IconNoFlash: function IconNoFlash() {
    return rv;
  },
  IconNoFood: function IconNoFood() {
    return sv;
  },
  IconNoLuggage: function IconNoLuggage() {
    return nv;
  },
  IconNoMeals: function IconNoMeals() {
    return cv;
  },
  IconNoMeetingRoom: function IconNoMeetingRoom() {
    return pv;
  },
  IconNoPhotography: function IconNoPhotography() {
    return fv;
  },
  IconNoSim: function IconNoSim() {
    return gv;
  },
  IconNoStroller: function IconNoStroller() {
    return wv;
  },
  IconNoTransfer: function IconNoTransfer() {
    return Vv;
  },
  IconNorth: function IconNorth() {
    return vv;
  },
  IconNorthEast: function IconNorthEast() {
    return Mv;
  },
  IconNorthWest: function IconNorthWest() {
    return Iv;
  },
  IconNotAccessible: function IconNotAccessible() {
    return yv;
  },
  IconNotInterested: function IconNotInterested() {
    return Zv;
  },
  IconNotListedLocation: function IconNotListedLocation() {
    return Wv;
  },
  IconNotStarted: function IconNotStarted() {
    return Dv;
  },
  IconNote: function IconNote() {
    return Yv;
  },
  IconNoteAdd: function IconNoteAdd() {
    return Sv;
  },
  IconNotes: function IconNotes() {
    return Tv;
  },
  IconNotificationImportant: function IconNotificationImportant() {
    return Ev;
  },
  IconNotifications: function IconNotifications() {
    return Jv;
  },
  IconNotificationsActive: function IconNotificationsActive() {
    return _v;
  },
  IconNotificationsNone: function IconNotificationsNone() {
    return Uv;
  },
  IconNotificationsOff: function IconNotificationsOff() {
    return Xv;
  },
  IconNotificationsPaused: function IconNotificationsPaused() {
    return qv;
  },
  IconOfflineBolt: function IconOfflineBolt() {
    return Rv;
  },
  IconOfflinePin: function IconOfflinePin() {
    return oN;
  },
  IconOndemandVideo: function IconOndemandVideo() {
    return rN;
  },
  IconOnlinePrediction: function IconOnlinePrediction() {
    return sN;
  },
  IconOpacity: function IconOpacity() {
    return nN;
  },
  IconOpenInBrowser: function IconOpenInBrowser() {
    return cN;
  },
  IconOpenInFull: function IconOpenInFull() {
    return pN;
  },
  IconOpenInNew: function IconOpenInNew() {
    return fN;
  },
  IconOpenWith: function IconOpenWith() {
    return gN;
  },
  IconOutbond: function IconOutbond() {
    return wN;
  },
  IconOutdoorGrill: function IconOutdoorGrill() {
    return VN;
  },
  IconOutlet: function IconOutlet() {
    return MN;
  },
  IconOutlinedFlag: function IconOutlinedFlag() {
    return IN;
  },
  IconPages: function IconPages() {
    return vN;
  },
  IconPageview: function IconPageview() {
    return yN;
  },
  IconPalette: function IconPalette() {
    return ZN;
  },
  IconPanTool: function IconPanTool() {
    return WN;
  },
  IconPanorama: function IconPanorama() {
    return EN;
  },
  IconPanoramaFishEye: function IconPanoramaFishEye() {
    return DN;
  },
  IconPanoramaHorizontal: function IconPanoramaHorizontal() {
    return SN;
  },
  IconPanoramaVertical: function IconPanoramaVertical() {
    return YN;
  },
  IconPanoramaWideAngle: function IconPanoramaWideAngle() {
    return TN;
  },
  IconPartyMode: function IconPartyMode() {
    return _N;
  },
  IconPause: function IconPause() {
    return JN;
  },
  IconPauseCircleFilled: function IconPauseCircleFilled() {
    return UN;
  },
  IconPauseCircleOutline: function IconPauseCircleOutline() {
    return XN;
  },
  IconPausePresentation: function IconPausePresentation() {
    return qN;
  },
  IconPayment: function IconPayment() {
    return RN;
  },
  IconPayments: function IconPayments() {
    return oy;
  },
  IconPedalBike: function IconPedalBike() {
    return ry;
  },
  IconPending: function IconPending() {
    return ny;
  },
  IconPendingActions: function IconPendingActions() {
    return sy;
  },
  IconPeople: function IconPeople() {
    return fy;
  },
  IconPeopleAlt: function IconPeopleAlt() {
    return cy;
  },
  IconPeopleOutline: function IconPeopleOutline() {
    return py;
  },
  IconPermCameraMic: function IconPermCameraMic() {
    return gy;
  },
  IconPermContactCalendar: function IconPermContactCalendar() {
    return wy;
  },
  IconPermDataSetting: function IconPermDataSetting() {
    return Vy;
  },
  IconPermDeviceInformation: function IconPermDeviceInformation() {
    return My;
  },
  IconPermIdentity: function IconPermIdentity() {
    return Iy;
  },
  IconPermMedia: function IconPermMedia() {
    return vy;
  },
  IconPermPhoneMsg: function IconPermPhoneMsg() {
    return yy;
  },
  IconPermScanWifi: function IconPermScanWifi() {
    return Zy;
  },
  IconPerson: function IconPerson() {
    return qy;
  },
  IconPersonAdd: function IconPersonAdd() {
    return Sy;
  },
  IconPersonAddAlt_1: function IconPersonAddAlt_1() {
    return Wy;
  },
  IconPersonAddDisabled: function IconPersonAddDisabled() {
    return Dy;
  },
  IconPersonOutline: function IconPersonOutline() {
    return Yy;
  },
  IconPersonPin: function IconPersonPin() {
    return Ey;
  },
  IconPersonPinCircle: function IconPersonPinCircle() {
    return Ty;
  },
  IconPersonRemove: function IconPersonRemove() {
    return Uy;
  },
  IconPersonRemoveAlt_1: function IconPersonRemoveAlt_1() {
    return _y;
  },
  IconPersonSearch: function IconPersonSearch() {
    return Xy;
  },
  IconPersonalVideo: function IconPersonalVideo() {
    return Jy;
  },
  IconPestControl: function IconPestControl() {
    return ob;
  },
  IconPestControlRodent: function IconPestControlRodent() {
    return Ry;
  },
  IconPets: function IconPets() {
    return rb;
  },
  IconPhone: function IconPhone() {
    return yb;
  },
  IconPhoneAndroid: function IconPhoneAndroid() {
    return sb;
  },
  IconPhoneBluetoothSpeaker: function IconPhoneBluetoothSpeaker() {
    return nb;
  },
  IconPhoneCallback: function IconPhoneCallback() {
    return cb;
  },
  IconPhoneDisabled: function IconPhoneDisabled() {
    return pb;
  },
  IconPhoneEnabled: function IconPhoneEnabled() {
    return fb;
  },
  IconPhoneForwarded: function IconPhoneForwarded() {
    return gb;
  },
  IconPhoneInTalk: function IconPhoneInTalk() {
    return wb;
  },
  IconPhoneIphone: function IconPhoneIphone() {
    return Vb;
  },
  IconPhoneLocked: function IconPhoneLocked() {
    return Mb;
  },
  IconPhoneMissed: function IconPhoneMissed() {
    return Ib;
  },
  IconPhonePaused: function IconPhonePaused() {
    return vb;
  },
  IconPhonelink: function IconPhonelink() {
    return Tb;
  },
  IconPhonelinkErase: function IconPhonelinkErase() {
    return Zb;
  },
  IconPhonelinkLock: function IconPhonelinkLock() {
    return Wb;
  },
  IconPhonelinkOff: function IconPhonelinkOff() {
    return Db;
  },
  IconPhonelinkRing: function IconPhonelinkRing() {
    return Sb;
  },
  IconPhonelinkSetup: function IconPhonelinkSetup() {
    return Yb;
  },
  IconPhoto: function IconPhoto() {
    return oZ;
  },
  IconPhotoAlbum: function IconPhotoAlbum() {
    return Eb;
  },
  IconPhotoCamera: function IconPhotoCamera() {
    return _b;
  },
  IconPhotoFilter: function IconPhotoFilter() {
    return Ub;
  },
  IconPhotoLibrary: function IconPhotoLibrary() {
    return Xb;
  },
  IconPhotoSizeSelectActual: function IconPhotoSizeSelectActual() {
    return qb;
  },
  IconPhotoSizeSelectLarge: function IconPhotoSizeSelectLarge() {
    return Jb;
  },
  IconPhotoSizeSelectSmall: function IconPhotoSizeSelectSmall() {
    return Rb;
  },
  IconPictureAsPdf: function IconPictureAsPdf() {
    return rZ;
  },
  IconPictureInPicture: function IconPictureInPicture() {
    return nZ;
  },
  IconPictureInPictureAlt: function IconPictureInPictureAlt() {
    return sZ;
  },
  IconPieChart: function IconPieChart() {
    return pZ;
  },
  IconPieChartOutline: function IconPieChartOutline() {
    return cZ;
  },
  IconPinDrop: function IconPinDrop() {
    return fZ;
  },
  IconPlace: function IconPlace() {
    return gZ;
  },
  IconPlagiarism: function IconPlagiarism() {
    return wZ;
  },
  IconPlayArrow: function IconPlayArrow() {
    return VZ;
  },
  IconPlayCircleFilled: function IconPlayCircleFilled() {
    return MZ;
  },
  IconPlayCircleOutline: function IconPlayCircleOutline() {
    return IZ;
  },
  IconPlayForWork: function IconPlayForWork() {
    return vZ;
  },
  IconPlaylistAdd: function IconPlaylistAdd() {
    return ZZ;
  },
  IconPlaylistAddCheck: function IconPlaylistAddCheck() {
    return yZ;
  },
  IconPlaylistPlay: function IconPlaylistPlay() {
    return WZ;
  },
  IconPlumbing: function IconPlumbing() {
    return DZ;
  },
  IconPlusOne: function IconPlusOne() {
    return SZ;
  },
  IconPointOfSale: function IconPointOfSale() {
    return YZ;
  },
  IconPolicy: function IconPolicy() {
    return TZ;
  },
  IconPoll: function IconPoll() {
    return EZ;
  },
  IconPolymer: function IconPolymer() {
    return _Z;
  },
  IconPool: function IconPool() {
    return UZ;
  },
  IconPortableWifiOff: function IconPortableWifiOff() {
    return XZ;
  },
  IconPortrait: function IconPortrait() {
    return qZ;
  },
  IconPostAdd: function IconPostAdd() {
    return JZ;
  },
  IconPower: function IconPower() {
    return sB;
  },
  IconPowerInput: function IconPowerInput() {
    return RZ;
  },
  IconPowerOff: function IconPowerOff() {
    return oB;
  },
  IconPowerSettingsNew: function IconPowerSettingsNew() {
    return rB;
  },
  IconPrecisionManufacturing: function IconPrecisionManufacturing() {
    return nB;
  },
  IconPregnantWoman: function IconPregnantWoman() {
    return cB;
  },
  IconPresentToAll: function IconPresentToAll() {
    return pB;
  },
  IconPreview: function IconPreview() {
    return fB;
  },
  IconPrint: function IconPrint() {
    return wB;
  },
  IconPrintDisabled: function IconPrintDisabled() {
    return gB;
  },
  IconPriorityHigh: function IconPriorityHigh() {
    return VB;
  },
  IconPrivacyTip: function IconPrivacyTip() {
    return MB;
  },
  IconPsychology: function IconPsychology() {
    return IB;
  },
  IconPublic: function IconPublic() {
    return yB;
  },
  IconPublicOff: function IconPublicOff() {
    return vB;
  },
  IconPublish: function IconPublish() {
    return ZB;
  },
  IconPublishedWithChanges: function IconPublishedWithChanges() {
    return WB;
  },
  IconPushPin: function IconPushPin() {
    return DB;
  },
  IconQrCode: function IconQrCode() {
    return YB;
  },
  IconQrCodeScanner: function IconQrCodeScanner() {
    return SB;
  },
  IconQueryBuilder: function IconQueryBuilder() {
    return TB;
  },
  IconQuestionAnswer: function IconQuestionAnswer() {
    return EB;
  },
  IconQueue: function IconQueue() {
    return XB;
  },
  IconQueueMusic: function IconQueueMusic() {
    return _B;
  },
  IconQueuePlayNext: function IconQueuePlayNext() {
    return UB;
  },
  IconQuickreply: function IconQuickreply() {
    return qB;
  },
  IconRadio: function IconRadio() {
    return oW;
  },
  IconRadioButtonChecked: function IconRadioButtonChecked() {
    return JB;
  },
  IconRadioButtonUnchecked: function IconRadioButtonUnchecked() {
    return RB;
  },
  IconRateReview: function IconRateReview() {
    return rW;
  },
  IconReadMore: function IconReadMore() {
    return sW;
  },
  IconReceipt: function IconReceipt() {
    return cW;
  },
  IconReceiptLong: function IconReceiptLong() {
    return nW;
  },
  IconRecentActors: function IconRecentActors() {
    return pW;
  },
  IconRecordVoiceOver: function IconRecordVoiceOver() {
    return fW;
  },
  IconRedeem: function IconRedeem() {
    return gW;
  },
  IconRedo: function IconRedo() {
    return wW;
  },
  IconReduceCapacity: function IconReduceCapacity() {
    return VW;
  },
  IconRefresh: function IconRefresh() {
    return MW;
  },
  IconRemove: function IconRemove() {
    return Pt;
  },
  IconRemoveCircle: function IconRemoveCircle() {
    return vW;
  },
  IconRemoveCircleOutline: function IconRemoveCircleOutline() {
    return IW;
  },
  IconRemoveFromQueue: function IconRemoveFromQueue() {
    return yW;
  },
  IconRemoveRedEye: function IconRemoveRedEye() {
    return ZW;
  },
  IconRemoveShoppingCart: function IconRemoveShoppingCart() {
    return WW;
  },
  IconReorder: function IconReorder() {
    return PW;
  },
  IconRepeat: function IconRepeat() {
    return FW;
  },
  IconRepeatOne: function IconRepeatOne() {
    return jW;
  },
  IconReplay: function IconReplay() {
    return zW;
  },
  IconReplay_10: function IconReplay_10() {
    return AW;
  },
  IconReplay_30: function IconReplay_30() {
    return OW;
  },
  IconReplay_5: function IconReplay_5() {
    return GW;
  },
  IconReply: function IconReply() {
    return QW;
  },
  IconReplyAll: function IconReplyAll() {
    return KW;
  },
  IconReport: function IconReport() {
    return ik;
  },
  IconReportGmailerrorred: function IconReportGmailerrorred() {
    return $W;
  },
  IconReportOff: function IconReportOff() {
    return ek;
  },
  IconReportProblem: function IconReportProblem() {
    return tk;
  },
  IconRequestPage: function IconRequestPage() {
    return ak;
  },
  IconRequestQuote: function IconRequestQuote() {
    return mk;
  },
  IconRestaurant: function IconRestaurant() {
    return hk;
  },
  IconRestaurantMenu: function IconRestaurantMenu() {
    return lk;
  },
  IconRestore: function IconRestore() {
    return dk;
  },
  IconRestoreFromTrash: function IconRestoreFromTrash() {
    return Ck;
  },
  IconRestorePage: function IconRestorePage() {
    return uk;
  },
  IconRingVolume: function IconRingVolume() {
    return Hk;
  },
  IconRoofing: function IconRoofing() {
    return xk;
  },
  IconRoom: function IconRoom() {
    return bk;
  },
  IconRoomPreferences: function IconRoomPreferences() {
    return Lk;
  },
  IconRoomService: function IconRoomService() {
    return Nk;
  },
  IconRotateLeft: function IconRotateLeft() {
    return kk;
  },
  IconRotateRight: function IconRotateRight() {
    return Pk;
  },
  IconRotate_90DegreesCcw: function IconRotate_90DegreesCcw() {
    return Bk;
  },
  IconRoundedCorner: function IconRoundedCorner() {
    return jk;
  },
  IconRouter: function IconRouter() {
    return Fk;
  },
  IconRowing: function IconRowing() {
    return Ak;
  },
  IconRssFeed: function IconRssFeed() {
    return Ok;
  },
  IconRule: function IconRule() {
    return zk;
  },
  IconRuleFolder: function IconRuleFolder() {
    return Gk;
  },
  IconRunCircle: function IconRunCircle() {
    return Kk;
  },
  IconRvHookup: function IconRvHookup() {
    return Qk;
  },
  IconSanitizer: function IconSanitizer() {
    return $k;
  },
  IconSatellite: function IconSatellite() {
    return eD;
  },
  IconSave: function IconSave() {
    return iD;
  },
  IconSaveAlt: function IconSaveAlt() {
    return tD;
  },
  IconScanner: function IconScanner() {
    return aD;
  },
  IconScatterPlot: function IconScatterPlot() {
    return mD;
  },
  IconSchedule: function IconSchedule() {
    return lD;
  },
  IconSchool: function IconSchool() {
    return hD;
  },
  IconScience: function IconScience() {
    return CD;
  },
  IconScore: function IconScore() {
    return uD;
  },
  IconScreenLockLandscape: function IconScreenLockLandscape() {
    return dD;
  },
  IconScreenLockPortrait: function IconScreenLockPortrait() {
    return HD;
  },
  IconScreenLockRotation: function IconScreenLockRotation() {
    return xD;
  },
  IconScreenRotation: function IconScreenRotation() {
    return LD;
  },
  IconScreenShare: function IconScreenShare() {
    return ND;
  },
  IconSdCard: function IconSdCard() {
    return BD;
  },
  IconSdCardAlert: function IconSdCardAlert() {
    return bD;
  },
  IconSdStorage: function IconSdStorage() {
    return kD;
  },
  IconSearch: function IconSearch() {
    return St;
  },
  IconSearchOff: function IconSearchOff() {
    return PD;
  },
  IconSecurity: function IconSecurity() {
    return YD;
  },
  IconSelectAll: function IconSelectAll() {
    return TD;
  },
  IconSelfImprovement: function IconSelfImprovement() {
    return ED;
  },
  IconSend: function IconSend() {
    return _D;
  },
  IconSensorDoor: function IconSensorDoor() {
    return UD;
  },
  IconSensorWindow: function IconSensorWindow() {
    return XD;
  },
  IconSentimentDissatisfied: function IconSentimentDissatisfied() {
    return qD;
  },
  IconSentimentNeutral: function IconSentimentNeutral() {
    return JD;
  },
  IconSentimentSatisfied: function IconSentimentSatisfied() {
    return oP;
  },
  IconSentimentSatisfiedAlt: function IconSentimentSatisfiedAlt() {
    return RD;
  },
  IconSentimentVeryDissatisfied: function IconSentimentVeryDissatisfied() {
    return rP;
  },
  IconSentimentVerySatisfied: function IconSentimentVerySatisfied() {
    return sP;
  },
  IconSetMeal: function IconSetMeal() {
    return nP;
  },
  IconSettings: function IconSettings() {
    return _P;
  },
  IconSettingsApplications: function IconSettingsApplications() {
    return cP;
  },
  IconSettingsBackupRestore: function IconSettingsBackupRestore() {
    return pP;
  },
  IconSettingsBluetooth: function IconSettingsBluetooth() {
    return fP;
  },
  IconSettingsBrightness: function IconSettingsBrightness() {
    return gP;
  },
  IconSettingsCell: function IconSettingsCell() {
    return wP;
  },
  IconSettingsEthernet: function IconSettingsEthernet() {
    return VP;
  },
  IconSettingsInputAntenna: function IconSettingsInputAntenna() {
    return MP;
  },
  IconSettingsInputComponent: function IconSettingsInputComponent() {
    return IP;
  },
  IconSettingsInputComposite: function IconSettingsInputComposite() {
    return vP;
  },
  IconSettingsInputHdmi: function IconSettingsInputHdmi() {
    return yP;
  },
  IconSettingsInputSvideo: function IconSettingsInputSvideo() {
    return ZP;
  },
  IconSettingsOverscan: function IconSettingsOverscan() {
    return WP;
  },
  IconSettingsPhone: function IconSettingsPhone() {
    return DP;
  },
  IconSettingsPower: function IconSettingsPower() {
    return SP;
  },
  IconSettingsRemote: function IconSettingsRemote() {
    return YP;
  },
  IconSettingsSystemDaydream: function IconSettingsSystemDaydream() {
    return TP;
  },
  IconSettingsVoice: function IconSettingsVoice() {
    return EP;
  },
  IconShare: function IconShare() {
    return UP;
  },
  IconShop: function IconShop() {
    return qP;
  },
  IconShopTwo: function IconShopTwo() {
    return XP;
  },
  IconShoppingBag: function IconShoppingBag() {
    return JP;
  },
  IconShoppingBasket: function IconShoppingBasket() {
    return RP;
  },
  IconShoppingCart: function IconShoppingCart() {
    return oS;
  },
  IconShortText: function IconShortText() {
    return rS;
  },
  IconShowChart: function IconShowChart() {
    return sS;
  },
  IconShuffle: function IconShuffle() {
    return nS;
  },
  IconShutterSpeed: function IconShutterSpeed() {
    return cS;
  },
  IconSick: function IconSick() {
    return pS;
  },
  IconSignalCellularAlt: function IconSignalCellularAlt() {
    return gS;
  },
  IconSignalCellularConnectedNoInternet_4Bar: function IconSignalCellularConnectedNoInternet_4Bar() {
    return wS;
  },
  IconSignalCellularNoSim: function IconSignalCellularNoSim() {
    return VS;
  },
  IconSignalCellularNull: function IconSignalCellularNull() {
    return MS;
  },
  IconSignalCellularOff: function IconSignalCellularOff() {
    return IS;
  },
  IconSignalCellular_4Bar: function IconSignalCellular_4Bar() {
    return fS;
  },
  IconSignalWifiOff: function IconSignalWifiOff() {
    return ZS;
  },
  IconSignalWifi_4Bar: function IconSignalWifi_4Bar() {
    return yS;
  },
  IconSignalWifi_4BarLock: function IconSignalWifi_4BarLock() {
    return vS;
  },
  IconSimCard: function IconSimCard() {
    return WS;
  },
  IconSingleBed: function IconSingleBed() {
    return DS;
  },
  IconSkipNext: function IconSkipNext() {
    return SS;
  },
  IconSkipPrevious: function IconSkipPrevious() {
    return YS;
  },
  IconSlideshow: function IconSlideshow() {
    return TS;
  },
  IconSlowMotionVideo: function IconSlowMotionVideo() {
    return ES;
  },
  IconSmartButton: function IconSmartButton() {
    return _S;
  },
  IconSmartphone: function IconSmartphone() {
    return US;
  },
  IconSmokeFree: function IconSmokeFree() {
    return XS;
  },
  IconSmokingRooms: function IconSmokingRooms() {
    return qS;
  },
  IconSms: function IconSms() {
    return RS;
  },
  IconSmsFailed: function IconSmsFailed() {
    return JS;
  },
  IconSnippetFolder: function IconSnippetFolder() {
    return oj;
  },
  IconSnooze: function IconSnooze() {
    return rj;
  },
  IconSoap: function IconSoap() {
    return sj;
  },
  IconSort: function IconSort() {
    return cj;
  },
  IconSortByAlpha: function IconSortByAlpha() {
    return nj;
  },
  IconSource: function IconSource() {
    return pj;
  },
  IconSouth: function IconSouth() {
    return wj;
  },
  IconSouthEast: function IconSouthEast() {
    return fj;
  },
  IconSouthWest: function IconSouthWest() {
    return gj;
  },
  IconSpa: function IconSpa() {
    return Vj;
  },
  IconSpaceBar: function IconSpaceBar() {
    return Mj;
  },
  IconSpeaker: function IconSpeaker() {
    return Wj;
  },
  IconSpeakerGroup: function IconSpeakerGroup() {
    return Ij;
  },
  IconSpeakerNotes: function IconSpeakerNotes() {
    return yj;
  },
  IconSpeakerNotesOff: function IconSpeakerNotesOff() {
    return vj;
  },
  IconSpeakerPhone: function IconSpeakerPhone() {
    return Zj;
  },
  IconSpeed: function IconSpeed() {
    return Dj;
  },
  IconSpellcheck: function IconSpellcheck() {
    return Sj;
  },
  IconSports: function IconSports() {
    return gY;
  },
  IconSportsBar: function IconSportsBar() {
    return Yj;
  },
  IconSportsBaseball: function IconSportsBaseball() {
    return Tj;
  },
  IconSportsBasketball: function IconSportsBasketball() {
    return Ej;
  },
  IconSportsCricket: function IconSportsCricket() {
    return _j;
  },
  IconSportsEsports: function IconSportsEsports() {
    return Uj;
  },
  IconSportsFootball: function IconSportsFootball() {
    return Xj;
  },
  IconSportsGolf: function IconSportsGolf() {
    return qj;
  },
  IconSportsHandball: function IconSportsHandball() {
    return Jj;
  },
  IconSportsHockey: function IconSportsHockey() {
    return Rj;
  },
  IconSportsKabaddi: function IconSportsKabaddi() {
    return oY;
  },
  IconSportsMma: function IconSportsMma() {
    return rY;
  },
  IconSportsMotorsports: function IconSportsMotorsports() {
    return sY;
  },
  IconSportsRugby: function IconSportsRugby() {
    return nY;
  },
  IconSportsSoccer: function IconSportsSoccer() {
    return cY;
  },
  IconSportsTennis: function IconSportsTennis() {
    return pY;
  },
  IconSportsVolleyball: function IconSportsVolleyball() {
    return fY;
  },
  IconSquareFoot: function IconSquareFoot() {
    return wY;
  },
  IconStackedLineChart: function IconStackedLineChart() {
    return VY;
  },
  IconStairs: function IconStairs() {
    return MY;
  },
  IconStar: function IconStar() {
    return jt;
  },
  IconStarBorder: function IconStarBorder() {
    return vY;
  },
  IconStarBorderPurple500: function IconStarBorderPurple500() {
    return IY;
  },
  IconStarHalf: function IconStarHalf() {
    return yY;
  },
  IconStarOutline: function IconStarOutline() {
    return ZY;
  },
  IconStarPurple500: function IconStarPurple500() {
    return WY;
  },
  IconStarRate: function IconStarRate() {
    return DY;
  },
  IconStars: function IconStars() {
    return jY;
  },
  IconStayCurrentLandscape: function IconStayCurrentLandscape() {
    return FY;
  },
  IconStayCurrentPortrait: function IconStayCurrentPortrait() {
    return AY;
  },
  IconStayPrimaryLandscape: function IconStayPrimaryLandscape() {
    return OY;
  },
  IconStayPrimaryPortrait: function IconStayPrimaryPortrait() {
    return GY;
  },
  IconStickyNote_2: function IconStickyNote_2() {
    return zY;
  },
  IconStop: function IconStop() {
    return $Y;
  },
  IconStopCircle: function IconStopCircle() {
    return KY;
  },
  IconStopScreenShare: function IconStopScreenShare() {
    return QY;
  },
  IconStorage: function IconStorage() {
    return eF;
  },
  IconStore: function IconStore() {
    return iF;
  },
  IconStoreMallDirectory: function IconStoreMallDirectory() {
    return tF;
  },
  IconStorefront: function IconStorefront() {
    return aF;
  },
  IconStraighten: function IconStraighten() {
    return mF;
  },
  IconStreetview: function IconStreetview() {
    return lF;
  },
  IconStrikethroughS: function IconStrikethroughS() {
    return hF;
  },
  IconStroller: function IconStroller() {
    return CF;
  },
  IconStyle: function IconStyle() {
    return uF;
  },
  IconSubdirectoryArrowLeft: function IconSubdirectoryArrowLeft() {
    return dF;
  },
  IconSubdirectoryArrowRight: function IconSubdirectoryArrowRight() {
    return HF;
  },
  IconSubject: function IconSubject() {
    return xF;
  },
  IconSubscript: function IconSubscript() {
    return LF;
  },
  IconSubscriptions: function IconSubscriptions() {
    return NF;
  },
  IconSubtitles: function IconSubtitles() {
    return BF;
  },
  IconSubtitlesOff: function IconSubtitlesOff() {
    return bF;
  },
  IconSubway: function IconSubway() {
    return kF;
  },
  IconSuperscript: function IconSuperscript() {
    return PF;
  },
  IconSupervisedUserCircle: function IconSupervisedUserCircle() {
    return jF;
  },
  IconSupervisorAccount: function IconSupervisorAccount() {
    return FF;
  },
  IconSupport: function IconSupport() {
    return OF;
  },
  IconSupportAgent: function IconSupportAgent() {
    return AF;
  },
  IconSurroundSound: function IconSurroundSound() {
    return GF;
  },
  IconSwapCalls: function IconSwapCalls() {
    return zF;
  },
  IconSwapHoriz: function IconSwapHoriz() {
    return KF;
  },
  IconSwapHorizontalCircle: function IconSwapHorizontalCircle() {
    return QF;
  },
  IconSwapVert: function IconSwapVert() {
    return $F;
  },
  IconSwapVerticalCircle: function IconSwapVerticalCircle() {
    return eT;
  },
  IconSwitchCamera: function IconSwitchCamera() {
    return tT;
  },
  IconSwitchLeft: function IconSwitchLeft() {
    return iT;
  },
  IconSwitchRight: function IconSwitchRight() {
    return aT;
  },
  IconSwitchVideo: function IconSwitchVideo() {
    return mT;
  },
  IconSync: function IconSync() {
    return uT;
  },
  IconSyncAlt: function IconSyncAlt() {
    return lT;
  },
  IconSyncDisabled: function IconSyncDisabled() {
    return hT;
  },
  IconSyncProblem: function IconSyncProblem() {
    return CT;
  },
  IconSystemUpdate: function IconSystemUpdate() {
    return HT;
  },
  IconSystemUpdateAlt: function IconSystemUpdateAlt() {
    return dT;
  },
  IconTab: function IconTab() {
    return LT;
  },
  IconTabUnselected: function IconTabUnselected() {
    return xT;
  },
  IconTableChart: function IconTableChart() {
    return NT;
  },
  IconTableRows: function IconTableRows() {
    return bT;
  },
  IconTableView: function IconTableView() {
    return BT;
  },
  IconTablet: function IconTablet() {
    return jT;
  },
  IconTabletAndroid: function IconTabletAndroid() {
    return kT;
  },
  IconTabletMac: function IconTabletMac() {
    return PT;
  },
  IconTagFaces: function IconTagFaces() {
    return FT;
  },
  IconTapAndPlay: function IconTapAndPlay() {
    return AT;
  },
  IconTapas: function IconTapas() {
    return OT;
  },
  IconTerrain: function IconTerrain() {
    return GT;
  },
  IconTextFields: function IconTextFields() {
    return zT;
  },
  IconTextFormat: function IconTextFormat() {
    return KT;
  },
  IconTextRotateUp: function IconTextRotateUp() {
    return QT;
  },
  IconTextRotateVertical: function IconTextRotateVertical() {
    return $T;
  },
  IconTextRotationAngledown: function IconTextRotationAngledown() {
    return eA;
  },
  IconTextRotationAngleup: function IconTextRotationAngleup() {
    return tA;
  },
  IconTextRotationDown: function IconTextRotationDown() {
    return iA;
  },
  IconTextRotationNone: function IconTextRotationNone() {
    return aA;
  },
  IconTextSnippet: function IconTextSnippet() {
    return mA;
  },
  IconTextsms: function IconTextsms() {
    return lA;
  },
  IconTexture: function IconTexture() {
    return hA;
  },
  IconTheaters: function IconTheaters() {
    return CA;
  },
  IconThermostat: function IconThermostat() {
    return uA;
  },
  IconThumbDown: function IconThumbDown() {
    return HA;
  },
  IconThumbDownAlt: function IconThumbDownAlt() {
    return dA;
  },
  IconThumbUp: function IconThumbUp() {
    return LA;
  },
  IconThumbUpAlt: function IconThumbUpAlt() {
    return xA;
  },
  IconThumbsUpDown: function IconThumbsUpDown() {
    return NA;
  },
  IconTimeToLeave: function IconTimeToLeave() {
    return bA;
  },
  IconTimelapse: function IconTimelapse() {
    return BA;
  },
  IconTimeline: function IconTimeline() {
    return kA;
  },
  IconTimer: function IconTimer() {
    return AA;
  },
  IconTimerOff: function IconTimerOff() {
    return FA;
  },
  IconTimer_10: function IconTimer_10() {
    return PA;
  },
  IconTimer_3: function IconTimer_3() {
    return jA;
  },
  IconTitle: function IconTitle() {
    return OA;
  },
  IconToc: function IconToc() {
    return GA;
  },
  IconToday: function IconToday() {
    return zA;
  },
  IconToggleOff: function IconToggleOff() {
    return KA;
  },
  IconToggleOn: function IconToggleOn() {
    return QA;
  },
  IconToll: function IconToll() {
    return $A;
  },
  IconTonality: function IconTonality() {
    return eE;
  },
  IconTopic: function IconTopic() {
    return tE;
  },
  IconTouchApp: function IconTouchApp() {
    return iE;
  },
  IconTour: function IconTour() {
    return aE;
  },
  IconToys: function IconToys() {
    return mE;
  },
  IconTrackChanges: function IconTrackChanges() {
    return lE;
  },
  IconTraffic: function IconTraffic() {
    return hE;
  },
  IconTrain: function IconTrain() {
    return CE;
  },
  IconTram: function IconTram() {
    return uE;
  },
  IconTransferWithinAStation: function IconTransferWithinAStation() {
    return dE;
  },
  IconTransform: function IconTransform() {
    return HE;
  },
  IconTransitEnterexit: function IconTransitEnterexit() {
    return xE;
  },
  IconTranslate: function IconTranslate() {
    return LE;
  },
  IconTrendingDown: function IconTrendingDown() {
    return NE;
  },
  IconTrendingFlat: function IconTrendingFlat() {
    return bE;
  },
  IconTrendingUp: function IconTrendingUp() {
    return BE;
  },
  IconTripOrigin: function IconTripOrigin() {
    return kE;
  },
  IconTty: function IconTty() {
    return PE;
  },
  IconTune: function IconTune() {
    return jE;
  },
  IconTurnedIn: function IconTurnedIn() {
    return AE;
  },
  IconTurnedInNot: function IconTurnedInNot() {
    return FE;
  },
  IconTv: function IconTv() {
    return GE;
  },
  IconTvOff: function IconTvOff() {
    return OE;
  },
  IconTwoWheeler: function IconTwoWheeler() {
    return zE;
  },
  IconUmbrella: function IconUmbrella() {
    return KE;
  },
  IconUnarchive: function IconUnarchive() {
    return QE;
  },
  IconUndo: function IconUndo() {
    return $E;
  },
  IconUnfoldLess: function IconUnfoldLess() {
    return eO;
  },
  IconUnfoldMore: function IconUnfoldMore() {
    return tO;
  },
  IconUnpublished: function IconUnpublished() {
    return iO;
  },
  IconUnsubscribe: function IconUnsubscribe() {
    return aO;
  },
  IconUpdate: function IconUpdate() {
    return mO;
  },
  IconUpgrade: function IconUpgrade() {
    return lO;
  },
  IconUpload: function IconUpload() {
    return hO;
  },
  IconUsb: function IconUsb() {
    return CO;
  },
  IconVerified: function IconVerified() {
    return dO;
  },
  IconVerifiedUser: function IconVerifiedUser() {
    return uO;
  },
  IconVerticalAlignBottom: function IconVerticalAlignBottom() {
    return HO;
  },
  IconVerticalAlignCenter: function IconVerticalAlignCenter() {
    return xO;
  },
  IconVerticalAlignTop: function IconVerticalAlignTop() {
    return LO;
  },
  IconVerticalSplit: function IconVerticalSplit() {
    return NO;
  },
  IconVibration: function IconVibration() {
    return bO;
  },
  IconVideoCall: function IconVideoCall() {
    return BO;
  },
  IconVideoLabel: function IconVideoLabel() {
    return kO;
  },
  IconVideoLibrary: function IconVideoLibrary() {
    return PO;
  },
  IconVideoSettings: function IconVideoSettings() {
    return jO;
  },
  IconVideocam: function IconVideocam() {
    return AO;
  },
  IconVideocamOff: function IconVideocamOff() {
    return FO;
  },
  IconVideogameAsset: function IconVideogameAsset() {
    return OO;
  },
  IconViewAgenda: function IconViewAgenda() {
    return GO;
  },
  IconViewArray: function IconViewArray() {
    return zO;
  },
  IconViewCarousel: function IconViewCarousel() {
    return KO;
  },
  IconViewColumn: function IconViewColumn() {
    return QO;
  },
  IconViewComfy: function IconViewComfy() {
    return $O;
  },
  IconViewCompact: function IconViewCompact() {
    return e_;
  },
  IconViewDay: function IconViewDay() {
    return t_;
  },
  IconViewHeadline: function IconViewHeadline() {
    return i_;
  },
  IconViewList: function IconViewList() {
    return a_;
  },
  IconViewModule: function IconViewModule() {
    return m_;
  },
  IconViewQuilt: function IconViewQuilt() {
    return l_;
  },
  IconViewSidebar: function IconViewSidebar() {
    return h_;
  },
  IconViewStream: function IconViewStream() {
    return C_;
  },
  IconViewWeek: function IconViewWeek() {
    return u_;
  },
  IconVignette: function IconVignette() {
    return d_;
  },
  IconVisibility: function IconVisibility() {
    return Ft;
  },
  IconVisibilityOff: function IconVisibilityOff() {
    return Yt;
  },
  IconVoiceChat: function IconVoiceChat() {
    return x_;
  },
  IconVoiceOverOff: function IconVoiceOverOff() {
    return L_;
  },
  IconVoicemail: function IconVoicemail() {
    return N_;
  },
  IconVolumeDown: function IconVolumeDown() {
    return b_;
  },
  IconVolumeMute: function IconVolumeMute() {
    return B_;
  },
  IconVolumeOff: function IconVolumeOff() {
    return k_;
  },
  IconVolumeUp: function IconVolumeUp() {
    return P_;
  },
  IconVpnKey: function IconVpnKey() {
    return j_;
  },
  IconVpnLock: function IconVpnLock() {
    return F_;
  },
  IconWallpaper: function IconWallpaper() {
    return A_;
  },
  IconWarning: function IconWarning() {
    return Tt;
  },
  IconWarningAmber: function IconWarningAmber() {
    return O_;
  },
  IconWash: function IconWash() {
    return U_;
  },
  IconWatch: function IconWatch() {
    return q_;
  },
  IconWatchLater: function IconWatchLater() {
    return X_;
  },
  IconWaterDamage: function IconWaterDamage() {
    return J_;
  },
  IconWaves: function IconWaves() {
    return R_;
  },
  IconWbAuto: function IconWbAuto() {
    return oG;
  },
  IconWbCloudy: function IconWbCloudy() {
    return rG;
  },
  IconWbIncandescent: function IconWbIncandescent() {
    return sG;
  },
  IconWbIridescent: function IconWbIridescent() {
    return nG;
  },
  IconWbSunny: function IconWbSunny() {
    return cG;
  },
  IconWc: function IconWc() {
    return pG;
  },
  IconWeb: function IconWeb() {
    return gG;
  },
  IconWebAsset: function IconWebAsset() {
    return fG;
  },
  IconWeekend: function IconWeekend() {
    return wG;
  },
  IconWest: function IconWest() {
    return VG;
  },
  IconWhatshot: function IconWhatshot() {
    return MG;
  },
  IconWheelchairPickup: function IconWheelchairPickup() {
    return IG;
  },
  IconWhereToVote: function IconWhereToVote() {
    return vG;
  },
  IconWidgets: function IconWidgets() {
    return yG;
  },
  IconWifi: function IconWifi() {
    return TG;
  },
  IconWifiCalling: function IconWifiCalling() {
    return ZG;
  },
  IconWifiLock: function IconWifiLock() {
    return WG;
  },
  IconWifiOff: function IconWifiOff() {
    return DG;
  },
  IconWifiProtectedSetup: function IconWifiProtectedSetup() {
    return SG;
  },
  IconWifiTethering: function IconWifiTethering() {
    return YG;
  },
  IconWineBar: function IconWineBar() {
    return EG;
  },
  IconWork: function IconWork() {
    return XG;
  },
  IconWorkOff: function IconWorkOff() {
    return _G;
  },
  IconWorkOutline: function IconWorkOutline() {
    return UG;
  },
  IconWrapText: function IconWrapText() {
    return qG;
  },
  IconWrongLocation: function IconWrongLocation() {
    return JG;
  },
  IconWysiwyg: function IconWysiwyg() {
    return RG;
  },
  IconYoutubeSearchedFor: function IconYoutubeSearchedFor() {
    return oU;
  },
  IconZoomIn: function IconZoomIn() {
    return rU;
  },
  IconZoomOut: function IconZoomOut() {
    return nU;
  },
  IconZoomOutMap: function IconZoomOutMap() {
    return sU;
  },
  Image: function Image() {
    return ko;
  },
  Link: function Link() {
    return Po;
  },
  Loader: function Loader() {
    return ue;
  },
  Menu: function Menu() {
    return jo;
  },
  MenuButton: function MenuButton() {
    return oe;
  },
  MenuItem: function MenuItem() {
    return Yo;
  },
  Pagination: function Pagination() {
    return ye;
  },
  PasswordField: function PasswordField() {
    return ke;
  },
  PhoneNumberField: function PhoneNumberField() {
    return Pe;
  },
  Placeholder: function Placeholder() {
    return To;
  },
  Radio: function Radio() {
    return Se;
  },
  RadioGroupField: function RadioGroupField() {
    return je;
  },
  Rating: function Rating() {
    return Eo;
  },
  ScrollView: function ScrollView() {
    return _o;
  },
  SearchField: function SearchField() {
    return Be;
  },
  SelectField: function SelectField() {
    return De;
  },
  SharedText: function SharedText() {
    return i1;
  },
  SliderField: function SliderField() {
    return Go;
  },
  StepperField: function StepperField() {
    return Uo;
  },
  SwitchField: function SwitchField() {
    return zo;
  },
  TabItem: function TabItem() {
    return le;
  },
  Table: function Table() {
    return ei;
  },
  TableBody: function TableBody() {
    return oi;
  },
  TableCell: function TableCell() {
    return ti;
  },
  TableFoot: function TableFoot() {
    return ri;
  },
  TableHead: function TableHead() {
    return ii;
  },
  TableRow: function TableRow() {
    return si;
  },
  Tabs: function Tabs() {
    return Ye;
  },
  Text: function Text() {
    return G;
  },
  TextAreaField: function TextAreaField() {
    return $o;
  },
  TextField: function TextField() {
    return g1;
  },
  ToggleButton: function ToggleButton() {
    return ot;
  },
  ToggleButtonGroup: function ToggleButtonGroup() {
    return tt;
  },
  View: function View() {
    return c;
  },
  VisuallyHidden: function VisuallyHidden() {
    return e1;
  },
  usePagination: function usePagination() {
    return Ke;
  }
});
import * as s1 from "react";
import mU from "classnames";
var Vt = {
  Alert: {
    className: "amplify-alert",
    components: ["Alert"],
    description: "Top level element that wraps the Alert primitive"
  },
  AlertIcon: {
    className: "amplify-alert__icon",
    components: ["Alert"],
    description: "Class applied to Icon component within the Alert primitive"
  },
  AlertHeading: {
    className: "amplify-alert__heading",
    components: ["Alert"],
    description: "Class applied to the heading View"
  },
  AlertBody: {
    className: "amplify-alert__body",
    components: ["Alert"],
    description: "Class applied to the body View"
  },
  AlertDismiss: {
    className: "amplify-alert__dismiss",
    components: ["Alert"],
    description: "Class applied to the close Button"
  },
  Badge: {
    className: "amplify-badge",
    components: ["Badge"],
    description: "Top level element that wraps the Badge component"
  },
  Button: {
    className: "amplify-button",
    components: ["Button"],
    description: "Top level element that wraps the Button primitive"
  },
  ButtonGroup: {
    className: "amplify-buttongroup"
  },
  ButtonLoaderWrapper: {
    className: "amplify-button__loader-wrapper",
    components: ["Button"],
    description: "Class applied to the Loader component within the Button Loading state"
  },
  Card: {
    className: "amplify-card",
    components: ["Card"],
    description: "Top level element that wraps the Card primitive"
  },
  Checkbox: {
    className: "amplify-checkbox",
    components: ["Checkbox"],
    description: "Top level element that wraps the Checkbox primitive"
  },
  CheckboxButton: {
    className: "amplify-checkbox__button",
    components: ["Checkbox"],
    description: "Wrapper for the checked icon within the Checkbox primitive"
  },
  CheckboxIcon: {
    className: "amplify-checkbox__icon",
    components: ["Checkbox"],
    description: "Class applied to the checked icon within the Checkbox primitive"
  },
  CheckboxInput: {
    className: "amplify-checkbox__input",
    components: ["Checkbox"],
    description: "Class applied to the visually hidden checkbox input within the Checkbox primitive"
  },
  CheckboxLabel: {
    className: "amplify-checkbox__label",
    components: ["Checkbox"],
    description: "Class applied to the label within the Checkbox primitive"
  },
  CheckboxField: {
    className: "amplify-checkboxfield",
    components: ["CheckboxField"],
    description: "Top level element that wraps the CheckboxField primitive"
  },
  Collection: {
    className: "amplify-collection",
    components: ["Collection"],
    description: "Top level element that wraps the Collection primitive"
  },
  CollectionItems: {
    className: "amplify-collection-items",
    components: ["Collection"],
    description: "Class applied to the element that wraps all the items in a collection"
  },
  CollectionSearch: {
    className: "amplify-collection-search",
    components: ["Collection"],
    description: "Class applied to the element that wraps the collection search box"
  },
  CollectionPagination: {
    className: "amplify-collection-pagination",
    components: ["Collection"],
    description: "Class applied to the element that wraps the pagination component in a collection"
  },
  CountryCodeSelect: {
    className: "amplify-countrycodeselect",
    components: ["PhoneNumberField"],
    description: "Class applied to the Country Code Select within the PhoneNumberField primitive"
  },
  Divider: {
    className: "amplify-divider",
    components: ["Divider"],
    description: "Top level element that wraps the Divider primitive"
  },
  DividerLabel: {
    className: "amplify-divider--label",
    components: ["Divider"],
    description: "Class applied to the label of the Divider component"
  },
  Expander: {
    className: "amplify-expander",
    components: ["Expander"],
    description: "Top level element that wraps the Expander primitive"
  },
  ExpanderContent: {
    className: "amplify-expander__content",
    components: ["Expander"],
    description: "Expander content container"
  },
  ExpanderContentText: {
    className: "amplify-expander__content__text",
    components: ["Expander"],
    description: "Expander content text"
  },
  ExpanderHeader: {
    className: "amplify-expander__header",
    components: ["Expander"],
    description: "Expander item header"
  },
  ExpanderIcon: {
    className: "amplify-expander__icon",
    components: ["Expander"],
    description: "Icon to indicate whether an item is expanded or collapsed"
  },
  ExpanderItem: {
    className: "amplify-expander__item",
    components: ["Expander"],
    description: "Expander item(containier for header, trigger, and content)"
  },
  ExpanderTrigger: {
    className: "amplify-expander__trigger",
    components: ["Expander"],
    description: "Expander item trigger(button)"
  },
  Field: {
    className: "amplify-field"
  },
  FieldDescription: {
    className: "amplify-field__description"
  },
  FieldErrorMessage: {
    className: "amplify-field__error-message"
  },
  FieldGroup: {
    className: "amplify-field-group"
  },
  FieldGroupControl: {
    className: "amplify-field-group__control"
  },
  FieldGroupOuterEnd: {
    className: "amplify-field-group__outer-end"
  },
  FieldGroupOuterStart: {
    className: "amplify-field-group__outer-start"
  },
  FieldGroupInnerEnd: {
    className: "amplify-field-group__inner-end"
  },
  FieldGroupInnerStart: {
    className: "amplify-field-group__inner-start"
  },
  FieldGroupIcon: {
    className: "amplify-field-group__icon"
  },
  FieldGroupIconButton: {
    className: "amplify-field-group__icon-button"
  },
  FieldGroupHasInnerEnd: {
    className: "amplify-field-group--has-inner-end"
  },
  FieldGroupHasInnerStart: {
    className: "amplify-field-group--has-inner-start"
  },
  FieldShowPassword: {
    className: "amplify-field__show-password"
  },
  FieldGroupFieldWrapper: {
    className: "amplify-field-group__field-wrapper"
  },
  Flex: {
    className: "amplify-flex",
    components: ["Flex"],
    description: "Top level element that wraps the Flex primitive"
  },
  Grid: {
    className: "amplify-grid",
    components: ["Grid"],
    description: "Top level element that wraps the Grid primitive"
  },
  Heading: {
    className: "amplify-heading",
    components: ["Heading"],
    description: "Top level element that wraps the Heading primitive"
  },
  Icon: {
    className: "amplify-icon",
    components: ["Icon"],
    description: "Top level element that wraps the Icon primitive"
  },
  Image: {
    className: "amplify-image",
    components: ["Image"],
    description: "Top level element that wraps the Image primitive"
  },
  Input: {
    className: "amplify-input"
  },
  Label: {
    className: "amplify-label"
  },
  Link: {
    className: "amplify-link",
    components: ["Link"],
    description: "Top level element that wraps the Link primitive"
  },
  Loader: {
    className: "amplify-loader",
    components: ["Loader"],
    description: "Top level element that wraps the Loader primitive"
  },
  MenuContent: {
    className: "amplify-menu-content",
    components: ["Menu"],
    description: "Menu content container (Flex)"
  },
  MenuItem: {
    className: "amplify-menu-content__item",
    components: ["Menu"],
    description: "Menu item button (MenuButton, wrapped in amplify-menu-content class)"
  },
  MenuTrigger: {
    className: "amplify-menu-trigger",
    components: ["Menu"],
    description: "Menu trigger button (MenuButton, not wrapped in amplify-menu-content class)"
  },
  Pagination: {
    className: "amplify-pagination",
    components: ["Pagination"],
    description: "Top level element that wraps the Pagination primitive"
  },
  PaginationItemButton: {
    className: "amplify-pagination__item-button",
    components: ["Pagination"],
    description: "Class applied to the pagination buttons"
  },
  PaginationItemCurrent: {
    className: "amplify-pagination__item-current",
    components: ["Pagination"],
    description: "Class applied to the currently selected pagination button"
  },
  PaginationItemEllipsis: {
    className: "amplify-pagination__item-ellipsis",
    components: ["Pagination"],
    description: "Class applied to the ellipsis within the Pagination primitive"
  },
  PasswordField: {
    className: "amplify-passwordfield",
    components: ["PasswordField"],
    description: "Top level element that wraps the PasswordField primitive"
  },
  PhoneNumberField: {
    className: "amplify-phonenumberfield",
    components: ["PhoneNumberField"],
    description: "Top level element that wraps the PhoneNumberField primitive"
  },
  Placeholder: {
    className: "amplify-placeholder",
    components: ["Placeholder"],
    description: "Top level element that wraps the Placeholder primitive"
  },
  Radio: {
    className: "amplify-radio",
    components: ["RadioGroupField", "Radio"],
    description: "Top level element that wraps the Radio primitive"
  },
  RadioButton: {
    className: "amplify-radio__button",
    compoents: ["RadioGroupField", "Radio"],
    description: "Class applied to the displayed radio button"
  },
  RadioInput: {
    className: "amplify-radio__input",
    components: ["RadioGroupField", "Radio"],
    description: "Class applied to the visually hidden radio input"
  },
  RadioLabel: {
    className: "amplify-radio__label",
    components: ["RadioGroupField", "Radio"],
    description: "Class applied to the radio label"
  },
  RadioGroupField: {
    className: "amplify-radiogroupfield",
    components: ["RadioGroupField"],
    description: "Top level element that wraps the RadioGroupField primitive"
  },
  RadioGroup: {
    className: "amplify-radiogroup",
    components: ["RadioGroupField"],
    description: "Class applied to the radio group wrapper"
  },
  Rating: {
    className: "amplify-rating",
    components: ["Rating"],
    description: "Top level element that wraps the Rating primitive"
  },
  ScrollView: {
    className: "amplify-scrollview",
    components: ["ScrollView"],
    description: "Top level element that wraps the ScrollView primitive"
  },
  SearchField: {
    className: "amplify-searchfield",
    components: ["SearchField"],
    description: "Top level element that wraps the SearchField primitive"
  },
  SearchFieldClear: {
    className: "amplify-searchfield__clear",
    components: ["SearchField"],
    description: "Class applied to the search field clear button"
  },
  SearchFieldSearch: {
    className: "amplify-searchfield__search",
    components: ["SearchField"],
    description: "Class applied to the search button"
  },
  Select: {
    className: "amplify-select",
    components: ["Select", "SelectField"],
    description: "Class applied to the select element"
  },
  SelectField: {
    className: "amplify-selectfield",
    components: ["SelectField"],
    description: "Top level element that wraps the SelectField primitive"
  },
  SelectWrapper: {
    className: "amplify-select__wrapper",
    components: ["Select", "SelectField"],
    description: "Class applied to the select wrapper"
  },
  SelectIconWrapper: {
    className: "amplify-select__icon-wrapper",
    components: ["Select", "SelectField"],
    description: "Class applied to the select icon wrapper"
  },
  SliderField: {
    className: "amplify-sliderfield",
    components: ["SliderField"],
    description: "Top level element that wraps the SliderField primitive"
  },
  SliderFieldGroup: {
    className: "amplify-sliderfield__group",
    components: ["SliderField"],
    description: "Class applied to the element that wraps the slider root"
  },
  SliderFieldLabel: {
    className: "amplify-sliderfield__label",
    components: ["SliderField"],
    description: "Class applied to the slider label"
  },
  SliderFieldRange: {
    className: "amplify-sliderfield__range",
    components: ["SliderField"],
    description: "Class applied to the filled in portion of the slider track"
  },
  SliderFieldRoot: {
    className: "amplify-sliderfield__root",
    components: ["SliderField"],
    description: "Class applied to the slider root which wraps the track and thumb"
  },
  SliderFieldThumb: {
    className: "amplify-sliderfield__thumb",
    components: ["SliderField"],
    description: "Class applied to the slider thumb"
  },
  SliderFieldTrack: {
    className: "amplify-sliderfield__track",
    components: ["SliderField"],
    description: "Class applied to the slider track"
  },
  StepperField: {
    className: "amplify-stepperfield",
    components: ["StepperField"],
    description: "Top level element that wraps the StepperField primitive"
  },
  StepperFieldButtonDecrease: {
    className: "amplify-stepperfield__button--decrease",
    components: ["StepperField"],
    description: "Class applied to the decrease button"
  },
  StepperFieldButtonIncrease: {
    className: "amplify-stepperfield__button--increase",
    components: ["StepperField"],
    description: "Class applied to the increase button"
  },
  StepperFieldInput: {
    className: "amplify-stepperfield__input",
    components: ["StepperField"],
    description: "Class applied to the StepperField input"
  },
  SwitchField: {
    className: "amplify-switchfield",
    components: ["SwitchField"],
    description: "Top level element that wraps the SwitchField primitive"
  },
  SwitchLabel: {
    className: "amplify-switch-label",
    components: ["SwitchField"],
    description: "Class applied to the SwitchField label text"
  },
  SwitchThumb: {
    className: "amplify-switch-thumb",
    components: ["SwitchField"],
    description: "Class applied to the SwitchField thumb"
  },
  SwitchTrack: {
    className: "amplify-switch-track",
    components: ["SwitchField"],
    description: "Class applied to the SwitchField track"
  },
  SwitchWrapper: {
    className: "amplify-switch__wrapper",
    components: ["SwitchField"],
    description: "Class applied to the label element that wraps the SwitchField label and track"
  },
  Table: {
    className: "amplify-table",
    components: ["Table"],
    description: "Top level element that wraps the Table primitive"
  },
  TableCaption: {
    className: "amplify-table__caption",
    components: ["Table"],
    description: "Class applied to the content provided as the caption prop"
  },
  TableBody: {
    className: "amplify-table__body",
    components: ["Table"],
    description: "Class applied to TableBody component"
  },
  TableTd: {
    className: "amplify-table__td",
    components: ["Table"],
    description: 'Class applied to TableCell component rendered as a <td> element (<TableCell as="td" />)'
  },
  TableTh: {
    className: "amplify-table__th",
    components: ["Table"],
    description: 'Class applied to TableCell comopnent rendered as a <th> element (<TableCell as="th" />)'
  },
  TableFoot: {
    className: "amplify-table__foot",
    components: ["Table"],
    description: "Class applied to TableFoot component"
  },
  TableHead: {
    className: "amplify-table__head",
    components: ["Table"],
    description: "Class applied to TableHead component"
  },
  TableRow: {
    className: "amplify-table__row",
    components: ["Table"],
    description: "Class applied to TableRow component"
  },
  Tabs: {
    className: "amplify-tabs",
    components: ["Tabs"],
    description: "Top level element that wraps the Tabs primitive"
  },
  TabItems: {
    className: "amplify-tabs-item",
    components: ["Tabs"],
    description: "Top level element that wraps the TabItem primitive"
  },
  Text: {
    className: "amplify-text",
    components: ["Text"],
    description: "Top level element that wraps the Text primitive"
  },
  Textarea: {
    className: "amplify-textarea",
    components: ["TextAreaField"],
    description: "Class applied to the text area"
  },
  TextAreaField: {
    className: "amplify-textareafield",
    components: ["TextAreaField"],
    description: "Top level element that wraps the TextAreaField primitive"
  },
  TextField: {
    className: "amplify-textfield",
    components: ["TextField"],
    description: "Top level element that wraps the TextField primitive"
  },
  ToggleButton: {
    className: "amplify-togglebutton",
    components: ["ToggleButton"],
    description: "Top level element that wraps the ToggleButton primitive"
  },
  ToggleButtonGroup: {
    className: "amplify-togglebuttongroup",
    components: ["ToggleButton", "ToggleButtonGroup"],
    description: "Top level element that wraps the ToggleButtonGroup primitive"
  },
  VisuallyHidden: {
    className: "amplify-visually-hidden",
    components: ["VisuallyHidden"],
    description: "Top level element that wraps the VisuallyHidden primitive"
  }
},
    a = {};
Object.keys(Vt).map(function (t) {
  a[t] = Vt[t].className;
});
Object.freeze(a);
import * as no from "react";
import * as Lt from "react";
import { isDesignToken as Xi } from "@aws-amplify/ui";
var Ae = {
  alignContent: "alignContent",
  alignItems: "alignItems",
  alignSelf: "alignSelf",
  area: "gridArea",
  autoColumns: "gridAutoColumns",
  autoFlow: "gridAutoFlow",
  autoRows: "gridAutoRows",
  backgroundColor: "backgroundColor",
  backgroundImage: "backgroundImage",
  basis: "flexBasis",
  border: "border",
  borderRadius: "borderRadius",
  bottom: "bottom",
  boxShadow: "boxShadow",
  color: "color",
  column: "gridColumn",
  columnEnd: "gridColumnEnd",
  columnGap: "columnGap",
  columnSpan: "gridColumn",
  columnStart: "gridColumnStart",
  direction: "flexDirection",
  display: "display",
  flex: "flex",
  fontFamily: "fontFamily",
  fontSize: "fontSize",
  fontStyle: "fontStyle",
  fontWeight: "fontWeight",
  gap: "gap",
  grow: "flexGrow",
  height: "height",
  justifyContent: "justifyContent",
  left: "left",
  letterSpacing: "letterSpacing",
  lineHeight: "lineHeight",
  margin: "margin",
  marginBlockEnd: "marginBlockEnd",
  marginBlockStart: "marginBlockStart",
  marginBottom: "marginBlockEnd",
  marginInlineEnd: "marginInlineEnd",
  marginInlineStart: "marginInlineStart",
  marginLeft: "marginInlineStart",
  marginRight: "marginInlineEnd",
  marginTop: "marginBlockStart",
  maxHeight: "maxHeight",
  maxWidth: "maxWidth",
  minHeight: "minHeight",
  minWidth: "minWidth",
  objectFit: "objectFit",
  objectPosition: "objectPosition",
  opacity: "opacity",
  order: "order",
  overflow: "overflow",
  padding: "padding",
  paddingBlockEnd: "paddingBlockEnd",
  paddingBlockStart: "paddingBlockStart",
  paddingBottom: "paddingBlockEnd",
  paddingInlineEnd: "paddingInlineEnd",
  paddingInlineStart: "paddingInlineStart",
  paddingLeft: "paddingInlineStart",
  paddingRight: "paddingInlineEnd",
  paddingTop: "paddingBlockStart",
  position: "position",
  resize: "resize",
  right: "right",
  row: "gridRow",
  rowEnd: "gridRowEnd",
  rowGap: "rowGap",
  rowSpan: "gridRow",
  rowStart: "gridRowStart",
  shrink: "flexShrink",
  templateAreas: "gridTemplateAreas",
  templateColumns: "gridTemplateColumns",
  templateRows: "gridTemplateRows",
  textAlign: "textAlign",
  textDecoration: "textDecoration",
  textTransform: "textTransform",
  top: "top",
  transform: "transform",
  transformOrigin: "transformOrigin",
  width: "width",
  whiteSpace: "whiteSpace",
  wrap: "flexWrap"
},
    Ei = Object.keys(Ae);
import { isDesignToken as Oi } from "@aws-amplify/ui";

var pr = s(function (t, r, i) {
  if (typeof t != "object") return t;
  var o = {},
      f = Object.keys(i).sort(function (C, g) {
    return i[C] - i[g];
  });
  return Array.isArray(t) ? t.map(function (C, g) {
    o[f[g]] = C;
  }) : o = t, Object.keys(o).forEach(function (C) {
    var g = o[C];
    Oi(g) && (o[C] = g.toString());
  }), _i(o, r, i);
}, "getValueAtCurrentBreakpoint"),
    _i = s(function (t, r, i) {
  if (t.hasOwnProperty(r)) return t[r];
  var o = Object.keys(i).sort(function (C, g) {
    return i[g] - i[C];
  }),
      f = o.slice(o.indexOf(r));

  var _iterator3 = _createForOfIteratorHelper(f),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var C = _step3.value;
      if (t.hasOwnProperty(C)) return t[C];
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return null;
}, "getClosestValueByBreakpoint");

import * as f1 from "react";
var hr = s(function (_ref5) {
  var t = _ref5.breakpoints;
  var r = Object.keys(t).sort(function (i, o) {
    return t[o] - t[i];
  });
  return r.map(function (i, o) {
    var f = "",
        C = t[i],
        g = r[o - 1],
        u = g ? t[g] - 1 : null;
    return C >= 0 && (f = "(min-width: ".concat(C, "px)")), u !== null && (f && (f += " and "), f += "(max-width: ".concat(u, "px)")), {
      breakpoint: i,
      query: f,
      maxWidth: u,
      minWidth: C
    };
  });
}, "getMediaQueries");
var Gi = typeof window == "undefined" ? f1.useEffect : f1.useLayoutEffect,
    fr = s(function (_ref6) {
  var t = _ref6.breakpoints,
      r = _ref6.defaultBreakpoint;

  var o = typeof window != "undefined" && typeof window.matchMedia != "undefined" ? window.matchMedia : null,
      f = f1.useMemo(function () {
    return hr({
      breakpoints: t
    });
  }, [t]),
      _f1$useState = f1.useState(r),
      _f1$useState2 = _slicedToArray(_f1$useState, 2),
      C = _f1$useState2[0],
      g = _f1$useState2[1],
      u = f1.useCallback(function (w, d) {
    w && g(d);
  }, [g]);

  return Gi(function () {
    if (!o) return;
    var w = f.map(function (_ref7) {
      var d = _ref7.query,
          V = _ref7.breakpoint;
      var H = o(d);
      u(H.matches, V);
      var M = s(function (x) {
        x.matches && g(V);
      }, "handleMediaChange");
      return H.addEventListener("change", M), function () {
        return H.removeEventListener("change", M);
      };
    });
    return function () {
      w.forEach(function (d) {
        return d();
      });
    };
  }, [t, g, o, f]), f1.useDebugValue(C, function (w) {
    return w;
  }), C;
}, "useBreakpoint");
import * as gr from "react";
import * as Cr from "react";
import { defaultTheme as Ui } from "@aws-amplify/ui";
var Ht = s(function () {
  var t = Cr.useContext(pe);
  return Mt(t);
}, "useTheme"),
    Mt = s(function (t) {
  return typeof t == "undefined" || typeof t.theme == "undefined" ? Ui : t.theme;
}, "getThemeFromContext");

function zi() {
  var t = gr.useContext(pe);
  return {
    theme: Mt(t)
  };
}

s(zi, "useAmplify");
var ge = s(function (t) {
  return typeof t == "string" && t.length > 0;
}, "strHasLength"),
    O = s(function (t) {
  return typeof t == "function";
}, "isFunction"),
    xt = s(function (t) {
  return typeof t == "string" && t.length === 0;
}, "isEmptyString"),
    It = s(function (t) {
  return t == null || xt(t);
}, "isNullOrEmptyString"),
    Ee = s(function (t, r) {
  var i = r - t + 1;
  return Array.from({
    length: i
  }, function (o, f) {
    return f + t;
  });
}, "getConsecutiveIntArray");
var Ki = s(function (t) {
  var w = t,
      r = w.rowSpan,
      i = w.columnSpan,
      o = w.row,
      f = w.column,
      C = m(w, ["rowSpan", "columnSpan", "row", "column"]),
      _Lt$useMemo = Lt.useMemo(function () {
    return {
      rowFromSpanValue: ur(r),
      columnFromSpanValue: ur(i)
    };
  }, [r, i]),
      g = _Lt$useMemo.rowFromSpanValue,
      u = _Lt$useMemo.columnFromSpanValue;

  return n({
    row: It(o) ? g : o,
    column: It(f) ? u : f
  }, C);
}, "useTransformStyleProps"),
    ao = s(function (t, r) {
  var _Ht = Ht(),
      _Ht$breakpoints = _Ht.breakpoints,
      i = _Ht$breakpoints.values,
      o = _Ht$breakpoints.defaultBreakpoint,
      f = fr({
    breakpoints: i,
    defaultBreakpoint: o
  }),
      C = Ki(t);

  return Lt.useMemo(function () {
    return Qi({
      props: C,
      style: r,
      breakpoint: f,
      breakpoints: i
    });
  }, [C, r, i, f]);
}, "useStyles"),
    qi = s(function (t) {
  return t === "auto" || typeof t == "number" && !isNaN(t) || typeof t == "string" && !isNaN(parseFloat(t));
}, "isSpanPrimitiveValue"),
    ur = s(function (t) {
  if (qi(t)) return vt(t);
  if (Array.isArray(t)) return t.map(function (r) {
    return vt(r);
  });

  if (typeof t == "object" && t != null) {
    var r = {};
    return Object.entries(t).forEach(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
          i = _ref9[0],
          o = _ref9[1];

      r[i] = vt(o);
    }), r;
  }

  return null;
}, "convertGridSpan"),
    vt = s(function (t) {
  return t === "auto" ? "auto" : "span ".concat(t);
}, "getGridSpan"),
    Qi = s(function (_ref10) {
  var _ref10$props = _ref10.props,
      t = _ref10$props === void 0 ? {} : _ref10$props,
      _ref10$style = _ref10.style,
      r = _ref10$style === void 0 ? {} : _ref10$style,
      i = _ref10.breakpoint,
      o = _ref10.breakpoints;
  var f = {};
  return Object.keys(t).filter(function (C) {
    return t[C] != null;
  }).forEach(function (C) {
    if (!(C in Ae)) f[C] = t[C];else if (!xt(t[C])) {
      var g = t[C];
      Xi(g) ? g = g.toString() : g = pr(g, i, o);
      var u = Ae[C];
      r = $1(n({}, r), _defineProperty({}, u, g));
    }
  }), {
    propStyles: r,
    nonStyleProps: f
  };
}, "convertStylePropsToStyleObj"),
    Ji = {
  alignContent: !0,
  alignItems: !0,
  direction: !0,
  gap: !0,
  justifyContent: !0,
  wrap: !0,
  columnGap: !0,
  rowGap: !0
},
    $i = {
  alignSelf: !0,
  area: !0,
  backgroundColor: !0,
  backgroundImage: !0,
  basis: !0,
  border: !0,
  borderRadius: !0,
  bottom: !0,
  boxShadow: !0,
  color: !0,
  column: !0,
  columnEnd: !0,
  columnSpan: !0,
  columnStart: !0,
  display: !0,
  flex: !0,
  fontFamily: !0,
  fontSize: !0,
  fontStyle: !0,
  fontWeight: !0,
  grow: !0,
  height: !0,
  left: !0,
  letterSpacing: !0,
  lineHeight: !0,
  margin: !0,
  marginBlockEnd: !0,
  marginBlockStart: !0,
  marginBottom: !0,
  marginInlineEnd: !0,
  marginInlineStart: !0,
  marginLeft: !0,
  marginRight: !0,
  marginTop: !0,
  maxHeight: !0,
  maxWidth: !0,
  minHeight: !0,
  minWidth: !0,
  opacity: !0,
  order: !0,
  overflow: !0,
  padding: !0,
  paddingBlockEnd: !0,
  paddingBlockStart: !0,
  paddingBottom: !0,
  paddingInlineEnd: !0,
  paddingInlineStart: !0,
  paddingLeft: !0,
  paddingRight: !0,
  paddingTop: !0,
  position: !0,
  right: !0,
  row: !0,
  rowEnd: !0,
  rowSpan: !0,
  rowStart: !0,
  shrink: !0,
  textAlign: !0,
  textDecoration: !0,
  textTransform: !0,
  top: !0,
  transform: !0,
  transformOrigin: !0,
  width: !0,
  whiteSpace: !0
},
    J = s(function (t) {
  var r = {
    flexContainerStyleProps: {},
    baseStyleProps: {},
    rest: {}
  };
  return Object.keys(t).forEach(function (i) {
    i in Ji ? r.flexContainerStyleProps[i] = t[i] : i in $i ? r.baseStyleProps[i] = t[i] : r.rest[i] = t[i];
  }), r;
}, "splitPrimitiveProps");
var Ri = s(function (w, u) {
  var d = w,
      _d$as = d.as,
      t = _d$as === void 0 ? "div" : _d$as,
      r = d.children,
      i = d.testId,
      o = d.ariaLabel,
      f = d.isDisabled,
      C = d.style,
      g = m(d, ["as", "children", "testId", "ariaLabel", "isDisabled", "style"]);

  var _ao = ao(g, C),
      V = _ao.propStyles,
      H = _ao.nonStyleProps;

  return no.createElement(t, n({
    "aria-label": o,
    "data-testid": i,
    disabled: f,
    ref: u,
    style: V
  }, H), r);
}, "ViewPrimitive"),
    c = no.forwardRef(Ri);
c.displayName = "View";
import * as mo from "react";
import es from "classnames";
var os = s(function (f, o) {
  var C = f,
      t = C.className,
      r = C.children,
      i = m(C, ["className", "children"]);
  return mo.createElement(c, n({
    className: es(a.Flex, t),
    ref: o
  }, i), r);
}, "FlexPrimitive"),
    I = mo.forwardRef(os);
I.displayName = "Flex";
import ms from "classnames";
import * as we from "react";
import * as N1 from "react";
import ts from "classnames";
var rs = "linear-empty",
    is = "linear-filled",
    ss = "circular-empty",
    as = "circular-filled",
    ns = s(function (u, g) {
  var w = u,
      t = w.className,
      r = w.filledColor,
      i = w.emptyColor,
      o = w.size,
      f = w.variation,
      C = m(w, ["className", "filledColor", "emptyColor", "size", "variation"]);
  var d = N1.createElement("g", null, N1.createElement("line", {
    x1: "0",
    x2: "100%",
    y1: "50%",
    y2: "50%",
    style: {
      stroke: i
    },
    "data-testid": rs
  }), N1.createElement("line", {
    x1: "0",
    x2: "100%",
    y1: "50%",
    y2: "50%",
    style: {
      stroke: r
    },
    "data-testid": is
  })),
      V = N1.createElement("g", null, N1.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: "42%",
    strokeWidth: "8%",
    style: {
      stroke: i
    },
    "data-testid": ss
  }), N1.createElement("circle", {
    cx: "50%",
    cy: "50%",
    r: "42%",
    strokeWidth: "8%",
    style: {
      stroke: r
    },
    "data-testid": as
  }));
  return N1.createElement(c, n({
    as: "svg",
    className: ts(a.Loader, t),
    "data-size": o,
    "data-variation": f,
    ref: g,
    role: "img"
  }, C), f === "linear" ? d : V);
}, "LoaderPrimitive"),
    ue = N1.forwardRef(ns);
ue.displayName = "Loader";
var cs = s(function (H, V) {
  var M = H,
      t = M.className,
      r = M.children,
      _M$isFullWidth = M.isFullWidth,
      i = _M$isFullWidth === void 0 ? !1 : _M$isFullWidth,
      o = M.isDisabled,
      f = M.isLoading,
      _M$loadingText = M.loadingText,
      C = _M$loadingText === void 0 ? "" : _M$loadingText,
      g = M.size,
      _M$type = M.type,
      u = _M$type === void 0 ? "button" : _M$type,
      w = M.variation,
      d = m(M, ["className", "children", "isFullWidth", "isDisabled", "isLoading", "loadingText", "size", "type", "variation"]);
  return we.createElement(c, n({
    ref: V,
    as: "button",
    className: ms(a.Button, a.FieldGroupControl, t),
    "data-fullwidth": i,
    "data-loading": f,
    "data-size": g,
    "data-variation": w,
    isDisabled: o || f,
    type: u
  }, d), f && C ? we.createElement(I, {
    as: "span",
    className: a.ButtonLoaderWrapper
  }, we.createElement(ue, {
    size: g
  }), C) : r);
}, "ButtonPrimitive"),
    Z = we.forwardRef(cs);
Z.displayName = "Button";
import * as Ue from "react";
import * as de from "react";
import ls from "classnames";
var i1 = {
  CountryCodeSelect: {
    ariaLabel: "Country code"
  },
  ShowPasswordButton: {
    ariaLabel: {
      showPassword: "Show password",
      hidePassword: "Hide password"
    }
  },
  Fields: {
    ariaLabel: {
      clearField: "Clear search"
    }
  },
  SearchField: {
    ariaLabel: {
      search: "Search"
    }
  },
  StepperField: {
    ariaLabel: {
      IncreaseTo: "Increase to",
      DecreaseTo: "Decrease to"
    }
  },
  Collection: {
    SearchFieldLabel: "Search"
  }
};
var Oe = {
  minX: 0,
  minY: 0,
  width: 24,
  height: 24
},
    ps = s(function (d, w) {
  var V = d,
      t = V.className,
      _V$as = V.as,
      r = _V$as === void 0 ? "svg" : _V$as,
      _V$fill = V.fill,
      i = _V$fill === void 0 ? "currentColor" : _V$fill,
      o = V.pathData,
      _V$viewBox = V.viewBox,
      f = _V$viewBox === void 0 ? Oe : _V$viewBox,
      C = V.children,
      g = V.paths,
      u = m(V, ["className", "as", "fill", "pathData", "viewBox", "children", "paths"]);
  var H = f.minX ? f.minX : Oe.minX,
      M = f.minY ? f.minY : Oe.minY,
      x = f.width ? f.width : Oe.width,
      L = f.height ? f.height : Oe.height,
      v;
  return C && (v = C), g && (v = g.map(function (b, y) {
    return de.createElement("path", $1(n({}, b), {
      key: y
    }));
  })), o && (v = de.createElement("path", {
    d: o,
    fill: i
  })), de.createElement(c, n({
    as: r,
    className: ls(a.Icon, t),
    ref: w,
    viewBox: "".concat(H, " ").concat(M, " ").concat(x, " ").concat(L)
  }, u), v);
}, "IconPrimitive"),
    fe = de.forwardRef(ps);
fe.displayName = "Icon";
import hs from "classnames";
import * as wr from "react";
var l = s(function (_ref11) {
  var t = _ref11.shouldWarn,
      r = _ref11.message;
  wr.useEffect(function () {
    t && (typeof process == "undefined" || process && process.env.NODE_ENV !== "production") && console.warn(r);
  }, [t, r]);
}, "useDeprecationWarning");
var fs = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { Icon360 } from '@aws-amplify/ui-react'; \u2192 import { Md360 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 7C6.48 7 2 9.24 2 12C2 14.24 4.94 16.13 9 16.77V20L13 16L9 12V14.73C5.85 14.17 4 12.83 4 12C4 10.94 7.04 9 12 9C16.96 9 20 10.94 20 12C20 12.73 18.54 13.89 16 14.53V16.58C19.53 15.81 22 14.05 22 12C22 9.24 17.52 7 12 7V7Z",
    fill: "currentColor"
  })));
}, "Icon360");
import Cs from "classnames";
var gs = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { Icon3dRotation } from '@aws-amplify/ui-react'; \u2192 import { Md3dRotation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.53 21.48C4.26 19.94 1.92 16.76 1.56 13H0.0599995C0.569999 19.16 5.72 24 12.01 24L12.67 23.97L8.86 20.16L7.53 21.48V21.48ZM8.42 14.96C8.23 14.96 8.05 14.93 7.9 14.88C7.74 14.82 7.61 14.75 7.5 14.64C7.39 14.54 7.3 14.42 7.24 14.27C7.18 14.13 7.15 13.97 7.15 13.8H5.85C5.85 14.16 5.92 14.48 6.06 14.75C6.2 15.02 6.39 15.25 6.62 15.44C6.86 15.62 7.13 15.76 7.44 15.85C7.74 15.95 8.06 16 8.4 16C8.77 16 9.12 15.95 9.43 15.85C9.75 15.75 10.03 15.6 10.26 15.41C10.49 15.22 10.68 14.98 10.81 14.69C10.94 14.4 11.01 14.08 11.01 13.72C11.01 13.53 10.99 13.34 10.94 13.16C10.89 12.98 10.82 12.81 10.71 12.65C10.61 12.49 10.47 12.35 10.31 12.22C10.14 12.09 9.94 11.99 9.7 11.91C9.9 11.82 10.07 11.71 10.22 11.58C10.37 11.45 10.49 11.31 10.59 11.16C10.69 11.01 10.76 10.86 10.81 10.7C10.86 10.54 10.88 10.38 10.88 10.22C10.88 9.86 10.82 9.54 10.7 9.26C10.58 8.98 10.41 8.75 10.19 8.57C9.99 8.38 9.72 8.24 9.42 8.14C9.11 8.05 8.77 8 8.4 8C8.04 8 7.71 8.05 7.4 8.16C7.1 8.27 6.83 8.42 6.61 8.61C6.4 8.8 6.23 9.02 6.1 9.28C5.98 9.54 5.92 9.82 5.92 10.13H7.22C7.22 9.96 7.25 9.81 7.31 9.68C7.37 9.55 7.45 9.43 7.56 9.34C7.67 9.25 7.79 9.17 7.94 9.12C8.09 9.07 8.24 9.04 8.42 9.04C8.82 9.04 9.12 9.14 9.31 9.35C9.5 9.55 9.6 9.84 9.6 10.21C9.6 10.39 9.57 10.55 9.52 10.7C9.47 10.85 9.38 10.97 9.27 11.07C9.16 11.17 9.02 11.25 8.86 11.31C8.7 11.37 8.5 11.4 8.28 11.4H7.51V12.43H8.28C8.5 12.43 8.7 12.45 8.88 12.5C9.06 12.55 9.21 12.63 9.33 12.73C9.45 12.84 9.55 12.97 9.62 13.13C9.69 13.29 9.72 13.48 9.72 13.7C9.72 14.11 9.6 14.42 9.37 14.63C9.14 14.86 8.82 14.96 8.42 14.96V14.96ZM16.97 9.04C16.65 8.71 16.27 8.45 15.83 8.27C15.39 8.09 14.9 8 14.36 8H12V16H14.3C14.85 16 15.36 15.91 15.81 15.73C16.26 15.55 16.65 15.3 16.97 14.97C17.29 14.64 17.54 14.24 17.71 13.78C17.88 13.31 17.97 12.79 17.97 12.21V11.81C17.97 11.23 17.88 10.71 17.71 10.24C17.54 9.77 17.29 9.37 16.97 9.04ZM16.58 12.2C16.58 12.62 16.53 12.99 16.44 13.33C16.34 13.66 16.2 13.95 16.01 14.18C15.82 14.41 15.58 14.59 15.3 14.71C15.01 14.83 14.68 14.89 14.31 14.89H13.4V9.12H14.37C15.09 9.12 15.64 9.35 16.01 9.81C16.39 10.27 16.58 10.93 16.58 11.8V12.2V12.2ZM12.01 0L11.35 0.03L15.16 3.84L16.49 2.51C19.76 4.06 22.1 7.23 22.45 10.99H23.95C23.45 4.84 18.3 0 12.01 0Z",
    fill: "currentColor"
  })));
}, "Icon3dRotation");
import us from "classnames";
var ws = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { Icon4k } from '@aws-amplify/ui-react'; \u2192 import { Md4k } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: us(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V5H19V19ZM9.5 15H11V13.51H12V12H11V9H9.5V12H8V9H6.5V13.5H9.5V15ZM18.2 15L16.2 12L18.2 9H16.5L14.5 12L16.5 15H18.2ZM14.5 12V9H13V15H14.5V12Z",
    fill: "currentColor"
  })));
}, "Icon4k");
import ds from "classnames";
var Vs = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { Icon5g } from '@aws-amplify/ui-react'; \u2192 import { Md5g } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ds(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.5 13H19V15H14V9H21C21 7.9 20.1 7 19 7H14C12.9 7 12 7.9 12 9V15C12 16.1 12.9 17 14 17H19C20.1 17 21 16.1 21 15V11H16.5V13Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M3 13H8V15H3V17H8C9.1 17 10 16.1 10 15V13C10 11.9 9.1 11 8 11H5V9H10V7H3V13Z",
    fill: "black"
  })));
}, "Icon5g");
import Hs from "classnames";
var Ms = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { Icon6FtApart } from '@aws-amplify/ui-react'; \u2192 import { Md6FtApart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 6C7.1 6 8 5.1 8 4C8 2.9 7.1 2 6 2C4.9 2 4 2.9 4 4C4 5.1 4.9 6 6 6ZM10 9.43C10 8.62 9.52 7.9 8.78 7.58C7.93 7.21 6.99 7 6 7C5.01 7 4.07 7.21 3.22 7.58C2.48 7.9 2 8.62 2 9.43V10H10V9.43ZM18 6C19.1 6 20 5.1 20 4C20 2.9 19.1 2 18 2C16.9 2 16 2.9 16 4C16 5.1 16.9 6 18 6ZM22 9.43C22 8.62 21.52 7.9 20.78 7.58C19.93 7.21 18.99 7 18 7C17.01 7 16.07 7.21 15.22 7.58C14.48 7.9 14 8.62 14 9.43V10H22V9.43ZM19 17V14.99L5 15V17L2 14L5 11V13.01L19 13V11L22 14L19 17ZM10 19V18H7.5C7.22 18 7 18.22 7 18.5V21.5C7 21.78 7.22 22 7.5 22H9.5C9.78 22 10 21.78 10 21.5V20C10 19.72 9.78 19.5 9.5 19.5H8V19H10ZM9 20.5V21H8V20.5H9ZM17.5 19H16.5V22H15.5V19H14.5V18H17.5V19ZM12.5 19V19.5H13.5V20.5H12.5V22H11.5V18H14V19H12.5Z",
    fill: "currentColor"
  })));
}, "Icon6FtApart");
import xs from "classnames";
var Is = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAcUnit } from '@aws-amplify/ui-react'; \u2192 import { MdAcUnit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 11H17.83L21.07 7.76L19.66 6.34L15 11H13V9L17.66 4.34L16.24 2.93L13 6.17V2H11V6.17L7.76 2.93L6.34 4.34L11 9V11H9L4.34 6.34L2.93 7.76L6.17 11H2V13H6.17L2.93 16.24L4.34 17.66L9 13H11V15L6.34 19.66L7.76 21.07L11 17.83V22H13V17.83L16.24 21.07L17.66 19.66L13 15V13H15L19.66 17.66L21.07 16.24L17.83 13H22V11Z",
    fill: "currentColor"
  })));
}, "IconAcUnit");
import Ls from "classnames";
var vs = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccessAlarm } from '@aws-amplify/ui-react'; \u2192 import { MdAccessAlarm } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ls(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 5.71986L17.4 1.85986L16.11 3.38986L20.71 7.24986L22 5.71986ZM7.88 3.38986L6.6 1.85986L2 5.70986L3.29 7.23986L7.88 3.38986ZM12.5 7.99986H11V13.9999L15.75 16.8499L16.5 15.6199L12.5 13.2499V7.99986ZM12 3.99986C7.03 3.99986 3 8.02986 3 12.9999C3 17.9699 7.02 21.9999 12 21.9999C16.97 21.9999 21 17.9699 21 12.9999C21 8.02986 16.97 3.99986 12 3.99986ZM12 19.9999C8.13 19.9999 5 16.8699 5 12.9999C5 9.12986 8.13 5.99986 12 5.99986C15.87 5.99986 19 9.12986 19 12.9999C19 16.8699 15.87 19.9999 12 19.9999Z",
    fill: "currentColor"
  })));
}, "IconAccessAlarm");
import Ns from "classnames";
var ys = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccessAlarms } from '@aws-amplify/ui-react'; \u2192 import { MdAccessAlarms } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ns(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 5.6998L17.4 1.7998L16.1 3.2998L20.7 7.1998L22 5.6998ZM7.9 3.3998L6.6 1.8998L2 5.6998L3.3 7.1998L7.9 3.3998V3.3998ZM12.5 7.9998H11V13.9998L15.7 16.8998L16.5 15.6998L12.5 13.2998V7.9998ZM12 3.9998C7 3.9998 3 7.9998 3 12.9998C3 17.9998 7 21.9998 12 21.9998C17 21.9998 21 17.9998 21 12.9998C21 7.9998 17 3.9998 12 3.9998ZM12 19.9998C8.1 19.9998 5 16.8998 5 12.9998C5 9.0998 8.1 5.9998 12 5.9998C15.9 5.9998 19 9.0998 19 12.9998C19 16.8998 15.9 19.9998 12 19.9998Z",
    fill: "currentColor"
  })));
}, "IconAccessAlarms");
import bs from "classnames";
var Zs = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccessTime } from '@aws-amplify/ui-react'; \u2192 import { MdAccessTime } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z",
    fill: "currentColor"
  })));
}, "IconAccessTime");
import Bs from "classnames";
var Ws = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccessibilityNew } from '@aws-amplify/ui-react'; \u2192 import { MdAccessibilityNew } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.5 6C17.89 6.7 14.83 7 12 7C9.17 7 6.11 6.7 3.5 6L3 8C4.86 8.5 7 8.83 9 9V22H11V16H13V22H15V9C17 8.83 19.14 8.5 21 8L20.5 6ZM12 6C13.1 6 14 5.1 14 4C14 2.9 13.1 2 12 2C10.9 2 10 2.9 10 4C10 5.1 10.9 6 12 6Z",
    fill: "currentColor"
  })));
}, "IconAccessibilityNew");
import ks from "classnames";
var Ds = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccessibility } from '@aws-amplify/ui-react'; \u2192 import { MdAccessibility } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ks(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9H15V22H13V16H11V22H9V9H3V7H21V9Z",
    fill: "currentColor"
  })));
}, "IconAccessibility");
import Ps from "classnames";
var Ss = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccessibleForward } from '@aws-amplify/ui-react'; \u2192 import { MdAccessibleForward } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ps(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 6.54004C19.1046 6.54004 20 5.64461 20 4.54004C20 3.43547 19.1046 2.54004 18 2.54004C16.8954 2.54004 16 3.43547 16 4.54004C16 5.64461 16.8954 6.54004 18 6.54004Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15 17H13C13 18.65 11.65 20 10 20C8.35 20 7 18.65 7 17C7 15.35 8.35 14 10 14V12C7.24 12 5 14.24 5 17C5 19.76 7.24 22 10 22C12.76 22 15 19.76 15 17ZM18 13.5H16.14L17.81 9.83C18.42 8.5 17.44 7 15.96 7H10.76C9.95 7 9.22 7.47 8.89 8.2L8.22 10L10.14 10.53L10.79 9H13L11.17 13.1C10.57 14.43 11.56 16 13.02 16H18V21H20V15.5C20 14.4 19.1 13.5 18 13.5Z",
    fill: "black"
  })));
}, "IconAccessibleForward");
import js from "classnames";
var Ys = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccessible } from '@aws-amplify/ui-react'; \u2192 import { MdAccessible } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: js(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M19 12.9999V10.9999C17.46 11.0199 15.91 10.2499 14.93 9.16992L13.64 7.73992C13.47 7.54992 13.26 7.39992 13.03 7.28992C13.02 7.28992 13.02 7.27992 13.01 7.27992H13C12.65 7.07992 12.25 6.97992 11.81 7.01992C10.76 7.10992 10 8.03992 10 9.08992V14.9999C10 16.0999 10.9 16.9999 12 16.9999H17V21.9999H19V16.4999C19 15.3999 18.1 14.4999 17 14.4999H14V11.0499C15.29 12.1199 17.25 12.9899 19 12.9999ZM10 19.9999C8.34 19.9999 7 18.6599 7 16.9999C7 15.6899 7.84 14.5899 9 14.1699V12.0999C6.72 12.5599 5 14.5799 5 16.9999C5 19.7599 7.24 21.9999 10 21.9999C12.42 21.9999 14.44 20.2799 14.9 17.9999H12.83C12.42 19.1599 11.31 19.9999 10 19.9999Z",
    fill: "black"
  })));
}, "IconAccessible");
import Fs from "classnames";
var Ts = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccountBalanceWallet } from '@aws-amplify/ui-react'; \u2192 import { MdAccountBalanceWallet } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 7.28V5C21 3.9 20.1 3 19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V16.72C21.59 16.37 22 15.74 22 15V9C22 8.26 21.59 7.63 21 7.28ZM20 9V15H13V9H20ZM5 19V5H19V7H13C11.9 7 11 7.9 11 9V15C11 16.1 11.9 17 13 17H19V19H5Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M16 13.5C16.8284 13.5 17.5 12.8284 17.5 12C17.5 11.1716 16.8284 10.5 16 10.5C15.1716 10.5 14.5 11.1716 14.5 12C14.5 12.8284 15.1716 13.5 16 13.5Z",
    fill: "black"
  })));
}, "IconAccountBalanceWallet");
import As from "classnames";
var Es = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccountBalance } from '@aws-amplify/ui-react'; \u2192 import { MdAccountBalance } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: As(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.5 10H4.5V17H6.5V10ZM12.5 10H10.5V17H12.5V10ZM21 19H2V21H21V19ZM18.5 10H16.5V17H18.5V10ZM11.5 3.26L16.71 6H6.29L11.5 3.26ZM11.5 1L2 6V8H21V6L11.5 1Z",
    fill: "currentColor"
  })));
}, "IconAccountBalance");
import Os from "classnames";

var _s = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccountBox } from '@aws-amplify/ui-react'; \u2192 import { MdAccountBox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Os(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 12C10.35 12 9 10.65 9 9C9 7.35 10.35 6 12 6C13.65 6 15 7.35 15 9C15 10.65 13.65 12 12 12ZM12 8C11.45 8 11 8.45 11 9C11 9.55 11.45 10 12 10C12.55 10 13 9.55 13 9C13 8.45 12.55 8 12 8ZM18 18H6V16.47C6 13.97 9.97 12.89 12 12.89C14.03 12.89 18 13.97 18 16.47V18ZM8.31 16H15.69C15 15.44 13.31 14.88 12 14.88C10.69 14.88 8.99 15.44 8.31 16V16Z",
    fill: "currentColor"
  })));
}, "IconAccountBox");

import Gs from "classnames";
var Us = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccountCircle } from '@aws-amplify/ui-react'; \u2192 import { MdAccountCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.07 18.28C7.5 17.38 10.12 16.5 12 16.5C13.88 16.5 16.51 17.38 16.93 18.28C15.57 19.36 13.86 20 12 20C10.14 20 8.43 19.36 7.07 18.28ZM18.36 16.83C16.93 15.09 13.46 14.5 12 14.5C10.54 14.5 7.07 15.09 5.64 16.83C4.62 15.49 4 13.82 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.82 19.38 15.49 18.36 16.83V16.83ZM12 6C10.06 6 8.5 7.56 8.5 9.5C8.5 11.44 10.06 13 12 13C13.94 13 15.5 11.44 15.5 9.5C15.5 7.56 13.94 6 12 6ZM12 11C11.17 11 10.5 10.33 10.5 9.5C10.5 8.67 11.17 8 12 8C12.83 8 13.5 8.67 13.5 9.5C13.5 10.33 12.83 11 12 11Z",
    fill: "currentColor"
  })));
}, "IconAccountCircle");
import zs from "classnames";
var Xs = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAccountTree } from '@aws-amplify/ui-react'; \u2192 import { MdAccountTree } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 11V3H15V6H9V3H2V11H9V8H11V18H15V21H22V13H15V16H13V8H15V11H22ZM7 9H4V5H7V9ZM17 15H20V19H17V15ZM17 5H20V9H17V5Z",
    fill: "currentColor"
  })));
}, "IconAccountTree");
import Ks from "classnames";
var qs = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAdUnits } from '@aws-amplify/ui-react'; \u2192 import { MdAdUnits } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ks(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM7 4V3H17V4H7ZM7 18V6H17V18H7ZM7 21V20H17V21H7Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M16 7H8V9H16V7Z",
    fill: "black"
  })));
}, "IconAdUnits");
import Qs from "classnames";
var Js = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAdb } from '@aws-amplify/ui-react'; \u2192 import { MdAdb } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qs(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 15.9999C5 19.8699 8.13 22.9999 12 22.9999C15.87 22.9999 19 19.8699 19 15.9999V11.9999H5V15.9999ZM16.12 4.36994L18.22 2.26994L17.4 1.43994L15.1 3.74994C14.16 3.27994 13.12 2.99994 12 2.99994C10.88 2.99994 9.84 3.27994 8.91 3.74994L6.6 1.43994L5.78 2.26994L7.88 4.36994C6.14 5.63994 5 7.67994 5 9.99994V10.9999H19V9.99994C19 7.67994 17.86 5.63994 16.12 4.36994ZM9 8.99994C8.45 8.99994 8 8.54994 8 7.99994C8 7.44994 8.45 6.99994 9 6.99994C9.55 6.99994 10 7.44994 10 7.99994C10 8.54994 9.55 8.99994 9 8.99994ZM15 8.99994C14.45 8.99994 14 8.54994 14 7.99994C14 7.44994 14.45 6.99994 15 6.99994C15.55 6.99994 16 7.44994 16 7.99994C16 8.54994 15.55 8.99994 15 8.99994Z",
    fill: "currentColor"
  })));
}, "IconAdb");
import $s from "classnames";
var Rs = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddAPhoto } from '@aws-amplify/ui-react'; \u2192 import { MdAddAPhoto } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $s(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 6H17.83L16 4H10V6H15.12L16.95 8H21V20H5V11H3V20C3 21.1 3.9 22 5 22H21C22.1 22 23 21.1 23 20V8C23 6.9 22.1 6 21 6ZM8 14C8 16.76 10.24 19 13 19C15.76 19 18 16.76 18 14C18 11.24 15.76 9 13 9C10.24 9 8 11.24 8 14ZM13 11C14.65 11 16 12.35 16 14C16 15.65 14.65 17 13 17C11.35 17 10 15.65 10 14C10 12.35 11.35 11 13 11ZM5 6H8V4H5V1H3V4H0V6H3V9H5V6Z",
    fill: "currentColor"
  })));
}, "IconAddAPhoto");
import ea from "classnames";
var oa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddAlarm } from '@aws-amplify/ui-react'; \u2192 import { MdAddAlarm } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ea(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.88 3.38986L6.6 1.85986L2 5.70986L3.29 7.23986L7.88 3.38986ZM22 5.71986L17.4 1.85986L16.11 3.38986L20.71 7.24986L22 5.71986ZM12 3.99986C7.03 3.99986 3 8.02986 3 12.9999C3 17.9699 7.02 21.9999 12 21.9999C16.97 21.9999 21 17.9699 21 12.9999C21 8.02986 16.97 3.99986 12 3.99986ZM12 19.9999C8.13 19.9999 5 16.8699 5 12.9999C5 9.12986 8.13 5.99986 12 5.99986C15.87 5.99986 19 9.12986 19 12.9999C19 16.8699 15.87 19.9999 12 19.9999ZM13 8.99986H11V11.9999H8V13.9999H11V16.9999H13V13.9999H16V11.9999H13V8.99986Z",
    fill: "currentColor"
  })));
}, "IconAddAlarm");
import ta from "classnames";
var ra = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddAlert } from '@aws-amplify/ui-react'; \u2192 import { MdAddAlert } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ta(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.01 21.01C10.01 22.11 10.9 23 12 23C13.1 23 13.99 22.11 13.99 21.01H10.01ZM12 6C14.76 6 17 8.24 17 11V18H7V11C7 8.24 9.24 6 12 6ZM12 1.5C11.17 1.5 10.5 2.17 10.5 3V4.17C7.36 4.85 5 7.65 5 11V17L3 19V20H21V19L19 17V11C19 7.65 16.64 4.85 13.5 4.17V3C13.5 2.17 12.83 1.5 12 1.5ZM13 8H11V11H8V13H11V16H13V13H16V11H13V8Z",
    fill: "currentColor"
  })));
}, "IconAddAlert");
import ia from "classnames";
var sa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddBox } from '@aws-amplify/ui-react'; \u2192 import { MdAddBox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ia(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM11 17H13V13H17V11H13V7H11V11H7V13H11V17Z",
    fill: "currentColor"
  })));
}, "IconAddBox");
import aa from "classnames";
var na = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddBusiness } from '@aws-amplify/ui-react'; \u2192 import { MdAddBusiness } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aa(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 4H2V6H17V4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15 17H17V14H18V12L17 7H2L1 12V14H2V20H11V14H15V17ZM9 18H4V14H9V18ZM3.04 12L3.64 9H15.36L15.96 12H3.04Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M23 18H20V15H18V18H15V20H18V23H20V20H23V18Z",
    fill: "black"
  })));
}, "IconAddBusiness");
import ma from "classnames";
var ca = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddCircleOutline } from '@aws-amplify/ui-react'; \u2192 import { MdAddCircleOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ma(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconAddCircleOutline");
import la from "classnames";
var pa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddCircle } from '@aws-amplify/ui-react'; \u2192 import { MdAddCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: la(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z",
    fill: "currentColor"
  })));
}, "IconAddCircle");
import ha from "classnames";
var fa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddComment } from '@aws-amplify/ui-react'; \u2192 import { MdAddComment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ha(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 4C22 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4ZM20 17.17L18.83 16H4V4H20V17.17ZM13 5H11V9H7V11H11V15H13V11H17V9H13V5Z",
    fill: "currentColor"
  })));
}, "IconAddComment");
import Ca from "classnames";
var ga = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddIcCall } from '@aws-amplify/ui-react'; \u2192 import { MdAddIcCall } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ca(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 15.4502C18.75 15.4502 17.55 15.2502 16.43 14.8802C16.33 14.8502 16.22 14.8302 16.12 14.8302C15.86 14.8302 15.61 14.9302 15.41 15.1202L13.21 17.3202C10.38 15.8802 8.06 13.5702 6.62 10.7302L8.82 8.5202C9.1 8.2602 9.18 7.8702 9.07 7.5202C8.7 6.4002 8.5 5.2002 8.5 3.9502C8.5 3.4002 8.05 2.9502 7.5 2.9502H4C3.45 2.9502 3 3.4002 3 3.9502C3 13.3402 10.61 20.9502 20 20.9502C20.55 20.9502 21 20.5002 21 19.9502V16.4502C21 15.9002 20.55 15.4502 20 15.4502ZM5.03 4.9502H6.53C6.6 5.8302 6.75 6.7002 6.98 7.5302L5.78 8.7402C5.38 7.5302 5.12 6.2702 5.03 4.9502ZM19 18.9202C17.68 18.8302 16.4 18.5702 15.2 18.1602L16.4 16.9602C17.25 17.2002 18.12 17.3502 19 17.4102V18.9202ZM18 5.9502V2.9502H16V5.9502H13V7.9502H16V10.9502H18V7.9502H21V5.9502H18Z",
    fill: "currentColor"
  })));
}, "IconAddIcCall");
import ua from "classnames";
var wa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddLocationAlt } from '@aws-amplify/ui-react'; \u2192 import { MdAddLocationAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ua(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 1V4H23V6H20V9H18V6H15V4H18V1H20ZM12 13C10.9 13 10 12.1 10 11C10 9.9 10.9 9 12 9C13.1 9 14 9.9 14 11C14 12.1 13.1 13 12 13ZM13 3.06V5.08C12.6692 5.02773 12.3349 5.00098 12 5C8.65 5 6 7.57 6 11.2C6 13.54 7.95 16.64 12 20.34C16.05 16.64 18 13.55 18 11.2V11H20V11.2C20 14.52 17.33 18.45 12 23C6.67 18.45 4 14.52 4 11.2C4 6.22 7.8 3 12 3C12.34 3 12.67 3.02 13 3.06V3.06Z",
    fill: "currentColor"
  })));
}, "IconAddLocationAlt");
import da from "classnames";
var Va = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddLocation } from '@aws-amplify/ui-react'; \u2192 import { MdAddLocation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: da(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 6V9H16V11H13V14H11V11H8V9H11V6H13ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z",
    fill: "currentColor"
  })));
}, "IconAddLocation");
import Ha from "classnames";
var Ma = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddPhotoAlternate } from '@aws-amplify/ui-react'; \u2192 import { MdAddPhotoAlternate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ha(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 20H4V6H13V4H4C2.9 4 2 4.9 2 6V20C2 21.1 2.9 22 4 22H18C19.1 22 20 21.1 20 20V11H18V20ZM10.21 16.83L8.25 14.47L5.5 18H16.5L12.96 13.29L10.21 16.83ZM20 4V1H18V4H15C15.01 4.01 15 6 15 6H18V8.99C18.01 9 20 8.99 20 8.99V6H23V4H20Z",
    fill: "currentColor"
  })));
}, "IconAddPhotoAlternate");
import xa from "classnames";
var Ia = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddRoad } from '@aws-amplify/ui-react'; \u2192 import { MdAddRoad } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xa(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 18V15H18V18H15V20H18V23H20V20H23V18H20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M20 4H18V13H20V4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M6 4H4V20H6V4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 4H11V8H13V4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 10H11V14H13V10Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 16H11V20H13V16Z",
    fill: "black"
  })));
}, "IconAddRoad");
import La from "classnames";
var va = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddShoppingCart } from '@aws-amplify/ui-react'; \u2192 import { MdAddShoppingCart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: La(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 9H13V6H16V4H13V1H11V4H8V6H11V9ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18ZM8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L21.16 4.96L19.42 4L15.55 11H8.53L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13Z",
    fill: "currentColor"
  })));
}, "IconAddShoppingCart");
import Na from "classnames";
var ya = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddTask } from '@aws-amplify/ui-react'; \u2192 import { MdAddTask } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Na(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C13.57 4 15.04 4.46 16.28 5.25L17.73 3.8C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C13.73 22 15.36 21.56 16.78 20.78L15.28 19.28C14.28 19.74 13.17 20 12 20ZM19 15H16V17H19V20H21V17H24V15H21V12H19V15Z",
    fill: "currentColor"
  })));
}, "IconAddTask");
import ba from "classnames";
var Za = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddToHomeScreen } from '@aws-amplify/ui-react'; \u2192 import { MdAddToHomeScreen } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ba(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 1.01L8 1C6.9 1 6 1.9 6 3V6H8V5H18V19H8V18H6V21C6 22.1 6.9 23 8 23H18C19.1 23 20 22.1 20 21V3C20 1.9 19.1 1.01 18 1.01ZM10 15H12V8H5V10H8.59L3 15.59L4.41 17L10 11.41V15Z",
    fill: "currentColor"
  })));
}, "IconAddToHomeScreen");
import Ba from "classnames";
var Wa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddToPhotos } from '@aws-amplify/ui-react'; \u2192 import { MdAddToPhotos } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ba(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13 15H15V11H19V9H15V5H13V9H9V11H13V15Z",
    fill: "currentColor"
  })));
}, "IconAddToPhotos");
import ka from "classnames";
var Da = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddToQueue } from '@aws-amplify/ui-react'; \u2192 import { MdAddToQueue } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ka(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 15H13V12H16V10H13V7H11V10H8V12H11V15ZM21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.89 22.1 3 21 3ZM21 17H3V5H21V17Z",
    fill: "currentColor"
  })));
}, "IconAddToQueue");
import Pa from "classnames";
var Nt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pa(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
    fill: "currentColor"
  })));
}, "IconAdd");
import Sa from "classnames";
var ja = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAddchart } from '@aws-amplify/ui-react'; \u2192 import { MdAddchart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Sa(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 5V7H19V10H17V7H14V5H17V2H19V5H22ZM19 19H5V5H11V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V13H19V19ZM15 13V17H17V13H15ZM11 17H13V9H11V17ZM9 17V11H7V17H9Z",
    fill: "currentColor"
  })));
}, "IconAddchart");
import Ya from "classnames";
var Fa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAdjust } from '@aws-amplify/ui-react'; \u2192 import { MdAdjust } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ya(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM15 12C15 13.66 13.66 15 12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12Z",
    fill: "currentColor"
  })));
}, "IconAdjust");
import Ta from "classnames";
var Aa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAdminPanelSettings } from '@aws-amplify/ui-react'; \u2192 import { MdAdminPanelSettings } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ta(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 16.6199C17.6186 16.6199 18.12 16.1184 18.12 15.4999C18.12 14.8813 17.6186 14.3799 17 14.3799C16.3814 14.3799 15.88 14.8813 15.88 15.4999C15.88 16.1184 16.3814 16.6199 17 16.6199Z",
    fill: "currentColor"
  }), e.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17 17.5C16.27 17.5 14.81 17.86 14.76 18.58C15.26 19.29 16.08 19.75 17 19.75C17.92 19.75 18.74 19.29 19.24 18.58C19.19 17.86 17.73 17.5 17 17.5Z",
    fill: "black"
  }), e.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M18 11.09V6.27L10.5 3L3 6.27V11.18C3 15.72 6.2 19.97 10.5 21C11.05 20.87 11.58 20.68 12.1 20.45C13.18 21.99 14.97 23 17 23C20.31 23 23 20.31 23 17C23 14.03 20.84 11.57 18 11.09ZM11 17C11 17.56 11.08 18.11 11.23 18.62C10.99 18.73 10.75 18.84 10.5 18.92C7.33 17.92 5 14.68 5 11.18V7.58L10.5 5.18L16 7.58V11.09C13.16 11.57 11 14.03 11 17ZM17 21C14.79 21 13 19.21 13 17C13 14.79 14.79 13 17 13C19.21 13 21 14.79 21 17C21 19.21 19.21 21 17 21Z",
    fill: "black"
  })));
}, "IconAdminPanelSettings");
import Ea from "classnames";
var Oa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAgriculture } from '@aws-amplify/ui-react'; \u2192 import { MdAgriculture } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ea(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 9H9C9 7.9 8.1 7 7 7H4C3.45 7 3 7.45 3 8C3 8.55 3.45 9 4 9Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M22 14.0601V8.00007C22 6.90007 21.1 6.00007 20 6.00007H13.71L12.65 4.94007L14.06 3.53007L13.35 2.82007L9.82 6.35007L10.53 7.06007L11.94 5.65007L13 6.71007V9.00007C13 10.1001 12.1 11.0001 11 11.0001H8.96C8.74 10.8401 8.51 10.7001 8.27 10.5701L7.87 11.4601L7.41 11.2501L7.81 10.3501C7.26 10.1301 6.64 10.0001 6 10.0001C5.47 10.0001 4.96 10.1101 4.48 10.2601L4.82 11.1701L4.35 11.3501L4 10.4201C2.94 10.8801 2.09 11.7001 1.57 12.7301L2.46 13.1301L2.25 13.5901L1.35 13.1901C1.13 13.7401 1 14.3601 1 15.0001C1 15.5301 1.11 16.0401 1.26 16.5201L2.17 16.1801L2.35 16.6501L1.42 17.0001C1.88 18.0601 2.7 18.9101 3.73 19.4301L4.13 18.5401L4.59 18.7501L4.19 19.6501C4.74 19.8701 5.36 20.0001 6 20.0001C6.53 20.0001 7.04 19.8901 7.52 19.7401L7.18 18.8301L7.65 18.6501L8 19.5801C9.06 19.1201 9.91 18.3001 10.43 17.2701L9.54 16.8701L9.75 16.4101L10.65 16.8101C10.75 16.5501 10.83 16.2701 10.89 15.9901H16.05C16.03 16.1601 16 16.3301 16 16.5001C16 18.4301 17.57 20.0001 19.5 20.0001C21.43 20.0001 23 18.4301 23 16.5001C23 15.5501 22.62 14.6901 22 14.0601ZM6 18.0001C4.34 18.0001 3 16.6601 3 15.0001C3 13.3401 4.34 12.0001 6 12.0001C7.66 12.0001 9 13.3401 9 15.0001C9 16.6601 7.66 18.0001 6 18.0001ZM10.87 14.0001C10.83 13.8201 10.79 13.6501 10.74 13.4801L9.83 13.8201L9.65 13.3501L10.58 13.0001H11C13.21 13.0001 15 11.2101 15 9.00007V8.00007H20V13.0501C19.84 13.0301 19.67 13.0001 19.5 13.0001C18.55 13.0001 17.69 13.3801 17.06 14.0001H10.87ZM19.5 18.0001C18.67 18.0001 18 17.3301 18 16.5001C18 15.6701 18.67 15.0001 19.5 15.0001C20.33 15.0001 21 15.6701 21 16.5001C21 17.3301 20.33 18.0001 19.5 18.0001Z",
    fill: "black"
  })));
}, "IconAgriculture");
import _a from "classnames";
var Ga = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirlineSeatFlatAngled } from '@aws-amplify/ui-react'; \u2192 import { MdAirlineSeatFlatAngled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _a(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 6.5C6.31 6.5 6.7 6.65 6.9 7.06C7.14 7.56 6.92 8.16 6.43 8.4C6.29 8.46 6.15 8.5 6 8.5C5.7 8.5 5.3 8.35 5.11 7.94C4.94 7.6 5.01 7.31 5.06 7.16C5.11 7.02 5.24 6.76 5.57 6.6C5.71 6.54 5.85 6.5 6 6.5V6.5ZM12.47 8.61L19.16 11.02C19.68 11.21 20.09 11.58 20.31 12.07C20.53 12.55 20.56 13.1 20.37 13.6L20.36 13.62L11.77 10.51L12.47 8.61V8.61ZM10 15.19L14 16.63V17H10V15.19ZM6 4.5C5.56 4.5 5.12 4.6 4.7 4.8C3.21 5.51 2.58 7.3 3.3 8.8C3.81 9.87 4.88 10.5 6 10.5C6.44 10.5 6.88 10.4 7.3 10.2C8.79 9.48 9.42 7.69 8.71 6.2C8.19 5.13 7.12 4.5 6 4.5ZM11.28 6.05L9.2 11.71L21.56 16.18L22.25 14.29C23.02 12.2 21.94 9.9 19.84 9.14L11.28 6.05V6.05ZM2.19 10.25L1.5 12.14L8 14.48V19H16V17.37L20.52 19L21.21 17.11L2.19 10.25Z",
    fill: "currentColor"
  })));
}, "IconAirlineSeatFlatAngled");
import Ua from "classnames";
var za = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirlineSeatFlat } from '@aws-amplify/ui-react'; \u2192 import { MdAirlineSeatFlat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ua(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 13C5.78 13 6.55 12.7 7.14 12.1C8.3 10.91 8.28 9.02 7.1 7.86C6.51 7.29 5.75 7 5 7C4.22 7 3.45 7.3 2.86 7.9C1.7 9.09 1.72 10.98 2.9 12.14C3.49 12.71 4.25 13 5 13ZM4.29 9.3C4.48 9.11 4.73 9 5 9C5.26 9 5.51 9.1 5.7 9.28C6.1 9.67 6.1 10.29 5.72 10.69C5.52 10.89 5.27 11 5 11C4.74 11 4.49 10.9 4.3 10.72C3.9 10.32 3.9 9.7 4.29 9.3ZM18 7H9V13H22V11C22 8.79 20.21 7 18 7ZM11 11V9H18C19.1 9 20 9.9 20 11H11ZM2 16H8V18H16V16H22V14H2V16Z",
    fill: "currentColor"
  })));
}, "IconAirlineSeatFlat");
import Xa from "classnames";
var Ka = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirlineSeatIndividualSuite } from '@aws-amplify/ui-react'; \u2192 import { MdAirlineSeatIndividualSuite } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Xa(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 14C8.66 14 10 12.66 10 11C10 9.34 8.66 8 7 8C5.34 8 4 9.34 4 11C4 12.66 5.34 14 7 14ZM7 10C7.55 10 8 10.45 8 11C8 11.55 7.55 12 7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10ZM19 7H11V15H3V7H1V17H23V11C23 8.79 21.21 7 19 7ZM21 15H13V9H19C20.1 9 21 9.9 21 11V15Z",
    fill: "currentColor"
  })));
}, "IconAirlineSeatIndividualSuite");
import qa from "classnames";
var Qa = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirlineSeatLegroomExtra } from '@aws-amplify/ui-react'; \u2192 import { MdAirlineSeatLegroomExtra } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qa(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 12V3H2V12C2 14.76 4.24 17 7 17H13V15H7C5.34 15 4 13.66 4 12ZM22.83 17.24C22.45 16.52 21.54 16.27 20.8 16.61L19.71 17.11L16.3 10.13C15.96 9.45 15.27 9 14.51 9H11V3H5V11C5 12.66 6.34 14 8 14H15L18.41 21L22.13 19.3C22.9 18.94 23.23 18 22.83 17.24Z",
    fill: "currentColor"
  })));
}, "IconAirlineSeatLegroomExtra");
import Ja from "classnames";
var $a = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirlineSeatLegroomNormal } from '@aws-amplify/ui-react'; \u2192 import { MdAirlineSeatLegroomNormal } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ja(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 12V3H3V12C3 14.76 5.24 17 8 17H14V15H8C6.34 15 5 13.66 5 12ZM20.5 18H19V11C19 9.9 18.1 9 17 9H12V3H6V11C6 12.65 7.35 14 9 14H16V21H20.5C21.33 21 22 20.33 22 19.5C22 18.67 21.33 18 20.5 18Z",
    fill: "currentColor"
  })));
}, "IconAirlineSeatLegroomNormal");
import Ra from "classnames";
var en = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirlineSeatLegroomReduced } from '@aws-amplify/ui-react'; \u2192 import { MdAirlineSeatLegroomReduced } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ra(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.97 19.2C20.15 20.16 19.42 21 18.5 21H14V18L15 14H9C7.35 14 6 12.65 6 11V3H12V9H17C18.1 9 19 9.9 19 11L17 18H18.44C19.17 18 19.83 18.49 19.97 19.2V19.2ZM5 12V3H3V12C3 14.76 5.24 17 8 17H12V15H8C6.34 15 5 13.66 5 12Z",
    fill: "currentColor"
  })));
}, "IconAirlineSeatLegroomReduced");
import on from "classnames";
var tn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirlineSeatReclineExtra } from '@aws-amplify/ui-react'; \u2192 import { MdAirlineSeatReclineExtra } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: on(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5.35 5.64011C4.45 5.00011 4.23 3.76011 4.86 2.85011C5.49 1.95011 6.74 1.73011 7.65 2.36011C8.55 3.00011 8.77 4.24011 8.14 5.15011C7.5 6.05011 6.26 6.27011 5.35 5.64011V5.64011ZM16 19.0001H8.93C7.45 19.0001 6.19 17.9201 5.97 16.4601L4 7.00011H2L3.99 16.7601C4.37 19.2001 6.47 21.0001 8.94 21.0001H16V19.0001ZM16.23 15.0001H11.35L10.32 10.9001C11.9 11.7901 13.6 12.4401 15.47 12.1201V9.99011C13.84 10.3001 12.03 9.72011 10.78 8.74011L9.14 7.47011C8.91 7.29011 8.65 7.17011 8.38 7.09011C8.06 7.00011 7.72 6.97011 7.39 7.03011H7.37C6.14 7.25011 5.32 8.42011 5.53 9.64011L6.88 15.5601C7.16 16.9801 8.39 18.0001 9.83 18.0001H16.68L20.5 21.0001L22 19.5001L16.23 15.0001Z",
    fill: "currentColor"
  })));
}, "IconAirlineSeatReclineExtra");
import rn from "classnames";
var sn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirlineSeatReclineNormal } from '@aws-amplify/ui-react'; \u2192 import { MdAirlineSeatReclineNormal } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.59 5.41012C6.81 4.63012 6.81 3.36012 7.59 2.58012C8.37 1.80012 9.64 1.80012 10.42 2.58012C11.2 3.36012 11.2 4.63012 10.42 5.41012C9.63 6.20012 8.37 6.20012 7.59 5.41012ZM6 16.0001V7.00012H4V16.0001C4 18.7601 6.24 21.0001 9 21.0001H15V19.0001H9C7.34 19.0001 6 17.6601 6 16.0001ZM20 20.0701L14.93 15.0001H11.5V11.3201C12.9 12.4701 15.1 13.4801 17 13.4801V11.3201C15.34 11.3401 13.39 10.4501 12.33 9.28012L10.93 7.73012C10.74 7.52012 10.5 7.35012 10.24 7.23012C9.95 7.09012 9.62 7.00012 9.28 7.00012H9.25C8.01 7.00012 7 8.01012 7 9.25012V15.0001C7 16.6601 8.34 18.0001 10 18.0001H15.07L18.57 21.5001L20 20.0701Z",
    fill: "currentColor"
  })));
}, "IconAirlineSeatReclineNormal");
import an from "classnames";
var nn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirplanemodeActive } from '@aws-amplify/ui-react'; \u2192 import { MdAirplanemodeActive } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: an(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2 14V16L10.5 13.5V19L8 20.5V22L12 21L16 22V20.5L13.5 19V13.5L22 16Z",
    fill: "currentColor"
  })));
}, "IconAirplanemodeActive");
import mn from "classnames";
var cn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirplanemodeInactive } from '@aws-amplify/ui-react'; \u2192 import { MdAirplanemodeInactive } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.5 7.67V3.5C10.5 2.67 11.17 2 12 2C12.83 2 13.5 2.67 13.5 3.5V9L22 14V16L17.51 14.68L10.5 7.67ZM19.78 22.61L21.19 21.2L13.5 13.5L9.56001 9.56L2.81001 2.81L1.39001 4.22L7.77001 10.6L2.00001 14V16L10.5 13.5V19L8.00001 20.5V22L12 21L16 22V20.5L13.5 19V16.33L19.78 22.61Z",
    fill: "currentColor"
  })));
}, "IconAirplanemodeInactive");
import ln from "classnames";
var pn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirplay } from '@aws-amplify/ui-react'; \u2192 import { MdAirplay } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ln(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 22H18L12 16L6 22Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H7V17H3V5H21V17H17V19H21C22.1 19 23 18.1 23 17V5C23 3.9 22.1 3 21 3Z",
    fill: "black"
  })));
}, "IconAirplay");
import hn from "classnames";
var fn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAirportShuttle } from '@aws-amplify/ui-react'; \u2192 import { MdAirportShuttle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 5H3C1.9 5 1 5.89 1 7V16H3C3 17.66 4.34 19 6 19C7.66 19 9 17.66 9 16H15C15 17.66 16.34 19 18 19C19.66 19 21 17.66 21 16H23V11L17 5ZM15 7H16L19 10H15V7ZM9 7H13V10H9V7ZM3 7H7V10H3V7ZM6 17.25C5.31 17.25 4.75 16.69 4.75 16C4.75 15.31 5.31 14.75 6 14.75C6.69 14.75 7.25 15.31 7.25 16C7.25 16.69 6.69 17.25 6 17.25ZM18 17.25C17.31 17.25 16.75 16.69 16.75 16C16.75 15.31 17.31 14.75 18 14.75C18.69 14.75 19.25 15.31 19.25 16C19.25 16.69 18.69 17.25 18 17.25ZM21 14H20.22C19.67 13.39 18.88 13 18 13C17.12 13 16.33 13.39 15.78 14H8.22C7.67 13.39 6.89 13 6 13C5.11 13 4.33 13.39 3.78 14H3V12H21V14Z",
    fill: "currentColor"
  })));
}, "IconAirportShuttle");
import Cn from "classnames";
var gn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAlarmAdd } from '@aws-amplify/ui-react'; \u2192 import { MdAlarmAdd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.337 1.81006L21.944 5.65506L20.664 7.19006L16.054 3.34706L17.337 1.81006ZM6.66301 1.81006L7.94501 3.34606L3.33701 7.19006L2.05701 5.65406L6.66301 1.81006ZM12 4.00006C7.03001 4.00006 3.00001 8.03006 3.00001 13.0001C3.00001 17.9701 7.03001 22.0001 12 22.0001C16.97 22.0001 21 17.9701 21 13.0001C21 8.03006 16.97 4.00006 12 4.00006ZM12 20.0001C8.14001 20.0001 5.00001 16.8601 5.00001 13.0001C5.00001 9.14006 8.14001 6.00006 12 6.00006C15.86 6.00006 19 9.14006 19 13.0001C19 16.8601 15.86 20.0001 12 20.0001ZM13 9.00006H11V12.0001H8.00001V14.0001H11V17.0001H13V14.0001H16V12.0001H13V9.00006Z",
    fill: "currentColor"
  })));
}, "IconAlarmAdd");
import un from "classnames";
var wn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAlarmOff } from '@aws-amplify/ui-react'; \u2192 import { MdAlarmOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: un(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.04 6.29006C10.66 6.11006 11.32 6.00006 12 6.00006C15.86 6.00006 19 9.14006 19 13.0001C19 13.6801 18.89 14.3401 18.71 14.9601L20.27 16.5201C20.74 15.4401 21 14.2501 21 13.0001C21 8.03006 16.97 4.00006 12 4.00006C10.75 4.00006 9.55999 4.26006 8.46999 4.72006L10.04 6.29006V6.29006ZM17.337 1.81006L21.944 5.65506L20.664 7.19006L16.054 3.34706L17.337 1.81006ZM3.01999 2.10006L1.60999 3.51006L2.97999 4.88006L2.05999 5.65006L3.33999 7.19006L4.39999 6.31006L5.19999 7.11006C3.82999 8.69006 2.99999 10.7501 2.99999 13.0001C2.99999 17.9701 7.02999 22.0001 12 22.0001C14.25 22.0001 16.31 21.1701 17.89 19.8001L19.99 21.9001L21.4 20.4901L3.01999 2.10006ZM12 20.0001C8.13999 20.0001 4.99999 16.8601 4.99999 13.0001C4.99999 11.3001 5.60999 9.74006 6.61999 8.53006L16.47 18.3801C15.26 19.3901 13.7 20.0001 12 20.0001ZM7.47999 3.73006L7.93999 3.35006L6.65999 1.81006L6.05999 2.31006L7.47999 3.73006Z",
    fill: "currentColor"
  })));
}, "IconAlarmOff");
import dn from "classnames";
var Vn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAlarmOn } from '@aws-amplify/ui-react'; \u2192 import { MdAlarmOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.54 14.5301L8.41001 12.4001L7.35001 13.4601L10.53 16.6401L16.53 10.6401L15.47 9.58006L10.54 14.5301ZM17.337 1.81006L21.944 5.65506L20.664 7.19006L16.054 3.34706L17.337 1.81006ZM6.66301 1.81006L7.94501 3.34606L3.33701 7.19006L2.05701 5.65406L6.66301 1.81006ZM12 4.00006C7.03001 4.00006 3.00001 8.03006 3.00001 13.0001C3.00001 17.9701 7.03001 22.0001 12 22.0001C16.97 22.0001 21 17.9701 21 13.0001C21 8.03006 16.97 4.00006 12 4.00006ZM12 20.0001C8.14001 20.0001 5.00001 16.8601 5.00001 13.0001C5.00001 9.14006 8.14001 6.00006 12 6.00006C15.86 6.00006 19 9.14006 19 13.0001C19 16.8601 15.86 20.0001 12 20.0001Z",
    fill: "currentColor"
  })));
}, "IconAlarmOn");
import Hn from "classnames";
var Mn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAlarm } from '@aws-amplify/ui-react'; \u2192 import { MdAlarm } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.5 8.00006H11V14.0001L15.75 16.8501L16.5 15.6201L12.5 13.2501V8.00006ZM17.337 1.81006L21.944 5.65506L20.664 7.19006L16.054 3.34706L17.337 1.81006ZM6.66301 1.81006L7.94501 3.34606L3.33701 7.19006L2.05701 5.65406L6.66301 1.81006ZM12 4.00006C7.03001 4.00006 3.00001 8.03006 3.00001 13.0001C3.00001 17.9701 7.03001 22.0001 12 22.0001C16.97 22.0001 21 17.9701 21 13.0001C21 8.03006 16.97 4.00006 12 4.00006ZM12 20.0001C8.14001 20.0001 5.00001 16.8601 5.00001 13.0001C5.00001 9.14006 8.14001 6.00006 12 6.00006C15.86 6.00006 19 9.14006 19 13.0001C19 16.8601 15.86 20.0001 12 20.0001Z",
    fill: "currentColor"
  })));
}, "IconAlarm");
import xn from "classnames";
var In = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAlbum } from '@aws-amplify/ui-react'; \u2192 import { MdAlbum } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 7.5C9.51 7.5 7.5 9.51 7.5 12C7.5 14.49 9.51 16.5 12 16.5C14.49 16.5 16.5 14.49 16.5 12C16.5 9.51 14.49 7.5 12 7.5ZM12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12C13 12.55 12.55 13 12 13Z",
    fill: "currentColor"
  })));
}, "IconAlbum");
import Ln from "classnames";
var vn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAllInbox } from '@aws-amplify/ui-react'; \u2192 import { MdAllInbox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ln(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V12C3 13.1 3.9 14 5 14H19C20.1 14 21 13.1 21 12V5C21 3.9 20.1 3 19 3ZM5 10H8.13C8.34 10.78 8.8 11.47 9.4 12H5V10ZM19 12H14.6C15.2 11.47 15.66 10.78 15.87 10H19V12ZM19 8H14V9C14 10.07 13.07 11 12 11C10.93 11 10 10.07 10 9V8H5V5H19V8ZM17 15H14V16C14 16.47 13.81 16.9 13.52 17.25C13.15 17.7 12.6 18 12 18C11.4 18 10.85 17.7 10.48 17.25C10.19 16.9 10 16.47 10 16V15H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15H17ZM5 17H8.13C8.15 17.09 8.19 17.17 8.22 17.25C8.46 17.93 8.87 18.53 9.4 19H5V17ZM19 19H14.6C15.14 18.53 15.55 17.93 15.78 17.25C15.81 17.17 15.85 17.09 15.87 17H19V19Z",
    fill: "currentColor"
  })));
}, "IconAllInbox");
import Nn from "classnames";
var yn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAllInclusive } from '@aws-amplify/ui-react'; \u2192 import { MdAllInclusive } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.6 6.62012C17.16 6.62012 15.8 7.18012 14.83 8.15012L7.8 14.3901C7.16 15.0301 6.31 15.3801 5.4 15.3801C3.53 15.3801 2.01 13.8701 2.01 12.0001C2.01 10.1301 3.53 8.62012 5.4 8.62012C6.31 8.62012 7.16 8.97012 7.84 9.65012L8.97 10.6501L10.48 9.31012L9.22 8.20012C8.2 7.18012 6.84 6.62012 5.4 6.62012C2.42 6.62012 0 9.04012 0 12.0001C0 14.9601 2.42 17.3801 5.4 17.3801C6.84 17.3801 8.2 16.8201 9.17 15.8501L16.2 9.61012C16.84 8.97012 17.69 8.62012 18.6 8.62012C20.47 8.62012 21.99 10.1301 21.99 12.0001C21.99 13.8701 20.47 15.3801 18.6 15.3801C17.7 15.3801 16.84 15.0301 16.16 14.3501L15.02 13.3401L13.51 14.6801L14.78 15.8001C15.8 16.8101 17.15 17.3701 18.6 17.3701C21.58 17.3701 24 14.9601 24 11.9901C24 9.02012 21.58 6.62012 18.6 6.62012V6.62012Z",
    fill: "currentColor"
  })));
}, "IconAllInclusive");
import bn from "classnames";
var Zn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAllOut } from '@aws-amplify/ui-react'; \u2192 import { MdAllOut } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 4V8L8 4H4ZM16 4L20 8V4H16ZM20 20V16L16 20H20ZM4 20H8L4 16V20ZM19 12C19 8.13 15.87 5 12 5C8.13 5 5 8.13 5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z",
    fill: "currentColor"
  })));
}, "IconAllOut");
import Bn from "classnames";
var Wn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAltRoute } from '@aws-amplify/ui-react'; \u2192 import { MdAltRoute } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.78 11.16L8.36 12.58C7.68 11.89 7.02 11 6.57 9.64L8.51 9.15C8.83 10.04 9.28 10.65 9.78 11.16ZM11 6L7 2L3 6H6.02C6.04 6.81 6.1 7.54 6.21 8.17L8.15 7.68C8.08 7.2 8.03 6.63 8.02 6H11ZM21 6L17 2L13 6H15.99C15.89 9.68 14.71 10.75 13.45 11.88C12.95 12.32 12.44 12.8 12 13.43C11.66 12.94 11.27 12.55 10.87 12.19L9.46 13.6C10.39 14.45 11 15.14 11 17V22H13V17C13 14.98 13.71 14.34 14.79 13.37C16.17 12.13 17.87 10.59 17.99 6H21V6Z",
    fill: "currentColor"
  })));
}, "IconAltRoute");
import kn from "classnames";
var Dn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAlternateEmail } from '@aws-amplify/ui-react'; \u2192 import { MdAlternateEmail } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 1.9502C6.48 1.9502 2 6.4302 2 11.9502C2 17.4702 6.48 21.9502 12 21.9502H17V19.9502H12C7.66 19.9502 4 16.2902 4 11.9502C4 7.6102 7.66 3.9502 12 3.9502C16.34 3.9502 20 7.6102 20 11.9502V13.3802C20 14.1702 19.29 14.9502 18.5 14.9502C17.71 14.9502 17 14.1702 17 13.3802V11.9502C17 9.1902 14.76 6.9502 12 6.9502C9.24 6.9502 7 9.1902 7 11.9502C7 14.7102 9.24 16.9502 12 16.9502C13.38 16.9502 14.64 16.3902 15.54 15.4802C16.19 16.3702 17.31 16.9502 18.5 16.9502C20.47 16.9502 22 15.3502 22 13.3802V11.9502C22 6.4302 17.52 1.9502 12 1.9502V1.9502ZM12 14.9502C10.34 14.9502 9 13.6102 9 11.9502C9 10.2902 10.34 8.9502 12 8.9502C13.66 8.9502 15 10.2902 15 11.9502C15 13.6102 13.66 14.9502 12 14.9502Z",
    fill: "currentColor"
  })));
}, "IconAlternateEmail");
import Pn from "classnames";
var Sn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAmpStories } from '@aws-amplify/ui-react'; \u2192 import { MdAmpStories } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 19H17V4H7V19ZM9 6H15V17H9V6Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M5 6H3V17H5V6Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M21 6H19V17H21V6Z",
    fill: "black"
  })));
}, "IconAmpStories");
import jn from "classnames";
var Yn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAnalytics } from '@aws-amplify/ui-react'; \u2192 import { MdAnalytics } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9 12H7V17H9V12Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17 7H15V17H17V7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 14H11V17H13V14Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 10H11V12H13V10Z",
    fill: "black"
  })));
}, "IconAnalytics");
import Fn from "classnames";
var Tn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAnchor } from '@aws-amplify/ui-react'; \u2192 import { MdAnchor } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 15L18.55 16.55C17.59 18.24 15.22 19.59 13 19.92V11H16V9H13V7.82C14.16 7.4 15 6.3 15 5C15 3.35 13.65 2 12 2C10.35 2 9 3.35 9 5C9 6.3 9.84 7.4 11 7.82V9H8V11H11V19.92C8.78 19.59 6.41 18.24 5.45 16.55L7 15L3 12V15C3 18.88 7.92 22 12 22C16.08 22 21 18.88 21 15V12L17 15ZM12 4C12.55 4 13 4.45 13 5C13 5.55 12.55 6 12 6C11.45 6 11 5.55 11 5C11 4.45 11.45 4 12 4Z",
    fill: "currentColor"
  })));
}, "IconAnchor");
import An from "classnames";
var En = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAndroid } from '@aws-amplify/ui-react'; \u2192 import { MdAndroid } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: An(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_37520)"
  }, e.createElement("path", {
    d: "M6 18C6 18.55 6.45 19 7 19H8V22.5C8 23.33 8.67 24 9.5 24C10.33 24 11 23.33 11 22.5V19H13V22.5C13 23.33 13.67 24 14.5 24C15.33 24 16 23.33 16 22.5V19H17C17.55 19 18 18.55 18 18V8H6V18ZM3.5 8C2.67 8 2 8.67 2 9.5V16.5C2 17.33 2.67 18 3.5 18C4.33 18 5 17.33 5 16.5V9.5C5 8.67 4.33 8 3.5 8ZM20.5 8C19.67 8 19 8.67 19 9.5V16.5C19 17.33 19.67 18 20.5 18C21.33 18 22 17.33 22 16.5V9.5C22 8.67 21.33 8 20.5 8ZM15.53 2.16L16.83 0.86C17.03 0.66 17.03 0.35 16.83 0.15C16.63 -0.05 16.32 -0.05 16.12 0.15L14.64 1.63C13.85 1.23 12.95 1 12 1C11.04 1 10.14 1.23 9.34 1.63L7.85 0.15C7.65 -0.05 7.34 -0.05 7.14 0.15C6.94 0.35 6.94 0.66 7.14 0.86L8.45 2.17C6.97 3.26 6 5.01 6 7H18C18 5.01 17.03 3.25 15.53 2.16V2.16ZM10 5H9V4H10V5ZM15 5H14V4H15V5Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_37520"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconAndroid");
import On from "classnames";

var _n = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAnnouncement } from '@aws-amplify/ui-react'; \u2192 import { MdAnnouncement } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: On(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM11 5H13V11H11V5ZM11 13H13V15H11V13Z",
    fill: "currentColor"
  })));
}, "IconAnnouncement");

import Gn from "classnames";
var Un = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconApartment } from '@aws-amplify/ui-react'; \u2192 import { MdApartment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 11V3H7V7H3V21H11V17H13V21H21V11H17ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM11 15H9V13H11V15ZM11 11H9V9H11V11ZM11 7H9V5H11V7ZM15 15H13V13H15V15ZM15 11H13V9H15V11ZM15 7H13V5H15V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z",
    fill: "currentColor"
  })));
}, "IconApartment");
import zn from "classnames";
var Xn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconApi } from '@aws-amplify/ui-react'; \u2192 import { MdApi } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 12L12 14L10 12L12 10L14 12ZM12 6L14.12 8.12L16.62 5.62L12 1L7.38 5.62L9.88 8.12L12 6ZM6 12L8.12 9.88L5.62 7.38L1 12L5.62 16.62L8.12 14.12L6 12ZM18 12L15.88 14.12L18.38 16.62L23 12L18.38 7.38L15.88 9.88L18 12ZM12 18L9.88 15.88L7.38 18.38L12 23L16.62 18.38L14.12 15.88L12 18Z",
    fill: "currentColor"
  })));
}, "IconApi");
import Kn from "classnames";
var qn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAppBlocking } from '@aws-amplify/ui-react'; \u2192 import { MdAppBlocking } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 8C15.79 8 14 9.79 14 12C14 14.21 15.79 16 18 16C20.21 16 22 14.21 22 12C22 9.79 20.21 8 18 8ZM15.5 12C15.5 10.62 16.62 9.5 18 9.5C18.42 9.5 18.8 9.61 19.15 9.79L15.79 13.15C15.61 12.8 15.5 12.42 15.5 12ZM18 14.5C17.58 14.5 17.2 14.39 16.85 14.21L20.21 10.85C20.39 11.2 20.5 11.58 20.5 12C20.5 13.38 19.38 14.5 18 14.5Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M17 18H7V6H17V7H19V6V5V3C19 1.9 18.1 1 17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V19V18V17H17V18ZM7 3H17V4H7V3ZM17 21H7V20H17V21Z",
    fill: "black"
  })));
}, "IconAppBlocking");
import Qn from "classnames";
var Jn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAppSettingsAlt } from '@aws-amplify/ui-react'; \u2192 import { MdAppSettingsAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qn(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.81 12.74L20.99 12.11C20.99 12.02 20.99 11.98 20.99 11.89L21.79 11.26C21.95 11.14 21.99 10.92 21.89 10.75L21.04 9.27C20.97 9.14 20.83 9.07 20.69 9.07C20.64 9.07 20.59 9.08 20.54 9.1L19.59 9.48C19.51 9.43 19.48 9.41 19.4 9.37L19.25 8.36C19.22 8.15 19.05 8 18.85 8H17.14C16.94 8 16.77 8.15 16.74 8.34L16.6 9.35C16.57 9.37 16.53 9.38 16.5 9.4C16.47 9.42 16.44 9.44 16.41 9.46L15.46 9.08C15.41 9.06 15.36 9.05 15.31 9.05C15.17 9.05 15.04 9.12 14.96 9.25L14.11 10.73C14.01 10.9 14.05 11.12 14.21 11.24L15.01 11.87C15.01 11.96 15.01 12 15.01 12.1L14.21 12.73C14.05 12.85 14.01 13.07 14.11 13.24L14.96 14.72C15.03 14.85 15.17 14.92 15.31 14.92C15.36 14.92 15.41 14.91 15.46 14.89L16.41 14.52C16.49 14.57 16.53 14.59 16.61 14.63L16.76 15.64C16.79 15.84 16.96 15.98 17.16 15.98H18.87C19.07 15.98 19.24 15.83 19.27 15.64L19.42 14.63C19.45 14.61 19.49 14.6 19.52 14.58C19.55 14.56 19.58 14.54 19.61 14.52L20.56 14.9C20.61 14.92 20.66 14.93 20.71 14.93C20.85 14.93 20.98 14.86 21.06 14.73L21.91 13.25C22.01 13.08 21.97 12.86 21.81 12.74ZM18 13.5C17.17 13.5 16.5 12.83 16.5 12C16.5 11.17 17.17 10.5 18 10.5C18.83 10.5 19.5 11.17 19.5 12C19.5 12.83 18.83 13.5 18 13.5ZM17 18H7V6H17V7H19V3C19 1.9 18.1 1 17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V17H17V18ZM7 3H17V4H7V3ZM17 21H7V20H17V21Z",
    fill: "currentColor"
  })));
}, "IconAppSettingsAlt");
import $n from "classnames";
var Rn = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconApps } from '@aws-amplify/ui-react'; \u2192 import { MdApps } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $n(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z",
    fill: "currentColor"
  })));
}, "IconApps");
import e2 from "classnames";
var o2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArchitecture } from '@aws-amplify/ui-react'; \u2192 import { MdArchitecture } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: e2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.35986 18.7799L6.60986 20.9999L8.22986 19.4599L10.9999 11.8599C10.3199 11.6899 9.71986 11.3499 9.22986 10.8799L6.35986 18.7799Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M14.77 10.8799C14.28 11.3499 13.67 11.6899 13 11.8599L15.77 19.4599L17.39 20.9999L17.65 18.7799L14.77 10.8799Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 8C15 6.7 14.16 5.6 13 5.18V3H11V5.18C9.84 5.6 9 6.7 9 8C9 9.66 10.34 11 12 11C13.66 11 15 9.66 15 8ZM12 9C11.45 9 11 8.55 11 8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8C13 8.55 12.55 9 12 9Z",
    fill: "black"
  })));
}, "IconArchitecture");
import t2 from "classnames";
var r2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArchive } from '@aws-amplify/ui-react'; \u2192 import { MdArchive } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: t2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM6.24 5H17.76L18.57 5.97H5.44L6.24 5ZM5 19V8H19V19H5ZM13.45 10H10.55V13H8L12 17L16 13H13.45V10Z",
    fill: "currentColor"
  })));
}, "IconArchive");
import i2 from "classnames";
var s2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowBackIos } from '@aws-amplify/ui-react'; \u2192 import { MdArrowBackIos } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: i2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.5098 3.8701L15.7298 2.1001L5.83984 12.0001L15.7398 21.9001L17.5098 20.1301L9.37984 12.0001L17.5098 3.8701V3.8701Z",
    fill: "currentColor"
  })));
}, "IconArrowBackIos");
import a2 from "classnames";
var n2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowBack } from '@aws-amplify/ui-react'; \u2192 import { MdArrowBack } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: a2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z",
    fill: "currentColor"
  })));
}, "IconArrowBack");
import m2 from "classnames";
var c2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowCircleDown } from '@aws-amplify/ui-react'; \u2192 import { MdArrowCircleDown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: m2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 12V8H11V12H8L12 16L16 12H13Z",
    fill: "currentColor"
  })));
}, "IconArrowCircleDown");
import l2 from "classnames";
var p2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowCircleUp } from '@aws-amplify/ui-react'; \u2192 import { MdArrowCircleUp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: l2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM11 12V16H13V12H16L12 8L8 12H11Z",
    fill: "currentColor"
  })));
}, "IconArrowCircleUp");
import h2 from "classnames";
var f2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowDownward } from '@aws-amplify/ui-react'; \u2192 import { MdArrowDownward } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: h2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z",
    fill: "currentColor"
  })));
}, "IconArrowDownward");
import C2 from "classnames";
var g2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowDropDownCircle } from '@aws-amplify/ui-react'; \u2192 import { MdArrowDropDownCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: C2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 15L8 11H16L12 15Z",
    fill: "currentColor"
  })));
}, "IconArrowDropDownCircle");
import u2 from "classnames";
var w2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowDropDown } from '@aws-amplify/ui-react'; \u2192 import { MdArrowDropDown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: u2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 10L12 15L17 10H7Z",
    fill: "currentColor"
  })));
}, "IconArrowDropDown");
import d2 from "classnames";
var V2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowDropUp } from '@aws-amplify/ui-react'; \u2192 import { MdArrowDropUp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: d2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 14L12 9L17 14H7Z",
    fill: "currentColor"
  })));
}, "IconArrowDropUp");
import H2 from "classnames";
var M2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowForwardIos } from '@aws-amplify/ui-react'; \u2192 import { MdArrowForwardIos } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: H2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.49023 20.1301L8.26023 21.9001L18.1602 12.0001L8.26023 2.1001L6.49023 3.8701L14.6202 12.0001L6.49023 20.1301V20.1301Z",
    fill: "currentColor"
  })));
}, "IconArrowForwardIos");
import x2 from "classnames";
var I2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowForward } from '@aws-amplify/ui-react'; \u2192 import { MdArrowForward } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: x2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z",
    fill: "currentColor"
  })));
}, "IconArrowForward");
import L2 from "classnames";
var v2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowLeft } from '@aws-amplify/ui-react'; \u2192 import { MdArrowLeft } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: L2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 7L9 12L14 17V7Z",
    fill: "currentColor"
  })));
}, "IconArrowLeft");
import N2 from "classnames";
var y2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowRightAlt } from '@aws-amplify/ui-react'; \u2192 import { MdArrowRightAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: N2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.01 11H4V13H16.01V16L20 12L16.01 8V11V11Z",
    fill: "currentColor"
  })));
}, "IconArrowRightAlt");
import b2 from "classnames";
var Z2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowRight } from '@aws-amplify/ui-react'; \u2192 import { MdArrowRight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: b2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 17L15 12L10 7V17Z",
    fill: "currentColor"
  })));
}, "IconArrowRight");
import B2 from "classnames";
var W2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArrowUpward } from '@aws-amplify/ui-react'; \u2192 import { MdArrowUpward } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: B2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 12L5.41 13.41L11 7.83V20H13V7.83L18.58 13.42L20 12L12 4L4 12Z",
    fill: "currentColor"
  })));
}, "IconArrowUpward");
import k2 from "classnames";
var D2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArtTrack } from '@aws-amplify/ui-react'; \u2192 import { MdArtTrack } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: k2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 13H14V11H22V13ZM22 7H14V9H22V7ZM14 17H22V15H14V17ZM12 9V15C12 16.1 11.1 17 10 17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H10C11.1 7 12 7.9 12 9ZM10.5 15L8.25 12L6.5 14.26L5.25 12.75L3.5 15H10.5Z",
    fill: "currentColor"
  })));
}, "IconArtTrack");
import P2 from "classnames";
var S2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconArticle } from '@aws-amplify/ui-react'; \u2192 import { MdArticle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: P2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z",
    fill: "black"
  })));
}, "IconArticle");
import j2 from "classnames";
var Y2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAspectRatio } from '@aws-amplify/ui-react'; \u2192 import { MdAspectRatio } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: j2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 12H17V15H14V17H19V12ZM7 9H10V7H5V12H7V9ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01V19.01Z",
    fill: "currentColor"
  })));
}, "IconAspectRatio");
import F2 from "classnames";
var T2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssessment } from '@aws-amplify/ui-react'; \u2192 import { MdAssessment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: F2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z",
    fill: "currentColor"
  })));
}, "IconAssessment");
import A2 from "classnames";
var E2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssignmentInd } from '@aws-amplify/ui-react'; \u2192 import { MdAssignmentInd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: A2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.22 2.75 12.41 2.85 12.55 3C12.67 3.13 12.75 3.31 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.31 11.33 3.13 11.45 3C11.59 2.85 11.78 2.75 12 2.75ZM19 19H5V5H19V19ZM12 6C10.35 6 9 7.35 9 9C9 10.65 10.35 12 12 12C13.65 12 15 10.65 15 9C15 7.35 13.65 6 12 6ZM12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10ZM6 16.47V18H18V16.47C18 13.97 14.03 12.89 12 12.89C9.97 12.89 6 13.96 6 16.47ZM8.31 16C9 15.44 10.69 14.88 12 14.88C13.31 14.88 15.01 15.44 15.69 16H8.31Z",
    fill: "currentColor"
  })));
}, "IconAssignmentInd");
import O2 from "classnames";

var _2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssignmentLate } from '@aws-amplify/ui-react'; \u2192 import { MdAssignmentLate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: O2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 15H13V17H11V15ZM11 7H13V13H11V7ZM19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconAssignmentLate");

import G2 from "classnames";
var U2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssignmentReturn } from '@aws-amplify/ui-react'; \u2192 import { MdAssignmentReturn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: G2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 14H16V10H12V7L7 12L12 17V14ZM19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconAssignmentReturn");
import z2 from "classnames";
var X2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssignmentReturned } from '@aws-amplify/ui-react'; \u2192 import { MdAssignmentReturned } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: z2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 12H14V8H10V12H7L12 17L17 12ZM19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconAssignmentReturned");
import K2 from "classnames";
var q2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssignmentTurnedIn } from '@aws-amplify/ui-react'; \u2192 import { MdAssignmentTurnedIn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: K2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 9L16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9ZM19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconAssignmentTurnedIn");
import Q2 from "classnames";
var J2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssignment } from '@aws-amplify/ui-react'; \u2192 import { MdAssignment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Q2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 15H14V17H7V15ZM7 11H17V13H7V11ZM7 7H17V9H7V7ZM19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconAssignment");
import $2 from "classnames";
var R2 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssistantPhoto } from '@aws-amplify/ui-react'; \u2192 import { MdAssistantPhoto } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $2(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.36 6L12.44 6.39L12.76 8H18V14H14.64L14.56 13.61L14.24 12H7V6H12.36ZM14 4H5V21H7V14H12.6L13 16H20V6H14.4L14 4Z",
    fill: "currentColor"
  })));
}, "IconAssistantPhoto");
import em from "classnames";
var om = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAssistant } from '@aws-amplify/ui-react'; \u2192 import { MdAssistant } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: em(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 2H5C3.9 2 3 2.9 3 4V18C3 19.1 3.9 20 5 20H9L12 23L15 20H19C20.1 20 21 19.1 21 18V4C21 2.9 20.1 2 19 2ZM19 18H14.17L13.58 18.59L12 20.17L10.41 18.58L9.83 18H5V4H19V18ZM12 17L13.88 12.88L18 11L13.88 9.12L12 5L10.12 9.12L6 11L10.12 12.88L12 17Z",
    fill: "currentColor"
  })));
}, "IconAssistant");
import tm from "classnames";
var rm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAtm } from '@aws-amplify/ui-react'; \u2192 import { MdAtm } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 9V10.5H10.25V15H11.75V10.5H14V9H8ZM6 9H3C2.45 9 2 9.45 2 10V15H3.5V13.5H5.5V15H7V10C7 9.45 6.55 9 6 9ZM5.5 12H3.5V10.5H5.5V12ZM21 9H16.5C15.95 9 15.5 9.45 15.5 10V15H17V10.5H18V14H19.5V10.49H20.5V15H22V10C22 9.45 21.55 9 21 9Z",
    fill: "currentColor"
  })));
}, "IconAtm");
import im from "classnames";
var sm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAttachEmail } from '@aws-amplify/ui-react'; \u2192 import { MdAttachEmail } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: im(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 6L11 11L19 6V9H21V4C21 2.9 20.1 2 19 2H3C1.9 2 1.01 2.9 1.01 4L1 16C1 17.1 1.9 18 3 18H13V16H3V6ZM19 4L11 9L3 4H19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M21 14V18C21 19.1 20.1 20 19 20C17.9 20 17 19.1 17 18V13.5C17 13.22 17.22 13 17.5 13C17.78 13 18 13.22 18 13.5V18H20V13.5C20 12.12 18.88 11 17.5 11C16.12 11 15 12.12 15 13.5V18C15 20.21 16.79 22 19 22C21.21 22 23 20.21 23 18V14H21Z",
    fill: "black"
  })));
}, "IconAttachEmail");
import am from "classnames";
var nm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAttachFile } from '@aws-amplify/ui-react'; \u2192 import { MdAttachFile } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: am(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z",
    fill: "currentColor"
  })));
}, "IconAttachFile");
import mm from "classnames";
var cm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAttachMoney } from '@aws-amplify/ui-react'; \u2192 import { MdAttachMoney } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.8001 10.9C9.53007 10.31 8.80007 9.7 8.80007 8.75C8.80007 7.66 9.81007 6.9 11.5001 6.9C13.2801 6.9 13.9401 7.75 14.0001 9H16.2101C16.1401 7.28 15.0901 5.7 13.0001 5.19V3H10.0001V5.16C8.06007 5.58 6.50007 6.84 6.50007 8.77C6.50007 11.08 8.41007 12.23 11.2001 12.9C13.7001 13.5 14.2001 14.38 14.2001 15.31C14.2001 16 13.7101 17.1 11.5001 17.1C9.44007 17.1 8.63007 16.18 8.52007 15H6.32007C6.44007 17.19 8.08007 18.42 10.0001 18.83V21H13.0001V18.85C14.9501 18.48 16.5001 17.35 16.5001 15.3C16.5001 12.46 14.0701 11.49 11.8001 10.9Z",
    fill: "currentColor"
  })));
}, "IconAttachMoney");
import lm from "classnames";
var pm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAttachment } from '@aws-amplify/ui-react'; \u2192 import { MdAttachment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.5 16H7C4.79 16 3 14.21 3 12C3 9.79 4.79 8 7 8H19.5C20.88 8 22 9.12 22 10.5C22 11.88 20.88 13 19.5 13H9C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11H18.5V9.5H9C7.62 9.5 6.5 10.62 6.5 12C6.5 13.38 7.62 14.5 9 14.5H19.5C21.71 14.5 23.5 12.71 23.5 10.5C23.5 8.29 21.71 6.5 19.5 6.5H7C3.96 6.5 1.5 8.96 1.5 12C1.5 15.04 3.96 17.5 7 17.5H18.5V16Z",
    fill: "currentColor"
  })));
}, "IconAttachment");
import hm from "classnames";
var fm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAttribution } from '@aws-amplify/ui-react'; \u2192 import { MdAttribution } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 8.5C11.09 8.5 9.25 8.96 9.25 9.88V14.5H10.75V19H13.25V14.5H14.75V9.88C14.75 8.97 12.91 8.5 12 8.5ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 8C12.8284 8 13.5 7.32843 13.5 6.5C13.5 5.67157 12.8284 5 12 5C11.1716 5 10.5 5.67157 10.5 6.5C10.5 7.32843 11.1716 8 12 8Z",
    fill: "black"
  })));
}, "IconAttribution");
import Cm from "classnames";
var gm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAudiotrack } from '@aws-amplify/ui-react'; \u2192 import { MdAudiotrack } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 3V13.55C11.41 13.21 10.73 13 10 13C7.79 13 6 14.79 6 17C6 19.21 7.79 21 10 21C12.21 21 14 19.21 14 17V7H18V3H12ZM10 19C8.9 19 8 18.1 8 17C8 15.9 8.9 15 10 15C11.1 15 12 15.9 12 17C12 18.1 11.1 19 10 19Z",
    fill: "currentColor"
  })));
}, "IconAudiotrack");
import um from "classnames";
var wm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAutoDelete } from '@aws-amplify/ui-react'; \u2192 import { MdAutoDelete } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: um(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 2H11.5L10.5 1H5.5L4.5 2H1V4H15V2Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M16 9C15.3 9 14.63 9.1 14 9.29V5H2V17C2 18.1 2.9 19 4 19H9.68C10.8 21.36 13.21 23 16 23C19.87 23 23 19.87 23 16C23 12.13 19.87 9 16 9ZM9 16C9 16.34 9.03 16.67 9.08 17H4V7H12V10.26C10.19 11.53 9 13.62 9 16ZM16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 12H15V17L18.6 19.1L19.4 17.9L16.5 16.2V12Z",
    fill: "black"
  })));
}, "IconAutoDelete");
import dm from "classnames";
var Vm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAutorenew } from '@aws-amplify/ui-react'; \u2192 import { MdAutorenew } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74V7.74Z",
    fill: "currentColor"
  })));
}, "IconAutorenew");
import Hm from "classnames";
var Mm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconAvTimer } from '@aws-amplify/ui-react'; \u2192 import { MdAvTimer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 17C11 17.55 11.45 18 12 18C12.55 18 13 17.55 13 17C13 16.45 12.55 16 12 16C11.45 16 11 16.45 11 17ZM11 3V7H13V5.08C16.39 5.57 19 8.47 19 12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12C5 10.32 5.59 8.78 6.58 7.58L12 13L13.41 11.59L6.61 4.79V4.81C4.42 6.45 3 9.05 3 12C3 16.97 7.02 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3H11ZM18 12C18 11.45 17.55 11 17 11C16.45 11 16 11.45 16 12C16 12.55 16.45 13 17 13C17.55 13 18 12.55 18 12ZM6 12C6 12.55 6.45 13 7 13C7.55 13 8 12.55 8 12C8 11.45 7.55 11 7 11C6.45 11 6 11.45 6 12Z",
    fill: "currentColor"
  })));
}, "IconAvTimer");
import xm from "classnames";
var Im = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBabyChangingStation } from '@aws-amplify/ui-react'; \u2192 import { MdBabyChangingStation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 8V10H11L8.31 8.82L7 12.75V22H3V12L4.58 7.37C4.96 6.25 6.22 5.69 7.3 6.18L11.45 8.01L14 8ZM8 1C6.9 1 6 1.9 6 3C6 4.1 6.9 5 8 5C9.1 5 10 4.1 10 3C10 1.9 9.1 1 8 1ZM9 19H21V17H9V19ZM19.5 16C20.33 16 21 15.33 21 14.5C21 13.67 20.33 13 19.5 13C18.67 13 18 13.67 18 14.5C18 15.33 18.67 16 19.5 16ZM13 12C13 11.45 12.55 11 12 11H9V13H11V14C11 15.1 11.9 16 13 16H15C16.1 16 17 15.1 17 14V11H15V13H13V12Z",
    fill: "currentColor"
  })));
}, "IconBabyChangingStation");
import Lm from "classnames";
var vm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBackpack } from '@aws-amplify/ui-react'; \u2192 import { MdBackpack } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 4.14V2H14V4H10V2H7V4.14C5.28 4.59 4 6.14 4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8C20 6.14 18.72 4.59 17 4.14ZM18 20H6V8C6 6.9 6.9 6 8 6H16C17.1 6 18 6.9 18 8V20ZM16.5 12V16H14.5V14H7.5V12H16.5Z",
    fill: "currentColor"
  })));
}, "IconBackpack");
import Nm from "classnames";
var ym = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBackspace } from '@aws-amplify/ui-react'; \u2192 import { MdBackspace } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 3H7C6.31 3 5.77 3.35 5.41 3.88L0 12L5.41 20.11C5.77 20.64 6.31 21 7 21H22C23.1 21 24 20.1 24 19V5C24 3.9 23.1 3 22 3ZM22 19H7.07L2.4 12L7.06 5H22V19ZM10.41 17L14 13.41L17.59 17L19 15.59L15.41 12L19 8.41L17.59 7L14 10.59L10.41 7L9 8.41L12.59 12L9 15.59L10.41 17Z",
    fill: "currentColor"
  })));
}, "IconBackspace");
import bm from "classnames";
var Zm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBackupTable } from '@aws-amplify/ui-react'; \u2192 import { MdBackupTable } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6V20H6V22H20C21.1 22 22 21.1 22 20V6H20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M16 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H16C17.1 18 18 17.1 18 16V4C18 2.9 17.1 2 16 2ZM9 16H4V11H9V16ZM16 16H11V11H16V16ZM16 9H4V4H16V9Z",
    fill: "black"
  })));
}, "IconBackupTable");
import Bm from "classnames";
var Wm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBackup } from '@aws-amplify/ui-react'; \u2192 import { MdBackup } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18V18ZM8 13H10.55V16H13.45V13H16L12 9L8 13Z",
    fill: "currentColor"
  })));
}, "IconBackup");
import km from "classnames";
var Dm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBallot } from '@aws-amplify/ui-react'; \u2192 import { MdBallot } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: km(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 7.5H18V9.5H13V7.5ZM13 14.5H18V16.5H13V14.5ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM11 6H6V11H11V6ZM10 10H7V7H10V10ZM11 13H6V18H11V13ZM10 17H7V14H10V17Z",
    fill: "currentColor"
  })));
}, "IconBallot");
import Pm from "classnames";
var Sm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBarChart } from '@aws-amplify/ui-react'; \u2192 import { MdBarChart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 9.2H8V19H5V9.2ZM10.6 5H13.4V19H10.6V5V5ZM16.2 13H19V19H16.2V13Z",
    fill: "currentColor"
  })));
}, "IconBarChart");
import jm from "classnames";
var Ym = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBatchPrediction } from '@aws-amplify/ui-react'; \u2192 import { MdBatchPrediction } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 8H7C5.9 8 5 8.9 5 10V20C5 21.1 5.9 22 7 22H17C18.1 22 19 21.1 19 20V10C19 8.9 18.1 8 17 8ZM13 20.5H11V19H13V20.5ZM13 18H11C11 16.5 8.5 15 8.5 13C8.5 11.07 10.07 9.5 12 9.5C13.93 9.5 15.5 11.07 15.5 13C15.5 15 13 16.5 13 18ZM18 6.5H6C6 5.67 6.67 5 7.5 5H16.5C17.33 5 18 5.67 18 6.5ZM17 3.5H7C7 2.67 7.67 2 8.5 2H15.5C16.33 2 17 2.67 17 3.5Z",
    fill: "currentColor"
  })));
}, "IconBatchPrediction");
import Fm from "classnames";
var Tm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBathtub } from '@aws-amplify/ui-react'; \u2192 import { MdBathtub } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M20 13V4.83C20 3.27 18.73 2 17.17 2C16.42 2 15.7 2.3 15.17 2.83L13.92 4.08C13.76 4.03 13.59 4 13.41 4C13.01 4 12.64 4.12 12.33 4.32L15.09 7.08C15.29 6.77 15.41 6.4 15.41 6C15.41 5.82 15.38 5.66 15.34 5.49L16.59 4.24C16.74 4.09 16.95 4 17.17 4C17.63 4 18 4.37 18 4.83V13H11.15C10.85 12.79 10.58 12.55 10.33 12.28L8.93 10.73C8.74 10.52 8.5 10.35 8.24 10.23C7.93 10.08 7.59 10 7.24 10C6 10.01 5 11.01 5 12.25V13H2V19C2 20.1 2.9 21 4 21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21C21.1 21 22 20.1 22 19V13H20ZM20 19H4V15H20V19Z",
    fill: "black"
  })));
}, "IconBathtub");
import Am from "classnames";
var Em = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBatteryAlert } from '@aws-amplify/ui-react'; \u2192 import { MdBatteryAlert } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Am(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM13 18H11V16H13V18ZM13 14H11V9H13V14Z",
    fill: "currentColor"
  })));
}, "IconBatteryAlert");
import Om from "classnames";

var _m = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBatteryChargingFull } from '@aws-amplify/ui-react'; \u2192 import { MdBatteryChargingFull } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Om(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM11 20V14.5H9L13 7V12.5H15L11 20Z",
    fill: "currentColor"
  })));
}, "IconBatteryChargingFull");

import Gm from "classnames";
var Um = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBatteryFull } from '@aws-amplify/ui-react'; \u2192 import { MdBatteryFull } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4Z",
    fill: "currentColor"
  })));
}, "IconBatteryFull");
import zm from "classnames";
var Xm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBatteryStd } from '@aws-amplify/ui-react'; \u2192 import { MdBatteryStd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4Z",
    fill: "currentColor"
  })));
}, "IconBatteryStd");
import Km from "classnames";
var qm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBatteryUnknown } from '@aws-amplify/ui-react'; \u2192 import { MdBatteryUnknown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Km(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.67 4H14V2H10V4H8.33C7.6 4 7 4.6 7 5.33V20.66C7 21.4 7.6 22 8.33 22H15.66C16.4 22 17 21.4 17 20.67V5.33C17 4.6 16.4 4 15.67 4ZM13 18H11V16H13V18ZM14.3 12.69C14.3 12.69 13.92 13.11 13.63 13.4C13.15 13.88 12.8 14.55 12.8 15H11.2C11.2 14.17 11.66 13.48 12.13 13L13.06 12.06C13.33 11.79 13.5 11.41 13.5 11C13.5 10.17 12.83 9.5 12 9.5C11.17 9.5 10.5 10.17 10.5 11H9C9 9.34 10.34 8 12 8C13.66 8 15 9.34 15 11C15 11.66 14.73 12.26 14.3 12.69Z",
    fill: "currentColor"
  })));
}, "IconBatteryUnknown");
import Qm from "classnames";
var Jm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBeachAccess } from '@aws-amplify/ui-react'; \u2192 import { MdBeachAccess } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qm(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.9998 19.57L19.5728 20.998L13.1308 14.556L14.5608 13.128L20.9998 19.57ZM13.1198 3C10.5398 3 7.95982 3.98 5.97982 5.95L5.96982 5.96C2.01982 9.91 2.01982 16.32 5.96982 20.27L20.2698 5.96C18.2998 3.99 15.7098 3 13.1198 3ZM6.13982 17.27C5.39982 16.03 4.99982 14.61 4.99982 13.12C4.99982 12.19 5.15982 11.3 5.45982 10.45C5.64982 12.36 6.34982 14.24 7.52982 15.89L6.13982 17.27ZM8.97982 14.43C7.62982 12.38 7.11982 9.93 7.59982 7.6C8.17982 7.48 8.75982 7.42 9.34982 7.42C11.1498 7.42 12.8998 7.97 14.4298 8.98L8.97982 14.43ZM10.4498 5.46C11.2998 5.16 12.1898 5 13.1198 5C14.6098 5 16.0298 5.4 17.2698 6.14L15.8798 7.53C14.2298 6.35 12.3598 5.65 10.4498 5.46V5.46Z",
    fill: "currentColor"
  })));
}, "IconBeachAccess");
import $m from "classnames";
var Rm = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBedtime } from '@aws-amplify/ui-react'; \u2192 import { MdBedtime } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $m(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.27 4.49001C7.64 12.03 13.02 16.9 16.93 18.29C15.54 19.38 13.81 20 12 20C7.59 20 4 16.41 4 12C4 8.55001 6.2 5.60001 9.27 4.49001ZM11.99 2.01001C6.4 2.01001 2 6.54001 2 12C2 17.52 6.48 22 12 22C15.71 22 18.93 19.98 20.66 16.98C13.15 16.73 8.57 8.55001 12.34 2.01001C12.22 2.01001 12.11 2.01001 11.99 2.01001Z",
    fill: "currentColor"
  })));
}, "IconBedtime");
import ec from "classnames";
var oc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBeenhere } from '@aws-amplify/ui-react'; \u2192 import { MdBeenhere } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ec(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 1H5C3.9 1 3.01 1.9 3.01 3L3 15.93C3 16.62 3.35 17.23 3.88 17.59L12 23L20.11 17.59C20.64 17.23 20.99 16.62 20.99 15.93L21 3C21 1.9 20.1 1 19 1ZM12 20.6L5 15.94V3H19V15.93L12 20.6ZM9.99 13.18L7.41 10.59L6 12L10 16L18 8L16.58 6.58L9.99 13.18Z",
    fill: "currentColor"
  })));
}, "IconBeenhere");
import tc from "classnames";
var rc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBento } from '@aws-amplify/ui-react'; \u2192 import { MdBento } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 5H4C2.9 5 2 5.9 2 7V17C2 18.1 2.9 19 4 19H20C21.1 19 22 18.1 22 17V7C22 5.9 21.1 5 20 5ZM20 11H14V7H20V11ZM4 7H12V17H4V7ZM14 17V13H20V17H14ZM9.5 12C9.5 12.83 8.83 13.5 8 13.5C7.17 13.5 6.5 12.83 6.5 12C6.5 11.17 7.17 10.5 8 10.5C8.83 10.5 9.5 11.17 9.5 12Z",
    fill: "currentColor"
  })));
}, "IconBento");
import ic from "classnames";
var sc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBikeScooter } from '@aws-amplify/ui-react'; \u2192 import { MdBikeScooter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ic(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 14H10.74L8.82 5.56C8.61 4.65 7.8 4 6.87 4H3V6H6.87L8.29 12.25H8.28C6.12 12.9 4.47 14.73 4.09 17H0V19H6V18C6 15.79 7.79 14 10 14Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18.9999 8H18.1799L16.8299 4.31C16.5499 3.52 15.7999 3 14.9599 3H10.9999V5H14.9599L16.0599 8H10.3999L10.8599 10H14.9999C14.5699 10.58 14.2499 11.25 14.0999 12H11.3099L11.7699 14H14.0999C14.5399 16.23 16.4099 17.88 18.7499 17.99C21.5499 18.12 23.9999 15.8 23.9999 12.99C23.9999 10.2 21.7999 8 18.9999 8ZM18.9999 16C17.3199 16 15.9999 14.68 15.9999 13C15.9999 12.07 16.4099 11.27 17.0499 10.72L18.0099 13.36L19.8899 12.68L18.9199 10.01C18.9499 10.01 18.9799 10 19.0099 10C20.6899 10 22.0099 11.32 22.0099 13C22.0099 14.68 20.6799 16 18.9999 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10 15C8.34 15 7 16.34 7 18C7 19.66 8.34 21 10 21C11.66 21 13 19.66 13 18C13 16.34 11.66 15 10 15ZM10 19C9.45 19 9 18.55 9 18C9 17.45 9.45 17 10 17C10.55 17 11 17.45 11 18C11 18.55 10.55 19 10 19Z",
    fill: "black"
  })));
}, "IconBikeScooter");
import ac from "classnames";
var nc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBiotech } from '@aws-amplify/ui-react'; \u2192 import { MdBiotech } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ac(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 19C5.9 19 5 19.9 5 21H19C19 19.9 18.1 19 17 19H13V17H16C17.1 17 18 16.1 18 15H10C8.34 15 7 13.66 7 12C7 10.91 7.59 9.96 8.47 9.43C8.88 10.02 9.53 10.43 10.3 10.49C11 10.55 11.66 10.3 12.15 9.87L12.74 11.48L13.68 11.14L14.02 12.08L15.9 11.4L15.56 10.46L16.5 10.12L13.76 2.6L12.82 2.94L12.48 2L10.6 2.68L10.94 3.62L10 3.97L10.56 5.52C9.39 5.48 8.37 6.27 8.08 7.38C6.27 8.14 5 9.92 5 12C5 14.76 7.24 17 10 17V19H7ZM12.86 4.52L14.57 9.22L13.63 9.56L11.92 4.86L12.86 4.52ZM10.5 7C11.05 7 11.5 7.45 11.5 8C11.5 8.55 11.05 9 10.5 9C9.95 9 9.5 8.55 9.5 8C9.5 7.45 9.95 7 10.5 7Z",
    fill: "currentColor"
  })));
}, "IconBiotech");
import mc from "classnames";
var cc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBlock } from '@aws-amplify/ui-react'; \u2192 import { MdBlock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 7.58 7.58 4 12 4C13.85 4 15.55 4.63 16.9 5.69L5.69 16.9C4.63 15.55 4 13.85 4 12ZM12 20C10.15 20 8.45 19.37 7.1 18.31L18.31 7.1C19.37 8.45 20 10.15 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconBlock");
import lc from "classnames";
var pc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBluetoothAudio } from '@aws-amplify/ui-react'; \u2192 import { MdBluetoothAudio } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.24 12.01L16.56 14.33C16.84 13.61 17 12.82 17 12C17 11.18 16.84 10.41 16.57 9.69L14.24 12.01ZM19.53 6.71L18.27 7.97C18.9 9.18 19.25 10.54 19.25 11.99C19.25 13.44 18.89 14.81 18.27 16.01L19.47 17.21C20.44 15.67 21.01 13.85 21.01 11.9C21 10.01 20.46 8.23 19.53 6.71V6.71ZM15.71 7.71L10 2H9V9.59L4.41 5L3 6.41L8.59 12L3 17.59L4.41 19L9 14.41V22H10L15.71 16.29L11.41 12L15.71 7.71ZM11 5.83L12.88 7.71L11 9.59V5.83ZM12.88 16.29L11 18.17V14.41L12.88 16.29V16.29Z",
    fill: "currentColor"
  })));
}, "IconBluetoothAudio");
import hc from "classnames";
var fc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBluetoothConnected } from '@aws-amplify/ui-react'; \u2192 import { MdBluetoothConnected } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 12L5 10L3 12L5 14L7 12ZM17.71 7.71L12 2H11V9.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L11 14.41V22H12L17.71 16.29L13.41 12L17.71 7.71ZM13 5.83L14.88 7.71L13 9.59V5.83ZM14.88 16.29L13 18.17V14.41L14.88 16.29V16.29ZM19 10L17 12L19 14L21 12L19 10Z",
    fill: "currentColor"
  })));
}, "IconBluetoothConnected");
import Cc from "classnames";
var gc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBluetoothDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdBluetoothDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 5.83L14.88 7.71L13.28 9.31L14.69 10.72L17.71 7.7L12 2H11V7.03L13 9.03V5.83V5.83ZM5.41 4L4 5.41L10.59 12L5 17.59L6.41 19L11 14.41V22H12L16.29 17.71L18.59 20L20 18.59L5.41 4ZM13 18.17V14.41L14.88 16.29L13 18.17Z",
    fill: "currentColor"
  })));
}, "IconBluetoothDisabled");
import uc from "classnames";
var wc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBluetoothSearching } from '@aws-amplify/ui-react'; \u2192 import { MdBluetoothSearching } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.24 12.01L16.56 14.33C16.84 13.61 17 12.82 17 12C17 11.18 16.84 10.41 16.57 9.69L14.24 12.01ZM19.53 6.71L18.27 7.97C18.9 9.18 19.25 10.54 19.25 11.99C19.25 13.44 18.89 14.81 18.27 16.01L19.47 17.21C20.44 15.67 21.01 13.85 21.01 11.9C21 10.01 20.46 8.23 19.53 6.71V6.71ZM15.71 7.71L10 2H9V9.59L4.41 5L3 6.41L8.59 12L3 17.59L4.41 19L9 14.41V22H10L15.71 16.29L11.41 12L15.71 7.71ZM11 5.83L12.88 7.71L11 9.59V5.83ZM12.88 16.29L11 18.17V14.41L12.88 16.29V16.29Z",
    fill: "currentColor"
  })));
}, "IconBluetoothSearching");
import dc from "classnames";
var Vc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBluetooth } from '@aws-amplify/ui-react'; \u2192 import { MdBluetooth } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.71 7.71L12 2H11V9.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L11 14.41V22H12L17.71 16.29L13.41 12L17.71 7.71ZM13 5.83L14.88 7.71L13 9.59V5.83ZM14.88 16.29L13 18.17V14.41L14.88 16.29V16.29Z",
    fill: "currentColor"
  })));
}, "IconBluetooth");
import Hc from "classnames";
var Mc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBlurCircular } from '@aws-amplify/ui-react'; \u2192 import { MdBlurCircular } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 9C9.45 9 9 9.45 9 10C9 10.55 9.45 11 10 11C10.55 11 11 10.55 11 10C11 9.45 10.55 9 10 9ZM10 13C9.45 13 9 13.45 9 14C9 14.55 9.45 15 10 15C10.55 15 11 14.55 11 14C11 13.45 10.55 13 10 13ZM7 9.5C6.72 9.5 6.5 9.72 6.5 10C6.5 10.28 6.72 10.5 7 10.5C7.28 10.5 7.5 10.28 7.5 10C7.5 9.72 7.28 9.5 7 9.5ZM10 16.5C9.72 16.5 9.5 16.72 9.5 17C9.5 17.28 9.72 17.5 10 17.5C10.28 17.5 10.5 17.28 10.5 17C10.5 16.72 10.28 16.5 10 16.5ZM7 13.5C6.72 13.5 6.5 13.72 6.5 14C6.5 14.28 6.72 14.5 7 14.5C7.28 14.5 7.5 14.28 7.5 14C7.5 13.72 7.28 13.5 7 13.5ZM10 7.5C10.28 7.5 10.5 7.28 10.5 7C10.5 6.72 10.28 6.5 10 6.5C9.72 6.5 9.5 6.72 9.5 7C9.5 7.28 9.72 7.5 10 7.5ZM14 9C13.45 9 13 9.45 13 10C13 10.55 13.45 11 14 11C14.55 11 15 10.55 15 10C15 9.45 14.55 9 14 9ZM14 7.5C14.28 7.5 14.5 7.28 14.5 7C14.5 6.72 14.28 6.5 14 6.5C13.72 6.5 13.5 6.72 13.5 7C13.5 7.28 13.72 7.5 14 7.5ZM17 13.5C16.72 13.5 16.5 13.72 16.5 14C16.5 14.28 16.72 14.5 17 14.5C17.28 14.5 17.5 14.28 17.5 14C17.5 13.72 17.28 13.5 17 13.5ZM17 9.5C16.72 9.5 16.5 9.72 16.5 10C16.5 10.28 16.72 10.5 17 10.5C17.28 10.5 17.5 10.28 17.5 10C17.5 9.72 17.28 9.5 17 9.5ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM14 16.5C13.72 16.5 13.5 16.72 13.5 17C13.5 17.28 13.72 17.5 14 17.5C14.28 17.5 14.5 17.28 14.5 17C14.5 16.72 14.28 16.5 14 16.5ZM14 13C13.45 13 13 13.45 13 14C13 14.55 13.45 15 14 15C14.55 15 15 14.55 15 14C15 13.45 14.55 13 14 13Z",
    fill: "currentColor"
  })));
}, "IconBlurCircular");
import xc from "classnames";
var Ic = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBlurLinear } from '@aws-amplify/ui-react'; \u2192 import { MdBlurLinear } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 17.5C5.83 17.5 6.5 16.83 6.5 16C6.5 15.17 5.83 14.5 5 14.5C4.17 14.5 3.5 15.17 3.5 16C3.5 16.83 4.17 17.5 5 17.5ZM9 13C9.55 13 10 12.55 10 12C10 11.45 9.55 11 9 11C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13ZM9 9C9.55 9 10 8.55 10 8C10 7.45 9.55 7 9 7C8.45 7 8 7.45 8 8C8 8.55 8.45 9 9 9ZM3 21H21V19H3V21ZM5 9.5C5.83 9.5 6.5 8.83 6.5 8C6.5 7.17 5.83 6.5 5 6.5C4.17 6.5 3.5 7.17 3.5 8C3.5 8.83 4.17 9.5 5 9.5ZM5 13.5C5.83 13.5 6.5 12.83 6.5 12C6.5 11.17 5.83 10.5 5 10.5C4.17 10.5 3.5 11.17 3.5 12C3.5 12.83 4.17 13.5 5 13.5ZM9 17C9.55 17 10 16.55 10 16C10 15.45 9.55 15 9 15C8.45 15 8 15.45 8 16C8 16.55 8.45 17 9 17ZM17 16.5C17.28 16.5 17.5 16.28 17.5 16C17.5 15.72 17.28 15.5 17 15.5C16.72 15.5 16.5 15.72 16.5 16C16.5 16.28 16.72 16.5 17 16.5ZM3 3V5H21V3H3ZM17 8.5C17.28 8.5 17.5 8.28 17.5 8C17.5 7.72 17.28 7.5 17 7.5C16.72 7.5 16.5 7.72 16.5 8C16.5 8.28 16.72 8.5 17 8.5ZM17 12.5C17.28 12.5 17.5 12.28 17.5 12C17.5 11.72 17.28 11.5 17 11.5C16.72 11.5 16.5 11.72 16.5 12C16.5 12.28 16.72 12.5 17 12.5ZM13 9C13.55 9 14 8.55 14 8C14 7.45 13.55 7 13 7C12.45 7 12 7.45 12 8C12 8.55 12.45 9 13 9ZM13 13C13.55 13 14 12.55 14 12C14 11.45 13.55 11 13 11C12.45 11 12 11.45 12 12C12 12.55 12.45 13 13 13ZM13 17C13.55 17 14 16.55 14 16C14 15.45 13.55 15 13 15C12.45 15 12 15.45 12 16C12 16.55 12.45 17 13 17Z",
    fill: "currentColor"
  })));
}, "IconBlurLinear");
import Lc from "classnames";
var vc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBlurOff } from '@aws-amplify/ui-react'; \u2192 import { MdBlurOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 7C14.5523 7 15 6.55228 15 6C15 5.44772 14.5523 5 14 5C13.4477 5 13 5.44772 13 6C13 6.55228 13.4477 7 14 7Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M13.8 11.48L14 11.5C14.83 11.5 15.5 10.83 15.5 10C15.5 9.17 14.83 8.5 14 8.5C13.17 8.5 12.5 9.17 12.5 10L12.52 10.2C12.61 10.87 13.13 11.39 13.8 11.48V11.48ZM14 3.5C14.28 3.5 14.5 3.28 14.5 3C14.5 2.72 14.28 2.5 14 2.5C13.72 2.5 13.5 2.72 13.5 3C13.5 3.28 13.72 3.5 14 3.5ZM10 3.5C10.28 3.5 10.5 3.28 10.5 3C10.5 2.72 10.28 2.5 10 2.5C9.72 2.5 9.5 2.72 9.5 3C9.5 3.28 9.72 3.5 10 3.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18 11C18.5523 11 19 10.5523 19 10C19 9.44772 18.5523 9 18 9C17.4477 9 17 9.44772 17 10C17 10.5523 17.4477 11 18 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M21 10.5C21.28 10.5 21.5 10.28 21.5 10C21.5 9.72 21.28 9.5 21 9.5C20.72 9.5 20.5 9.72 20.5 10C20.5 10.28 20.72 10.5 21 10.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18 15C18.5523 15 19 14.5523 19 14C19 13.4477 18.5523 13 18 13C17.4477 13 17 13.4477 17 14C17 14.5523 17.4477 15 18 15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M6 19C6.55228 19 7 18.5523 7 18C7 17.4477 6.55228 17 6 17C5.44772 17 5 17.4477 5 18C5 18.5523 5.44772 19 6 19Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14 20.5C13.72 20.5 13.5 20.72 13.5 21C13.5 21.28 13.72 21.5 14 21.5C14.28 21.5 14.5 21.28 14.5 21C14.5 20.72 14.28 20.5 14 20.5ZM21 13.5C20.72 13.5 20.5 13.72 20.5 14C20.5 14.28 20.72 14.5 21 14.5C21.28 14.5 21.5 14.28 21.5 14C21.5 13.72 21.28 13.5 21 13.5ZM3 13.5C2.72 13.5 2.5 13.72 2.5 14C2.5 14.28 2.72 14.5 3 14.5C3.28 14.5 3.5 14.28 3.5 14C3.5 13.72 3.28 13.5 3 13.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10 19C10.5523 19 11 18.5523 11 18C11 17.4477 10.5523 17 10 17C9.44772 17 9 17.4477 9 18C9 18.5523 9.44772 19 10 19Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M3 9.5C2.72 9.5 2.5 9.72 2.5 10C2.5 10.28 2.72 10.5 3 10.5C3.28 10.5 3.5 10.28 3.5 10C3.5 9.72 3.28 9.5 3 9.5ZM10 20.5C9.72 20.5 9.5 20.72 9.5 21C9.5 21.28 9.72 21.5 10 21.5C10.28 21.5 10.5 21.28 10.5 21C10.5 20.72 10.28 20.5 10 20.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M6 15C6.55228 15 7 14.5523 7 14C7 13.4477 6.55228 13 6 13C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M2.5 5.27011L6 8.77011L6.28 9.05011L6 9.00011C5.45 9.00011 5 9.45011 5 10.0001C5 10.5501 5.45 11.0001 6 11.0001C6.55 11.0001 7 10.5501 7 10.0001C7 9.90011 6.97 9.81011 6.94 9.72011L9.75 12.5301C9.04 12.6401 8.5 13.2601 8.5 14.0001C8.5 14.8301 9.17 15.5001 10 15.5001C10.74 15.5001 11.36 14.9601 11.47 14.2501L14.28 17.0601C14.19 17.0301 14.1 17.0001 14 17.0001C13.45 17.0001 13 17.4501 13 18.0001C13 18.5501 13.45 19.0001 14 19.0001C14.55 19.0001 15 18.5501 15 18.0001C15 17.9001 14.97 17.8101 14.94 17.7201L18.72 21.5001H18.73L20.14 20.0901L3.91 3.86011L2.5 5.27011Z",
    fill: "black"
  })));
}, "IconBlurOff");
import Nc from "classnames";
var yc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBlurOn } from '@aws-amplify/ui-react'; \u2192 import { MdBlurOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 13C5.45 13 5 13.45 5 14C5 14.55 5.45 15 6 15C6.55 15 7 14.55 7 14C7 13.45 6.55 13 6 13ZM6 17C5.45 17 5 17.45 5 18C5 18.55 5.45 19 6 19C6.55 19 7 18.55 7 18C7 17.45 6.55 17 6 17ZM6 9C5.45 9 5 9.45 5 10C5 10.55 5.45 11 6 11C6.55 11 7 10.55 7 10C7 9.45 6.55 9 6 9ZM3 9.5C2.72 9.5 2.5 9.72 2.5 10C2.5 10.28 2.72 10.5 3 10.5C3.28 10.5 3.5 10.28 3.5 10C3.5 9.72 3.28 9.5 3 9.5ZM6 5C5.45 5 5 5.45 5 6C5 6.55 5.45 7 6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5ZM21 10.5C21.28 10.5 21.5 10.28 21.5 10C21.5 9.72 21.28 9.5 21 9.5C20.72 9.5 20.5 9.72 20.5 10C20.5 10.28 20.72 10.5 21 10.5ZM14 7C14.55 7 15 6.55 15 6C15 5.45 14.55 5 14 5C13.45 5 13 5.45 13 6C13 6.55 13.45 7 14 7ZM14 3.5C14.28 3.5 14.5 3.28 14.5 3C14.5 2.72 14.28 2.5 14 2.5C13.72 2.5 13.5 2.72 13.5 3C13.5 3.28 13.72 3.5 14 3.5ZM3 13.5C2.72 13.5 2.5 13.72 2.5 14C2.5 14.28 2.72 14.5 3 14.5C3.28 14.5 3.5 14.28 3.5 14C3.5 13.72 3.28 13.5 3 13.5ZM10 20.5C9.72 20.5 9.5 20.72 9.5 21C9.5 21.28 9.72 21.5 10 21.5C10.28 21.5 10.5 21.28 10.5 21C10.5 20.72 10.28 20.5 10 20.5ZM10 3.5C10.28 3.5 10.5 3.28 10.5 3C10.5 2.72 10.28 2.5 10 2.5C9.72 2.5 9.5 2.72 9.5 3C9.5 3.28 9.72 3.5 10 3.5ZM10 7C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6C9 6.55 9.45 7 10 7ZM10 12.5C9.17 12.5 8.5 13.17 8.5 14C8.5 14.83 9.17 15.5 10 15.5C10.83 15.5 11.5 14.83 11.5 14C11.5 13.17 10.83 12.5 10 12.5ZM18 13C17.45 13 17 13.45 17 14C17 14.55 17.45 15 18 15C18.55 15 19 14.55 19 14C19 13.45 18.55 13 18 13ZM18 17C17.45 17 17 17.45 17 18C17 18.55 17.45 19 18 19C18.55 19 19 18.55 19 18C19 17.45 18.55 17 18 17ZM18 9C17.45 9 17 9.45 17 10C17 10.55 17.45 11 18 11C18.55 11 19 10.55 19 10C19 9.45 18.55 9 18 9ZM18 5C17.45 5 17 5.45 17 6C17 6.55 17.45 7 18 7C18.55 7 19 6.55 19 6C19 5.45 18.55 5 18 5ZM21 13.5C20.72 13.5 20.5 13.72 20.5 14C20.5 14.28 20.72 14.5 21 14.5C21.28 14.5 21.5 14.28 21.5 14C21.5 13.72 21.28 13.5 21 13.5ZM14 17C13.45 17 13 17.45 13 18C13 18.55 13.45 19 14 19C14.55 19 15 18.55 15 18C15 17.45 14.55 17 14 17ZM14 20.5C13.72 20.5 13.5 20.72 13.5 21C13.5 21.28 13.72 21.5 14 21.5C14.28 21.5 14.5 21.28 14.5 21C14.5 20.72 14.28 20.5 14 20.5ZM10 8.5C9.17 8.5 8.5 9.17 8.5 10C8.5 10.83 9.17 11.5 10 11.5C10.83 11.5 11.5 10.83 11.5 10C11.5 9.17 10.83 8.5 10 8.5ZM10 17C9.45 17 9 17.45 9 18C9 18.55 9.45 19 10 19C10.55 19 11 18.55 11 18C11 17.45 10.55 17 10 17ZM14 12.5C13.17 12.5 12.5 13.17 12.5 14C12.5 14.83 13.17 15.5 14 15.5C14.83 15.5 15.5 14.83 15.5 14C15.5 13.17 14.83 12.5 14 12.5ZM14 8.5C13.17 8.5 12.5 9.17 12.5 10C12.5 10.83 13.17 11.5 14 11.5C14.83 11.5 15.5 10.83 15.5 10C15.5 9.17 14.83 8.5 14 8.5Z",
    fill: "currentColor"
  })));
}, "IconBlurOn");
import bc from "classnames";
var Zc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBookOnline } from '@aws-amplify/ui-react'; \u2192 import { MdBookOnline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 4H7V3H17V4ZM17 21H7V20H17V21ZM17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM7 6H17V18H7V6ZM16 11V9.14C16 8.51 15.55 8 15 8H9C8.45 8 8 8.51 8 9.14V11.1C8.55 11.1 9 11.55 9 12.1C9 12.65 8.55 13.1 8 13.1V14.86C8 15.49 8.45 16 9 16H15C15.55 16 16 15.49 16 14.86V13C15.45 13 15 12.55 15 12C15 11.45 15.45 11 16 11ZM12.5 14.5H11.5V13.5H12.5V14.5ZM12.5 12.5H11.5V11.5H12.5V12.5ZM12.5 10.5H11.5V9.5H12.5V10.5Z",
    fill: "currentColor"
  })));
}, "IconBookOnline");
import Bc from "classnames";
var Wc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBook } from '@aws-amplify/ui-react'; \u2192 import { MdBook } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 4H11V9L10 8.25L9 9V4ZM18 20H6V4H7V13L10 10.75L13 13V4H18V20Z",
    fill: "currentColor"
  })));
}, "IconBook");
import kc from "classnames";
var Dc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBookmarkBorder } from '@aws-amplify/ui-react'; \u2192 import { MdBookmarkBorder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z",
    fill: "currentColor"
  })));
}, "IconBookmarkBorder");
import Pc from "classnames";
var Sc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBookmark } from '@aws-amplify/ui-react'; \u2192 import { MdBookmark } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z",
    fill: "currentColor"
  })));
}, "IconBookmark");
import jc from "classnames";
var Yc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBookmarks } from '@aws-amplify/ui-react'; \u2192 import { MdBookmarks } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 7V19.97L10.79 18.16L10 17.82L9.21 18.16L5 19.97V7H15ZM19 1H8.99C7.89 1 7 1.9 7 3H17C18.1 3 19 3.9 19 5V18L21 19V3C21 1.9 20.1 1 19 1ZM15 5H5C3.9 5 3 5.9 3 7V23L10 20L17 23V7C17 5.9 16.1 5 15 5Z",
    fill: "currentColor"
  })));
}, "IconBookmarks");
import Fc from "classnames";
var Tc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderAll } from '@aws-amplify/ui-react'; \u2192 import { MdBorderAll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 3V21H21V3H3ZM11 19H5V13H11V19ZM11 11H5V5H11V11ZM19 19H13V13H19V19ZM19 11H13V5H19V11Z",
    fill: "currentColor"
  })));
}, "IconBorderAll");
import Ac from "classnames";
var Ec = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderBottom } from '@aws-amplify/ui-react'; \u2192 import { MdBorderBottom } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ac(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 11H7V13H9V11ZM13 15H11V17H13V15ZM9 3H7V5H9V3ZM13 11H11V13H13V11ZM5 3H3V5H5V3ZM13 7H11V9H13V7ZM17 11H15V13H17V11ZM13 3H11V5H13V3ZM17 3H15V5H17V3ZM19 13H21V11H19V13ZM19 17H21V15H19V17ZM5 7H3V9H5V7ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM5 11H3V13H5V11ZM3 21H21V19H3V21ZM5 15H3V17H5V15Z",
    fill: "currentColor"
  })));
}, "IconBorderBottom");
import Oc from "classnames";

var _c = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderClear } from '@aws-amplify/ui-react'; \u2192 import { MdBorderClear } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Oc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 5H9V3H7V5ZM7 13H9V11H7V13ZM7 21H9V19H7V21ZM11 17H13V15H11V17ZM11 21H13V19H11V21ZM3 21H5V19H3V21ZM3 17H5V15H3V17ZM3 13H5V11H3V13ZM3 9H5V7H3V9ZM3 5H5V3H3V5ZM11 13H13V11H11V13ZM19 17H21V15H19V17ZM19 13H21V11H19V13ZM19 21H21V19H19V21ZM19 9H21V7H19V9ZM11 9H13V7H11V9ZM19 3V5H21V3H19ZM11 5H13V3H11V5ZM15 21H17V19H15V21ZM15 13H17V11H15V13ZM15 5H17V3H15V5Z",
    fill: "currentColor"
  })));
}, "IconBorderClear");

import Gc from "classnames";
var Uc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderHorizontal } from '@aws-amplify/ui-react'; \u2192 import { MdBorderHorizontal } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 21H5V19H3V21ZM5 7H3V9H5V7ZM3 17H5V15H3V17ZM7 21H9V19H7V21ZM5 3H3V5H5V3ZM9 3H7V5H9V3ZM17 3H15V5H17V3ZM13 7H11V9H13V7ZM13 3H11V5H13V3ZM19 17H21V15H19V17ZM11 21H13V19H11V21ZM3 13H21V11H3V13ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM11 17H13V15H11V17ZM15 21H17V19H15V21ZM19 21H21V19H19V21Z",
    fill: "currentColor"
  })));
}, "IconBorderHorizontal");
import zc from "classnames";
var Xc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderInner } from '@aws-amplify/ui-react'; \u2192 import { MdBorderInner } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 21H5V19H3V21ZM7 21H9V19H7V21ZM5 7H3V9H5V7ZM3 17H5V15H3V17ZM9 3H7V5H9V3ZM5 3H3V5H5V3ZM17 3H15V5H17V3ZM19 9H21V7H19V9ZM19 3V5H21V3H19ZM15 21H17V19H15V21ZM13 3H11V11H3V13H11V21H13V13H21V11H13V3ZM19 21H21V19H19V21ZM19 17H21V15H19V17Z",
    fill: "currentColor"
  })));
}, "IconBorderInner");
import Kc from "classnames";
var qc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderLeft } from '@aws-amplify/ui-react'; \u2192 import { MdBorderLeft } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 21H13V19H11V21ZM11 17H13V15H11V17ZM11 5H13V3H11V5ZM11 9H13V7H11V9ZM11 13H13V11H11V13ZM7 21H9V19H7V21ZM7 5H9V3H7V5ZM7 13H9V11H7V13ZM3 21H5V3H3V21ZM19 9H21V7H19V9ZM15 21H17V19H15V21ZM19 17H21V15H19V17ZM19 3V5H21V3H19ZM19 13H21V11H19V13ZM19 21H21V19H19V21ZM15 13H17V11H15V13ZM15 5H17V3H15V5Z",
    fill: "currentColor"
  })));
}, "IconBorderLeft");
import Qc from "classnames";
var Jc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderOuter } from '@aws-amplify/ui-react'; \u2192 import { MdBorderOuter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qc(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 7H11V9H13V7ZM13 11H11V13H13V11ZM17 11H15V13H17V11ZM3 3V21H21V3H3ZM19 19H5V5H19V19ZM13 15H11V17H13V15ZM9 11H7V13H9V11Z",
    fill: "currentColor"
  })));
}, "IconBorderOuter");
import $c from "classnames";
var Rc = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderRight } from '@aws-amplify/ui-react'; \u2192 import { MdBorderRight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $c(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 21H9V19H7V21ZM3 5H5V3H3V5ZM7 5H9V3H7V5ZM7 13H9V11H7V13ZM3 21H5V19H3V21ZM11 21H13V19H11V21ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM11 17H13V15H11V17ZM15 13H17V11H15V13ZM19 3V21H21V3H19ZM15 21H17V19H15V21ZM15 5H17V3H15V5ZM11 13H13V11H11V13ZM11 5H13V3H11V5ZM11 9H13V7H11V9Z",
    fill: "currentColor"
  })));
}, "IconBorderRight");
import e9 from "classnames";
var o9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderStyle } from '@aws-amplify/ui-react'; \u2192 import { MdBorderStyle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: e9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 21H17V19H15V21ZM19 21H21V19H19V21ZM7 21H9V19H7V21ZM11 21H13V19H11V21ZM19 17H21V15H19V17ZM19 13H21V11H19V13ZM3 3V21H5V5H21V3H3ZM19 9H21V7H19V9Z",
    fill: "currentColor"
  })));
}, "IconBorderStyle");
import t9 from "classnames";
var r9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderTop } from '@aws-amplify/ui-react'; \u2192 import { MdBorderTop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: t9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 21H9V19H7V21ZM7 13H9V11H7V13ZM11 13H13V11H11V13ZM11 21H13V19H11V21ZM3 17H5V15H3V17ZM3 21H5V19H3V21ZM3 13H5V11H3V13ZM3 9H5V7H3V9ZM11 17H13V15H11V17ZM19 9H21V7H19V9ZM19 13H21V11H19V13ZM3 3V5H21V3H3ZM19 17H21V15H19V17ZM15 21H17V19H15V21ZM11 9H13V7H11V9ZM19 21H21V19H19V21ZM15 13H17V11H15V13Z",
    fill: "currentColor"
  })));
}, "IconBorderTop");
import i9 from "classnames";
var s9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBorderVertical } from '@aws-amplify/ui-react'; \u2192 import { MdBorderVertical } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: i9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 9H5V7H3V9ZM3 5H5V3H3V5ZM7 21H9V19H7V21ZM7 13H9V11H7V13ZM3 13H5V11H3V13ZM3 21H5V19H3V21ZM3 17H5V15H3V17ZM7 5H9V3H7V5ZM19 17H21V15H19V17ZM11 21H13V3H11V21ZM19 21H21V19H19V21ZM19 13H21V11H19V13ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM15 5H17V3H15V5ZM15 21H17V19H15V21ZM15 13H17V11H15V13Z",
    fill: "currentColor"
  })));
}, "IconBorderVertical");
import a9 from "classnames";
var n9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrandingWatermark } from '@aws-amplify/ui-react'; \u2192 import { MdBrandingWatermark } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: a9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM11 12H20V18H11V12Z",
    fill: "currentColor"
  })));
}, "IconBrandingWatermark");
import m9 from "classnames";
var c9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightness_1 } from '@aws-amplify/ui-react'; \u2192 import { MdBrightness_1 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: m9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z",
    fill: "currentColor"
  })));
}, "IconBrightness_1");
import l9 from "classnames";
var p9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightness_2 } from '@aws-amplify/ui-react'; \u2192 import { MdBrightness_2 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: l9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 4C14.41 4 18 7.59 18 12C18 16.41 14.41 20 10 20C9.66 20 9.32 19.98 8.99 19.93C10.9 17.77 12 14.95 12 12C12 9.05 10.9 6.23 8.99 4.07C9.32 4.02 9.66 4 10 4ZM10 2C8.18 2 6.47 2.5 5 3.35C7.99 5.08 10 8.3 10 12C10 15.7 7.99 18.92 5 20.65C6.47 21.5 8.18 22 10 22C15.52 22 20 17.52 20 12C20 6.48 15.52 2 10 2Z",
    fill: "currentColor"
  })));
}, "IconBrightness_2");
import h9 from "classnames";
var f9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightness_3 } from '@aws-amplify/ui-react'; \u2192 import { MdBrightness_3 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: h9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.7 4.91C15.25 6.24 17 8.92 17 12C17 15.08 15.25 17.76 12.7 19.09C14.16 17.09 15 14.63 15 12C15 9.37 14.16 6.91 12.7 4.91ZM9 2C7.95 2 6.95 2.16 6 2.46C10.06 3.73 13 7.52 13 12C13 16.48 10.06 20.27 6 21.54C6.95 21.84 7.95 22 9 22C14.52 22 19 17.52 19 12C19 6.48 14.52 2 9 2Z",
    fill: "currentColor"
  })));
}, "IconBrightness_3");
import C9 from "classnames";
var g9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightness_4 } from '@aws-amplify/ui-react'; \u2192 import { MdBrightness_4 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: C9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM12.2899 6.99994C11.5499 6.99994 10.8399 7.16994 10.2099 7.45994C11.9299 8.24994 13.1299 9.98994 13.1299 11.9999C13.1299 14.0099 11.9299 15.7499 10.2099 16.5399C10.8399 16.8299 11.5499 16.9999 12.2899 16.9999C15.0499 16.9999 17.2899 14.7599 17.2899 11.9999C17.2899 9.23994 15.0499 6.99994 12.2899 6.99994Z",
    fill: "currentColor"
  })));
}, "IconBrightness_4");
import u9 from "classnames";
var w9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightness_5 } from '@aws-amplify/ui-react'; \u2192 import { MdBrightness_5 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: u9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM11.9999 6.49994C8.96994 6.49994 6.49994 8.96994 6.49994 11.9999C6.49994 15.0299 8.96994 17.4999 11.9999 17.4999C15.0299 17.4999 17.4999 15.0299 17.4999 11.9999C17.4999 8.96994 15.0299 6.49994 11.9999 6.49994ZM11.9999 15.4999C10.0699 15.4999 8.49994 13.9299 8.49994 11.9999C8.49994 10.0699 10.0699 8.49994 11.9999 8.49994C13.9299 8.49994 15.4999 10.0699 15.4999 11.9999C15.4999 13.9299 13.9299 15.4999 11.9999 15.4999Z",
    fill: "currentColor"
  })));
}, "IconBrightness_5");
import d9 from "classnames";
var V9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightness_6 } from '@aws-amplify/ui-react'; \u2192 import { MdBrightness_6 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: d9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM11.9999 6.49994V17.4999C15.0299 17.4999 17.4999 15.0299 17.4999 11.9999C17.4999 8.96994 15.0299 6.49994 11.9999 6.49994Z",
    fill: "currentColor"
  })));
}, "IconBrightness_6");
import H9 from "classnames";
var M9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightness_7 } from '@aws-amplify/ui-react'; \u2192 import { MdBrightness_7 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: H9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM11.9999 6.49994C8.96994 6.49994 6.49994 8.96994 6.49994 11.9999C6.49994 15.0299 8.96994 17.4999 11.9999 17.4999C15.0299 17.4999 17.4999 15.0299 17.4999 11.9999C17.4999 8.96994 15.0299 6.49994 11.9999 6.49994ZM11.9999 15.4999C10.0699 15.4999 8.49994 13.9299 8.49994 11.9999C8.49994 10.0699 10.0699 8.49994 11.9999 8.49994C13.9299 8.49994 15.4999 10.0699 15.4999 11.9999C15.4999 13.9299 13.9299 15.4999 11.9999 15.4999Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "black"
  })));
}, "IconBrightness_7");
import x9 from "classnames";
var I9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightnessAuto } from '@aws-amplify/ui-react'; \u2192 import { MdBrightnessAuto } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: x9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.9999 6.99994L7.79994 15.9999H9.69994L10.3999 13.9999H13.5999L14.2999 15.9999H16.1999L12.9999 6.99994H10.9999ZM10.8499 12.6499L11.9999 8.99994L13.1499 12.6499H10.8499V12.6499ZM19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799Z",
    fill: "currentColor"
  })));
}, "IconBrightnessAuto");
import L9 from "classnames";
var v9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightnessHigh } from '@aws-amplify/ui-react'; \u2192 import { MdBrightnessHigh } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: L9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM11.9999 5.99994C8.68994 5.99994 5.99994 8.68994 5.99994 11.9999C5.99994 15.3099 8.68994 17.9999 11.9999 17.9999C15.3099 17.9999 17.9999 15.3099 17.9999 11.9999C17.9999 8.68994 15.3099 5.99994 11.9999 5.99994ZM11.9999 15.9999C9.78994 15.9999 7.99994 14.2099 7.99994 11.9999C7.99994 9.78994 9.78994 7.99994 11.9999 7.99994C14.2099 7.99994 15.9999 9.78994 15.9999 11.9999C15.9999 14.2099 14.2099 15.9999 11.9999 15.9999Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 14.5C13.3807 14.5 14.5 13.3807 14.5 12C14.5 10.6193 13.3807 9.5 12 9.5C10.6193 9.5 9.5 10.6193 9.5 12C9.5 13.3807 10.6193 14.5 12 14.5Z",
    fill: "black"
  })));
}, "IconBrightnessHigh");
import N9 from "classnames";
var y9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightnessLow } from '@aws-amplify/ui-react'; \u2192 import { MdBrightnessLow } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: N9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.9999 8.68994V3.99994H15.3099L11.9999 0.689941L8.68994 3.99994H3.99994V8.68994L0.689941 11.9999L3.99994 15.3099V19.9999H8.68994L11.9999 23.3099L15.3099 19.9999H19.9999V15.3099L23.3099 11.9999L19.9999 8.68994ZM17.9999 14.4799V17.9999H14.4799L11.9999 20.4799L9.51994 17.9999H5.99994V14.4799L3.51994 11.9999L5.99994 9.51994V5.99994H9.51994L11.9999 3.51994L14.4799 5.99994H17.9999V9.51994L20.4799 11.9999L17.9999 14.4799ZM11.9999 5.99994C8.68994 5.99994 5.99994 8.68994 5.99994 11.9999C5.99994 15.3099 8.68994 17.9999 11.9999 17.9999C15.3099 17.9999 17.9999 15.3099 17.9999 11.9999C17.9999 8.68994 15.3099 5.99994 11.9999 5.99994ZM11.9999 15.9999C9.78994 15.9999 7.99994 14.2099 7.99994 11.9999C7.99994 9.78994 9.78994 7.99994 11.9999 7.99994C14.2099 7.99994 15.9999 9.78994 15.9999 11.9999C15.9999 14.2099 14.2099 15.9999 11.9999 15.9999Z",
    fill: "currentColor"
  })));
}, "IconBrightnessLow");
import b9 from "classnames";
var Z9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrightnessMedium } from '@aws-amplify/ui-react'; \u2192 import { MdBrightnessMedium } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: b9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 8.68994V3.99994H15.31L12 0.689941L8.69 3.99994H4V8.68994L0.690002 11.9999L4 15.3099V19.9999H8.69L12 23.3099L15.31 19.9999H20V15.3099L23.31 11.9999L20 8.68994ZM18 14.4799V17.9999H14.48L12 20.4799L9.52 17.9999H6V14.4799L3.52 11.9999L6 9.51994V5.99994H9.52L12 3.51994L14.48 5.99994H18V9.51994L20.48 11.9999L18 14.4799ZM12 5.99994V17.9999C15.31 17.9999 18 15.3099 18 11.9999C18 8.68994 15.31 5.99994 12 5.99994Z",
    fill: "currentColor"
  })));
}, "IconBrightnessMedium");
import B9 from "classnames";
var W9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrokenImage } from '@aws-amplify/ui-react'; \u2192 import { MdBrokenImage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: B9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V14.42L5.99 15.41L9.99 11.41L13.99 15.41L17.99 11.42L19 12.43V19ZM19 9.59L17.99 8.58L13.99 12.59L9.99 8.59L5.99 12.59L5 11.59V5H19V9.59Z",
    fill: "currentColor"
  })));
}, "IconBrokenImage");
import k9 from "classnames";
var D9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrowserNotSupported } from '@aws-amplify/ui-react'; \u2192 import { MdBrowserNotSupported } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: k9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 6V16.5L20.95 18.45C20.98 18.3 21 18.15 21 18V6C21 4.9 20.1 4 19 4H6.5L8.5 6H19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M3.21995 3.31982L1.94995 4.58982L2.99995 5.63982V17.9998C2.99995 19.0998 3.89995 19.9998 4.99995 19.9998H17.36L19.42 22.0598L20.69 20.7898L3.21995 3.31982ZM15 17.9998H4.99995V7.63982L15.36 17.9998H15Z",
    fill: "black"
  })));
}, "IconBrowserNotSupported");
import P9 from "classnames";
var S9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBrush } from '@aws-amplify/ui-react'; \u2192 import { MdBrush } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: P9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 16C7.55 16 8 16.45 8 17C8 18.1 7.1 19 6 19C5.83 19 5.67 18.98 5.5 18.95C5.81 18.4 6 17.74 6 17C6 16.45 6.45 16 7 16ZM18.67 3C18.41 3 18.16 3.1 17.96 3.29L9 12.25L11.75 15L20.71 6.04C21.1 5.65 21.1 5.02 20.71 4.63L19.37 3.29C19.17 3.09 18.92 3 18.67 3V3ZM7 14C5.34 14 4 15.34 4 17C4 18.31 2.84 19 2 19C2.92 20.22 4.49 21 6 21C8.21 21 10 19.21 10 17C10 15.34 8.66 14 7 14Z",
    fill: "currentColor"
  })));
}, "IconBrush");
import j9 from "classnames";
var Y9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBubbleChart } from '@aws-amplify/ui-react'; \u2192 import { MdBubbleChart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: j9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 10C4.79 10 3 11.79 3 14C3 16.21 4.79 18 7 18C9.21 18 11 16.21 11 14C11 11.79 9.21 10 7 10ZM7 16C5.9 16 5 15.1 5 14C5 12.9 5.9 12 7 12C8.1 12 9 12.9 9 14C9 15.1 8.1 16 7 16ZM15.01 15C13.36 15 12.01 16.35 12.01 18C12.01 19.65 13.36 21 15.01 21C16.66 21 18.01 19.65 18.01 18C18.01 16.35 16.66 15 15.01 15V15ZM15.01 19C14.46 19 14.01 18.55 14.01 18C14.01 17.45 14.46 17 15.01 17C15.56 17 16.01 17.45 16.01 18C16.01 18.55 15.56 19 15.01 19V19ZM16.5 3C13.47 3 11 5.47 11 8.5C11 11.53 13.47 14 16.5 14C19.53 14 22 11.53 22 8.5C22 5.47 19.53 3 16.5 3ZM16.5 12C14.57 12 13 10.43 13 8.5C13 6.57 14.57 5 16.5 5C18.43 5 20 6.57 20 8.5C20 10.43 18.43 12 16.5 12Z",
    fill: "currentColor"
  })));
}, "IconBubbleChart");
import F9 from "classnames";
var T9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBugReport } from '@aws-amplify/ui-react'; \u2192 import { MdBugReport } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: F9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 8H17.19C16.74 7.22 16.12 6.55 15.37 6.04L17 4.41L15.59 3L13.42 5.17C12.96 5.06 12.49 5 12 5C11.51 5 11.04 5.06 10.59 5.17L8.41 3L7 4.41L8.62 6.04C7.88 6.55 7.26 7.22 6.81 8H4V10H6.09C6.04 10.33 6 10.66 6 11V12H4V14H6V15C6 15.34 6.04 15.67 6.09 16H4V18H6.81C7.85 19.79 9.78 21 12 21C14.22 21 16.15 19.79 17.19 18H20V16H17.91C17.96 15.67 18 15.34 18 15V14H20V12H18V11C18 10.66 17.96 10.33 17.91 10H20V8ZM16 12V15C16 15.22 15.97 15.47 15.93 15.7L15.83 16.35L15.46 17C14.74 18.24 13.42 19 12 19C10.58 19 9.26 18.23 8.54 17L8.17 16.36L8.07 15.71C8.03 15.48 8 15.23 8 15V11C8 10.77 8.03 10.52 8.07 10.3L8.17 9.65L8.54 9C8.84 8.48 9.26 8.03 9.75 7.69L10.32 7.3L11.06 7.12C11.37 7.04 11.69 7 12 7C12.32 7 12.63 7.04 12.95 7.12L13.63 7.28L14.24 7.7C14.74 8.04 15.15 8.48 15.45 9.01L15.83 9.66L15.93 10.31C15.97 10.53 16 10.78 16 11V12ZM10 14H14V16H10V14ZM10 10H14V12H10V10Z",
    fill: "currentColor"
  })));
}, "IconBugReport");
import A9 from "classnames";
var E9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBuildCircle } from '@aws-amplify/ui-react'; \u2192 import { MdBuildCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: A9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.49 11.3798C13.92 10.1598 13.66 8.73984 12.68 7.75984C11.57 6.64984 9.88999 6.45984 8.57999 7.16984L10.93 9.51984L9.51999 10.9298L7.16999 8.57984C6.45999 9.89984 6.64999 11.5698 7.75999 12.6798C8.73999 13.6598 10.16 13.9198 11.38 13.4898L14.79 16.8998C14.99 17.0998 15.3 17.0998 15.5 16.8998L16.9 15.4998C17.1 15.2998 17.1 14.9898 16.9 14.7898L13.49 11.3798Z",
    fill: "black"
  })));
}, "IconBuildCircle");
import O9 from "classnames";

var _9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBuild } from '@aws-amplify/ui-react'; \u2192 import { MdBuild } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: O9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22.61 18.99L13.53 9.90997C14.46 7.56997 13.98 4.80997 12.09 2.90997C9.78999 0.609971 6.20999 0.399971 3.65999 2.25997L7.49999 6.10997L6.07999 7.51997L2.24999 3.68997C0.389992 6.22997 0.599992 9.81997 2.89999 12.11C4.75999 13.97 7.46999 14.46 9.78999 13.59L18.9 22.7C19.29 23.09 19.92 23.09 20.31 22.7L22.61 20.4C23.01 20.02 23.01 19.39 22.61 18.99ZM19.61 20.59L10.15 11.13C9.53999 11.58 8.85999 11.85 8.14999 11.95C6.78999 12.15 5.35999 11.74 4.31999 10.7C3.36999 9.75997 2.92999 8.49997 2.99999 7.25997L6.08999 10.35L10.33 6.10997L7.23999 3.01997C8.47999 2.94997 9.72999 3.38997 10.68 4.32997C11.76 5.40997 12.17 6.89997 11.92 8.28997C11.8 8.99997 11.5 9.65997 11.04 10.25L20.49 19.7L19.61 20.59Z",
    fill: "currentColor"
  })));
}, "IconBuild");

import G9 from "classnames";
var U9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBurstMode } from '@aws-amplify/ui-react'; \u2192 import { MdBurstMode } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: G9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1 5H3V19H1V5ZM5 5H7V19H5V5ZM22 5H10C9.45 5 9 5.45 9 6V18C9 18.55 9.45 19 10 19H22C22.55 19 23 18.55 23 18V6C23 5.45 22.55 5 22 5ZM21 17H11V7H21V17ZM17.43 12.62L15.43 15.19L14 13.47L12 15.99H20L17.43 12.62Z",
    fill: "currentColor"
  })));
}, "IconBurstMode");
import z9 from "classnames";
var X9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBusinessCenter } from '@aws-amplify/ui-react'; \u2192 import { MdBusinessCenter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: z9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 7H16V5L14 3H10L8 5V7H4C2.9 7 2 7.9 2 9V14C2 14.75 2.4 15.38 3 15.73V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V15.72C21.59 15.37 22 14.73 22 14V9C22 7.9 21.1 7 20 7ZM10 5H14V7H10V5ZM4 9H20V14H15V11H9V14H4V9ZM13 15H11V13H13V15ZM19 19H5V16H9V17H15V16H19V19Z",
    fill: "currentColor"
  })));
}, "IconBusinessCenter");
import K9 from "classnames";
var q9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconBusiness } from '@aws-amplify/ui-react'; \u2192 import { MdBusiness } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: K9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z",
    fill: "currentColor"
  })));
}, "IconBusiness");
import Q9 from "classnames";
var J9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCached } from '@aws-amplify/ui-react'; \u2192 import { MdCached } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Q9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 8L15 12H18C18 15.31 15.31 18 12 18C10.99 18 10.03 17.75 9.2 17.3L7.74 18.76C8.97 19.54 10.43 20 12 20C16.42 20 20 16.42 20 12H23L19 8ZM6 12C6 8.69 8.69 6 12 6C13.01 6 13.97 6.25 14.8 6.7L16.26 5.24C15.03 4.46 13.57 4 12 4C7.58 4 4 7.58 4 12H1L5 16L9 12H6Z",
    fill: "currentColor"
  })));
}, "IconCached");
import $9 from "classnames";
var R9 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCake } from '@aws-amplify/ui-react'; \u2192 import { MdCake } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $9(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C13.11 6 14 5.1 14 4C14 3.62 13.9 3.27 13.71 2.97L12 0L10.29 2.97C10.1 3.27 10 3.62 10 4C10 5.1 10.9 6 12 6ZM18 9H13V7H11V9H6C4.34 9 3 10.34 3 12V21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21V12C21 10.34 19.66 9 18 9ZM19 20H5V17C5.9 16.99 6.76 16.63 7.4 15.99L8.49 14.92L9.56 15.99C10.87 17.3 13.15 17.29 14.45 15.99L15.53 14.92L16.6 15.99C17.24 16.63 18.1 16.99 19 17V20V20ZM19 15.5C18.49 15.49 18.01 15.3 17.65 14.93L15.52 12.8L13.38 14.93C12.64 15.67 11.35 15.67 10.61 14.93L8.48 12.8L6.34 14.93C5.99 15.29 5.51 15.49 5 15.5V12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12V15.5Z",
    fill: "currentColor"
  })));
}, "IconCake");
import e0 from "classnames";
var o0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCalculate } from '@aws-amplify/ui-react'; \u2192 import { MdCalculate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: e0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M11.25 7.71997H6.25V9.21997H11.25V7.71997Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18 15.75H13V17.25H18V15.75Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18 13.25H13V14.75H18V13.25Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M8 18H9.5V16H11.5V14.5H9.5V12.5H8V14.5H6V16H8V18Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14.09 10.95L15.5 9.54L16.91 10.95L17.97 9.89L16.56 8.47L17.97 7.06L16.91 6L15.5 7.41L14.09 6L13.03 7.06L14.44 8.47L13.03 9.89L14.09 10.95Z",
    fill: "black"
  })));
}, "IconCalculate");
import t0 from "classnames";
var r0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCalendarToday } from '@aws-amplify/ui-react'; \u2192 import { MdCalendarToday } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: t0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V10H20V21ZM20 8H4V5H20V8Z",
    fill: "currentColor"
  })));
}, "IconCalendarToday");
import i0 from "classnames";
var s0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCalendarViewDay } from '@aws-amplify/ui-react'; \u2192 import { MdCalendarViewDay } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: i0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 17H21V19H3V17ZM19 12V13H5V12H19ZM21 10H3V15H21V10ZM3 6H21V8H3V6Z",
    fill: "currentColor"
  })));
}, "IconCalendarViewDay");
import a0 from "classnames";
var n0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCallEnd } from '@aws-amplify/ui-react'; \u2192 import { MdCallEnd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: a0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.59 10.52C19.64 11.03 20.63 11.67 21.55 12.43L20.48 13.5C19.9 13.03 19.27 12.61 18.6 12.23V10.52H18.59ZM5.4 10.52V12.22C4.75 12.59 4.12 13.01 3.53 13.49L2.46 12.42C3.37 11.67 4.36 11.04 5.4 10.52V10.52ZM12 7C7.46 7 3.34 8.78 0.29 11.67C0.11 11.85 0 12.1 0 12.38C0 12.66 0.11 12.91 0.29 13.08L2.77 15.56C2.95 15.74 3.2 15.85 3.48 15.85C3.75 15.85 4 15.75 4.18 15.57C4.97 14.84 5.86 14.21 6.84 13.72C7.17 13.56 7.4 13.21 7.4 12.82V9.72C8.85 9.25 10.4 9 12 9C13.6 9 15.15 9.25 16.59 9.73V12.83C16.59 13.23 16.82 13.57 17.15 13.73C18.13 14.22 19.03 14.84 19.82 15.58C20 15.75 20.25 15.86 20.52 15.86C20.8 15.86 21.05 15.75 21.23 15.57L23.71 13.09C23.89 12.91 24 12.66 24 12.38C24 12.1 23.89 11.85 23.71 11.67C20.66 8.78 16.54 7 12 7Z",
    fill: "currentColor"
  })));
}, "IconCallEnd");
import m0 from "classnames";
var c0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCallMade } from '@aws-amplify/ui-react'; \u2192 import { MdCallMade } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: m0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 5V7H15.59L4 18.59L5.41 20L17 8.41V15H19V5H9Z",
    fill: "currentColor"
  })));
}, "IconCallMade");
import l0 from "classnames";
var p0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCallMerge } from '@aws-amplify/ui-react'; \u2192 import { MdCallMerge } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: l0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 20.41L18.41 19L15 15.59L13.59 17L17 20.41ZM7.49997 8H11V13.59L5.58997 19L6.99997 20.41L13 14.41V8H16.5L12 3.5L7.49997 8Z",
    fill: "currentColor"
  })));
}, "IconCallMerge");
import h0 from "classnames";
var f0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCallMissedOutgoing } from '@aws-amplify/ui-react'; \u2192 import { MdCallMissedOutgoing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: h0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 8.41L12 17.41L19 10.41V15H21V7H13V9H17.59L12 14.59L4.41 7L3 8.41Z",
    fill: "currentColor"
  })));
}, "IconCallMissedOutgoing");
import C0 from "classnames";
var g0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCallMissed } from '@aws-amplify/ui-react'; \u2192 import { MdCallMissed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: C0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.59 7L12 14.59L6.41 9H11V7H3V15H5V10.41L12 17.41L21 8.41L19.59 7Z",
    fill: "currentColor"
  })));
}, "IconCallMissed");
import u0 from "classnames";
var w0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCallReceived } from '@aws-amplify/ui-react'; \u2192 import { MdCallReceived } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: u0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 5.41L18.59 4L7 15.59V9H5V19H15V17H8.41L20 5.41Z",
    fill: "currentColor"
  })));
}, "IconCallReceived");
import d0 from "classnames";
var V0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCallSplit } from '@aws-amplify/ui-react'; \u2192 import { MdCallSplit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: d0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 4L16.29 6.29L13.41 9.17L14.83 10.59L17.71 7.71L20 10V4H14ZM10 4H4V10L6.29 7.71L11 12.41V20H13V11.59L7.71 6.29L10 4Z",
    fill: "currentColor"
  })));
}, "IconCallSplit");
import H0 from "classnames";
var M0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCallToAction } from '@aws-amplify/ui-react'; \u2192 import { MdCallToAction } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: H0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM5 15H19V18H5V15Z",
    fill: "currentColor"
  })));
}, "IconCallToAction");
import x0 from "classnames";
var I0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCall } from '@aws-amplify/ui-react'; \u2192 import { MdCall } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: x0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54V5ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02V17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z",
    fill: "currentColor"
  })));
}, "IconCall");
import L0 from "classnames";
var v0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCameraAlt } from '@aws-amplify/ui-react'; \u2192 import { MdCameraAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: L0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H16.83L15 2H9L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H8.05L9.88 4H14.12L15.95 6H20V18ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15Z",
    fill: "currentColor"
  })));
}, "IconCameraAlt");
import N0 from "classnames";
var y0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCameraEnhance } from '@aws-amplify/ui-react'; \u2192 import { MdCameraEnhance } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: N0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 10L11.06 12.06L9 13L11.06 13.94L12 16L12.94 13.94L15 13L12.94 12.06L12 10ZM20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H8.05L8.64 6.35L9.88 5H14.12L15.36 6.35L15.95 7H20V19ZM12 8C9.24 8 7 10.24 7 13C7 15.76 9.24 18 12 18C14.76 18 17 15.76 17 13C17 10.24 14.76 8 12 8ZM12 16C10.35 16 9 14.65 9 13C9 11.35 10.35 10 12 10C13.65 10 15 11.35 15 13C15 14.65 13.65 16 12 16Z",
    fill: "currentColor"
  })));
}, "IconCameraEnhance");
import b0 from "classnames";
var Z0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCameraFront } from '@aws-amplify/ui-react'; \u2192 import { MdCameraFront } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: b0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 20V22H10V24L13 21L10 18V20H5ZM14 20H19V22H14V20ZM11.99 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 11.99 4C10.88 4 10 4.9 10 6C10 7.1 10.89 8 11.99 8ZM17 0H7C5.9 0 5 0.9 5 2V16C5 17.1 5.9 18 7 18H17C18.1 18 19 17.1 19 16V2C19 0.9 18.1 0 17 0ZM17 16H7V14H17V16ZM17 12.5C17 10.83 13.67 10 12 10C10.33 10 7 10.83 7 12.5V2H17V12.5Z",
    fill: "currentColor"
  })));
}, "IconCameraFront");
import B0 from "classnames";
var W0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCameraRear } from '@aws-amplify/ui-react'; \u2192 import { MdCameraRear } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: B0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 20V22H10V24L13 21L10 18V20H5ZM14 20H19V22H14V20ZM17 0H7C5.9 0 5 0.9 5 2V16C5 17.1 5.9 18 7 18H17C18.1 18 19 17.1 19 16V2C19 0.9 18.1 0 17 0ZM17 16H7V2H17V16ZM12 7C13.1 7 14 6.1 13.99 5C13.99 3.9 13.09 3 11.99 3C10.89 3 10 3.9 10 5C10 6.1 10.89 7 12 7Z",
    fill: "currentColor"
  })));
}, "IconCameraRear");
import k0 from "classnames";
var D0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCameraRoll } from '@aws-amplify/ui-react'; \u2192 import { MdCameraRoll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: k0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 5C14 3.9 13.1 3 12 3H11V2C11 1.45 10.55 1 10 1H6C5.45 1 5 1.45 5 2V3H4C2.9 3 2 3.9 2 5V20C2 21.1 2.9 22 4 22H12C13.1 22 14 21.1 14 20H22V5H14ZM20 18H12V20H4V5H7V3H9V5H12V7H20V18ZM9 15H11V17H9V15ZM9 8H11V10H9V8ZM13 15H15V17H13V15ZM13 8H15V10H13V8ZM17 15H19V17H17V15ZM17 8H19V10H17V8Z",
    fill: "currentColor"
  })));
}, "IconCameraRoll");
import P0 from "classnames";
var S0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCamera } from '@aws-amplify/ui-react'; \u2192 import { MdCamera } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: P0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.25 2.26L14.17 2.22L14.16 2.24C13.46 2.09 12.74 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 7.25 18.69 3.28 14.25 2.26ZM19.41 9H11.42L14.13 4.3C16.53 4.96 18.48 6.72 19.41 9ZM13.1 4.08L10.27 9L9.12 11L6.4 6.3C7.84 4.88 9.82 4 12 4C12.37 4 12.74 4.03 13.1 4.08ZM5.7 7.09L8.54 12L9.69 14H4.26C4.1 13.36 4 12.69 4 12C4 10.15 4.64 8.45 5.7 7.09ZM4.59 15H12.57L9.86 19.7C7.46 19.03 5.52 17.28 4.59 15ZM10.9 19.91L14.89 13L17.61 17.7C16.16 19.12 14.18 20 12 20C11.62 20 11.26 19.96 10.9 19.91V19.91ZM18.3 16.91L14.3 10H19.73C19.9 10.64 20 11.31 20 12C20 13.85 19.36 15.55 18.3 16.91Z",
    fill: "currentColor"
  })));
}, "IconCamera");
import j0 from "classnames";
var Y0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCampaign } from '@aws-amplify/ui-react'; \u2192 import { MdCampaign } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: j0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 11C18 11.67 18 12.33 18 13C19.2 13 20.76 13 22 13C22 12.33 22 11.67 22 11C20.76 11 19.2 11 18 11Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M16 17.61C16.96 18.32 18.21 19.26 19.2 20C19.6 19.47 20 18.93 20.4 18.4C19.41 17.66 18.16 16.72 17.2 16C16.8 16.54 16.4 17.08 16 17.61Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M20.4 5.6C20 5.07 19.6 4.53 19.2 4C18.21 4.74 16.96 5.68 16 6.4C16.4 6.93 16.8 7.47 17.2 8C18.16 7.28 19.41 6.35 20.4 5.6Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M4 9C2.9 9 2 9.9 2 11V13C2 14.1 2.9 15 4 15H5V19H7V15H8L13 18V6L8 9H4ZM9.03 10.71L11 9.53V14.47L9.03 13.29L8.55 13H8H4V11H8H8.55L9.03 10.71Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15.5 11.9999C15.5 10.6699 14.92 9.4699 14 8.6499V15.3399C14.92 14.5299 15.5 13.3299 15.5 11.9999Z",
    fill: "black"
  })));
}, "IconCampaign");
import F0 from "classnames";
var T0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCancelPresentation } from '@aws-amplify/ui-react'; \u2192 import { MdCancelPresentation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: F0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM9.41 15.95L12 13.36L14.59 15.95L16 14.54L13.41 11.95L16 9.36L14.59 7.95L12 10.54L9.41 7.95L8 9.36L10.59 11.95L8 14.54L9.41 15.95Z",
    fill: "currentColor"
  })));
}, "IconCancelPresentation");
import A0 from "classnames";
var E0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCancelScheduleSend } from '@aws-amplify/ui-react'; \u2192 import { MdCancelScheduleSend } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: A0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.5 9C16.08 9 15.67 9.04 15.26 9.11L1.01 3L1 10L11.06 11.34C10.64 11.78 10.28 12.27 9.97 12.8L1 14L1.01 21L9.08 17.54C9.59 21.19 12.71 24 16.5 24C20.64 24 24 20.64 24 16.5C24 12.36 20.64 9 16.5 9ZM3 8.25L3.01 6.03L10.52 9.25L3 8.25ZM9.1 15.36L3 17.97V15.75L9.17 14.93C9.14 15.07 9.12 15.21 9.1 15.36ZM16.5 22C13.47 22 11 19.53 11 16.5C11 13.47 13.47 11 16.5 11C19.53 11 22 13.47 22 16.5C22 19.53 19.53 22 16.5 22Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18.27 14.0298L16.5 15.7898L14.73 14.0298L14.03 14.7298L15.79 16.4998L14.03 18.2698L14.73 18.9698L16.5 17.2098L18.27 18.9698L18.97 18.2698L17.21 16.4998L18.97 14.7298L18.27 14.0298Z",
    fill: "black"
  })));
}, "IconCancelScheduleSend");
import O0 from "classnames";

var _0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCancel } from '@aws-amplify/ui-react'; \u2192 import { MdCancel } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: O0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17L17 15.59L13.41 12L17 8.41L15.59 7Z",
    fill: "currentColor"
  })));
}, "IconCancel");

import G0 from "classnames";
var U0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCardGiftcard } from '@aws-amplify/ui-react'; \u2192 import { MdCardGiftcard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: G0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H17.82C17.93 5.69 18 5.35 18 5C18 3.34 16.66 2 15 2C13.95 2 13.04 2.54 12.5 3.35L12 4.02L11.5 3.34C10.96 2.54 10.05 2 9 2C7.34 2 6 3.34 6 5C6 5.35 6.07 5.69 6.18 6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM15 4C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4ZM9 4C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6C8.45 6 8 5.55 8 5C8 4.45 8.45 4 9 4ZM20 19H4V17H20V19ZM20 14H4V8H9.08L7 10.83L8.62 12L12 7.4L15.38 12L17 10.83L14.92 8H20V14Z",
    fill: "currentColor"
  })));
}, "IconCardGiftcard");
import z0 from "classnames";
var X0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCardMembership } from '@aws-amplify/ui-react'; \u2192 import { MdCardMembership } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: z0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM20 10H4V4H20V10Z",
    fill: "currentColor"
  })));
}, "IconCardMembership");
import K0 from "classnames";
var q0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCardTravel } from '@aws-amplify/ui-react'; \u2192 import { MdCardTravel } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: K0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H17V4C17 2.89 16.11 2 15 2H9C7.89 2 7 2.89 7 4V6H4C2.89 6 2 6.89 2 8V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM9 4H15V6H9V4ZM20 19H4V17H20V19ZM20 14H4V8H7V10H9V8H15V10H17V8H20V14Z",
    fill: "currentColor"
  })));
}, "IconCardTravel");
import Q0 from "classnames";
var J0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCarpenter } from '@aws-amplify/ui-react'; \u2192 import { MdCarpenter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Q0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.7299 14.23L6.99986 1.5L3.10986 5.39L11.2399 17.06C10.4599 17.84 10.4599 19.11 11.2399 19.89L12.6499 21.3C13.4299 22.08 14.6999 22.08 15.4799 21.3L19.7199 17.06C20.5099 16.28 20.5099 15.01 19.7299 14.23ZM5.70986 5.62L6.99986 4.33L15.4899 12.82L12.6799 15.63L5.70986 5.62ZM14.0699 19.88L12.6599 18.47L16.8999 14.23L18.3099 15.64L14.0699 19.88Z",
    fill: "currentColor"
  })));
}, "IconCarpenter");
import $0 from "classnames";
var R0 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCasino } from '@aws-amplify/ui-react'; \u2192 import { MdCasino } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $0(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7.5 9C8.32843 9 9 8.32843 9 7.5C9 6.67157 8.32843 6 7.5 6C6.67157 6 6 6.67157 6 7.5C6 8.32843 6.67157 9 7.5 9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 9C17.3284 9 18 8.32843 18 7.5C18 6.67157 17.3284 6 16.5 6C15.6716 6 15 6.67157 15 7.5C15 8.32843 15.6716 9 16.5 9Z",
    fill: "black"
  })));
}, "IconCasino");
import el from "classnames";
var ol = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCastConnected } from '@aws-amplify/ui-react'; \u2192 import { MdCastConnected } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: el(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10ZM21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM5 7V9H17V15H14V17H19V7H5Z",
    fill: "currentColor"
  })));
}, "IconCastConnected");
import tl from "classnames";
var rl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCastForEducation } from '@aws-amplify/ui-react'; \u2192 import { MdCastForEducation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10ZM11 11.09V13.09L14.5 15L18 13.09V11.09L14.5 13L11 11.09ZM14.5 6L9 9L14.5 12L20 9L14.5 6Z",
    fill: "currentColor"
  })));
}, "IconCastForEducation");
import il from "classnames";
var sl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCast } from '@aws-amplify/ui-react'; \u2192 import { MdCast } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: il(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V8H3V5H21V19H14V21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM1 18V21H4C4 19.34 2.66 18 1 18ZM1 14V16C3.76 16 6 18.24 6 21H8C8 17.13 4.87 14 1 14ZM1 10V12C5.97 12 10 16.03 10 21H12C12 14.92 7.07 10 1 10Z",
    fill: "currentColor"
  })));
}, "IconCast");
import al from "classnames";
var nl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCategory } from '@aws-amplify/ui-react'; \u2192 import { MdCategory } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: al(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2L6.5 11H17.5L12 2ZM12 5.84L13.93 9H10.06L12 5.84ZM17.5 13C15.01 13 13 15.01 13 17.5C13 19.99 15.01 22 17.5 22C19.99 22 22 19.99 22 17.5C22 15.01 19.99 13 17.5 13ZM17.5 20C16.12 20 15 18.88 15 17.5C15 16.12 16.12 15 17.5 15C18.88 15 20 16.12 20 17.5C20 18.88 18.88 20 17.5 20ZM3 21.5H11V13.5H3V21.5ZM5 15.5H9V19.5H5V15.5Z",
    fill: "currentColor"
  })));
}, "IconCategory");
import ml from "classnames";
var cl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCenterFocusStrong } from '@aws-amplify/ui-react'; \u2192 import { MdCenterFocusStrong } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ml(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12ZM12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15ZM5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM5 5H9V3H5C3.9 3 3 3.9 3 5V9H5V5ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19Z",
    fill: "currentColor"
  })));
}, "IconCenterFocusStrong");
import ll from "classnames";
var pl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCenterFocusWeak } from '@aws-amplify/ui-react'; \u2192 import { MdCenterFocusWeak } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ll(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM5 5H9V3H5C3.9 3 3 3.9 3 5V9H5V5ZM12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19Z",
    fill: "currentColor"
  })));
}, "IconCenterFocusWeak");
import hl from "classnames";
var fl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconChangeHistory } from '@aws-amplify/ui-react'; \u2192 import { MdChangeHistory } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 7.77L18.39 18H5.61L12 7.77ZM12 4L2 20H22L12 4Z",
    fill: "currentColor"
  })));
}, "IconChangeHistory");
import Cl from "classnames";
var gl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconChargingStation } from '@aws-amplify/ui-react'; \u2192 import { MdChargingStation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.5 11L11.5 17V13H9.5L12.5 7V11H14.5ZM17 3H7V4H17V3ZM17 20H7V21H17V20ZM17 1C18.1 1 19 1.9 19 3V21C19 22.1 18.1 23 17 23H7C5.9 23 5 22.1 5 21V3C5 1.9 5.9 1 7 1H17ZM7 18H17V6H7V18Z",
    fill: "currentColor"
  })));
}, "IconChargingStation");
import ul from "classnames";
var wl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconChatBubbleOutline } from '@aws-amplify/ui-react'; \u2192 import { MdChatBubbleOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ul(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z",
    fill: "currentColor"
  })));
}, "IconChatBubbleOutline");
import dl from "classnames";
var Vl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconChatBubble } from '@aws-amplify/ui-react'; \u2192 import { MdChatBubble } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z",
    fill: "currentColor"
  })));
}, "IconChatBubble");
import Hl from "classnames";
var Ml = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconChat } from '@aws-amplify/ui-react'; \u2192 import { MdChat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 4H20V16H5.17L4 17.17V4ZM4 2C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H4ZM6 12H14V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z",
    fill: "currentColor"
  })));
}, "IconChat");
import xl from "classnames";
var Il = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCheckBoxOutlineBlank } from '@aws-amplify/ui-react'; \u2192 import { MdCheckBoxOutlineBlank } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
    fill: "currentColor"
  })));
}, "IconCheckBoxOutlineBlank");
import Ll from "classnames";
var vl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCheckBox } from '@aws-amplify/ui-react'; \u2192 import { MdCheckBox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ll(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM17.99 9L16.58 7.58L9.99 14.17L7.41 11.6L5.99 13.01L9.99 17L17.99 9Z",
    fill: "currentColor"
  })));
}, "IconCheckBox");
import Nl from "classnames";
var yl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
    fill: "currentColor"
  })));
}, "IconCheckCircleOutline");
import bl from "classnames";
var yt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
    fill: "currentColor"
  })));
}, "IconCheckCircle");
import Zl from "classnames";
var bt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Zl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.00016 16.1698L4.83016 11.9998L3.41016 13.4098L9.00016 18.9998L21.0002 6.99984L19.5902 5.58984L9.00016 16.1698Z",
    fill: "currentColor"
  })));
}, "IconCheck");
import Bl from "classnames";
var Wl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCheckroom } from '@aws-amplify/ui-react'; \u2192 import { MdCheckroom } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.5998 18.2002L12.9998 11.7502V10.8402C14.6498 10.3502 15.7998 8.67016 15.4298 6.79016C15.1698 5.48016 14.1298 4.39016 12.8198 4.09016C10.5398 3.57016 8.49977 5.30016 8.49977 7.50016H10.4998C10.4998 6.67016 11.1698 6.00016 11.9998 6.00016C12.8298 6.00016 13.4998 6.67016 13.4998 7.50016C13.4998 8.34016 12.8098 9.02016 11.9698 9.00016C11.4298 8.99016 10.9998 9.45016 10.9998 9.99016V11.7502L2.39977 18.2002C1.62977 18.7802 2.03977 20.0002 2.99977 20.0002H11.9998H20.9998C21.9598 20.0002 22.3698 18.7802 21.5998 18.2002ZM5.99977 18.0002L11.9998 13.5002L17.9998 18.0002H5.99977Z",
    fill: "currentColor"
  })));
}, "IconCheckroom");
import kl from "classnames";
var Zt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z",
    fill: "currentColor"
  })));
}, "IconChevronLeft");
import Dl from "classnames";
var Bt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Dl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.99984 6L8.58984 7.41L13.1698 12L8.58984 16.59L9.99984 18L15.9998 12L9.99984 6Z",
    fill: "currentColor"
  })));
}, "IconChevronRight");
import Pl from "classnames";
var Sl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconChildCare } from '@aws-amplify/ui-react'; \u2192 import { MdChildCare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.5 11.75C15.1904 11.75 15.75 11.1904 15.75 10.5C15.75 9.80964 15.1904 9.25 14.5 9.25C13.8096 9.25 13.25 9.80964 13.25 10.5C13.25 11.1904 13.8096 11.75 14.5 11.75Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9.5 11.75C10.1904 11.75 10.75 11.1904 10.75 10.5C10.75 9.80964 10.1904 9.25 9.5 9.25C8.80964 9.25 8.25 9.80964 8.25 10.5C8.25 11.1904 8.80964 11.75 9.5 11.75Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M22.94 11.34C22.69 9.83 21.58 8.6 20.13 8.17C19.6 7.05 18.85 6.07 17.94 5.26C16.36 3.85 14.28 3 12 3C9.72 3 7.64 3.85 6.06 5.26C5.14 6.07 4.39 7.06 3.87 8.17C2.42 8.6 1.31 9.82 1.06 11.34C1.02 11.55 1 11.77 1 12C1 12.23 1.02 12.45 1.06 12.66C1.31 14.17 2.42 15.4 3.87 15.83C4.39 16.94 5.14 17.92 6.04 18.72C7.62 20.14 9.71 21 12 21C14.29 21 16.38 20.14 17.97 18.72C18.87 17.92 19.62 16.93 20.14 15.83C21.58 15.4 22.69 14.18 22.94 12.66C22.98 12.45 23 12.23 23 12C23 11.77 22.98 11.55 22.94 11.34V11.34ZM19 14C18.9 14 18.81 13.98 18.71 13.97C18.51 14.64 18.22 15.26 17.85 15.83C16.6 17.74 14.45 19 12 19C9.55 19 7.4 17.74 6.15 15.83C5.78 15.26 5.49 14.64 5.29 13.97C5.19 13.98 5.1 14 5 14C3.9 14 3 13.1 3 12C3 10.9 3.9 10 5 10C5.1 10 5.19 10.02 5.29 10.03C5.49 9.36 5.78 8.74 6.15 8.17C7.4 6.26 9.55 5 12 5C14.45 5 16.6 6.26 17.85 8.17C18.22 8.74 18.51 9.36 18.71 10.03C18.81 10.02 18.9 10 19 10C20.1 10 21 10.9 21 12C21 13.1 20.1 14 19 14ZM12 17C14.01 17 15.74 15.77 16.5 14H7.5C8.26 15.77 9.99 17 12 17Z",
    fill: "black"
  })));
}, "IconChildCare");
import jl from "classnames";
var Yl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconChildFriendly } from '@aws-amplify/ui-react'; \u2192 import { MdChildFriendly } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 2V10H21C21 5.58 17.42 2 13 2ZM15 8V4.34C16.7 4.94 18.05 6.29 18.66 8H15ZM6.44 11L5.49 9H2V11H4.22C4.22 11 6.11 15.07 6.34 15.42C5.24 16.01 4.5 17.17 4.5 18.5C4.5 20.43 6.07 22 8 22C9.76 22 11.22 20.7 11.46 19H13.54C13.78 20.7 15.24 22 17 22C18.93 22 20.5 20.43 20.5 18.5C20.5 17.46 20.04 16.53 19.32 15.89C20.37 14.54 21 12.84 21 11H6.44V11ZM8 20C7.17 20 6.5 19.33 6.5 18.5C6.5 17.67 7.17 17 8 17C8.83 17 9.5 17.67 9.5 18.5C9.5 19.33 8.83 20 8 20ZM17 20C16.17 20 15.5 19.33 15.5 18.5C15.5 17.67 16.17 17 17 17C17.83 17 18.5 17.67 18.5 18.5C18.5 19.33 17.83 20 17 20ZM17.74 14.66L17.45 15.03C17.31 15.01 17.15 15 17 15C15.61 15 14.4 15.82 13.84 17H11.16C10.66 15.96 9.66 15.2 8.48 15.03L8.04 14.36C7.94 14.19 7.7 13.67 7.37 13H18.66C18.45 13.59 18.14 14.15 17.74 14.66Z",
    fill: "currentColor"
  })));
}, "IconChildFriendly");
import Fl from "classnames";
var Tl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconChromeReaderMode } from '@aws-amplify/ui-react'; \u2192 import { MdChromeReaderMode } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 4H3C1.9 4 1 4.9 1 6V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V6C23 4.9 22.1 4 21 4ZM3 19V6H11V19H3ZM21 19H13V6H21V19ZM14 9.5H20V11H14V9.5ZM14 12H20V13.5H14V12ZM14 14.5H20V16H14V14.5Z",
    fill: "currentColor"
  })));
}, "IconChromeReaderMode");
import Al from "classnames";
var El = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconClass } from '@aws-amplify/ui-react'; \u2192 import { MdClass } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Al(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 4H11V9L10 8.25L9 9V4ZM18 20H6V4H7V13L10 10.75L13 13V4H18V20Z",
    fill: "currentColor"
  })));
}, "IconClass");
import Ol from "classnames";

var _l = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCleanHands } from '@aws-amplify/ui-react'; \u2192 import { MdCleanHands } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ol(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.99 5L17.62 6.37L18.99 7L17.62 7.63L16.99 9L16.36 7.63L14.99 7L16.36 6.37L16.99 5ZM20 14C21.1 14 22 13.1 22 12C22 10.9 20 8 20 8C20 8 18 10.9 18 12C18 13.1 18.9 14 20 14ZM11 6.1V4H13C13.57 4 14.1 4.17 14.55 4.45L15.98 3.02C15.15 2.39 14.13 2 13 2C11.53 2 7.56 2 7.5 2V4H9V6.11C7.22 6.48 5.8 7.79 5.25 9.5H7.41C7.94 8.61 8.89 8 10 8C11.62 8 12.94 9.29 12.99 10.9L15 11.65V11C15 8.58 13.28 6.56 11 6.1ZM22 19V20L14 22.5L7 20.56V22H1V11H8.97L15.13 13.3C16.25 13.72 17 14.8 17 16H19C20.66 16 22 17.34 22 19ZM5 20V13H3V20H5ZM19.9 18.57C19.74 18.24 19.39 18.01 19 18.01H13.65C13.11 18.01 12.58 17.92 12.07 17.75L9.69 16.96L10.32 15.06L12.7 15.85C13.01 15.95 15 16 15 16C15 15.63 14.77 15.3 14.43 15.17L8.61 13H7V18.48L13.97 20.41L19.9 18.57Z",
    fill: "currentColor"
  })));
}, "IconCleanHands");

import Gl from "classnames";
var Ul = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCleaningServices } from '@aws-amplify/ui-react'; \u2192 import { MdCleaningServices } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 11H15V3C15 1.9 14.1 1 13 1H11C9.9 1 9 1.9 9 3V11H8C5.24 11 3 13.24 3 16V23H21V16C21 13.24 18.76 11 16 11ZM11 3H13V11H11V3ZM19 21H17V18C17 17.45 16.55 17 16 17C15.45 17 15 17.45 15 18V21H13V18C13 17.45 12.55 17 12 17C11.45 17 11 17.45 11 18V21H9V18C9 17.45 8.55 17 8 17C7.45 17 7 17.45 7 18V21H5V16C5 14.35 6.35 13 8 13H16C17.65 13 19 14.35 19 16V21Z",
    fill: "currentColor"
  })));
}, "IconCleaningServices");
import zl from "classnames";
var Xl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconClearAll } from '@aws-amplify/ui-react'; \u2192 import { MdClearAll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 13H19V11H5V13ZM3 17H17V15H3V17ZM7 7V9H21V7H7Z",
    fill: "currentColor"
  })));
}, "IconClearAll");
import Kl from "classnames";
var ql = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconClear } from '@aws-amplify/ui-react'; \u2192 import { MdClear } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
    fill: "currentColor"
  })));
}, "IconClear");
import Ql from "classnames";
var Jl = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCloseFullscreen } from '@aws-amplify/ui-react'; \u2192 import { MdCloseFullscreen } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ql(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 3.41L16.71 8.7L20 12H12V4L15.29 7.29L20.59 2L22 3.41ZM3.41 22L8.7 16.71L12 20V12H4L7.29 15.29L2 20.59L3.41 22Z",
    fill: "currentColor"
  })));
}, "IconCloseFullscreen");
import $l from "classnames";

var _e = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $l(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
    fill: "currentColor"
  })));
}, "IconClose");

import Rl from "classnames";
var ep = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconClosedCaptionDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdClosedCaptionDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Rl(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 10.0001C13 9.45006 13.45 9.00006 14 9.00006H17C17.55 9.00006 18 9.45006 18 10.0001V11.0001H16.5V10.5001H14.5V11.5001L13 10.0001ZM16.5 13.5001L17.71 14.7101C17.89 14.5201 18 14.2701 18 14.0001V13.0001H16.5V13.5001ZM8.83001 6.00006H19V16.1701L20.98 18.1501C20.98 18.1001 21 18.0501 21 17.9901V6.00006C21 4.90006 20.1 4.00006 19 4.00006H6.83001L8.83001 6.00006ZM19.78 22.6101L17.17 20.0001H5.00001C3.89001 20.0001 3.00001 19.1001 3.00001 18.0001V6.00006C3.00001 5.95006 3.02001 5.90006 3.02001 5.85006L1.39001 4.22006L2.80001 2.81006L21.18 21.1901L19.78 22.6101ZM7.50001 13.5001H9.50001V13.0001H10.17L7.67001 10.5001H7.50001V13.5001ZM15.17 18.0001L11 13.8301V14.0001C11 14.5501 10.55 15.0001 10 15.0001H7.00001C6.45001 15.0001 6.00001 14.5501 6.00001 14.0001V10.0001C6.00001 9.68006 6.16001 9.41006 6.40001 9.22006L5.00001 7.83006V18.0001H15.17Z",
    fill: "currentColor"
  })));
}, "IconClosedCaptionDisabled");
import op from "classnames";
var tp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconClosedCaption } from '@aws-amplify/ui-react'; \u2192 import { MdClosedCaption } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: op(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM19 18H5V6H19V18ZM7 15H10C10.55 15 11 14.55 11 14V13H9.5V13.5H7.5V10.5H9.5V11H11V10C11 9.45 10.55 9 10 9H7C6.45 9 6 9.45 6 10V14C6 14.55 6.45 15 7 15ZM14 15H17C17.55 15 18 14.55 18 14V13H16.5V13.5H14.5V10.5H16.5V11H18V10C18 9.45 17.55 9 17 9H14C13.45 9 13 9.45 13 10V14C13 14.55 13.45 15 14 15Z",
    fill: "currentColor"
  })));
}, "IconClosedCaption");
import rp from "classnames";
var ip = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCloudCircle } from '@aws-amplify/ui-react'; \u2192 import { MdCloudCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.29 10.19C15.89 8.18 14.13 6.67 12 6.67C10.31 6.67 8.85 7.63 8.12 9.03C6.36 9.21 5 10.7 5 12.5C5 14.43 6.57 16 8.5 16H16.08C17.69 16 19 14.69 19 13.08C19 11.54 17.8 10.29 16.29 10.19ZM16 14H8.5C7.67 14 7 13.33 7 12.5C7 11.67 7.67 11 8.5 11H9.4L9.89 9.95C10.3 9.16 11.11 8.67 12 8.67C13.13 8.67 14.11 9.47 14.33 10.58L14.61 12H16C16.55 12 17 12.45 17 13C17 13.55 16.55 14 16 14Z",
    fill: "currentColor"
  })));
}, "IconCloudCircle");
import sp from "classnames";
var ap = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCloudDone } from '@aws-amplify/ui-react'; \u2192 import { MdCloudDone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18V18ZM10 14.18L7.91 12.09L6.5 13.5L10 17L16.01 10.99L14.6 9.58L10 14.18Z",
    fill: "currentColor"
  })));
}, "IconCloudDone");
import np from "classnames";
var mp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCloudDownload } from '@aws-amplify/ui-react'; \u2192 import { MdCloudDownload } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: np(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18V18ZM13.45 10H10.55V13H8L12 17L16 13H13.45V10Z",
    fill: "currentColor"
  })));
}, "IconCloudDownload");
import cp from "classnames";
var lp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCloudOff } from '@aws-amplify/ui-react'; \u2192 import { MdCloudOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M24 14.9999C24 12.3599 21.95 10.2199 19.35 10.0399C18.67 6.58986 15.64 3.99986 12 3.99986C10.67 3.99986 9.43 4.35986 8.35 4.96986L9.84 6.45986C10.51 6.16986 11.23 5.99986 12 5.99986C15.04 5.99986 17.5 8.45986 17.5 11.4999V11.9999H19C20.66 11.9999 22 13.3399 22 14.9999C22 15.9899 21.52 16.8499 20.79 17.3999L22.2 18.8099C23.29 17.8899 24 16.5399 24 14.9999V14.9999ZM4.41 3.85986L3 5.26986L5.77 8.03986H5.35C2.34 8.35986 0 10.9099 0 13.9999C0 17.3099 2.69 19.9999 6 19.9999H17.73L19.73 21.9999L21.14 20.5899L4.41 3.85986ZM6 17.9999C3.79 17.9999 2 16.2099 2 13.9999C2 11.7899 3.79 9.99986 6 9.99986H7.73L15.73 17.9999H6Z",
    fill: "currentColor"
  })));
}, "IconCloudOff");
import pp from "classnames";
var hp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCloudQueue } from '@aws-amplify/ui-react'; \u2192 import { MdCloudQueue } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.79 3.79 10 6 10H6.71C7.37 7.69 9.48 6 12 6C15.04 6 17.5 8.46 17.5 11.5V12H19C20.66 12 22 13.34 22 15C22 16.66 20.66 18 19 18Z",
    fill: "currentColor"
  })));
}, "IconCloudQueue");
import fp from "classnames";
var Cp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCloudUpload } from '@aws-amplify/ui-react'; \u2192 import { MdCloudUpload } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18V18ZM8 13H10.55V16H13.45V13H16L12 9L8 13Z",
    fill: "currentColor"
  })));
}, "IconCloudUpload");
import gp from "classnames";
var up = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCloud } from '@aws-amplify/ui-react'; \u2192 import { MdCloud } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C14.62 6 16.88 7.86 17.39 10.43L17.69 11.93L19.22 12.04C20.78 12.14 22 13.45 22 15C22 16.65 20.65 18 19 18H6C3.79 18 2 16.21 2 14C2 11.95 3.53 10.24 5.56 10.03L6.63 9.92L7.13 8.97C8.08 7.14 9.94 6 12 6ZM12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04C18.67 6.59 15.64 4 12 4Z",
    fill: "currentColor"
  })));
}, "IconCloud");
import wp from "classnames";
var dp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCode } from '@aws-amplify/ui-react'; \u2192 import { MdCode } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.4 16.6L4.8 12L9.4 7.4L8 6L2 12L8 18L9.4 16.6ZM14.6 16.6L19.2 12L14.6 7.4L16 6L22 12L16 18L14.6 16.6V16.6Z",
    fill: "currentColor"
  })));
}, "IconCode");
import Vp from "classnames";
var Hp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCollectionsBookmark } from '@aws-amplify/ui-react'; \u2192 import { MdCollectionsBookmark } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Vp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM17 4V9L16 8.25L15 9V4H17ZM20 16H8V4H13V13L16 10.75L19 13V4H20V16Z",
    fill: "currentColor"
  })));
}, "IconCollectionsBookmark");
import Mp from "classnames";
var xp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCollections } from '@aws-amplify/ui-react'; \u2192 import { MdCollections } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Mp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 11.67L13.19 13.93L15.67 10.83L19 15H9L11.5 11.67ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z",
    fill: "currentColor"
  })));
}, "IconCollections");
import Ip from "classnames";
var Lp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconColorLens } from '@aws-amplify/ui-react'; \u2192 import { MdColorLens } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ip(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.04 22 11C22 14.31 19.31 17 16 17H14.23C13.95 17 13.73 17.22 13.73 17.5C13.73 17.62 13.78 17.73 13.86 17.83C14.27 18.3 14.5 18.89 14.5 19.5C14.5 20.88 13.38 22 12 22V22ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C12.28 20 12.5 19.78 12.5 19.5C12.5 19.34 12.42 19.22 12.36 19.15C11.95 18.69 11.73 18.1 11.73 17.5C11.73 16.12 12.85 15 14.23 15H16C18.21 15 20 13.21 20 11C20 7.14 16.41 4 12 4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M6.5 13C7.32843 13 8 12.3284 8 11.5C8 10.6716 7.32843 10 6.5 10C5.67157 10 5 10.6716 5 11.5C5 12.3284 5.67157 13 6.5 13Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17.5 13C18.3284 13 19 12.3284 19 11.5C19 10.6716 18.3284 10 17.5 10C16.6716 10 16 10.6716 16 11.5C16 12.3284 16.6716 13 17.5 13Z",
    fill: "black"
  })));
}, "IconColorLens");
import vp from "classnames";
var Np = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconColorize } from '@aws-amplify/ui-react'; \u2192 import { MdColorize } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.66 5.41L18.58 6.33L15.89 9.02L14.97 8.1L17.66 5.41V5.41ZM17.67 3C17.41 3 17.16 3.1 16.96 3.29L13.84 6.41L11.91 4.5L10.5 5.91L11.92 7.33L3 16.25V21H7.75L16.67 12.08L18.09 13.5L19.5 12.09L17.58 10.17L20.7 7.05C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.1 17.92 3 17.67 3V3ZM6.92 19L5 17.08L13.06 9.02L14.98 10.94L6.92 19Z",
    fill: "currentColor"
  })));
}, "IconColorize");
import yp from "classnames";
var bp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCommentBank } from '@aws-amplify/ui-react'; \u2192 import { MdCommentBank } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 14V6H13V14L15.5 12.5L18 14Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z",
    fill: "black"
  })));
}, "IconCommentBank");
import Zp from "classnames";
var Bp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconComment } from '@aws-amplify/ui-react'; \u2192 import { MdComment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Zp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.99 4C21.99 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22L21.99 4ZM20 4V17.17L18.83 16H4V4H20ZM6 12H18V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z",
    fill: "currentColor"
  })));
}, "IconComment");
import Wp from "classnames";
var kp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCommute } from '@aws-amplify/ui-react'; \u2192 import { MdCommute } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Wp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4H5C3.34 4 2 5.34 2 7V15C2 16.66 3.34 18 5 18L4 19V20H5L7 18H9V13H4V6H13V8H15V7C15 5.34 13.66 4 12 4ZM5 14C5.55 14 6 14.45 6 15C6 15.55 5.55 16 5 16C4.45 16 4 15.55 4 15C4 14.45 4.45 14 5 14ZM20.57 9.66C20.43 9.26 20.05 9 19.6 9H12.41C11.95 9 11.58 9.26 11.43 9.66L10.01 13.77V19.28C10.01 19.66 10.32 20 10.7 20H11.32C11.7 20 12 19.62 12 19.24V18H20V19.24C20 19.62 20.31 20 20.69 20H21.3C21.68 20 21.99 19.66 21.99 19.28L22 17.91V13.77L20.57 9.66V9.66ZM12.41 10H19.6L20.63 13H11.38L12.41 10V10ZM12 16C11.45 16 11 15.55 11 15C11 14.45 11.45 14 12 14C12.55 14 13 14.45 13 15C13 15.55 12.55 16 12 16ZM20 16C19.45 16 19 15.55 19 15C19 14.45 19.45 14 20 14C20.55 14 21 14.45 21 15C21 15.55 20.55 16 20 16Z",
    fill: "currentColor"
  })));
}, "IconCommute");
import Dp from "classnames";
var Pp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCompareArrows } from '@aws-amplify/ui-react'; \u2192 import { MdCompareArrows } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Dp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.01 14H2V16H9.01V19L13 15L9.01 11V14ZM14.99 13V10H22V8H14.99V5L11 9L14.99 13Z",
    fill: "currentColor"
  })));
}, "IconCompareArrows");
import Sp from "classnames";
var jp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCompare } from '@aws-amplify/ui-react'; \u2192 import { MdCompare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Sp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H10V23H12V1H10V3ZM10 18H5L10 12V18ZM19 3H14V5H19V18L14 12V21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
    fill: "currentColor"
  })));
}, "IconCompare");
import Yp from "classnames";
var Fp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCompassCalibration } from '@aws-amplify/ui-react'; \u2192 import { MdCompassCalibration } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Yp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 12C9.24 12 7 14.24 7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17C17 14.24 14.76 12 12 12ZM12 20C10.35 20 9 18.65 9 17C9 15.35 10.35 14 12 14C13.65 14 15 15.35 15 17C15 18.65 13.65 20 12 20ZM12 3C8.1 3 4.56 4.59 2 7.15L7 12.15C8.28 10.87 10.05 10.07 12 10.07C13.95 10.07 15.72 10.86 17 12.14L22 7.14C19.44 4.59 15.9 3 12 3ZM16.84 9.47C15.4 8.56 13.74 8.07 12 8.07C10.26 8.07 8.59 8.56 7.15 9.48L4.94 7.26C6.99 5.79 9.44 5 12 5C14.56 5 17 5.79 19.05 7.26L16.84 9.47Z",
    fill: "currentColor"
  })));
}, "IconCompassCalibration");
import Tp from "classnames";
var Ap = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconComputer } from '@aws-amplify/ui-react'; \u2192 import { MdComputer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Tp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 18C21.1 18 21.99 17.1 21.99 16L22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V16C2 17.1 2.9 18 4 18H0V20H24V18H20ZM4 6H20V16H4V6Z",
    fill: "currentColor"
  })));
}, "IconComputer");
import Ep from "classnames";
var Op = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconConfirmationNumber } from '@aws-amplify/ui-react'; \u2192 import { MdConfirmationNumber } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ep(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 10V6C22 4.89 21.1 4 20 4H4C2.9 4 2.01 4.89 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM11 15H13V17H11V15ZM11 11H13V13H11V11ZM11 7H13V9H11V7Z",
    fill: "currentColor"
  })));
}, "IconConfirmationNumber");
import _p from "classnames";
var Gp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconConnectWithoutContact } from '@aws-amplify/ui-react'; \u2192 import { MdConnectWithoutContact } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _p(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 14H9C9 9.03 13.03 5 18 5V7C14.13 7 11 10.13 11 14ZM18 11V9C15.24 9 13 11.24 13 14H15C15 12.34 16.34 11 18 11ZM7 4C7 2.89 6.11 2 5 2C3.89 2 3 2.89 3 4C3 5.11 3.89 6 5 6C6.11 6 7 5.11 7 4ZM11.45 4.5H9.45C9.21 5.92 7.99 7 6.5 7H3.5C2.67 7 2 7.67 2 8.5V11H8V8.74C9.86 8.15 11.25 6.51 11.45 4.5ZM19 17C20.11 17 21 16.11 21 15C21 13.89 20.11 13 19 13C17.89 13 17 13.89 17 15C17 16.11 17.89 17 19 17ZM20.5 18H17.5C16.01 18 14.79 16.92 14.55 15.5H12.55C12.75 17.51 14.14 19.15 16 19.74V22H22V19.5C22 18.67 21.33 18 20.5 18Z",
    fill: "currentColor"
  })));
}, "IconConnectWithoutContact");
import Up from "classnames";
var zp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconConstruction } from '@aws-amplify/ui-react'; \u2192 import { MdConstruction } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Up(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.904 13.0506L13.7827 15.1719L19.7789 21.1681L21.9002 19.0468L15.904 13.0506Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M17.5001 10C19.4301 10 21.0001 8.43005 21.0001 6.50005C21.0001 5.92005 20.8401 5.38005 20.5901 4.90005L17.8901 7.60005L16.4001 6.11005L19.1001 3.41005C18.6201 3.16005 18.0801 3.00005 17.5001 3.00005C15.5701 3.00005 14.0001 4.57005 14.0001 6.50005C14.0001 6.91005 14.0801 7.30005 14.2101 7.66005L12.3601 9.51005L10.5801 7.73005L11.2901 7.02005L9.8801 5.61005L12.0001 3.49005C10.8301 2.32005 8.9301 2.32005 7.7601 3.49005L4.2201 7.03005L5.6301 8.44005H2.8101L2.1001 9.15005L5.6401 12.69L6.3501 11.98V9.15005L7.7601 10.56L8.4701 9.85005L10.2501 11.63L2.8401 19.0401L4.9601 21.16L16.3401 9.79005C16.7001 9.92005 17.0901 10 17.5001 10Z",
    fill: "black"
  })));
}, "IconConstruction");
import Xp from "classnames";
var Kp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContactMail } from '@aws-amplify/ui-react'; \u2192 import { MdContactMail } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Xp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM22 19H2V5H22V19ZM21 6H14V11H21V6ZM20 8L17.5 9.75L15 8V7L17.5 8.75L20 7V8ZM9 12C10.65 12 12 10.65 12 9C12 7.35 10.65 6 9 6C7.35 6 6 7.35 6 9C6 10.65 7.35 12 9 12ZM9 8C9.55 8 10 8.45 10 9C10 9.55 9.55 10 9 10C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8ZM15 16.59C15 14.09 11.03 13.01 9 13.01C6.97 13.01 3 14.09 3 16.59V18H15V16.59ZM5.48 16C6.22 15.5 7.7 15 9 15C10.3 15 11.77 15.49 12.52 16H5.48Z",
    fill: "currentColor"
  })));
}, "IconContactMail");
import qp from "classnames";
var Qp = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContactPage } from '@aws-amplify/ui-react'; \u2192 import { MdContactPage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13.17 4L18 8.83V20H6V4H13.17ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14ZM16 17.43C16 16.62 15.52 15.9 14.78 15.58C13.93 15.21 12.99 15 12 15C11.01 15 10.07 15.21 9.22 15.58C8.48 15.9 8 16.62 8 17.43V18H16V17.43Z",
    fill: "currentColor"
  })));
}, "IconContactPage");
import Jp from "classnames";
var $p = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContactPhone } from '@aws-amplify/ui-react'; \u2192 import { MdContactPhone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Jp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 3H2C0.9 3 0 3.9 0 5V19C0 20.1 0.9 21 2 21H22C23.1 21 23.99 20.1 23.99 19L24 5C24 3.9 23.1 3 22 3ZM22 19H2V5H22V19ZM19.01 17.99L21 16L19.49 14H17.85C17.63 13.37 17.5 12.7 17.5 12C17.5 11.3 17.63 10.63 17.85 10H19.49L21 8L19.01 6.01C17.7 6.99 16.73 8.38 16.28 10C16.1 10.64 16 11.31 16 12C16 12.69 16.1 13.36 16.28 14C16.73 15.61 17.7 17.01 19.01 17.99V17.99ZM9 12C10.65 12 12 10.65 12 9C12 7.35 10.65 6 9 6C7.35 6 6 7.35 6 9C6 10.65 7.35 12 9 12ZM9 8C9.55 8 10 8.45 10 9C10 9.55 9.55 10 9 10C8.45 10 8 9.55 8 9C8 8.45 8.45 8 9 8ZM15 16.59C15 14.09 11.03 13.01 9 13.01C6.97 13.01 3 14.09 3 16.59V18H15V16.59ZM5.48 16C6.22 15.5 7.7 15 9 15C10.3 15 11.77 15.49 12.52 16H5.48Z",
    fill: "currentColor"
  })));
}, "IconContactPhone");
import Rp from "classnames";
var e5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContactSupport } from '@aws-amplify/ui-react'; \u2192 import { MdContactSupport } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Rp(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 23.59V19.99C5.99 19.73 2 15.57 2 10.5C2 5.26 6.26 1 11.5 1C16.74 1 21 5.26 21 10.5C21 15.45 17.56 20.43 12.43 22.9L11 23.59ZM11.5 3C7.36 3 4 6.36 4 10.5C4 14.64 7.36 18 11.5 18H13V20.3C16.64 18 19 14.22 19 10.5C19 6.36 15.64 3 11.5 3ZM10.5 14.5H12.5V16.5H10.5V14.5ZM12.5 13H10.5C10.5 9.75 13.5 10 13.5 8C13.5 6.9 12.6 6 11.5 6C10.4 6 9.5 6.9 9.5 8H7.5C7.5 5.79 9.29 4 11.5 4C13.71 4 15.5 5.79 15.5 8C15.5 10.5 12.5 10.75 12.5 13Z",
    fill: "currentColor"
  })));
}, "IconContactSupport");
import o5 from "classnames";
var t5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContactless } from '@aws-amplify/ui-react'; \u2192 import { MdContactless } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: o5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.10001 10.1801C7.36001 10.7401 7.49001 11.3401 7.50001 11.9801C7.51001 12.6101 7.37001 13.2301 7.10001 13.8401L8.47001 14.4601C8.84001 13.6501 9.02001 12.8101 9.01001 11.9601C9.00001 11.1201 8.82001 10.3101 8.47001 9.56006L7.10001 10.1801Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13.33 7.33016C14.11 8.90016 14.51 10.4702 14.51 11.9702C14.51 13.4802 14.11 15.0602 13.33 16.6602L14.68 17.3202C15.56 15.5102 16.01 13.7102 16.01 11.9702C16.01 10.2302 15.56 8.44016 14.68 6.66016L13.33 7.33016Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10.2 8.7198C10.73 9.7898 11 10.9298 11 12.1198C11 13.2898 10.74 14.3498 10.22 15.2698L11.52 16.0098C12.17 14.8598 12.5 13.5598 12.5 12.1198C12.5 10.6998 12.18 9.3298 11.54 8.0498L10.2 8.7198Z",
    fill: "black"
  })));
}, "IconContactless");
import r5 from "classnames";
var i5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContacts } from '@aws-amplify/ui-react'; \u2192 import { MdContacts } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: r5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18ZM4 0H20V2H4V0ZM4 22H20V24H4V22ZM12 12C13.38 12 14.5 10.88 14.5 9.5C14.5 8.12 13.38 7 12 7C10.62 7 9.5 8.12 9.5 9.5C9.5 10.88 10.62 12 12 12ZM12 8.5C12.55 8.5 13 8.95 13 9.5C13 10.05 12.55 10.5 12 10.5C11.45 10.5 11 10.05 11 9.5C11 8.95 11.45 8.5 12 8.5ZM17 15.99C17 13.9 13.69 13 12 13C10.31 13 7 13.9 7 15.99V17H17V15.99ZM8.81 15.5C9.42 14.98 10.84 14.5 12 14.5C13.17 14.5 14.59 14.98 15.2 15.5H8.81Z",
    fill: "currentColor"
  })));
}, "IconContacts");
import s5 from "classnames";
var a5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContentCopy } from '@aws-amplify/ui-react'; \u2192 import { MdContentCopy } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: s5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z",
    fill: "currentColor"
  })));
}, "IconContentCopy");
import n5 from "classnames";
var m5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContentCut } from '@aws-amplify/ui-react'; \u2192 import { MdContentCut } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: n5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.64 7.64C9.87 7.14 10 6.59 10 6C10 3.79 8.21 2 6 2C3.79 2 2 3.79 2 6C2 8.21 3.79 10 6 10C6.59 10 7.14 9.87 7.64 9.64L10 12L7.64 14.36C7.14 14.13 6.59 14 6 14C3.79 14 2 15.79 2 18C2 20.21 3.79 22 6 22C8.21 22 10 20.21 10 18C10 17.41 9.87 16.86 9.64 16.36L12 14L19 21H22V20L9.64 7.64ZM6 8C4.9 8 4 7.11 4 6C4 4.89 4.9 4 6 4C7.1 4 8 4.89 8 6C8 7.11 7.1 8 6 8ZM6 20C4.9 20 4 19.11 4 18C4 16.89 4.9 16 6 16C7.1 16 8 16.89 8 18C8 19.11 7.1 20 6 20ZM12 12.5C11.72 12.5 11.5 12.28 11.5 12C11.5 11.72 11.72 11.5 12 11.5C12.28 11.5 12.5 11.72 12.5 12C12.5 12.28 12.28 12.5 12 12.5ZM19 3L13 9L15 11L22 4V3H19Z",
    fill: "currentColor"
  })));
}, "IconContentCut");
import c5 from "classnames";
var l5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconContentPaste } from '@aws-amplify/ui-react'; \u2192 import { MdContentPaste } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: c5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 2H14.82C14.4 0.84 13.3 0 12 0C10.7 0 9.6 0.84 9.18 2H5C3.9 2 3 2.9 3 4V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V4C21 2.9 20.1 2 19 2ZM12 2C12.55 2 13 2.45 13 3C13 3.55 12.55 4 12 4C11.45 4 11 3.55 11 3C11 2.45 11.45 2 12 2ZM19 20H5V4H7V7H17V4H19V20Z",
    fill: "currentColor"
  })));
}, "IconContentPaste");
import p5 from "classnames";
var h5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconControlCamera } from '@aws-amplify/ui-react'; \u2192 import { MdControlCamera } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: p5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5.54 8.46L2 12L5.54 15.54L7.3 13.77L5.54 12L7.3 10.23L5.54 8.46ZM12 18.46L10.23 16.7L8.46 18.46L12 22L15.54 18.46L13.77 16.7L12 18.46ZM18.46 8.46L16.7 10.23L18.46 12L16.7 13.77L18.46 15.54L22 12L18.46 8.46ZM8.46 5.54L10.23 7.3L12 5.54L13.77 7.3L15.54 5.54L12 2L8.46 5.54Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "black"
  })));
}, "IconControlCamera");
import f5 from "classnames";
var C5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconControlPointDuplicate } from '@aws-amplify/ui-react'; \u2192 import { MdControlPointDuplicate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: f5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 8H14V11H11V13H14V16H16V13H19V11H16V8ZM2 12C2 9.21 3.64 6.8 6.01 5.68V3.52C2.52 4.76 0 8.09 0 12C0 15.91 2.52 19.24 6.01 20.48V18.32C3.64 17.2 2 14.79 2 12ZM15 3C10.04 3 6 7.04 6 12C6 16.96 10.04 21 15 21C19.96 21 24 16.96 24 12C24 7.04 19.96 3 15 3ZM15 19C11.14 19 8 15.86 8 12C8 8.14 11.14 5 15 5C18.86 5 22 8.14 22 12C22 15.86 18.86 19 15 19Z",
    fill: "currentColor"
  })));
}, "IconControlPointDuplicate");
import g5 from "classnames";
var u5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconControlPoint } from '@aws-amplify/ui-react'; \u2192 import { MdControlPoint } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: g5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconControlPoint");
import w5 from "classnames";
var d5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCopyright } from '@aws-amplify/ui-react'; \u2192 import { MdCopyright } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: w5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.08 10.86C10.13 10.53 10.24 10.24 10.38 9.99C10.52 9.74 10.72 9.53 10.97 9.37C11.21 9.22 11.51 9.15 11.88 9.14C12.11 9.15 12.32 9.19 12.51 9.27C12.71 9.36 12.89 9.48 13.03 9.63C13.17 9.78 13.28 9.96 13.37 10.16C13.46 10.36 13.5 10.58 13.51 10.8H15.3C15.28 10.33 15.19 9.9 15.02 9.51C14.85 9.12 14.62 8.78 14.32 8.5C14.02 8.22 13.66 8 13.24 7.84C12.82 7.68 12.36 7.61 11.85 7.61C11.2 7.61 10.63 7.72 10.15 7.95C9.67 8.18 9.27 8.48 8.95 8.87C8.63 9.26 8.39 9.71 8.24 10.23C8.09 10.75 8 11.29 8 11.87V12.14C8 12.72 8.08 13.26 8.23 13.78C8.38 14.3 8.62 14.75 8.94 15.13C9.26 15.51 9.66 15.82 10.14 16.04C10.62 16.26 11.19 16.38 11.84 16.38C12.31 16.38 12.75 16.3 13.16 16.15C13.57 16 13.93 15.79 14.24 15.52C14.55 15.25 14.8 14.94 14.98 14.58C15.16 14.22 15.27 13.84 15.28 13.43H13.49C13.48 13.64 13.43 13.83 13.34 14.01C13.25 14.19 13.13 14.34 12.98 14.47C12.83 14.6 12.66 14.7 12.46 14.77C12.27 14.84 12.07 14.86 11.86 14.87C11.5 14.86 11.2 14.79 10.97 14.64C10.72 14.48 10.52 14.27 10.38 14.02C10.24 13.77 10.13 13.47 10.08 13.14C10.03 12.81 10 12.47 10 12.14V11.87C10 11.52 10.03 11.19 10.08 10.86V10.86ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconCopyright");
import V5 from "classnames";
var H5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCoronavirus } from '@aws-amplify/ui-react'; \u2192 import { MdCoronavirus } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: V5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.5 12C9.5 12.55 9.05 13 8.5 13C7.95 13 7.5 12.55 7.5 12C7.5 11.45 7.95 11 8.5 11C9.05 11 9.5 11.45 9.5 12ZM13.75 10C14.3 10 14.75 9.55 14.75 9C14.75 8.45 14.3 8 13.75 8C13.2 8 12.75 8.45 12.75 9C12.75 9.55 13.2 10 13.75 10ZM10.25 10C10.8 10 11.25 9.55 11.25 9C11.25 8.45 10.8 8 10.25 8C9.7 8 9.25 8.45 9.25 9C9.25 9.55 9.7 10 10.25 10ZM10.25 14C9.7 14 9.25 14.45 9.25 15C9.25 15.55 9.7 16 10.25 16C10.8 16 11.25 15.55 11.25 15C11.25 14.45 10.8 14 10.25 14ZM22 11.25V12.75C22 13.16 21.66 13.5 21.25 13.5C20.84 13.5 20.5 13.16 20.5 12.75H18.96C18.81 14.12 18.27 15.38 17.44 16.4L18.53 17.49L18.54 17.48C18.83 17.19 19.31 17.19 19.6 17.48C19.89 17.77 19.89 18.25 19.6 18.54L18.54 19.6C18.25 19.89 17.77 19.89 17.48 19.6C17.19 19.31 17.19 18.84 17.47 18.55L16.38 17.46C15.36 18.28 14.11 18.82 12.74 18.97V20.51H12.75C13.16 20.51 13.5 20.85 13.5 21.26C13.5 21.67 13.16 22.01 12.75 22.01H11.25C10.84 22.01 10.5 21.67 10.5 21.26C10.5 20.85 10.83 20.52 11.24 20.51V18.96C9.87 18.81 8.62 18.27 7.61 17.45L6.52 18.54L6.53 18.55C6.82 18.84 6.82 19.32 6.53 19.61C6.24 19.9 5.76 19.9 5.47 19.61L4.4 18.54C4.11 18.25 4.11 17.77 4.4 17.48C4.69 17.19 5.16 17.19 5.45 17.47L6.54 16.38C5.72 15.36 5.18 14.12 5.04 12.75H3.5C3.5 13.16 3.16 13.5 2.75 13.5C2.34 13.5 2 13.16 2 12.75V11.25C2 10.84 2.34 10.5 2.75 10.5C3.16 10.5 3.5 10.84 3.5 11.25H5.04C5.19 9.88 5.73 8.64 6.54 7.62L5.45 6.53C5.16 6.81 4.69 6.81 4.4 6.52C4.11 6.23 4.11 5.75 4.4 5.46L5.46 4.4C5.75 4.11 6.23 4.11 6.52 4.4C6.81 4.69 6.81 5.17 6.52 5.46L6.51 5.47L7.6 6.56C8.62 5.74 9.86 5.2 11.23 5.05V3.5C10.82 3.49 10.49 3.16 10.49 2.75C10.5 2.34 10.84 2 11.25 2H12.75C13.16 2 13.5 2.34 13.5 2.75C13.5 3.16 13.16 3.5 12.75 3.5H12.74V5.04C14.11 5.18 15.36 5.73 16.38 6.55L17.47 5.46C17.18 5.17 17.19 4.7 17.48 4.41C17.77 4.12 18.25 4.12 18.54 4.41L19.6 5.47C19.89 5.76 19.89 6.24 19.6 6.53C19.31 6.82 18.83 6.82 18.54 6.53L18.53 6.52L17.44 7.6C18.26 8.62 18.81 9.87 18.96 11.25H20.5C20.5 10.84 20.84 10.5 21.25 10.5C21.66 10.5 22 10.84 22 11.25ZM17 12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12ZM12 11C11.45 11 11 11.45 11 12C11 12.55 11.45 13 12 13C12.55 13 13 12.55 13 12C13 11.45 12.55 11 12 11ZM15.5 11C14.95 11 14.5 11.45 14.5 12C14.5 12.55 14.95 13 15.5 13C16.05 13 16.5 12.55 16.5 12C16.5 11.45 16.05 11 15.5 11ZM13.75 14C13.2 14 12.75 14.45 12.75 15C12.75 15.55 13.2 16 13.75 16C14.3 16 14.75 15.55 14.75 15C14.75 14.45 14.3 14 13.75 14Z",
    fill: "currentColor"
  })));
}, "IconCoronavirus");
import M5 from "classnames";
var x5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCorporateFare } from '@aws-amplify/ui-react'; \u2192 import { MdCorporateFare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: M5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 7V3H2V21H22V7H12ZM10 19H4V17H10V19ZM10 15H4V13H10V15ZM10 11H4V9H10V11ZM10 7H4V5H10V7ZM20 19H12V9H20V19ZM18 11H14V13H18V11ZM18 15H14V17H18V15Z",
    fill: "currentColor"
  })));
}, "IconCorporateFare");
import I5 from "classnames";
var L5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCountertops } from '@aws-amplify/ui-react'; \u2192 import { MdCountertops } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: I5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 10H18V7C18 5.34 16.66 4 15 4C13.34 4 12 5.34 12 7H14C14 6.45 14.45 6 15 6C15.55 6 16 6.45 16 7V10H8C9.1 10 10 9.1 10 8V4H4V8C4 9.1 4.9 10 6 10H2V12H4V20H20V12H22V10ZM6 6H8V8H6V6ZM6 18V12H11V18H6ZM18 18H13V12H18V18Z",
    fill: "currentColor"
  })));
}, "IconCountertops");
import v5 from "classnames";
var N5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCreateNewFolder } from '@aws-amplify/ui-react'; \u2192 import { MdCreateNewFolder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: v5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H12L10 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V8C22 6.89 21.11 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM12 14H14V16H16V14H18V12H16V10H14V12H12V14Z",
    fill: "currentColor"
  })));
}, "IconCreateNewFolder");
import y5 from "classnames";
var b5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCreate } from '@aws-amplify/ui-react'; \u2192 import { MdCreate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: y5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM5.92 19H5V18.08L14.06 9.02L14.98 9.94L5.92 19ZM20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3C17.4 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63V5.63Z",
    fill: "currentColor"
  })));
}, "IconCreate");
import Z5 from "classnames";
var B5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCreditCard } from '@aws-amplify/ui-react'; \u2192 import { MdCreditCard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Z5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z",
    fill: "currentColor"
  })));
}, "IconCreditCard");
import W5 from "classnames";
var k5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCrop_16_9 } from '@aws-amplify/ui-react'; \u2192 import { MdCrop_16_9 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: W5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 6H5C3.9 6 3 6.9 3 8V16C3 17.1 3.9 18 5 18H19C20.1 18 21 17.1 21 16V8C21 6.9 20.1 6 19 6ZM19 16H5V8H19V16Z",
    fill: "currentColor"
  })));
}, "IconCrop_16_9");
import D5 from "classnames";
var P5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCrop_3_2 } from '@aws-amplify/ui-react'; \u2192 import { MdCrop_3_2 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: D5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 4H5C3.9 4 3 4.9 3 6V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM19 18H5V6H19V18Z",
    fill: "currentColor"
  })));
}, "IconCrop_3_2");
import S5 from "classnames";
var j5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCrop_5_4 } from '@aws-amplify/ui-react'; \u2192 import { MdCrop_5_4 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: S5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5H5C3.9 5 3 5.9 3 7V17C3 18.1 3.9 19 5 19H19C20.1 19 21 18.1 21 17V7C21 5.9 20.1 5 19 5ZM19 17H5V7H19V17Z",
    fill: "currentColor"
  })));
}, "IconCrop_5_4");
import Y5 from "classnames";
var F5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCrop_7_5 } from '@aws-amplify/ui-react'; \u2192 import { MdCrop_7_5 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Y5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 7H5C3.9 7 3 7.9 3 9V15C3 16.1 3.9 17 5 17H19C20.1 17 21 16.1 21 15V9C21 7.9 20.1 7 19 7ZM19 15H5V9H19V15Z",
    fill: "currentColor"
  })));
}, "IconCrop_7_5");
import T5 from "classnames";
var A5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCropDin } from '@aws-amplify/ui-react'; \u2192 import { MdCropDin } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: T5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconCropDin");
import E5 from "classnames";
var O5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCropFree } from '@aws-amplify/ui-react'; \u2192 import { MdCropFree } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: E5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5V9H5V5H9V3H5C3.9 3 3 3.9 3 5ZM5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3Z",
    fill: "currentColor"
  })));
}, "IconCropFree");
import _5 from "classnames";
var G5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCropLandscape } from '@aws-amplify/ui-react'; \u2192 import { MdCropLandscape } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5H5C3.9 5 3 5.9 3 7V17C3 18.1 3.9 19 5 19H19C20.1 19 21 18.1 21 17V7C21 5.9 20.1 5 19 5ZM19 17H5V7H19V17Z",
    fill: "currentColor"
  })));
}, "IconCropLandscape");
import U5 from "classnames";
var z5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCropOriginal } from '@aws-amplify/ui-react'; \u2192 import { MdCropOriginal } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: U5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM13.96 12.29L11.21 15.83L9.25 13.47L6.5 17H17.5L13.96 12.29Z",
    fill: "currentColor"
  })));
}, "IconCropOriginal");
import X5 from "classnames";
var K5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCropPortrait } from '@aws-amplify/ui-react'; \u2192 import { MdCropPortrait } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: X5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 3H7C5.9 3 5 3.9 5 5V19C5 20.1 5.9 21 7 21H17C18.1 21 19 20.1 19 19V5C19 3.9 18.1 3 17 3ZM17 19H7V5H17V19Z",
    fill: "currentColor"
  })));
}, "IconCropPortrait");
import q5 from "classnames";
var Q5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCropRotate } from '@aws-amplify/ui-react'; \u2192 import { MdCropRotate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: q5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0C0.51 19.16 5.66 24 11.95 24C12.18 24 12.39 23.98 12.61 23.97L8.8 20.15L7.47 21.49V21.49ZM12.05 0C11.82 0 11.61 0.02 11.39 0.04L15.2 3.85L16.53 2.52C19.8 4.07 22.14 7.24 22.5 11H24C23.49 4.84 18.34 0 12.05 0ZM16 14H18V8C18 6.89 17.1 6 16 6H10V8H16V14ZM8 16V4H6V6H4V8H6V16C6 17.1 6.89 18 8 18H16V20H18V18H20V16H8Z",
    fill: "currentColor"
  })));
}, "IconCropRotate");
import J5 from "classnames";
var $5 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCropSquare } from '@aws-amplify/ui-react'; \u2192 import { MdCropSquare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: J5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 4H6C4.9 4 4 4.9 4 6V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V6C20 4.9 19.1 4 18 4ZM18 18H6V6H18V18Z",
    fill: "currentColor"
  })));
}, "IconCropSquare");
import R5 from "classnames";
var e4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconCrop } from '@aws-amplify/ui-react'; \u2192 import { MdCrop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: R5(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 15H19V7C19 5.9 18.1 5 17 5H9V7H17V15ZM7 17V1H5V5H1V7H5V17C5 18.1 5.9 19 7 19H17V23H19V19H23V17H7Z",
    fill: "currentColor"
  })));
}, "IconCrop");
import o4 from "classnames";
var t4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDashboard } from '@aws-amplify/ui-react'; \u2192 import { MdDashboard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: o4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V7H15V5H19ZM9 5V11H5V5H9ZM19 13V19H15V13H19ZM9 17V19H5V17H9ZM21 3H13V9H21V3ZM11 3H3V13H11V3ZM21 11H13V21H21V11ZM11 15H3V21H11V15Z",
    fill: "currentColor"
  })));
}, "IconDashboard");
import r4 from "classnames";
var i4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDataUsage } from '@aws-amplify/ui-react'; \u2192 import { MdDataUsage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: r4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 2.0498V5.0798C16.39 5.5698 19 8.4698 19 11.9998C19 12.8998 18.82 13.7498 18.52 14.5398L21.12 16.0698C21.68 14.8298 22 13.4498 22 11.9998C22 6.8198 18.05 2.5498 13 2.0498V2.0498ZM12 18.9998C8.13 18.9998 5 15.8698 5 11.9998C5 8.4698 7.61 5.5698 11 5.0798V2.0498C5.94 2.5498 2 6.8098 2 11.9998C2 17.5198 6.47 21.9998 11.99 21.9998C15.3 21.9998 18.23 20.3898 20.05 17.9098L17.45 16.3798C16.17 17.9798 14.21 18.9998 12 18.9998Z",
    fill: "currentColor"
  })));
}, "IconDataUsage");
import s4 from "classnames";
var a4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDateRange } from '@aws-amplify/ui-react'; \u2192 import { MdDateRange } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: s4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 11H9V13H7V11ZM21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19ZM15 13H17V11H15V13ZM11 13H13V11H11V13Z",
    fill: "currentColor"
  })));
}, "IconDateRange");
import n4 from "classnames";
var m4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDeck } from '@aws-amplify/ui-react'; \u2192 import { MdDeck } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: n4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 9L12 2L2 9H11V22H13V9H22ZM12 4.44L15.66 7H8.34L12 4.44Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M4.14018 12L2.18018 12.37L3.00018 16.74V22H5.00018L5.02018 18H7.00018V22H9.00018V16H4.90018L4.14018 12Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19.1 16H15V22H17V18H18.98L19 22H21V16.74L21.82 12.37L19.86 12L19.1 16Z",
    fill: "black"
  })));
}, "IconDeck");
import c4 from "classnames";
var l4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDehaze } from '@aws-amplify/ui-react'; \u2192 import { MdDehaze } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: c4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 16V18H22V16H2ZM2 11V13H22V11H2ZM2 6V8H22V6H2Z",
    fill: "currentColor"
  })));
}, "IconDehaze");
import p4 from "classnames";
var h4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDeleteForever } from '@aws-amplify/ui-react'; \u2192 import { MdDeleteForever } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: p4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.12 10.47L12 12.59L9.87 10.47L8.46 11.88L10.59 14L8.47 16.12L9.88 17.53L12 15.41L14.12 17.53L15.53 16.12L13.41 14L15.53 11.88L14.12 10.47ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5ZM6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9Z",
    fill: "currentColor"
  })));
}, "IconDeleteForever");
import f4 from "classnames";
var C4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDeleteOutline } from '@aws-amplify/ui-react'; \u2192 import { MdDeleteOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: f4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z",
    fill: "currentColor"
  })));
}, "IconDeleteOutline");
import g4 from "classnames";
var u4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDeleteSweep } from '@aws-amplify/ui-react'; \u2192 import { MdDeleteSweep } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: g4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 16H19V18H15V16ZM15 8H22V10H15V8ZM15 12H21V14H15V12ZM3 18C3 19.1 3.9 20 5 20H11C12.1 20 13 19.1 13 18V8H3V18ZM5 10H11V18H5V10ZM10 4H6L5 5H2V7H14V5H11L10 4Z",
    fill: "currentColor"
  })));
}, "IconDeleteSweep");
import w4 from "classnames";
var d4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDelete } from '@aws-amplify/ui-react'; \u2192 import { MdDelete } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: w4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z",
    fill: "currentColor"
  })));
}, "IconDelete");
import V4 from "classnames";
var H4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDepartureBoard } from '@aws-amplify/ui-react'; \u2192 import { MdDepartureBoard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: V4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5.5 18C6.32843 18 7 17.3284 7 16.5C7 15.6716 6.32843 15 5.5 15C4.67157 15 4 15.6716 4 16.5C4 17.3284 4.67157 18 5.5 18Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12.5 18C13.3284 18 14 17.3284 14 16.5C14 15.6716 13.3284 15 12.5 15C11.6716 15 11 15.6716 11 16.5C11 17.3284 11.6716 18 12.5 18Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16 1C13.61 1 11.51 2.2 10.25 4.02C9.84 4.01 9.43 4 9 4C4.58 4 1 4.5 1 8V18C1 18.88 1.39 19.67 2 20.22V22C2 22.55 2.45 23 3 23H4C4.55 23 5 22.55 5 22V21H13V22C13 22.55 13.45 23 14 23H15C15.55 23 16 22.55 16 22V20.22C16.61 19.67 17 18.88 17 18V14.92C20.39 14.43 23 11.53 23 8C23 4.13 19.87 1 16 1ZM9 6H9.29C9.2 6.32 9.13 6.66 9.08 6.99H3.34C3.89 6.46 5.31 6 9 6ZM3 8.99H9.08C9.24 10.1 9.65 11.12 10.26 12H3V8.99ZM15 18C15 18.37 14.79 18.62 14.66 18.73L14.37 19H3.63L3.34 18.73C3.21 18.62 3 18.37 3 18V14H12.41C13.19 14.47 14.06 14.79 15 14.92V18ZM16 13C13.24 13 11 10.76 11 8C11 5.24 13.24 3 16 3C18.76 3 21 5.24 21 8C21 10.76 18.76 13 16 13ZM16.5 4H15V9L18.62 11.16L19.37 9.93L16.5 8.25V4Z",
    fill: "black"
  })));
}, "IconDepartureBoard");
import M4 from "classnames";
var x4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDescription } from '@aws-amplify/ui-react'; \u2192 import { MdDescription } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: M4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 16H16V18H8V16ZM8 12H16V14H8V12ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z",
    fill: "currentColor"
  })));
}, "IconDescription");
import I4 from "classnames";
var L4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDesignServices } from '@aws-amplify/ui-react'; \u2192 import { MdDesignServices } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: I4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.97 7.27005C21.36 6.88005 21.36 6.25005 20.97 5.86005L18.14 3.03005C17.75 2.64005 17.12 2.64005 16.73 3.03005L12.24 7.52005L8.35 3.63005C7.57 2.85005 6.3 2.85005 5.52 3.63005L3.62 5.53005C2.84 6.31005 2.84 7.58005 3.62 8.36005L7.51 12.25L3 16.76V21H7.24L11.76 16.48L15.65 20.3701C16.6 21.3201 17.88 20.9701 18.48 20.3701L20.38 18.47C21.16 17.69 21.16 16.42 20.38 15.64L16.49 11.75L20.97 7.27005ZM5.04 6.94005L6.93 5.04005L8.2 6.31005L7.02 7.50005L8.43 8.91005L9.62 7.72005L10.82 8.92005L8.92 10.82L5.04 6.94005ZM16.27 14.38L15.08 15.57L16.49 16.98L17.68 15.79L18.95 17.06L17.05 18.96L13.16 15.07L15.06 13.17L16.27 14.38ZM6.41 19H5V17.59L14.61 7.98005L15.91 9.28005L16.02 9.39005L6.41 19ZM16.02 6.56005L17.43 5.15005L18.84 6.56005L17.43 7.97005L16.02 6.56005Z",
    fill: "currentColor"
  })));
}, "IconDesignServices");
import v4 from "classnames";
var N4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDesktopAccessDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdDesktopAccessDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: v4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1.41 1.68994L0 3.09994L1 4.08994V15.9999C1 17.0999 1.89 17.9999 2.99 17.9999H10V19.9999H8V21.9999H16V19.9999H14V17.9999H14.9L20.9 23.9999L22.31 22.5899L1.41 1.68994V1.68994ZM2.99 15.9999V6.08994L12.9 15.9999H2.99ZM4.55 1.99994L6.55 3.99994H21V15.9999H18.55L20.55 17.9999H20.99C22.09 17.9999 22.99 17.0999 22.99 15.9999V3.99994C22.99 2.89994 22.09 1.99994 20.99 1.99994H4.55Z",
    fill: "currentColor"
  })));
}, "IconDesktopAccessDisabled");
import y4 from "classnames";
var b4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDesktopMac } from '@aws-amplify/ui-react'; \u2192 import { MdDesktopMac } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: y4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 2H3C1.9 2 1 2.9 1 4V16C1 17.1 1.9 18 3 18H10L8 21V22H16V21L14 18H21C22.1 18 23 17.1 23 16V4C23 2.9 22.1 2 21 2ZM21 14H3V4H21V14Z",
    fill: "currentColor"
  })));
}, "IconDesktopMac");
import Z4 from "classnames";
var B4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDesktopWindows } from '@aws-amplify/ui-react'; \u2192 import { MdDesktopWindows } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Z4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 2H3C1.9 2 1 2.9 1 4V16C1 17.1 1.9 18 3 18H10V20H8V22H16V20H14V18H21C22.1 18 23 17.1 23 16V4C23 2.9 22.1 2 21 2ZM21 16H3V4H21V16Z",
    fill: "currentColor"
  })));
}, "IconDesktopWindows");
import W4 from "classnames";
var k4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDetails } from '@aws-amplify/ui-react'; \u2192 import { MdDetails } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: W4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 3L2 21H22L12 3ZM13 8.92L18.6 19H13V8.92ZM11 8.92V19H5.4L11 8.92Z",
    fill: "currentColor"
  })));
}, "IconDetails");
import D4 from "classnames";
var P4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDeveloperBoard } from '@aws-amplify/ui-react'; \u2192 import { MdDeveloperBoard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: D4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 9V7H20V5C20 3.9 19.1 3 18 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H18C19.1 21 20 20.1 20 19V17H22V15H20V13H22V11H20V9H22ZM18 19H4V5H18V19ZM6 13H11V17H6V13ZM12 7H16V10H12V7ZM6 7H11V12H6V7ZM12 11H16V17H12V11Z",
    fill: "currentColor"
  })));
}, "IconDeveloperBoard");
import S4 from "classnames";
var j4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDeveloperMode } from '@aws-amplify/ui-react'; \u2192 import { MdDeveloperMode } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: S4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 5H17V7H19V3C19 1.9 18.1 1.01 17 1.01L7 1C5.9 1 5 1.9 5 3V7H7V5ZM15.41 16.59L20 12L15.41 7.41L14 8.83L17.17 12L14 15.17L15.41 16.59ZM10 15.17L6.83 12L10 8.83L8.59 7.41L4 12L8.59 16.59L10 15.17ZM17 19H7V17H5V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V17H17V19Z",
    fill: "currentColor"
  })));
}, "IconDeveloperMode");
import Y4 from "classnames";
var F4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDeviceHub } from '@aws-amplify/ui-react'; \u2192 import { MdDeviceHub } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Y4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 16L13 12V8.82C14.16 8.4 15 7.3 15 6C15 4.34 13.66 3 12 3C10.34 3 9 4.34 9 6C9 7.3 9.84 8.4 11 8.82V12L7 16H3V21H8V17.95L12 13.75L16 17.95V21H21V16H17Z",
    fill: "currentColor"
  })));
}, "IconDeviceHub");
import T4 from "classnames";
var A4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDeviceUnknown } from '@aws-amplify/ui-react'; \u2192 import { MdDeviceUnknown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: T4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 19H7V5H17V19ZM12 6.72C10.04 6.72 8.5 8.24 8.5 10.19H10.25C10.25 9.26 11.07 8.44 12 8.44C12.93 8.44 13.75 9.26 13.75 10.19C13.75 11.94 11.12 11.76 11.12 14.64H12.88C12.88 12.68 15.5 12.45 15.5 10.19C15.5 8.23 13.96 6.72 12 6.72V6.72ZM11 16H13V18H11V16Z",
    fill: "currentColor"
  })));
}, "IconDeviceUnknown");
import E4 from "classnames";
var O4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDevicesOther } from '@aws-amplify/ui-react'; \u2192 import { MdDevicesOther } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: E4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 6H21V4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H7V18H3V6ZM13 12H9V13.78C8.39 14.33 8 15.11 8 16C8 16.89 8.39 17.67 9 18.22V20H13V18.22C13.61 17.67 14 16.88 14 16C14 15.12 13.61 14.33 13 13.78V12ZM11 17.5C10.17 17.5 9.5 16.83 9.5 16C9.5 15.17 10.17 14.5 11 14.5C11.83 14.5 12.5 15.17 12.5 16C12.5 16.83 11.83 17.5 11 17.5ZM22 8H16C15.5 8 15 8.5 15 9V19C15 19.5 15.5 20 16 20H22C22.5 20 23 19.5 23 19V9C23 8.5 22.5 8 22 8ZM21 18H17V10H21V18Z",
    fill: "currentColor"
  })));
}, "IconDevicesOther");
import _4 from "classnames";
var G4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDevices } from '@aws-amplify/ui-react'; \u2192 import { MdDevices } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H22V4H4C2.9 4 2 4.9 2 6V17H0V20H14V17H4V6ZM23 8H17C16.45 8 16 8.45 16 9V19C16 19.55 16.45 20 17 20H23C23.55 20 24 19.55 24 19V9C24 8.45 23.55 8 23 8ZM22 17H18V10H22V17Z",
    fill: "currentColor"
  })));
}, "IconDevices");
import U4 from "classnames";
var z4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDialerSip } from '@aws-amplify/ui-react'; \u2192 import { MdDialerSip } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: U4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 3H17V8H16V3ZM15 5H13V4H15V3H12V6H14V7H12V8H15V5ZM18 3V8H19V6H21V3H18ZM20 5H19V4H20V5ZM20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.42 15.17L13.22 17.37C10.39 15.93 8.07 13.62 6.63 10.78L8.83 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.99 7.59L5.79 8.8C5.38 7.59 5.12 6.32 5.03 5V5ZM19 18.97C17.68 18.88 16.41 18.62 15.2 18.22L16.4 17.02C17.25 17.26 18.11 17.41 18.99 17.47V18.97H19Z",
    fill: "currentColor"
  })));
}, "IconDialerSip");
import X4 from "classnames";
var K4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDialpad } from '@aws-amplify/ui-react'; \u2192 import { MdDialpad } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: X4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 19C10.9 19 10 19.9 10 21C10 22.1 10.9 23 12 23C13.1 23 14 22.1 14 21C14 19.9 13.1 19 12 19ZM6 1C4.9 1 4 1.9 4 3C4 4.1 4.9 5 6 5C7.1 5 8 4.1 8 3C8 1.9 7.1 1 6 1ZM6 7C4.9 7 4 7.9 4 9C4 10.1 4.9 11 6 11C7.1 11 8 10.1 8 9C8 7.9 7.1 7 6 7ZM6 13C4.9 13 4 13.9 4 15C4 16.1 4.9 17 6 17C7.1 17 8 16.1 8 15C8 13.9 7.1 13 6 13ZM18 5C19.1 5 20 4.1 20 3C20 1.9 19.1 1 18 1C16.9 1 16 1.9 16 3C16 4.1 16.9 5 18 5ZM12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13ZM18 13C16.9 13 16 13.9 16 15C16 16.1 16.9 17 18 17C19.1 17 20 16.1 20 15C20 13.9 19.1 13 18 13ZM18 7C16.9 7 16 7.9 16 9C16 10.1 16.9 11 18 11C19.1 11 20 10.1 20 9C20 7.9 19.1 7 18 7ZM12 7C10.9 7 10 7.9 10 9C10 10.1 10.9 11 12 11C13.1 11 14 10.1 14 9C14 7.9 13.1 7 12 7ZM12 1C10.9 1 10 1.9 10 3C10 4.1 10.9 5 12 5C13.1 5 14 4.1 14 3C14 1.9 13.1 1 12 1Z",
    fill: "currentColor"
  })));
}, "IconDialpad");
import q4 from "classnames";
var Q4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsBike } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsBike } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: q4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 5.5C16.6 5.5 17.5 4.6 17.5 3.5C17.5 2.4 16.6 1.5 15.5 1.5C14.4 1.5 13.5 2.4 13.5 3.5C13.5 4.6 14.4 5.5 15.5 5.5ZM5 12C2.2 12 0 14.2 0 17C0 19.8 2.2 22 5 22C7.8 22 10 19.8 10 17C10 14.2 7.8 12 5 12ZM5 20.5C3.1 20.5 1.5 18.9 1.5 17C1.5 15.1 3.1 13.5 5 13.5C6.9 13.5 8.5 15.1 8.5 17C8.5 18.9 6.9 20.5 5 20.5ZM10.8 10.5L13.2 8.1L14 8.9C15.3 10.2 17 11 19.1 11V9C17.6 9 16.4 8.4 15.5 7.5L13.6 5.6C13.1 5.2 12.6 5 12 5C11.4 5 10.9 5.2 10.6 5.6L7.8 8.4C7.4 8.8 7.2 9.3 7.2 9.8C7.2 10.4 7.4 10.9 7.8 11.2L11 14V19H13V12.8L10.8 10.5ZM19 12C16.2 12 14 14.2 14 17C14 19.8 16.2 22 19 22C21.8 22 24 19.8 24 17C24 14.2 21.8 12 19 12ZM19 20.5C17.1 20.5 15.5 18.9 15.5 17C15.5 15.1 17.1 13.5 19 13.5C20.9 13.5 22.5 15.1 22.5 17C22.5 18.9 20.9 20.5 19 20.5Z",
    fill: "currentColor"
  })));
}, "IconDirectionsBike");
import J4 from "classnames";
var $4 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsBoat } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsBoat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: J4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.9999 3V4H10.9999V3H12.9999ZM11.9999 10.11L17.3799 11.88L19.7699 12.66L18.6499 16.63C18.1099 16.33 17.7099 15.92 17.5099 15.69L15.9999 13.96L14.4899 15.68C14.1499 16.08 13.2099 17 11.9999 17C10.7899 17 9.84989 16.08 9.50989 15.68L7.99989 13.96L6.48989 15.68C6.28989 15.91 5.88989 16.31 5.34989 16.61L4.21989 12.65L6.61989 11.86L11.9999 10.11ZM14.9999 1H8.99989V4H5.99989C4.89989 4 3.99989 4.9 3.99989 6V10.62L2.70989 11.04C2.44989 11.12 2.22989 11.3 2.10989 11.54C1.98989 11.78 1.95989 12.06 2.04989 12.32L3.94989 19H3.99989C5.59989 19 7.01989 18.12 7.99989 17C8.97989 18.12 10.3999 19 11.9999 19C13.5999 19 15.0199 18.12 15.9999 17C16.9799 18.12 18.3999 19 19.9999 19H20.0499L21.9399 12.32C22.0199 12.06 21.9999 11.78 21.8799 11.54C21.7599 11.3 21.5399 11.12 21.2799 11.04L19.9999 10.62V6C19.9999 4.9 19.0999 4 17.9999 4H14.9999V1ZM5.99989 9.97V6H17.9999V9.97L11.9999 8L5.99989 9.97ZM15.9999 19.68C14.7799 20.53 13.3899 20.96 11.9999 20.96C10.6099 20.96 9.21989 20.53 7.99989 19.68C6.77989 20.53 5.38989 21 3.99989 21H1.99989V23H3.99989C5.37989 23 6.73989 22.65 7.99989 22.01C9.25989 22.65 10.6299 22.98 11.9999 22.98C13.3699 22.98 14.7399 22.66 15.9999 22.01C17.2599 22.66 18.6199 23 19.9999 23H21.9999V21H19.9999C18.6099 21 17.2199 20.53 15.9999 19.68Z",
    fill: "currentColor"
  })));
}, "IconDirectionsBoat");
import R4 from "classnames";
var eh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsBus } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsBus } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: R4(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C7.58 2 4 2.5 4 6V16C4 16.88 4.39 17.67 5 18.22V20C5 20.55 5.45 21 6 21H7C7.55 21 8 20.55 8 20V19H16V20C16 20.55 16.45 21 17 21H18C18.55 21 19 20.55 19 20V18.22C19.61 17.67 20 16.88 20 16V6C20 2.5 16.42 2 12 2ZM17.66 4.99H6.34C6.89 4.46 8.31 4 12 4C15.69 4 17.11 4.46 17.66 4.99ZM18 6.99V10H6V6.99H18ZM17.66 16.73L17.37 17H6.63L6.34 16.73C6.21 16.62 6 16.37 6 16V12H18V16C18 16.37 17.79 16.62 17.66 16.73Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.5 16C9.32843 16 10 15.3284 10 14.5C10 13.6716 9.32843 13 8.5 13C7.67157 13 7 13.6716 7 14.5C7 15.3284 7.67157 16 8.5 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15.5 16C16.3284 16 17 15.3284 17 14.5C17 13.6716 16.3284 13 15.5 13C14.6716 13 14 13.6716 14 14.5C14 15.3284 14.6716 16 15.5 16Z",
    fill: "black"
  })));
}, "IconDirectionsBus");
import oh from "classnames";
var th = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsCar } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsCar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H6.5C5.84 5 5.29 5.42 5.08 6.01L3 12V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H18V20C18 20.55 18.45 21 19 21H20C20.55 21 21 20.55 21 20V12L18.92 6.01ZM6.85 7H17.14L18.22 10.11H5.77L6.85 7ZM19 17H5V12H19V17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.5 16C8.32843 16 9 15.3284 9 14.5C9 13.6716 8.32843 13 7.5 13C6.67157 13 6 13.6716 6 14.5C6 15.3284 6.67157 16 7.5 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 16C17.3284 16 18 15.3284 18 14.5C18 13.6716 17.3284 13 16.5 13C15.6716 13 15 13.6716 15 14.5C15 15.3284 15.6716 16 16.5 16Z",
    fill: "black"
  })));
}, "IconDirectionsCar");
import rh from "classnames";
var ih = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsOff } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.71 11.2901L12.71 2.29006C12.32 1.90006 11.69 1.90006 11.3 2.29006L8.20996 5.38006L9.61996 6.79006L12 4.42006L19.58 12.0001L17.2 14.3801L18.61 15.7901L21.7 12.7001C22.1 12.3301 22.1 11.7001 21.71 11.2901Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M13 7.5V10.17L15.17 12.34L16.5 11L13 7.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M1.39014 4.22006L5.38014 8.21006L2.29014 11.3001C1.90014 11.6901 1.90014 12.3201 2.29014 12.7101L11.2901 21.7101C11.6801 22.1001 12.3101 22.1001 12.7001 21.7101L15.7901 18.6201L19.7801 22.6101L21.1901 21.2001L2.81014 2.81006L1.39014 4.22006ZM8.03014 10.8501C8.02014 10.9001 7.99014 10.9501 7.99014 11.0001V15.0001H9.99014V12.8201L14.3701 17.2001L12.0001 19.5801L4.42014 12.0001L6.80014 9.62006L8.03014 10.8501Z",
    fill: "black"
  })));
}, "IconDirectionsOff");
import sh from "classnames";
var ah = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsRailway } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsRailway } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 1C7.58 1 4 1.5 4 5V15.5C4 17.43 5.57 19 7.5 19L6 20.5V21H18V20.5L16.5 19C18.43 19 20 17.43 20 15.5V5C20 1.5 16.42 1 12 1ZM12 3C18 3 18 4.2 18 5H6C6 4.2 6 3 12 3ZM18 7V10H6V7H18ZM16.5 17H7.5C6.67 17 6 16.33 6 15.5V12H18V15.5C18 16.33 17.33 17 16.5 17ZM12 12.5C10.9 12.5 10 13.4 10 14.5C10 15.6 10.9 16.5 12 16.5C13.1 16.5 14 15.6 14 14.5C14 13.4 13.1 12.5 12 12.5Z",
    fill: "currentColor"
  })));
}, "IconDirectionsRailway");
import nh from "classnames";
var mh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsRun } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsRun } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13.4901 5.47998C14.5901 5.47998 15.4901 4.57998 15.4901 3.47998C15.4901 2.37998 14.5901 1.47998 13.4901 1.47998C12.3901 1.47998 11.4901 2.37998 11.4901 3.47998C11.4901 4.57998 12.3901 5.47998 13.4901 5.47998ZM9.89014 19.38L10.8901 14.98L12.9901 16.98V22.98H14.9901V15.48L12.8901 13.48L13.4901 10.48C14.7901 11.98 16.7901 12.98 18.9901 12.98V10.98C17.0901 10.98 15.4901 9.97998 14.6901 8.57998L13.6901 6.97998C13.2901 6.37998 12.6901 5.97998 11.9901 5.97998C11.6901 5.97998 11.4901 6.07998 11.1901 6.07998L5.99014 8.27998V12.98H7.99014V9.57998L9.79014 8.87998L8.19014 16.98L3.29014 15.98L2.89014 17.98L9.89014 19.38Z",
    fill: "currentColor"
  })));
}, "IconDirectionsRun");
import ch from "classnames";
var lh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsSubway } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsSubway } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ch(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C8 2 4 2.5 4 6V15.5C4 17.43 5.57 19 7.5 19L6 20.5V21H18V20.5L16.5 19C18.43 19 20 17.43 20 15.5V6C20 2.5 16.42 2 12 2ZM17.66 5H6.43C7.04 4.48 8.49 4 12 4C15.71 4 17.12 4.46 17.66 5ZM11 7V10H6V7H11ZM13 7H18V10H13V7ZM16.5 17H7.5C6.67 17 6 16.33 6 15.5V12H18V15.5C18 16.33 17.33 17 16.5 17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.5 16C9.32843 16 10 15.3284 10 14.5C10 13.6716 9.32843 13 8.5 13C7.67157 13 7 13.6716 7 14.5C7 15.3284 7.67157 16 8.5 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15.5 16C16.3284 16 17 15.3284 17 14.5C17 13.6716 16.3284 13 15.5 13C14.6716 13 14 13.6716 14 14.5C14 15.3284 14.6716 16 15.5 16Z",
    fill: "black"
  })));
}, "IconDirectionsSubway");
import ph from "classnames";
var hh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsTransit } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsTransit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ph(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C8 2 4 2.5 4 6V15.5C4 17.43 5.57 19 7.5 19L6 20.5V21H18V20.5L16.5 19C18.43 19 20 17.43 20 15.5V6C20 2.5 16.42 2 12 2ZM17.66 5H6.43C7.04 4.48 8.49 4 12 4C15.71 4 17.12 4.46 17.66 5ZM11 7V10H6V7H11ZM13 7H18V10H13V7ZM16.5 17H7.5C6.67 17 6 16.33 6 15.5V12H18V15.5C18 16.33 17.33 17 16.5 17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.5 16C9.32843 16 10 15.3284 10 14.5C10 13.6716 9.32843 13 8.5 13C7.67157 13 7 13.6716 7 14.5C7 15.3284 7.67157 16 8.5 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15.5 16C16.3284 16 17 15.3284 17 14.5C17 13.6716 16.3284 13 15.5 13C14.6716 13 14 13.6716 14 14.5C14 15.3284 14.6716 16 15.5 16Z",
    fill: "black"
  })));
}, "IconDirectionsTransit");
import fh from "classnames";
var Ch = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirectionsWalk } from '@aws-amplify/ui-react'; \u2192 import { MdDirectionsWalk } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13.5 5.5C14.6 5.5 15.5 4.6 15.5 3.5C15.5 2.4 14.6 1.5 13.5 1.5C12.4 1.5 11.5 2.4 11.5 3.5C11.5 4.6 12.4 5.5 13.5 5.5ZM9.8 8.9L7 23H9.1L10.9 15L13 17V23H15V15.5L12.9 13.5L13.5 10.5C14.8 12 16.8 13 19 13V11C17.1 11 15.5 10 14.7 8.6L13.7 7C13.14 6.11 12.02 5.75 11.05 6.16L6 8.3V13H8V9.6L9.8 8.9Z",
    fill: "currentColor"
  })));
}, "IconDirectionsWalk");
import gh from "classnames";
var uh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDirections } from '@aws-amplify/ui-react'; \u2192 import { MdDirections } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22.4299 10.5899L13.4199 1.57993C12.6699 0.829928 11.3499 0.819928 10.5899 1.57993L1.58988 10.5799C0.809883 11.3599 0.809883 12.6199 1.58988 13.3999L10.5899 22.3999C10.9799 22.7899 11.4899 22.9799 11.9999 22.9799C12.5099 22.9799 13.0199 22.7899 13.4099 22.3999L22.3999 13.4099C23.1899 12.6499 23.1999 11.3899 22.4299 10.5899V10.5899ZM12.0099 20.9899L3.00988 11.9899L12.0099 2.98993L21.0099 11.9899L12.0099 20.9899V20.9899ZM7.99988 10.9999V14.9999H9.99988V11.9999H13.9999V14.4999L17.4999 10.9999L13.9999 7.49993V9.99993H8.99988C8.44988 9.99993 7.99988 10.4499 7.99988 10.9999Z",
    fill: "currentColor"
  })));
}, "IconDirections");
import wh from "classnames";
var dh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDisabledByDefault } from '@aws-amplify/ui-react'; \u2192 import { MdDisabledByDefault } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 19H5V5H19V19ZM3 3V21H21V3H3ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z",
    fill: "currentColor"
  })));
}, "IconDisabledByDefault");
import Vh from "classnames";
var Hh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDiscFull } from '@aws-amplify/ui-react'; \u2192 import { MdDiscFull } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Vh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 7H22V12H20V7ZM10 4C5.58 4 2 7.58 2 12C2 16.42 5.58 20 10 20C14.42 20 18 16.42 18 12C18 7.58 14.42 4 10 4ZM10 18C6.69 18 4 15.31 4 12C4 8.69 6.69 6 10 6C13.31 6 16 8.69 16 12C16 15.31 13.31 18 10 18ZM20 14H22V16H20V14ZM10 10C8.9 10 8 10.9 8 12C8 13.1 8.9 14 10 14C11.1 14 12 13.1 12 12C12 10.9 11.1 10 10 10Z",
    fill: "currentColor"
  })));
}, "IconDiscFull");
import Mh from "classnames";
var xh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDns } from '@aws-amplify/ui-react'; \u2192 import { MdDns } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Mh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 15V19H5V15H19ZM20 13H4C3.45 13 3 13.45 3 14V20C3 20.55 3.45 21 4 21H20C20.55 21 21 20.55 21 20V14C21 13.45 20.55 13 20 13ZM7 18.5C6.18 18.5 5.5 17.83 5.5 17C5.5 16.17 6.18 15.5 7 15.5C7.82 15.5 8.5 16.17 8.5 17C8.5 17.83 7.83 18.5 7 18.5ZM19 5V9H5V5H19ZM20 3H4C3.45 3 3 3.45 3 4V10C3 10.55 3.45 11 4 11H20C20.55 11 21 10.55 21 10V4C21 3.45 20.55 3 20 3ZM7 8.5C6.18 8.5 5.5 7.83 5.5 7C5.5 6.17 6.18 5.5 7 5.5C7.82 5.5 8.5 6.18 8.5 7C8.5 7.82 7.83 8.5 7 8.5Z",
    fill: "currentColor"
  })));
}, "IconDns");
import Ih from "classnames";
var Lh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoDisturbAlt } from '@aws-amplify/ui-react'; \u2192 import { MdDoDisturbAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ih(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM4 12C4 7.6 7.6 4 12 4C13.8 4 15.5 4.6 16.9 5.7L5.7 16.9C4.6 15.5 4 13.8 4 12ZM12 20C10.2 20 8.5 19.4 7.1 18.3L18.3 7.1C19.4 8.5 20 10.2 20 12C20 16.4 16.4 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconDoDisturbAlt");
import vh from "classnames";
var Nh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoDisturbOff } from '@aws-amplify/ui-react'; \u2192 import { MdDoDisturbOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 13.41 19.63 14.73 18.99 15.88L20.45 17.34C21.43 15.79 22 13.96 22 12C22 6.48 17.52 2 12 2C10.04 2 8.21 2.57 6.67 3.55L8.13 5.01C9.27 4.37 10.59 4 12 4ZM17 11H14.12L16.12 13H17V11ZM2.41 2.13L1 3.54L3.78 6.32C2.66 7.93 2 9.89 2 12C2 17.52 6.48 22 12 22C14.11 22 16.07 21.34 17.68 20.22L20.46 23L21.87 21.59L2.41 2.13ZM12 20C7.59 20 4 16.41 4 12C4 10.44 4.45 9 5.23 7.77L8.46 11H7V13H10.46L16.23 18.77C15 19.55 13.56 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconDoDisturbOff");
import yh from "classnames";
var bh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoDisturbOn } from '@aws-amplify/ui-react'; \u2192 import { MdDoDisturbOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM7 11H17V13H7V11Z",
    fill: "currentColor"
  })));
}, "IconDoDisturbOn");
import Zh from "classnames";
var Bh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoDisturb } from '@aws-amplify/ui-react'; \u2192 import { MdDoDisturb } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Zh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z",
    fill: "currentColor"
  })));
}, "IconDoDisturb");
import Wh from "classnames";
var kh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoNotStep } from '@aws-amplify/ui-react'; \u2192 import { MdDoNotStep } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Wh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.51 15.68L17.1 14.27L21.58 9.79L23 11.2L18.51 15.68ZM14.98 12.15L18.05 9.08L13.8 4.82L10.72 7.89L9.3 6.47L13.8 2L20.88 9.08L16.4 13.56L14.98 12.15ZM21.18 21.2L19.77 22.61L13.83 16.67L10.5 20H1V17.37C1 16.53 1.52 15.8 2.3 15.49C2.88 15.26 3.58 14.93 4.27 14.47L5.65 15.85C5.74 15.95 5.87 16 6 16C6.13 16 6.26 15.95 6.36 15.85C6.56 15.65 6.56 15.34 6.36 15.14L5.08 13.86C5.35 13.62 5.61 13.35 5.85 13.06L7.12 14.33C7.21 14.43 7.35 14.48 7.47 14.48C7.59 14.48 7.72 14.43 7.82 14.33C8.02 14.13 8.02 13.82 7.82 13.62L6.42 12.22C6.61 11.88 6.76 11.5 6.87 11.1L8.58 12.82C8.67 12.92 8.81 12.97 8.93 12.97C9.05 12.97 9.18 12.92 9.28 12.82C9.47 12.62 9.47 12.32 9.29 12.12L1.39 4.22L2.81 2.81L21.18 21.2ZM12.42 15.26L10.75 13.58L7.42 16.9C6.64 17.68 5.37 17.68 4.59 16.89L4.4 16.72L3.93 16.96C3.64 17.1 3.34 17.23 3.04 17.35L3.03 18H9.67L12.42 15.26Z",
    fill: "currentColor"
  })));
}, "IconDoNotStep");
import Dh from "classnames";
var Ph = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoNotTouch } from '@aws-amplify/ui-react'; \u2192 import { MdDoNotTouch } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Dh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2.81014 2.81L1.39014 4.22L7.00014 9.83V14.13L4.40014 12.65C4.23014 12.56 4.06014 12.51 3.86014 12.51C3.60014 12.51 3.36014 12.6 3.16014 12.77L2.00014 13.88L8.80014 21.06C9.37014 21.66 10.1501 22 10.9801 22H17.0001C17.6201 22 18.1801 21.81 18.6601 21.48L19.7801 22.6L21.1901 21.19L2.81014 2.81ZM17.0001 20H11.0001C10.6101 20 10.3601 19.77 10.2501 19.64L6.87014 16H9.00014V11.83L17.1401 19.97C17.0901 19.98 17.0501 20 17.0001 20ZM13.8301 11H14.0001V3.25C14.0001 2.56 14.5601 2 15.2501 2C15.9401 2 16.5001 2.56 16.5001 3.25V11H17.5001V5.25C17.5001 4.56 18.0601 4 18.7501 4C19.4401 4 20.0001 4.56 20.0001 5.25V17.17L18.0001 15.17V13H15.8301L13.8301 11ZM13.0001 10.17V2.25C13.0001 1.56 12.4401 1 11.7501 1C11.0601 1 10.5001 1.56 10.5001 2.25V7.67L13.0001 10.17ZM9.50014 6.67V4.25C9.50014 3.56 8.94014 3 8.25014 3C7.58014 3 7.05014 3.53 7.01014 4.18L9.50014 6.67Z",
    fill: "currentColor"
  })));
}, "IconDoNotTouch");
import Sh from "classnames";
var jh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDock } from '@aws-amplify/ui-react'; \u2192 import { MdDock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Sh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 23H16V21H8V23ZM16 1.01L8 1C6.9 1 6 1.9 6 3V17C6 18.1 6.9 19 8 19H16C17.1 19 18 18.1 18 17V3C18 1.9 17.1 1.01 16 1.01V1.01ZM16 15H8V5H16V15Z",
    fill: "currentColor"
  })));
}, "IconDock");
import Yh from "classnames";
var Fh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDomainDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdDomainDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Yh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1.41 1.68994L0 3.09994L2 5.09994V20.9999H17.9L20.9 23.9999L22.31 22.5899L1.41 1.68994V1.68994ZM6 18.9999H4V16.9999H6V18.9999ZM6 14.9999H4V12.9999H6V14.9999ZM4 10.9999V8.99994H6V10.9999H4ZM10 18.9999H8V16.9999H10V18.9999ZM8 14.9999V12.9999H10V14.9999H8ZM12 18.9999V16.9999H13.9L15.9 18.9999H12ZM8 4.99994H10V6.99994H9.55L12 9.44994V8.99994H20V17.4499L22 19.4499V6.99994H12V2.99994H5.55L8 5.44994V4.99994ZM16 10.9999H18V12.9999H16V10.9999Z",
    fill: "currentColor"
  })));
}, "IconDomainDisabled");
import Th from "classnames";
var Ah = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDomainVerification } from '@aws-amplify/ui-react'; \u2192 import { MdDomainVerification } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Th(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.6 10.88L15.18 9.45996L10.94 13.71L8.82002 11.58L7.40002 13L10.94 16.54L16.6 10.88Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM19 18H5V8H19V18Z",
    fill: "black"
  })));
}, "IconDomainVerification");
import Eh from "classnames";
var Oh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDomain } from '@aws-amplify/ui-react'; \u2192 import { MdDomain } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Eh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 7V3H2V21H22V7H12ZM6 19H4V17H6V19ZM6 15H4V13H6V15ZM6 11H4V9H6V11ZM6 7H4V5H6V7ZM10 19H8V17H10V19ZM10 15H8V13H10V15ZM10 11H8V9H10V11ZM10 7H8V5H10V7ZM20 19H12V17H14V15H12V13H14V11H12V9H20V19ZM18 11H16V13H18V11ZM18 15H16V17H18V15Z",
    fill: "currentColor"
  })));
}, "IconDomain");
import _h from "classnames";
var Gh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoneAll } from '@aws-amplify/ui-react'; \u2192 import { MdDoneAll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _h(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 6.99984L16.59 5.58984L10.25 11.9298L11.66 13.3398L18 6.99984ZM22.24 5.58984L11.66 16.1698L7.48 11.9998L6.07 13.4098L11.66 18.9998L23.66 6.99984L22.24 5.58984ZM0.410004 13.4098L6 18.9998L7.41 17.5898L1.83 11.9998L0.410004 13.4098Z",
    fill: "currentColor"
  })));
}, "IconDoneAll");
import Uh from "classnames";
var zh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoneOutline } from '@aws-amplify/ui-react'; \u2192 import { MdDoneOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Uh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.77 4.9301L21.17 6.3301L8.43 19.0701L2.83 13.4701L4.23 12.0701L8.43 16.2701L19.77 4.9301ZM19.77 2.1001L8.43 13.4401L4.23 9.2401L0 13.4701L8.43 21.9001L24 6.3301L19.77 2.1001V2.1001Z",
    fill: "currentColor"
  })));
}, "IconDoneOutline");
import Xh from "classnames";
var Kh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDone } from '@aws-amplify/ui-react'; \u2192 import { MdDone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Xh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 16.2001L4.8 12.0001L3.4 13.4001L9 19.0001L21 7.0001L19.6 5.6001L9 16.2001Z",
    fill: "currentColor"
  })));
}, "IconDone");
import qh from "classnames";
var Qh = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDonutLarge } from '@aws-amplify/ui-react'; \u2192 import { MdDonutLarge } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 5.0798C16.06 5.5198 18.48 7.9398 18.92 10.9998H21.95C21.48 6.2798 17.72 2.5198 13 2.0498V5.0798V5.0798ZM18.92 12.9998C18.48 16.0598 16.06 18.4798 13 18.9198V21.9498C17.72 21.4798 21.48 17.7198 21.95 12.9998H18.92V12.9998ZM11 18.9198C7.61 18.4298 5 15.5198 5 11.9998C5 8.4798 7.61 5.5698 11 5.0798V2.0498C5.95 2.5498 2 6.8098 2 11.9998C2 17.1898 5.95 21.4498 11 21.9498V18.9198V18.9198Z",
    fill: "currentColor"
  })));
}, "IconDonutLarge");
import Jh from "classnames";
var $h = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDonutSmall } from '@aws-amplify/ui-react'; \u2192 import { MdDonutSmall } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Jh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.82 10.9998H21.95C21.48 6.2798 17.72 2.5198 13 2.0498V9.1798C13.85 9.4898 14.51 10.1498 14.82 10.9998ZM15 4.5798C17 5.3998 18.6 6.9998 19.42 8.9998H15.99C15.71 8.6298 15.37 8.2898 15 8.0098V4.5798V4.5798ZM2 11.9998C2 17.1898 5.95 21.4498 11 21.9498V14.8198C9.84 14.3998 9 13.2998 9 11.9998C9 10.6998 9.84 9.5998 11 9.1798V2.0498C5.95 2.5498 2 6.8098 2 11.9998ZM9 4.5798V8.0198C7.77 8.9398 7 10.4098 7 11.9998C7 13.5898 7.77 15.0598 9 15.9898V19.4298C6.04 18.2398 4 15.3498 4 11.9998C4 8.6498 6.04 5.7598 9 4.5798ZM13 14.8198V21.9498C17.72 21.4798 21.48 17.7198 21.95 12.9998H14.82C14.51 13.8498 13.85 14.5098 13 14.8198ZM15 15.9898C15.37 15.7098 15.71 15.3798 15.99 14.9998H19.42C18.6 16.9998 17 18.5998 15 19.4198V15.9898V15.9898Z",
    fill: "currentColor"
  })));
}, "IconDonutSmall");
import Rh from "classnames";
var e3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDoubleArrow } from '@aws-amplify/ui-react'; \u2192 import { MdDoubleArrow } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Rh(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 5H11L16 12L11 19H15.5L20.5 12L15.5 5Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.5 5H4L9 12L4 19H8.5L13.5 12L8.5 5Z",
    fill: "black"
  })));
}, "IconDoubleArrow");
import o3 from "classnames";
var t3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDownloadDone } from '@aws-amplify/ui-react'; \u2192 import { MdDownloadDone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: o3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 18H19V20H5V18ZM9.6 15.3L5 10.7L7 8.8L9.6 11.4L17 4L19 6L9.6 15.3Z",
    fill: "currentColor"
  })));
}, "IconDownloadDone");
import r3 from "classnames";
var i3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDownload } from '@aws-amplify/ui-react'; \u2192 import { MdDownload } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: r3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z",
    fill: "currentColor"
  })));
}, "IconDownload");
import s3 from "classnames";
var a3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDrafts } from '@aws-amplify/ui-react'; \u2192 import { MdDrafts } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: s3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.99 8C21.99 7.28 21.62 6.65 21.05 6.3L12 1L2.95 6.3C2.38 6.65 2 7.28 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18L21.99 8ZM19.99 8V8.01L12 13L4 8L12 3.32L19.99 8ZM4 18V10.34L12 15.36L19.99 10.37L20 18H4Z",
    fill: "currentColor"
  })));
}, "IconDrafts");
import n3 from "classnames";
var m3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDragHandle } from '@aws-amplify/ui-react'; \u2192 import { MdDragHandle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: n3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 9H4V11H20V9ZM4 15H20V13H4V15Z",
    fill: "currentColor"
  })));
}, "IconDragHandle");
import c3 from "classnames";
var l3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDragIndicator } from '@aws-amplify/ui-react'; \u2192 import { MdDragIndicator } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: c3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z",
    fill: "currentColor"
  })));
}, "IconDragIndicator");
import p3 from "classnames";
var h3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDriveEta } from '@aws-amplify/ui-react'; \u2192 import { MdDriveEta } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: p3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V11L18.92 5.01ZM6.85 6H17.14L18.18 9H5.81L6.85 6ZM19 16H5V11.34L5.12 11H18.89L19 11.34V16Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.5 15C8.32843 15 9 14.3284 9 13.5C9 12.6716 8.32843 12 7.5 12C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 15C17.3284 15 18 14.3284 18 13.5C18 12.6716 17.3284 12 16.5 12C15.6716 12 15 12.6716 15 13.5C15 14.3284 15.6716 15 16.5 15Z",
    fill: "black"
  })));
}, "IconDriveEta");
import f3 from "classnames";
var C3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDry } from '@aws-amplify/ui-react'; \u2192 import { MdDry } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: f3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.75 16C21.44 16 22 15.44 22 14.75C22 14.06 21.44 13.5 20.75 13.5H12V12.5H18.75C19.44 12.5 20 11.94 20 11.25C20 10.58 19.47 10.05 18.82 10.01L8.87 10L10.35 7.4C10.44 7.23 10.49 7.06 10.49 6.86C10.49 6.6 10.4 6.36 10.23 6.16L9.12 5L1.94 11.8C1.34 12.36 1 13.15 1 13.97V20C1 21.66 2.34 23 4 23H17.75C18.44 23 19 22.44 19 21.75C19 21.06 18.44 20.5 17.75 20.5H12V19.5H19.75C20.44 19.5 21 18.94 21 18.25C21 17.56 20.44 17 19.75 17H12V16H20.75ZM10 21H4C3.45 21 3 20.55 3 20V14C3 13.61 3.23 13.36 3.36 13.25L7 9.87V12H10V21ZM15.65 4.86L15.58 4.79C15.01 4.17 14.76 3.38 14.91 2.59L15 2H13.11L13.05 2.43C12.85 3.79 13.32 5.14 14.35 6.15L14.42 6.21C14.99 6.83 15.24 7.62 15.09 8.41L14.98 9H16.89L16.95 8.57C17.16 7.21 16.68 5.86 15.65 4.86ZM19.65 4.86L19.58 4.79C19.01 4.17 18.76 3.38 18.91 2.59L19 2H17.11L17.05 2.43C16.85 3.79 17.32 5.14 18.35 6.15L18.42 6.21C18.99 6.83 19.24 7.62 19.09 8.41L18.98 9H20.89L20.95 8.57C21.16 7.21 20.68 5.86 19.65 4.86Z",
    fill: "currentColor"
  })));
}, "IconDry");
import g3 from "classnames";
var u3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDuo } from '@aws-amplify/ui-react'; \u2192 import { MdDuo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: g3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H12C6.38 2 2 6.66 2 12.28C2 17.5 6.49 22 11.72 22C17.39 22 22 17.62 22 12V4C22 2.9 21.1 2 20 2ZM17 15L14 13V15H7V9H14V11L17 9V15Z",
    fill: "currentColor"
  })));
}, "IconDuo");
import w3 from "classnames";
var d3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDvr } from '@aws-amplify/ui-react'; \u2192 import { MdDvr } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: w3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17ZM19 8H8V10H19V8ZM19 12H8V14H19V12ZM7 8H5V10H7V8ZM7 12H5V14H7V12Z",
    fill: "currentColor"
  })));
}, "IconDvr");
import V3 from "classnames";
var H3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDynamicFeed } from '@aws-amplify/ui-react'; \u2192 import { MdDynamicFeed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: V3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 8H6V15C6 16.1 6.9 17 8 17H17V15H8V8Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M20 3H12C10.9 3 10 3.9 10 5V11C10 12.1 10.9 13 12 13H20C21.1 13 22 12.1 22 11V5C22 3.9 21.1 3 20 3ZM20 11H12V7H20V11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M4 12H2V19C2 20.1 2.9 21 4 21H13V19H4V12Z",
    fill: "black"
  })));
}, "IconDynamicFeed");
import M3 from "classnames";
var x3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconDynamicForm } from '@aws-amplify/ui-react'; \u2192 import { MdDynamicForm } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: M3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 11H4C2.9 11 2 10.1 2 9V6C2 4.9 2.9 4 4 4H13V11ZM4 9H11V6H4V9ZM15 20H4C2.9 20 2 19.1 2 18V15C2 13.9 2.9 13 4 13H15V20ZM4 18H13V15H4V18ZM22 9H20L22 4H15V11H17V20L22 9ZM4.75 17.25H6.25V15.75H4.75V17.25ZM4.75 8.25H6.25V6.75H4.75V8.25Z",
    fill: "currentColor"
  })));
}, "IconDynamicForm");
import I3 from "classnames";
var L3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEast } from '@aws-amplify/ui-react'; \u2192 import { MdEast } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: I3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 5L13.59 6.41L18.17 11H2V13H18.17L13.58 17.59L15 19L22 12L15 5Z",
    fill: "currentColor"
  })));
}, "IconEast");
import v3 from "classnames";
var N3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEco } from '@aws-amplify/ui-react'; \u2192 import { MdEco } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: v3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.05 8.05C3.32 10.78 3.32 15.22 6.05 17.95C7.42 19.32 9.21 20 11 20C12.79 20 14.58 19.32 15.95 17.95C19.43 14.47 20 4 20 4C20 4 9.53 4.57 6.05 8.05ZM14.54 16.54C13.59 17.48 12.34 18 11 18C10.11 18 9.27 17.75 8.52 17.32C9.44 14.44 11.14 11.91 13.4 10C10.77 11.36 8.56 13.46 7.03 16C5.55 14.04 5.68 11.25 7.47 9.46C9.21 7.72 14.04 6.65 17.8 6.2C17.35 9.96 16.28 14.79 14.54 16.54Z",
    fill: "currentColor"
  })));
}, "IconEco");
import y3 from "classnames";
var b3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEditAttributes } from '@aws-amplify/ui-react'; \u2192 import { MdEditAttributes } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: y3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.63 7H6.37C3.96 7 2 9.24 2 12C2 14.76 3.96 17 6.37 17H17.63C20.04 17 22 14.76 22 12C22 9.24 20.04 7 17.63 7ZM17.63 15H6.37C5.09 15 4 13.63 4 12C4 10.37 5.09 9 6.37 9H17.63C18.91 9 20 10.37 20 12C20 13.63 18.91 15 17.63 15ZM7.24 13.06L5.37 11.19L4.67 11.89L7.24 14.46L11.46 10.24L10.76 9.54L7.24 13.06Z",
    fill: "currentColor"
  })));
}, "IconEditAttributes");
import Z3 from "classnames";
var B3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEditLocation } from '@aws-amplify/ui-react'; \u2192 import { MdEditLocation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Z3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.17 4.91019L17.1 3.84019L11.55 9.39019V10.4702H12.63L18.17 4.91019V4.91019ZM16 2.74019L17.29 1.45019C17.4286 1.3099 17.5936 1.19851 17.7756 1.12249C17.9576 1.04647 18.1528 1.00732 18.35 1.00732C18.5472 1.00732 18.7424 1.04647 18.9244 1.12249C19.1064 1.19851 19.2714 1.3099 19.41 1.45019L20.56 2.60019C21.15 3.19019 21.15 4.14019 20.56 4.72019L19.88 5.40019L19.86 5.42019L19.28 6.00019L13.28 12.0002H10V8.74018L16 2.74019ZM13.72 2.19019L13.17 2.74019L11.9 4.01019C8.6 4.06019 6 6.61019 6 10.2102C6 12.5502 7.95 15.6502 12 19.3502C16.05 15.6502 18 12.5602 18 10.2102V10.1102L19.8 8.31019C19.93 8.91019 20 9.55019 20 10.2102C20 13.5302 17.33 17.4602 12 22.0102C6.67 17.4602 4 13.5302 4 10.2102C4 5.23019 7.8 2.01019 12 2.01019C12.58 2.01019 13.16 2.07019 13.72 2.19019V2.19019Z",
    fill: "currentColor"
  })));
}, "IconEditLocation");
import W3 from "classnames";
var k3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEditRoad } from '@aws-amplify/ui-react'; \u2192 import { MdEditRoad } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: W3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 4H16V11.9L18 9.9V4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M6 4H4V20H6V4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 4H10V8H12V4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 10H10V14H12V10Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 16H10V20H12V16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M22.56 12.5901L21.41 11.4401C20.82 10.8501 19.87 10.8501 19.29 11.4401L14 16.7301V20.0001H17.27L22.56 14.7101C23.15 14.1201 23.15 13.1701 22.56 12.5901ZM16.58 18.4501H15.55V17.4201L19 13.9701L20.03 15.0001L16.58 18.4501Z",
    fill: "black"
  })));
}, "IconEditRoad");
import D3 from "classnames";
var P3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEdit } from '@aws-amplify/ui-react'; \u2192 import { MdEdit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: D3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02V9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3V3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19V6.19Z",
    fill: "currentColor"
  })));
}, "IconEdit");
import S3 from "classnames";
var j3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEject } from '@aws-amplify/ui-react'; \u2192 import { MdEject } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: S3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 17H19V19H5V17ZM12 5L5.33 15H18.67L12 5ZM12 8.6L14.93 13H9.07L12 8.6Z",
    fill: "currentColor"
  })));
}, "IconEject");
import Y3 from "classnames";
var F3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconElderly } from '@aws-amplify/ui-react'; \u2192 import { MdElderly } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Y3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13.5 5.5C14.6 5.5 15.5 4.6 15.5 3.5C15.5 2.4 14.6 1.5 13.5 1.5C12.4 1.5 11.5 2.4 11.5 3.5C11.5 4.6 12.4 5.5 13.5 5.5ZM20 12.5V23H19V12.5C19 12.22 18.78 12 18.5 12C18.22 12 18 12.22 18 12.5V13.5H17V12.81C15.54 12.43 14.3 11.52 13.49 10.29C13.18 11.16 13 12.07 13 13C13 13.23 13.02 13.46 13.03 13.69L15 16.5V23H13V18L11.22 15.46L11 19L8 23L6.4 21.8L9 18.33V13C9 11.85 9.18 10.71 9.5 9.61L8 10.46V14H6V9.3L11.4 6.23V6.24C11.99 5.93 12.72 5.91 13.34 6.27C13.7 6.48 13.97 6.78 14.14 7.12L14.93 8.79C15.58 10.1 16.94 11 18.5 11C19.33 11 20 11.67 20 12.5Z",
    fill: "currentColor"
  })));
}, "IconElderly");
import T3 from "classnames";
var A3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconElectricBike } from '@aws-amplify/ui-react'; \u2192 import { MdElectricBike } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: T3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 7H18.18L16.48 2.32C16.19 1.53 15.44 1 14.6 1H12V3H14.6L16.06 7H11.25L10.89 6H12V4H7V6H8.75L10.57 11H9.9C9.46 8.77 7.59 7.12 5.25 7.01C2.45 6.87 0 9.2 0 12C0 14.8 2.2 17 5 17C7.46 17 9.45 15.31 9.9 13H14.1C14.54 15.23 16.41 16.88 18.75 16.99C21.55 17.12 24 14.8 24 11.99C24 9.2 21.8 7 19 7ZM7.82 13C7.42 14.17 6.33 15 5 15C3.32 15 2 13.68 2 12C2 10.32 3.32 9 5 9C6.33 9 7.42 9.83 7.82 11H5V13H7.82ZM14.1 11H12.7L11.97 9H15C14.56 9.58 14.24 10.25 14.1 11ZM19 15C17.32 15 16 13.68 16 12C16 11.07 16.41 10.27 17.05 9.72L18.01 12.36L19.89 11.68L18.92 9.01C18.94 9.01 18.97 9 19 9C20.68 9 22 10.32 22 12C22 13.68 20.68 15 19 15Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M11 20H7L13 23V21H17L11 18V20Z",
    fill: "black"
  })));
}, "IconElectricBike");
import E3 from "classnames";
var O3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconElectricCar } from '@aws-amplify/ui-react'; \u2192 import { MdElectricCar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: E3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.92 2.01C18.72 1.42 18.16 1 17.5 1H6.5C5.84 1 5.29 1.42 5.08 2.01L3 8V16C3 16.55 3.45 17 4 17H5C5.55 17 6 16.55 6 16V15H18V16C18 16.55 18.45 17 19 17H20C20.55 17 21 16.55 21 16V8L18.92 2.01ZM6.85 3H17.14L18.22 6.11H5.77L6.85 3ZM19 13H5V8H19V13Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.5 12C8.32843 12 9 11.3284 9 10.5C9 9.67157 8.32843 9 7.5 9C6.67157 9 6 9.67157 6 10.5C6 11.3284 6.67157 12 7.5 12Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 12C17.3284 12 18 11.3284 18 10.5C18 9.67157 17.3284 9 16.5 9C15.6716 9 15 9.67157 15 10.5C15 11.3284 15.6716 12 16.5 12Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7 20H11V18L17 21H13V23L7 20Z",
    fill: "black"
  })));
}, "IconElectricCar");
import _3 from "classnames";
var G3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconElectricMoped } from '@aws-amplify/ui-react'; \u2192 import { MdElectricMoped } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5C19 3.9 18.1 3 17 3H14V5H17V7.65L13.52 12H10V7H6C3.79 7 2 8.79 2 11V14H4C4 15.66 5.34 17 7 17C8.66 17 10 15.66 10 14H14.48L19 8.35V5ZM4 12V11C4 9.9 4.9 9 6 9H8V12H4ZM7 15C6.45 15 6 14.55 6 14H8C8 14.55 7.55 15 7 15Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10 4H5V6H10V4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19 11C17.34 11 16 12.34 16 14C16 15.66 17.34 17 19 17C20.66 17 22 15.66 22 14C22 12.34 20.66 11 19 11ZM19 15C18.45 15 18 14.55 18 14C18 13.45 18.45 13 19 13C19.55 13 20 13.45 20 14C20 14.55 19.55 15 19 15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7 20H11V18L17 21H13V23L7 20Z",
    fill: "black"
  })));
}, "IconElectricMoped");
import U3 from "classnames";
var z3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconElectricScooter } from '@aws-amplify/ui-react'; \u2192 import { MdElectricScooter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: U3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.82018 16H15.0002V15C15.0002 12.79 16.7902 11 19.0002 11H19.7402L17.8402 2.56C17.6302 1.65 16.8202 1 15.8902 1H12.0002V3H15.8902L17.2902 9.25H17.2802C15.1202 9.9 13.4702 11.73 13.0902 14H7.82018C7.34018 12.66 5.96018 11.76 4.40018 12.06C3.22018 12.29 2.27018 13.26 2.05018 14.44C1.70018 16.34 3.16018 18 5.00018 18C6.30018 18 7.40018 17.16 7.82018 16ZM5.00018 16C4.45018 16 4.00018 15.55 4.00018 15C4.00018 14.45 4.45018 14 5.00018 14C5.55018 14 6.00018 14.45 6.00018 15C6.00018 15.55 5.55018 16 5.00018 16Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M19 12C17.34 12 16 13.34 16 15C16 16.66 17.34 18 19 18C20.66 18 22 16.66 22 15C22 13.34 20.66 12 19 12ZM19 16C18.45 16 18 15.55 18 15C18 14.45 18.45 14 19 14C19.55 14 20 14.45 20 15C20 15.55 19.55 16 19 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11 20H7L13 23V21H17L11 18V20Z",
    fill: "black"
  })));
}, "IconElectricScooter");
import X3 from "classnames";
var K3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconElectricalServices } from '@aws-amplify/ui-react'; \u2192 import { MdElectricalServices } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: X3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 14C21 13.45 20.55 13 20 13H18V15H20C20.55 15 21 14.55 21 14Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M20 17H18V19H20C20.55 19 21 18.55 21 18C21 17.45 20.55 17 20 17Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 14H10V18H12C12 19.1 12.9 20 14 20H17V12H14C12.9 12 12 12.9 12 14Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M5 13C5 11.9 5.9 11 7 11H8.5C10.43 11 12 9.43 12 7.5C12 5.57 10.43 4 8.5 4H5C4.45 4 4 4.45 4 5C4 5.55 4.45 6 5 6H8.5C9.33 6 10 6.67 10 7.5C10 8.33 9.33 9 8.5 9H7C4.79 9 3 10.79 3 13C3 15.21 4.79 17 7 17H9V15H7C5.9 15 5 14.1 5 13Z",
    fill: "black"
  })));
}, "IconElectricalServices");
import q3 from "classnames";
var Q3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconElevator } from '@aws-amplify/ui-react'; \u2192 import { MdElevator } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: q3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10 18V14H11V11.5C11 10.4 10.1 9.5 9 9.5H8C6.9 9.5 6 10.4 6 11.5V14H7V18H10ZM8.5 8.5C9.19 8.5 9.75 7.94 9.75 7.25C9.75 6.56 9.19 6 8.5 6C7.81 6 7.25 6.56 7.25 7.25C7.25 7.94 7.81 8.5 8.5 8.5ZM18 11L15.5 7L13 11H18ZM13 13L15.5 17L18 13H13Z",
    fill: "currentColor"
  })));
}, "IconElevator");
import J3 from "classnames";
var $3 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmail } from '@aws-amplify/ui-react'; \u2192 import { MdEmail } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: J3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z",
    fill: "currentColor"
  })));
}, "IconEmail");
import R3 from "classnames";
var e8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiEmotions } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiEmotions } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: R3(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 18C14.28 18 16.22 16.34 17 14H7C7.78 16.34 9.72 18 12 18Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "black"
  })));
}, "IconEmojiEmotions");
import o8 from "classnames";
var t8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiEvents } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiEvents } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: o8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5H17V3H7V5H5C3.9 5 3 5.9 3 7V8C3 10.55 4.92 12.63 7.39 12.94C8.02 14.44 9.37 15.57 11 15.9V19H7V21H17V19H13V15.9C14.63 15.57 15.98 14.44 16.61 12.94C19.08 12.63 21 10.55 21 8V7C21 5.9 20.1 5 19 5ZM5 8V7H7V10.82C5.84 10.4 5 9.3 5 8ZM12 14C10.35 14 9 12.65 9 11V5H15V11C15 12.65 13.65 14 12 14ZM19 8C19 9.3 18.16 10.4 17 10.82V7H19V8Z",
    fill: "currentColor"
  })));
}, "IconEmojiEvents");
import r8 from "classnames";
var i8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiFlags } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiFlags } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: r8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 9L13 7H7V5.72C7.6 5.38 8 4.74 8 4C8 2.9 7.1 2 6 2C4.9 2 4 2.9 4 4C4 4.74 4.4 5.38 5 5.72V21H7V17H12L13 19H20V9H14ZM18 17H14L13 15H7V9H12L13 11H18V17Z",
    fill: "currentColor"
  })));
}, "IconEmojiFlags");
import s8 from "classnames";
var a8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiFoodBeverage } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiFoodBeverage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: s8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 19H2V21H20V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M20 3H4V13C4 15.21 5.79 17 8 17H14C16.21 17 18 15.21 18 13V10H20C21.11 10 22 9.11 22 8V5C22 3.89 21.11 3 20 3ZM16 13C16 14.1 15.1 15 14 15H8C6.9 15 6 14.1 6 13V5H9V6.4L7.19 7.85C7.07 7.94 7 8.09 7 8.24V12.5C7 12.78 7.22 13 7.5 13H11.5C11.78 13 12 12.78 12 12.5V8.24C12 8.09 11.93 7.94 11.81 7.85L10 6.4V5H16V13ZM9.5 7.28L11 8.48V12H8V8.48L9.5 7.28ZM20 8H18V5H20V8Z",
    fill: "black"
  })));
}, "IconEmojiFoodBeverage");
import n8 from "classnames";
var m8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiNature } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiNature } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: n8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.94 4.88C21.76 4.35 21.25 4 20.68 4C20.65 4 20.62 4 20.59 4H19.6L19.29 3.03C19.15 2.43 18.61 2 18 2C17.39 2 16.85 2.43 16.71 3.04L16.4 4H15.42C15.39 4 15.36 4 15.33 4C14.76 4 14.25 4.35 14.07 4.88C13.88 5.44 14.11 6.05 14.63 6.36L15.5 6.88L15.1 8.12C14.87 8.7 15.06 9.37 15.55 9.74C15.78 9.91 16.06 10 16.33 10C16.64 10 16.94 9.89 17.19 9.68L18 8.98L18.81 9.68C19.06 9.89 19.36 10 19.67 10C19.94 10 20.22 9.91 20.45 9.74C20.95 9.37 21.13 8.7 20.9 8.12L20.51 6.88L21.38 6.36C21.89 6.05 22.12 5.44 21.94 4.88ZM18 7C17.45 7 17 6.55 17 6C17 5.45 17.45 5 18 5C18.55 5 19 5.45 19 6C19 6.55 18.55 7 18 7Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M13.49 10.51C13.06 10.08 12.55 9.78 12 9.58V8H11V9.38C10.89 9.37 10.77 9.35 10.66 9.35C9.64002 9.35 8.61002 9.74 7.83002 10.52C7.71002 10.64 7.53002 10.82 7.33002 11.02L6.00002 10.52C4.44002 9.97 2.72002 10.79 2.17002 12.34C1.90002 13.09 1.94002 13.91 2.29002 14.63C2.52002 15.11 2.87002 15.5 3.29002 15.79C2.91002 17.14 3.23002 18.64 4.29002 19.7C5.07002 20.48 6.09002 20.87 7.12002 20.87C7.49002 20.87 7.85002 20.8 8.21002 20.7C8.50002 21.12 8.89002 21.47 9.37002 21.7C9.78002 21.9 10.21 22 10.65 22C10.99 22 11.33 21.94 11.66 21.83C13.22 21.28 14.04 19.56 13.48 17.98L12.99 16.68C13.19 16.48 13.37 16.3 13.49 16.18C14.36 15.31 14.73 14.14 14.63 13.01H16V12.01H14.41C14.22 11.46 13.92 10.95 13.49 10.51ZM7.58002 18.82C7.43002 18.86 7.28002 18.88 7.12002 18.88C6.59002 18.88 6.08002 18.67 5.71002 18.29C5.33002 17.91 5.12002 17.41 5.12002 16.88C5.12002 16.72 5.15002 16.56 5.18002 16.41C5.32002 16.42 5.46002 16.44 5.60002 16.44C6.45002 16.44 7.28002 16.24 8.04002 15.96C7.72002 16.85 7.50002 17.83 7.58002 18.82ZM4.67002 14.29C4.42002 14.2 4.22002 14.02 4.10002 13.78C3.98002 13.54 3.97002 13.27 4.06002 13.02C4.25002 12.5 4.82002 12.23 5.32002 12.41L8.48002 13.6C7.33002 14.2 5.85002 14.71 4.67002 14.29ZM10.99 19.94C10.74 20.03 10.47 20.02 10.23 19.9C9.99002 19.79 9.81002 19.58 9.72002 19.33C9.30002 18.15 9.81002 16.68 10.42 15.53L11.6 18.66C11.78 19.18 11.51 19.76 10.99 19.94ZM12.2 14.6L11.59 12.99C11.59 12.98 11.58 12.97 11.57 12.96C11.55 12.92 11.53 12.88 11.51 12.84C11.49 12.8 11.47 12.77 11.44 12.73C11.41 12.7 11.38 12.67 11.35 12.64C11.32 12.61 11.29 12.58 11.26 12.55C11.23 12.52 11.19 12.5 11.15 12.48C11.11 12.46 11.08 12.43 11.03 12.42C11.02 12.42 11.01 12.41 11 12.4L9.40002 11.8C9.76002 11.51 10.19 11.34 10.66 11.34C11.19 11.34 11.7 11.55 12.07 11.93C12.8 12.66 12.84 13.81 12.2 14.6Z",
    fill: "black"
  })));
}, "IconEmojiNature");
import c8 from "classnames";
var l8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiObjects } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiObjects } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: c8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.9998 3C11.5398 3 11.0698 3.04 10.5998 3.14C7.83983 3.67 5.63983 5.9 5.11983 8.66C4.63983 11.27 5.59983 13.67 7.33983 15.22C7.76983 15.6 7.99983 16.13 7.99983 16.69V19C7.99983 20.1 8.89983 21 9.99983 21H10.2798C10.6298 21.6 11.2598 22 11.9998 22C12.7398 22 13.3798 21.6 13.7198 21H13.9998C15.0998 21 15.9998 20.1 15.9998 19V16.69C15.9998 16.14 16.2198 15.6 16.6398 15.23C18.0898 13.95 18.9998 12.08 18.9998 10C18.9998 6.13 15.8698 3 11.9998 3ZM13.9998 17H9.99983V16H13.9998V17ZM9.99983 19V18H13.9998V19H9.99983ZM15.3098 13.74C15.2198 13.82 15.1498 13.92 15.0698 14H8.91983C8.83983 13.91 8.76983 13.81 8.67983 13.73C7.35983 12.55 6.76983 10.79 7.08983 9.03C7.44983 7.09 9.04983 5.48 10.9798 5.1C11.3198 5.03 11.6598 5 11.9998 5C14.7598 5 16.9998 7.24 16.9998 10C16.9998 11.43 16.3898 12.79 15.3098 13.74Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12.5 11H11.5V14H12.5V11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10.3795 8.87371L9.67236 9.58081L11.7937 11.7021L12.5008 10.995L10.3795 8.87371Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11.5009 11.0053L12.208 11.7124L14.3293 9.5911L13.6222 8.884L11.5009 11.0053Z",
    fill: "black"
  })));
}, "IconEmojiObjects");
import p8 from "classnames";
var h8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiPeople } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiPeople } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: p8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C13.1046 6 14 5.10457 14 4C14 2.89543 13.1046 2 12 2C10.8954 2 10 2.89543 10 4C10 5.10457 10.8954 6 12 6Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15.89 8.11C15.5 7.72 14.83 7 13.53 7C13.32 7 12.11 7 10.99 7C8.24 6.99 6 4.75 6 2H4C4 5.16 6.11 7.84 9 8.71V22H11V16H13V22H15V10.05L18.95 14L20.36 12.59L15.89 8.11Z",
    fill: "black"
  })));
}, "IconEmojiPeople");
import f8 from "classnames";
var C8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiSymbols } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiSymbols } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: f8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 2H3V4H11V2Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M6 11H8V7H11V5H3V7H6V11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M20.1814 12.4035L12.4033 20.1816L13.8175 21.5958L21.5956 13.8177L20.1814 12.4035Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14.5 16C15.3284 16 16 15.3284 16 14.5C16 13.6716 15.3284 13 14.5 13C13.6716 13 13 13.6716 13 14.5C13 15.3284 13.6716 16 14.5 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19.5 21C20.3284 21 21 20.3284 21 19.5C21 18.6716 20.3284 18 19.5 18C18.6716 18 18 18.6716 18 19.5C18 20.3284 18.6716 21 19.5 21Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15.5 11C16.88 11 18 9.88 18 8.5V4H21V2H17V6.51C16.58 6.19 16.07 6 15.5 6C14.12 6 13 7.12 13 8.5C13 9.88 14.12 11 15.5 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M9.73986 15.96L8.32986 17.37L7.61986 16.66L7.96986 16.31C8.94986 15.33 8.94986 13.75 7.96986 12.77C7.47986 12.28 6.83986 12.04 6.19986 12.04C5.55986 12.04 4.91986 12.28 4.42986 12.77C3.44986 13.75 3.44986 15.33 4.42986 16.31L4.77986 16.66L3.71986 17.72C2.73986 18.7 2.73986 20.28 3.71986 21.26C4.21986 21.76 4.85986 22 5.49986 22C6.13986 22 6.77986 21.76 7.26986 21.27L8.32986 20.21L9.73986 21.62L11.1499 20.21L9.73986 18.8L11.1499 17.39L9.73986 15.96ZM5.84986 14.2C5.96986 14.08 6.10986 14.05 6.19986 14.05C6.28986 14.05 6.42986 14.08 6.54986 14.2C6.73986 14.4 6.73986 14.71 6.54986 14.91L6.19986 15.26L5.84986 14.9C5.65986 14.71 5.65986 14.39 5.84986 14.2ZM5.84986 19.85C5.72986 19.97 5.58986 20 5.49986 20C5.40986 20 5.26986 19.97 5.14986 19.85C4.95986 19.66 4.95986 19.34 5.14986 19.14L6.20986 18.08L6.91986 18.79L5.84986 19.85Z",
    fill: "black"
  })));
}, "IconEmojiSymbols");
import g8 from "classnames";
var u8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEmojiTransportation } from '@aws-amplify/ui-react'; \u2192 import { MdEmojiTransportation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: g8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.57 10.66C20.43 10.26 20.05 10 19.6 10H12.41C11.95 10 11.58 10.26 11.43 10.66L10 14.77L10.01 20.28C10.01 20.66 10.32 21 10.7 21H11.32C11.7 21 12 20.62 12 20.24V19H20V20.24C20 20.62 20.31 21 20.69 21H21.3C21.68 21 21.99 20.66 21.99 20.28L22 18.91V14.77L20.57 10.66ZM12.41 11H19.6L20.63 14H11.38L12.41 11ZM12 17C11.45 17 11 16.55 11 16C11 15.45 11.45 15 12 15C12.55 15 13 15.45 13 16C13 16.55 12.55 17 12 17ZM20 17C19.45 17 19 16.55 19 16C19 15.45 19.45 15 20 15C20.55 15 21 15.45 21 16C21 16.55 20.55 17 20 17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M14 9H15V3H7V8H2V21H3V9H8V4H14V9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7 11H5V13H7V11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 5H10V7H12V5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7 15H5V17H7V15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7 19H5V21H7V19Z",
    fill: "black"
  })));
}, "IconEmojiTransportation");
import w8 from "classnames";
var d8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEngineering } from '@aws-amplify/ui-react'; \u2192 import { MdEngineering } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: w8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 15C6.33 15 1 16.34 1 19V21H17V19C17 16.34 11.67 15 9 15ZM3 19C3.22 18.28 6.31 17 9 17C11.7 17 14.8 18.29 15 19H3Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M4.74 9H5C5 11.21 6.79 13 9 13C11.21 13 13 11.21 13 9H13.26C13.53 9 13.75 8.78 13.75 8.51V8.49C13.75 8.22 13.53 8 13.26 8H13C13 6.52 12.19 5.25 11 4.55V5.5C11 5.78 10.78 6 10.5 6C10.22 6 10 5.78 10 5.5V4.14C9.68 4.06 9.35 4 9 4C8.65 4 8.32 4.06 8 4.14V5.5C8 5.78 7.78 6 7.5 6C7.22 6 7 5.78 7 5.5V4.55C5.81 5.25 5 6.52 5 8H4.74C4.47 8 4.25 8.22 4.25 8.49V8.52C4.25 8.78 4.47 9 4.74 9ZM11 9C11 10.1 10.1 11 9 11C7.9 11 7 10.1 7 9H11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M21.9798 6.23L22.9098 5.4L22.1598 4.1L20.9698 4.49C20.8298 4.38 20.6698 4.29 20.4998 4.22L20.2498 3H18.7498L18.4998 4.22C18.3298 4.29 18.1698 4.38 18.0198 4.49L16.8398 4.1L16.0898 5.4L17.0198 6.23C16.9998 6.4 16.9998 6.58 17.0198 6.75L16.0898 7.6L16.8398 8.9L18.0398 8.52C18.1698 8.62 18.3198 8.7 18.4698 8.77L18.7498 10H20.2498L20.5198 8.78C20.6798 8.71 20.8198 8.63 20.9598 8.53L22.1498 8.91L22.8998 7.61L21.9698 6.76C21.9998 6.57 21.9898 6.4 21.9798 6.23ZM19.4998 7.75C18.8098 7.75 18.2498 7.19 18.2498 6.5C18.2498 5.81 18.8098 5.25 19.4998 5.25C20.1898 5.25 20.7498 5.81 20.7498 6.5C20.7498 7.19 20.1898 7.75 19.4998 7.75Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19.3998 10.79L18.5498 11.07C18.4498 10.99 18.3398 10.93 18.2198 10.88L18.0398 10H16.9698L16.7898 10.87C16.6698 10.92 16.5498 10.99 16.4498 11.06L15.6098 10.78L15.0698 11.71L15.7298 12.3C15.7198 12.43 15.7198 12.55 15.7298 12.67L15.0698 13.28L15.6098 14.21L16.4698 13.94C16.5698 14.01 16.6698 14.07 16.7798 14.12L16.9598 15H18.0298L18.2198 14.13C18.3298 14.08 18.4398 14.02 18.5398 13.95L19.3898 14.22L19.9298 13.29L19.2698 12.68C19.2798 12.55 19.2798 12.43 19.2698 12.31L19.9298 11.72L19.3998 10.79ZM17.4998 13.39C17.0098 13.39 16.6098 12.99 16.6098 12.5C16.6098 12.01 17.0098 11.61 17.4998 11.61C17.9898 11.61 18.3898 12.01 18.3898 12.5C18.3898 12.99 17.9898 13.39 17.4998 13.39Z",
    fill: "black"
  })));
}, "IconEngineering");
import V8 from "classnames";
var H8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEnhancedEncryption } from '@aws-amplify/ui-react'; \u2192 import { MdEnhancedEncryption } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: V8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H8.9V6ZM18 20H6V10H18V20ZM13 11H11V14H8V16H11V19H13V16H16V14H13V11Z",
    fill: "currentColor"
  })));
}, "IconEnhancedEncryption");
import M8 from "classnames";
var x8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEqualizer } from '@aws-amplify/ui-react'; \u2192 import { MdEqualizer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: M8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 20H14V4H10V20ZM4 20H8V12H4V20ZM16 9V20H20V9H16Z",
    fill: "currentColor"
  })));
}, "IconEqualizer");
import I8 from "classnames";
var L8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconErrorOutline } from '@aws-amplify/ui-react'; \u2192 import { MdErrorOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: I8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconErrorOutline");
import v8 from "classnames";
var Wt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: v8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
    fill: "currentColor"
  })));
}, "IconError");
import N8 from "classnames";
var y8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEscalatorWarning } from '@aws-amplify/ui-react'; \u2192 import { MdEscalatorWarning } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: N8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.5 2C7.6 2 8.5 2.9 8.5 4C8.5 5.1 7.6 6 6.5 6C5.4 6 4.5 5.1 4.5 4C4.5 2.9 5.4 2 6.5 2ZM15.5 9.5C15.5 10.33 16.17 11 17 11C17.83 11 18.5 10.33 18.5 9.5C18.5 8.67 17.83 8 17 8C16.17 8 15.5 8.67 15.5 9.5ZM18.5 12H15.66C15.08 12.01 14.52 12.32 14.21 12.86L13.29 14.18L9.72 8C9.35 7.37 8.69 7.01 8.01 7H5C3.9 7 3 7.9 3 9V15H4.5V22H9.5V11.61L12.03 16H14.23L15 14.9V22H19V17H20V13.5C20 12.68 19.33 12 18.5 12Z",
    fill: "currentColor"
  })));
}, "IconEscalatorWarning");
import b8 from "classnames";
var Z8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEscalator } from '@aws-amplify/ui-react'; \u2192 import { MdEscalator } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: b8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM17 6H13.7L8.7 15H7C6.17 15 5.5 15.67 5.5 16.5C5.5 17.33 6.17 18 7 18H10.3L15.3 9H17C17.83 9 18.5 8.33 18.5 7.5C18.5 6.67 17.83 6 17 6Z",
    fill: "currentColor"
  })));
}, "IconEscalator");
import B8 from "classnames";
var W8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEuroSymbol } from '@aws-amplify/ui-react'; \u2192 import { MdEuroSymbol } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: B8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 18.5C12.49 18.5 10.32 17.08 9.24 15H15V13H8.58C8.53 12.67 8.5 12.34 8.5 12C8.5 11.66 8.53 11.33 8.58 11H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5C16.61 5.5 18.09 6.09 19.23 7.07L21 5.3C19.41 3.87 17.3 3 15 3C11.08 3 7.76 5.51 6.52 9H3V11H6.06C6.02 11.33 6 11.66 6 12C6 12.34 6.02 12.67 6.06 13H3V15H6.52C7.76 18.49 11.08 21 15 21C17.31 21 19.41 20.13 21 18.7L19.22 16.93C18.09 17.91 16.62 18.5 15 18.5Z",
    fill: "currentColor"
  })));
}, "IconEuroSymbol");
import k8 from "classnames";
var D8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEuro } from '@aws-amplify/ui-react'; \u2192 import { MdEuro } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: k8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 18.5C12.49 18.5 10.32 17.08 9.24 15H15L16 13H8.58C8.53 12.67 8.5 12.34 8.5 12C8.5 11.66 8.53 11.33 8.58 11H15L16 9H9.24C10.32 6.92 12.5 5.5 15 5.5C16.61 5.5 18.09 6.09 19.23 7.07L21 5.3C19.41 3.87 17.3 3 15 3C11.08 3 7.76 5.51 6.52 9H3L2 11H6.06C6.02 11.33 6 11.66 6 12C6 12.34 6.02 12.67 6.06 13H3L2 15H6.52C7.76 18.49 11.08 21 15 21C17.31 21 19.41 20.13 21 18.7L19.22 16.93C18.09 17.91 16.62 18.5 15 18.5Z",
    fill: "currentColor"
  })));
}, "IconEuro");
import P8 from "classnames";
var S8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEvStation } from '@aws-amplify/ui-react'; \u2192 import { MdEvStation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: P8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.77 7.23L19.78 7.22L16.06 3.5L15 4.56L17.11 6.67C16.17 7.03 15.5 7.93 15.5 9C15.5 10.38 16.62 11.5 18 11.5C18.36 11.5 18.69 11.42 19 11.29V18.5C19 19.05 18.55 19.5 18 19.5C17.45 19.5 17 19.05 17 18.5V14C17 12.9 16.1 12 15 12H14V5C14 3.9 13.1 3 12 3H6C4.9 3 4 3.9 4 5V21H14V13.5H15.5V18.5C15.5 19.88 16.62 21 18 21C19.38 21 20.5 19.88 20.5 18.5V9C20.5 8.31 20.22 7.68 19.77 7.23ZM12 11V19H6V5H12V11ZM18 10C17.45 10 17 9.55 17 9C17 8.45 17.45 8 18 8C18.55 8 19 8.45 19 9C19 9.55 18.55 10 18 10ZM10 6L6 13.5H8V18L12 11H10V6Z",
    fill: "currentColor"
  })));
}, "IconEvStation");
import j8 from "classnames";
var Y8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEventAvailable } from '@aws-amplify/ui-react'; \u2192 import { MdEventAvailable } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: j8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V9H19V19ZM5 7V5H19V7H5ZM10.56 17.46L16.49 11.53L15.43 10.47L10.56 15.34L8.45 13.23L7.39 14.29L10.56 17.46Z",
    fill: "currentColor"
  })));
}, "IconEventAvailable");
import F8 from "classnames";
var T8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEventBusy } from '@aws-amplify/ui-react'; \u2192 import { MdEventBusy } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: F8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V9H19V19ZM5 7V5H19V7H5ZM8.23 16.41L9.29 17.47L11.73 15.03L14.17 17.47L15.23 16.41L12.79 13.97L15.23 11.53L14.17 10.47L11.73 12.91L9.29 10.47L8.23 11.53L10.67 13.97L8.23 16.41Z",
    fill: "currentColor"
  })));
}, "IconEventBusy");
import A8 from "classnames";
var E8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEventNote } from '@aws-amplify/ui-react'; \u2192 import { MdEventNote } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: A8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V9H19V19ZM5 7V5H19V7H5ZM7 11H17V13H7V11ZM7 15H14V17H7V15Z",
    fill: "currentColor"
  })));
}, "IconEventNote");
import O8 from "classnames";

var _8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEventSeat } from '@aws-amplify/ui-react'; \u2192 import { MdEventSeat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: O8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 5V12H9V5H15ZM15 3H9C7.9 3 7 3.9 7 5V14H17V5C17 3.9 16.1 3 15 3ZM22 10H19V13H22V10ZM5 10H2V13H5V10ZM20 15H4V21H6V17H18V21H20V15Z",
    fill: "currentColor"
  })));
}, "IconEventSeat");

import G8 from "classnames";
var U8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconEvent } from '@aws-amplify/ui-react'; \u2192 import { MdEvent } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: G8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z",
    fill: "currentColor"
  })));
}, "IconEvent");
import z8 from "classnames";
var X8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExitToApp } from '@aws-amplify/ui-react'; \u2192 import { MdExitToApp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: z8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.09 15.59L11.5 17L16.5 12L11.5 7L10.09 8.41L12.67 11H3V13H12.67L10.09 15.59ZM19 3H5C3.89 3 3 3.9 3 5V9H5V5H19V19H5V15H3V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
    fill: "currentColor"
  })));
}, "IconExitToApp");
import K8 from "classnames";
var q8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExpandLess } from '@aws-amplify/ui-react'; \u2192 import { MdExpandLess } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: K8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 8L6 14L7.41 15.41L12 10.83L16.59 15.41L18 14L12 8Z",
    fill: "currentColor"
  })));
}, "IconExpandLess");
import Q8 from "classnames";
var Ge = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Q8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z",
    fill: "currentColor"
  })));
}, "IconExpandMore");
import J8 from "classnames";
var $8 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExplicit } from '@aws-amplify/ui-react'; \u2192 import { MdExplicit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: J8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15 15H11V13H15V11H11V9H15V7H9V17H15V15Z",
    fill: "currentColor"
  })));
}, "IconExplicit");
import R8 from "classnames";
var e7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExploreOff } from '@aws-amplify/ui-react'; \u2192 import { MdExploreOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: R8(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 13.48 19.59 14.86 18.88 16.06L20.34 17.52C21.39 15.93 22 14.04 22 12C22 6.48 17.52 2 12 2C9.96 2 8.07 2.61 6.49 3.66L7.95 5.12C9.14 4.41 10.52 4 12 4ZM14.91 12.08L17.5 6.5L11.92 9.09L14.91 12.08ZM2.1 4.93L3.66 6.49C2.61 8.07 2 9.96 2 12C2 17.52 6.48 22 12 22C14.04 22 15.93 21.39 17.51 20.34L19.07 21.9L20.48 20.49L3.51 3.51L2.1 4.93ZM5.12 7.94L9.1 11.92L6.5 17.5L12.08 14.91L16.06 18.89C14.86 19.59 13.48 20 12 20C7.59 20 4 16.41 4 12C4 10.52 4.41 9.14 5.12 7.94V7.94Z",
    fill: "currentColor"
  })));
}, "IconExploreOff");
import o7 from "classnames";
var t7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExplore } from '@aws-amplify/ui-react'; \u2192 import { MdExplore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: o7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM6.5 17.5L14.01 14.01L17.5 6.5L9.99 9.99L6.5 17.5ZM12 10.9C12.61 10.9 13.1 11.39 13.1 12C13.1 12.61 12.61 13.1 12 13.1C11.39 13.1 10.9 12.61 10.9 12C10.9 11.39 11.39 10.9 12 10.9Z",
    fill: "currentColor"
  })));
}, "IconExplore");
import r7 from "classnames";
var i7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExposureNeg_1 } from '@aws-amplify/ui-react'; \u2192 import { MdExposureNeg_1 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: r7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 11V13H12V11H4ZM19 18H17V7.38L14 8.4V6.7L18.7 5H19V18Z",
    fill: "currentColor"
  })));
}, "IconExposureNeg_1");
import s7 from "classnames";
var a7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExposureNeg_2 } from '@aws-amplify/ui-react'; \u2192 import { MdExposureNeg_2 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: s7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.05 16.29L17.91 13.22C18.29 12.83 18.63 12.43 18.95 12.04C19.27 11.65 19.54 11.26 19.77 10.87C20 10.48 20.18 10.09 20.31 9.7C20.44 9.31 20.5 8.91 20.5 8.52C20.5 7.99 20.41 7.5 20.23 7.06C20.05 6.62 19.79 6.25 19.45 5.95C19.11 5.64 18.68 5.41 18.19 5.24C17.68 5.08 17.11 5 16.47 5C15.78 5 15.16 5.11 14.62 5.32C14.08 5.53 13.62 5.83 13.26 6.2C12.89 6.57 12.61 7 12.42 7.5C12.24 7.97 12.15 8.47 12.14 9H14.28C14.29 8.69 14.33 8.4 14.41 8.13C14.5 7.84 14.64 7.59 14.81 7.38C14.99 7.17 15.22 7.01 15.49 6.89C15.76 6.77 16.09 6.71 16.45 6.71C16.76 6.71 17.03 6.76 17.26 6.86C17.49 6.96 17.69 7.11 17.85 7.29C18.01 7.47 18.13 7.69 18.22 7.94C18.3 8.19 18.35 8.46 18.35 8.75C18.35 8.97 18.32 9.18 18.27 9.4C18.21 9.62 18.12 9.85 17.98 10.1C17.84 10.35 17.66 10.63 17.42 10.93C17.19 11.23 16.9 11.58 16.54 11.96L12.37 16.51V18H21V16.29H15.05ZM2 11V13H10V11H2Z",
    fill: "currentColor"
  })));
}, "IconExposureNeg_2");
import n7 from "classnames";
var m7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExposurePlus_1 } from '@aws-amplify/ui-react'; \u2192 import { MdExposurePlus_1 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: n7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 7H8V11H4V13H8V17H10V13H14V11H10V7ZM20 18H18V7.38L15 8.4V6.7L19.7 5H20V18Z",
    fill: "currentColor"
  })));
}, "IconExposurePlus_1");
import c7 from "classnames";
var l7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExposurePlus_2 } from '@aws-amplify/ui-react'; \u2192 import { MdExposurePlus_2 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: c7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.05 16.29L18.91 13.22C19.29 12.83 19.63 12.43 19.95 12.04C20.27 11.65 20.54 11.26 20.77 10.87C21 10.48 21.18 10.09 21.31 9.7C21.44 9.31 21.5 8.91 21.5 8.52C21.5 7.99 21.41 7.5 21.23 7.06C21.05 6.62 20.79 6.25 20.45 5.95C20.11 5.64 19.68 5.41 19.19 5.24C18.68 5.08 18.11 5 17.47 5C16.78 5 16.16 5.11 15.62 5.32C15.08 5.53 14.62 5.83 14.26 6.2C13.89 6.57 13.61 7 13.42 7.5C13.24 7.97 13.15 8.47 13.14 9H15.28C15.29 8.69 15.33 8.4 15.41 8.13C15.5 7.84 15.64 7.59 15.81 7.38C15.99 7.17 16.22 7.01 16.49 6.89C16.76 6.77 17.09 6.71 17.45 6.71C17.76 6.71 18.03 6.76 18.26 6.86C18.49 6.96 18.69 7.11 18.85 7.29C19.01 7.47 19.13 7.69 19.22 7.94C19.3 8.19 19.35 8.46 19.35 8.75C19.35 8.97 19.32 9.18 19.27 9.4C19.21 9.62 19.12 9.85 18.98 10.1C18.84 10.35 18.66 10.63 18.42 10.93C18.19 11.23 17.9 11.58 17.54 11.96L13.37 16.51V18H22V16.29H16.05ZM8 7H6V11H2V13H6V17H8V13H12V11H8V7Z",
    fill: "currentColor"
  })));
}, "IconExposurePlus_2");
import p7 from "classnames";
var h7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExposureZero } from '@aws-amplify/ui-react'; \u2192 import { MdExposureZero } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: p7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.1401 12.5C16.1401 13.5 16.0401 14.35 15.8401 15.05C15.6401 15.75 15.3601 16.32 15.0101 16.75C14.6501 17.19 14.2201 17.5 13.7101 17.7C13.2001 17.9 12.6401 18 12.0101 18C11.3901 18 10.8301 17.9 10.3201 17.7C9.81011 17.5 9.37011 17.19 9.01011 16.75C8.65011 16.31 8.36011 15.74 8.16011 15.05C7.96011 14.35 7.86011 13.5 7.86011 12.5V10.46C7.86011 9.46 7.96011 8.61 8.16011 7.91C8.36011 7.21 8.64011 6.65 9.00011 6.22C9.36011 5.79 9.80011 5.48 10.3101 5.29C10.8101 5.1 11.3801 5 12.0001 5C12.6301 5 13.1901 5.1 13.7001 5.29C14.2101 5.48 14.6501 5.79 15.0101 6.22C15.3701 6.65 15.6501 7.21 15.8501 7.91C16.0501 8.61 16.1501 9.45 16.1501 10.46V12.5H16.1401V12.5ZM14.0301 10.14C14.0301 9.5 13.9801 8.96 13.9001 8.52C13.8101 8.08 13.6801 7.73 13.5001 7.46C13.3301 7.19 13.1101 7 12.8601 6.88C12.6101 6.75 12.3201 6.69 12.0001 6.69C11.6801 6.69 11.3901 6.75 11.1401 6.87C10.8901 6.99 10.6701 7.18 10.5001 7.45C10.3301 7.72 10.1901 8.07 10.1001 8.51C10.0101 8.95 9.97011 9.49 9.97011 10.13V12.8C9.97011 13.44 10.0201 13.98 10.1101 14.42C10.2001 14.87 10.3401 15.23 10.5101 15.51C10.6801 15.79 10.9001 15.99 11.1501 16.12C11.4001 16.25 11.6901 16.31 12.0201 16.31C12.3501 16.31 12.6401 16.25 12.8901 16.12C13.1401 15.99 13.3501 15.79 13.5201 15.51C13.6901 15.23 13.8201 14.87 13.9101 14.42C14.0001 13.97 14.0401 13.43 14.0401 12.8V10.14H14.0301V10.14Z",
    fill: "currentColor"
  })));
}, "IconExposureZero");
import f7 from "classnames";
var C7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExposure } from '@aws-amplify/ui-react'; \u2192 import { MdExposure } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: f7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM17.59 5L5 17.59V5H17.59ZM6.41 19L19 6.41V19H6.41ZM6 7H11V8.5H6V7ZM16 12.5H14.5V14.5H12.5V16H14.5V18H16V16H18V14.5H16V12.5Z",
    fill: "currentColor"
  })));
}, "IconExposure");
import g7 from "classnames";
var u7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconExtension } from '@aws-amplify/ui-react'; \u2192 import { MdExtension } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: g7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.5 4.5C10.78 4.5 11 4.72 11 5V7H17V13H19C19.28 13 19.5 13.22 19.5 13.5C19.5 13.78 19.28 14 19 14H17V20H14.88C14.2 18.25 12.49 17 10.5 17C8.51 17 6.8 18.25 6.12 20H4V17.88C5.75 17.2 7 15.49 7 13.5C7 11.51 5.76 9.8 4.01 9.12L4 7H10V5C10 4.72 10.22 4.5 10.5 4.5ZM10.5 2.5C9.12 2.5 8 3.62 8 5H4C2.9 5 2.01 5.9 2.01 7V10.8H2.3C3.79 10.8 5 12.01 5 13.5C5 14.99 3.79 16.2 2.3 16.2H2V20C2 21.1 2.9 22 4 22H7.8V21.7C7.8 20.21 9.01 19 10.5 19C11.99 19 13.2 20.21 13.2 21.7V22H17C18.1 22 19 21.1 19 20V16C20.38 16 21.5 14.88 21.5 13.5C21.5 12.12 20.38 11 19 11V7C19 5.9 18.1 5 17 5H13C13 3.62 11.88 2.5 10.5 2.5Z",
    fill: "currentColor"
  })));
}, "IconExtension");
import w7 from "classnames";
var d7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFaceUnlock } from '@aws-amplify/ui-react'; \u2192 import { MdFaceUnlock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: w7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.25 13C10.25 13.69 9.69 14.25 9 14.25C8.31 14.25 7.75 13.69 7.75 13C7.75 12.31 8.31 11.75 9 11.75C9.69 11.75 10.25 12.31 10.25 13ZM15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75ZM22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM10.66 4.12C12.06 6.44 14.6 8 17.5 8C17.96 8 18.41 7.95 18.84 7.88C17.44 5.56 14.9 4 12 4C11.54 4 11.09 4.05 10.66 4.12ZM4.42 9.47C6.13 8.5 7.45 6.92 8.08 5.03C6.37 6 5.05 7.58 4.42 9.47ZM20 12C20 11.22 19.88 10.47 19.67 9.76C18.97 9.91 18.25 10 17.5 10C14.37 10 11.58 8.56 9.74 6.31C8.69 8.87 6.6 10.88 4 11.86C4.01 11.9 4 11.95 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12Z",
    fill: "currentColor"
  })));
}, "IconFaceUnlock");
import V7 from "classnames";
var H7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFace } from '@aws-amplify/ui-react'; \u2192 import { MdFace } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: V7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.25 13C10.25 13.69 9.69 14.25 9 14.25C8.31 14.25 7.75 13.69 7.75 13C7.75 12.31 8.31 11.75 9 11.75C9.69 11.75 10.25 12.31 10.25 13ZM15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75ZM22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM10.66 4.12C12.06 6.44 14.6 8 17.5 8C17.96 8 18.41 7.95 18.84 7.88C17.44 5.56 14.9 4 12 4C11.54 4 11.09 4.05 10.66 4.12ZM4.42 9.47C6.13 8.5 7.45 6.92 8.08 5.03C6.37 6 5.05 7.58 4.42 9.47ZM20 12C20 11.22 19.88 10.47 19.67 9.76C18.97 9.91 18.25 10 17.5 10C14.37 10 11.58 8.56 9.74 6.31C8.69 8.87 6.6 10.88 4 11.86C4.01 11.9 4 11.95 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12Z",
    fill: "currentColor"
  })));
}, "IconFace");
import M7 from "classnames";
var x7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFacebook } from '@aws-amplify/ui-react'; \u2192 import { MdFacebook } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: M7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 16.84 5.44 20.87 10 21.8V15H8V12H10V9.5C10 7.57 11.57 6 13.5 6H16V9H14C13.45 9 13 9.45 13 10V12H16V15H13V21.95C18.05 21.45 22 17.19 22 12Z",
    fill: "currentColor"
  })));
}, "IconFacebook");
import I7 from "classnames";
var L7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFactCheck } from '@aws-amplify/ui-react'; \u2192 import { MdFactCheck } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: I7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM20 19H4V5H20V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M19.41 10.42L17.99 9L14.82 12.17L13.41 10.75L12 12.16L14.82 15L19.41 10.42Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10 7H5V9H10V7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10 11H5V13H10V11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10 15H5V17H10V15Z",
    fill: "black"
  })));
}, "IconFactCheck");
import v7 from "classnames";
var N7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFamilyRestroom } from '@aws-amplify/ui-react'; \u2192 import { MdFamilyRestroom } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: v7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 4C16 2.89 16.89 2 18 2C19.11 2 20 2.89 20 4C20 5.11 19.11 6 18 6C16.89 6 16 5.11 16 4ZM20 22V16H22.5L19.96 8.37C19.68 7.55 18.92 7 18.06 7H17.94C17.08 7 16.31 7.55 16.04 8.37L15.18 10.95C16.26 11.55 17 12.68 17 14V22H20ZM12.5 11.5C13.33 11.5 14 10.83 14 10C14 9.17 13.33 8.5 12.5 8.5C11.67 8.5 11 9.17 11 10C11 10.83 11.67 11.5 12.5 11.5ZM5.5 6C6.61 6 7.5 5.11 7.5 4C7.5 2.89 6.61 2 5.5 2C4.39 2 3.5 2.89 3.5 4C3.5 5.11 4.39 6 5.5 6ZM7.5 22V15H9V9C9 7.9 8.1 7 7 7H4C2.9 7 2 7.9 2 9V15H3.5V22H7.5ZM14 22V18H15V14C15 13.18 14.32 12.5 13.5 12.5H11.5C10.68 12.5 10 13.18 10 14V18H11V22H14Z",
    fill: "currentColor"
  })));
}, "IconFamilyRestroom");
import y7 from "classnames";
var b7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFastForward } from '@aws-amplify/ui-react'; \u2192 import { MdFastForward } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: y7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 9.86L18.03 12L15 14.14V9.86ZM6 9.86L9.03 12L6 14.14V9.86ZM13 6V18L21.5 12L13 6ZM4 6V18L12.5 12L4 6Z",
    fill: "currentColor"
  })));
}, "IconFastForward");
import Z7 from "classnames";
var B7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFastRewind } from '@aws-amplify/ui-react'; \u2192 import { MdFastRewind } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Z7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 9.86V14.14L14.97 12L18 9.86ZM9 9.86V14.14L5.97 12L9 9.86ZM20 6L11.5 12L20 18V6ZM11 6L2.5 12L11 18V6Z",
    fill: "currentColor"
  })));
}, "IconFastRewind");
import W7 from "classnames";
var k7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFastfood } from '@aws-amplify/ui-react'; \u2192 import { MdFastfood } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: W7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1 21.98C1 22.54 1.45 22.99 2.01 22.99H15C15.56 22.99 16.01 22.54 16.01 21.98V21H1V21.98ZM8.5 8.99C4.75 8.99 1 11 1 15H16C16 11 12.25 8.99 8.5 8.99ZM3.62 13C4.73 11.45 7.09 10.99 8.5 10.99C9.91 10.99 12.27 11.45 13.38 13H3.62ZM1 17H16V19H1V17ZM18 5V1H16V5H11L11.23 7H20.79L19.39 21H18V23H19.72C20.56 23 21.25 22.35 21.35 21.53L23 5H18Z",
    fill: "currentColor"
  })));
}, "IconFastfood");
import D7 from "classnames";
var P7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFavoriteBorder } from '@aws-amplify/ui-react'; \u2192 import { MdFavoriteBorder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: D7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.5 3C14.76 3 13.09 3.81 12 5.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.28 5.4 15.36 10.55 20.04L12 21.35L13.45 20.03C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3ZM12.1 18.55L12 18.65L11.9 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 5.99 11.07 7.36H12.94C13.46 5.99 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55Z",
    fill: "currentColor"
  })));
}, "IconFavoriteBorder");
import S7 from "classnames";
var j7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFavorite } from '@aws-amplify/ui-react'; \u2192 import { MdFavorite } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: S7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 21.35L10.55 20.03C5.4 15.36 2 12.28 2 8.5C2 5.42 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.09C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.42 22 8.5C22 12.28 18.6 15.36 13.45 20.04L12 21.35Z",
    fill: "currentColor"
  })));
}, "IconFavorite");
import Y7 from "classnames";
var F7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFeaturedPlayList } from '@aws-amplify/ui-react'; \u2192 import { MdFeaturedPlayList } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Y7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM5 10H14V12H5V10ZM5 7H14V9H5V7Z",
    fill: "currentColor"
  })));
}, "IconFeaturedPlayList");
import T7 from "classnames";
var A7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFeaturedVideo } from '@aws-amplify/ui-react'; \u2192 import { MdFeaturedVideo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: T7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM4 6H13V13H4V6Z",
    fill: "currentColor"
  })));
}, "IconFeaturedVideo");
import E7 from "classnames";
var O7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFeedback } from '@aws-amplify/ui-react'; \u2192 import { MdFeedback } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: E7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4.58 16.59L4 17.17V4H20V16ZM11 12H13V14H11V12ZM11 6H13V10H11V6Z",
    fill: "currentColor"
  })));
}, "IconFeedback");
import _7 from "classnames";
var G7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFence } from '@aws-amplify/ui-react'; \u2192 import { MdFence } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 12V10H19V7L16 4L14 6L12 4L10 6L8 4L5 7V10H3V12H5V14H3V16H5V20H19V16H21V14H19V12H21ZM16 6.83L17 7.83V10H15V7.83L15.41 7.42L16 6.83ZM12 6.83L12.59 7.42L13 7.83V10H11V7.83L11.41 7.42L12 6.83ZM11 14V12H13V14H11ZM13 16V18H11V16H13ZM7 7.83L8 6.83L8.59 7.42L9 7.83V10H7V7.83ZM7 12H9V14H7V12ZM7 16H9V18H7V16ZM17 18H15V16H17V18ZM17 14H15V12H17V14Z",
    fill: "currentColor"
  })));
}, "IconFence");
import U7 from "classnames";
var z7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFiberDvr } from '@aws-amplify/ui-react'; \u2192 import { MdFiberDvr } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: U7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.87 12.43L10.87 9H9.37L11.12 15H12.62L14.37 9H12.87L11.87 12.43ZM21 11.5V10.5C21 9.65 20.35 9 19.5 9H16V15H17.5V13H18.65L19.5 15H21L20.1 12.9C20.6 12.65 21 12.1 21 11.5ZM19.5 11.5H17.5V10.5H19.5V11.5ZM6.5 9H3V15H6.5C7.35 15 8 14.35 8 13.5V10.5C8 9.65 7.35 9 6.5 9ZM6.5 13.5H4.5V10.5H6.5V13.5Z",
    fill: "currentColor"
  })));
}, "IconFiberDvr");
import X7 from "classnames";
var K7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: X7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z",
    fill: "currentColor"
  })));
}, "IconFiberManualRecord");
import q7 from "classnames";
var Q7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFiberNew } from '@aws-amplify/ui-react'; \u2192 import { MdFiberNew } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: q7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.25 12.5L4.75 9H3.5V15H4.75V11.5L7.3 15H8.5V9H7.25V12.5ZM9.5 15H13.5V13.75H11V12.64H13.5V11.38H11V10.26H13.5V9H9.5V15ZM19.25 9V13.5H18.13V9.99H16.88V13.51H15.75V9H14.5V14C14.5 14.55 14.95 15 15.5 15H19.5C20.05 15 20.5 14.55 20.5 14V9H19.25Z",
    fill: "currentColor"
  })));
}, "IconFiberNew");
import J7 from "classnames";
var $7 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFiberPin } from '@aws-amplify/ui-react'; \u2192 import { MdFiberPin } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: J7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 15H12.5V9H11V15ZM18.75 9V12.5L16.25 9H15V15H16.25V11.5L18.8 15H20V9H18.75ZM7.5 9H4V15H5.5V13H7.5C8.35 13 9 12.35 9 11.5V10.5C9 9.65 8.35 9 7.5 9ZM7.5 11.5H5.5V10.5H7.5V11.5Z",
    fill: "currentColor"
  })));
}, "IconFiberPin");
import R7 from "classnames";
var e6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFiberSmartRecord } from '@aws-amplify/ui-react'; \u2192 import { MdFiberSmartRecord } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: R7(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 4C4.58 4 1 7.58 1 12C1 16.42 4.58 20 9 20C13.42 20 17 16.42 17 12C17 7.58 13.42 4 9 4ZM9 18C5.69 18 3 15.31 3 12C3 8.69 5.69 6 9 6C12.31 6 15 8.69 15 12C15 15.31 12.31 18 9 18ZM17 4.26V6.35C19.33 7.17 21 9.39 21 12C21 14.61 19.33 16.83 17 17.65V19.74C20.45 18.85 23 15.73 23 12C23 8.27 20.45 5.15 17 4.26V4.26Z",
    fill: "currentColor"
  })));
}, "IconFiberSmartRecord");
import o6 from "classnames";
var t6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFileCopy } from '@aws-amplify/ui-react'; \u2192 import { MdFileCopy } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: o6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z",
    fill: "currentColor"
  })));
}, "IconFileCopy");
import r6 from "classnames";
var i6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_1 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_1 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: r6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM14 15H16V5H12V7H14V15ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z",
    fill: "currentColor"
  })));
}, "IconFilter_1");
import s6 from "classnames";
var a6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_2 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_2 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: s6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM17 13H13V11H15C16.1 11 17 10.11 17 9V7C17 5.89 16.1 5 15 5H11V7H15V9H13C11.9 9 11 9.89 11 11V15H17V13Z",
    fill: "currentColor"
  })));
}, "IconFilter_2");
import n6 from "classnames";
var m6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_3 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_3 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: n6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM17 13V11.5C17 10.67 16.33 10 15.5 10C16.33 10 17 9.33 17 8.5V7C17 5.89 16.1 5 15 5H11V7H15V9H13V11H15V13H11V15H15C16.1 15 17 14.11 17 13Z",
    fill: "currentColor"
  })));
}, "IconFilter_3");
import c6 from "classnames";
var l6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_4 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_4 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: c6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM15 15H17V5H15V9H13V5H11V11H15V15ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z",
    fill: "currentColor"
  })));
}, "IconFilter_4");
import p6 from "classnames";
var h6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_5 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_5 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: p6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM17 13V11C17 9.89 16.1 9 15 9H13V7H17V5H11V11H15V13H11V15H15C16.1 15 17 14.11 17 13Z",
    fill: "currentColor"
  })));
}, "IconFilter_5");
import f6 from "classnames";
var C6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_6 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_6 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: f6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM13 15H15C16.1 15 17 14.11 17 13V11C17 9.89 16.1 9 15 9H13V7H17V5H13C11.9 5 11 5.89 11 7V13C11 14.11 11.9 15 13 15ZM13 11H15V13H13V11Z",
    fill: "currentColor"
  })));
}, "IconFilter_6");
import g6 from "classnames";
var u6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_7 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_7 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: g6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM13 15L17 7V5H11V7H15L11 15H13Z",
    fill: "currentColor"
  })));
}, "IconFilter_7");
import w6 from "classnames";
var d6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_8 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_8 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: w6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM13 15H15C16.1 15 17 14.11 17 13V11.5C17 10.67 16.33 10 15.5 10C16.33 10 17 9.33 17 8.5V7C17 5.89 16.1 5 15 5H13C11.9 5 11 5.89 11 7V8.5C11 9.33 11.67 10 12.5 10C11.67 10 11 10.67 11 11.5V13C11 14.11 11.9 15 13 15ZM13 7H15V9H13V7ZM13 11H15V13H13V11Z",
    fill: "currentColor"
  })));
}, "IconFilter_8");
import V6 from "classnames";
var H6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_9Plus } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_9Plus } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: V6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM14 12V8C14 6.89 13.1 6 12 6H11C9.9 6 9 6.89 9 8V9C9 10.11 9.9 11 11 11H12V12H9V14H12C13.1 14 14 13.11 14 12ZM11 9V8H12V9H11ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 9H19V7H17V9H15V11H17V13H19V11H21V17H7V3H21V9Z",
    fill: "currentColor"
  })));
}, "IconFilter_9Plus");
import M6 from "classnames";
var x6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter_9 } from '@aws-amplify/ui-react'; \u2192 import { MdFilter_9 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: M6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17ZM15 5H13C11.9 5 11 5.89 11 7V9C11 10.11 11.9 11 13 11H15V13H11V15H15C16.1 15 17 14.11 17 13V7C17 5.89 16.1 5 15 5ZM15 9H13V7H15V9Z",
    fill: "currentColor"
  })));
}, "IconFilter_9");
import I6 from "classnames";
var L6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterAlt } from '@aws-amplify/ui-react'; \u2192 import { MdFilterAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: I6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.99999 6H17L11.99 12.3L6.99999 6ZM4.24999 5.61C6.26999 8.2 9.99999 13 9.99999 13V19C9.99999 19.55 10.45 20 11 20H13C13.55 20 14 19.55 14 19V13C14 13 17.72 8.2 19.74 5.61C20.25 4.95 19.78 4 18.95 4H5.03999C4.20999 4 3.73999 4.95 4.24999 5.61Z",
    fill: "currentColor"
  })));
}, "IconFilterAlt");
import v6 from "classnames";
var N6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterBAndW } from '@aws-amplify/ui-react'; \u2192 import { MdFilterBAndW } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: v6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19L12 11V19H5L12 11V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconFilterBAndW");
import y6 from "classnames";
var b6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterCenterFocus } from '@aws-amplify/ui-react'; \u2192 import { MdFilterCenterFocus } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: y6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 15H3V19C3 20.1 3.9 21 5 21H9V19H5V15ZM5 5H9V3H5C3.9 3 3 3.9 3 5V9H5V5ZM19 3H15V5H19V9H21V5C21 3.9 20.1 3 19 3ZM19 19H15V21H19C20.1 21 21 20.1 21 19V15H19V19ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z",
    fill: "currentColor"
  })));
}, "IconFilterCenterFocus");
import Z6 from "classnames";
var B6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterDrama } from '@aws-amplify/ui-react'; \u2192 import { MdFilterDrama } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Z6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.61 5.64 5.36 8.04C2.35 8.36 0 10.9 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM19 18H6C3.79 18 2 16.21 2 14C2 11.79 3.79 10 6 10C8.21 10 10 11.79 10 14H12C12 11.24 10.14 8.92 7.6 8.22C8.61 6.88 10.2 6 12 6C15.03 6 17.5 8.47 17.5 11.5V12H19C20.65 12 22 13.35 22 15C22 16.65 20.65 18 19 18Z",
    fill: "currentColor"
  })));
}, "IconFilterDrama");
import W6 from "classnames";
var k6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterFrames } from '@aws-amplify/ui-react'; \u2192 import { MdFilterFrames } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: W6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H16L12 0L8 4H4C2.9 4 2 4.9 2 6V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V6C22 4.9 21.1 4 20 4ZM20 20H4V6H8.52L12.04 2.5L15.52 6H20V20ZM6 18H18V8H6V18ZM8 10H16V16H8V10Z",
    fill: "currentColor"
  })));
}, "IconFilterFrames");
import D6 from "classnames";
var P6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterHdr } from '@aws-amplify/ui-react'; \u2192 import { MdFilterHdr } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: D6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 6L9.78 11.63L11.03 13.3L14 9.33L19 16H10.54L6.53 10.63L1 18H23L14 6ZM5 16L6.52 13.97L8.04 16H5Z",
    fill: "currentColor"
  })));
}, "IconFilterHdr");
import S6 from "classnames";
var j6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterList } from '@aws-amplify/ui-react'; \u2192 import { MdFilterList } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: S6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z",
    fill: "currentColor"
  })));
}, "IconFilterList");
import Y6 from "classnames";
var F6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterNone } from '@aws-amplify/ui-react'; \u2192 import { MdFilterNone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Y6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z",
    fill: "currentColor"
  })));
}, "IconFilterNone");
import T6 from "classnames";
var A6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterTiltShift } from '@aws-amplify/ui-react'; \u2192 import { MdFilterTiltShift } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: T6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 4.0698V2.0498C8.99005 2.2498 7.16005 3.0498 5.68005 4.2598L7.10005 5.6898C8.21005 4.8298 9.54005 4.2498 11 4.0698ZM18.32 4.2598C16.84 3.0498 15.01 2.2498 13 2.0498V4.0698C14.46 4.2498 15.79 4.8298 16.9 5.6898L18.32 4.2598ZM19.93 10.9998H21.9501C21.7501 8.9898 20.95 7.1598 19.74 5.6798L18.31 7.0998C19.17 8.2098 19.75 9.5398 19.93 10.9998ZM5.69005 7.0998L4.26005 5.6798C3.05005 7.1598 2.25005 8.9898 2.05005 10.9998H4.07005C4.25005 9.5398 4.83005 8.2098 5.69005 7.0998ZM4.07005 12.9998H2.05005C2.25005 15.0098 3.05005 16.8398 4.26005 18.3198L5.69005 16.8898C4.83005 15.7898 4.25005 14.4598 4.07005 12.9998V12.9998ZM15 11.9998C15 10.3398 13.66 8.9998 12 8.9998C10.34 8.9998 9.00005 10.3398 9.00005 11.9998C9.00005 13.6598 10.34 14.9998 12 14.9998C13.66 14.9998 15 13.6598 15 11.9998ZM18.31 16.8998L19.74 18.3298C20.95 16.8498 21.7501 15.0098 21.9501 13.0098H19.93C19.75 14.4598 19.17 15.7898 18.31 16.8998ZM13 19.9298V21.9498C15.01 21.7498 16.84 20.9498 18.32 19.7398L16.89 18.3098C15.79 19.1698 14.46 19.7498 13 19.9298ZM5.68005 19.7398C7.16005 20.9498 9.00005 21.7498 11 21.9498V19.9298C9.54005 19.7498 8.21005 19.1698 7.10005 18.3098L5.68005 19.7398Z",
    fill: "currentColor"
  })));
}, "IconFilterTiltShift");
import E6 from "classnames";
var O6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilterVintage } from '@aws-amplify/ui-react'; \u2192 import { MdFilterVintage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: E6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.7001 12.4001C18.4201 12.2401 18.13 12.1101 17.84 12.0001C18.13 11.8901 18.4201 11.7601 18.7001 11.6001C20.6201 10.4901 21.6901 8.48006 21.7001 6.41006C20.7901 5.89006 19.7501 5.61006 18.6901 5.61006C17.6701 5.61006 16.64 5.87006 15.7 6.41006C15.42 6.57006 15.16 6.76006 14.92 6.95006C14.97 6.64006 15 6.32006 15 6.00006C15 3.78006 13.79 1.85006 12 0.810059C10.21 1.85006 9.00005 3.78006 9.00005 6.00006C9.00005 6.32006 9.03005 6.64006 9.08005 6.95006C8.84005 6.75006 8.58005 6.56006 8.30005 6.40006C7.36005 5.86006 6.33005 5.60006 5.31005 5.60006C4.26005 5.60006 3.21005 5.88006 2.30005 6.40006C2.30005 8.47006 3.37005 10.4801 5.30005 11.5901C5.58005 11.7501 5.87005 11.8801 6.16005 11.9901C5.87005 12.1001 5.58005 12.2301 5.30005 12.3901C3.38005 13.5001 2.31005 15.5101 2.30005 17.5801C3.21005 18.1001 4.25005 18.3801 5.31005 18.3801C6.33005 18.3801 7.36005 18.1201 8.30005 17.5801C8.58005 17.4201 8.84005 17.2301 9.08005 17.0401C9.03005 17.3601 9.00005 17.6801 9.00005 18.0001C9.00005 20.2201 10.21 22.1501 12 23.1901C13.79 22.1501 15 20.2201 15 18.0001C15 17.6801 14.97 17.3601 14.92 17.0501C15.16 17.2501 15.42 17.4301 15.7 17.5901C16.64 18.1301 17.6701 18.3901 18.6901 18.3901C19.7401 18.3901 20.7901 18.1101 21.7001 17.5901C21.6901 15.5201 20.6201 13.5101 18.7001 12.4001V12.4001ZM16.16 8.52006C16.37 8.35006 16.54 8.23006 16.7 8.15006C17.31 7.80006 18.0001 7.61006 18.7001 7.61006C18.9701 7.61006 19.23 7.64006 19.49 7.69006C19.18 8.60006 18.55 9.38006 17.71 9.87006C17.54 9.97006 17.35 10.0501 17.13 10.1401L15.75 10.6601C15.58 10.2001 15.34 9.79006 15.03 9.42006L16.16 8.52006ZM12 3.37006C12.63 4.09006 13 5.03006 13 6.00006C13 6.19006 12.98 6.41006 12.95 6.63006L12.72 8.07006C12.48 8.03006 12.24 8.00006 12 8.00006C11.76 8.00006 11.52 8.03006 11.29 8.07006L11.06 6.63006C11.02 6.41006 11 6.19006 11 6.00006C11 5.02006 11.37 4.09006 12 3.37006ZM4.51005 7.68006C4.77005 7.62006 5.04005 7.60006 5.31005 7.60006C6.00005 7.60006 6.69005 7.78006 7.30005 8.14006C7.45005 8.23006 7.62005 8.34006 7.79005 8.49006L8.94005 9.45006C8.64005 9.81006 8.41005 10.2101 8.24005 10.6501L6.86005 10.1301C6.65005 10.0401 6.46005 9.95006 6.30005 9.86006C5.43005 9.36006 4.81005 8.59006 4.51005 7.68006V7.68006ZM7.84005 15.4701C7.63005 15.6401 7.46005 15.7601 7.30005 15.8401C6.69005 16.1901 6.00005 16.3801 5.30005 16.3801C5.03005 16.3801 4.77005 16.3501 4.51005 16.3001C4.82005 15.3901 5.45005 14.6101 6.29005 14.1201C6.46005 14.0201 6.65005 13.9401 6.87005 13.8501L8.25005 13.3301C8.41005 13.7901 8.66005 14.2101 8.97005 14.5701L7.84005 15.4701V15.4701ZM12 20.6301C11.37 19.9101 11 18.9701 11 18.0001C11 17.8001 11.02 17.5901 11.06 17.3501L11.28 15.9301C11.51 15.9701 11.75 16.0001 12 16.0001C12.24 16.0001 12.48 15.9701 12.71 15.9301L12.94 17.3701C12.98 17.5901 13 17.8101 13 18.0001C13 18.9801 12.63 19.9101 12 20.6301V20.6301ZM18.6901 16.3901C18.0001 16.3901 17.31 16.2101 16.7 15.8501C16.52 15.7501 16.36 15.6301 16.21 15.5101L15.06 14.5501C15.36 14.1901 15.6 13.7901 15.76 13.3401L17.14 13.8601C17.36 13.9401 17.55 14.0301 17.71 14.1201C18.56 14.6101 19.18 15.3901 19.49 16.3001C19.22 16.3701 18.9501 16.3901 18.6901 16.3901V16.3901Z",
    fill: "currentColor"
  })));
}, "IconFilterVintage");
import _6 from "classnames";
var G6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFilter } from '@aws-amplify/ui-react'; \u2192 import { MdFilter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.96 10.29L13.21 13.83L11.25 11.47L8.5 15H19.5L15.96 10.29ZM3 5H1V21C1 22.1 1.9 23 3 23H19V21H3V5ZM21 1H7C5.9 1 5 1.9 5 3V17C5 18.1 5.9 19 7 19H21C22.1 19 23 18.1 23 17V3C23 1.9 22.1 1 21 1ZM21 17H7V3H21V17Z",
    fill: "currentColor"
  })));
}, "IconFilter");
import U6 from "classnames";
var z6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFindInPage } from '@aws-amplify/ui-react'; \u2192 import { MdFindInPage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: U6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 4H13L18 9V17.58L16.16 15.74C17.44 13.8 17.23 11.17 15.52 9.46C14.55 8.49 13.28 8 12 8C10.72 8 9.45 8.49 8.47 9.46C6.52 11.41 6.52 14.57 8.47 16.51C9.44 17.48 10.72 17.97 12 17.97C12.96 17.97 13.92 17.69 14.75 17.14L17.6 20H6V4ZM14.11 15.1C13.55 15.66 12.8 15.98 12 15.98C11.2 15.98 10.45 15.67 9.89 15.1C9.33 14.54 9.01 13.79 9.01 12.99C9.01 12.19 9.32 11.44 9.89 10.88C10.45 10.31 11.2 10 12 10C12.8 10 13.55 10.31 14.11 10.88C14.67 11.44 14.99 12.19 14.99 12.99C14.99 13.79 14.68 14.54 14.11 15.1Z",
    fill: "currentColor"
  })));
}, "IconFindInPage");
import X6 from "classnames";
var K6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFindReplace } from '@aws-amplify/ui-react'; \u2192 import { MdFindReplace } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: X6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 6C12.38 6 13.63 6.56 14.54 7.46L12 10H18V4L15.95 6.05C14.68 4.78 12.93 4 11 4C7.47 4 4.57 6.61 4.08 10H6.1C6.56 7.72 8.58 6 11 6ZM16.64 15.14C17.3 14.24 17.76 13.17 17.92 12H15.9C15.44 14.28 13.42 16 11 16C9.62 16 8.37 15.44 7.46 14.54L10 12H4V18L6.05 15.95C7.32 17.22 9.07 18 11 18C12.55 18 13.98 17.49 15.14 16.64L20 21.49L21.49 20L16.64 15.14Z",
    fill: "currentColor"
  })));
}, "IconFindReplace");
import q6 from "classnames";
var Q6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFingerprint } from '@aws-amplify/ui-react'; \u2192 import { MdFingerprint } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: q6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.81 4.47C17.73 4.47 17.65 4.45 17.58 4.41C15.66 3.42 14 3 12.01 3C10.03 3 8.14999 3.47 6.43999 4.41C6.19999 4.54 5.89999 4.45 5.75999 4.21C5.62999 3.97 5.71999 3.66 5.95999 3.53C7.81999 2.52 9.85998 2 12.01 2C14.14 2 16 2.47 18.04 3.52C18.29 3.65 18.38 3.95 18.25 4.19C18.16 4.37 17.99 4.47 17.81 4.47V4.47ZM3.49998 9.72C3.39998 9.72 3.29999 9.69 3.20999 9.63C2.97999 9.47 2.92998 9.16 3.08998 8.93C4.07998 7.53 5.33999 6.43 6.83999 5.66C9.97999 4.04 14 4.03 17.15 5.65C18.65 6.42 19.91 7.51 20.9 8.9C21.06 9.12 21.01 9.44 20.78 9.6C20.55 9.76 20.24 9.71 20.08 9.48C19.18 8.22 18.04 7.23 16.69 6.54C13.82 5.07 10.15 5.07 7.28999 6.55C5.92999 7.25 4.78999 8.25 3.88999 9.51C3.80999 9.65 3.65998 9.72 3.49998 9.72V9.72ZM9.74999 21.79C9.61999 21.79 9.48998 21.74 9.39998 21.64C8.52998 20.77 8.05999 20.21 7.38999 19C6.69999 17.77 6.33999 16.27 6.33999 14.66C6.33999 11.69 8.87998 9.27 12 9.27C15.12 9.27 17.66 11.69 17.66 14.66C17.66 14.94 17.44 15.16 17.16 15.16C16.88 15.16 16.66 14.94 16.66 14.66C16.66 12.24 14.57 10.27 12 10.27C9.42998 10.27 7.33999 12.24 7.33999 14.66C7.33999 16.1 7.65999 17.43 8.26999 18.51C8.90999 19.66 9.34999 20.15 10.12 20.93C10.31 21.13 10.31 21.44 10.12 21.64C10.01 21.74 9.87999 21.79 9.74999 21.79ZM16.92 19.94C15.73 19.94 14.68 19.64 13.82 19.05C12.33 18.04 11.44 16.4 11.44 14.66C11.44 14.38 11.66 14.16 11.94 14.16C12.22 14.16 12.44 14.38 12.44 14.66C12.44 16.07 13.16 17.4 14.38 18.22C15.09 18.7 15.92 18.93 16.92 18.93C17.16 18.93 17.56 18.9 17.96 18.83C18.23 18.78 18.49 18.96 18.54 19.24C18.59 19.51 18.41 19.77 18.13 19.82C17.56 19.93 17.06 19.94 16.92 19.94V19.94ZM14.91 22C14.87 22 14.82 21.99 14.78 21.98C13.19 21.54 12.15 20.95 11.06 19.88C9.65999 18.49 8.88999 16.64 8.88999 14.66C8.88999 13.04 10.27 11.72 11.97 11.72C13.67 11.72 15.05 13.04 15.05 14.66C15.05 15.73 15.98 16.6 17.13 16.6C18.28 16.6 19.21 15.73 19.21 14.66C19.21 10.89 15.96 7.83 11.96 7.83C9.11998 7.83 6.51998 9.41 5.34998 11.86C4.95998 12.67 4.75999 13.62 4.75999 14.66C4.75999 15.44 4.82998 16.67 5.42998 18.27C5.52998 18.53 5.39998 18.82 5.13998 18.91C4.87998 19.01 4.58998 18.87 4.49998 18.62C4.00998 17.31 3.76998 16.01 3.76998 14.66C3.76998 13.46 3.99998 12.37 4.44998 11.42C5.77998 8.63 8.72998 6.82 11.96 6.82C16.51 6.82 20.21 10.33 20.21 14.65C20.21 16.27 18.83 17.59 17.13 17.59C15.43 17.59 14.05 16.27 14.05 14.65C14.05 13.58 13.12 12.71 11.97 12.71C10.82 12.71 9.88999 13.58 9.88999 14.65C9.88999 16.36 10.55 17.96 11.76 19.16C12.71 20.1 13.62 20.62 15.03 21.01C15.3 21.08 15.45 21.36 15.38 21.62C15.33 21.85 15.12 22 14.91 22V22Z",
    fill: "currentColor"
  })));
}, "IconFingerprint");
import J6 from "classnames";
var $6 = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFireExtinguisher } from '@aws-amplify/ui-react'; \u2192 import { MdFireExtinguisher } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: J6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 19H17V20C17 21.1 16.1 22 15 22H9C7.9 22 7 21.1 7 20V19ZM7 18H17V13H7V18ZM17 3V9L13.85 8.34C13.84 8.34 13.84 8.35 13.83 8.36C15.38 8.98 16.55 10.34 16.9 12H7.1C7.44 10.34 8.62 8.98 10.17 8.36C9.84 8.1 9.57 7.78 9.37 7.41L5 6.5V5.5L9.37 4.59C9.87 3.65 10.86 3 12 3C12.7 3 13.34 3.25 13.85 3.66L17 3ZM13 6C12.97 5.41 12.55 5 12 5C11.45 5 11 5.45 11 6C11 6.55 11.45 7 12 7C12.55 7 13 6.55 13 6Z",
    fill: "currentColor"
  })));
}, "IconFireExtinguisher");
import R6 from "classnames";
var ef = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFireplace } from '@aws-amplify/ui-react'; \u2192 import { MdFireplace } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: R6(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.0101 12.46C11.8601 12.88 11.8601 13.28 11.9301 13.74C12.0301 14.29 12.2601 14.78 12.1301 15.34C12.0001 15.93 11.3601 16.72 10.6001 16.97C11.8801 18.02 13.8001 17.34 13.9901 15.65C14.1601 14.11 12.5501 13.67 12.0101 12.46Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M2 2V22H22V2H2ZM12 18C10.42 18 9.03 16.12 9 14.94C9 14.89 8.99 14.81 8.99 14.72C8.86 12.99 9.99 11.52 11.46 10.35C11.93 11.36 12.73 12.38 14.03 13.27C14.61 13.69 15 14.13 15 15C15 16.65 13.65 18 12 18ZM20 20H18V18H15.98C16.61 17.16 17 16.13 17 15C17 13.11 15.91 12.15 15.15 11.63C12.2 9.61 13 7 13 7C6.27 10.57 6.98 14.47 7 15C7.03 15.96 7.49 17.07 8.23 18H6V20H4V4H20V20Z",
    fill: "black"
  })));
}, "IconFireplace");
import of from "classnames";
var tf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFirstPage } from '@aws-amplify/ui-react'; \u2192 import { MdFirstPage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: of(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.41 16.59L13.82 12L18.41 7.41L17 6L11 12L17 18L18.41 16.59ZM6 6H8V18H6V6Z",
    fill: "currentColor"
  })));
}, "IconFirstPage");
import rf from "classnames";
var sf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFitnessCenter } from '@aws-amplify/ui-react'; \u2192 import { MdFitnessCenter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.57 14.86L22 13.43L20.57 12L17 15.57L8.43 7L12 3.43L10.57 2L9.14 3.43L7.71 2L5.57 4.14L4.14 2.71L2.71 4.14L4.14 5.57L2 7.71L3.43 9.14L2 10.57L3.43 12L7 8.43L15.57 17L12 20.57L13.43 22L14.86 20.57L16.29 22L18.43 19.86L19.86 21.29L21.29 19.86L19.86 18.43L22 16.29L20.57 14.86Z",
    fill: "currentColor"
  })));
}, "IconFitnessCenter");
import af from "classnames";
var nf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlag } from '@aws-amplify/ui-react'; \u2192 import { MdFlag } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: af(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.36 6L12.76 8H18V14H14.64L14.24 12H7V6H12.36ZM14 4H5V21H7V14H12.6L13 16H20V6H14.4L14 4Z",
    fill: "currentColor"
  })));
}, "IconFlag");
import mf from "classnames";
var cf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlaky } from '@aws-amplify/ui-react'; \u2192 import { MdFlaky } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M14.05 17.58L14.04 17.59L11.64 15.19L12.7 14.13L14.05 15.48L16.54 13L17.6 14.06L14.06 17.6L14.05 17.58ZM12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM7.34 6.28L8.75 7.69L10.16 6.28L11.22 7.34L9.81 8.75L11.22 10.16L10.16 11.22L8.75 9.81L7.34 11.22L6.28 10.16L7.69 8.75L6.28 7.34L7.34 6.28ZM12 20C9.8 20 7.8 19.1 6.3 17.7L17.7 6.3C19.1 7.8 20 9.8 20 12C20 16.4 16.4 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconFlaky");
import lf from "classnames";
var pf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlare } from '@aws-amplify/ui-react'; \u2192 import { MdFlare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 11H1V13H7V11ZM9.17 7.76L7.05 5.64L5.64 7.05L7.76 9.17L9.17 7.76ZM13 1H11V7H13V1ZM18.36 7.05L16.95 5.64L14.83 7.76L16.24 9.17L18.36 7.05ZM17 11V13H23V11H17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9ZM14.83 16.24L16.95 18.36L18.36 16.95L16.24 14.83L14.83 16.24V16.24ZM5.64 16.95L7.05 18.36L9.17 16.24L7.76 14.83L5.64 16.95V16.95ZM11 23H13V17H11V23Z",
    fill: "currentColor"
  })));
}, "IconFlare");
import hf from "classnames";
var ff = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlashAuto } from '@aws-amplify/ui-react'; \u2192 import { MdFlashAuto } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 2V14H6V23L13 11H9L13 2H3ZM19 2H17L13.8 11H15.7L16.4 9H19.6L20.3 11H22.2L19 2ZM16.85 7.65L18 4L19.15 7.65H16.85V7.65Z",
    fill: "currentColor"
  })));
}, "IconFlashAuto");
import Cf from "classnames";
var gf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlashOff } from '@aws-amplify/ui-react'; \u2192 import { MdFlashOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 10H13.39L15.67 12.28L17 10ZM17 2H7V3.61L13.13 9.74L17 2ZM3.41 2.86L2 4.27L7 9.27V13H10V22L13.58 15.85L17.73 20L19.14 18.59L3.41 2.86Z",
    fill: "currentColor"
  })));
}, "IconFlashOff");
import uf from "classnames";
var wf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlashOn } from '@aws-amplify/ui-react'; \u2192 import { MdFlashOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 2V13H10V22L17 10H13L16 2H7Z",
    fill: "currentColor"
  })));
}, "IconFlashOn");
import df from "classnames";
var Vf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlightLand } from '@aws-amplify/ui-react'; \u2192 import { MdFlightLand } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: df(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2.5 19H21.5V21H2.5V19ZM19.34 15.85C20.14 16.06 20.96 15.59 21.18 14.79C21.39 13.99 20.92 13.17 20.12 12.95L14.81 11.53L12.05 2.51L10.12 2V10.28L5.15 8.95L4.22 6.63L2.77 6.24V11.41L19.34 15.85V15.85Z",
    fill: "currentColor"
  })));
}, "IconFlightLand");
import Hf from "classnames";
var Mf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlightTakeoff } from '@aws-amplify/ui-react'; \u2192 import { MdFlightTakeoff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2.5 18.9998H21.5V20.9998H2.5V18.9998ZM22.07 9.63982C21.86 8.83982 21.03 8.35982 20.23 8.57982L14.92 9.99982L8.02 3.56982L6.09 4.07982L10.23 11.2498L5.26 12.5798L3.29 11.0398L1.84 11.4298L4.43 15.9198L21 11.4898C21.81 11.2598 22.28 10.4398 22.07 9.63982Z",
    fill: "currentColor"
  })));
}, "IconFlightTakeoff");
import xf from "classnames";
var If = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlight } from '@aws-amplify/ui-react'; \u2192 import { MdFlight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 16V14L13 9V3.5C13 2.67 12.33 2 11.5 2C10.67 2 10 2.67 10 3.5V9L2 14V16L10 13.5V19L8 20.5V22L11.5 21L15 22V20.5L13 19V13.5L21 16Z",
    fill: "currentColor"
  })));
}, "IconFlight");
import Lf from "classnames";
var vf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlipCameraAndroid } from '@aws-amplify/ui-react'; \u2192 import { MdFlipCameraAndroid } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9C10.34 9 9 10.34 9 12ZM13 12C13 12.55 12.55 13 12 13C11.45 13 11 12.55 11 12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8 10V8H5.09C6.47 5.61 9.05 4 12 4C15.72 4 18.85 6.56 19.74 10H21.8C20.87 5.44 16.84 2 12 2C8.73 2 5.82 3.58 4 6.01V4H2V10H8Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16 14V16H18.91C17.53 18.39 14.95 20 12 20C8.27995 20 5.14995 17.44 4.25995 14H2.19995C3.12995 18.56 7.15995 22 12 22C15.27 22 18.18 20.42 20 17.99V20H22V14H16Z",
    fill: "black"
  })));
}, "IconFlipCameraAndroid");
import Nf from "classnames";
var yf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlipCameraIos } from '@aws-amplify/ui-react'; \u2192 import { MdFlipCameraIos } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 5H16.83L15 3H9L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H4V7H7.17H8.05L8.64 6.35L9.88 5H14.12L15.36 6.35L15.95 7H16.83H20V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 17C9.79 17 8 15.21 8 13H10L7.5 10.5L5 13H7C7 15.76 9.24 18 12 18C12.86 18 13.65 17.76 14.36 17.38L13.62 16.64C13.13 16.87 12.58 17 12 17Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11.9999 8C11.1399 8 10.3499 8.24 9.63989 8.62L10.3799 9.35C10.8699 9.13 11.4199 9 11.9999 9C14.2099 9 15.9999 10.79 15.9999 13H13.9999L16.4999 15.5L18.9999 13H16.9999C16.9999 10.24 14.7599 8 11.9999 8Z",
    fill: "black"
  })));
}, "IconFlipCameraIos");
import bf from "classnames";
var Zf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlipToBack } from '@aws-amplify/ui-react'; \u2192 import { MdFlipToBack } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 7H7V9H9V7ZM9 11H7V13H9V11ZM9 3C7.89 3 7 3.9 7 5H9V3ZM13 15H11V17H13V15ZM19 3V5H21C21 3.9 20.1 3 19 3ZM13 3H11V5H13V3ZM9 17V15H7C7 16.1 7.89 17 9 17ZM19 13H21V11H19V13ZM19 9H21V7H19V9ZM19 17C20.1 17 21 16.1 21 15H19V17ZM5 7H3V19C3 20.1 3.89 21 5 21H17V19H5V7ZM15 5H17V3H15V5ZM15 17H17V15H15V17Z",
    fill: "currentColor"
  })));
}, "IconFlipToBack");
import Bf from "classnames";
var Wf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlipToFront } from '@aws-amplify/ui-react'; \u2192 import { MdFlipToFront } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 13H5V11H3V13ZM3 17H5V15H3V17ZM5 21V19H3C3 20.1 3.89 21 5 21ZM3 9H5V7H3V9ZM15 21H17V19H15V21ZM19 3H9C7.89 3 7 3.9 7 5V15C7 16.1 7.89 17 9 17H19C20.1 17 21 16.1 21 15V5C21 3.9 20.1 3 19 3ZM19 15H9V5H19V15ZM11 21H13V19H11V21ZM7 21H9V19H7V21Z",
    fill: "currentColor"
  })));
}, "IconFlipToFront");
import kf from "classnames";
var Df = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFlip } from '@aws-amplify/ui-react'; \u2192 import { MdFlip } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 21H17V19H15V21ZM19 9H21V7H19V9ZM3 5V19C3 20.1 3.9 21 5 21H9V19H5V5H9V3H5C3.9 3 3 3.9 3 5ZM19 3V5H21C21 3.9 20.1 3 19 3ZM11 23H13V1H11V23ZM19 17H21V15H19V17ZM15 5H17V3H15V5ZM19 13H21V11H19V13ZM19 21C20.1 21 21 20.1 21 19H19V21Z",
    fill: "currentColor"
  })));
}, "IconFlip");
import Pf from "classnames";
var Sf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFolderOpen } from '@aws-amplify/ui-react'; \u2192 import { MdFolderOpen } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V8H20V18Z",
    fill: "currentColor"
  })));
}, "IconFolderOpen");
import jf from "classnames";
var Yf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFolderShared } from '@aws-amplify/ui-react'; \u2192 import { MdFolderShared } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM15 13C16.1 13 17 12.1 17 11C17 9.9 16.1 9 15 9C13.9 9 13 9.9 13 11C13 12.1 13.9 13 15 13ZM11 17H19V16C19 14.67 16.33 14 15 14C13.67 14 11 14.67 11 16V17Z",
    fill: "currentColor"
  })));
}, "IconFolderShared");
import Ff from "classnames";
var Tf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFolderSpecial } from '@aws-amplify/ui-react'; \u2192 import { MdFolderSpecial } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ff(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H12L10 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM13.08 14.04L12.39 17L15 15.47L17.61 17L16.92 14.04L19.22 12.05L16.19 11.79L15 9L13.81 11.79L10.78 12.05L13.08 14.04Z",
    fill: "currentColor"
  })));
}, "IconFolderSpecial");
import Af from "classnames";
var Ef = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFolder } from '@aws-amplify/ui-react'; \u2192 import { MdFolder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Af(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z",
    fill: "currentColor"
  })));
}, "IconFolder");
import Of from "classnames";

var _f = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFollowTheSigns } from '@aws-amplify/ui-react'; \u2192 import { MdFollowTheSigns } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Of(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.5 5.5C10.6 5.5 11.5 4.6 11.5 3.5C11.5 2.4 10.6 1.5 9.5 1.5C8.4 1.5 7.5 2.4 7.5 3.5C7.5 4.6 8.4 5.5 9.5 5.5ZM5.75 8.9L3 23H5.1L6.85 15L9 17V23H11V15.45L8.95 13.4L9.55 10.4C10.85 12 12.8 13 15 13V11C13.15 11 11.55 10 10.65 8.55L9.7 6.95C9.35 6.35 8.7 6 8 6C7.75 6 7.5 6.05 7.25 6.15L2 8.3V13H4V9.65L5.75 8.9ZM13 2V9H16.75V23H18.25V9H22V2H13ZM18.01 8V6.25H14.5V4.75H18.01V3L20.5 5.5L18.01 8Z",
    fill: "currentColor"
  })));
}, "IconFollowTheSigns");

import Gf from "classnames";
var Uf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFontDownload } from '@aws-amplify/ui-react'; \u2192 import { MdFontDownload } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.17 15.5H14.81L15.95 18.5H18.04L12.93 5.5H11.07L5.96 18.5H8.05L9.17 15.5V15.5ZM12 7.98L14.07 13.5H9.93L12 7.98ZM20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM20 20H4V4H20V20Z",
    fill: "currentColor"
  })));
}, "IconFontDownload");
import zf from "classnames";
var Xf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFoodBank } from '@aws-amplify/ui-react'; \u2192 import { MdFoodBank } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5.5L18 10V19H6V10L12 5.5ZM12 3L4 9V21H20V9L12 3ZM11.5 9.5V12.5H11V9.5H10V12.5H9.5V9.5H8.5V12.5C8.5 13.33 9.17 14 10 14V18H11V14C11.83 14 12.5 13.33 12.5 12.5V9.5H11.5ZM13 11.5V14.5H14V18H15V9.5C13.9 9.5 13 10.4 13 11.5Z",
    fill: "currentColor"
  })));
}, "IconFoodBank");
import Kf from "classnames";
var qf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatAlignCenter } from '@aws-amplify/ui-react'; \u2192 import { MdFormatAlignCenter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 15V17H17V15H7ZM3 21H21V19H3V21ZM3 13H21V11H3V13ZM7 7V9H17V7H7ZM3 3V5H21V3H3Z",
    fill: "currentColor"
  })));
}, "IconFormatAlignCenter");
import Qf from "classnames";
var Jf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatAlignJustify } from '@aws-amplify/ui-react'; \u2192 import { MdFormatAlignJustify } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qf(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 21H21V19H3V21ZM3 17H21V15H3V17ZM3 13H21V11H3V13ZM3 9H21V7H3V9ZM3 3V5H21V3H3Z",
    fill: "currentColor"
  })));
}, "IconFormatAlignJustify");
import $f from "classnames";
var Rf = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatAlignLeft } from '@aws-amplify/ui-react'; \u2192 import { MdFormatAlignLeft } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $f(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 15H3V17H15V15ZM15 7H3V9H15V7ZM3 13H21V11H3V13ZM3 21H21V19H3V21ZM3 3V5H21V3H3Z",
    fill: "currentColor"
  })));
}, "IconFormatAlignLeft");
import eC from "classnames";
var oC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatAlignRight } from '@aws-amplify/ui-react'; \u2192 import { MdFormatAlignRight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 21H21V19H3V21ZM9 17H21V15H9V17ZM3 13H21V11H3V13ZM9 9H21V7H9V9ZM3 3V5H21V3H3Z",
    fill: "currentColor"
  })));
}, "IconFormatAlignRight");
import tC from "classnames";
var rC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatBold } from '@aws-amplify/ui-react'; \u2192 import { MdFormatBold } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.6 10.79C16.57 10.12 17.25 9.02 17.25 8C17.25 5.74 15.5 4 13.25 4H7V18H14.04C16.13 18 17.75 16.3 17.75 14.21C17.75 12.69 16.89 11.39 15.6 10.79V10.79ZM10 6.5H13C13.83 6.5 14.5 7.17 14.5 8C14.5 8.83 13.83 9.5 13 9.5H10V6.5ZM13.5 15.5H10V12.5H13.5C14.33 12.5 15 13.17 15 14C15 14.83 14.33 15.5 13.5 15.5Z",
    fill: "currentColor"
  })));
}, "IconFormatBold");
import iC from "classnames";
var sC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatClear } from '@aws-amplify/ui-react'; \u2192 import { MdFormatClear } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 7.99986V4.99986H6.39L9.39 7.99986H11.22L10.67 9.27986L12.76 11.3799L14.21 7.99986H20ZM3.41 4.85986L2 6.26986L8.97 13.2399L6.5 18.9999H9.5L11.07 15.3399L16.73 20.9999L18.14 19.5899L3.41 4.85986Z",
    fill: "currentColor"
  })));
}, "IconFormatClear");
import aC from "classnames";
var nC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatColorReset } from '@aws-amplify/ui-react'; \u2192 import { MdFormatColorReset } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6.3602C13.53 8.3602 15.08 10.7902 15.71 12.6002L17.94 14.8302C17.97 14.5602 18 14.2802 18 14.0002C18 10.0202 12 3.2002 12 3.2002C12 3.2002 10.82 4.5502 9.5 6.3902L10.94 7.8302C11.28 7.3202 11.64 6.8302 12 6.3602ZM5.41 5.1402L4 6.5502L7.32 9.8702C6.55 11.3302 6 12.7902 6 14.0002C6 17.3102 8.69 20.0002 12 20.0002C13.52 20.0002 14.9 19.4302 15.95 18.5002L18.58 21.1302L20 19.7202L5.41 5.1402ZM12 18.0002C9.79 18.0002 8 16.2102 8 14.0002C8 13.3102 8.32 12.3802 8.81 11.3602L14.53 17.0802C13.83 17.6402 12.96 18.0002 12 18.0002V18.0002Z",
    fill: "currentColor"
  })));
}, "IconFormatColorReset");
import mC from "classnames";
var cC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatIndentDecrease } from '@aws-amplify/ui-react'; \u2192 import { MdFormatIndentDecrease } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 17H21V15H11V17ZM3 12L7 16V8L3 12ZM3 21H21V19H3V21ZM3 3V5H21V3H3ZM11 9H21V7H11V9ZM11 13H21V11H11V13Z",
    fill: "currentColor"
  })));
}, "IconFormatIndentDecrease");
import lC from "classnames";
var pC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatIndentIncrease } from '@aws-amplify/ui-react'; \u2192 import { MdFormatIndentIncrease } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 21H21V19H3V21ZM3 8V16L7 12L3 8ZM11 17H21V15H11V17ZM3 3V5H21V3H3ZM11 9H21V7H11V9ZM11 13H21V11H11V13Z",
    fill: "currentColor"
  })));
}, "IconFormatIndentIncrease");
import hC from "classnames";
var fC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatItalic } from '@aws-amplify/ui-react'; \u2192 import { MdFormatItalic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 4V7H12.21L8.79 15H6V18H14V15H11.79L15.21 7H18V4H10Z",
    fill: "currentColor"
  })));
}, "IconFormatItalic");
import CC from "classnames";
var gC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatLineSpacing } from '@aws-amplify/ui-react'; \u2192 import { MdFormatLineSpacing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 7H8.5L5 3.5L1.5 7H4V17H1.5L5 20.5L8.5 17H6V7ZM10 5V7H22V5H10ZM10 19H22V17H10V19ZM10 13H22V11H10V13Z",
    fill: "currentColor"
  })));
}, "IconFormatLineSpacing");
import uC from "classnames";
var wC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatListBulleted } from '@aws-amplify/ui-react'; \u2192 import { MdFormatListBulleted } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 10.5C3.17 10.5 2.5 11.17 2.5 12C2.5 12.83 3.17 13.5 4 13.5C4.83 13.5 5.5 12.83 5.5 12C5.5 11.17 4.83 10.5 4 10.5ZM4 4.5C3.17 4.5 2.5 5.17 2.5 6C2.5 6.83 3.17 7.5 4 7.5C4.83 7.5 5.5 6.83 5.5 6C5.5 5.17 4.83 4.5 4 4.5ZM4 16.5C3.17 16.5 2.5 17.18 2.5 18C2.5 18.82 3.18 19.5 4 19.5C4.82 19.5 5.5 18.82 5.5 18C5.5 17.18 4.83 16.5 4 16.5ZM7 19H21V17H7V19ZM7 13H21V11H7V13ZM7 5V7H21V5H7Z",
    fill: "currentColor"
  })));
}, "IconFormatListBulleted");
import dC from "classnames";
var VC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatListNumberedRtl } from '@aws-amplify/ui-react'; \u2192 import { MdFormatListNumberedRtl } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 17H20V17.5H19V18.5H20V19H18V20H21V16H18V17ZM19 8H20V4H18V5H19V8ZM18 11H19.8L18 13.1V14H21V13H19.2L21 10.9V10H18V11ZM2 5H16V7H2V5ZM2 17H16V19H2V17ZM2 11H16V13H2V11Z",
    fill: "currentColor"
  })));
}, "IconFormatListNumberedRtl");
import HC from "classnames";
var MC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatListNumbered } from '@aws-amplify/ui-react'; \u2192 import { MdFormatListNumbered } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 17H4V17.5H3V18.5H4V19H2V20H5V16H2V17ZM3 8H4V4H2V5H3V8ZM2 11H3.8L2 13.1V14H5V13H3.2L5 10.9V10H2V11ZM7 5V7H21V5H7ZM7 19H21V17H7V19ZM7 13H21V11H7V13Z",
    fill: "currentColor"
  })));
}, "IconFormatListNumbered");
import xC from "classnames";
var IC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatPaint } from '@aws-amplify/ui-react'; \u2192 import { MdFormatPaint } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 4V3C18 2.45 17.55 2 17 2H5C4.45 2 4 2.45 4 3V7C4 7.55 4.45 8 5 8H17C17.55 8 18 7.55 18 7V6H19V10H9V21C9 21.55 9.45 22 10 22H12C12.55 22 13 21.55 13 21V12H21V4H18ZM16 6H6V4H16V6Z",
    fill: "currentColor"
  })));
}, "IconFormatPaint");
import LC from "classnames";
var vC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatQuote } from '@aws-amplify/ui-react'; \u2192 import { MdFormatQuote } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.62 18H13.38L15.38 14H13V6H21V13.24L18.62 18ZM16.62 16H17.38L19 12.76V8H15V12H18.62L16.62 16ZM8.62 18H3.38L5.38 14H3V6H11V13.24L8.62 18V18ZM6.62 16H7.38L9 12.76V8H5V12H8.62L6.62 16Z",
    fill: "currentColor"
  })));
}, "IconFormatQuote");
import NC from "classnames";
var yC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatShapes } from '@aws-amplify/ui-react'; \u2192 import { MdFormatShapes } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23 7V1H17V3H7V1H1V7H3V17H1V23H7V21H17V23H23V17H21V7H23ZM3 3H5V5H3V3ZM5 21H3V19H5V21ZM17 19H7V17H5V7H7V5H17V7H19V17H17V19ZM21 21H19V19H21V21ZM19 5V3H21V5H19ZM13.73 14H10.24L9.51 16H7.89L11.29 7H12.69L16.1 16H14.47L13.73 14V14ZM10.69 12.74H13.3L12 8.91L10.69 12.74V12.74Z",
    fill: "currentColor"
  })));
}, "IconFormatShapes");
import bC from "classnames";
var ZC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatSize } from '@aws-amplify/ui-react'; \u2192 import { MdFormatSize } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 4V7H14V19H17V7H22V4H9ZM3 12H6V19H9V12H12V9H3V12Z",
    fill: "currentColor"
  })));
}, "IconFormatSize");
import BC from "classnames";
var WC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatStrikethrough } from '@aws-amplify/ui-react'; \u2192 import { MdFormatStrikethrough } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 19H14V16H10V19ZM5 4V7H10V10H14V7H19V4H5ZM3 14H21V12H3V14Z",
    fill: "currentColor"
  })));
}, "IconFormatStrikethrough");
import kC from "classnames";
var DC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatTextdirectionLToR } from '@aws-amplify/ui-react'; \u2192 import { MdFormatTextdirectionLToR } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 4V8C7.9 8 7 7.1 7 6C7 4.9 7.9 4 9 4ZM17 2H9C6.79 2 5 3.79 5 6C5 8.21 6.79 10 9 10V15H11V4H13V15H15V4H17V2ZM17 14V17H5V19H17V22L21 18L17 14Z",
    fill: "currentColor"
  })));
}, "IconFormatTextdirectionLToR");
import PC from "classnames";
var SC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatTextdirectionRToL } from '@aws-amplify/ui-react'; \u2192 import { MdFormatTextdirectionRToL } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 4V8C8.9 8 8 7.1 8 6C8 4.9 8.9 4 10 4ZM18 2H10C7.79 2 6 3.79 6 6C6 8.21 7.79 10 10 10V15H12V4H14V15H16V4H18V2ZM8 14L4 18L8 22V19H20V17H8V14Z",
    fill: "currentColor"
  })));
}, "IconFormatTextdirectionRToL");
import jC from "classnames";
var YC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFormatUnderlined } from '@aws-amplify/ui-react'; \u2192 import { MdFormatUnderlined } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 17C15.31 17 18 14.31 18 11V3H15.5V11C15.5 12.93 13.93 14.5 12 14.5C10.07 14.5 8.5 12.93 8.5 11V3H6V11C6 14.31 8.69 17 12 17ZM5 19V21H19V19H5Z",
    fill: "currentColor"
  })));
}, "IconFormatUnderlined");
import FC from "classnames";
var TC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconForum } from '@aws-amplify/ui-react'; \u2192 import { MdForum } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 4V11H5.17L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z",
    fill: "currentColor"
  })));
}, "IconForum");
import AC from "classnames";
var EC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconForward_10 } from '@aws-amplify/ui-react'; \u2192 import { MdForward_10 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13C6 9.69 8.69 7 12 7V11L17 6L12 1V5C7.58 5 4 8.58 4 13C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13H18Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10.9 16V11.73H10.81L9.03998 12.36V13.05L10.05 12.74V16H10.9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14.32 11.7802C14.14 11.7102 13.95 11.6802 13.73 11.6802C13.51 11.6802 13.32 11.7102 13.14 11.7802C12.96 11.8502 12.81 11.9602 12.69 12.1102C12.57 12.2602 12.46 12.4502 12.4 12.6802C12.34 12.9102 12.3 13.1802 12.3 13.5002V14.2402C12.3 14.5602 12.34 14.8402 12.41 15.0602C12.48 15.2802 12.58 15.4802 12.71 15.6302C12.84 15.7802 12.99 15.8902 13.17 15.9602C13.35 16.0302 13.54 16.0602 13.76 16.0602C13.98 16.0602 14.17 16.0302 14.35 15.9602C14.53 15.8902 14.68 15.7802 14.8 15.6302C14.92 15.4802 15.02 15.2902 15.09 15.0602C15.16 14.8302 15.19 14.5602 15.19 14.2402V13.5002C15.19 13.1802 15.15 12.9002 15.08 12.6802C15.01 12.4602 14.91 12.2602 14.78 12.1102C14.65 11.9602 14.49 11.8502 14.32 11.7802ZM14.33 14.3502C14.33 14.5402 14.32 14.7002 14.29 14.8302C14.26 14.9602 14.23 15.0702 14.18 15.1502C14.13 15.2302 14.07 15.2902 13.99 15.3202C13.91 15.3502 13.83 15.3702 13.74 15.3702C13.65 15.3702 13.56 15.3502 13.49 15.3202C13.42 15.2902 13.35 15.2302 13.3 15.1502C13.25 15.0702 13.21 14.9602 13.18 14.8302C13.15 14.7002 13.14 14.5402 13.14 14.3502V13.3802C13.14 13.1902 13.15 13.0302 13.18 12.9002C13.21 12.7702 13.24 12.6702 13.3 12.5902C13.36 12.5102 13.41 12.4502 13.49 12.4202C13.57 12.3902 13.65 12.3702 13.74 12.3702C13.83 12.3702 13.92 12.3902 13.99 12.4202C14.06 12.4502 14.13 12.5102 14.18 12.5902C14.23 12.6702 14.27 12.7702 14.3 12.9002C14.33 13.0302 14.34 13.1902 14.34 13.3802V14.3502H14.33Z",
    fill: "black"
  })));
}, "IconForward_10");
import OC from "classnames";

var _C = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconForward_30 } from '@aws-amplify/ui-react'; \u2192 import { MdForward_30 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13C6 9.69 8.69 7 12 7V11L17 6L12 1V5C7.58 5 4 8.58 4 13C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13H18ZM10.54 15.22C10.48 15.27 10.42 15.31 10.34 15.34C10.26 15.37 10.17 15.38 10.07 15.38C9.98 15.38 9.9 15.37 9.82 15.34C9.74 15.31 9.68 15.28 9.62 15.23C9.56 15.18 9.52 15.13 9.49 15.06C9.46 14.99 9.44 14.92 9.44 14.84H8.59C8.59 15.05 8.63 15.23 8.71 15.39C8.79 15.55 8.9 15.67 9.04 15.77C9.18 15.87 9.33 15.95 9.5 16C9.67 16.05 9.85 16.07 10.03 16.07C10.24 16.07 10.44 16.04 10.63 15.99C10.82 15.94 10.97 15.85 11.11 15.75C11.25 15.65 11.35 15.51 11.43 15.36C11.51 15.21 11.55 15.03 11.55 14.83C11.55 14.6 11.49 14.39 11.37 14.22C11.25 14.05 11.07 13.92 10.83 13.83C10.93 13.78 11.03 13.73 11.11 13.66C11.19 13.59 11.26 13.52 11.31 13.44C11.36 13.36 11.41 13.28 11.44 13.19C11.47 13.1 11.48 13.01 11.48 12.92C11.48 12.72 11.44 12.55 11.37 12.39C11.3 12.23 11.2 12.11 11.07 12.01C10.94 11.91 10.79 11.83 10.61 11.78C10.43 11.73 10.24 11.7 10.02 11.7C9.83 11.7 9.64 11.73 9.48 11.78C9.32 11.83 9.16 11.91 9.04 12.01C8.92 12.11 8.81 12.23 8.74 12.38C8.67 12.53 8.63 12.68 8.63 12.86H9.48C9.48 12.79 9.5 12.72 9.53 12.66C9.56 12.6 9.6 12.55 9.65 12.51C9.7 12.47 9.76 12.44 9.83 12.41C9.9 12.38 9.97 12.38 10.05 12.38C10.15 12.38 10.23 12.39 10.3 12.42C10.37 12.45 10.43 12.48 10.48 12.53C10.53 12.58 10.56 12.64 10.59 12.7C10.62 12.76 10.63 12.84 10.63 12.92C10.63 13.1 10.58 13.24 10.47 13.35C10.36 13.46 10.21 13.51 9.99 13.51H9.56V14.17H10.01C10.12 14.17 10.21 14.18 10.3 14.21C10.39 14.24 10.46 14.27 10.52 14.32C10.58 14.37 10.63 14.44 10.66 14.52C10.69 14.6 10.71 14.7 10.71 14.81C10.71 14.9 10.7 14.98 10.67 15.05C10.64 15.12 10.59 15.16 10.54 15.22V15.22ZM14.44 11.78C14.26 11.71 14.07 11.68 13.85 11.68C13.63 11.68 13.44 11.71 13.26 11.78C13.08 11.85 12.93 11.96 12.81 12.11C12.69 12.26 12.58 12.45 12.52 12.68C12.46 12.91 12.42 13.18 12.42 13.5V14.24C12.42 14.56 12.46 14.84 12.53 15.06C12.6 15.28 12.7 15.48 12.83 15.63C12.96 15.78 13.11 15.89 13.29 15.96C13.47 16.03 13.66 16.06 13.88 16.06C14.1 16.06 14.29 16.03 14.47 15.96C14.65 15.89 14.8 15.78 14.92 15.63C15.04 15.48 15.14 15.29 15.21 15.06C15.28 14.83 15.31 14.56 15.31 14.24V13.5C15.31 13.18 15.27 12.9 15.2 12.68C15.13 12.46 15.03 12.26 14.9 12.11C14.77 11.96 14.62 11.85 14.44 11.78ZM14.45 14.35C14.45 14.54 14.44 14.7 14.41 14.83C14.38 14.96 14.35 15.07 14.3 15.15C14.25 15.23 14.19 15.29 14.11 15.32C14.03 15.35 13.95 15.37 13.86 15.37C13.77 15.37 13.68 15.35 13.61 15.32C13.54 15.29 13.47 15.23 13.42 15.15C13.37 15.07 13.33 14.96 13.3 14.83C13.27 14.7 13.26 14.54 13.26 14.35V13.38C13.26 13.19 13.27 13.03 13.3 12.9C13.33 12.77 13.36 12.67 13.42 12.59C13.48 12.51 13.53 12.45 13.61 12.42C13.69 12.39 13.77 12.37 13.86 12.37C13.95 12.37 14.04 12.39 14.11 12.42C14.18 12.45 14.25 12.51 14.3 12.59C14.35 12.67 14.39 12.77 14.42 12.9C14.45 13.03 14.46 13.19 14.46 13.38V14.35H14.45Z",
    fill: "currentColor"
  })));
}, "IconForward_30");

import GC from "classnames";
var UC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconForward_5 } from '@aws-amplify/ui-react'; \u2192 import { MdForward_5 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.95 13C17.95 16.31 15.26 19 11.95 19C8.63995 19 5.94995 16.31 5.94995 13C5.94995 9.69 8.63995 7 11.95 7V11L16.95 6L11.95 1V5C7.52995 5 3.94995 8.58 3.94995 13C3.94995 17.42 7.52995 21 11.95 21C16.37 21 19.95 17.42 19.95 13H17.95ZM12.43 15.15C12.38 15.22 12.32 15.28 12.25 15.32C12.18 15.36 12.08 15.38 11.98 15.38C11.81 15.38 11.67 15.33 11.56 15.23C11.45 15.13 11.39 14.99 11.37 14.82H10.53C10.54 15.02 10.58 15.19 10.66 15.35C10.74 15.51 10.85 15.63 10.98 15.74C11.11 15.85 11.27 15.93 11.44 15.98C11.61 16.03 11.79 16.06 11.97 16.06C12.21 16.06 12.43 16.02 12.61 15.94C12.79 15.86 12.94 15.76 13.06 15.63C13.18 15.5 13.27 15.35 13.33 15.18C13.39 15.01 13.42 14.83 13.42 14.64C13.42 14.42 13.39 14.21 13.33 14.04C13.27 13.87 13.19 13.71 13.08 13.59C12.97 13.47 12.83 13.37 12.67 13.31C12.51 13.25 12.33 13.21 12.12 13.21C12.05 13.21 11.98 13.22 11.92 13.23C11.86 13.24 11.79 13.25 11.74 13.27C11.69 13.29 11.64 13.3 11.59 13.32C11.54 13.34 11.51 13.36 11.48 13.37L11.59 12.45H13.29V11.74H10.9L10.65 13.91L11.32 14.08C11.35 14.05 11.38 14.02 11.42 13.99C11.46 13.96 11.49 13.94 11.54 13.92C11.59 13.9 11.64 13.88 11.69 13.87C11.74 13.86 11.82 13.85 11.89 13.85C12.01 13.85 12.11 13.87 12.19 13.9C12.27 13.93 12.35 13.99 12.4 14.05C12.45 14.11 12.5 14.19 12.53 14.29C12.56 14.39 12.57 14.48 12.57 14.6C12.57 14.72 12.56 14.82 12.54 14.91C12.52 15 12.48 15.08 12.43 15.15V15.15Z",
    fill: "currentColor"
  })));
}, "IconForward_5");
import zC from "classnames";
var XC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconForwardToInbox } from '@aws-amplify/ui-react'; \u2192 import { MdForwardToInbox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H13V18H4V8L12 13L20 8V13H22V6C22 4.9 21.1 4 20 4ZM12 11L4 6H20L12 11ZM19 15L23 19L19 23V20H15V18H19V15Z",
    fill: "currentColor"
  })));
}, "IconForwardToInbox");
import KC from "classnames";
var qC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconForward } from '@aws-amplify/ui-react'; \u2192 import { MdForward } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 8.83L17.17 12L14 15.17V14H6V10H14V8.83ZM12 4V8H4V16H12V20L20 12L12 4Z",
    fill: "currentColor"
  })));
}, "IconForward");
import QC from "classnames";
var JC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFoundation } from '@aws-amplify/ui-react'; \u2192 import { MdFoundation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QC(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 12H22L12 3L2 12H5V15H3V17H5V20H7V17H11V20H13V17H17V20H19V17H21V15H19V12ZM7 15V10.19L11 6.59V15H7ZM13 15V6.59L17 10.19V15H13Z",
    fill: "currentColor"
  })));
}, "IconFoundation");
import $C from "classnames";
var RC = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFreeBreakfast } from '@aws-amplify/ui-react'; \u2192 import { MdFreeBreakfast } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $C(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 19H20V21H4V19ZM20 3H4V13C4 15.21 5.79 17 8 17H14C16.21 17 18 15.21 18 13V10H20C21.11 10 22 9.1 22 8V5C22 3.89 21.11 3 20 3ZM16 13C16 14.1 15.1 15 14 15H8C6.9 15 6 14.1 6 13V5H16V13ZM20 8H18V5H20V8Z",
    fill: "currentColor"
  })));
}, "IconFreeBreakfast");
import eg from "classnames";
var og = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFullscreenExit } from '@aws-amplify/ui-react'; \u2192 import { MdFullscreenExit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 16H8V19H10V14H5V16ZM8 8H5V10H10V5H8V8ZM14 19H16V16H19V14H14V19ZM16 8V5H14V10H19V8H16Z",
    fill: "currentColor"
  })));
}, "IconFullscreenExit");
import tg from "classnames";
var rg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFullscreen } from '@aws-amplify/ui-react'; \u2192 import { MdFullscreen } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z",
    fill: "currentColor"
  })));
}, "IconFullscreen");
import ig from "classnames";
var sg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconFunctions } from '@aws-amplify/ui-react'; \u2192 import { MdFunctions } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ig(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 4H6V6L12.5 12L6 18V20H18V17H11L16 12L11 7H18V4Z",
    fill: "currentColor"
  })));
}, "IconFunctions");
import ag from "classnames";
var ng = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGTranslate } from '@aws-amplify/ui-react'; \u2192 import { MdGTranslate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ag(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 5H10.88L10 2H4C2.9 2 2 2.9 2 4V17C2 18.1 2.9 19 4 19H11L12 22H20C21.1 22 22 21.1 22 20V7C22 5.9 21.1 5 20 5ZM7.17 14.59C4.92 14.59 3.08 12.76 3.08 10.5C3.08 8.24 4.91 6.41 7.17 6.41C8.21 6.41 9.16 6.78 9.91 7.48L9.98 7.54L8.75 8.72L8.69 8.67C8.4 8.4 7.91 8.08 7.17 8.08C5.86 8.08 4.79 9.17 4.79 10.5C4.79 11.83 5.86 12.92 7.17 12.92C8.54 12.92 9.13 12.05 9.29 11.46H7.08V9.91H11.03L11.04 9.98C11.08 10.19 11.09 10.38 11.09 10.59C11.09 12.94 9.48 14.59 7.17 14.59V14.59ZM13.2 12.88C13.53 13.48 13.94 14.06 14.39 14.58L13.85 15.11L13.2 12.88V12.88ZM13.97 12.12H12.98L12.67 11.08H16.66C16.66 11.08 16.32 12.39 15.1 13.82C14.58 13.2 14.21 12.59 13.97 12.12V12.12ZM21 20C21 20.55 20.55 21 20 21H13L15 19L14.19 16.23L15.11 15.31L17.79 18L18.52 17.27L15.81 14.59C16.71 13.56 17.41 12.34 17.73 11.08H19V10.04H15.36V9H14.32V10.04H12.36L11.18 6H20C20.55 6 21 6.45 21 7V20Z",
    fill: "currentColor"
  })));
}, "IconGTranslate");
import mg from "classnames";
var cg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGamepad } from '@aws-amplify/ui-react'; \u2192 import { MdGamepad } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 4V6.67L12 7.67L11 6.67V4H13ZM20 11V13H17.33L16.33 12L17.33 11H20ZM6.67 11L7.67 12L6.67 13H4V11H6.67ZM12 16.33L13 17.33V20H11V17.33L12 16.33ZM15 2H9V7.5L12 10.5L15 7.5V2ZM22 9H16.5L13.5 12L16.5 15H22V9ZM7.5 9H2V15H7.5L10.5 12L7.5 9ZM12 13.5L9 16.5V22H15V16.5L12 13.5Z",
    fill: "currentColor"
  })));
}, "IconGamepad");
import lg from "classnames";
var pg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGames } from '@aws-amplify/ui-react'; \u2192 import { MdGames } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 4V6.67L12 7.67L11 6.67V4H13ZM20 11V13H17.33L16.33 12L17.33 11H20ZM6.67 11L7.67 12L6.67 13H4V11H6.67ZM12 16.33L13 17.33V20H11V17.33L12 16.33ZM15 2H9V7.5L12 10.5L15 7.5V2ZM22 9H16.5L13.5 12L16.5 15H22V9ZM7.5 9H2V15H7.5L10.5 12L7.5 9ZM12 13.5L9 16.5V22H15V16.5L12 13.5Z",
    fill: "currentColor"
  })));
}, "IconGames");
import hg from "classnames";
var fg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGavel } from '@aws-amplify/ui-react'; \u2192 import { MdGavel } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1 21H13V23H1V21ZM5.24 8.07L8.07 5.24L22.21 19.38L19.38 22.21L5.24 8.07ZM12.32 1L17.98 6.66L15.15 9.49L9.49 3.83L12.32 1ZM3.83 9.48L9.49 15.14L6.66 17.97L1 12.31L3.83 9.48Z",
    fill: "currentColor"
  })));
}, "IconGavel");
import Cg from "classnames";
var gg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGesture } from '@aws-amplify/ui-react'; \u2192 import { MdGesture } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4.58997 6.89C5.28997 6.18 5.98997 5.54 6.29997 5.67C6.79997 5.87 6.29997 6.7 5.99997 7.19C5.74997 7.61 3.13997 11.08 3.13997 13.5C3.13997 14.78 3.61997 15.84 4.47997 16.48C5.22997 17.04 6.21997 17.21 7.11997 16.94C8.18997 16.63 9.06997 15.54 10.18 14.17C11.39 12.68 13.01 10.73 14.26 10.73C15.89 10.73 15.91 11.74 16.02 12.52C12.24 13.16 10.64 16.19 10.64 17.89C10.64 19.59 12.08 20.98 13.85 20.98C15.48 20.98 18.14 19.65 18.54 14.88H21V12.38H18.53C18.38 10.73 17.44 8.18 14.5 8.18C12.25 8.18 10.32 10.09 9.55997 11.02C8.97997 11.75 7.49997 13.5 7.26997 13.74C7.01997 14.04 6.58997 14.58 6.15997 14.58C5.70997 14.58 5.43997 13.75 5.79997 12.66C6.14997 11.57 7.19997 9.8 7.64997 9.14C8.42997 8 8.94997 7.22 8.94997 5.86C8.94997 3.69 7.30997 3 6.43997 3C5.11997 3 3.96997 4 3.71997 4.25C3.35997 4.61 3.05997 4.91 2.83997 5.18L4.58997 6.89ZM13.88 18.55C13.57 18.55 13.14 18.29 13.14 17.83C13.14 17.23 13.87 15.63 16.01 15.07C15.71 17.76 14.58 18.55 13.88 18.55Z",
    fill: "currentColor"
  })));
}, "IconGesture");
import ug from "classnames";
var wg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGetApp } from '@aws-amplify/ui-react'; \u2192 import { MdGetApp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ug(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 5V11H14.17L12 13.17L9.83 11H11V5H13ZM15 3H9V9H5L12 16L19 9H15V3ZM19 18H5V20H19V18Z",
    fill: "currentColor"
  })));
}, "IconGetApp");
import dg from "classnames";
var Vg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGif } from '@aws-amplify/ui-react'; \u2192 import { MdGif } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.5 9H13V15H11.5V9ZM9 9H6C5.4 9 5 9.5 5 10V14C5 14.5 5.4 15 6 15H9C9.6 15 10 14.5 10 14V12H8.5V13.5H6.5V10.5H10V10C10 9.5 9.6 9 9 9ZM19 10.5V9H14.5V15H16V13H18V11.5H16V10.5H19Z",
    fill: "currentColor"
  })));
}, "IconGif");
import Hg from "classnames";
var Mg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGolfCourse } from '@aws-amplify/ui-react'; \u2192 import { MdGolfCourse } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.5 21C20.3284 21 21 20.3284 21 19.5C21 18.6716 20.3284 18 19.5 18C18.6716 18 18 18.6716 18 19.5C18 20.3284 18.6716 21 19.5 21Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M17 5.92L9 2V20H7V18.27C5.21 18.62 4 19.26 4 20C4 21.1 6.69 22 10 22C13.31 22 16 21.1 16 20C16 19.01 13.84 18.19 11 18.03V8.98L17 5.92Z",
    fill: "black"
  })));
}, "IconGolfCourse");
import xg from "classnames";
var Ig = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGpsFixed } from '@aws-amplify/ui-react'; \u2192 import { MdGpsFixed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94V11ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z",
    fill: "currentColor"
  })));
}, "IconGpsFixed");
import Lg from "classnames";
var vg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGpsNotFixed } from '@aws-amplify/ui-react'; \u2192 import { MdGpsNotFixed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z",
    fill: "currentColor"
  })));
}, "IconGpsNotFixed");
import Ng from "classnames";
var yg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGpsOff } from '@aws-amplify/ui-react'; \u2192 import { MdGpsOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ng(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C10.02 3.17 9.09 3.44 8.23 3.84L9.76 5.37C10.46 5.13 11.22 5 12 5C15.87 5 19 8.13 19 12C19 12.79 18.87 13.54 18.63 14.24L20.16 15.77C20.56 14.91 20.83 13.98 20.94 13H23V11H20.94ZM3 4.27L5.04 6.31C3.97 7.62 3.26 9.23 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C14.77 20.74 16.38 20.03 17.69 18.96L19.73 21L21.14 19.59L4.41 2.86L3 4.27ZM16.27 17.54C15.09 18.45 13.61 19 12 19C8.13 19 5 15.87 5 12C5 10.39 5.55 8.91 6.46 7.73L16.27 17.54Z",
    fill: "currentColor"
  })));
}, "IconGpsOff");
import bg from "classnames";
var Zg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGrade } from '@aws-amplify/ui-react'; \u2192 import { MdGrade } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 7.13L12.97 9.42L13.44 10.53L14.64 10.63L17.11 10.84L15.23 12.47L14.32 13.26L14.59 14.44L15.15 16.85L13.03 15.57L12 14.93L10.97 15.55L8.85 16.83L9.41 14.42L9.68 13.24L8.77 12.45L6.89 10.82L9.36 10.61L10.56 10.51L11.03 9.4L12 7.13V7.13ZM12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2Z",
    fill: "currentColor"
  })));
}, "IconGrade");
import Bg from "classnames";
var Wg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGradient } from '@aws-amplify/ui-react'; \u2192 import { MdGradient } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 9H13V11H11V9ZM9 11H11V13H9V11ZM13 11H15V13H13V11ZM15 9H17V11H15V9ZM7 9H9V11H7V9ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18ZM19 11H17V13H19V15H17V13H15V15H13V13H11V15H9V13H7V15H5V13H7V11H5V5H19V11Z",
    fill: "currentColor"
  })));
}, "IconGradient");
import kg from "classnames";
var Dg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGrading } from '@aws-amplify/ui-react'; \u2192 import { MdGrading } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 7H20V9H4V7ZM4 13H20V11H4V13ZM4 17H11V15H4V17ZM4 21H11V19H4V21ZM15.41 18.17L14 16.75L12.59 18.16L15.41 21L20 16.42L18.58 15L15.41 18.17ZM4 3V5H20V3H4Z",
    fill: "currentColor"
  })));
}, "IconGrading");
import Pg from "classnames";
var Sg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGrain } from '@aws-amplify/ui-react'; \u2192 import { MdGrain } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 12C8.9 12 8 12.9 8 14C8 15.1 8.9 16 10 16C11.1 16 12 15.1 12 14C12 12.9 11.1 12 10 12ZM6 8C4.9 8 4 8.9 4 10C4 11.1 4.9 12 6 12C7.1 12 8 11.1 8 10C8 8.9 7.1 8 6 8ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16ZM18 8C19.1 8 20 7.1 20 6C20 4.9 19.1 4 18 4C16.9 4 16 4.9 16 6C16 7.1 16.9 8 18 8ZM14 16C12.9 16 12 16.9 12 18C12 19.1 12.9 20 14 20C15.1 20 16 19.1 16 18C16 16.9 15.1 16 14 16ZM18 12C16.9 12 16 12.9 16 14C16 15.1 16.9 16 18 16C19.1 16 20 15.1 20 14C20 12.9 19.1 12 18 12ZM14 8C12.9 8 12 8.9 12 10C12 11.1 12.9 12 14 12C15.1 12 16 11.1 16 10C16 8.9 15.1 8 14 8ZM10 4C8.9 4 8 4.9 8 6C8 7.1 8.9 8 10 8C11.1 8 12 7.1 12 6C12 4.9 11.1 4 10 4Z",
    fill: "currentColor"
  })));
}, "IconGrain");
import jg from "classnames";
var Yg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGraphicEq } from '@aws-amplify/ui-react'; \u2192 import { MdGraphicEq } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 18H9V6H7V18ZM11 22H13V2H11V22ZM3 14H5V10H3V14ZM15 18H17V6H15V18ZM19 10V14H21V10H19Z",
    fill: "currentColor"
  })));
}, "IconGraphicEq");
import Fg from "classnames";
var Tg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGrass } from '@aws-amplify/ui-react'; \u2192 import { MdGrass } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 20H2V18H7.75C7.02 15.19 4.81 12.99 2 12.26C2.64 12.1 3.31 12 4 12C8.42 12 12 15.58 12 20ZM22 12.26C21.36 12.1 20.69 12 20 12C17.07 12 14.52 13.58 13.12 15.93C13.41 16.59 13.65 17.28 13.79 18C13.92 18.65 13.99 19.32 13.99 20H15.99H21.99V18H16.24C16.98 15.19 19.19 12.99 22 12.26ZM15.64 11.02C16.42 8.93 17.87 7.18 19.73 6.02C15.44 6.16 12 9.67 12 14C12 14.01 12 14.02 12 14.02C12.95 12.75 14.2 11.72 15.64 11.02ZM11.42 8.85C10.58 6.66 8.88 4.89 6.7 4C8.14 5.86 9 8.18 9 10.71C9 10.92 8.97 11.12 8.96 11.32C9.39 11.56 9.79 11.84 10.18 12.14C10.39 10.96 10.83 9.85 11.42 8.85Z",
    fill: "currentColor"
  })));
}, "IconGrass");
import Ag from "classnames";
var Eg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGridOff } from '@aws-amplify/ui-react'; \u2192 import { MdGridOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ag(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_40416)"
  }, e.createElement("path", {
    d: "M8 4.00014V4.89014L10 6.89014V4.00014H14V8.00014H11.11L13.11 10.0001H14V10.8901L16 12.8901V10.0001H20V14.0001H17.11L19.11 16.0001H20V16.8901L22 18.8901V4.00014C22 2.90014 21.1 2.00014 20 2.00014H5.11L7.11 4.00014H8ZM16 4.00014H20V8.00014H16V4.00014ZM1.41 1.14014L0 2.55014L2 4.55014V20.0001C2 21.1001 2.9 22.0001 4 22.0001H19.45L21.46 24.0101L22.87 22.6001L1.41 1.14014ZM10 12.5501L11.45 14.0001H10V12.5501ZM4 6.55014L5.45 8.00014H4V6.55014V6.55014ZM8 20.0001H4V16.0001H8V20.0001ZM8 14.0001H4V10.0001H7.45L8 10.5501V14.0001ZM14 20.0001H10V16.0001H13.45L14 16.5501V20.0001ZM16 20.0001V18.5501L17.45 20.0001H16Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_40416"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconGridOff");
import Og from "classnames";

var _g = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGridOn } from '@aws-amplify/ui-react'; \u2192 import { MdGridOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Og(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM8 20H4V16H8V20ZM8 14H4V10H8V14ZM8 8H4V4H8V8ZM14 20H10V16H14V20ZM14 14H10V10H14V14ZM14 8H10V4H14V8ZM20 20H16V16H20V20ZM20 14H16V10H20V14ZM20 8H16V4H20V8Z",
    fill: "currentColor"
  })));
}, "IconGridOn");

import Gg from "classnames";
var Ug = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGroupAdd } from '@aws-amplify/ui-react'; \u2192 import { MdGroupAdd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 15V12H8V10H5V7H3V10H0V12H3V15H5ZM12 13.75C9.66 13.75 5 14.92 5 17.25V19H19V17.25C19 14.92 14.34 13.75 12 13.75ZM7.34 17C8.18 16.42 10.21 15.75 12 15.75C13.79 15.75 15.82 16.42 16.66 17H7.34ZM12 12C13.93 12 15.5 10.43 15.5 8.5C15.5 6.57 13.93 5 12 5C10.07 5 8.5 6.57 8.5 8.5C8.5 10.43 10.07 12 12 12ZM12 7C12.83 7 13.5 7.67 13.5 8.5C13.5 9.33 12.83 10 12 10C11.17 10 10.5 9.33 10.5 8.5C10.5 7.67 11.17 7 12 7ZM17 12C18.93 12 20.5 10.43 20.5 8.5C20.5 6.57 18.93 5 17 5C16.76 5 16.52 5.02 16.29 5.07C17.05 6.01 17.5 7.2 17.5 8.5C17.5 9.8 17.03 10.98 16.27 11.92C16.51 11.97 16.75 12 17 12ZM19.32 14.02C20.32 14.83 21 15.89 21 17.25V19H24V17.25C24 15.56 21.56 14.49 19.32 14.02Z",
    fill: "currentColor"
  })));
}, "IconGroupAdd");
import zg from "classnames";
var Xg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGroupWork } from '@aws-amplify/ui-react'; \u2192 import { MdGroupWork } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8 16C9.10457 16 10 15.1046 10 14C10 12.8954 9.10457 12 8 12C6.89543 12 6 12.8954 6 14C6 15.1046 6.89543 16 8 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 10C13.1046 10 14 9.10457 14 8C14 6.89543 13.1046 6 12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16 16C17.1046 16 18 15.1046 18 14C18 12.8954 17.1046 12 16 12C14.8954 12 14 12.8954 14 14C14 15.1046 14.8954 16 16 16Z",
    fill: "black"
  })));
}, "IconGroupWork");
import Kg from "classnames";
var qg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGroup } from '@aws-amplify/ui-react'; \u2192 import { MdGroup } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81V13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z",
    fill: "currentColor"
  })));
}, "IconGroup");
import Qg from "classnames";
var Jg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconGroups } from '@aws-amplify/ui-react'; \u2192 import { MdGroups } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qg(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V18H18V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z",
    fill: "currentColor"
  })));
}, "IconGroups");
import $g from "classnames";
var Rg = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHandyman } from '@aws-amplify/ui-react'; \u2192 import { MdHandyman } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $g(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.6698 18.1701L16.3698 12.8701H15.3798L12.8398 15.4101V16.4001L18.1398 21.7001C18.5298 22.0901 19.1598 22.0901 19.5498 21.7001L21.6698 19.5801C22.0598 19.2001 22.0598 18.5601 21.6698 18.1701ZM18.8398 19.5901L14.5998 15.3501L15.3098 14.6401L19.5498 18.8801L18.8398 19.5901Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M17.34 10.19L18.75 8.78L20.87 10.9C22.04 9.73 22.04 7.83 20.87 6.66L17.33 3.12L15.92 4.53V1.71L15.22 1L11.68 4.54L12.39 5.25H15.22L13.81 6.66L14.87 7.72L11.98 10.61L7.85 6.48V5.06L4.83 2.04L2 4.87L5.03 7.9H6.44L10.57 12.03L9.72 12.88H7.6L2.3 18.18C1.91 18.57 1.91 19.2 2.3 19.59L4.42 21.71C4.81 22.1 5.44 22.1 5.83 21.71L11.13 16.41V14.29L16.28 9.14L17.34 10.19ZM9.36 15.34L5.12 19.58L4.41 18.87L8.65 14.63L9.36 15.34Z",
    fill: "black"
  })));
}, "IconHandyman");
import eu from "classnames";
var ou = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHd } from '@aws-amplify/ui-react'; \u2192 import { MdHd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7.5 13H9.5V15H11V9H9.5V11.5H7.5V9H6V15H7.5V13ZM18 14V10C18 9.45 17.55 9 17 9H13V15H17C17.55 15 18 14.55 18 14ZM16.5 13.5H14.5V10.5H16.5V13.5Z",
    fill: "currentColor"
  })));
}, "IconHd");
import tu from "classnames";
var ru = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHdrOff } from '@aws-amplify/ui-react'; \u2192 import { MdHdrOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.5 15.0002V13.0002H18.6L19.5 15.0002H21L20.1 12.9002C20.6 12.6002 21 12.1002 21 11.5002V10.5002C21 9.70023 20.3 9.00023 19.5 9.00023H16V13.8602L17.14 15.0002H17.5ZM17.5 10.5002H19.5V11.5002H17.5V10.5002ZM13 10.5002V10.8602L14.5 12.3602V10.5002C14.5 9.70023 13.8 9.00023 13 9.00023H11.14L12.64 10.5002H13ZM2.50995 2.49023L1.44995 3.55023L6.89995 9.00023H6.49995V11.0002H4.49995V9.00023H2.99995V15.0002H4.49995V12.5002H6.49995V15.0002H7.99995V10.1002L9.49995 11.6002V15.0002H12.9L20.5 22.6002L21.5599 21.5402L2.50995 2.49023Z",
    fill: "currentColor"
  })));
}, "IconHdrOff");
import iu from "classnames";
var su = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHdrOn } from '@aws-amplify/ui-react'; \u2192 import { MdHdrOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 11.5V10.5C21 9.7 20.3 9 19.5 9H16V15H17.5V13H18.6L19.5 15H21L20.1 12.9C20.6 12.6 21 12.1 21 11.5ZM19.5 11.5H17.5V10.5H19.5V11.5ZM6.5 11H4.5V9H3V15H4.5V12.5H6.5V15H8V9H6.5V11ZM13 9H9.5V15H13C13.8 15 14.5 14.3 14.5 13.5V10.5C14.5 9.7 13.8 9 13 9ZM13 13.5H11V10.5H13V13.5Z",
    fill: "currentColor"
  })));
}, "IconHdrOn");
import au from "classnames";
var nu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHdrStrong } from '@aws-amplify/ui-react'; \u2192 import { MdHdrStrong } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: au(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 6C13.69 6 11 8.69 11 12C11 15.31 13.69 18 17 18C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM5 8C2.79 8 1 9.79 1 12C1 14.21 2.79 16 5 16C7.21 16 9 14.21 9 12C9 9.79 7.21 8 5 8ZM5 14C3.9 14 3 13.1 3 12C3 10.9 3.9 10 5 10C6.1 10 7 10.9 7 12C7 13.1 6.1 14 5 14Z",
    fill: "currentColor"
  })));
}, "IconHdrStrong");
import mu from "classnames";
var cu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHdrWeak } from '@aws-amplify/ui-react'; \u2192 import { MdHdrWeak } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 8C2.79 8 1 9.79 1 12C1 14.21 2.79 16 5 16C7.21 16 9 14.21 9 12C9 9.79 7.21 8 5 8ZM17 6C13.69 6 11 8.69 11 12C11 15.31 13.69 18 17 18C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM17 16C14.79 16 13 14.21 13 12C13 9.79 14.79 8 17 8C19.21 8 21 9.79 21 12C21 14.21 19.21 16 17 16Z",
    fill: "currentColor"
  })));
}, "IconHdrWeak");
import lu from "classnames";
var pu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHeadsetMic } from '@aws-amplify/ui-react'; \u2192 import { MdHeadsetMic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 14V18H17V14H19ZM7 14V18H6C5.45 18 5 17.55 5 17V14H7ZM12 1C7.03 1 3 5.03 3 10V17C3 18.66 4.34 20 6 20H9V12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H15V20H19V21H12V23H18C19.66 23 21 21.66 21 20V10C21 5.03 16.97 1 12 1Z",
    fill: "currentColor"
  })));
}, "IconHeadsetMic");
import hu from "classnames";
var fu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHeadset } from '@aws-amplify/ui-react'; \u2192 import { MdHeadset } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 14V17C19 17.55 18.55 18 18 18H17V14H19ZM7 14V18H6C5.45 18 5 17.55 5 17V14H7ZM12 1C7.03 1 3 5.03 3 10V17C3 18.66 4.34 20 6 20H9V12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H15V20H18C19.66 20 21 18.66 21 17V10C21 5.03 16.97 1 12 1Z",
    fill: "currentColor"
  })));
}, "IconHeadset");
import Cu from "classnames";
var gu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHealing } from '@aws-amplify/ui-react'; \u2192 import { MdHealing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.73 12.0201L21.71 8.04006C22.1 7.65006 22.1 7.02006 21.71 6.63006L17.37 2.29006C16.98 1.90006 16.35 1.90006 15.96 2.29006L11.98 6.27006L8.00002 2.29006C7.80002 2.10006 7.55002 2.00006 7.29002 2.00006C7.04002 2.00006 6.78002 2.10006 6.59002 2.29006L2.25002 6.63006C1.86002 7.02006 1.86002 7.65006 2.25002 8.04006L6.23002 12.0201L2.25002 16.0001C1.86002 16.3901 1.86002 17.0201 2.25002 17.4101L6.59002 21.7501C6.98002 22.1401 7.61002 22.1401 8.00002 21.7501L11.98 17.7701L15.96 21.7501C16.16 21.9501 16.41 22.0401 16.67 22.0401C16.93 22.0401 17.18 21.9401 17.38 21.7501L21.72 17.4101C22.11 17.0201 22.11 16.3901 21.72 16.0001L17.73 12.0201V12.0201ZM12 9.00006C12.55 9.00006 13 9.45006 13 10.0001C13 10.5501 12.55 11.0001 12 11.0001C11.45 11.0001 11 10.5501 11 10.0001C11 9.45006 11.45 9.00006 12 9.00006ZM7.29002 10.9601L3.66002 7.34006L7.29002 3.71006L10.91 7.33006L7.29002 10.9601ZM10 13.0001C9.45002 13.0001 9.00002 12.5501 9.00002 12.0001C9.00002 11.4501 9.45002 11.0001 10 11.0001C10.55 11.0001 11 11.4501 11 12.0001C11 12.5501 10.55 13.0001 10 13.0001ZM12 15.0001C11.45 15.0001 11 14.5501 11 14.0001C11 13.4501 11.45 13.0001 12 13.0001C12.55 13.0001 13 13.4501 13 14.0001C13 14.5501 12.55 15.0001 12 15.0001ZM14 11.0001C14.55 11.0001 15 11.4501 15 12.0001C15 12.5501 14.55 13.0001 14 13.0001C13.45 13.0001 13 12.5501 13 12.0001C13 11.4501 13.45 11.0001 14 11.0001ZM16.66 20.3401L13.03 16.7201L16.66 13.0901L20.28 16.7101L16.66 20.3401Z",
    fill: "currentColor"
  })));
}, "IconHealing");
import uu from "classnames";
var wu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHearingDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdHearingDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.03001 3.20021C7.15001 2.44021 8.51001 2.00021 10 2.00021C13.93 2.00021 17 5.07021 17 9.00021C17 10.2602 16.62 11.6502 15.93 12.9002C15.91 12.9402 15.88 12.9802 15.85 13.0302L14.37 11.5502C14.77 10.6902 15 9.80021 15 9.00021C15 6.20021 12.8 4.00021 10 4.00021C9.08001 4.00021 8.24001 4.26021 7.50001 4.67021L6.03001 3.20021ZM17.21 14.3802L18.64 15.8102C20.11 13.9302 21 11.5702 21 9.00021C21 5.96021 19.77 3.21021 17.78 1.22021L16.36 2.64021C17.99 4.26021 19 6.51021 19 9.00021C19 11.0202 18.33 12.8802 17.21 14.3802ZM10 6.50021C9.79001 6.50021 9.60001 6.53021 9.41001 6.58021L12.42 9.59021C12.47 9.40021 12.5 9.21021 12.5 9.00021C12.5 7.62021 11.38 6.50021 10 6.50021ZM21.19 21.1902L2.81001 2.81021L1.39001 4.22021L3.52001 6.35021C3.19001 7.16021 3.00001 8.05021 3.00001 9.00021H5.00001C5.00001 8.64021 5.05001 8.29021 5.12001 7.95021L11.73 14.5602C10.85 15.2402 9.95001 15.9702 9.46001 17.4602C8.96001 18.9602 8.46001 19.4702 7.75001 19.8402C7.56001 19.9402 7.29001 20.0002 7.00001 20.0002C5.90001 20.0002 5.00001 19.1002 5.00001 18.0002H3.00001C3.00001 20.2102 4.79001 22.0002 7.00001 22.0002C7.57001 22.0002 8.13002 21.8802 8.64002 21.6502C10 20.9402 10.77 19.9202 11.37 18.1002C11.69 17.1202 12.27 16.6702 13.08 16.0502C13.11 16.0302 13.13 16.0102 13.16 15.9902L19.78 22.6102L21.19 21.1902Z",
    fill: "currentColor"
  })));
}, "IconHearingDisabled");
import du from "classnames";
var Vu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHearing } from '@aws-amplify/ui-react'; \u2192 import { MdHearing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: du(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 20.0002C16.71 20.0002 16.44 19.9402 16.24 19.8502C15.53 19.4802 15.03 18.9702 14.53 17.4702C14.02 15.9102 13.06 15.1802 12.14 14.4702C11.35 13.8602 10.53 13.2302 9.82 11.9402C9.29 10.9802 9 9.93021 9 9.00021C9 6.20021 11.2 4.00021 14 4.00021C16.8 4.00021 19 6.20021 19 9.00021H21C21 5.07021 17.93 2.00021 14 2.00021C10.07 2.00021 7 5.07021 7 9.00021C7 10.2602 7.38 11.6502 8.07 12.9002C8.98 14.5502 10.05 15.3802 10.92 16.0502C11.73 16.6702 12.31 17.1202 12.63 18.1002C13.23 19.9202 14 20.9402 15.36 21.6502C15.87 21.8802 16.43 22.0002 17 22.0002C19.21 22.0002 21 20.2102 21 18.0002H19C19 19.1002 18.1 20.0002 17 20.0002V20.0002ZM7.64 2.64021L6.22 1.22021C4.23 3.21021 3 5.96021 3 9.00021C3 12.0402 4.23 14.7902 6.22 16.7802L7.63 15.3702C6.01 13.7402 5 11.4902 5 9.00021C5 6.51021 6.01 4.26021 7.64 2.64021V2.64021ZM11.5 9.00021C11.5 10.3802 12.62 11.5002 14 11.5002C15.38 11.5002 16.5 10.3802 16.5 9.00021C16.5 7.62021 15.38 6.50021 14 6.50021C12.62 6.50021 11.5 7.62021 11.5 9.00021Z",
    fill: "currentColor"
  })));
}, "IconHearing");
import Hu from "classnames";
var Mu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHeight } from '@aws-amplify/ui-react'; \u2192 import { MdHeight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 6.99H16L12 3L8 6.99H11V17.01H8L12 21L16 17.01H13V6.99Z",
    fill: "currentColor"
  })));
}, "IconHeight");
import xu from "classnames";
var Iu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHelpCenter } from '@aws-amplify/ui-react'; \u2192 import { MdHelpCenter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13.25 16.74C13.25 17.43 12.72 18 12 18C11.3 18 10.74 17.44 10.74 16.74C10.74 16.03 11.3 15.49 12 15.49C12.71 15.49 13.25 16.04 13.25 16.74ZM11.99 6C10.22 6 9.01 7.15 8.56 8.49L10.2 9.18C10.42 8.51 10.94 7.7 12 7.7C13.62 7.7 13.94 9.22 13.37 10.03C12.83 10.8 11.9 11.32 11.41 12.19C11.02 12.88 11.1 13.68 11.1 14.17H12.92C12.92 13.24 12.99 13.05 13.14 12.76C13.53 12.04 14.25 11.7 15.01 10.59C15.69 9.59 15.43 8.23 14.99 7.51C14.48 6.67 13.47 6 11.99 6ZM19 5H5V19H19V5ZM19 3C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19Z",
    fill: "currentColor"
  })));
}, "IconHelpCenter");
import Lu from "classnames";
var vu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHelpOutline } from '@aws-amplify/ui-react'; \u2192 import { MdHelpOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z",
    fill: "currentColor"
  })));
}, "IconHelpOutline");
import Nu from "classnames";
var yu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHelp } from '@aws-amplify/ui-react'; \u2192 import { MdHelp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",
    fill: "currentColor"
  })));
}, "IconHelp");
import bu from "classnames";
var Zu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHighQuality } from '@aws-amplify/ui-react'; \u2192 import { MdHighQuality } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.1 4 19 4ZM19 18H5V6H19V18ZM7.5 13H9.5V15H11V9H9.5V11.5H7.5V9H6V15H7.5V13ZM14 15H14.75V16.5H16.25V15H17C17.55 15 18 14.55 18 14V10C18 9.45 17.55 9 17 9H14C13.45 9 13 9.45 13 10V14C13 14.55 13.45 15 14 15ZM14.5 10.5H16.5V13.5H14.5V10.5Z",
    fill: "currentColor"
  })));
}, "IconHighQuality");
import Bu from "classnames";
var Wu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHighlightAlt } from '@aws-amplify/ui-react'; \u2192 import { MdHighlightAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 5H15V3H17V5ZM15 15V21L17.29 18.71L19.59 21L21 19.59L18.71 17.3L21 15H15ZM19 9H21V7H19V9ZM19 13H21V11H19V13ZM11 21H13V19H11V21ZM7 5H9V3H7V5ZM3 17H5V15H3V17ZM5 21V19H3C3 20.1 3.9 21 5 21ZM19 3V5H21C21 3.9 20.1 3 19 3ZM11 5H13V3H11V5ZM3 9H5V7H3V9ZM7 21H9V19H7V21ZM3 13H5V11H3V13ZM3 5H5V3C3.9 3 3 3.9 3 5Z",
    fill: "currentColor"
  })));
}, "IconHighlightAlt");
import ku from "classnames";
var Du = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ku(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.59 8L12 10.59L9.41 8L8 9.41L10.59 12L8 14.59L9.41 16L12 13.41L14.59 16L16 14.59L13.41 12L16 9.41L14.59 8ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconHighlightOff");
import Pu from "classnames";
var Su = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHighlight } from '@aws-amplify/ui-react'; \u2192 import { MdHighlight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5.99995 14L8.99995 17V22H15V17L18 14V9H5.99995V14ZM7.99995 11H16V13.17L13 16.17V20H11V16.17L7.99995 13.17V11ZM11 2H13V5H11V2ZM3.50195 5.874L4.91595 4.46L7.03795 6.58L5.62395 7.995L3.50195 5.874ZM16.96 6.582L19.083 4.462L20.496 5.878L18.373 7.998L16.96 6.582Z",
    fill: "currentColor"
  })));
}, "IconHighlight");
import ju from "classnames";
var Yu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHistoryEdu } from '@aws-amplify/ui-react'; \u2192 import { MdHistoryEdu } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ju(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.99994 4V5.38C8.16994 5.05 7.27994 4.88 6.38994 4.88C4.59994 4.88 2.80994 5.56 1.43994 6.93L4.76994 10.26H5.87994V11.37C6.73994 12.23 7.85994 12.68 8.98994 12.73V15H5.99994V18C5.99994 19.1 6.89994 20 7.99994 20H17.9999C19.6599 20 20.9999 18.66 20.9999 17V4H8.99994ZM7.88994 10.41V8.26H5.60994L4.56994 7.22C5.13994 7 5.75994 6.88 6.38994 6.88C7.72994 6.88 8.97994 7.4 9.92994 8.34L11.3399 9.75L11.1399 9.95C10.6299 10.46 9.94994 10.75 9.21994 10.75C8.74994 10.75 8.28994 10.63 7.88994 10.41ZM18.9999 17C18.9999 17.55 18.5499 18 17.9999 18C17.4499 18 16.9999 17.55 16.9999 17V15H10.9999V12.41C11.5699 12.18 12.0999 11.84 12.5599 11.38L12.7599 11.18L15.5899 14H16.9999V12.59L10.9999 6.62V6H18.9999V17Z",
    fill: "currentColor"
  })));
}, "IconHistoryEdu");
import Fu from "classnames";
var Tu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHistoryToggleOff } from '@aws-amplify/ui-react'; \u2192 import { MdHistoryToggleOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.1 19.3698L16.1 21.1098C15.14 21.5498 14.09 21.8398 13 21.9498V19.9298C13.74 19.8398 14.44 19.6498 15.1 19.3698ZM4.07 12.9998H2.05C2.16 14.0998 2.45 15.1398 2.89 16.0998L4.63 15.0998C4.35 14.4398 4.16 13.7398 4.07 12.9998ZM15.1 4.6298L16.1 2.8898C15.14 2.4498 14.1 2.1598 13 2.0498V4.0698C13.74 4.1598 14.44 4.3498 15.1 4.6298ZM19.93 10.9998H21.95C21.84 9.8998 21.55 8.85981 21.11 7.89981L19.37 8.8998C19.65 9.5598 19.84 10.2598 19.93 10.9998ZM8.9 19.3698L7.9 21.1098C8.86 21.5498 9.91 21.8398 11 21.9498V19.9298C10.26 19.8398 9.56 19.6498 8.9 19.3698ZM11 4.0698V2.0498C9.9 2.1598 8.86 2.4498 7.9 2.8898L8.9 4.6298C9.56 4.3498 10.26 4.1598 11 4.0698ZM18.36 7.1698L20.1 6.1598C19.47 5.2898 18.7 4.5198 17.83 3.8898L16.82 5.6298C17.41 6.0798 17.92 6.5898 18.36 7.1698ZM4.63 8.8998L2.89 7.89981C2.45 8.85981 2.16 9.8998 2.05 10.9998H4.07C4.16 10.2598 4.35 9.5598 4.63 8.8998ZM19.93 12.9998C19.84 13.7398 19.65 14.4398 19.37 15.0998L21.11 16.0998C21.55 15.1398 21.84 14.0898 21.95 12.9998H19.93V12.9998ZM16.83 18.3598L17.84 20.0998C18.71 19.4698 19.48 18.6998 20.11 17.8298L18.37 16.8198C17.92 17.4098 17.41 17.9198 16.83 18.3598ZM7.17 5.6398L6.17 3.8898C5.29 4.5298 4.53 5.2898 3.9 6.1698L5.64 7.1798C6.08 6.5898 6.59 6.0798 7.17 5.6398ZM5.64 16.8298L3.9 17.8298C4.53 18.6998 5.3 19.4698 6.17 20.0998L7.18 18.3598C6.59 17.9198 6.08 17.4098 5.64 16.8298ZM13 6.9998H11V12.4098L15.29 16.6998L16.7 15.2898L13 11.5898V6.9998Z",
    fill: "currentColor"
  })));
}, "IconHistoryToggleOff");
import Au from "classnames";
var Eu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHistory } from '@aws-amplify/ui-react'; \u2192 import { MdHistory } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Au(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 3C8.03 3 4 7.03 4 12H1L4.89 15.89L4.96 16.03L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.25 15.52L17.02 14.24L13.5 12.15V8H12Z",
    fill: "currentColor"
  })));
}, "IconHistory");
import Ou from "classnames";

var _u = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHomeRepairService } from '@aws-amplify/ui-react'; \u2192 import { MdHomeRepairService } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ou(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 8H17V6C17 4.9 16.1 4 15 4H9C7.9 4 7 4.9 7 6V8H4C2.9 8 2 8.9 2 10V20H22V10C22 8.9 21.1 8 20 8ZM9 6H15V8H9V6ZM20 18H4V15H6V16H8V15H16V16H18V15H20V18ZM18 13V12H16V13H8V12H6V13H4V10H7H17H20V13H18Z",
    fill: "currentColor"
  })));
}, "IconHomeRepairService");

import Gu from "classnames";
var Uu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHomeWork } from '@aws-amplify/ui-react'; \u2192 import { MdHomeWork } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.0002 15H19.0002V17H17.0002V15ZM17.0002 11H19.0002V13H17.0002V11ZM17.0002 7H19.0002V9H17.0002V7ZM13.7402 7L15.0002 7.84V7H13.7402Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10 3V4.51L12 5.84V5H21V19H17V21H23V3H10Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M8.17 5.7002L15 10.2502V21.0002H1V10.4802L8.17 5.7002ZM10 19.0002H13V11.1602L8.17 8.0902L3 11.3802V19.0002H6V13.0002H10V19.0002Z",
    fill: "black"
  })));
}, "IconHomeWork");
import zu from "classnames";
var Xu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHome } from '@aws-amplify/ui-react'; \u2192 import { MdHome } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5.69L17 10.19V18H15V12H9V18H7V10.19L12 5.69V5.69ZM12 3L2 12H5V20H11V14H13V20H19V12H22L12 3Z",
    fill: "currentColor"
  })));
}, "IconHome");
import Ku from "classnames";
var qu = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHorizontalRule } from '@aws-amplify/ui-react'; \u2192 import { MdHorizontalRule } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ku(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 11H4V13H20V11Z",
    fill: "currentColor"
  })));
}, "IconHorizontalRule");
import Qu from "classnames";
var Ju = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHorizontalSplit } from '@aws-amplify/ui-react'; \u2192 import { MdHorizontalSplit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qu(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 15V17H5V15H19ZM21 5H3V7H21V5ZM21 9H3V11H21V9ZM21 13H3V19H21V13Z",
    fill: "currentColor"
  })));
}, "IconHorizontalSplit");
import $u from "classnames";
var Ru = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHotTub } from '@aws-amplify/ui-react'; \u2192 import { MdHotTub } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $u(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 8C8.10457 8 9 7.10457 9 6C9 4.89543 8.10457 4 7 4C5.89543 4 5 4.89543 5 6C5 7.10457 5.89543 8 7 8Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M11.15 12C10.84 11.78 10.56 11.54 10.33 11.28L8.93 9.73C8.74 9.52 8.5 9.35 8.24 9.23C7.95 9.09 7.62 9 7.28 9H7.25C6.01 9 5 10.01 5 11.25V12H2V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V12H11.15ZM7 20H5V14H7V20ZM11 20H9V14H11V20ZM15 20H13V14H15V20ZM19 20H17V14H19V20ZM17.42 7.21C17.99 7.83 18.24 8.62 18.09 9.41L17.98 10H19.89L19.95 9.57C20.16 8.21 19.68 6.86 18.65 5.86L18.58 5.79C18.01 5.17 17.76 4.38 17.91 3.59L18 3H16.11L16.05 3.43C15.85 4.79 16.32 6.14 17.35 7.15L17.42 7.21ZM13.42 7.21C13.99 7.83 14.24 8.62 14.09 9.41L13.98 10H15.89L15.95 9.57C16.16 8.21 15.68 6.86 14.65 5.86L14.58 5.79C14.01 5.17 13.76 4.38 13.91 3.59L14 3H12.11L12.05 3.43C11.85 4.79 12.32 6.14 13.35 7.15L13.42 7.21V7.21Z",
    fill: "black"
  })));
}, "IconHotTub");
import ew from "classnames";
var ow = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHotel } from '@aws-amplify/ui-react'; \u2192 import { MdHotel } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ew(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 14C8.66 14 10 12.66 10 11C10 9.34 8.66 8 7 8C5.34 8 4 9.34 4 11C4 12.66 5.34 14 7 14ZM7 10C7.55 10 8 10.45 8 11C8 11.55 7.55 12 7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10ZM19 7H11V15H3V5H1V20H3V17H21V20H23V11C23 8.79 21.21 7 19 7ZM21 15H13V9H19C20.1 9 21 9.9 21 11V15Z",
    fill: "currentColor"
  })));
}, "IconHotel");
import tw from "classnames";
var rw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHourglassBottom } from '@aws-amplify/ui-react'; \u2192 import { MdHourglassBottom } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 22L17.99 16L14 12L17.99 7.99L18 2H6V8L10 12L6 15.99V22H18ZM8 7.5V4H16V7.5L12 11.5L8 7.5Z",
    fill: "currentColor"
  })));
}, "IconHourglassBottom");
import iw from "classnames";
var sw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHourglassDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdHourglassDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 4H16V7.5L13.16 10.34L14.41 11.59L18 8.01L17.99 8H18V2H6V3.17L8 5.17V4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M2.1 2.1001L0.690002 3.5101L9.59 12.4101L6 16.0001L6.01 16.0101H6V22.0001H18V20.8301L20.49 23.3201L21.9 21.9101L2.1 2.1001ZM16 20.0001H8V16.5001L10.84 13.6601L16 18.8301V20.0001Z",
    fill: "black"
  })));
}, "IconHourglassDisabled");
import aw from "classnames";
var nw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHourglassEmpty } from '@aws-amplify/ui-react'; \u2192 import { MdHourglassEmpty } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 2V8H6.01L6 8.01L10 12L6 16L6.01 16.01H6V22H18V16.01H17.99L18 16L14 12L18 8.01L17.99 8H18V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5ZM12 11.5L8 7.5V4H16V7.5L12 11.5Z",
    fill: "currentColor"
  })));
}, "IconHourglassEmpty");
import mw from "classnames";
var cw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHourglassFull } from '@aws-amplify/ui-react'; \u2192 import { MdHourglassFull } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 2V8H6.01L6 8.01L10 12L6 16L6.01 16.01H6V22H18V16.01H17.99L18 16L14 12L18 8.01L17.99 8H18V2H6Z",
    fill: "currentColor"
  })));
}, "IconHourglassFull");
import lw from "classnames";
var pw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHourglassTop } from '@aws-amplify/ui-react'; \u2192 import { MdHourglassTop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 2L6.01 8L10 12L6.01 16.01L6 22H18V16L14 12L18 8.01V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5Z",
    fill: "currentColor"
  })));
}, "IconHourglassTop");
import hw from "classnames";
var fw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHouseSiding } from '@aws-amplify/ui-react'; \u2192 import { MdHouseSiding } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 12H22L12 3L2 12H5V20H7V18H17V20H19V12ZM7.21 10H16.79L17 10.19V12H7V10.19L7.21 10ZM14.57 8H9.43L12 5.69L14.57 8ZM7 16V14H17V16H7Z",
    fill: "currentColor"
  })));
}, "IconHouseSiding");
import Cw from "classnames";
var gw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHouse } from '@aws-amplify/ui-react'; \u2192 import { MdHouse } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 9.3V4H16V6.6L12 3L2 12H5V20H11V14H13V20H19V12H22L19 9.3ZM17 18H15V12H9V18H7V10.19L12 5.69L17 10.19V18Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10 10H14C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10Z",
    fill: "black"
  })));
}, "IconHouse");
import uw from "classnames";
var ww = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHowToReg } from '@aws-amplify/ui-react'; \u2192 import { MdHowToReg } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 12C13.21 12 15 10.21 15 8C15 5.79 13.21 4 11 4C8.79 4 7 5.79 7 8C7 10.21 8.79 12 11 12ZM11 6C12.1 6 13 6.9 13 8C13 9.1 12.1 10 11 10C9.9 10 9 9.1 9 8C9 6.9 9.9 6 11 6ZM5 18C5.2 17.37 7.57 16.32 9.96 16.06L12 14.06C11.61 14.02 11.32 14 11 14C8.33 14 3 15.34 3 18V20H12L10 18H5ZM20.6 12.5L15.47 17.67L13.4 15.59L12 17L15.47 20.5L22 13.91L20.6 12.5Z",
    fill: "currentColor"
  })));
}, "IconHowToReg");
import dw from "classnames";
var Vw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHowToVote } from '@aws-amplify/ui-react'; \u2192 import { MdHowToVote } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 12.9998H17.32L15.32 14.9998H17.23L19 16.9998H5L6.78 14.9998H8.83L6.83 12.9998H6L3 15.9998V19.9998C3 21.0998 3.89 21.9998 4.99 21.9998H19C20.1 21.9998 21 21.1098 21 19.9998V15.9998L18 12.9998ZM19 19.9998H5V18.9998H19V19.9998ZM11.34 15.0198C11.73 15.4098 12.36 15.4098 12.75 15.0198L19.11 8.6598C19.5 8.2698 19.5 7.6398 19.11 7.2498L14.16 2.2998C13.78 1.8998 13.15 1.8998 12.76 2.2898L6.39 8.6598C6 9.0498 6 9.6798 6.39 10.0698L11.34 15.0198ZM13.46 4.4098L17 7.9498L12.05 12.8998L8.51 9.3598L13.46 4.4098V4.4098Z",
    fill: "currentColor"
  })));
}, "IconHowToVote");
import Hw from "classnames";
var Mw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHttp } from '@aws-amplify/ui-react'; \u2192 import { MdHttp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4.5 11H2.5V9H1V15H2.5V12.5H4.5V15H6V9H4.5V11ZM7 10.5H8.5V15H10V10.5H11.5V9H7V10.5ZM12.5 10.5H14V15H15.5V10.5H17V9H12.5V10.5ZM21.5 9H18V15H19.5V13H21.5C22.3 13 23 12.3 23 11.5V10.5C23 9.7 22.3 9 21.5 9ZM21.5 11.5H19.5V10.5H21.5V11.5Z",
    fill: "currentColor"
  })));
}, "IconHttp");
import xw from "classnames";
var Iw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHttps } from '@aws-amplify/ui-react'; \u2192 import { MdHttps } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM9 6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9V6ZM18 20H6V10H18V20ZM12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17Z",
    fill: "currentColor"
  })));
}, "IconHttps");
import Lw from "classnames";
var vw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconHvac } from '@aws-amplify/ui-react'; \u2192 import { MdHvac } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18ZM15.44 10C15.7 10.45 15.88 10.96 15.95 11.5H8.05C8.12 10.96 8.29 10.45 8.56 10H15.44ZM15.95 12.5C15.88 13.04 15.71 13.55 15.44 14H8.56C8.3 13.55 8.12 13.04 8.05 12.5H15.95ZM9.38 15H14.62C13.92 15.61 13.01 16 12 16C10.99 16 10.09 15.61 9.38 15ZM14.62 9H9.38C10.08 8.39 10.99 8 12 8C13.01 8 13.91 8.39 14.62 9Z",
    fill: "black"
  })));
}, "IconHvac");
import Nw from "classnames";
var yw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconImageAspectRatio } from '@aws-amplify/ui-react'; \u2192 import { MdImageAspectRatio } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 10H14V12H16V10ZM16 14H14V16H16V14ZM8 10H6V12H8V10ZM12 10H10V12H12V10ZM20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z",
    fill: "currentColor"
  })));
}, "IconImageAspectRatio");
import bw from "classnames";
var Zw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconImageNotSupported } from '@aws-amplify/ui-react'; \u2192 import { MdImageNotSupported } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.8999 21.9001L15.7999 15.8001L13.1099 13.1101L4.99994 5.0001L3.58994 3.5901L2.09994 2.1001L0.689941 3.5101L2.99994 5.8301V19.0001C2.99994 20.1001 3.89994 21.0001 4.99994 21.0001H18.1699L20.4799 23.3101L21.8999 21.9001ZM4.99994 19.0001V7.8301L11.8399 14.6701L10.9999 15.7201L8.99994 13.0001L5.99994 17.0001H14.1699L16.1699 19.0001H4.99994ZM7.82994 5.0001L5.82994 3.0001H18.9999C20.0999 3.0001 20.9999 3.9001 20.9999 5.0001V18.1701L18.9999 16.1701V5.0001H7.82994Z",
    fill: "currentColor"
  })));
}, "IconImageNotSupported");
import Bw from "classnames";
var Ww = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconImageSearch } from '@aws-amplify/ui-react'; \u2192 import { MdImageSearch } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 13V20H4V6H9.02C9.07 5.29 9.24 4.62 9.5 4H4C2.9 4 2 4.9 2 6V20C2 21.1 2.9 22 4 22H18C19.1 22 20 21.1 20 20V15L18 13ZM16.5 18H5.5L8.25 14.47L10.21 16.83L12.96 13.29L16.5 18ZM19.3 8.89C19.74 8.19 20 7.38 20 6.5C20 4.01 17.99 2 15.5 2C13.01 2 11 4.01 11 6.5C11 8.99 13.01 11 15.49 11C16.37 11 17.19 10.74 17.88 10.3L21 13.42L22.42 12L19.3 8.89ZM15.5 9C14.12 9 13 7.88 13 6.5C13 5.12 14.12 4 15.5 4C16.88 4 18 5.12 18 6.5C18 7.88 16.88 9 15.5 9Z",
    fill: "currentColor"
  })));
}, "IconImageSearch");
import kw from "classnames";
var Dw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconImage } from '@aws-amplify/ui-react'; \u2192 import { MdImage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z",
    fill: "currentColor"
  })));
}, "IconImage");
import Pw from "classnames";
var Sw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconImportContacts } from '@aws-amplify/ui-react'; \u2192 import { MdImportContacts } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 5C19.89 4.65 18.67 4.5 17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5ZM21 18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5Z",
    fill: "currentColor"
  })));
}, "IconImportContacts");
import jw from "classnames";
var Yw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconImportExport } from '@aws-amplify/ui-react'; \u2192 import { MdImportExport } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 3L5 6.99H8V14H10V6.99H13L9 3ZM16 17.01V10H14V17.01H11L15 21L19 17.01H16Z",
    fill: "currentColor"
  })));
}, "IconImportExport");
import Fw from "classnames";
var Tw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconImportantDevices } from '@aws-amplify/ui-react'; \u2192 import { MdImportantDevices } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23 11.01L18 11C17.45 11 17 11.45 17 12V21C17 21.55 17.45 22 18 22H23C23.55 22 24 21.55 24 21V12C24 11.45 23.55 11.01 23 11.01ZM23 20H18V13H23V20ZM20 2H2C0.89 2 0 2.89 0 4V16C0 17.1 0.89 18 2 18H9V20H7V22H15V20H13V18H15V16H2V4H20V9H22V4C22 2.89 21.1 2 20 2ZM11.97 9L11 6L10.03 9H7L9.47 10.76L8.53 13.67L11 11.87L13.47 13.67L12.53 10.76L15 9H11.97Z",
    fill: "currentColor"
  })));
}, "IconImportantDevices");
import Aw from "classnames";
var Ew = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInbox } from '@aws-amplify/ui-react'; \u2192 import { MdInbox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Aw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.56C9.25 17.19 10.53 18 12.01 18C13.49 18 14.76 17.19 15.46 16H19V19ZM19 14H14.01C14.01 15.1 13.11 16 12.01 16C10.91 16 10.01 15.1 10.01 14H5V5H19V14Z",
    fill: "currentColor"
  })));
}, "IconInbox");
import Ow from "classnames";

var _w = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconIndeterminateCheckBox } from '@aws-amplify/ui-react'; \u2192 import { MdIndeterminateCheckBox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ow(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 11H17V13H7V11Z",
    fill: "currentColor"
  })));
}, "IconIndeterminateCheckBox");

import Gw from "classnames";
var kt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconInfo");
import Uw from "classnames";
var zw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInput } from '@aws-amplify/ui-react'; \u2192 import { MdInput } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Uw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3.00977H3C1.9 3.00977 1 3.90977 1 5.00977V8.99977H3V4.98977H21V19.0198H3V14.9998H1V19.0098C1 20.1098 1.9 20.9898 3 20.9898H21C22.1 20.9898 23 20.1098 23 19.0098V5.00977C23 3.89977 22.1 3.00977 21 3.00977V3.00977ZM11 15.9998L15 11.9998L11 7.99977V10.9998H1V12.9998H11V15.9998ZM21 3.00977H3C1.9 3.00977 1 3.90977 1 5.00977V8.99977H3V4.98977H21V19.0198H3V14.9998H1V19.0098C1 20.1098 1.9 20.9898 3 20.9898H21C22.1 20.9898 23 20.1098 23 19.0098V5.00977C23 3.89977 22.1 3.00977 21 3.00977V3.00977ZM11 15.9998L15 11.9998L11 7.99977V10.9998H1V12.9998H11V15.9998Z",
    fill: "currentColor"
  })));
}, "IconInput");
import Xw from "classnames";
var Kw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsertChartOutlined } from '@aws-amplify/ui-react'; \u2192 import { MdInsertChartOutlined } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Xw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17ZM19 19H5V5H19V19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
    fill: "currentColor"
  })));
}, "IconInsertChartOutlined");
import qw from "classnames";
var Qw = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsertChart } from '@aws-amplify/ui-react'; \u2192 import { MdInsertChart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z",
    fill: "currentColor"
  })));
}, "IconInsertChart");
import Jw from "classnames";
var $w = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsertComment } from '@aws-amplify/ui-react'; \u2192 import { MdInsertComment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Jw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4V17.17L18.83 16H4V4H20ZM20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2ZM18 12H6V14H18V12ZM18 9H6V11H18V9ZM18 6H6V8H18V6Z",
    fill: "currentColor"
  })));
}, "IconInsertComment");
import Rw from "classnames";
var ed = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsertDriveFile } from '@aws-amplify/ui-react'; \u2192 import { MdInsertDriveFile } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Rw(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V9H18V20H6Z",
    fill: "currentColor"
  })));
}, "IconInsertDriveFile");
import od from "classnames";
var td = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsertEmoticon } from '@aws-amplify/ui-react'; \u2192 import { MdInsertEmoticon } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: od(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z",
    fill: "currentColor"
  })));
}, "IconInsertEmoticon");
import rd from "classnames";
var id = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsertInvitation } from '@aws-amplify/ui-react'; \u2192 import { MdInsertInvitation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3.01 3.9 3.01 5L3 19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V9H19V19ZM19 7H5V5H19V7ZM17 12H12V17H17V12Z",
    fill: "currentColor"
  })));
}, "IconInsertInvitation");
import sd from "classnames";
var ad = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsertLink } from '@aws-amplify/ui-react'; \u2192 import { MdInsertLink } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3.9 12C3.9 10.29 5.29 8.9 7 8.9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15.1H7C5.29 15.1 3.9 13.71 3.9 12ZM8 13H16V11H8V13ZM17 7H13V8.9H17C18.71 8.9 20.1 10.29 20.1 12C20.1 13.71 18.71 15.1 17 15.1H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7Z",
    fill: "currentColor"
  })));
}, "IconInsertLink");
import nd from "classnames";
var md = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsertPhoto } from '@aws-amplify/ui-react'; \u2192 import { MdInsertPhoto } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z",
    fill: "currentColor"
  })));
}, "IconInsertPhoto");
import cd from "classnames";
var ld = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInsights } from '@aws-amplify/ui-react'; \u2192 import { MdInsights } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 8C19.55 8 18.74 9.44 19.07 10.51L15.52 14.07C15.22 13.98 14.78 13.98 14.48 14.07L11.93 11.52C12.27 10.45 11.46 9 10 9C8.55 9 7.73 10.44 8.07 11.52L3.51 16.07C2.44 15.74 1 16.55 1 18C1 19.1 1.9 20 3 20C4.45 20 5.26 18.56 4.93 17.49L9.48 12.93C9.78 13.02 10.22 13.02 10.52 12.93L13.07 15.48C12.73 16.55 13.54 18 15 18C16.45 18 17.27 16.56 16.93 15.48L20.49 11.93C21.56 12.26 23 11.45 23 10C23 8.9 22.1 8 21 8Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15 9L15.94 6.93L18 6L15.94 5.07L15 3L14.08 5.07L12 6L14.08 6.93L15 9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M3.5 11L4 9L6 8.5L4 8L3.5 6L3 8L1 8.5L3 9L3.5 11Z",
    fill: "black"
  })));
}, "IconInsights");
import pd from "classnames";
var hd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconIntegrationInstructions } from '@aws-amplify/ui-react'; \u2192 import { MdIntegrationInstructions } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 14.1702L8.83 12.0002L11 9.83016L9.59 8.41016L6 12.0002L9.59 15.5902L11 14.1702Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M14.41 15.5902L18 12.0002L14.41 8.41016L13 9.83016L15.17 12.0002L13 14.1702L14.41 15.5902Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C4.86 3 4.73 3.01 4.6 3.04C4.21 3.12 3.86 3.32 3.59 3.59C3.41 3.77 3.26 3.99 3.16 4.23C3.06 4.46 3 4.72 3 5V15V16V19C3 19.27 3.06 19.54 3.16 19.78C3.26 20.02 3.41 20.23 3.59 20.42C3.86 20.69 4.21 20.89 4.6 20.97C4.73 20.99 4.86 21 5 21H19C20.1 21 21 20.1 21 19V16V15V5C21 3.9 20.1 3 19 3ZM12 2.75C12.41 2.75 12.75 3.09 12.75 3.5C12.75 3.91 12.41 4.25 12 4.25C11.59 4.25 11.25 3.91 11.25 3.5C11.25 3.09 11.59 2.75 12 2.75ZM19 15V16V19H5V16V15V5H19V15Z",
    fill: "black"
  })));
}, "IconIntegrationInstructions");
import fd from "classnames";
var Cd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInvertColorsOff } from '@aws-amplify/ui-react'; \u2192 import { MdInvertColorsOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5.10002V9.15002L19.4 16.55C20.55 13.67 19.99 10.27 17.65 7.94002L12 2.27002L8.55999 5.71002L9.96999 7.12002L12 5.10002ZM4.39999 4.37002L2.98999 5.78002L5.76999 8.56002C3.22999 11.7 3.41999 16.31 6.33999 19.24C7.89999 20.8 9.94999 21.58 12 21.58C13.78 21.58 15.56 20.99 17.02 19.81L19.72 22.51L21.13 21.1L4.39999 4.37002V4.37002ZM12 19.59C10.4 19.59 8.88999 18.97 7.75999 17.83C6.61999 16.69 5.99999 15.19 5.99999 13.59C5.99999 12.27 6.42999 11.03 7.20999 10L12 14.79V19.59Z",
    fill: "currentColor"
  })));
}, "IconInvertColorsOff");
import gd from "classnames";
var ud = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconInvertColors } from '@aws-amplify/ui-react'; \u2192 import { MdInvertColors } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.66 7.93002L12 2.27002L6.34 7.93002C3.22 11.05 3.22 16.12 6.34 19.24C7.9 20.8 9.95 21.58 12 21.58C14.05 21.58 16.1 20.8 17.66 19.24C20.78 16.12 20.78 11.05 17.66 7.93002V7.93002ZM12 19.59C10.4 19.59 8.89 18.97 7.76 17.83C6.62 16.69 6 15.19 6 13.59C6 11.99 6.62 10.48 7.76 9.35002L12 5.10002V19.59Z",
    fill: "currentColor"
  })));
}, "IconInvertColors");
import wd from "classnames";
var dd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconIso } from '@aws-amplify/ui-react'; \u2192 import { MdIso } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5.5 7.5H7.5V5.5H9V7.5H11V9H9V11H7.5V9H5.5V7.5ZM19 19H5L19 5V19ZM17 17V15.5H12V17H17Z",
    fill: "currentColor"
  })));
}, "IconIso");
import Vd from "classnames";
var Hd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardArrowDown } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardArrowDown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Vd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z",
    fill: "currentColor"
  })));
}, "IconKeyboardArrowDown");
import Md from "classnames";
var xd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardArrowLeft } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardArrowLeft } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Md(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z",
    fill: "currentColor"
  })));
}, "IconKeyboardArrowLeft");
import Id from "classnames";
var Ld = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardArrowRight } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardArrowRight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Id(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.59009 16.59L13.1701 12L8.59009 7.41L10.0001 6L16.0001 12L10.0001 18L8.59009 16.59Z",
    fill: "currentColor"
  })));
}, "IconKeyboardArrowRight");
import vd from "classnames";
var Nd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardArrowUp } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardArrowUp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8L6 14L7.41 15.41Z",
    fill: "currentColor"
  })));
}, "IconKeyboardArrowUp");
import yd from "classnames";
var bd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardBackspace } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardBackspace } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z",
    fill: "currentColor"
  })));
}, "IconKeyboardBackspace");
import Zd from "classnames";
var Bd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardCapslock } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardCapslock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Zd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 8.40984L16.59 12.9998L18 11.5898L12 5.58984L6 11.5898L7.41 12.9998L12 8.40984ZM6 17.9998H18V15.9998H6V17.9998Z",
    fill: "currentColor"
  })));
}, "IconKeyboardCapslock");
import Wd from "classnames";
var kd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardHide } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardHide } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Wd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 3H4C2.9 3 2.01 3.9 2.01 5L2 15C2 16.1 2.9 17 4 17H20C21.1 17 22 16.1 22 15V5C22 3.9 21.1 3 20 3ZM20 15H4V5H20V15ZM11 6H13V8H11V6ZM11 9H13V11H11V9ZM8 6H10V8H8V6ZM8 9H10V11H8V9ZM5 9H7V11H5V9ZM5 6H7V8H5V6ZM8 12H16V14H8V12ZM14 9H16V11H14V9ZM14 6H16V8H14V6ZM17 9H19V11H17V9ZM17 6H19V8H17V6ZM12 23L16 19H8L12 23Z",
    fill: "currentColor"
  })));
}, "IconKeyboardHide");
import Dd from "classnames";
var Pd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardReturn } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardReturn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Dd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 7V11H5.83L9.41 7.41L8 6L2 12L8 18L9.41 16.59L5.83 13H21V7H19Z",
    fill: "currentColor"
  })));
}, "IconKeyboardReturn");
import Sd from "classnames";
var jd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardTab } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardTab } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Sd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.59 7.41L15.17 11H1V13H15.17L11.58 16.59L13 18L19 12L13 6L11.59 7.41ZM20 6V18H22V6H20Z",
    fill: "currentColor"
  })));
}, "IconKeyboardTab");
import Yd from "classnames";
var Fd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboardVoice } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboardVoice } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Yd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 15C13.66 15 14.99 13.66 14.99 12L15 6C15 4.34 13.66 3 12 3C10.34 3 9 4.34 9 6V12C9 13.66 10.34 15 12 15ZM10.8 5.9C10.8 5.24 11.34 4.7 12 4.7C12.66 4.7 13.2 5.24 13.2 5.9L13.19 12.1C13.19 12.76 12.66 13.3 12 13.3C11.34 13.3 10.8 12.76 10.8 12.1V5.9ZM17.3 12C17.3 15 14.76 17.1 12 17.1C9.24 17.1 6.7 15 6.7 12H5C5 15.41 7.72 18.23 11 18.72V22H13V18.72C16.28 18.24 19 15.42 19 12H17.3Z",
    fill: "currentColor"
  })));
}, "IconKeyboardVoice");
import Td from "classnames";
var Ad = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKeyboard } from '@aws-amplify/ui-react'; \u2192 import { MdKeyboard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Td(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 7V17H4V7H20ZM20 5H4C2.9 5 2.01 5.9 2.01 7L2 17C2 18.1 2.9 19 4 19H20C21.1 19 22 18.1 22 17V7C22 5.9 21.1 5 20 5ZM11 8H13V10H11V8ZM11 11H13V13H11V11ZM8 8H10V10H8V8ZM8 11H10V13H8V11ZM5 11H7V13H5V11ZM5 8H7V10H5V8ZM8 14H16V16H8V14ZM14 11H16V13H14V11ZM14 8H16V10H14V8ZM17 11H19V13H17V11ZM17 8H19V10H17V8Z",
    fill: "currentColor"
  })));
}, "IconKeyboard");
import Ed from "classnames";
var Od = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKingBed } from '@aws-amplify/ui-react'; \u2192 import { MdKingBed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ed(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 12C22 10.9 21.1 10 20 10V7C20 5.9 19.1 5 18 5H6C4.9 5 4 5.9 4 7V10C2.9 10 2 10.9 2 12V17H3.33L4 19H5L5.67 17H18.34L19 19H20L20.67 17H22V12ZM18 10H13V7H18V10ZM6 7H11V10H6V7ZM4 12H20V15H4V12Z",
    fill: "currentColor"
  })));
}, "IconKingBed");
import _d from "classnames";
var Gd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconKitchen } from '@aws-amplify/ui-react'; \u2192 import { MdKitchen } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _d(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 5H10V8H8V5ZM8 12H10V17H8V12ZM18 2.01L6 2C4.9 2 4 2.89 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.89 19.1 2.01 18 2.01ZM18 20H6V10.98H18V20ZM18 9H6V4H18V9Z",
    fill: "currentColor"
  })));
}, "IconKitchen");
import Ud from "classnames";
var zd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLabelImportant } from '@aws-amplify/ui-react'; \u2192 import { MdLabelImportant } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ud(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 18.99H15C15.67 18.99 16.27 18.67 16.63 18.16L21 12L16.63 5.84C16.27 5.33 15.67 5 15 5H4L9 12L4 18.99V18.99Z",
    fill: "currentColor"
  })));
}, "IconLabelImportant");
import Xd from "classnames";
var Kd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLabelOff } from '@aws-amplify/ui-react'; \u2192 import { MdLabelOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Xd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 7.00012L19.55 12.0001L17.92 14.2901L19.35 15.7201L22 12.0001L17.63 5.84012C17.27 5.33012 16.67 5.00012 16 5.00012L8.63 5.01012L10.63 7.00012H16ZM2 4.03012L3.58 5.61012C3.22 5.96012 3 6.46012 3 7.00012V17.0001C3 18.1001 3.9 18.9901 5 18.9901L16 19.0001C16.28 19.0001 16.55 18.9301 16.79 18.8201L18.97 21.0001L20.38 19.5901L3.41 2.62012L2 4.03012ZM14.97 17.0001H5V7.03012L14.97 17.0001Z",
    fill: "currentColor"
  })));
}, "IconLabelOff");
import qd from "classnames";
var Qd = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLabel } from '@aws-amplify/ui-react'; \u2192 import { MdLabel } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7V17C3 18.1 3.9 18.99 5 18.99L16 19C16.67 19 17.27 18.67 17.63 18.16L22 12L17.63 5.84ZM16 17H5V7H16L19.55 12L16 17Z",
    fill: "currentColor"
  })));
}, "IconLabel");
import Jd from "classnames";
var $d = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLandscape } from '@aws-amplify/ui-react'; \u2192 import { MdLandscape } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Jd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 6L9.78 11.63L11.03 13.3L14 9.33L19 16H10.54L6.53 10.63L1 18H23L14 6ZM5 16L6.52 13.97L8.04 16H5Z",
    fill: "currentColor"
  })));
}, "IconLandscape");
import Rd from "classnames";
var eV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLanguage } from '@aws-amplify/ui-react'; \u2192 import { MdLanguage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Rd(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.35 18.92 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16V16ZM8.03 8H5.08C6.04 6.34 7.57 5.07 9.41 4.44C8.81 5.55 8.35 6.75 8.03 8V8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56V19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z",
    fill: "currentColor"
  })));
}, "IconLanguage");
import oV from "classnames";
var tV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLaptopChromebook } from '@aws-amplify/ui-react'; \u2192 import { MdLaptopChromebook } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 18V3H2V18H0V20H24V18H22ZM14 18H10V17H14V18ZM20 15H4V5H20V15Z",
    fill: "currentColor"
  })));
}, "IconLaptopChromebook");
import rV from "classnames";
var iV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLaptopMac } from '@aws-amplify/ui-react'; \u2192 import { MdLaptopMac } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 18C21.1 18 21.99 17.1 21.99 16L22 5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V16C2 17.1 2.9 18 4 18H0C0 19.1 0.9 20 2 20H22C23.1 20 24 19.1 24 18H20ZM4 5H20V16H4V5ZM12 19C11.45 19 11 18.55 11 18C11 17.45 11.45 17 12 17C12.55 17 13 17.45 13 18C13 18.55 12.55 19 12 19Z",
    fill: "currentColor"
  })));
}, "IconLaptopMac");
import sV from "classnames";
var aV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLaptopWindows } from '@aws-amplify/ui-react'; \u2192 import { MdLaptopWindows } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 18V17C21.1 17 21.99 16.1 21.99 15L22 5C22 3.9 21.1 3 20 3H4C2.9 3 2 3.9 2 5V15C2 16.1 2.9 17 4 17V18H0V20H24V18H20ZM4 5H20V15H4V5Z",
    fill: "currentColor"
  })));
}, "IconLaptopWindows");
import nV from "classnames";
var mV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLaptop } from '@aws-amplify/ui-react'; \u2192 import { MdLaptop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 18C21.1 18 22 17.1 22 16V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V16C2 17.1 2.9 18 4 18H0V20H24V18H20ZM4 6H20V16H4V6Z",
    fill: "currentColor"
  })));
}, "IconLaptop");
import cV from "classnames";
var lV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLastPage } from '@aws-amplify/ui-react'; \u2192 import { MdLastPage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5.58984 7.41L10.1798 12L5.58984 16.59L6.99984 18L12.9998 12L6.99984 6L5.58984 7.41ZM15.9998 6H17.9998V18H15.9998V6Z",
    fill: "currentColor"
  })));
}, "IconLastPage");
import pV from "classnames";
var hV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLaunch } from '@aws-amplify/ui-react'; \u2192 import { MdLaunch } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z",
    fill: "currentColor"
  })));
}, "IconLaunch");
import fV from "classnames";
var CV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLayersClear } from '@aws-amplify/ui-react'; \u2192 import { MdLayersClear } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4.52986L17.74 8.99986L15.85 10.4699L17.28 11.8899L21 8.99986L12 1.99986L9.41 4.01986L10.83 5.43986L12 4.52986ZM21 14.0699L19.37 12.7999L18.7 13.3199L20.13 14.7499L21 14.0699ZM3.41 0.859863L2 2.26986L6.22 6.48986L3 8.99986L12 15.9999L14.1 14.3699L15.52 15.7899L11.99 18.5399L4.62 12.8099L3 14.0699L12 21.0699L16.95 17.2199L20.73 20.9999L22.14 19.5899L3.41 0.859863ZM12 13.4699L6.26 8.99986L7.65 7.91986L12.67 12.9399L12 13.4699V13.4699Z",
    fill: "currentColor"
  })));
}, "IconLayersClear");
import gV from "classnames";
var uV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLayers } from '@aws-amplify/ui-react'; \u2192 import { MdLayers } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 18.54L4.62 12.81L3 14.07L12 21.07L21 14.07L19.37 12.8L11.99 18.54ZM12 16L19.36 10.27L21 9L12 2L3 9L4.63 10.27L12 16ZM12 4.53L17.74 9L12 13.47L6.26 9L12 4.53V4.53Z",
    fill: "currentColor"
  })));
}, "IconLayers");
import wV from "classnames";
var dV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLeaderboard } from '@aws-amplify/ui-react'; \u2192 import { MdLeaderboard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 11V3H8V9H2V21H22V11H16ZM10 5H14V19H10V5ZM4 11H8V19H4V11ZM20 19H16V13H20V19Z",
    fill: "currentColor"
  })));
}, "IconLeaderboard");
import VV from "classnames";
var HV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLeakAdd } from '@aws-amplify/ui-react'; \u2192 import { MdLeakAdd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 3H3V6C4.66 6 6 4.66 6 3ZM14 3H12C12 7.97 7.97 12 3 12V14C9.08 14 14 9.07 14 3ZM10 3H8C8 5.76 5.76 8 3 8V10C6.87 10 10 6.87 10 3ZM10 21H12C12 16.03 16.03 12 21 12V10C14.93 10 10 14.93 10 21ZM18 21H21V18C19.34 18 18 19.34 18 21ZM14 21H16C16 18.24 18.24 16 21 16V14C17.13 14 14 17.13 14 21Z",
    fill: "currentColor"
  })));
}, "IconLeakAdd");
import MV from "classnames";
var xV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLeakRemove } from '@aws-amplify/ui-react'; \u2192 import { MdLeakRemove } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: MV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 2.99986H12C12 4.34986 11.69 5.62986 11.16 6.76986L12.65 8.25986C13.51 6.69986 14 4.90986 14 2.99986ZM21 11.9999V9.99986C19.09 9.99986 17.3 10.4899 15.73 11.3499L17.22 12.8399C18.37 12.3099 19.65 11.9999 21 11.9999ZM21 15.9999V13.9999C20.21 13.9999 19.46 14.1299 18.76 14.3699L20.44 16.0499C20.63 16.0399 20.81 15.9999 21 15.9999V15.9999ZM10 2.99986H8C8 3.18986 7.96 3.36986 7.94 3.55986L9.62 5.23986C9.87 4.53986 10 3.77986 10 2.99986V2.99986ZM4.41 2.85986L3 4.26986L5.84 7.10986C5.03 7.66986 4.06 7.99986 3 7.99986V9.99986C4.61 9.99986 6.09 9.44986 7.27 8.53986L8.7 9.96986C7.14 11.2399 5.16 11.9999 3 11.9999V13.9999C5.72 13.9999 8.2 13.0099 10.11 11.3799L12.62 13.8899C10.99 15.8099 10 18.2899 10 20.9999H12C12 18.8399 12.76 16.8599 14.03 15.2999L15.46 16.7299C14.55 17.9099 14 19.3899 14 20.9999H16C16 19.9399 16.33 18.9699 16.89 18.1599L19.73 20.9999L21.14 19.5899L4.41 2.85986Z",
    fill: "currentColor"
  })));
}, "IconLeakRemove");
import IV from "classnames";
var LV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLegendToggle } from '@aws-amplify/ui-react'; \u2192 import { MdLegendToggle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: IV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 15H4V13H20V15ZM20 17H4V19H20V17ZM15 11L20 7.45V5L15 8.55L10 5L4 8.66V11L9.92 7.39L15 11Z",
    fill: "currentColor"
  })));
}, "IconLegendToggle");
import vV from "classnames";
var NV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLens } from '@aws-amplify/ui-react'; \u2192 import { MdLens } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z",
    fill: "currentColor"
  })));
}, "IconLens");
import yV from "classnames";
var bV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLibraryAddCheck } from '@aws-amplify/ui-react'; \u2192 import { MdLibraryAddCheck } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM12.47 14L9 10.5L10.4 9.09L12.47 11.17L17.6 6L19 7.41L12.47 14ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z",
    fill: "currentColor"
  })));
}, "IconLibraryAddCheck");
import ZV from "classnames";
var BV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLibraryAdd } from '@aws-amplify/ui-react'; \u2192 import { MdLibraryAdd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13 14H15V11H18V9H15V6H13V9H10V11H13V14Z",
    fill: "currentColor"
  })));
}, "IconLibraryAdd");
import WV from "classnames";
var kV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLibraryBooks } from '@aws-amplify/ui-react'; \u2192 import { MdLibraryBooks } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z",
    fill: "currentColor"
  })));
}, "IconLibraryBooks");
import DV from "classnames";
var PV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLibraryMusic } from '@aws-amplify/ui-react'; \u2192 import { MdLibraryMusic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM12.5 15C13.88 15 15 13.88 15 12.5V7H18V5H14V10.51C13.58 10.19 13.07 10 12.5 10C11.12 10 10 11.12 10 12.5C10 13.88 11.12 15 12.5 15ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z",
    fill: "currentColor"
  })));
}, "IconLibraryMusic");
import SV from "classnames";
var jV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLightbulb } from '@aws-amplify/ui-react'; \u2192 import { MdLightbulb } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 21C9 21.55 9.45 22 10 22H14C14.55 22 15 21.55 15 21V20H9V21ZM12 2C8.14 2 5 5.14 5 9C5 11.38 6.19 13.47 8 14.74V17C8 17.55 8.45 18 9 18H15C15.55 18 16 17.55 16 17V14.74C17.81 13.47 19 11.38 19 9C19 5.14 15.86 2 12 2ZM14.85 13.1L14 13.7V16H10V13.7L9.15 13.1C7.8 12.16 7 10.63 7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 10.63 16.2 12.16 14.85 13.1Z",
    fill: "currentColor"
  })));
}, "IconLightbulb");
import YV from "classnames";
var FV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLineStyle } from '@aws-amplify/ui-react'; \u2192 import { MdLineStyle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 16H8V14H3V16ZM9.5 16H14.5V14H9.5V16ZM16 16H21V14H16V16ZM3 20H5V18H3V20ZM7 20H9V18H7V20ZM11 20H13V18H11V20ZM15 20H17V18H15V20ZM19 20H21V18H19V20ZM3 12H11V10H3V12ZM13 12H21V10H13V12ZM3 4V8H21V4H3Z",
    fill: "currentColor"
  })));
}, "IconLineStyle");
import TV from "classnames";
var AV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLineWeight } from '@aws-amplify/ui-react'; \u2192 import { MdLineWeight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 17H21V15H3V17ZM3 20H21V19H3V20ZM3 13H21V10H3V13ZM3 4V8H21V4H3Z",
    fill: "currentColor"
  })));
}, "IconLineWeight");
import EV from "classnames";
var OV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLinearScale } from '@aws-amplify/ui-react'; \u2192 import { MdLinearScale } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.5 9.5C18.47 9.5 17.6 10.12 17.21 11H14.29C13.9 10.12 13.03 9.5 12 9.5C10.97 9.5 10.1 10.12 9.71 11H6.79C6.4 10.12 5.53 9.5 4.5 9.5C3.12 9.5 2 10.62 2 12C2 13.38 3.12 14.5 4.5 14.5C5.53 14.5 6.4 13.88 6.79 13H9.71C10.1 13.88 10.97 14.5 12 14.5C13.03 14.5 13.9 13.88 14.29 13H17.21C17.6 13.88 18.47 14.5 19.5 14.5C20.88 14.5 22 13.38 22 12C22 10.62 20.88 9.5 19.5 9.5Z",
    fill: "currentColor"
  })));
}, "IconLinearScale");
import _V from "classnames";
var GV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLinkOff } from '@aws-amplify/ui-react'; \u2192 import { MdLinkOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _V(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.39 10.9999L16 12.6099V10.9999H14.39ZM17 6.99986H13V8.89986H17C18.71 8.89986 20.1 10.2899 20.1 11.9999C20.1 13.2699 19.33 14.3699 18.23 14.8399L19.63 16.2399C21.05 15.3599 22 13.7899 22 11.9999C22 9.23986 19.76 6.99986 17 6.99986ZM2 4.26986L5.11 7.37986C3.29 8.11986 2 9.90986 2 11.9999C2 14.7599 4.24 16.9999 7 16.9999H11V15.0999H7C5.29 15.0999 3.9 13.7099 3.9 11.9999C3.9 10.4099 5.11 9.09986 6.66 8.92986L8.73 10.9999H8V12.9999H10.73L13 15.2699V16.9999H14.73L18.74 21.0099L20.15 19.5999L3.41 2.85986L2 4.26986Z",
    fill: "currentColor"
  })));
}, "IconLinkOff");
import UV from "classnames";
var zV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLink } from '@aws-amplify/ui-react'; \u2192 import { MdLink } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 7H13V9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H13V17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM11 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H11V7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H11V15ZM8 11H16V13H8V11Z",
    fill: "currentColor"
  })));
}, "IconLink");
import XV from "classnames";
var KV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLinkedCamera } from '@aws-amplify/ui-react'; \u2192 import { MdLinkedCamera } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 9V20H4V8H8.05L9.88 6H15V4H9L7.17 6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9H20ZM20.67 7.99H22C21.99 4.68 19.31 2 16 2V3.33C18.58 3.33 20.66 5.41 20.67 7.99ZM18 7.99H19.33C19.32 6.15 17.84 4.67 16 4.67V6C17.11 6 17.99 6.89 18 7.99ZM7 14C7 16.76 9.24 19 12 19C14.76 19 17 16.76 17 14C17 11.24 14.76 9 12 9C9.24 9 7 11.24 7 14ZM15 14C15 15.65 13.65 17 12 17C10.35 17 9 15.65 9 14C9 12.35 10.35 11 12 11C13.65 11 15 12.34 15 14Z",
    fill: "currentColor"
  })));
}, "IconLinkedCamera");
import qV from "classnames";
var QV = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconListAlt } from '@aws-amplify/ui-react'; \u2192 import { MdListAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 7H17V9H11V7ZM11 11H17V13H11V11ZM11 15H17V17H11V15ZM7 7H9V9H7V7ZM7 11H9V13H7V11ZM7 15H9V17H7V15ZM20.1 3H3.9C3.4 3 3 3.4 3 3.9V20.1C3 20.5 3.4 21 3.9 21H20.1C20.5 21 21 20.5 21 20.1V3.9C21 3.4 20.5 3 20.1 3V3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconListAlt");
import JV from "classnames";
var $V = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconList } from '@aws-amplify/ui-react'; \u2192 import { MdList } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z",
    fill: "currentColor"
  })));
}, "IconList");
import RV from "classnames";
var eH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLiveHelp } from '@aws-amplify/ui-react'; \u2192 import { MdLiveHelp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RV(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 2H5C3.89 2 3 2.9 3 4V18C3 19.1 3.89 20 5 20H9L12 23L15 20H19C20.1 20 21 19.1 21 18V4C21 2.9 20.1 2 19 2ZM19 18H14.17L13.58 18.59L12 20.17L10.41 18.58L9.83 18H5V4H19V18ZM11 15H13V17H11V15ZM12 7C13.1 7 14 7.9 14 9C14 11 11 10.75 11 14H13C13 11.75 16 11.5 16 9C16 6.79 14.21 5 12 5C9.79 5 8 6.79 8 9H10C10 7.9 10.9 7 12 7Z",
    fill: "currentColor"
  })));
}, "IconLiveHelp");
import oH from "classnames";
var tH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLiveTv } from '@aws-amplify/ui-react'; \u2192 import { MdLiveTv } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 10V18L16 14L9 10ZM21 6H13.42L16.71 2.71L16 2L12 6H11.97L7.97 2L7.28 2.71L10.56 6H3C1.9 6 1 6.9 1 8V20C1 21.1 1.9 22 3 22H21C22.1 22 23 21.1 23 20V8C23 6.9 22.1 6 21 6ZM21 20H3V8H21V20Z",
    fill: "currentColor"
  })));
}, "IconLiveTv");
import rH from "classnames";
var iH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalActivity } from '@aws-amplify/ui-react'; \u2192 import { MdLocalActivity } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 10V6C22 4.9 21.1 4 20 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM9.07 16L12 14.12L14.93 16L14.04 12.64L16.73 10.44L13.26 10.23L12 7L10.73 10.22L7.26 10.43L9.95 12.63L9.07 16Z",
    fill: "currentColor"
  })));
}, "IconLocalActivity");
import sH from "classnames";
var aH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalAirport } from '@aws-amplify/ui-react'; \u2192 import { MdLocalAirport } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 16V14L13.5 9V3.5C13.5 2.67 12.83 2 12 2C11.17 2 10.5 2.67 10.5 3.5V9L2 14V16L10.5 13.5V19L8 20.5V22L12 21L16 22V20.5L13.5 19V13.5L22 16Z",
    fill: "currentColor"
  })));
}, "IconLocalAirport");
import nH from "classnames";
var mH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalAtm } from '@aws-amplify/ui-react'; \u2192 import { MdLocalAtm } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 17H13V16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11H11V10H15V8H13V7H11V8H10C9.45 8 9 8.45 9 9V12C9 12.55 9.45 13 10 13H13V14H9V16H11V17ZM20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V6H20V18Z",
    fill: "currentColor"
  })));
}, "IconLocalAtm");
import cH from "classnames";
var lH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalBar } from '@aws-amplify/ui-react'; \u2192 import { MdLocalBar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.77 9L12 12.11L9.23 9H14.77ZM21 3H3V5L11 14V19H6V21H18V19H13V14L21 5V3ZM7.43 7L5.66 5H18.35L16.57 7H7.43Z",
    fill: "currentColor"
  })));
}, "IconLocalBar");
import pH from "classnames";
var hH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalCafe } from '@aws-amplify/ui-react'; \u2192 import { MdLocalCafe } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 5V13C16 14.1 15.1 15 14 15H8C6.9 15 6 14.1 6 13V5H16ZM20 3H4V13C4 15.21 5.79 17 8 17H14C16.21 17 18 15.21 18 13V10H20C21.11 10 22 9.11 22 8V5C22 3.89 21.11 3 20 3ZM18 8V5H20V8H18ZM20 19H2V21H20V19Z",
    fill: "currentColor"
  })));
}, "IconLocalCafe");
import fH from "classnames";
var CH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalCarWash } from '@aws-amplify/ui-react'; \u2192 import { MdLocalCarWash } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 4.9998C17.83 4.9998 18.5 4.3298 18.5 3.4998C18.5 2.4998 17 0.799805 17 0.799805C17 0.799805 15.5 2.4998 15.5 3.4998C15.5 4.3298 16.17 4.9998 17 4.9998ZM12 4.9998C12.83 4.9998 13.5 4.3298 13.5 3.4998C13.5 2.4998 12 0.799805 12 0.799805C12 0.799805 10.5 2.4998 10.5 3.4998C10.5 4.3298 11.17 4.9998 12 4.9998ZM7 4.9998C7.83 4.9998 8.5 4.3298 8.5 3.4998C8.5 2.4998 7 0.799805 7 0.799805C7 0.799805 5.5 2.4998 5.5 3.4998C5.5 4.3298 6.17 4.9998 7 4.9998ZM18.92 8.0098C18.72 7.4198 18.16 6.9998 17.5 6.9998H6.5C5.84 6.9998 5.29 7.4198 5.08 8.0098L3 13.9998V21.9998C3 22.5498 3.45 22.9998 4 22.9998H5C5.55 22.9998 6 22.5498 6 21.9998V20.9998H18V21.9998C18 22.5498 18.45 22.9998 19 22.9998H20C20.55 22.9998 21 22.5498 21 21.9998V13.9998L18.92 8.0098ZM6.85 8.9998H17.14L18.18 11.9998H5.81L6.85 8.9998ZM19 18.9998H5V14.3398L5.12 13.9998H18.89L19 14.3398V18.9998Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.5 18C8.32843 18 9 17.3284 9 16.5C9 15.6716 8.32843 15 7.5 15C6.67157 15 6 15.6716 6 16.5C6 17.3284 6.67157 18 7.5 18Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 18C17.3284 18 18 17.3284 18 16.5C18 15.6716 17.3284 15 16.5 15C15.6716 15 15 15.6716 15 16.5C15 17.3284 15.6716 18 16.5 18Z",
    fill: "black"
  })));
}, "IconLocalCarWash");
import gH from "classnames";
var uH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalConvenienceStore } from '@aws-amplify/ui-react'; \u2192 import { MdLocalConvenienceStore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 7V4H5V7H2V20H10V16H14V20H22V7H19ZM20 18H16V14H8V18H4V9H7V6H17V9H20V18ZM8 8H10V9H8V12H11V11H9V10H11V7H8V8ZM15 9H14V7H13V10H15V12H16V7H15V9Z",
    fill: "currentColor"
  })));
}, "IconLocalConvenienceStore");
import wH from "classnames";
var dH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalDining } from '@aws-amplify/ui-react'; \u2192 import { MdLocalDining } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.10023 13.34L10.9302 10.51L3.91023 3.49996C2.35023 5.05996 2.35023 7.58996 3.91023 9.15996L8.10023 13.34V13.34ZM14.8802 11.53C16.4102 12.24 18.5602 11.74 20.1502 10.15C22.0602 8.23996 22.4302 5.49996 20.9602 4.02996C19.5002 2.56996 16.7602 2.92996 14.8402 4.83996C13.2502 6.42996 12.7502 8.57996 13.4602 10.11L3.70023 19.87L5.11023 21.28L12.0002 14.41L18.8802 21.29L20.2902 19.88L13.4102 13L14.8802 11.53V11.53Z",
    fill: "currentColor"
  })));
}, "IconLocalDining");
import VH from "classnames";
var HH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalDrink } from '@aws-amplify/ui-react'; \u2192 import { MdLocalDrink } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 2L5.01 20.23C5.13 21.23 5.97 22 7 22H17C18.03 22 18.87 21.23 18.99 20.23L21 2H3ZM17 20L7 20.01L5.89 10H18.1L17 20ZM18.33 8H5.67L5.23 4H18.76L18.33 8ZM12 19C13.66 19 15 17.66 15 16C15 14 12 10.6 12 10.6C12 10.6 9 14 9 16C9 17.66 10.34 19 12 19ZM12 13.91C12.59 14.82 13 15.64 13 16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16C11 15.63 11.41 14.81 12 13.91Z",
    fill: "currentColor"
  })));
}, "IconLocalDrink");
import MH from "classnames";
var xH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalFireDepartment } from '@aws-amplify/ui-react'; \u2192 import { MdLocalFireDepartment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: MH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.48 12.3501C17.91 8.27014 12.32 8.05014 13.67 2.12014C13.77 1.68014 13.3 1.34014 12.92 1.57014C9.29 3.71014 6.68 8.00014 8.87 13.6201C9.05 14.0801 8.51 14.5101 8.12 14.2101C6.31 12.8401 6.12 10.8701 6.28 9.46014C6.34 8.94014 5.66 8.69014 5.37 9.12014C4.69 10.1601 4 11.8401 4 14.3701C4.38 19.9701 9.11 21.6901 10.81 21.9101C13.24 22.2201 15.87 21.7701 17.76 20.0401C19.84 18.1101 20.6 15.0301 19.48 12.3501ZM10.2 17.3801C11.64 17.0301 12.38 15.9901 12.58 15.0701C12.91 13.6401 11.62 12.2401 12.49 9.98014C12.82 11.8501 15.76 13.0201 15.76 15.0601C15.84 17.5901 13.1 19.7601 10.2 17.3801Z",
    fill: "currentColor"
  })));
}, "IconLocalFireDepartment");
import IH from "classnames";
var LH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalFlorist } from '@aws-amplify/ui-react'; \u2192 import { MdLocalFlorist } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: IH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.66 13.07C8.81 13.07 8.95 13.06 9.09 13.04C9.56 14.19 10.69 15 12 15C13.31 15 14.44 14.19 14.91 13.04C15.05 13.06 15.2 13.07 15.34 13.07C17.07 13.07 18.48 11.66 18.48 9.93C18.48 9.22 18.23 8.54 17.81 8C18.24 7.46 18.48 6.78 18.48 6.07C18.48 4.34 17.07 2.93 15.34 2.93C15.19 2.93 15.05 2.94 14.91 2.96C14.44 1.81 13.31 1 12 1C10.69 1 9.56 1.81 9.09 2.96C8.95 2.94 8.8 2.93 8.66 2.93C6.93 2.93 5.52 4.34 5.52 6.07C5.52 6.78 5.77 7.46 6.19 8C5.76 8.54 5.51 9.22 5.51 9.93C5.51 11.66 6.92 13.07 8.66 13.07ZM12 13C11.38 13 10.88 12.51 10.86 11.9L10.98 10.81C11.3 10.93 11.64 11 12 11C12.36 11 12.71 10.93 13.03 10.81L13.14 11.9C13.12 12.51 12.62 13 12 13V13ZM15.34 11.07C15.1 11.07 14.88 11 14.7 10.87L13.89 10.3C14.44 9.85 14.83 9.21 14.95 8.47L15.83 8.89C16.23 9.08 16.49 9.48 16.49 9.92C16.49 10.56 15.97 11.07 15.34 11.07V11.07ZM14.69 5.13C14.89 5 15.11 4.93 15.34 4.93C15.97 4.93 16.48 5.44 16.48 6.07C16.48 6.51 16.23 6.9 15.82 7.1L14.94 7.52C14.82 6.78 14.43 6.14 13.87 5.69L14.69 5.13V5.13ZM12 3C12.62 3 13.12 3.49 13.14 4.1L13.03 5.19C12.71 5.07 12.36 5 12 5C11.64 5 11.3 5.07 10.98 5.19L10.86 4.1C10.88 3.49 11.38 3 12 3V3ZM8.66 4.93C8.9 4.93 9.12 5 9.3 5.13L10.11 5.69C9.56 6.14 9.17 6.78 9.05 7.52L8.17 7.1C7.77 6.9 7.51 6.51 7.51 6.07C7.51 5.44 8.03 4.93 8.66 4.93ZM8.17 8.9L9.05 8.48C9.17 9.22 9.56 9.86 10.12 10.31L9.31 10.86C9.11 10.99 8.89 11.06 8.66 11.06C8.03 11.06 7.52 10.55 7.52 9.92C7.51 9.49 7.77 9.1 8.17 8.9ZM12 22C16.97 22 21 17.97 21 13C16.03 13 12 17.03 12 22ZM14.44 19.56C15.15 17.66 16.66 16.14 18.56 15.44C17.85 17.34 16.34 18.85 14.44 19.56V19.56ZM3 13C3 17.97 7.03 22 12 22C12 17.03 7.97 13 3 13ZM5.44 15.44C7.34 16.15 8.86 17.66 9.56 19.56C7.66 18.85 6.15 17.34 5.44 15.44V15.44Z",
    fill: "currentColor"
  })));
}, "IconLocalFlorist");
import vH from "classnames";
var NH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalGasStation } from '@aws-amplify/ui-react'; \u2192 import { MdLocalGasStation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.77 7.23L19.78 7.22L16.06 3.5L15 4.56L17.11 6.67C16.17 7.03 15.5 7.93 15.5 9C15.5 10.38 16.62 11.5 18 11.5C18.36 11.5 18.69 11.42 19 11.29V18.5C19 19.05 18.55 19.5 18 19.5C17.45 19.5 17 19.05 17 18.5V14C17 12.9 16.1 12 15 12H14V5C14 3.9 13.1 3 12 3H6C4.9 3 4 3.9 4 5V21H14V13.5H15.5V18.5C15.5 19.88 16.62 21 18 21C19.38 21 20.5 19.88 20.5 18.5V9C20.5 8.31 20.22 7.68 19.77 7.23ZM12 13.5V19H6V12H12V13.5ZM12 10H6V5H12V10ZM18 10C17.45 10 17 9.55 17 9C17 8.45 17.45 8 18 8C18.55 8 19 8.45 19 9C19 9.55 18.55 10 18 10Z",
    fill: "currentColor"
  })));
}, "IconLocalGasStation");
import yH from "classnames";
var bH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalGroceryStore } from '@aws-amplify/ui-react'; \u2192 import { MdLocalGroceryStore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18ZM15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6Z",
    fill: "currentColor"
  })));
}, "IconLocalGroceryStore");
import ZH from "classnames";
var BH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalHospital } from '@aws-amplify/ui-react'; \u2192 import { MdLocalHospital } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3.01 3.9 3.01 5L3 19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM10.5 17H13.5V13.5H17V10.5H13.5V7H10.5V10.5H7V13.5H10.5V17Z",
    fill: "currentColor"
  })));
}, "IconLocalHospital");
import WH from "classnames";
var kH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalHotel } from '@aws-amplify/ui-react'; \u2192 import { MdLocalHotel } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 14C8.66 14 10 12.66 10 11C10 9.34 8.66 8 7 8C5.34 8 4 9.34 4 11C4 12.66 5.34 14 7 14ZM7 10C7.55 10 8 10.45 8 11C8 11.55 7.55 12 7 12C6.45 12 6 11.55 6 11C6 10.45 6.45 10 7 10ZM19 7H11V15H3V5H1V20H3V17H21V20H23V11C23 8.79 21.21 7 19 7ZM21 15H13V9H19C20.1 9 21 9.9 21 11V15Z",
    fill: "currentColor"
  })));
}, "IconLocalHotel");
import DH from "classnames";
var PH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalLaundryService } from '@aws-amplify/ui-react'; \u2192 import { MdLocalLaundryService } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 2.01L6 2C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V4C20 2.89 19.11 2.01 18 2.01ZM18 20H6L5.99 4H18V20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11 7C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 19C14.76 19 17 16.76 17 14C17 11.24 14.76 9 12 9C9.24 9 7 11.24 7 14C7 16.76 9.24 19 12 19ZM14.36 11.64C15.66 12.94 15.66 15.06 14.36 16.36C13.06 17.66 10.94 17.66 9.64 16.36L14.36 11.64Z",
    fill: "black"
  })));
}, "IconLocalLaundryService");
import SH from "classnames";
var jH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalLibrary } from '@aws-amplify/ui-react'; \u2192 import { MdLocalLibrary } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 9C14.21 9 16 7.21 16 5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5C8 7.21 9.79 9 12 9ZM12 3C13.1 3 14 3.9 14 5C14 6.1 13.1 7 12 7C10.9 7 10 6.1 10 5C10 3.9 10.9 3 12 3ZM12 11.55C9.64 9.35 6.48 8 3 8V19C6.48 19 9.64 20.35 12 22.55C14.36 20.36 17.52 19 21 19V8C17.52 8 14.36 9.35 12 11.55ZM19 17.13C16.47 17.47 14.07 18.43 12 19.95C9.94 18.43 7.53 17.46 5 17.12V10.17C7.1 10.55 9.05 11.52 10.64 13L12 14.28L13.36 13.01C14.95 11.53 16.9 10.56 19 10.18V17.13V17.13Z",
    fill: "currentColor"
  })));
}, "IconLocalLibrary");
import YH from "classnames";
var FH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalMall } from '@aws-amplify/ui-react'; \u2192 import { MdLocalMall } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 6H17C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6H5C3.9 6 3 6.9 3 8V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V8C21 6.9 20.1 6 19 6ZM12 3C13.66 3 15 4.34 15 6H9C9 4.34 10.34 3 12 3ZM19 20H5V8H19V20ZM12 12C10.34 12 9 10.66 9 9H7C7 11.76 9.24 14 12 14C14.76 14 17 11.76 17 9H15C15 10.66 13.66 12 12 12Z",
    fill: "currentColor"
  })));
}, "IconLocalMall");
import TH from "classnames";
var AH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalMovies } from '@aws-amplify/ui-react'; \u2192 import { MdLocalMovies } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 5V19H10V5H14ZM20 3H18V5H16V3H8V5H6V3H4V21H6V19H8V21H16V19H18V21H20V3ZM16 9V7H18V9H16ZM6 9V7H8V9H6ZM16 13V11H18V13H16ZM6 13V11H8V13H6ZM16 17V15H18V17H16ZM6 17V15H8V17H6Z",
    fill: "currentColor"
  })));
}, "IconLocalMovies");
import EH from "classnames";
var OH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalOffer } from '@aws-amplify/ui-react'; \u2192 import { MdLocalOffer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01V20.01Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z",
    fill: "black"
  })));
}, "IconLocalOffer");
import _H from "classnames";
var GH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalParking } from '@aws-amplify/ui-react'; \u2192 import { MdLocalParking } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _H(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 3H6V21H10V15H13C16.31 15 19 12.31 19 9C19 5.69 16.31 3 13 3ZM13.2 11H10V7H13.2C14.3 7 15.2 7.9 15.2 9C15.2 10.1 14.3 11 13.2 11Z",
    fill: "currentColor"
  })));
}, "IconLocalParking");
import UH from "classnames";
var zH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalPharmacy } from '@aws-amplify/ui-react'; \u2192 import { MdLocalPharmacy } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 5H18.36L19.5 1.86L17.15 1L15.69 5H3V7L5 13L3 19V21H21V19L19 13L21 7V5ZM17.1 13.63L18.89 19H5.11L6.9 13.63L7.11 13L6.9 12.37L5.11 7H18.89L17.1 12.37L16.89 13L17.1 13.63V13.63ZM13 9H11V12H8V14H11V17H13V14H16V12H13V9Z",
    fill: "currentColor"
  })));
}, "IconLocalPharmacy");
import XH from "classnames";
var KH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalPhone } from '@aws-amplify/ui-react'; \u2192 import { MdLocalPhone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54V5ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02V17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z",
    fill: "currentColor"
  })));
}, "IconLocalPhone");
import qH from "classnames";
var QH = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalPizza } from '@aws-amplify/ui-react'; \u2192 import { MdLocalPizza } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.9998 2C8.42977 2 5.22977 3.54 3.00977 6L11.9998 22L20.9898 6C18.7798 3.55 15.5698 2 11.9998 2ZM11.9998 17.92L5.50977 6.36C7.31977 4.85 9.61977 4 11.9998 4C14.3798 4 16.6798 4.85 18.4898 6.36L11.9998 17.92ZM8.99977 5.5C8.16977 5.5 7.49977 6.17 7.49977 7C7.49977 7.83 8.16977 8.5 8.99977 8.5C9.82977 8.5 10.4998 7.83 10.4998 7C10.4998 6.17 9.81977 5.5 8.99977 5.5ZM10.4998 13C10.4998 13.83 11.1698 14.5 11.9998 14.5C12.8198 14.5 13.4998 13.83 13.4998 13C13.4998 12.17 12.8198 11.5 11.9998 11.5C11.1798 11.5 10.4998 12.17 10.4998 13Z",
    fill: "currentColor"
  })));
}, "IconLocalPizza");
import JH from "classnames";
var $H = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalPlay } from '@aws-amplify/ui-react'; \u2192 import { MdLocalPlay } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 10V6C22 4.9 21.1 4 20 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM9.07 16L12 14.12L14.93 16L14.04 12.64L16.73 10.44L13.26 10.23L12 7L10.73 10.22L7.26 10.43L9.95 12.63L9.07 16Z",
    fill: "currentColor"
  })));
}, "IconLocalPlay");
import RH from "classnames";
var eM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalPolice } from '@aws-amplify/ui-react'; \u2192 import { MdLocalPolice } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RH(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.5 12.59L15.4 16.47L12 14.42L8.6 16.47L9.5 12.6L6.5 10.01L10.46 9.67L12 6.02L13.54 9.66L17.5 10L14.5 12.59ZM12 3.19L19 6.3V11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19ZM12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z",
    fill: "currentColor"
  })));
}, "IconLocalPolice");
import oM from "classnames";
var tM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalPostOffice } from '@aws-amplify/ui-react'; \u2192 import { MdLocalPostOffice } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z",
    fill: "currentColor"
  })));
}, "IconLocalPostOffice");
import rM from "classnames";
var iM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalPrintshop } from '@aws-amplify/ui-react'; \u2192 import { MdLocalPrintshop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 8H18V3H6V8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM8 5H16V8H8V5ZM16 19H8V15H16V19ZM18 15V13H6V15H4V11C4 10.45 4.45 10 5 10H19C19.55 10 20 10.45 20 11V15H18Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18 12.5C18.5523 12.5 19 12.0523 19 11.5C19 10.9477 18.5523 10.5 18 10.5C17.4477 10.5 17 10.9477 17 11.5C17 12.0523 17.4477 12.5 18 12.5Z",
    fill: "black"
  })));
}, "IconLocalPrintshop");
import sM from "classnames";
var aM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalSee } from '@aws-amplify/ui-react'; \u2192 import { MdLocalSee } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H16.83L15 2H9L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H8.05L8.64 5.35L9.88 4H14.12L15.36 5.35L15.95 6H20V18ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 15.2C10.23 15.2 8.8 13.77 8.8 12C8.8 10.23 10.23 8.8 12 8.8C13.77 8.8 15.2 10.23 15.2 12C15.2 13.77 13.77 15.2 12 15.2Z",
    fill: "currentColor"
  })));
}, "IconLocalSee");
import nM from "classnames";
var mM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalShipping } from '@aws-amplify/ui-react'; \u2192 import { MdLocalShipping } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 8H17V4H3C1.9 4 1 4.9 1 6V17H3C3 18.66 4.34 20 6 20C7.66 20 9 18.66 9 17H15C15 18.66 16.34 20 18 20C19.66 20 21 18.66 21 17H23V12L20 8ZM19.5 9.5L21.46 12H17V9.5H19.5ZM6 18C5.45 18 5 17.55 5 17C5 16.45 5.45 16 6 16C6.55 16 7 16.45 7 17C7 17.55 6.55 18 6 18ZM8.22 15C7.67 14.39 6.89 14 6 14C5.11 14 4.33 14.39 3.78 15H3V6H15V15H8.22ZM18 18C17.45 18 17 17.55 17 17C17 16.45 17.45 16 18 16C18.55 16 19 16.45 19 17C19 17.55 18.55 18 18 18Z",
    fill: "currentColor"
  })));
}, "IconLocalShipping");
import cM from "classnames";
var lM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocalTaxi } from '@aws-amplify/ui-react'; \u2192 import { MdLocalTaxi } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9V5H6.5C5.84 5 5.29 5.42 5.08 6.01L3 12V20C3 20.55 3.45 21 4 21H5C5.55 21 6 20.55 6 20V19H18V20C18 20.55 18.45 21 19 21H20C20.55 21 21 20.55 21 20V12L18.92 6.01ZM6.85 7H17.14L18.18 10H5.81L6.85 7ZM19 17H5V12.34L5.12 12H18.89L19 12.34V17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.5 16C8.32843 16 9 15.3284 9 14.5C9 13.6716 8.32843 13 7.5 13C6.67157 13 6 13.6716 6 14.5C6 15.3284 6.67157 16 7.5 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 16C17.3284 16 18 15.3284 18 14.5C18 13.6716 17.3284 13 16.5 13C15.6716 13 15 13.6716 15 14.5C15 15.3284 15.6716 16 16.5 16Z",
    fill: "black"
  })));
}, "IconLocalTaxi");
import pM from "classnames";
var hM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocationCity } from '@aws-amplify/ui-react'; \u2192 import { MdLocationCity } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 11V5L12 2L9 5V7H3V21H21V11H15ZM7 19H5V17H7V19ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM13 19H11V17H13V19ZM13 15H11V13H13V15ZM13 11H11V9H13V11ZM13 7H11V5H13V7ZM19 19H17V17H19V19ZM19 15H17V13H19V15Z",
    fill: "currentColor"
  })));
}, "IconLocationCity");
import fM from "classnames";
var CM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocationDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdLocationDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23 13V11H20.94C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C10.02 3.17 9.09 3.44 8.23 3.84L9.76 5.37C10.46 5.13 11.22 5 12 5C15.87 5 19 8.13 19 12C19 12.79 18.87 13.54 18.63 14.24L20.16 15.77C20.56 14.91 20.83 13.98 20.94 13H23ZM4.41 2.86L3 4.27L5.04 6.31C3.97 7.62 3.26 9.23 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C14.77 20.74 16.38 20.03 17.69 18.96L19.73 21L21.14 19.59L4.41 2.86ZM12 19C8.13 19 5 15.87 5 12C5 10.39 5.55 8.91 6.46 7.73L16.27 17.54C15.09 18.45 13.61 19 12 19Z",
    fill: "currentColor"
  })));
}, "IconLocationDisabled");
import gM from "classnames";
var uM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocationOff } from '@aws-amplify/ui-react'; \u2192 import { MdLocationOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C14.76 4 17 6.24 17 9C17 10.06 16.61 11.32 16 12.62L17.49 14.11C18.37 12.36 19 10.57 19 9C19 5.13 15.87 2 12 2C10.16 2 8.5 2.71 7.25 3.86L8.68 5.29C9.56 4.5 10.72 4 12 4ZM12 6.5C11.41 6.5 10.87 6.71 10.44 7.06L13.94 10.56C14.29 10.13 14.5 9.59 14.5 9C14.5 7.62 13.38 6.5 12 6.5ZM3.41 2.86L2 4.27L5.18 7.45C5.07 7.95 5 8.47 5 9C5 14.25 12 22 12 22C12 22 13.67 20.15 15.38 17.65L18.73 21L20.14 19.59L3.41 2.86ZM12 18.88C9.99 16.3 7.2 12.14 7.02 9.29L13.94 16.21C13.29 17.19 12.61 18.1 12 18.88V18.88Z",
    fill: "currentColor"
  })));
}, "IconLocationOff");
import wM from "classnames";
var dM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocationOn } from '@aws-amplify/ui-react'; \u2192 import { MdLocationOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z",
    fill: "black"
  })));
}, "IconLocationOn");
import VM from "classnames";
var HM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLocationSearching } from '@aws-amplify/ui-react'; \u2192 import { MdLocationSearching } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z",
    fill: "currentColor"
  })));
}, "IconLocationSearching");
import MM from "classnames";
var xM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLockOpen } from '@aws-amplify/ui-react'; \u2192 import { MdLockOpen } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: MM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6H9C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM18 20H6V10H18V20ZM12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17Z",
    fill: "currentColor"
  })));
}, "IconLockOpen");
import IM from "classnames";
var LM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLock } from '@aws-amplify/ui-react'; \u2192 import { MdLock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: IM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM9 6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9V6ZM18 20H6V10H18V20ZM12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17Z",
    fill: "currentColor"
  })));
}, "IconLock");
import vM from "classnames";
var NM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLogin } from '@aws-amplify/ui-react'; \u2192 import { MdLogin } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z",
    fill: "currentColor"
  })));
}, "IconLogin");
import yM from "classnames";
var bM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLooks_3 } from '@aws-amplify/ui-react'; \u2192 import { MdLooks_3 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15 15V13.5C15 12.67 14.33 12 13.5 12C14.33 12 15 11.33 15 10.5V9C15 7.89 14.1 7 13 7H9V9H13V11H11V13H13V15H9V17H13C14.1 17 15 16.11 15 15Z",
    fill: "currentColor"
  })));
}, "IconLooks_3");
import ZM from "classnames";
var BM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLooks_4 } from '@aws-amplify/ui-react'; \u2192 import { MdLooks_4 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_40474)"
  }, e.createElement("path", {
    d: "M19.04 3H5.04004C3.94004 3 3.04004 3.9 3.04004 5V19C3.04004 20.1 3.94004 21 5.04004 21H19.04C20.14 21 21.04 20.1 21.04 19V5C21.04 3.9 20.14 3 19.04 3ZM19.04 19H5.04004V5H19.04V19ZM13.04 17H15.04V7H13.04V11H11.04V7H9.04004V13H13.04V17Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_40474"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconLooks_4");
import WM from "classnames";
var kM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLooks_5 } from '@aws-amplify/ui-react'; \u2192 import { MdLooks_5 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15 15V13C15 11.89 14.1 11 13 11H11V9H15V7H9V13H13V15H9V17H13C14.1 17 15 16.11 15 15Z",
    fill: "currentColor"
  })));
}, "IconLooks_5");
import DM from "classnames";
var PM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLooks_6 } from '@aws-amplify/ui-react'; \u2192 import { MdLooks_6 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 17H13C14.1 17 15 16.11 15 15V13C15 11.89 14.1 11 13 11H11V9H15V7H11C9.9 7 9 7.89 9 9V15C9 16.11 9.9 17 11 17ZM11 13H13V15H11V13ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconLooks_6");
import SM from "classnames";
var jM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLooksOne } from '@aws-amplify/ui-react'; \u2192 import { MdLooksOne } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM12 17H14V7H10V9H12V17Z",
    fill: "currentColor"
  })));
}, "IconLooksOne");
import YM from "classnames";
var FM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLooksTwo } from '@aws-amplify/ui-react'; \u2192 import { MdLooksTwo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM15 15H11V13H13C14.1 13 15 12.11 15 11V9C15 7.89 14.1 7 13 7H9V9H13V11H11C9.9 11 9 11.89 9 13V17H15V15Z",
    fill: "currentColor"
  })));
}, "IconLooksTwo");
import TM from "classnames";
var AM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLooks } from '@aws-amplify/ui-react'; \u2192 import { MdLooks } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 10C8.14 10 5 13.14 5 17H7C7 14.24 9.24 12 12 12C14.76 12 17 14.24 17 17H19C19 13.14 15.86 10 12 10ZM12 6C5.93 6 1 10.93 1 17H3C3 12.04 7.04 8 12 8C16.96 8 21 12.04 21 17H23C23 10.93 18.07 6 12 6Z",
    fill: "currentColor"
  })));
}, "IconLooks");
import EM from "classnames";
var OM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLoop } from '@aws-amplify/ui-react'; \u2192 import { MdLoop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4V1L8 5L12 9V6C15.31 6 18 8.69 18 12C18 13.01 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 10.99 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 16.42 7.58 20 12 20V23L16 19L12 15V18Z",
    fill: "currentColor"
  })));
}, "IconLoop");
import _M from "classnames";
var GM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLoupe } from '@aws-amplify/ui-react'; \u2192 import { MdLoupe } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _M(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22H20C21.1 22 22 21.1 22 20V12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconLoupe");
import UM from "classnames";
var zM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLowPriority } from '@aws-amplify/ui-react'; \u2192 import { MdLowPriority } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 5H22V7H14V5ZM14 10.5H22V12.5H14V10.5ZM14 16H22V18H14V16ZM2 11.5C2 15.08 4.92 18 8.5 18H9V20L12 17L9 14V16H8.5C6.02 16 4 13.98 4 11.5C4 9.02 6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5Z",
    fill: "currentColor"
  })));
}, "IconLowPriority");
import XM from "classnames";
var KM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLoyalty } from '@aws-amplify/ui-react'; \u2192 import { MdLoyalty } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01V20.01Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M8.9 12.55C8.9 13.12 9.13 13.62 9.5 14L13 17.5L16.5 14C16.87 13.63 17.1 13.11 17.1 12.55C17.1 11.42 16.18 10.5 15.05 10.5C14.48 10.5 13.97 10.73 13.6 11.1L13 11.7L12.4 11.11C12.03 10.73 11.51 10.5 10.95 10.5C9.82 10.5 8.9 11.42 8.9 12.55V12.55Z",
    fill: "black"
  })));
}, "IconLoyalty");
import qM from "classnames";
var QM = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconLuggage } from '@aws-amplify/ui-react'; \u2192 import { MdLuggage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.5 18H8V9H9.5V18ZM12.75 18H11.25V9H12.75V18ZM16 18H14.5V9H16V18ZM17 6H15V3C15 2.45 14.55 2 14 2H10C9.45 2 9 2.45 9 3V6H7C5.9 6 5 6.9 5 8V19C5 20.1 5.9 21 7 21C7 21.55 7.45 22 8 22C8.55 22 9 21.55 9 21H15C15 21.55 15.45 22 16 22C16.55 22 17 21.55 17 21C18.1 21 19 20.1 19 19V8C19 6.9 18.1 6 17 6ZM10.5 3.5H13.5V6H10.5V3.5ZM17 19H7V8H17V19Z",
    fill: "currentColor"
  })));
}, "IconLuggage");
import JM from "classnames";
var $M = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMailOutline } from '@aws-amplify/ui-react'; \u2192 import { MdMailOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V8L12 13L20 8V18ZM12 11L4 6H20L12 11Z",
    fill: "currentColor"
  })));
}, "IconMailOutline");
import RM from "classnames";
var ex = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMail } from '@aws-amplify/ui-react'; \u2192 import { MdMail } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RM(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 10.99L4 6H20ZM20 18H4V8L12 13L20 8V18Z",
    fill: "currentColor"
  })));
}, "IconMail");
import ox from "classnames";
var tx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMap } from '@aws-amplify/ui-react'; \u2192 import { MdMap } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ox(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.5 3L20.34 3.03L15 5.1L9 3L3.36 4.9C3.15 4.97 3 5.15 3 5.38V20.5C3 20.78 3.22 21 3.5 21L3.66 20.97L9 18.9L15 21L20.64 19.1C20.85 19.03 21 18.85 21 18.62V3.5C21 3.22 20.78 3 20.5 3ZM10 5.47L14 6.87V18.53L10 17.13V5.47ZM5 6.46L8 5.45V17.15L5 18.31V6.46ZM19 17.54L16 18.55V6.86L19 5.7V17.54Z",
    fill: "currentColor"
  })));
}, "IconMap");
import rx from "classnames";
var ix = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMapsUgc } from '@aws-amplify/ui-react'; \u2192 import { MdMapsUgc } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C10.82 20 9.66 19.74 8.57 19.22C8.3 19.09 8.01 19.03 7.71 19.03C7.52 19.03 7.33 19.06 7.15 19.11L3.95 20.05L4.89 16.85C5.03 16.38 4.99 15.87 4.78 15.43C4.26 14.34 4 13.18 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 13.54 2.36 14.98 2.97 16.29L1 23L7.71 21.03C9.02 21.64 10.46 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z",
    fill: "currentColor"
  }), e.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13 8H11V11H8V13H11V16H13V13H16V11H13V8Z",
    fill: "black"
  })));
}, "IconMapsUgc");
import sx from "classnames";
var ax = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMarkChatRead } from '@aws-amplify/ui-react'; \u2192 import { MdMarkChatRead } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 18H6L2 22V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V11H20V4H4V16H12V18ZM23 14.34L21.59 12.93L17.35 17.17L15.23 15.05L13.82 16.46L17.34 20L23 14.34Z",
    fill: "currentColor"
  })));
}, "IconMarkChatRead");
import nx from "classnames";
var mx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMarkChatUnread } from '@aws-amplify/ui-react'; \u2192 import { MdMarkChatUnread } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 6.98V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2H14.1C14.04 2.32 14 2.66 14 3C14 3.34 14.04 3.68 14.1 4H4V16H20V7.9C20.74 7.75 21.42 7.42 22 6.98ZM16 3C16 4.66 17.34 6 19 6C20.66 6 22 4.66 22 3C22 1.34 20.66 0 19 0C17.34 0 16 1.34 16 3Z",
    fill: "currentColor"
  })));
}, "IconMarkChatUnread");
import cx from "classnames";
var lx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMarkEmailRead } from '@aws-amplify/ui-react'; \u2192 import { MdMarkEmailRead } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H12V18H4V8L12 13L20 8V13H22V6C22 4.9 21.1 4 20 4ZM12 11L4 6H20L12 11ZM17.34 22L13.8 18.46L15.21 17.05L17.33 19.17L21.57 14.93L23 16.34L17.34 22Z",
    fill: "currentColor"
  })));
}, "IconMarkEmailRead");
import px from "classnames";
var hx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMarkEmailUnread } from '@aws-amplify/ui-react'; \u2192 import { MdMarkEmailUnread } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: px(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 8.98V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18L2.01 6C2.01 4.9 2.9 4 4 4H14.1C14.04 4.32 14 4.66 14 5C14 5.34 14.04 5.68 14.1 6H4L12 11L15.67 8.71C16.14 9.14 16.69 9.47 17.3 9.69L12 13L4 8V18H20V9.9C20.74 9.75 21.42 9.42 22 8.98ZM16 5C16 6.66 17.34 8 19 8C20.66 8 22 6.66 22 5C22 3.34 20.66 2 19 2C17.34 2 16 3.34 16 5Z",
    fill: "currentColor"
  })));
}, "IconMarkEmailUnread");
import fx from "classnames";
var Cx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMarkunreadMailbox } from '@aws-amplify/ui-react'; \u2192 import { MdMarkunreadMailbox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H10V8H20V20H4V8H6V12H8V4H14V0H6V6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V8C22 6.9 21.1 6 20 6Z",
    fill: "currentColor"
  })));
}, "IconMarkunreadMailbox");
import gx from "classnames";
var ux = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMarkunread } from '@aws-amplify/ui-react'; \u2192 import { MdMarkunread } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z",
    fill: "currentColor"
  })));
}, "IconMarkunread");
import wx from "classnames";
var dx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMasks } from '@aws-amplify/ui-react'; \u2192 import { MdMasks } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.5 6C18.19 6 17.13 7.01 17.02 8.3C15.14 7.8 14.18 6.5 12 6.5C9.81 6.5 8.86 7.8 6.98 8.3C6.87 7.02 5.81 6 4.5 6C3.12 6 2 7.12 2 8.5V9C2 15 5.6 16.81 8.52 16.98C9.53 17.62 10.72 18 12 18C13.28 18 14.47 17.62 15.48 16.98C18.4 16.81 22 15 22 9V8.5C22 7.12 20.88 6 19.5 6ZM3.5 9V8.5C3.5 7.95 3.95 7.5 4.5 7.5C5.05 7.5 5.5 7.95 5.5 8.5V11.5C5.5 12.78 5.88 13.97 6.51 14.98C4.99 14.27 3.5 12.65 3.5 9ZM7 11.5V9.85C8.12 9.62 8.95 9.16 9.66 8.77C10.48 8.33 11.07 8 12 8C12.93 8 13.52 8.33 14.34 8.78C15.05 9.17 15.88 9.62 17 9.86V11.51C17 14.27 14.76 16.51 12 16.51C9.24 16.51 7 14.26 7 11.5ZM20.5 9C20.5 12.65 19.01 14.27 17.49 14.98C18.13 13.97 18.5 12.78 18.5 11.5V8.5C18.5 7.95 18.95 7.5 19.5 7.5C20.05 7.5 20.5 7.95 20.5 8.5V9V9ZM10.69 10.48C10.25 10.74 9.73 11.04 9 11.24V10.2C9.48 10.03 9.84 9.82 10.18 9.62C10.72 9.3 11.23 9 12 9C12.77 9 13.27 9.3 13.8 9.62C14.14 9.82 14.51 10.04 15 10.21V11.25C14.25 11.04 13.74 10.74 13.29 10.47C12.83 10.2 12.49 10 12 10C11.51 10 11.16 10.2 10.69 10.48Z",
    fill: "currentColor"
  })));
}, "IconMasks");
import Vx from "classnames";
var Hx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMaximize } from '@aws-amplify/ui-react'; \u2192 import { MdMaximize } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Vx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 3H21V5H3V3Z",
    fill: "currentColor"
  })));
}, "IconMaximize");
import Mx from "classnames";
var xx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMediation } from '@aws-amplify/ui-react'; \u2192 import { MdMediation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Mx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 16L22 12L18 8V11H12.94C12.6 7.9 10.68 5.28 8 3.95C7.96 2.31 6.64 1 5 1C3.34 1 2 2.34 2 4C2 5.66 3.34 7 5 7C5.95 7 6.78 6.55 7.33 5.86C9.23 6.9 10.6 8.77 10.92 11H7.82C7.4 9.84 6.3 9 5 9C3.34 9 2 10.34 2 12C2 13.66 3.34 15 5 15C6.3 15 7.4 14.16 7.82 13H10.92C10.6 15.23 9.23 17.1 7.34 18.14C6.78 17.45 5.95 17 5 17C3.34 17 2 18.34 2 20C2 21.66 3.34 23 5 23C6.64 23 7.96 21.69 7.99 20.05C10.67 18.72 12.59 16.1 12.93 13H18V16Z",
    fill: "currentColor"
  })));
}, "IconMediation");
import Ix from "classnames";
var Lx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMedicalServices } from '@aws-amplify/ui-react'; \u2192 import { MdMedicalServices } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ix(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H16V4C16 2.9 15.1 2 14 2H10C8.9 2 8 2.9 8 4V6H4C2.9 6 2 6.9 2 8V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V8C22 6.9 21.1 6 20 6ZM10 4H14V6H10V4ZM20 20H4V8H20V20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M13 10H11V13H8V15H11V18H13V15H16V13H13V10Z",
    fill: "black"
  })));
}, "IconMedicalServices");
import vx from "classnames";
var Nx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMeetingRoom } from '@aws-amplify/ui-react'; \u2192 import { MdMeetingRoom } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 19V4H15V3H5V19H3V21H15V6H17V21H21V19H19ZM13 19H7V5H13V19ZM10 11H12V13H10V11Z",
    fill: "currentColor"
  })));
}, "IconMeetingRoom");
import yx from "classnames";
var bx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMemory } from '@aws-amplify/ui-react'; \u2192 import { MdMemory } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 9H9V15H15V9ZM13 13H11V11H13V13ZM21 11V9H19V7C19 5.9 18.1 5 17 5H15V3H13V5H11V3H9V5H7C5.9 5 5 5.9 5 7V9H3V11H5V13H3V15H5V17C5 18.1 5.9 19 7 19H9V21H11V19H13V21H15V19H17C18.1 19 19 18.1 19 17V15H21V13H19V11H21ZM17 17H7V7H17V17Z",
    fill: "currentColor"
  })));
}, "IconMemory");
import Zx from "classnames";
var Bx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMenuBook } from '@aws-amplify/ui-react'; \u2192 import { MdMenuBook } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Zx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 5C19.89 4.65 18.67 4.5 17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5ZM21 18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M17.5 10.5C18.38 10.5 19.23 10.59 20 10.76V9.24C19.21 9.09 18.36 9 17.5 9C15.8 9 14.26 9.29 13 9.83V11.49C14.13 10.85 15.7 10.5 17.5 10.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 12.4902V14.1502C14.13 13.5102 15.7 13.1602 17.5 13.1602C18.38 13.1602 19.23 13.2502 20 13.4202V11.9002C19.21 11.7502 18.36 11.6602 17.5 11.6602C15.8 11.6602 14.26 11.9602 13 12.4902Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17.5 14.3301C15.8 14.3301 14.26 14.6201 13 15.1601V16.8201C14.13 16.1801 15.7 15.8301 17.5 15.8301C18.38 15.8301 19.23 15.9201 20 16.0901V14.5701C19.21 14.4101 18.36 14.3301 17.5 14.3301Z",
    fill: "black"
  })));
}, "IconMenuBook");
import Wx from "classnames";
var kx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMenuOpen } from '@aws-amplify/ui-react'; \u2192 import { MdMenuOpen } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Wx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z",
    fill: "currentColor"
  })));
}, "IconMenuOpen");
import Dx from "classnames";
var Dt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Dx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z",
    fill: "currentColor"
  })));
}, "IconMenu");
import Px from "classnames";
var Sx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMergeType } from '@aws-amplify/ui-react'; \u2192 import { MdMergeType } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Px(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.0001 20.41L18.4101 19L15.0001 15.59L13.5901 17L17.0001 20.41ZM7.50009 8H11.0001V13.59L5.59009 19L7.00009 20.41L13.0001 14.41V8H16.5001L12.0001 3.5L7.50009 8Z",
    fill: "currentColor"
  })));
}, "IconMergeType");
import jx from "classnames";
var Yx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMessage } from '@aws-amplify/ui-react'; \u2192 import { MdMessage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 4H20V16H5.17L4 17.17V4ZM4 2C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2H4ZM6 12H18V14H6V12ZM6 9H18V11H6V9ZM6 6H18V8H6V6Z",
    fill: "currentColor"
  })));
}, "IconMessage");
import Fx from "classnames";
var Tx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMicNone } from '@aws-amplify/ui-react'; \u2192 import { MdMicNone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 14C13.66 14 15 12.66 15 11V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V11C9 12.66 10.34 14 12 14ZM11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5V11C13 11.55 12.55 12 12 12C11.45 12 11 11.55 11 11V5ZM17 11C17 13.76 14.76 16 12 16C9.24 16 7 13.76 7 11H5C5 14.53 7.61 17.43 11 17.92V21H13V17.92C16.39 17.43 19 14.53 19 11H17V11Z",
    fill: "currentColor"
  })));
}, "IconMicNone");
import Ax from "classnames";
var Ex = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMicOff } from '@aws-amplify/ui-react'; \u2192 import { MdMicOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ax(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.8 4.9C10.8 4.24 11.34 3.7 12 3.7C12.66 3.7 13.2 4.24 13.2 4.9L13.19 8.81L15 10.6V5C15 3.34 13.66 2 12 2C10.46 2 9.21 3.16 9.04 4.65L10.8 6.41V4.9V4.9ZM19 11H17.3C17.3 11.58 17.2 12.13 17.03 12.64L18.3 13.91C18.74 13.03 19 12.04 19 11ZM4.41 2.86L3 4.27L9 10.27V11C9 12.66 10.34 14 12 14C12.23 14 12.44 13.97 12.65 13.92L14.31 15.58C13.6 15.91 12.81 16.1 12 16.1C9.24 16.1 6.7 14 6.7 11H5C5 14.41 7.72 17.23 11 17.72V21H13V17.72C13.91 17.59 14.77 17.27 15.55 16.82L19.75 21.02L21.16 19.61L4.41 2.86Z",
    fill: "currentColor"
  })));
}, "IconMicOff");
import Ox from "classnames";

var _x = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMic } from '@aws-amplify/ui-react'; \u2192 import { MdMic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ox(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 14C13.66 14 15 12.66 15 11V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V11C9 12.66 10.34 14 12 14Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M17 11C17 13.76 14.76 16 12 16C9.24 16 7 13.76 7 11H5C5 14.53 7.61 17.43 11 17.92V21H13V17.92C16.39 17.43 19 14.53 19 11H17V11Z",
    fill: "black"
  })));
}, "IconMic");

import Gx from "classnames";
var Ux = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMicrowave } from '@aws-amplify/ui-react'; \u2192 import { MdMicrowave } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 6H14V18H4V6ZM20 18H16V6H20V18ZM19 9H17V7H19V9ZM18 13C17.45 13 17 12.55 17 12C17 11.45 17.45 11 18 11C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13ZM18 17C17.45 17 17 16.55 17 16C17 15.45 17.45 15 18 15C18.55 15 19 15.45 19 16C19 16.55 18.55 17 18 17ZM10.25 16C9.46 16 8.88 15.62 8.46 15.34C8.13 15.12 7.94 15 7.75 15C7.38 15 6.95 15.41 6.8 15.61L5.38 14.19C5.73 13.79 6.59 13 7.75 13C8.55 13 9.14 13.39 9.56 13.67C9.87 13.88 10.07 14 10.25 14C10.62 14 11.05 13.59 11.2 13.39L12.62 14.81C12.26 15.21 11.41 16 10.25 16ZM10.25 11C9.46 11 8.88 10.62 8.46 10.34C8.13 10.12 7.94 10 7.75 10C7.38 10 6.95 10.41 6.8 10.61L5.37 9.19C5.73 8.79 6.59 8 7.75 8C8.55 8 9.14 8.39 9.56 8.67C9.87 8.88 10.07 9 10.25 9C10.62 9 11.05 8.59 11.2 8.39L12.62 9.81C12.26 10.21 11.41 11 10.25 11Z",
    fill: "currentColor"
  })));
}, "IconMicrowave");
import zx from "classnames";
var Xx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMilitaryTech } from '@aws-amplify/ui-react'; \u2192 import { MdMilitaryTech } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 10.43V2H7V10.43C7 10.78 7.18 11.11 7.49 11.29L11.67 13.8L10.68 16.14L7.27 16.43L9.86 18.67L9.07 22L12 20.23L14.93 22L14.15 18.67L16.74 16.43L13.33 16.14L12.34 13.8L16.52 11.29C16.82 11.11 17 10.79 17 10.43ZM11 11.07L9 9.87V4H11V11.07ZM15 9.87L13 11.07V4H15V9.87Z",
    fill: "currentColor"
  })));
}, "IconMilitaryTech");
import Kx from "classnames";
var qx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMinimize } from '@aws-amplify/ui-react'; \u2192 import { MdMinimize } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 19H18V21H6V19Z",
    fill: "currentColor"
  })));
}, "IconMinimize");
import Qx from "classnames";
var Jx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMiscellaneousServices } from '@aws-amplify/ui-react'; \u2192 import { MdMiscellaneousServices } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qx(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.17 13.71L15.57 11.29C15.66 11.14 15.62 10.95 15.49 10.84L14.01 9.68C14.04 9.46 14.06 9.23 14.06 9C14.06 8.77 14.04 8.54 14.01 8.31L15.49 7.15C15.62 7.04 15.66 6.85 15.57 6.7L14.17 4.28C14.08 4.13 13.9 4.07 13.74 4.13L12 4.83C11.64 4.55 11.25 4.32 10.82 4.14L10.56 2.29C10.53 2.13 10.38 2 10.21 2H7.41C7.24 2 7.09 2.13 7.06 2.3L6.8 4.15C6.38 4.33 5.98 4.56 5.62 4.84L3.88 4.14C3.72 4.08 3.54 4.14 3.45 4.29L2.05 6.71C1.96 6.86 2 7.05 2.13 7.16L3.61 8.32C3.58 8.54 3.56 8.77 3.56 9C3.56 9.23 3.58 9.46 3.61 9.69L2.13 10.85C2 10.96 1.96 11.15 2.05 11.3L3.45 13.72C3.54 13.87 3.72 13.93 3.88 13.87L5.62 13.17C5.98 13.45 6.37 13.68 6.8 13.86L7.06 15.71C7.09 15.87 7.24 16 7.41 16H10.21C10.38 16 10.53 15.87 10.56 15.7L10.82 13.85C11.24 13.67 11.64 13.44 12 13.16L13.74 13.86C13.9 13.92 14.08 13.86 14.17 13.71ZM8.81 11C7.71 11 6.81 10.1 6.81 9C6.81 7.9 7.71 7 8.81 7C9.91 7 10.81 7.9 10.81 9C10.81 10.1 9.91 11 8.81 11Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M21.9202 18.67L20.9602 17.93C20.9802 17.79 21.0002 17.64 21.0002 17.49C21.0002 17.34 20.9902 17.19 20.9602 17.05L21.9102 16.31C21.9902 16.24 22.0202 16.12 21.9602 16.02L21.0602 14.47C21.0102 14.37 20.8902 14.34 20.7802 14.37L19.6702 14.82C19.4402 14.64 19.1902 14.49 18.9102 14.38L18.7402 13.2C18.7302 13.08 18.6302 13 18.5302 13H16.7402C16.6302 13 16.5302 13.08 16.5202 13.19L16.3502 14.37C16.0802 14.49 15.8202 14.63 15.5902 14.81L14.4802 14.36C14.3802 14.32 14.2602 14.36 14.2002 14.46L13.3002 16.01C13.2502 16.11 13.2602 16.23 13.3502 16.3L14.3002 17.04C14.2802 17.18 14.2702 17.33 14.2702 17.48C14.2702 17.63 14.2802 17.78 14.3002 17.92L13.3502 18.66C13.2702 18.73 13.2402 18.85 13.3002 18.95L14.2002 20.5C14.2502 20.6 14.3702 20.63 14.4802 20.6L15.5902 20.15C15.8202 20.33 16.0702 20.48 16.3502 20.59L16.5202 21.77C16.5402 21.88 16.6302 21.96 16.7402 21.96H18.5302C18.6402 21.96 18.7402 21.88 18.7502 21.77L18.9202 20.59C19.1902 20.47 19.4502 20.33 19.6702 20.15L20.7902 20.6C20.8902 20.64 21.0102 20.6 21.0702 20.5L21.9702 18.95C22.0302 18.86 22.0002 18.74 21.9202 18.67ZM17.6302 18.83C16.8902 18.83 16.2802 18.23 16.2802 17.48C16.2802 16.73 16.8802 16.13 17.6302 16.13C18.3802 16.13 18.9802 16.73 18.9802 17.48C18.9802 18.23 18.3702 18.83 17.6302 18.83Z",
    fill: "black"
  })));
}, "IconMiscellaneousServices");
import $x from "classnames";
var Rx = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMissedVideoCall } from '@aws-amplify/ui-react'; \u2192 import { MdMissedVideoCall } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $x(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5ZM15 8.67V16H5V8H15V8.67ZM7.11 11.11L11 15L14.77 11.21L13.99 10.42L11 13.43L7.89 10.33H10.44V9.22H6V13.66H7.11V11.11Z",
    fill: "currentColor"
  })));
}, "IconMissedVideoCall");
import eI from "classnames";
var oI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMms } from '@aws-amplify/ui-react'; \u2192 import { MdMms } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM14.5 8L11 12.51L8.5 9.5L5 14H19L14.5 8Z",
    fill: "currentColor"
  })));
}, "IconMms");
import tI from "classnames";
var rI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMobileFriendly } from '@aws-amplify/ui-react'; \u2192 import { MdMobileFriendly } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 1H9C7.9 1 7 1.9 7 3V6H9V4H19V20H9V18H7V21C7 22.1 7.9 23 9 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1ZM7.01 13.47L4.46 10.92L3.19 12.19L7 16L14.19 8.81L12.92 7.54L7.01 13.47V13.47Z",
    fill: "currentColor"
  })));
}, "IconMobileFriendly");
import iI from "classnames";
var sI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMobileOff } from '@aws-amplify/ui-react'; \u2192 import { MdMobileOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 5V13.61L19 15.61V3C19 1.9 18.1 1 17 1H6.99999C6.28999 1 5.66999 1.37 5.31999 1.93L8.38999 5H17ZM1.48999 3.76L4.99999 7.27V21C4.99999 22.1 5.89999 23 6.99999 23H17C18.02 23 18.85 22.23 18.98 21.25L20.7 22.97L22.11 21.56L2.89999 2.35L1.48999 3.76ZM6.99999 9.27L16.73 19H6.99999V9.27Z",
    fill: "currentColor"
  })));
}, "IconMobileOff");
import aI from "classnames";
var nI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMobileScreenShare } from '@aws-amplify/ui-react'; \u2192 import { MdMobileScreenShare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 1H7.00001C5.90001 1 5.01001 1.85 5.01001 2.95V20.95C5.01001 22.05 5.90001 23 7.00001 23H17C18.1 23 19 22.05 19 20.95V2.95C19 1.85 18.1 1 17 1ZM17 19H7.00001V5H17V19ZM12.8 13.24V14.99L16 12L12.8 9.02V10.72C9.69001 11.15 8.45001 13.28 8.00001 15.42C9.11001 13.92 10.58 13.24 12.8 13.24V13.24Z",
    fill: "currentColor"
  })));
}, "IconMobileScreenShare");
import mI from "classnames";
var cI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconModeComment } from '@aws-amplify/ui-react'; \u2192 import { MdModeComment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 17.17L18.83 16H4V4H20V17.17ZM20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2Z",
    fill: "currentColor"
  })));
}, "IconModeComment");
import lI from "classnames";
var pI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMode } from '@aws-amplify/ui-react'; \u2192 import { MdMode } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02V9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3V3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19V6.19Z",
    fill: "currentColor"
  })));
}, "IconMode");
import hI from "classnames";
var fI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconModelTraining } from '@aws-amplify/ui-react'; \u2192 import { MdModelTraining } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 13.5C15.5 15.5 13 17 13 18.5H11C11 17 8.5 15.5 8.5 13.5C8.5 11.57 10.07 10 12 10C13.93 10 15.5 11.57 15.5 13.5ZM13 19.5H11V21H13V19.5ZM19 13C19 14.68 18.41 16.21 17.42 17.42L18.84 18.84C20.18 17.27 21 15.23 21 13C21 10.26 19.77 7.81 17.84 6.16L16.42 7.58C17.99 8.86 19 10.82 19 13ZM16 5L12 1V4C7.03 4 3 8.03 3 13C3 15.23 3.82 17.27 5.16 18.84L6.58 17.42C5.59 16.21 5 14.68 5 13C5 9.14 8.14 6 12 6V9L16 5Z",
    fill: "currentColor"
  })));
}, "IconModelTraining");
import CI from "classnames";
var gI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMonetizationOn } from '@aws-amplify/ui-react'; \u2192 import { MdMonetizationOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.31 11.14C10.54 10.69 9.97 10.2 9.97 9.47C9.97 8.63 10.76 8.04 12.07 8.04C13.45 8.04 13.97 8.7 14.01 9.68H15.72C15.67 8.34 14.85 7.11 13.23 6.71V5H10.9V6.69C9.39 7.01 8.18 7.99 8.18 9.5C8.18 11.29 9.67 12.19 11.84 12.71C13.79 13.17 14.18 13.86 14.18 14.58C14.18 15.11 13.79 15.97 12.08 15.97C10.48 15.97 9.85 15.25 9.76 14.33H8.04C8.14 16.03 9.4 16.99 10.9 17.3V19H13.24V17.33C14.76 17.04 15.96 16.17 15.97 14.56C15.96 12.36 14.07 11.6 12.31 11.14V11.14Z",
    fill: "currentColor"
  })));
}, "IconMonetizationOn");
import uI from "classnames";
var wI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoneyOffCsred } from '@aws-amplify/ui-react'; \u2192 import { MdMoneyOffCsred } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.5001 6.9C14.2801 6.9 14.9401 7.75 15.0001 9H17.2101C17.1401 7.28 16.0901 5.7 14.0001 5.19V3H11.0001V5.16C10.6101 5.24 10.2501 5.37 9.90006 5.52L11.4101 7.03C11.7301 6.95 12.1001 6.9 12.5001 6.9ZM5.47006 3.92L4.06006 5.33L7.50006 8.77C7.50006 10.85 9.06006 11.99 11.4101 12.68L14.9201 16.19C14.5801 16.68 13.8701 17.1 12.5001 17.1C10.4401 17.1 9.63006 16.18 9.52006 15H7.32006C7.44006 17.19 9.08006 18.42 11.0001 18.83V21H14.0001V18.85C14.9601 18.67 15.8301 18.3 16.4601 17.73L18.6801 19.95L20.0901 18.54L5.47006 3.92Z",
    fill: "currentColor"
  })));
}, "IconMoneyOffCsred");
import dI from "classnames";
var VI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoneyOff } from '@aws-amplify/ui-react'; \u2192 import { MdMoneyOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.5001 6.9C14.2801 6.9 14.9401 7.75 15.0001 9H17.2101C17.1401 7.28 16.0901 5.7 14.0001 5.19V3H11.0001V5.16C10.6101 5.24 10.2501 5.37 9.90006 5.52L11.4101 7.03C11.7301 6.95 12.1001 6.9 12.5001 6.9ZM5.47006 3.92L4.06006 5.33L7.50006 8.77C7.50006 10.85 9.06006 11.99 11.4101 12.68L14.9201 16.19C14.5801 16.68 13.8701 17.1 12.5001 17.1C10.4401 17.1 9.63006 16.18 9.52006 15H7.32006C7.44006 17.19 9.08006 18.42 11.0001 18.83V21H14.0001V18.85C14.9601 18.67 15.8301 18.3 16.4601 17.73L18.6801 19.95L20.0901 18.54L5.47006 3.92Z",
    fill: "currentColor"
  })));
}, "IconMoneyOff");
import HI from "classnames";
var MI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoney } from '@aws-amplify/ui-react'; \u2192 import { MdMoney } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 16H18C18.55 16 19 15.55 19 15V9C19 8.45 18.55 8 18 8H15C14.45 8 14 8.45 14 9V15C14 15.55 14.45 16 15 16ZM16 10H17V14H16V10ZM9 16H12C12.55 16 13 15.55 13 15V9C13 8.45 12.55 8 12 8H9C8.45 8 8 8.45 8 9V15C8 15.55 8.45 16 9 16ZM10 10H11V14H10V10ZM5 8H7V16H5V8ZM2 4V20H22V4H2ZM20 18H4V6H20V18Z",
    fill: "currentColor"
  })));
}, "IconMoney");
import xI from "classnames";
var II = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMonochromePhotos } from '@aws-amplify/ui-react'; \u2192 import { MdMonochromePhotos } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 5H16.8L15 3H9L7.2 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H12V18C9.2 18 7 15.8 7 13C7 10.2 9.2 8 12 8V7H20V19ZM17 13C17 10.2 14.8 8 12 8V9.8C13.8 9.8 15.2 11.2 15.2 13C15.2 14.8 13.8 16.2 12 16.2V18C14.8 18 17 15.8 17 13ZM8.8 13C8.8 14.8 10.2 16.2 12 16.2V9.8C10.2 9.8 8.8 11.2 8.8 13Z",
    fill: "currentColor"
  })));
}, "IconMonochromePhotos");
import LI from "classnames";
var vI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoodBad } from '@aws-amplify/ui-react'; \u2192 import { MdMoodBad } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 13.5C9.67 13.5 7.69 14.96 6.89 17H17.11C16.31 14.96 14.33 13.5 12 13.5Z",
    fill: "currentColor"
  })));
}, "IconMoodBad");
import NI from "classnames";
var yI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMood } from '@aws-amplify/ui-react'; \u2192 import { MdMood } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z",
    fill: "currentColor"
  })));
}, "IconMood");
import bI from "classnames";
var ZI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoped } from '@aws-amplify/ui-react'; \u2192 import { MdMoped } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 7C19 5.9 18.1 5 17 5H14V7H17V9.65L13.52 14H10V9H6C3.79 9 2 10.79 2 13V16H4C4 17.66 5.34 19 7 19C8.66 19 10 17.66 10 16H14.48L19 10.35V7ZM4 14V13C4 11.9 4.9 11 6 11H8V14H4ZM7 17C6.45 17 6 16.55 6 16H8C8 16.55 7.55 17 7 17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10 6H5V8H10V6Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19 13C17.34 13 16 14.34 16 16C16 17.66 17.34 19 19 19C20.66 19 22 17.66 22 16C22 14.34 20.66 13 19 13ZM19 17C18.45 17 18 16.55 18 16C18 15.45 18.45 15 19 15C19.55 15 20 15.45 20 16C20 16.55 19.55 17 19 17Z",
    fill: "black"
  })));
}, "IconMoped");
import BI from "classnames";
var WI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoreHoriz } from '@aws-amplify/ui-react'; \u2192 import { MdMoreHoriz } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z",
    fill: "currentColor"
  })));
}, "IconMoreHoriz");
import kI from "classnames";
var DI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoreTime } from '@aws-amplify/ui-react'; \u2192 import { MdMoreTime } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 8V14L14.7 16.9L15.5 15.7L11.5 13.3V8H10Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M17.92 12C17.97 12.33 18 12.66 18 13C18 16.9 14.9 20 11 20C7.1 20 4 16.9 4 13C4 9.1 7.1 6 11 6C11.7 6 12.37 6.1 13 6.29V4.23C12.36 4.08 11.69 4 11 4C6 4 2 8 2 13C2 18 6 22 11 22C16 22 20 18 20 13C20 12.66 19.98 12.33 19.94 12H17.92Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M20 5V2H18V5H15V7H18V10H20V7H23V5H20Z",
    fill: "black"
  })));
}, "IconMoreTime");
import PI from "classnames";
var SI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoreVert } from '@aws-amplify/ui-react'; \u2192 import { MdMoreVert } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z",
    fill: "currentColor"
  })));
}, "IconMoreVert");
import jI from "classnames";
var YI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMore } from '@aws-amplify/ui-react'; \u2192 import { MdMore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 3H7C6.31 3 5.77 3.35 5.41 3.88L0 12L5.41 20.11C5.77 20.64 6.38 21 7.07 21H22C23.1 21 24 20.1 24 19V5C24 3.9 23.1 3 22 3ZM22 19H7.07L2.4 12L7.06 5H22V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9 13.5C9.82843 13.5 10.5 12.8284 10.5 12C10.5 11.1716 9.82843 10.5 9 10.5C8.17157 10.5 7.5 11.1716 7.5 12C7.5 12.8284 8.17157 13.5 9 13.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14 13.5C14.8284 13.5 15.5 12.8284 15.5 12C15.5 11.1716 14.8284 10.5 14 10.5C13.1716 10.5 12.5 11.1716 12.5 12C12.5 12.8284 13.1716 13.5 14 13.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19 13.5C19.8284 13.5 20.5 12.8284 20.5 12C20.5 11.1716 19.8284 10.5 19 10.5C18.1716 10.5 17.5 11.1716 17.5 12C17.5 12.8284 18.1716 13.5 19 13.5Z",
    fill: "black"
  })));
}, "IconMore");
import FI from "classnames";
var TI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMotionPhotosOn } from '@aws-amplify/ui-react'; \u2192 import { MdMotionPhotosOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 16.5V7.5L16 12L10 16.5ZM22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.81 2.22 9.68 2.6 8.62L4.48 9.3C4.17 10.14 4 11.05 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.05 4 10.15 4.17 9.31 4.48L8.63 2.59C9.69 2.22 10.82 2 12 2C17.52 2 22 6.48 22 12ZM5.5 4C4.67 4 4 4.67 4 5.5C4 6.33 4.67 7 5.5 7C6.33 7 7 6.33 7 5.5C7 4.67 6.33 4 5.5 4Z",
    fill: "currentColor"
  })));
}, "IconMotionPhotosOn");
import AI from "classnames";
var EI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMotionPhotosPause } from '@aws-amplify/ui-react'; \u2192 import { MdMotionPhotosPause } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.81 2.22 9.68 2.6 8.62L4.48 9.3C4.17 10.14 4 11.05 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.05 4 10.15 4.17 9.31 4.48L8.63 2.59C9.69 2.22 10.82 2 12 2C17.52 2 22 6.48 22 12ZM5.5 7C6.33 7 7 6.33 7 5.5C7 4.67 6.33 4 5.5 4C4.67 4 4 4.67 4 5.5C4 6.33 4.67 7 5.5 7ZM9 9V15H11V9H9ZM13 9V15H15V9H13Z",
    fill: "currentColor"
  })));
}, "IconMotionPhotosPause");
import OI from "classnames";

var _I = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMotionPhotosPaused } from '@aws-amplify/ui-react'; \u2192 import { MdMotionPhotosPaused } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 10.81 2.22 9.68 2.6 8.62L4.48 9.3C4.17 10.14 4 11.05 4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C11.05 4 10.15 4.17 9.31 4.48L8.63 2.59C9.69 2.22 10.82 2 12 2C17.52 2 22 6.48 22 12ZM5.5 4C4.67 4 4 4.67 4 5.5C4 6.33 4.67 7 5.5 7C6.33 7 7 6.33 7 5.5C7 4.67 6.33 4 5.5 4ZM11 16V8H9V16H11ZM15 16V8H13V16H15Z",
    fill: "currentColor"
  })));
}, "IconMotionPhotosPaused");

import GI from "classnames";
var UI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMouse } from '@aws-amplify/ui-react'; \u2192 import { MdMouse } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 8.99982C19.96 4.60982 16.4 1.06982 12 1.06982C7.6 1.06982 4.04 4.60982 4 8.99982V14.9998C4 19.4198 7.58 22.9998 12 22.9998C16.42 22.9998 20 19.4198 20 14.9998V8.99982ZM18 8.99982H13V3.15982C15.81 3.62982 17.96 6.05982 18 8.99982ZM11 3.15982V8.99982H6C6.04 6.05982 8.19 3.62982 11 3.15982ZM18 14.9998C18 18.3098 15.31 20.9998 12 20.9998C8.69 20.9998 6 18.3098 6 14.9998V10.9998H18V14.9998Z",
    fill: "currentColor"
  })));
}, "IconMouse");
import zI from "classnames";
var XI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMoveToInbox } from '@aws-amplify/ui-react'; \u2192 import { MdMoveToInbox } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 9H13.45V6H10.55V9H8L12 13L16 9ZM19 3H4.99C3.88 3 3 3.9 3 5V19C3 20.1 3.88 21 4.99 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.56C9.25 17.19 10.53 18 12.01 18C13.49 18 14.76 17.19 15.46 16H19V19ZM19 14H14.01C14.01 15.1 13.11 16 12.01 16C10.91 16 10.01 15.1 10.01 14H5L4.99 5H19V14Z",
    fill: "currentColor"
  })));
}, "IconMoveToInbox");
import KI from "classnames";
var qI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMovieCreation } from '@aws-amplify/ui-react'; \u2192 import { MdMovieCreation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5.76 10H20V18H4V6.47L5.76 10ZM22 4H18L20 8H17L15 4H13L15 8H12L10 4H8L10 8H7L5 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V4Z",
    fill: "currentColor"
  })));
}, "IconMovieCreation");
import QI from "classnames";
var JI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMovieFilter } from '@aws-amplify/ui-react'; \u2192 import { MdMovieFilter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QI(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 11L9.06001 13.06L7.00001 14L9.06001 14.94L10 17L10.94 14.94L13 14L10.94 13.06L10 11ZM18.01 4L20.01 8H17.01L15.01 4H13.01L15.01 8H12.01L10.01 4H8.01001L10.01 8H7.01001L5.01001 4H4.01001C2.91001 4 2.02001 4.9 2.02001 6L2.01001 18C2.01001 19.1 2.91001 20 4.01001 20H20.01C21.11 20 22 19.1 22 18V4H18.01ZM20.01 18H4.01001V6.47L5.77001 10H16L15.37 11.37L14 12L15.37 12.63L16 14L16.63 12.63L18 12L16.63 11.37L16 10H20.01V18Z",
    fill: "currentColor"
  })));
}, "IconMovieFilter");
import $I from "classnames";
var RI = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMovie } from '@aws-amplify/ui-react'; \u2192 import { MdMovie } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $I(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6.47L5.76 10H20V18H4V6.47ZM22 4H18L20 8H17L15 4H13L15 8H12L10 4H8L10 8H7L5 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V4Z",
    fill: "currentColor"
  })));
}, "IconMovie");
import eL from "classnames";
var oL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMultilineChart } from '@aws-amplify/ui-react'; \u2192 import { MdMultilineChart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 6.92L20.59 5.51L17.74 8.72C15.68 6.4 12.83 5 9.61 5C6.72 5 4.07 6.16 2 8L3.42 9.42C5.12 7.93 7.27 7 9.61 7C12.35 7 14.7 8.26 16.38 10.24L13.5 13.48L9.5 9.48L2 16.99L3.5 18.49L9.5 12.48L13.5 16.48L17.55 11.93C18.3 13.28 18.8 14.83 18.99 16.48H21C20.78 14.18 20.05 12.09 18.96 10.34L22 6.92Z",
    fill: "currentColor"
  })));
}, "IconMultilineChart");
import tL from "classnames";
var rL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMultipleStop } from '@aws-amplify/ui-react'; \u2192 import { MdMultipleStop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 4L21 8L17 12V9H13V7H17V4ZM10 7C9.45 7 9 7.45 9 8C9 8.55 9.45 9 10 9C10.55 9 11 8.55 11 8C11 7.45 10.55 7 10 7ZM6 7C5.45 7 5 7.45 5 8C5 8.55 5.45 9 6 9C6.55 9 7 8.55 7 8C7 7.45 6.55 7 6 7ZM7 17H11V15H7V12L3 16L7 20V17ZM14 17C14.55 17 15 16.55 15 16C15 15.45 14.55 15 14 15C13.45 15 13 15.45 13 16C13 16.55 13.45 17 14 17ZM18 17C18.55 17 19 16.55 19 16C19 15.45 18.55 15 18 15C17.45 15 17 15.45 17 16C17 16.55 17.45 17 18 17Z",
    fill: "currentColor"
  })));
}, "IconMultipleStop");
import iL from "classnames";
var sL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMuseum } from '@aws-amplify/ui-react'; \u2192 import { MdMuseum } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 11V9L12 2L2 9V11H4V20H2V22H22V20H20V11H22ZM18 20H6V9H18V20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10 14L12 17L14 14V18H16V11H14L12 14L10 11H8V18H10V14Z",
    fill: "black"
  })));
}, "IconMuseum");
import aL from "classnames";
var nL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMusicNote } from '@aws-amplify/ui-react'; \u2192 import { MdMusicNote } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 3L12.01 13.55C11.42 13.21 10.74 13 10.01 13C7.79 13 6 14.79 6 17C6 19.21 7.79 21 10.01 21C12.23 21 14 19.21 14 17V7H18V3H12ZM10.01 19C8.91 19 8.01 18.1 8.01 17C8.01 15.9 8.91 15 10.01 15C11.11 15 12.01 15.9 12.01 17C12.01 18.1 11.11 19 10.01 19Z",
    fill: "currentColor"
  })));
}, "IconMusicNote");
import mL from "classnames";
var cL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMusicOff } from '@aws-amplify/ui-react'; \u2192 import { MdMusicOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 6.99986H18V2.99986H12V7.60986L14 9.60986V6.99986ZM12 10.4399L4.41 2.85986L3 4.26986L12 13.2699V13.5499C11.06 13.0099 9.9 12.7999 8.67 13.2299C7.33 13.7099 6.3 14.8999 6.06 16.2999C5.6 19.0399 7.92 21.3799 10.65 20.9499C12.61 20.6399 14 18.8399 14 16.8499V15.2699L19.73 20.9999L21.14 19.5899L12 10.4399ZM10 18.9999C8.9 18.9999 8 18.0999 8 16.9999C8 15.8999 8.9 14.9999 10 14.9999C11.1 14.9999 12 15.8999 12 16.9999C12 18.0999 11.1 18.9999 10 18.9999Z",
    fill: "currentColor"
  })));
}, "IconMusicOff");
import lL from "classnames";
var pL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMusicVideo } from '@aws-amplify/ui-react'; \u2192 import { MdMusicVideo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19ZM8 15C8 13.34 9.34 12 11 12C11.35 12 11.69 12.07 12 12.18V6H17V8H14V15.03C13.98 16.67 12.65 18 11 18C9.34 18 8 16.66 8 15Z",
    fill: "currentColor"
  })));
}, "IconMusicVideo");
import hL from "classnames";
var fL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconMyLocation } from '@aws-amplify/ui-react'; \u2192 import { MdMyLocation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94V11ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z",
    fill: "currentColor"
  })));
}, "IconMyLocation");
import CL from "classnames";
var gL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNat } from '@aws-amplify/ui-react'; \u2192 import { MdNat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.82 13H11V11H6.82C6.4 9.84 5.3 9 4 9C2.34 9 1 10.34 1 12C1 13.66 2.34 15 4 15C5.3 15 6.4 14.16 6.82 13ZM4 13C3.45 13 3 12.55 3 12C3 11.45 3.45 11 4 11C4.55 11 5 11.45 5 12C5 12.55 4.55 13 4 13Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M23 12L19 9V11H14.95C14.45 5.95 10.19 2 5 2V4C9.42 4 13 7.58 13 12C13 16.42 9.42 20 5 20V22C10.19 22 14.45 18.05 14.95 13H19V15L23 12Z",
    fill: "black"
  })));
}, "IconNat");
import uL from "classnames";
var wL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNaturePeople } from '@aws-amplify/ui-react'; \u2192 import { MdNaturePeople } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4.5 11C5.32843 11 6 10.3284 6 9.5C6 8.67157 5.32843 8 4.5 8C3.67157 8 3 8.67157 3 9.5C3 10.3284 3.67157 11 4.5 11Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M22.17 9.16992C22.17 5.29992 19.04 2.16992 15.17 2.16992C11.3 2.16992 8.17 5.29992 8.17 9.16992C8.17 12.6399 10.69 15.5099 14 16.0599V19.9999H6V16.9999H7V12.9999C7 12.4499 6.55 11.9999 6 11.9999H3C2.45 11.9999 2 12.4499 2 12.9999V16.9999H3V21.9999H19V19.9999H16V16.1199C19.47 15.7099 22.17 12.7599 22.17 9.16992V9.16992ZM15.17 14.1699C12.41 14.1699 10.17 11.9299 10.17 9.16992C10.17 6.40992 12.41 4.16992 15.17 4.16992C17.93 4.16992 20.17 6.40992 20.17 9.16992C20.17 11.9299 17.93 14.1699 15.17 14.1699Z",
    fill: "black"
  })));
}, "IconNaturePeople");
import dL from "classnames";
var VL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNature } from '@aws-amplify/ui-react'; \u2192 import { MdNature } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 16.1199H12.97C16.46 15.7199 19.17 12.7599 19.17 9.16992C19.17 5.29992 16.04 2.16992 12.17 2.16992C8.3 2.16992 5.17 5.29992 5.17 9.16992C5.17 12.6399 7.69 15.5099 11 16.0599V19.9999H5V21.9999H19V19.9999H13V16.1199ZM7.17 9.16992C7.17 6.40992 9.41 4.16992 12.17 4.16992C14.93 4.16992 17.17 6.40992 17.17 9.16992C17.17 11.9299 14.93 14.1699 12.17 14.1699C9.41 14.1699 7.17 11.9299 7.17 9.16992V9.16992Z",
    fill: "currentColor"
  })));
}, "IconNature");
import HL from "classnames";
var ML = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNavigateBefore } from '@aws-amplify/ui-react'; \u2192 import { MdNavigateBefore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.61 7.41L14.2 6L8.19995 12L14.2 18L15.61 16.59L11.03 12L15.61 7.41Z",
    fill: "currentColor"
  })));
}, "IconNavigateBefore");
import xL from "classnames";
var IL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNavigateNext } from '@aws-amplify/ui-react'; \u2192 import { MdNavigateNext } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.0201 6L8.61011 7.41L13.1901 12L8.61011 16.59L10.0201 18L16.0201 12L10.0201 6Z",
    fill: "currentColor"
  })));
}, "IconNavigateNext");
import LL from "classnames";
var vL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNavigation } from '@aws-amplify/ui-react'; \u2192 import { MdNavigation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 7.27L16.28 17.7L12.81 16.17L12 15.81L11.19 16.17L7.72 17.7L12 7.27ZM12 2L4.5 20.29L5.21 21L12 18L18.79 21L19.5 20.29L12 2Z",
    fill: "currentColor"
  })));
}, "IconNavigation");
import NL from "classnames";
var yL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNearMeDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdNearMeDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.0001 6.3399L21.0001 2.9999L17.6601 11.9999L16.1001 10.4399L17.6001 6.3899L13.5501 7.8899L12.0001 6.3399ZM21.1901 21.1899L16.1201 16.1199L14.3101 20.9999H12.9001L10.0701 13.9299L3.00006 11.0999V9.6899L7.88006 7.8799L2.81006 2.8099L4.22006 1.3999L22.6001 19.7799L21.1901 21.1899ZM14.5701 14.5699L9.43006 9.4299L6.72006 10.4399L11.6101 12.3899L13.5601 17.2799L14.5701 14.5699Z",
    fill: "currentColor"
  })));
}, "IconNearMeDisabled");
import bL from "classnames";
var ZL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNearMe } from '@aws-amplify/ui-react'; \u2192 import { MdNearMe } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.27 6.73L13.03 16.86L11.71 13.44L11.39 12.61L10.57 12.29L7.14 10.96L17.27 6.73V6.73ZM21 3L3 10.53V11.51L9.84 14.16L12.48 21H13.46L21 3Z",
    fill: "currentColor"
  })));
}, "IconNearMe");
import BL from "classnames";
var WL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNetworkCheck } from '@aws-amplify/ui-react'; \u2192 import { MdNetworkCheck } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.9 5.00017C15.73 5.00017 15.58 5.09017 15.49 5.23017L15.42 5.38017L10.24 17.0302C10.08 17.3202 9.98 17.6402 9.98 17.9902C9.98 19.1002 10.88 20.0002 11.99 20.0002C12.95 20.0002 13.76 19.3202 13.95 18.4102L13.96 18.3802L16.4 5.50017C16.4 5.22017 16.18 5.00017 15.9 5.00017V5.00017ZM1 9.00017L3 11.0002C5.88 8.12017 9.79 6.92017 13.53 7.38017L14.72 4.70017C9.89 3.84017 4.74 5.27017 1 9.00017ZM21 11.0002L23 9.00017C21.36 7.36017 19.45 6.18017 17.41 5.43017L16.88 8.25017C18.38 8.87017 19.78 9.78017 21 11.0002ZM17 15.0002L19 13.0002C18.2 12.2002 17.3 11.5802 16.34 11.1102L15.79 14.0302C16.21 14.3002 16.62 14.6202 17 15.0002ZM5 13.0002L7 15.0002C8.13 13.8702 9.56 13.2102 11.03 13.0002L12.31 10.1202C9.68 10.0402 7.01 10.9902 5 13.0002V13.0002Z",
    fill: "currentColor"
  })));
}, "IconNetworkCheck");
import kL from "classnames";
var DL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNetworkLocked } from '@aws-amplify/ui-react'; \u2192 import { MdNetworkLocked } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 16V15.5C22 14.12 20.88 13 19.5 13C18.12 13 17 14.12 17 15.5V16C16.45 16 16 16.45 16 17V21C16 21.55 16.45 22 17 22H22C22.55 22 23 21.55 23 21V17C23 16.45 22.55 16 22 16ZM21 16H18V15.5C18 14.67 18.67 14 19.5 14C20.33 14 21 14.67 21 15.5V16ZM18 5.83V11.26C18.47 11.1 18.97 11 19.5 11C19.67 11 19.83 11.03 20 11.05V1L1 20H14V18H5.83L18 5.83Z",
    fill: "currentColor"
  })));
}, "IconNetworkLocked");
import PL from "classnames";
var SL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNewReleases } from '@aws-amplify/ui-react'; \u2192 import { MdNewReleases } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23 12L20.56 9.22004L20.9 5.54004L17.29 4.72004L15.4 1.54004L12 3.00004L8.6 1.54004L6.71 4.72004L3.1 5.53004L3.44 9.21004L1 12L3.44 14.78L3.1 18.47L6.71 19.29L8.6 22.47L12 21L15.4 22.46L17.29 19.28L20.9 18.46L20.56 14.78L23 12ZM18.49 14.11L18.75 16.9L16.01 17.52L14.58 19.93L12 18.82L9.42 19.93L7.99 17.52L5.25 16.9L5.51 14.1L3.66 12L5.51 9.88004L5.25 7.10004L7.99 6.49004L9.42 4.08004L12 5.18004L14.58 4.07004L16.01 6.48004L18.75 7.10004L18.49 9.89004L20.34 12L18.49 14.11V14.11ZM11 15H13V17H11V15ZM11 7.00004H13V13H11V7.00004Z",
    fill: "currentColor"
  })));
}, "IconNewReleases");
import jL from "classnames";
var YL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNextPlan } from '@aws-amplify/ui-react'; \u2192 import { MdNextPlan } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15.97 11.03C14.87 9.79 13.28 9 11.5 9C8.67999 9 6.31999 10.95 5.67999 13.56L6.63999 13.88C7.14999 11.66 9.12999 10 11.5 10C13.01 10 14.35 10.68 15.26 11.74L13 14H18V9L15.97 11.03Z",
    fill: "black"
  })));
}, "IconNextPlan");
import FL from "classnames";
var TL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNextWeek } from '@aws-amplify/ui-react'; \u2192 import { MdNextWeek } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 18.5L15 14.5L11 10.5L10 11.5L13 14.5L10 17.5L11 18.5ZM20 7H16V5C16 4.45 15.78 3.95 15.41 3.59C15.05 3.22 14.55 3 14 3H10C8.9 3 8 3.9 8 5V7H4C2.9 7 2 7.9 2 9V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V9C22 7.9 21.1 7 20 7ZM10 5H14V7H10V5ZM20 20H4V9H20V20Z",
    fill: "currentColor"
  })));
}, "IconNextWeek");
import AL from "classnames";
var EL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNfc } from '@aws-amplify/ui-react'; \u2192 import { MdNfc } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM20 20H4V4H20V20ZM18 6H13C11.9 6 11 6.9 11 8V10.28C10.4 10.63 10 11.26 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 11.26 13.6 10.62 13 10.28V8H16V16H8V8H10V6H6V18H18V6Z",
    fill: "currentColor"
  })));
}, "IconNfc");
import OL from "classnames";

var _L = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNightShelter } from '@aws-amplify/ui-react'; \u2192 import { MdNightShelter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5.5L18 10V19H6V10L12 5.5ZM12 3L4 9V21H20V9L12 3ZM15 12H11.5V15.5H8V11H7V18H8V16.5H16V18H17V14C17 12.9 16.1 12 15 12ZM9.75 12.5C9.06 12.5 8.5 13.06 8.5 13.75C8.5 14.44 9.06 15 9.75 15C10.44 15 11 14.44 11 13.75C11 13.06 10.44 12.5 9.75 12.5Z",
    fill: "currentColor"
  })));
}, "IconNightShelter");

import GL from "classnames";
var UL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNightsStay } from '@aws-amplify/ui-react'; \u2192 import { MdNightsStay } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.78 17.5098C17.31 17.5098 13.21 16.1798 11.1 12.0798C8.76998 7.56977 10.6 3.59977 11.63 2.00977C6.26998 2.19977 1.97998 6.58977 1.97998 11.9998C1.97998 12.1398 1.99998 12.2798 1.99998 12.4198C2.60998 12.1598 3.27998 11.9998 3.97998 11.9998C3.97998 8.90977 5.70998 6.22977 8.27998 4.89977C7.77998 7.08977 7.73998 9.93977 9.31998 12.9998C10.89 16.0398 13.5 17.9498 16.12 18.8598C14.89 19.5998 13.47 20.0098 11.99 20.0098C11.49 20.0098 10.99 19.9598 10.51 19.8698C10.14 20.5698 9.56998 21.1398 8.86998 21.5098C9.84998 21.8298 10.9 22.0098 11.98 22.0098C15.48 22.0098 18.56 20.2098 20.35 17.4898C20.18 17.4998 19.98 17.5098 19.78 17.5098Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7 16H6.82C6.4 14.84 5.3 14 4 14C2.34 14 1 15.34 1 17C1 18.66 2.34 20 4 20C4.62 20 6.49 20 7 20C8.1 20 9 19.1 9 18C9 16.9 8.1 16 7 16Z",
    fill: "black"
  })));
}, "IconNightsStay");
import zL from "classnames";
var XL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoBackpack } from '@aws-amplify/ui-react'; \u2192 import { MdNoBackpack } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.98014 4.15C6.99014 4.15 6.99014 4.14 7.00014 4.14V2H10.0001V4H14.0001V2H17.0001V4.14C18.7201 4.59 20.0001 6.14 20.0001 8V17.17L18.0001 15.17V8C18.0001 6.9 17.1001 6 16.0001 6H8.83014L6.98014 4.15ZM14.8301 12L16.5001 13.67V12H14.8301ZM19.7801 22.61L18.9301 21.76C18.6501 21.91 18.3401 22 18.0001 22H6.00014C4.90014 22 4.00014 21.1 4.00014 20V8C4.00014 7.64 4.06014 7.31 4.15014 6.98L1.39014 4.22L2.80014 2.81L21.1801 21.19L19.7801 22.61ZM17.1701 20L11.1701 14H7.50014V12H9.17014L6.00014 8.83V20H17.1701Z",
    fill: "currentColor"
  })));
}, "IconNoBackpack");
import KL from "classnames";
var qL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoCell } from '@aws-amplify/ui-react'; \u2192 import { MdNoCell } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.0001 6V14.17L19.0001 16.17V3C19.0001 1.9 18.1001 1.01 17.0001 1.01L7.00014 1C6.15014 1 5.42014 1.55 5.13014 2.3L8.83014 6H17.0001ZM7.00014 3H17.0001V4H7.00014V3ZM21.1901 21.19L19.0001 19L17.0001 17L7.00014 7L5.00014 5L2.81014 2.81L1.39014 4.22L5.00014 7.83V21C5.00014 22.1 5.90014 23 7.00014 23H17.0001C17.8501 23 18.5801 22.45 18.8701 21.7L19.7801 22.61L21.1901 21.19ZM17.0001 21H7.00014V20H17.0001V21ZM7.00014 18V9.83L15.1701 18H7.00014Z",
    fill: "currentColor"
  })));
}, "IconNoCell");
import QL from "classnames";
var JL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoDrinks } from '@aws-amplify/ui-react'; \u2192 import { MdNoDrinks } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QL(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.1901 21.1901L2.81014 2.81006L1.39014 4.22006L9.62014 12.4501L11.0001 14.0001V19.0001H6.00014V21.0001H18.0001V20.8301L19.7801 22.6101L21.1901 21.1901ZM13.0001 19.0001V15.8301L16.1701 19.0001H13.0001ZM7.83014 5.00006L5.83014 3.00006H21.0001V5.00006L14.8001 11.9701L13.3801 10.5501L14.7701 9.00006H11.8301L9.83014 7.00006H16.5701L18.3501 5.00006H7.83014Z",
    fill: "currentColor"
  })));
}, "IconNoDrinks");
import $L from "classnames";
var RL = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoEncryptionGmailerrorred } from '@aws-amplify/ui-react'; \u2192 import { MdNoEncryptionGmailerrorred } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $L(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H10.44L12.44 10H18V15.56L20 17.56V10C20 8.9 19.1 8 18 8H17V6C17 3.24 14.76 1 12 1C9.68 1 7.74 2.59 7.18 4.74L8.9 6.46V6ZM4.41 4.81L3 6.22L5.04 8.26C4.42 8.6 4 9.25 4 10V20C4 21.1 4.9 22 6 22H18.78L19.78 23L21.19 21.59L4.41 4.81ZM6 20V10H6.78L16.78 20H6Z",
    fill: "currentColor"
  })));
}, "IconNoEncryptionGmailerrorred");
import ev from "classnames";
var ov = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoEncryption } from '@aws-amplify/ui-react'; \u2192 import { MdNoEncryption } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ev(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H10.44L12.44 10H18V15.56L20 17.56V10C20 8.9 19.1 8 18 8H17V6C17 3.24 14.76 1 12 1C9.68 1 7.74 2.59 7.18 4.74L8.9 6.46V6ZM4.41 4.81L3 6.22L5.04 8.26C4.42 8.6 4 9.25 4 10V20C4 21.1 4.9 22 6 22H18.78L19.78 23L21.19 21.59L4.41 4.81ZM6 20V10H6.78L16.78 20H6Z",
    fill: "currentColor"
  })));
}, "IconNoEncryption");
import tv from "classnames";
var rv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoFlash } from '@aws-amplify/ui-react'; \u2192 import { MdNoFlash } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.3999 5.6H21.9999L18.9999 11V7H17.9999V2H21.9999L20.3999 5.6ZM15.9999 11.4V13.17L17.9999 15.17V11C17.9999 10.12 17.2799 9.4 16.3999 9.4H13.8599L12.5799 8H10.8299L14.2299 11.4H15.9999ZM2.09994 2.1L0.689941 3.51L6.34994 9.17L6.13994 9.4H3.59994C2.71994 9.4 1.99994 10.12 1.99994 11V20.4C1.99994 21.28 2.71994 22 3.59994 22H16.3999C17.1499 22 17.7799 21.48 17.9499 20.78L20.4899 23.32L21.8999 21.91L2.09994 2.1ZM11.4999 15.5C11.4999 16.33 10.8299 17 9.99994 17C9.16994 17 8.49994 16.33 8.49994 15.5C8.49994 14.67 9.16994 14 9.99994 14C10.8299 14 11.4999 14.67 11.4999 15.5ZM15.9599 20H3.99994V11.4H6.13994H7.01994L7.60994 10.75L7.75994 10.59L9.25994 12.09C7.67994 12.43 6.49994 13.82 6.49994 15.5C6.49994 17.43 8.06994 19 9.99994 19C11.6799 19 13.0699 17.82 13.4199 16.24L15.9699 18.79L15.9599 20Z",
    fill: "currentColor"
  })));
}, "IconNoFlash");
import iv from "classnames";
var sv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoFood } from '@aws-amplify/ui-react'; \u2192 import { MdNoFood } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1.00018 21H16.0102V21.98C16.0102 22.54 15.5602 22.99 15.0002 22.99H2.01018C1.45018 22.99 1.00018 22.54 1.00018 21.98V21ZM20.4902 23.31L16.0002 18.83V19H1.00018V17H14.1702L12.1702 15H1.00018C1.00018 11.76 3.46018 9.83 6.38018 9.21L0.680176 3.51L2.10018 2.1L13.0002 13L15.0002 15L21.9002 21.9L20.4902 23.31ZM10.1702 13L8.17018 11C6.75018 11.06 4.65018 11.56 3.62018 13H10.1702ZM23.0002 5H18.0002V1H16.0002V5H11.0002L11.2302 7H20.7902L19.7902 16.97L21.6202 18.8L23.0002 5Z",
    fill: "currentColor"
  })));
}, "IconNoFood");
import av from "classnames";
var nv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoLuggage } from '@aws-amplify/ui-react'; \u2192 import { MdNoLuggage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: av(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.0001 13.17L14.5001 11.67V9H16.0001V13.17ZM19.7801 22.61L17.9301 20.76C17.6501 20.91 17.3401 21 17.0001 21C17.0001 21.55 16.5501 22 16.0001 22C15.4501 22 15.0001 21.55 15.0001 21H9.00014C9.00014 21.55 8.55014 22 8.00014 22C7.45014 22 7.00014 21.55 7.00014 21C5.90014 21 5.00014 20.1 5.00014 19V8C5.00014 7.95 5.02014 7.9 5.02014 7.85L1.39014 4.22L2.80014 2.81L21.1801 21.19L19.7801 22.61ZM16.1701 19L12.7501 15.58V18H11.2501V14.08L9.50014 12.33V18H8.00014V10.83L7.00014 9.83V19H16.1701ZM12.7501 9H11.8301L12.7501 9.92V9ZM19.0001 8V16.17L17.0001 14.17V8H10.8301L9.84014 7.01L9.00014 6.17V6V3C9.00014 2.45 9.45014 2 10.0001 2H14.0001C14.5501 2 15.0001 2.45 15.0001 3V6H17.0001C18.1001 6 19.0001 6.9 19.0001 8ZM10.5001 6H13.5001V3.5H10.5001V6Z",
    fill: "currentColor"
  })));
}, "IconNoLuggage");
import mv from "classnames";
var cv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoMeals } from '@aws-amplify/ui-react'; \u2192 import { MdNoMeals } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.9999 14V6C15.9999 4.24 18.2399 2 20.9999 2V18.17L18.9999 16.17V14H15.9999ZM20.4899 23.31L10.0199 12.85C9.68994 12.94 9.35994 13 8.99994 13V22H6.99994V13C4.78994 13 2.99994 11.21 2.99994 9V5.83L0.689941 3.51L2.09994 2.1L21.8999 21.9L20.4899 23.31ZM6.16994 9L4.99994 7.83V9H6.16994ZM8.99994 2H6.99994V4.17L8.99994 6.17V2ZM12.9999 9V2H10.9999V8.17L12.8499 10.02C12.9399 9.69 12.9999 9.36 12.9999 9Z",
    fill: "currentColor"
  })));
}, "IconNoMeals");
import lv from "classnames";
var pv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoMeetingRoom } from '@aws-amplify/ui-react'; \u2192 import { MdNoMeetingRoom } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4.99988V8.87988L14 10.8799V5.99988H17V13.8799L19 15.8799V3.99988H14V2.99988H6.12L8.12 4.99988H12ZM2.41 2.12988L1 3.53988L5 7.53988V18.9999H3V20.9999H14V16.5399L20.46 22.9999L21.87 21.5899L2.41 2.12988ZM12 18.9999H7V9.53988L12 14.5399V18.9999Z",
    fill: "currentColor"
  })));
}, "IconNoMeetingRoom");
import hv from "classnames";
var fv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoPhotography } from '@aws-amplify/ui-react'; \u2192 import { MdNoPhotography } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.90018 6.0701L7.48018 4.6601L9.00018 3.0001H15.0002L16.8302 5.0001H20.0002C21.1002 5.0001 22.0002 5.9001 22.0002 7.0001V19.0001C22.0002 19.0501 21.9902 19.1001 21.9802 19.1601L20.0002 17.1701V7.0001H15.9502L14.1202 5.0001H9.88018L8.90018 6.0701ZM20.4902 23.3101L18.1702 21.0001H4.00018C2.90018 21.0001 2.00018 20.1001 2.00018 19.0001V7.0001C2.00018 6.4101 2.27018 5.8801 2.68018 5.5101L0.680176 3.5101L2.10018 2.1001L21.9002 21.9001L20.4902 23.3101ZM9.19018 12.0201C9.08018 12.3301 9.00018 12.6501 9.00018 13.0001C9.00018 14.6601 10.3402 16.0001 12.0002 16.0001C12.3502 16.0001 12.6702 15.9201 12.9802 15.8101L9.19018 12.0201ZM16.1702 19.0001L14.4902 17.3201C13.7602 17.7501 12.9102 18.0001 12.0002 18.0001C9.24018 18.0001 7.00018 15.7601 7.00018 13.0001C7.00018 12.0901 7.25018 11.2401 7.68018 10.5101L4.17018 7.0001H4.00018V19.0001H16.1702ZM14.8102 11.9801L16.8802 14.0501C16.9602 13.7101 17.0002 13.3601 17.0002 13.0001C17.0002 10.2401 14.7602 8.0001 12.0002 8.0001C11.6402 8.0001 11.2902 8.0401 10.9402 8.1201L13.0102 10.1901C13.8502 10.4901 14.5102 11.1501 14.8102 11.9801Z",
    fill: "currentColor"
  })));
}, "IconNoPhotography");
import Cv from "classnames";
var gv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoSim } from '@aws-amplify/ui-react'; \u2192 import { MdNoSim } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.26 21.21L3.79 3.74L2.38 5.15L5.12 7.89L5 8.01V19C5 20.1 5.9 21 7 21H17C17.35 21 17.68 20.9 17.97 20.74L19.85 22.62L21.26 21.21V21.21ZM7 19V9.77L16.23 19H7ZM10.84 5H17V14.11L19 16.11V5C19 3.9 18.1 3 17 3H10.01L7.95 5.06L9.36 6.47L10.84 5Z",
    fill: "currentColor"
  })));
}, "IconNoSim");
import uv from "classnames";
var wv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoStroller } from '@aws-amplify/ui-react'; \u2192 import { MdNoStroller } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.00014 20.0001C8.00014 21.1001 7.10014 22.0001 6.00014 22.0001C4.90014 22.0001 4.00014 21.1001 4.00014 20.0001C4.00014 18.9001 4.90014 18.0001 6.00014 18.0001C7.10014 18.0001 8.00014 18.9001 8.00014 20.0001ZM15.0001 8.66006V12.1701L17.0001 14.1701V6.27006C17.5801 5.59006 17.9701 5.00006 18.6501 5.00006C19.4201 5.00006 20.0001 5.66006 20.0001 6.48006V7.00006H22.0001V6.48006C22.0001 4.56006 20.5201 3.00006 18.6501 3.00006C16.9901 3.00006 16.1101 4.27006 15.4701 5.03006L11.9701 9.14006L13.3901 10.5601L15.0001 8.66006ZM19.7801 22.6101L17.8701 20.7001C17.5801 21.4601 16.8601 22.0001 16.0001 22.0001C14.9001 22.0001 14.0001 21.1001 14.0001 20.0001C14.0001 19.1401 14.5401 18.4201 15.3001 18.1301L14.1701 17.0001H7.43014C6.58014 17.0001 6.12014 16.0001 6.67014 15.3501L9.36014 12.1901L1.39014 4.22006L2.80014 2.81006L10.6601 10.6701L12.0801 12.0901L21.1901 21.2001L19.7801 22.6101ZM12.1701 15.0001L10.7801 13.6101L9.60014 15.0001H12.1701ZM10.0001 5.00006C10.2901 5.00006 10.5801 5.02006 10.8601 5.05006L9.49014 6.67006L10.9101 8.09006L14.3001 4.10006C13.0301 3.40006 11.5601 3.00006 10.0001 3.00006C8.77014 3.00006 7.60014 3.25006 6.53014 3.70006L8.10014 5.27006C8.71014 5.10006 9.35014 5.00006 10.0001 5.00006Z",
    fill: "currentColor"
  })));
}, "IconNoStroller");
import dv from "classnames";
var Vv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoTransfer } from '@aws-amplify/ui-react'; \u2192 import { MdNoTransfer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.50014 13C9.33014 13 10.0001 13.67 10.0001 14.5C10.0001 15.33 9.33014 16 8.50014 16C7.67014 16 7.00014 15.33 7.00014 14.5C7.00014 13.67 7.67014 13 8.50014 13ZM19.7801 22.61L18.1401 20.97C18.0901 20.98 18.0501 21 18.0001 21H17.0001C16.4501 21 16.0001 20.55 16.0001 20V19H8.00014V20C8.00014 20.55 7.55014 21 7.00014 21H6.00014C5.45014 21 5.00014 20.55 5.00014 20V18.22C4.39014 17.67 4.00014 16.88 4.00014 16V6.83L1.39014 4.22L2.80014 2.81L21.1801 21.19L19.7801 22.61ZM6.00014 8.83V10H7.17014L6.00014 8.83ZM14.1701 17L9.17014 12H6.00014V16C6.00014 16.37 6.21014 16.62 6.34014 16.73L6.63014 17H14.1701ZM12.0001 4C15.6901 4 17.1101 4.46 17.6601 4.99H7.82014L9.82014 6.99H18.0001V10H12.8301L14.8301 12H18.0001V15.17L19.8101 16.98C19.9201 16.67 20.0001 16.35 20.0001 16V6C20.0001 2.5 16.4201 2 12.0001 2C9.48014 2 7.24014 2.16 5.78014 2.95L7.31014 4.48C8.17014 4.2 9.60014 4 12.0001 4Z",
    fill: "currentColor"
  })));
}, "IconNoTransfer");
import Hv from "classnames";
var Mv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNorthEast } from '@aws-amplify/ui-react'; \u2192 import { MdNorthEast } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 5V7H15.59L4 18.59L5.41 20L17 8.41V15H19V5H9Z",
    fill: "currentColor"
  })));
}, "IconNorthEast");
import xv from "classnames";
var Iv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNorthWest } from '@aws-amplify/ui-react'; \u2192 import { MdNorthWest } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 15H7V8.41L18.59 20L20 18.59L8.41 7H15V5H5V15Z",
    fill: "currentColor"
  })));
}, "IconNorthWest");
import Lv from "classnames";
var vv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNorth } from '@aws-amplify/ui-react'; \u2192 import { MdNorth } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 9L6.41 10.41L11 5.83V22H13V5.83L17.59 10.42L19 9L12 2L5 9Z",
    fill: "currentColor"
  })));
}, "IconNorth");
import Nv from "classnames";
var yv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotAccessible } from '@aws-amplify/ui-react'; \u2192 import { MdNotAccessible } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 4C10 2.9 10.9 2 12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4ZM19 13V11C17.46 11.02 15.91 10.25 14.93 9.17L13.64 7.74C13.4 7.5 13.2 7.38 13.01 7.28C12.65 7.09 12.29 6.98 11.81 7.02C11.32 7.06 10.9 7.29 10.58 7.63L14 11.05C15.29 12.12 17.25 12.99 19 13ZM10 20C8.34001 20 7.00001 18.66 7.00001 17C7.00001 15.69 7.84001 14.59 9.00001 14.17V12.1C6.72001 12.56 5.00001 14.58 5.00001 17C5.00001 19.76 7.24001 22 10 22C12.42 22 14.44 20.28 14.9 18H12.83C12.42 19.16 11.31 20 10 20ZM2.81001 2.81L1.39001 4.22L10 12.83V15C10 16.1 10.9 17 12 17H14.17L19.78 22.61L21.19 21.2L2.81001 2.81Z",
    fill: "currentColor"
  })));
}, "IconNotAccessible");
import bv from "classnames";
var Zv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotInterested } from '@aws-amplify/ui-react'; \u2192 import { MdNotInterested } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 10.15 4.63 8.45 5.69 7.1L16.9 18.31C15.55 19.37 13.85 20 12 20ZM18.31 16.9L7.1 5.69C8.45 4.63 10.15 4 12 4C16.42 4 20 7.58 20 12C20 13.85 19.37 15.55 18.31 16.9Z",
    fill: "currentColor"
  })));
}, "IconNotInterested");
import Bv from "classnames";
var Wv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotListedLocation } from '@aws-amplify/ui-react'; \u2192 import { MdNotListedLocation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.01 16C11.74 16 11.49 15.9 11.3 15.71C11.1 15.51 11.01 15.28 11.01 15C11 14.45 11.44 14.01 11.99 14C12 14 12 14 12.01 14C12.29 14 12.52 14.1 12.72 14.29C12.9 14.48 13 14.72 13 14.99C13 15.26 12.9 15.5 12.71 15.7C12.52 15.9 12.28 16 12.01 16ZM11.13 12.34C11.13 11.89 11.23 11.5 11.42 11.18C11.61 10.85 11.95 10.48 12.42 10.06C12.7 9.81 12.9 9.59 13.03 9.4C13.16 9.21 13.22 9 13.22 8.76C13.22 8.47 13.11 8.23 12.9 8.02C12.69 7.82 12.4 7.72 12.05 7.72C11.68 7.72 11.31 7.82 11.09 8.02C10.88 8.22 10.69 8.47 10.69 9H9C9 7.99 9.46 7.27 9.97 6.79C10.53 6.28 11.25 6 12 6C12.59 6 13.11 6.12 13.57 6.35C14.03 6.58 14.36 6.9 14.62 7.31C14.88 7.72 15 8.17 15 8.66C15 9.15 14.9 9.56 14.69 9.91C14.48 10.26 14.21 10.62 13.8 11C13.48 11.3 13.27 11.56 13.15 11.77C13.03 11.98 12.97 12.26 12.97 12.58V13H11.12V12.34H11.13ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z",
    fill: "currentColor"
  })));
}, "IconNotListedLocation");
import kv from "classnames";
var Dv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotStarted } from '@aws-amplify/ui-react'; \u2192 import { MdNotStarted } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 8H9V16H11V8ZM17 12L12 8V16L17 12Z",
    fill: "currentColor"
  })));
}, "IconNotStarted");
import Pv from "classnames";
var Sv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNoteAdd } from '@aws-amplify/ui-react'; \u2192 import { MdNoteAdd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 11H11V14H8V16H11V19H13V16H16V14H13V11ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z",
    fill: "currentColor"
  })));
}, "IconNoteAdd");
import jv from "classnames";
var Yv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNote } from '@aws-amplify/ui-react'; \u2192 import { MdNote } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 4H4C2.9 4 2 4.9 2 6V18.01C2 19.11 2.9 20 4 20H20C21.1 20 22 19.1 22 18V10L16 4V4ZM4 18.01V6H15V11H20V18.01H4V18.01Z",
    fill: "currentColor"
  })));
}, "IconNote");
import Fv from "classnames";
var Tv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotes } from '@aws-amplify/ui-react'; \u2192 import { MdNotes } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 11.01L3 11V13H21V11.01ZM3 16H15V18H3V16ZM21 6H3V8.01L21 8V6Z",
    fill: "currentColor"
  })));
}, "IconNotes");
import Av from "classnames";
var Ev = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotificationImportant } from '@aws-amplify/ui-react'; \u2192 import { MdNotificationImportant } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Av(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.01 21.01C10.01 22.11 10.9 23 12 23C13.1 23 13.99 22.11 13.99 21.01H10.01ZM12 6C14.76 6 17 8.24 17 11V18H7V11C7 8.24 9.24 6 12 6ZM12 1.5C11.17 1.5 10.5 2.17 10.5 3V4.17C7.36 4.85 5 7.65 5 11V17L3 19V20H21V19L19 17V11C19 7.65 16.64 4.85 13.5 4.17V3C13.5 2.17 12.83 1.5 12 1.5ZM11 8H13V12H11V8ZM11 14H13V16H11V14Z",
    fill: "currentColor"
  })));
}, "IconNotificationImportant");
import Ov from "classnames";

var _v = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotificationsActive } from '@aws-amplify/ui-react'; \u2192 import { MdNotificationsActive } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ov(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.9998 22C13.0998 22 13.9998 21.1 13.9998 20H9.99979C9.99979 21.1 10.8998 22 11.9998 22ZM17.9998 16V11C17.9998 7.93 16.3698 5.36 13.4998 4.68V4C13.4998 3.17 12.8298 2.5 11.9998 2.5C11.1698 2.5 10.4998 3.17 10.4998 4V4.68C7.63979 5.36 5.99979 7.92 5.99979 11V16L3.99979 18V19H19.9998V18L17.9998 16ZM15.9998 17H7.99979V11C7.99979 8.52 9.50979 6.5 11.9998 6.5C14.4898 6.5 15.9998 8.52 15.9998 11V17ZM7.57979 4.08L6.14979 2.65C3.74978 4.48 2.16979 7.3 2.02979 10.5H4.02979C4.17979 7.85 5.53979 5.53 7.57979 4.08V4.08ZM19.9698 10.5H21.9698C21.8198 7.3 20.2398 4.48 17.8498 2.65L16.4298 4.08C18.4498 5.53 19.8198 7.85 19.9698 10.5Z",
    fill: "currentColor"
  })));
}, "IconNotificationsActive");

import Gv from "classnames";
var Uv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotificationsNone } from '@aws-amplify/ui-react'; \u2192 import { MdNotificationsNone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z",
    fill: "currentColor"
  })));
}, "IconNotificationsNone");
import zv from "classnames";
var Xv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotificationsOff } from '@aws-amplify/ui-react'; \u2192 import { MdNotificationsOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM12 6.5C14.49 6.5 16 8.52 16 11V11.1L18 13.1V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C10.26 4.74 10.03 4.83 9.81 4.91L11.45 6.55C11.63 6.53 11.81 6.5 12 6.5V6.5ZM5.41 3.35L4 4.76L6.81 7.57C6.29 8.57 6 9.74 6 11V16L4 18V19H18.24L19.98 20.74L21.39 19.33L5.41 3.35ZM16 17H8V11C8 10.32 8.12 9.68 8.34 9.1L16 16.76V17Z",
    fill: "currentColor"
  })));
}, "IconNotificationsOff");
import Kv from "classnames";
var qv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotificationsPaused } from '@aws-amplify/ui-react'; \u2192 import { MdNotificationsPaused } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.5 9.8H12.3L9.5 13.2V15H14.5V13.2H11.7L14.5 9.8V8H9.5V9.8ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17ZM12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22Z",
    fill: "currentColor"
  })));
}, "IconNotificationsPaused");
import Qv from "classnames";
var Jv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconNotifications } from '@aws-amplify/ui-react'; \u2192 import { MdNotifications } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qv(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z",
    fill: "currentColor"
  })));
}, "IconNotifications");
import $v from "classnames";
var Rv = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOfflineBolt } from '@aws-amplify/ui-react'; \u2192 import { MdOfflineBolt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $v(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2.02002C6.49 2.02002 2.02 6.49002 2.02 12C2.02 17.51 6.49 21.98 12 21.98C17.51 21.98 21.98 17.51 21.98 12C21.98 6.49002 17.51 2.02002 12 2.02002ZM12 19.98C7.6 19.98 4.02 16.4 4.02 12C4.02 7.60002 7.6 4.02002 12 4.02002C16.4 4.02002 19.98 7.60002 19.98 12C19.98 16.4 16.4 19.98 12 19.98ZM12.75 5.00002L8.25 13.5H11.39V19L15.75 10.5H12.75V5.00002Z",
    fill: "currentColor"
  })));
}, "IconOfflineBolt");
import eN from "classnames";
var oN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOfflinePin } from '@aws-amplify/ui-react'; \u2192 import { MdOfflinePin } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM7 15H17V17H7V15ZM10.3 11.2L8.4 9.3L7 10.7L10.3 14L17 7.3L15.6 5.9L10.3 11.2Z",
    fill: "currentColor"
  })));
}, "IconOfflinePin");
import tN from "classnames";
var rN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOndemandVideo } from '@aws-amplify/ui-react'; \u2192 import { MdOndemandVideo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 7V15L16 11L9 7ZM21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z",
    fill: "currentColor"
  })));
}, "IconOndemandVideo");
import iN from "classnames";
var sN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOnlinePrediction } from '@aws-amplify/ui-react'; \u2192 import { MdOnlinePrediction } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 11.5002C15.5 13.5002 13 15.0002 13 16.5002H11C11 15.0002 8.5 13.5002 8.5 11.5002C8.5 9.57018 10.07 8.00018 12 8.00018C13.93 8.00018 15.5 9.57018 15.5 11.5002ZM13 17.5002H11V19.0002H13V17.5002ZM22 12.0002C22 9.24018 20.88 6.74018 19.07 4.93018L18.01 5.99018C19.55 7.53018 20.5 9.66018 20.5 12.0002C20.5 14.3402 19.55 16.4702 18.01 18.0102L19.07 19.0702C20.88 17.2602 22 14.7602 22 12.0002ZM3.5 12.0002C3.5 9.66018 4.45 7.53018 5.99 5.99018L4.93 4.93018C3.12 6.74018 2 9.24018 2 12.0002C2 14.7602 3.12 17.2602 4.93 19.0702L5.99 18.0102C4.45 16.4702 3.5 14.3402 3.5 12.0002ZM17.5 12.0002C17.5 13.5202 16.88 14.8902 15.89 15.8902L16.95 16.9502C18.22 15.6802 19 13.9302 19 12.0002C19 10.0702 18.22 8.32018 16.95 7.05018L15.89 8.11018C16.88 9.11018 17.5 10.4802 17.5 12.0002ZM7.05 16.9502L8.11 15.8902C7.11 14.8902 6.5 13.5202 6.5 12.0002C6.5 10.4802 7.12 9.11018 8.11 8.11018L7.05 7.05018C5.78 8.32018 5 10.0702 5 12.0002C5 13.9302 5.78 15.6802 7.05 16.9502Z",
    fill: "currentColor"
  })));
}, "IconOnlinePrediction");
import aN from "classnames";
var nN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOpacity } from '@aws-amplify/ui-react'; \u2192 import { MdOpacity } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.66 8.0001L12 2.3501L6.34 8.0001C4.78 9.5601 4 11.6401 4 13.6401C4 15.6401 4.78 17.7501 6.34 19.3101C7.9 20.8701 9.95 21.6601 12 21.6601C14.05 21.6601 16.1 20.8701 17.66 19.3101C19.22 17.7501 20 15.6401 20 13.6401C20 11.6401 19.22 9.5601 17.66 8.0001ZM6 14.0001C6.01 12.0001 6.62 10.7301 7.76 9.6001L12 5.2701L16.24 9.6501C17.38 10.7701 17.99 12.0001 18 14.0001H6Z",
    fill: "currentColor"
  })));
}, "IconOpacity");
import mN from "classnames";
var cN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOpenInBrowser } from '@aws-amplify/ui-react'; \u2192 import { MdOpenInBrowser } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H9V18H5V8H19V18H15V20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM12 10L8 14H11V20H13V14H16L12 10Z",
    fill: "currentColor"
  })));
}, "IconOpenInBrowser");
import lN from "classnames";
var pN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOpenInFull } from '@aws-amplify/ui-react'; \u2192 import { MdOpenInFull } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 11V3H13L16.29 6.29L6.29 16.29L3 13V21H11L7.71 17.71L17.71 7.71L21 11Z",
    fill: "currentColor"
  })));
}, "IconOpenInFull");
import hN from "classnames";
var fN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOpenInNew } from '@aws-amplify/ui-react'; \u2192 import { MdOpenInNew } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z",
    fill: "currentColor"
  })));
}, "IconOpenInNew");
import CN from "classnames";
var gN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOpenWith } from '@aws-amplify/ui-react'; \u2192 import { MdOpenWith } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 9H14V6H17L12 1L7 6H10V9ZM9 10H6V7L1 12L6 17V14H9V10ZM23 12L18 7V10H15V14H18V17L23 12ZM14 15H10V18H7L12 23L17 18H14V15Z",
    fill: "currentColor"
  })));
}, "IconOpenWith");
import uN from "classnames";
var wN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOutbond } from '@aws-amplify/ui-react'; \u2192 import { MdOutbond } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.88 11.54L8.92 16.5L7.51 15.09L12.47 10.13L10.34 8L15.99 8.01L16 13.66L13.88 11.54Z",
    fill: "currentColor"
  })));
}, "IconOutbond");
import dN from "classnames";
var VN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOutdoorGrill } from '@aws-amplify/ui-react'; \u2192 import { MdOutdoorGrill } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 22C18.66 22 20 20.66 20 19C20 17.34 18.66 16 17 16C15.7 16 14.6 16.84 14.18 18H9.14L11.13 14.94C11.42 14.98 11.71 15 12 15C12.29 15 12.58 14.98 12.87 14.94L13.89 16.51C14.31 15.98 14.85 15.56 15.49 15.3L14.89 14.37C17.31 13.27 19 10.84 19 8H5C5 10.84 6.69 13.27 9.12 14.37L5.17 20.45C4.87 20.91 5 21.53 5.46 21.83C5.92 22.13 6.54 22 6.84 21.54L7.84 19.99H14.18C14.6 21.16 15.7 22 17 22ZM17 18C17.55 18 18 18.45 18 19C18 19.55 17.55 20 17 20C16.45 20 16 19.55 16 19C16 18.45 16.45 18 17 18ZM7.42 10H16.58C15.81 11.76 14.04 13 12 13C9.96 13 8.19 11.76 7.42 10Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9.41001 7H10.41C10.56 5.85 10.64 5.36 9.52001 4.04C9.10001 3.54 8.84001 3.27 9.06001 2H8.07001C7.86001 3.11 8.10001 4.05 8.96001 4.96C9.18001 5.2 9.75001 5.63 9.41001 7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11.89 7H12.89C13.04 5.85 13.12 5.36 12 4.04C11.58 3.54 11.32 3.26 11.54 2H10.55C10.34 3.11 10.58 4.05 11.44 4.96C11.67 5.2 12.24 5.63 11.89 7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14.41 7H15.41C15.56 5.85 15.64 5.36 14.52 4.04C14.1 3.54 13.84 3.27 14.06 2H13.07C12.86 3.11 13.1 4.05 13.96 4.96C14.18 5.2 14.75 5.63 14.41 7Z",
    fill: "black"
  })));
}, "IconOutdoorGrill");
import HN from "classnames";
var MN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOutlet } from '@aws-amplify/ui-react'; \u2192 import { MdOutlet } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 11V8C10 7.45 9.55 7 9 7C8.45 7 8 7.45 8 8V11C8 11.55 8.45 12 9 12C9.55 12 10 11.55 10 11ZM16 11V8C16 7.45 15.55 7 15 7C14.45 7 14 7.45 14 8V11C14 11.55 14.45 12 15 12C15.55 12 16 11.55 16 11ZM14 16C14 14.9 13.1 14 12 14C10.9 14 10 14.9 10 16V18H14V16Z",
    fill: "currentColor"
  })));
}, "IconOutlet");
import xN from "classnames";
var IN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconOutlinedFlag } from '@aws-amplify/ui-react'; \u2192 import { MdOutlinedFlag } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 6L13 4H5V21H7V14H12L13 16H20V6H14ZM18 14H14L13 12H7V6H12L13 8H18V14Z",
    fill: "currentColor"
  })));
}, "IconOutlinedFlag");
import LN from "classnames";
var vN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPages } from '@aws-amplify/ui-react'; \u2192 import { MdPages } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM13 5H19V11H16L17 7L13 8V5ZM5 5H11V8L7 7L8 11H5V5ZM11 19H5V13H8L7 17L11 16V19ZM19 19H13V16L17 17L16 13H19V19ZM14.63 14.63L12 13.72L9.37 14.63L10.28 12L9.37 9.37L12 10.28L14.63 9.37L13.72 12L14.63 14.63Z",
    fill: "currentColor"
  })));
}, "IconPages");
import NN from "classnames";
var yN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPageview } from '@aws-amplify/ui-react'; \u2192 import { MdPageview } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.49 16C12.37 16 13.19 15.74 13.88 15.3L16.32 17.74L17.74 16.32L15.3 13.89C15.74 13.19 16 12.38 16 11.5C16 9.01 13.99 7 11.5 7C9.01 7 7 9.01 7 11.5C7 13.99 9.01 16 11.49 16ZM11.5 9C12.88 9 14 10.12 14 11.5C14 12.88 12.88 14 11.5 14C10.12 14 9 12.88 9 11.5C9 10.12 10.12 9 11.5 9ZM20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z",
    fill: "currentColor"
  })));
}, "IconPageview");
import bN from "classnames";
var ZN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPalette } from '@aws-amplify/ui-react'; \u2192 import { MdPalette } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.04 22 11C22 14.31 19.31 17 16 17H14.23C13.95 17 13.73 17.22 13.73 17.5C13.73 17.62 13.78 17.73 13.86 17.83C14.27 18.3 14.5 18.89 14.5 19.5C14.5 20.88 13.38 22 12 22V22ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C12.28 20 12.5 19.78 12.5 19.5C12.5 19.34 12.42 19.22 12.36 19.15C11.95 18.69 11.73 18.1 11.73 17.5C11.73 16.12 12.85 15 14.23 15H16C18.21 15 20 13.21 20 11C20 7.14 16.41 4 12 4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M6.5 13C7.32843 13 8 12.3284 8 11.5C8 10.6716 7.32843 10 6.5 10C5.67157 10 5 10.6716 5 11.5C5 12.3284 5.67157 13 6.5 13Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17.5 13C18.3284 13 19 12.3284 19 11.5C19 10.6716 18.3284 10 17.5 10C16.6716 10 16 10.6716 16 11.5C16 12.3284 16.6716 13 17.5 13Z",
    fill: "black"
  })));
}, "IconPalette");
import BN from "classnames";
var WN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPanTool } from '@aws-amplify/ui-react'; \u2192 import { MdPanTool } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 23.9998H11.45C10.37 23.9998 9.31 23.5498 8.56 22.7698L1.26 15.1598L3.33 13.3298C3.95 12.7798 4.86 12.6698 5.59 13.0598L8 14.3398V4.78977C8 3.40977 9.12 2.28977 10.5 2.28977C10.67 2.28977 10.84 2.30977 11.01 2.33977C11.1 1.03977 12.18 0.00976562 13.5 0.00976562C14.36 0.00976562 15.11 0.439766 15.56 1.09977C15.85 0.979766 16.17 0.919766 16.5 0.919766C17.88 0.919766 19 2.03977 19 3.41977V3.69977C19.16 3.66977 19.33 3.64977 19.5 3.64977C20.88 3.64977 22 4.76977 22 6.14977V19.9998C22 22.2098 20.21 23.9998 18 23.9998ZM4.14 15.2798L10 21.3798C10.38 21.7698 10.9 21.9998 11.44 21.9998H18C19.1 21.9998 20 21.0998 20 19.9998V6.14977C20 5.86977 19.78 5.64977 19.5 5.64977C19.22 5.64977 19 5.86977 19 6.14977V11.9998H17V3.41977C17 3.13977 16.78 2.91977 16.5 2.91977C16.22 2.91977 16 3.13977 16 3.41977V11.9998H14V2.50977C14 2.22977 13.78 2.00977 13.5 2.00977C13.22 2.00977 13 2.22977 13 2.50977V11.9998H11V4.78977C11 4.50977 10.78 4.28977 10.5 4.28977C10.22 4.28977 10 4.51977 10 4.78977V17.6598L4.65 14.8298L4.14 15.2798V15.2798Z",
    fill: "currentColor"
  })));
}, "IconPanTool");
import kN from "classnames";
var DN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPanoramaFishEye } from '@aws-amplify/ui-react'; \u2192 import { MdPanoramaFishEye } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconPanoramaFishEye");
import PN from "classnames";
var SN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPanoramaHorizontal } from '@aws-amplify/ui-react'; \u2192 import { MdPanoramaHorizontal } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6.54V17.45C17.4 16.68 14.72 16.29 12 16.29C9.28 16.29 6.6 16.68 4 17.45V6.54C6.6 7.31 9.28 7.7 12 7.7C14.72 7.71 17.4 7.32 20 6.54ZM21.43 4C21.33 4 21.23 4.02 21.12 4.06C18.18 5.16 15.09 5.7 12 5.7C8.91 5.7 5.82 5.15 2.88 4.06C2.77 4.02 2.66 4 2.57 4C2.23 4 2 4.23 2 4.63V19.38C2 19.77 2.23 20 2.57 20C2.67 20 2.77 19.98 2.88 19.94C5.82 18.84 8.91 18.3 12 18.3C15.09 18.3 18.18 18.85 21.12 19.94C21.23 19.98 21.33 20 21.43 20C21.76 20 22 19.77 22 19.37V4.63C22 4.23 21.76 4 21.43 4V4Z",
    fill: "currentColor"
  })));
}, "IconPanoramaHorizontal");
import jN from "classnames";
var YN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPanoramaVertical } from '@aws-amplify/ui-react'; \u2192 import { MdPanoramaVertical } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.94 21.12C18.84 18.18 18.3 15.09 18.3 12C18.3 8.91 18.85 5.82 19.94 2.88C19.98 2.77 20 2.66 20 2.57C20 2.23 19.77 2 19.37 2H4.63C4.23 2 4 2.23 4 2.57C4 2.67 4.02 2.77 4.06 2.88C5.16 5.82 5.71 8.91 5.71 12C5.71 15.09 5.16 18.18 4.07 21.12C4.02 21.23 4 21.34 4 21.43C4 21.76 4.23 22 4.63 22H19.38C19.77 22 20.01 21.76 20.01 21.43C20 21.33 19.98 21.23 19.94 21.12V21.12ZM6.54 20C7.31 17.4 7.7 14.72 7.7 12C7.7 9.28 7.31 6.6 6.54 4H17.45C16.68 6.6 16.29 9.28 16.29 12C16.29 14.72 16.68 17.4 17.45 20H6.54Z",
    fill: "currentColor"
  })));
}, "IconPanoramaVertical");
import FN from "classnames";
var TN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPanoramaWideAngle } from '@aws-amplify/ui-react'; \u2192 import { MdPanoramaWideAngle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C14.45 6 16.71 6.2 19.29 6.64C19.76 8.42 20 10.22 20 12C20 13.78 19.76 15.58 19.29 17.36C16.71 17.8 14.45 18 12 18C9.55 18 7.29 17.8 4.71 17.36C4.24 15.58 4 13.78 4 12C4 10.22 4.24 8.42 4.71 6.64C7.29 6.2 9.55 6 12 6ZM12 4C9.27 4 6.78 4.24 4.05 4.72L3.12 4.88L2.87 5.78C2.29 7.85 2 9.93 2 12C2 14.07 2.29 16.15 2.87 18.22L3.12 19.11L4.05 19.27C6.78 19.76 9.27 20 12 20C14.73 20 17.22 19.76 19.95 19.28L20.88 19.12L21.13 18.23C21.71 16.15 22 14.07 22 12C22 9.93 21.71 7.85 21.13 5.78L20.88 4.89L19.95 4.73C17.22 4.24 14.73 4 12 4Z",
    fill: "currentColor"
  })));
}, "IconPanoramaWideAngle");
import AN from "classnames";
var EN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPanorama } from '@aws-amplify/ui-react'; \u2192 import { MdPanorama } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V6C23 4.9 22.1 4 21 4ZM21 18H3V6H21V18ZM14.5 11L11 15.51L8.5 12.5L5 17H19L14.5 11Z",
    fill: "currentColor"
  })));
}, "IconPanorama");
import ON from "classnames";

var _N = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPartyMode } from '@aws-amplify/ui-react'; \u2192 import { MdPartyMode } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ON(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H16.83L15 2H9L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H8.05L8.64 5.35L9.88 4H14.12L15.36 5.35L15.95 6H20V18ZM9 12C9 10.34 10.34 9 12 9H15.98C15.06 7.79 13.63 7 12 7C9.24 7 7 9.24 7 12C7 12.34 7.04 12.68 7.1 13H9.18C9.07 12.69 9 12.35 9 12ZM15 12C15 13.66 13.66 15 12 15H8.02C8.94 16.21 10.37 17 12 17C14.76 17 17 14.76 17 12C17 11.66 16.97 11.32 16.9 11H14.82C14.93 11.31 15 11.65 15 12V12Z",
    fill: "currentColor"
  })));
}, "IconPartyMode");

import GN from "classnames";
var UN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPauseCircleFilled } from '@aws-amplify/ui-react'; \u2192 import { MdPauseCircleFilled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 16H9V8H11V16ZM15 16H13V8H15V16Z",
    fill: "currentColor"
  })));
}, "IconPauseCircleFilled");
import zN from "classnames";
var XN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPauseCircleOutline } from '@aws-amplify/ui-react'; \u2192 import { MdPauseCircleOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 16H11V8H9V16ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM13 16H15V8H13V16Z",
    fill: "currentColor"
  })));
}, "IconPauseCircleOutline");
import KN from "classnames";
var qN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPausePresentation } from '@aws-amplify/ui-react'; \u2192 import { MdPausePresentation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.85 1 4.95V18.95C1 20.05 1.9 21 3 21H21C22.1 21 23 20.05 23 18.95V4.95C23 3.85 22.1 3 21 3ZM21 19H3V5H21V19ZM9 8H11V16H9V8ZM13 8H15V16H13V8Z",
    fill: "currentColor"
  })));
}, "IconPausePresentation");
import QN from "classnames";
var JN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPause } from '@aws-amplify/ui-react'; \u2192 import { MdPause } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QN(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 19H10V5H6V19ZM14 5V19H18V5H14Z",
    fill: "currentColor"
  })));
}, "IconPause");
import $N from "classnames";
var RN = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPayment } from '@aws-amplify/ui-react'; \u2192 import { MdPayment } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $N(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z",
    fill: "currentColor"
  })));
}, "IconPayment");
import ey from "classnames";
var oy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPayments } from '@aws-amplify/ui-react'; \u2192 import { MdPayments } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ey(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 14V6C19 4.9 18.1 4 17 4H3C1.9 4 1 4.9 1 6V14C1 15.1 1.9 16 3 16H17C18.1 16 19 15.1 19 14ZM17 14H3V6H17V14ZM10 7C8.34 7 7 8.34 7 10C7 11.66 8.34 13 10 13C11.66 13 13 11.66 13 10C13 8.34 11.66 7 10 7ZM23 7V18C23 19.1 22.1 20 21 20H4C4 19 4 19.1 4 18H21V7C22.1 7 22 7 23 7Z",
    fill: "currentColor"
  })));
}, "IconPayments");
import ty from "classnames";
var ry = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPedalBike } from '@aws-amplify/ui-react'; \u2192 import { MdPedalBike } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ty(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.18 10L16.48 5.32C16.19 4.53 15.44 4 14.6 4H12V6H14.6L16.06 10H11.25L10.89 9H12V7H7V9H8.75L10.57 14H9.9C9.46 11.77 7.59 10.12 5.25 10.01C2.45 9.87 0 12.2 0 15C0 17.8 2.2 20 5 20C7.46 20 9.45 18.31 9.9 16H14.1C14.54 18.23 16.41 19.88 18.75 19.99C21.55 20.12 24 17.8 24 14.99C24 12.19 21.8 9.99 19 9.99H18.18V10ZM7.82 16C7.42 17.17 6.33 18 5 18C3.32 18 2 16.68 2 15C2 13.32 3.32 12 5 12C6.33 12 7.42 12.83 7.82 14H5V16H7.82ZM14.1 14H12.7L11.97 12H15C14.56 12.58 14.24 13.25 14.1 14ZM19 18C17.32 18 16 16.68 16 15C16 14.07 16.41 13.27 17.05 12.72L18.01 15.36L19.89 14.68L18.92 12.01C18.95 12.01 18.98 12 19.01 12C20.69 12 22.01 13.32 22.01 15C22.01 16.68 20.68 18 19 18Z",
    fill: "currentColor"
  })));
}, "IconPedalBike");
import iy from "classnames";
var sy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPendingActions } from '@aws-amplify/ui-react'; \u2192 import { MdPendingActions } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 12C14.24 12 12 14.24 12 17C12 19.76 14.24 22 17 22C19.76 22 22 19.76 22 17C22 14.24 19.76 12 17 12ZM18.65 19.35L16.5 17.2V14H17.5V16.79L19.35 18.64L18.65 19.35ZM18 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H6C4.9 3 4 3.9 4 5V20C4 21.1 4.9 22 6 22H12.11C11.52 21.43 11.04 20.75 10.69 20H6V5H8V8H16V5H18V10.08C18.71 10.18 19.38 10.39 20 10.68V5C20 3.9 19.1 3 18 3ZM12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5Z",
    fill: "currentColor"
  })));
}, "IconPendingActions");
import ay from "classnames";
var ny = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPending } from '@aws-amplify/ui-react'; \u2192 import { MdPending } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ay(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7 13.5C7.82843 13.5 8.5 12.8284 8.5 12C8.5 11.1716 7.82843 10.5 7 10.5C6.17157 10.5 5.5 11.1716 5.5 12C5.5 12.8284 6.17157 13.5 7 13.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17 13.5C17.8284 13.5 18.5 12.8284 18.5 12C18.5 11.1716 17.8284 10.5 17 10.5C16.1716 10.5 15.5 11.1716 15.5 12C15.5 12.8284 16.1716 13.5 17 13.5Z",
    fill: "black"
  })));
}, "IconPending");
import my from "classnames";
var cy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPeopleAlt } from '@aws-amplify/ui-react'; \u2192 import { MdPeopleAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: my(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.6699 13.1299C18.0399 14.0599 18.9999 15.3199 18.9999 16.9999V19.9999H22.9999V16.9999C22.9999 14.8199 19.4299 13.5299 16.6699 13.1299Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M14.9999 12C17.2099 12 18.9999 10.21 18.9999 8C18.9999 5.79 17.2099 4 14.9999 4C14.5299 4 14.0899 4.1 13.6699 4.24C14.4999 5.27 14.9999 6.58 14.9999 8C14.9999 9.42 14.4999 10.73 13.6699 11.76C14.0899 11.9 14.5299 12 14.9999 12Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z",
    fill: "black"
  })));
}, "IconPeopleAlt");
import ly from "classnames";
var py = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPeopleOutline } from '@aws-amplify/ui-react'; \u2192 import { MdPeopleOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ly(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81V13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z",
    fill: "currentColor"
  })));
}, "IconPeopleOutline");
import hy from "classnames";
var fy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPeople } from '@aws-amplify/ui-react'; \u2192 import { MdPeople } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81V13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z",
    fill: "currentColor"
  })));
}, "IconPeople");
import Cy from "classnames";
var gy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPermCameraMic } from '@aws-amplify/ui-react'; \u2192 import { MdPermCameraMic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C10.9 6 10 6.9 10 8V12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12V8C14 6.9 13.1 6 12 6ZM20 5H16.83L14.97 3H8.96L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5ZM20 19H13V17.91C15.83 17.43 18 14.97 18 12H16C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12H6C6 14.97 8.17 17.43 11 17.91V19H4V7H8.21L8.8 6.35L10.04 5H14.28L15.52 6.35L16.11 7H20V19Z",
    fill: "currentColor"
  })));
}, "IconPermCameraMic");
import uy from "classnames";
var wy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPermContactCalendar } from '@aws-amplify/ui-react'; \u2192 import { MdPermContactCalendar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.84 4.22C20.79 4.1 20.73 3.99 20.66 3.88C20.52 3.67 20.33 3.48 20.12 3.34C20.01 3.27 19.9 3.21 19.78 3.16C19.54 3.06 19.28 3 19 3H18V1H16V3H8V1H6V3H5C4.58 3 4.2 3.13 3.88 3.34C3.67 3.48 3.48 3.67 3.34 3.88C3.27 3.99 3.21 4.1 3.16 4.22C3.06 4.46 3 4.72 3 5V19C3 20.1 3.89 21 5 21H19C19.28 21 19.54 20.94 19.78 20.84C19.9 20.79 20.01 20.73 20.12 20.66C20.33 20.52 20.52 20.33 20.66 20.12C20.87 19.8 21 19.41 21 19V5C21 4.72 20.94 4.46 20.84 4.22ZM5 19V5H19V19H5ZM12 12.88C9.97 12.88 6 13.96 6 16.46V18H18V16.47C18 13.96 14.03 12.88 12 12.88ZM8.31 16C9 15.44 10.69 14.88 12 14.88C13.31 14.88 15.01 15.44 15.69 16H8.31ZM12 12C13.65 12 15 10.65 15 9C15 7.35 13.65 6 12 6C10.35 6 9 7.35 9 9C9 10.65 10.35 12 12 12ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8Z",
    fill: "currentColor"
  })));
}, "IconPermContactCalendar");
import dy from "classnames";
var Vy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPermDataSetting } from '@aws-amplify/ui-react'; \u2192 import { MdPermDataSetting } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.99 11.57H20V0L0 20H11.56V18H4.83L17.99 4.83V11.57ZM23.77 20.32L22.7 19.49C22.72 19.33 22.74 19.17 22.74 19C22.74 18.83 22.73 18.67 22.7 18.51L23.76 17.68C23.85 17.6 23.88 17.47 23.82 17.36L22.82 15.63C22.76 15.52 22.63 15.48 22.51 15.52L21.27 16.02C21.01 15.82 20.73 15.65 20.42 15.53L20.23 14.21C20.22 14.09 20.11 14 19.99 14H17.99C17.87 14 17.76 14.09 17.74 14.21L17.55 15.53C17.25 15.66 16.96 15.82 16.7 16.02L15.46 15.52C15.35 15.48 15.22 15.52 15.15 15.63L14.15 17.36C14.09 17.47 14.11 17.6 14.21 17.68L15.27 18.51C15.25 18.67 15.24 18.83 15.24 19C15.24 19.17 15.25 19.33 15.27 19.49L14.21 20.32C14.12 20.4 14.09 20.53 14.15 20.64L15.15 22.37C15.21 22.48 15.34 22.52 15.46 22.48L16.7 21.98C16.96 22.18 17.24 22.35 17.55 22.47L17.74 23.79C17.76 23.91 17.86 24 17.99 24H19.99C20.11 24 20.22 23.91 20.24 23.79L20.43 22.47C20.73 22.34 21.02 22.18 21.27 21.98L22.52 22.48C22.63 22.52 22.76 22.48 22.83 22.37L23.83 20.64C23.89 20.53 23.86 20.4 23.77 20.32ZM18.99 20.5C18.16 20.5 17.49 19.83 17.49 19C17.49 18.17 18.16 17.5 18.99 17.5C19.82 17.5 20.49 18.17 20.49 19C20.49 19.83 19.82 20.5 18.99 20.5Z",
    fill: "currentColor"
  })));
}, "IconPermDataSetting");
import Hy from "classnames";
var My = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPermDeviceInformation } from '@aws-amplify/ui-react'; \u2192 import { MdPermDeviceInformation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01V1.01ZM17 21H7V20H17V21ZM17 18H7V6H17V18ZM7 4V3H17V4H7Z",
    fill: "currentColor"
  })));
}, "IconPermDeviceInformation");
import xy from "classnames";
var Iy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPermIdentity } from '@aws-amplify/ui-react'; \u2192 import { MdPermIdentity } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 15C14.7 15 17.8 16.29 18 17V18H6V17.01C6.2 16.29 9.3 15 12 15V15ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4V4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13V13Z",
    fill: "currentColor"
  })));
}, "IconPermIdentity");
import Ly from "classnames";
var vy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPermMedia } from '@aws-amplify/ui-react'; \u2192 import { MdPermMedia } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ly(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 6H0V11H0.01L0 20C0 21.1 0.9 22 2 22H20V20H2V6ZM7 15H21L17.5 10.5L15 13.51L11.5 9L7 15ZM22 4H14L12 2H6C4.9 2 4.01 2.9 4.01 4L4 16C4 17.1 4.9 18 6 18H22C23.1 18 24 17.1 24 16V6C24 4.9 23.1 4 22 4ZM22 16H6V4H11.17L12.58 5.41L13.17 6H22V16Z",
    fill: "currentColor"
  })));
}, "IconPermMedia");
import Ny from "classnames";
var yy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPermPhoneMsg } from '@aws-amplify/ui-react'; \u2192 import { MdPermPhoneMsg } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ny(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.58C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.99 7.59L5.79 8.8C5.38 7.59 5.12 6.32 5.03 5V5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97ZM12 3V13L15 10H21V3H12ZM19 8H14V5H19V8Z",
    fill: "currentColor"
  })));
}, "IconPermPhoneMsg");
import by from "classnames";
var Zy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPermScanWifi } from '@aws-amplify/ui-react'; \u2192 import { MdPermScanWifi } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: by(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 3C6.95 3 3.15 4.85 0 7.23L12 22L24 7.25C20.85 4.87 17.05 3 12 3ZM2.92 7.65C5.8 5.85 8.74 5 12 5C15.25 5 18.18 5.85 21.08 7.67L12 18.83L2.92 7.65ZM11 10H13V16H11V10ZM11 6H13V8H11V6Z",
    fill: "currentColor"
  })));
}, "IconPermScanWifi");
import By from "classnames";
var Wy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonAddAlt_1 } from '@aws-amplify/ui-react'; \u2192 import { MdPersonAddAlt_1 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: By(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12C11.21 12 13 10.21 13 8ZM11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6C10.1 6 11 6.9 11 8ZM1 18V20H17V18C17 15.34 11.67 14 9 14C6.33 14 1 15.34 1 18ZM3 18C3.2 17.29 6.3 16 9 16C11.69 16 14.78 17.28 15 18H3ZM20 15V12H23V10H20V7H18V10H15V12H18V15H20Z",
    fill: "currentColor"
  })));
}, "IconPersonAddAlt_1");
import ky from "classnames";
var Dy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonAddDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdPersonAddDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ky(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_39085)"
  }, e.createElement("path", {
    d: "M15 5.99996C16.1 5.99996 17 6.89996 17 7.99996C17 8.98996 16.27 9.81996 15.33 9.96996L13.02 7.65996C13.19 6.71996 14.01 5.99996 15 5.99996ZM15 3.99996C12.79 3.99996 11 5.78996 11 7.99996C11 8.17996 11.03 8.34996 11.05 8.51996L14.48 11.95C14.65 11.97 14.82 12 15 12C17.21 12 19 10.21 19 7.99996C19 5.78996 17.21 3.99996 15 3.99996ZM16.69 14.16L22.53 20H23V18C23 15.86 19.44 14.5 16.69 14.16ZM13.01 16.13L14.88 18H9C9.08 17.76 9.88 16.99 11.91 16.43L13.01 16.13V16.13ZM1.41 1.70996L0 3.11996L4 7.11996V9.99996H1V12H4V15H6V12H8.88L11.39 14.51C9.19 15.11 7 16.3 7 18V20H16.88L20.88 24L22.29 22.59L1.41 1.70996ZM6 9.99996V9.11996L6.88 9.99996H6Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_39085"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconPersonAddDisabled");
import Py from "classnames";
var Sy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonAdd } from '@aws-amplify/ui-react'; \u2192 import { MdPersonAdd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Py(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM15 6C16.1 6 17 6.9 17 8C17 9.1 16.1 10 15 10C13.9 10 13 9.1 13 8C13 6.9 13.9 6 15 6ZM15 14C12.33 14 7 15.34 7 18V20H23V18C23 15.34 17.67 14 15 14ZM9 18C9.22 17.28 12.31 16 15 16C17.7 16 20.8 17.29 21 18H9ZM6 15V12H9V10H6V7H4V10H1V12H4V15H6Z",
    fill: "currentColor"
  })));
}, "IconPersonAdd");
import jy from "classnames";
var Yy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonOutline } from '@aws-amplify/ui-react'; \u2192 import { MdPersonOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z",
    fill: "currentColor"
  })));
}, "IconPersonOutline");
import Fy from "classnames";
var Ty = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonPinCircle } from '@aws-amplify/ui-react'; \u2192 import { MdPersonPinCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 11C13.33 11 16 11.67 16 13V13.16C15.03 14.28 13.6 15 12 15C10.4 15 8.97 14.28 8 13.16V13C8 11.67 10.67 11 12 11ZM12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z",
    fill: "currentColor"
  })));
}, "IconPersonPinCircle");
import Ay from "classnames";
var Ey = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonPin } from '@aws-amplify/ui-react'; \u2192 import { MdPersonPin } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ay(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 2H5C3.89 2 3 2.9 3 4V18C3 19.1 3.89 20 5 20H9L12 23L15 20H19C20.1 20 21 19.1 21 18V4C21 2.9 20.1 2 19 2ZM19 18H14.17L13.58 18.59L12 20.17L10.41 18.58L9.83 18H5V4H19V18ZM12 11C13.65 11 15 9.65 15 8C15 6.35 13.65 5 12 5C10.35 5 9 6.35 9 8C9 9.65 10.35 11 12 11ZM12 7C12.55 7 13 7.45 13 8C13 8.55 12.55 9 12 9C11.45 9 11 8.55 11 8C11 7.45 11.45 7 12 7ZM18 15.58C18 13.08 14.03 12 12 12C9.97 12 6 13.08 6 15.58V17H18V15.58ZM8.48 15C9.22 14.49 10.71 14 12 14C13.29 14 14.78 14.49 15.52 15H8.48Z",
    fill: "currentColor"
  })));
}, "IconPersonPin");
import Oy from "classnames";

var _y = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonRemoveAlt_1 } from '@aws-amplify/ui-react'; \u2192 import { MdPersonRemoveAlt_1 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Oy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 8C14 5.79 12.21 4 10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12C12.21 12 14 10.21 14 8ZM12 8C12 9.1 11.1 10 10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M2 18V20H18V18C18 15.34 12.67 14 10 14C7.33 14 2 15.34 2 18ZM4 18C4.2 17.29 7.3 16 10 16C12.69 16 15.77 17.28 16 18H4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M23 10H17V12H23V10Z",
    fill: "black"
  })));
}, "IconPersonRemoveAlt_1");

import Gy from "classnames";
var Uy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonRemove } from '@aws-amplify/ui-react'; \u2192 import { MdPersonRemove } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 8C14 5.79 12.21 4 10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12C12.21 12 14 10.21 14 8ZM12 8C12 9.1 11.1 10 10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M2 18V20H18V18C18 15.34 12.67 14 10 14C7.33 14 2 15.34 2 18ZM4 18C4.2 17.29 7.3 16 10 16C12.69 16 15.77 17.28 16 18H4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M23 10H17V12H23V10Z",
    fill: "black"
  })));
}, "IconPersonRemove");
import zy from "classnames";
var Xy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonSearch } from '@aws-amplify/ui-react'; \u2192 import { MdPersonSearch } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 12C12.21 12 14 10.21 14 8C14 5.79 12.21 4 10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12ZM10 6C11.1 6 12 6.9 12 8C12 9.1 11.1 10 10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M4 18C4.22 17.28 7.31 16 10 16C10 15.3 10.13 14.63 10.35 14.01C7.62 13.91 2 15.27 2 18V20H11.54C11.02 19.42 10.61 18.75 10.35 18H4Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19.43 18.02C19.79 17.43 20 16.74 20 16C20 13.79 18.21 12 16 12C13.79 12 12 13.79 12 16C12 18.21 13.79 20 16 20C16.74 20 17.43 19.78 18.02 19.43C18.95 20.36 19.64 21.05 20.59 22L22 20.59C20.5 19.09 21.21 19.79 19.43 18.02ZM16 18C14.9 18 14 17.1 14 16C14 14.9 14.9 14 16 14C17.1 14 18 14.9 18 16C18 17.1 17.1 18 16 18Z",
    fill: "black"
  })));
}, "IconPersonSearch");
import Ky from "classnames";
var qy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPerson } from '@aws-amplify/ui-react'; \u2192 import { MdPerson } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ky(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 16C14.7 16 17.8 17.29 18 18H6C6.23 17.28 9.31 16 12 16ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z",
    fill: "currentColor"
  })));
}, "IconPerson");
import Qy from "classnames";
var Jy = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPersonalVideo } from '@aws-amplify/ui-react'; \u2192 import { MdPersonalVideo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qy(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.89 22.1 3 21 3ZM21 17H3V5H21V17Z",
    fill: "currentColor"
  })));
}, "IconPersonalVideo");
import $y from "classnames";
var Ry = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPestControlRodent } from '@aws-amplify/ui-react'; \u2192 import { MdPestControlRodent } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $y(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 18C17.5523 18 18 17.5523 18 17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M20.86 14.97L19.93 14.13C20.41 10.68 17.06 8.09 13.88 9.31C13.3 9.11 12.66 9 12 9C7.74 9 6.35 12.58 6.11 13.85C4.89 13.47 4 12.35 4 11C4 9.34 5.34 8 7 8H9.5C10.88 8 12 6.88 12 5.5C12 4.12 10.88 3 9.5 3H8C7.45 3 7 3.45 7 4C7 4.55 7.45 5 8 5H9.5C9.78 5 10 5.22 10 5.5C10 5.78 9.78 6 9.5 6H7C4.24 6 2 8.24 2 11C2 13.44 3.76 15.47 6.07 15.91C6.51 18.79 8.99 21 12 21H18.53C21.64 21 23.23 17.11 20.86 14.97ZM18.53 19H12C10.79 19 9.66 18.46 8.89 17.52C8.11 16.57 7.83 15.36 8.09 14.11C8.4 12.63 9.6 11.42 11.08 11.1C11.3 11.05 11.53 11.04 11.75 11.03C11.28 11.74 11 12.58 11 13.5C11 14.74 11.5 15.87 12.32 16.68L13.73 15.27C13.28 14.82 13 14.19 13 13.5C13 12.08 14.2 11 15.5 11C16.88 11 18 12.12 18 13.5C18 13.96 17.87 14.38 17.65 14.75L19.52 16.45C19.83 16.73 20 17.12 20 17.54C20 18.34 19.34 19 18.53 19Z",
    fill: "black"
  })));
}, "IconPestControlRodent");
import eb from "classnames";
var ob = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPestControl } from '@aws-amplify/ui-react'; \u2192 import { MdPestControl } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 14.9998V12.9998H17.93C17.88 12.6098 17.81 12.2298 17.71 11.8598L20.29 10.3698L19.29 8.63977L16.92 9.99977C16.64 9.51977 16.3 9.08977 15.93 8.70977C16.03 8.14977 16.13 7.01977 15.35 5.81977L17 4.16977L15.59 2.75977L13.87 4.47977C12.19 3.58977 10.77 4.14977 10.14 4.47977L8.41 2.75977L7 4.16977L8.65 5.81977C7.87 7.01977 7.97 8.15977 8.07 8.70977C7.7 9.09977 7.36 9.52977 7.08 9.99977L4.71 8.62977L3.71 10.3598L6.29 11.8498C6.19 12.2198 6.12 12.5998 6.07 12.9898H3V14.9898H6.07C6.12 15.3798 6.19 15.7598 6.29 16.1298L3.71 17.6198L4.71 19.3498L7.08 17.9998C8.16 19.8098 9.96 20.9998 12 20.9998C14.04 20.9998 15.84 19.8098 16.92 17.9998L19.29 19.3698L20.29 17.6398L17.71 16.1498C17.81 15.7798 17.88 15.3998 17.93 15.0098H21V14.9998ZM12 5.99977C12.88 5.99977 13.62 6.56977 13.88 7.35977C13.29 7.12977 12.66 6.99977 12 6.99977C11.34 6.99977 10.71 7.12977 10.12 7.35977C10.38 6.56977 11.12 5.99977 12 5.99977ZM12 18.9998C9.79 18.9998 8 16.7598 8 13.9998C8 11.2398 9.79 8.99977 12 8.99977C14.21 8.99977 16 11.2398 16 13.9998C16 16.7598 14.21 18.9998 12 18.9998Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M13 11H11V17H13V11Z",
    fill: "black"
  })));
}, "IconPestControl");
import tb from "classnames";
var rb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPets } from '@aws-amplify/ui-react'; \u2192 import { MdPets } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4.5 12C5.88071 12 7 10.8807 7 9.5C7 8.11929 5.88071 7 4.5 7C3.11929 7 2 8.11929 2 9.5C2 10.8807 3.11929 12 4.5 12Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9 8C10.3807 8 11.5 6.88071 11.5 5.5C11.5 4.11929 10.3807 3 9 3C7.61929 3 6.5 4.11929 6.5 5.5C6.5 6.88071 7.61929 8 9 8Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 8C16.3807 8 17.5 6.88071 17.5 5.5C17.5 4.11929 16.3807 3 15 3C13.6193 3 12.5 4.11929 12.5 5.5C12.5 6.88071 13.6193 8 15 8Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19.5 12C20.8807 12 22 10.8807 22 9.5C22 8.11929 20.8807 7 19.5 7C18.1193 7 17 8.11929 17 9.5C17 10.8807 18.1193 12 19.5 12Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17.34 14.86C16.47 13.84 15.74 12.97 14.86 11.95C14.4 11.41 13.81 10.87 13.11 10.63C13 10.59 12.89 10.56 12.78 10.54C12.53 10.5 12.26 10.5 12 10.5C11.74 10.5 11.47 10.5 11.21 10.55C11.1 10.57 10.99 10.6 10.88 10.64C10.18 10.88 9.60001 11.42 9.13001 11.96C8.26001 12.98 7.53001 13.85 6.65001 14.87C5.34001 16.18 3.73001 17.63 4.03001 19.66C4.32001 20.68 5.05001 21.69 6.36001 21.98C7.09001 22.13 9.42001 21.54 11.9 21.54H12.08C14.56 21.54 16.89 22.12 17.62 21.98C18.93 21.69 19.66 20.67 19.95 19.66C20.26 17.62 18.65 16.17 17.34 14.86V14.86Z",
    fill: "black"
  })));
}, "IconPets");
import ib from "classnames";
var sb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneAndroid } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneAndroid } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ib(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 1H8C6.34 1 5 2.34 5 4V20C5 21.66 6.34 23 8 23H16C17.66 23 19 21.66 19 20V4C19 2.34 17.66 1 16 1ZM17 18H7V4H17V18ZM14 21H10V20H14V21Z",
    fill: "currentColor"
  })));
}, "IconPhoneAndroid");
import ab from "classnames";
var nb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneBluetoothSpeaker } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneBluetoothSpeaker } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ab(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.98 7.58L5.78 8.79C5.38 7.58 5.12 6.32 5.03 5V5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97ZM14.71 9.5L17 7.21V11H17.5L20.35 8.15L18.21 6L20.36 3.85L17.5 1H17V4.79L14.71 2.5L14 3.21L16.79 6L14 8.79L14.71 9.5ZM18 2.91L18.94 3.85L18 4.79V2.91ZM18 7.21L18.94 8.15L18 9.09V7.21Z",
    fill: "currentColor"
  })));
}, "IconPhoneBluetoothSpeaker");
import mb from "classnames";
var cb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneCallback } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneCallback } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 15.5098C18.76 15.5098 17.55 15.3098 16.43 14.9398C16.33 14.8998 16.22 14.8898 16.12 14.8898C15.86 14.8898 15.61 14.9898 15.41 15.1798L13.21 17.3798C10.38 15.9298 8.06 13.6198 6.62 10.7898L8.82 8.58982C9.1 8.30982 9.18 7.91982 9.07 7.56982C8.7 6.44982 8.5 5.24982 8.5 3.99982C8.5 3.44982 8.05 2.99982 7.5 2.99982H4C3.45 2.99982 3 3.44982 3 3.99982C3 13.3898 10.61 20.9998 20 20.9998C20.55 20.9998 21 20.5498 21 19.9998V16.5098C21 15.9598 20.55 15.5098 20 15.5098V15.5098ZM5.03 4.99982H6.53C6.6 5.88982 6.75 6.75982 6.99 7.58982L5.79 8.78982C5.38 7.58982 5.12 6.31982 5.03 4.99982V4.99982ZM19 18.9698C17.68 18.8798 16.41 18.6198 15.2 18.2198L16.39 17.0298C17.24 17.2698 18.11 17.4198 18.99 17.4798V18.9698H19ZM18 8.99982H15.41L20.43 3.97982L19.02 2.56982L14 7.58982V4.99982H12V10.9998H18V8.99982Z",
    fill: "currentColor"
  })));
}, "IconPhoneCallback");
import lb from "classnames";
var pb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.34 14.5401L15.91 13.1101C16.47 12.3801 16.96 11.6101 17.38 10.7901L15.18 8.59006C14.9 8.31006 14.82 7.92006 14.93 7.57006C15.3 6.45006 15.5 5.25006 15.5 4.00006C15.5 3.45006 15.95 3.00006 16.5 3.00006H20C20.55 3.00006 21 3.45006 21 4.00006C21 7.98006 19.63 11.6401 17.34 14.5401ZM14.52 17.3501C11.63 19.6401 7.97001 21.0001 4.00001 21.0001C3.45001 21.0001 3.00001 20.5501 3.00001 20.0001V16.5101C3.00001 15.9601 3.45001 15.5101 4.00001 15.5101C5.24001 15.5101 6.45001 15.3101 7.57001 14.9401C7.67001 14.9001 7.78001 14.8901 7.88001 14.8901C8.14001 14.8901 8.39001 14.9901 8.59001 15.1801L10.79 17.3801C11.6 16.9601 12.37 16.4801 13.09 15.9201L1.39001 4.22006L2.81001 2.81006L21.19 21.2001L19.78 22.6101L14.52 17.3501ZM7.60001 17.0201C6.75001 17.2601 5.88001 17.4101 5.00001 17.4701V18.9601C6.32001 18.8701 7.59001 18.6101 8.80001 18.2101L7.60001 17.0201ZM17.46 5.00006C17.4 5.89006 17.25 6.76006 17.01 7.59006L18.21 8.79006C18.62 7.59006 18.88 6.32006 18.97 5.00006H17.46V5.00006Z",
    fill: "currentColor"
  })));
}, "IconPhoneDisabled");
import hb from "classnames";
var fb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneEnabled } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneEnabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.46 5C17.4 5.89 17.25 6.76 17.01 7.59L18.21 8.79C18.62 7.59 18.88 6.32 18.97 5H17.46V5ZM7.6 17.02C6.75 17.26 5.88 17.41 5 17.47V18.96C6.32 18.87 7.59 18.61 8.8 18.21L7.6 17.02ZM16.5 3H20C20.55 3 21 3.45 21 4C21 13.39 13.39 21 4 21C3.45 21 3 20.55 3 20V16.51C3 15.96 3.45 15.51 4 15.51C5.24 15.51 6.45 15.31 7.57 14.94C7.67 14.9 7.78 14.89 7.88 14.89C8.14 14.89 8.39 14.99 8.59 15.18L10.79 17.38C13.62 15.93 15.94 13.62 17.38 10.79L15.18 8.59C14.9 8.31 14.82 7.92 14.93 7.57C15.3 6.45 15.5 5.25 15.5 4C15.5 3.45 15.95 3 16.5 3Z",
    fill: "currentColor"
  })));
}, "IconPhoneEnabled");
import Cb from "classnames";
var gb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneForwarded } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneForwarded } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.98 7.58L5.78 8.79C5.38 7.58 5.12 6.32 5.03 5V5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97ZM18 11L23 6L18 1V4H14V8H18V11Z",
    fill: "currentColor"
  })));
}, "IconPhoneForwarded");
import ub from "classnames";
var wb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneInTalk } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneInTalk } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ub(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 12H17C17 9.24 14.76 7 12 7V9C13.66 9 15 10.34 15 12ZM19 12H21C21 7.03 16.97 3 12 3V5C15.87 5 19 8.13 19 12ZM20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.98 7.58L5.78 8.79C5.38 7.58 5.12 6.32 5.03 5V5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97Z",
    fill: "currentColor"
  })));
}, "IconPhoneInTalk");
import db from "classnames";
var Vb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneIphone } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneIphone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: db(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 1H7.5C6.12 1 5 2.12 5 3.5V20.5C5 21.88 6.12 23 7.5 23H15.5C16.88 23 18 21.88 18 20.5V3.5C18 2.12 16.88 1 15.5 1ZM11.5 22C10.67 22 10 21.33 10 20.5C10 19.67 10.67 19 11.5 19C12.33 19 13 19.67 13 20.5C13 21.33 12.33 22 11.5 22ZM16 18H7V4H16V18Z",
    fill: "currentColor"
  })));
}, "IconPhoneIphone");
import Hb from "classnames";
var Mb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneLocked } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneLocked } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.98 7.58L5.78 8.79C5.38 7.58 5.12 6.32 5.03 5V5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97ZM20 4V3.5C20 2.12 18.88 1 17.5 1C16.12 1 15 2.12 15 3.5V4C14.45 4 14 4.45 14 5V9C14 9.55 14.45 10 15 10H20C20.55 10 21 9.55 21 9V5C21 4.45 20.55 4 20 4ZM19 4H16V3.5C16 2.67 16.67 2 17.5 2C18.33 2 19 2.67 19 3.5V4Z",
    fill: "currentColor"
  })));
}, "IconPhoneLocked");
import xb from "classnames";
var Ib = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoneMissed } from '@aws-amplify/ui-react'; \u2192 import { MdPhoneMissed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_41475)"
  }, e.createElement("path", {
    d: "M23.71 16.6699C20.66 13.7799 16.54 11.9999 12 11.9999C7.46 11.9999 3.34 13.7799 0.29 16.6699C0.11 16.8499 0 17.0999 0 17.3799C0 17.6599 0.11 17.9099 0.29 18.0899L2.77 20.5699C2.95 20.7499 3.2 20.8599 3.48 20.8599C3.75 20.8599 4 20.7499 4.18 20.5799C4.97 19.8399 5.87 19.2199 6.84 18.7299C7.17 18.5699 7.4 18.2299 7.4 17.8299V14.7299C8.85 14.2499 10.4 13.9999 12 13.9999C13.6 13.9999 15.15 14.2499 16.6 14.7199V17.8199C16.6 18.2099 16.83 18.5599 17.16 18.7199C18.14 19.2099 19.03 19.8399 19.83 20.5699C20.01 20.7499 20.26 20.8499 20.53 20.8499C20.81 20.8499 21.06 20.7399 21.24 20.5599L23.72 18.0799C23.9 17.8999 24.01 17.6499 24.01 17.3699C24.01 17.0899 23.89 16.8499 23.71 16.6699V16.6699ZM5.4 17.2299C4.74 17.5999 4.11 18.0299 3.53 18.4999L2.46 17.4299C3.37 16.6799 4.36 16.0399 5.41 15.5299V17.2299H5.4ZM20.48 18.4899C19.88 18.0099 19.26 17.5899 18.6 17.2199V15.5199C19.65 16.0299 20.63 16.6699 21.55 17.4199L20.48 18.4899ZM7 6.42988L11.94 11.3699L19.01 4.29988L17.6 2.87988L11.94 8.53988L8.4 4.99988H11V2.99988H5V8.99988H7V6.42988Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_41475"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconPhoneMissed");
import Lb from "classnames";
var vb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhonePaused } from '@aws-amplify/ui-react'; \u2192 import { MdPhonePaused } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.54 5C6.6 5.88 6.75 6.75 6.98 7.58L5.78 8.79C5.38 7.58 5.12 6.32 5.03 5H6.54V5ZM16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.96C17.68 18.87 16.4 18.61 15.2 18.2L16.4 17.01V17.01ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.78L8.82 8.57C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3ZM15 3H17V10H15V3ZM19 3H21V10H19V3Z",
    fill: "currentColor"
  })));
}, "IconPhonePaused");
import Nb from "classnames";
var yb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhone } from '@aws-amplify/ui-react'; \u2192 import { MdPhone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.54 5C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5H6.54V5ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02V17.02ZM7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3Z",
    fill: "currentColor"
  })));
}, "IconPhone");
import bb from "classnames";
var Zb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhonelinkErase } from '@aws-amplify/ui-react'; \u2192 import { MdPhonelinkErase } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 8.2L12 7.2L8 11.2L4 7.2L3 8.2L7 12.2L3 16.2L4 17.2L8 13.2L12 17.2L13 16.2L9 12.2L13 8.2ZM19 1H9C7.9 1 7 1.9 7 3V6H9V4H19V20H9V18H7V21C7 22.1 7.9 23 9 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1Z",
    fill: "currentColor"
  })));
}, "IconPhonelinkErase");
import Bb from "classnames";
var Wb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhonelinkLock } from '@aws-amplify/ui-react'; \u2192 import { MdPhonelinkLock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 1H9C7.9 1 7 1.9 7 3V6H9V4H19V20H9V18H7V21C7 22.1 7.9 23 9 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1ZM10.8 11V9.5C10.8 8.1 9.4 7 8 7C6.6 7 5.2 8.1 5.2 9.5V11C4.6 11 4 11.6 4 12.2V15.7C4 16.4 4.6 17 5.2 17H10.7C11.4 17 12 16.4 12 15.8V12.3C12 11.6 11.4 11 10.8 11ZM9.5 11H6.5V9.5C6.5 8.7 7.2 8.2 8 8.2C8.8 8.2 9.5 8.7 9.5 9.5V11Z",
    fill: "currentColor"
  })));
}, "IconPhonelinkLock");
import kb from "classnames";
var Db = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhonelinkOff } from '@aws-amplify/ui-react'; \u2192 import { MdPhonelinkOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 5.99977V3.99977H7.39L9.39 5.99977H22ZM24 18.9998V8.99977C24 8.44977 23.55 7.99977 23 7.99977H17C16.45 7.99977 16 8.44977 16 8.99977V12.6098L18 14.6098V9.99977H22V16.9998H20.39L23.32 19.9298C23.71 19.7998 24 19.4398 24 18.9998ZM2.06 1.50977L0.65 2.91977L2.47 4.73977C2.18 5.07977 2 5.51977 2 5.99977V16.9998H0V19.9998H17.73L20.08 22.3498L21.49 20.9398L2.06 1.50977ZM4 16.9998V6.26977L14.73 16.9998H4Z",
    fill: "currentColor"
  })));
}, "IconPhonelinkOff");
import Pb from "classnames";
var Sb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhonelinkRing } from '@aws-amplify/ui-react'; \u2192 import { MdPhonelinkRing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.1 7.7L19.1 8.7C20.9 10.5 20.9 13.3 19.1 15.2L20.1 16.2C22.6 13.9 22.6 10.1 20.1 7.7V7.7ZM18 9.8L17 10.8C17.5 11.5 17.5 12.4 17 13.1L18 14.1C19.2 12.9 19.2 11.1 18 9.8ZM14 1H4C2.9 1 2 1.9 2 3V21C2 22.1 2.9 23 4 23H14C15.1 23 16 22.1 16 21V3C16 1.9 15.1 1 14 1ZM14 20H4V4H14V20Z",
    fill: "currentColor"
  })));
}, "IconPhonelinkRing");
import jb from "classnames";
var Yb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhonelinkSetup } from '@aws-amplify/ui-react'; \u2192 import { MdPhonelinkSetup } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.99997 3V6H8.99997V4H19V20H8.99997V18H6.99997V21C6.99997 22.1 7.89997 23 8.99997 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1H8.99997C7.89997 1 6.99997 1.9 6.99997 3ZM9.49997 15.5C9.78997 15.38 10.05 15.21 10.3 15.02L10.28 15.05L11.29 15.44C11.52 15.53 11.78 15.44 11.9 15.22L12.74 13.76C12.86 13.55 12.81 13.27 12.62 13.12L11.77 12.44L11.75 12.47C11.77 12.31 11.8 12.15 11.8 11.99C11.8 11.83 11.77 11.67 11.75 11.51L11.77 11.54L12.62 10.86C12.81 10.71 12.86 10.43 12.74 10.22L11.9 8.76C11.78 8.55 11.52 8.45 11.29 8.54L10.28 8.93L10.3 8.96C10.05 8.79 9.78997 8.62 9.49997 8.5L9.32997 7.42C9.29997 7.18 9.08997 7 8.83997 7H7.15997C6.90997 7 6.69997 7.18 6.66997 7.42L6.49997 8.5C6.20997 8.62 5.94997 8.79 5.69997 8.98L5.71997 8.95L4.69997 8.56C4.46997 8.47 4.20997 8.56 4.08997 8.78L3.24997 10.24C3.12997 10.45 3.17997 10.73 3.36997 10.88L4.21997 11.56L4.23997 11.53C4.21997 11.68 4.18997 11.84 4.18997 12C4.18997 12.16 4.21997 12.32 4.23997 12.48L4.21997 12.45L3.36997 13.13C3.17997 13.28 3.12997 13.56 3.24997 13.77L4.08997 15.23C4.20997 15.44 4.46997 15.54 4.69997 15.45L5.70997 15.06L5.69997 15.02C5.94997 15.21 6.20997 15.38 6.49997 15.5L6.66997 16.57C6.69997 16.82 6.90997 17 7.15997 17H8.83997C9.08997 17 9.29997 16.82 9.32997 16.58L9.49997 15.5V15.5ZM5.99997 12C5.99997 10.9 6.89997 10 7.99997 10C9.09997 10 9.99997 10.9 9.99997 12C9.99997 13.1 9.09997 14 7.99997 14C6.89997 14 5.99997 13.1 5.99997 12Z",
    fill: "currentColor"
  })));
}, "IconPhonelinkSetup");
import Fb from "classnames";
var Tb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhonelink } from '@aws-amplify/ui-react'; \u2192 import { MdPhonelink } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H22V4H4C2.9 4 2 4.9 2 6V17H0V20H14V17H4V6ZM23 8H17C16.45 8 16 8.45 16 9V19C16 19.55 16.45 20 17 20H23C23.55 20 24 19.55 24 19V9C24 8.45 23.55 8 23 8ZM22 17H18V10H22V17Z",
    fill: "currentColor"
  })));
}, "IconPhonelink");
import Ab from "classnames";
var Eb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhotoAlbum } from '@aws-amplify/ui-react'; \u2192 import { MdPhotoAlbum } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ab(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM11 4V9L10 8.25L9 9V4H11ZM18 20H6V4H7V13L10 10.75L13 13V4H18V20ZM11.28 17.96L9.5 15.81L7 19H17L13.78 14.74L11.28 17.96Z",
    fill: "currentColor"
  })));
}, "IconPhotoAlbum");
import Ob from "classnames";

var _b = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhotoCamera } from '@aws-amplify/ui-react'; \u2192 import { MdPhotoCamera } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ob(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.12 4L15.95 6H20V18H4V6H8.05L9.88 4H14.12V4ZM15 2H9L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H16.83L15 2ZM12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7Z",
    fill: "currentColor"
  })));
}, "IconPhotoCamera");

import Gb from "classnames";
var Ub = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhotoFilter } from '@aws-amplify/ui-react'; \u2192 import { MdPhotoFilter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 10V19H4.98V5H13.98V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V10H19ZM16.06 7.94L17 10L17.94 7.94L20 7L17.94 6.06L17 4L16.06 6.06L14 7L16.06 7.94ZM12 8L10.75 10.75L8 12L10.75 13.25L12 16L13.25 13.25L16 12L13.25 10.75L12 8Z",
    fill: "currentColor"
  })));
}, "IconPhotoFilter");
import zb from "classnames";
var Xb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhotoLibrary } from '@aws-amplify/ui-react'; \u2192 import { MdPhotoLibrary } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 11.67L13.19 13.93L15.67 10.83L19 15H9L11.5 11.67ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z",
    fill: "currentColor"
  })));
}, "IconPhotoLibrary");
import Kb from "classnames";
var qb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhotoSizeSelectActual } from '@aws-amplify/ui-react'; \u2192 import { MdPhotoSizeSelectActual } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C2 3 1 4 1 5V19C1 20.1 1.9 21 3 21H21C22 21 23 20 23 19V5C23 4 22 3 21 3ZM21 18.92C20.98 18.95 20.94 18.98 20.92 19H3V5.08L3.08 5H20.91C20.94 5.02 20.97 5.06 20.99 5.08V18.92H21ZM11 15.51L8.5 12.5L5 17H19L14.5 11L11 15.51Z",
    fill: "currentColor"
  })));
}, "IconPhotoSizeSelectActual");
import Qb from "classnames";
var Jb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhotoSizeSelectLarge } from '@aws-amplify/ui-react'; \u2192 import { MdPhotoSizeSelectLarge } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qb(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 15H23V17H21V15ZM21 11H23V13H21V11ZM23 19H21V21C22 21 23 20 23 19ZM13 3H15V5H13V3ZM21 7H23V9H21V7ZM21 3V5H23C23 4 22 3 21 3ZM1 7H3V9H1V7ZM17 3H19V5H17V3ZM17 19H19V21H17V19ZM3 3C2 3 1 4 1 5H3V3ZM9 3H11V5H9V3ZM5 3H7V5H5V3ZM1 11V19C1 20.1 1.9 21 3 21H15V11H1ZM3 19L5.5 15.79L7.29 17.94L9.79 14.72L13 19H3Z",
    fill: "currentColor"
  })));
}, "IconPhotoSizeSelectLarge");
import $b from "classnames";
var Rb = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhotoSizeSelectSmall } from '@aws-amplify/ui-react'; \u2192 import { MdPhotoSizeSelectSmall } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $b(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23 15H21V17H23V15ZM23 11H21V13H23V11ZM23 19H21V21C22 21 23 20 23 19ZM15 3H13V5H15V3ZM23 7H21V9H23V7ZM21 3V5H23C23 4 22 3 21 3ZM3 21H11V15H1V19C1 20.1 1.9 21 3 21ZM3 7H1V9H3V7ZM15 19H13V21H15V19ZM19 3H17V5H19V3ZM19 19H17V21H19V19ZM3 3C2 3 1 4 1 5H3V3ZM3 11H1V13H3V11ZM11 3H9V5H11V3ZM7 3H5V5H7V3Z",
    fill: "currentColor"
  })));
}, "IconPhotoSizeSelectSmall");
import eZ from "classnames";
var oZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPhoto } from '@aws-amplify/ui-react'; \u2192 import { MdPhoto } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM14.14 11.86L11.14 15.73L9 13.14L6 17H18L14.14 11.86Z",
    fill: "currentColor"
  })));
}, "IconPhoto");
import tZ from "classnames";
var rZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPictureAsPdf } from '@aws-amplify/ui-react'; \u2192 import { MdPictureAsPdf } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM16 12V9C16 8.45 15.55 8 15 8H13V13H15C15.55 13 16 12.55 16 12ZM14 9H15V12H14V9ZM18 11H19V10H18V9H19V8H17V13H18V11ZM10 11H11C11.55 11 12 10.55 12 10V9C12 8.45 11.55 8 11 8H9V13H10V11ZM10 9H11V10H10V9Z",
    fill: "currentColor"
  })));
}, "IconPictureAsPdf");
import iZ from "classnames";
var sZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPictureInPictureAlt } from '@aws-amplify/ui-react'; \u2192 import { MdPictureInPictureAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 11H11V17H19V11ZM17 15H13V13H17V15ZM21 3H3C1.9 3 1 3.88 1 4.98V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V4.98C23 3.88 22.1 3 21 3ZM21 19.02H3V4.97H21V19.02Z",
    fill: "currentColor"
  })));
}, "IconPictureInPictureAlt");
import aZ from "classnames";
var nZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPictureInPicture } from '@aws-amplify/ui-react'; \u2192 import { MdPictureInPicture } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 7H11V13H19V7ZM17 11H13V9H17V11ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 20.98 3 20.98H21C22.1 20.98 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.98H21V19.01V19.01Z",
    fill: "currentColor"
  })));
}, "IconPictureInPicture");
import mZ from "classnames";
var cZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPieChartOutline } from '@aws-amplify/ui-react'; \u2192 import { MdPieChartOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM13 4.07C16.61 4.52 19.48 7.4 19.93 11H13V4.07ZM4 12C4 7.94 7.07 4.56 11 4.07V19.94C7.07 19.44 4 16.06 4 12V12ZM13 19.93V13H19.93C19.48 16.61 16.61 19.48 13 19.93Z",
    fill: "currentColor"
  })));
}, "IconPieChartOutline");
import lZ from "classnames";
var pZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPieChart } from '@aws-amplify/ui-react'; \u2192 import { MdPieChart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM19.93 11H13V4.07C16.61 4.52 19.48 7.39 19.93 11ZM4 12C4 7.93 7.06 4.56 11 4.07V19.93C7.06 19.44 4 16.07 4 12ZM13 19.93V13H19.93C19.48 16.61 16.61 19.48 13 19.93Z",
    fill: "currentColor"
  })));
}, "IconPieChart");
import hZ from "classnames";
var fZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPinDrop } from '@aws-amplify/ui-react'; \u2192 import { MdPinDrop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 4C13.93 4 17 5.4 17 9.15C17 11.31 15.28 13.82 12 16.47C8.72 13.82 7 11.3 7 9.15C7 5.4 10.07 4 12 4ZM12 2C8.73 2 5 4.46 5 9.15C5 12.27 7.33 15.56 12 19C16.67 15.56 19 12.27 19 9.15C19 4.46 15.27 2 12 2Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 7C10.9 7 10 7.9 10 9C10 10.1 10.9 11 12 11C12.5304 11 13.0391 10.7893 13.4142 10.4142C13.7893 10.0391 14 9.53043 14 9C14 8.46957 13.7893 7.96086 13.4142 7.58579C13.0391 7.21071 12.5304 7 12 7V7ZM5 20H19V22H5V20Z",
    fill: "black"
  })));
}, "IconPinDrop");
import CZ from "classnames";
var gZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlace } from '@aws-amplify/ui-react'; \u2192 import { MdPlace } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 12C10.9 12 10 11.1 10 10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 11.1 13.1 12 12 12ZM18 10.2C18 6.57 15.35 4 12 4C8.65 4 6 6.57 6 10.2C6 12.54 7.95 15.64 12 19.34C16.05 15.64 18 12.54 18 10.2ZM12 2C16.2 2 20 5.22 20 10.2C20 13.52 17.33 17.45 12 22C6.67 17.45 4 13.52 4 10.2C4 5.22 7.8 2 12 2Z",
    fill: "currentColor"
  })));
}, "IconPlace");
import uZ from "classnames";
var wZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlagiarism } from '@aws-amplify/ui-react'; \u2192 import { MdPlagiarism } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9.03 11.0299C7.66 12.3999 7.66 14.6099 9.03 15.9799C10.15 17.0999 11.83 17.2899 13.16 16.5699L15.04 18.4499L16.45 17.0399L14.57 15.1599C15.28 13.8299 15.1 12.1499 13.98 11.0299C12.61 9.65994 10.39 9.65994 9.03 11.0299ZM12.56 14.5599C11.97 15.1499 11.02 15.1499 10.44 14.5599C9.85 13.9699 9.85 13.0199 10.44 12.4399C11.03 11.8499 11.98 11.8499 12.56 12.4399C13.15 13.0299 13.15 13.9699 12.56 14.5599Z",
    fill: "black"
  })));
}, "IconPlagiarism");
import dZ from "classnames";
var VZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlayArrow } from '@aws-amplify/ui-react'; \u2192 import { MdPlayArrow } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 8.64L15.27 12L10 15.36V8.64ZM8 5V19L19 12L8 5Z",
    fill: "currentColor"
  })));
}, "IconPlayArrow");
import HZ from "classnames";
var MZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlayCircleFilled } from '@aws-amplify/ui-react'; \u2192 import { MdPlayCircleFilled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 16.5V7.5L16 12L10 16.5Z",
    fill: "currentColor"
  })));
}, "IconPlayCircleFilled");
import xZ from "classnames";
var IZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlayCircleOutline } from '@aws-amplify/ui-react'; \u2192 import { MdPlayCircleOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 16.5L16 12L10 7.5V16.5ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconPlayCircleOutline");
import LZ from "classnames";
var vZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlayForWork } from '@aws-amplify/ui-react'; \u2192 import { MdPlayForWork } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 5V10.59H7.5L12 15.09L16.5 10.59H13V5H11ZM6 14C6 17.31 8.69 20 12 20C15.31 20 18 17.31 18 14H16C16 16.21 14.21 18 12 18C9.79 18 8 16.21 8 14H6Z",
    fill: "currentColor"
  })));
}, "IconPlayForWork");
import NZ from "classnames";
var yZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlaylistAddCheck } from '@aws-amplify/ui-react'; \u2192 import { MdPlaylistAddCheck } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 10H2V12H14V10ZM14 6H2V8H14V6ZM2 16H10V14H2V16ZM21.5 11.5L23 13L16.01 20L11.5 15.5L13 14L16.01 17L21.5 11.5Z",
    fill: "currentColor"
  })));
}, "IconPlaylistAddCheck");
import bZ from "classnames";
var ZZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlaylistAdd } from '@aws-amplify/ui-react'; \u2192 import { MdPlaylistAdd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 10H2V12H14V10ZM14 6H2V8H14V6ZM18 14V10H16V14H12V16H16V20H18V16H22V14H18ZM2 16H10V14H2V16Z",
    fill: "currentColor"
  })));
}, "IconPlaylistAdd");
import BZ from "classnames";
var WZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlaylistPlay } from '@aws-amplify/ui-react'; \u2192 import { MdPlaylistPlay } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 10H16V12H4V10ZM4 6H16V8H4V6ZM4 14H12V16H4V14ZM14 14V20L19 17L14 14Z",
    fill: "currentColor"
  })));
}, "IconPlaylistPlay");
import kZ from "classnames";
var DZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlumbing } from '@aws-amplify/ui-react'; \u2192 import { MdPlumbing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.28 4.9301L17.16 2.8101C16.38 2.0301 15.11 2.0301 14.33 2.8101L11.5 5.6401L13.62 7.7601L15.74 5.6401L19.28 9.1801C20.45 8.0001 20.45 6.1001 19.28 4.9301Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M5.49035 13.7699C6.08035 14.3599 7.03035 14.3599 7.61035 13.7699L10.0804 11.2999L7.96035 9.16992L5.49035 11.6399C4.90035 12.2299 4.90035 13.1799 5.49035 13.7699Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15.0402 7.76009L14.3302 8.47009L13.6202 9.18009L10.4402 6.00009C9.85021 5.40009 8.90021 5.40009 8.32021 5.99009C7.73021 6.58009 7.73021 7.53009 8.32021 8.11009L11.5002 11.2901L10.7902 12.0001L4.43021 18.3601C3.65021 19.1401 3.65021 20.4101 4.43021 21.1901C5.21021 21.9701 6.48022 21.9701 7.26022 21.1901L16.4502 12.0001C16.8402 12.3901 17.4702 12.3901 17.8602 12.0001C18.2502 11.6101 18.2502 10.9801 17.8602 10.5901L15.0402 7.76009Z",
    fill: "black"
  })));
}, "IconPlumbing");
import PZ from "classnames";
var SZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPlusOne } from '@aws-amplify/ui-react'; \u2192 import { MdPlusOne } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 8H8V12H4V14H8V18H10V14H14V12H10V8ZM14.5 6.08V7.9L17 7.4V18H19V5L14.5 6.08Z",
    fill: "currentColor"
  })));
}, "IconPlusOne");
import jZ from "classnames";
var YZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPointOfSale } from '@aws-amplify/ui-react'; \u2192 import { MdPointOfSale } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 2H7C5.9 2 5 2.9 5 4V6C5 7.1 5.9 8 7 8H17C18.1 8 19 7.1 19 6V4C19 2.9 18.1 2 17 2ZM17 6H7V4H17V6ZM20 22H4C2.9 22 2 21.1 2 20V19H22V20C22 21.1 21.1 22 20 22ZM18.53 10.19C18.21 9.47 17.49 9 16.7 9H7.3C6.51 9 5.79 9.47 5.47 10.19L2 18H22L18.53 10.19ZM9.5 16H8.5C8.22 16 8 15.78 8 15.5C8 15.22 8.22 15 8.5 15H9.5C9.78 15 10 15.22 10 15.5C10 15.78 9.78 16 9.5 16ZM9.5 14H8.5C8.22 14 8 13.78 8 13.5C8 13.22 8.22 13 8.5 13H9.5C9.78 13 10 13.22 10 13.5C10 13.78 9.78 14 9.5 14ZM9.5 12H8.5C8.22 12 8 11.78 8 11.5C8 11.22 8.22 11 8.5 11H9.5C9.78 11 10 11.22 10 11.5C10 11.78 9.78 12 9.5 12ZM12.5 16H11.5C11.22 16 11 15.78 11 15.5C11 15.22 11.22 15 11.5 15H12.5C12.78 15 13 15.22 13 15.5C13 15.78 12.78 16 12.5 16ZM12.5 14H11.5C11.22 14 11 13.78 11 13.5C11 13.22 11.22 13 11.5 13H12.5C12.78 13 13 13.22 13 13.5C13 13.78 12.78 14 12.5 14ZM12.5 12H11.5C11.22 12 11 11.78 11 11.5C11 11.22 11.22 11 11.5 11H12.5C12.78 11 13 11.22 13 11.5C13 11.78 12.78 12 12.5 12ZM15.5 16H14.5C14.22 16 14 15.78 14 15.5C14 15.22 14.22 15 14.5 15H15.5C15.78 15 16 15.22 16 15.5C16 15.78 15.78 16 15.5 16ZM15.5 14H14.5C14.22 14 14 13.78 14 13.5C14 13.22 14.22 13 14.5 13H15.5C15.78 13 16 13.22 16 13.5C16 13.78 15.78 14 15.5 14ZM15.5 12H14.5C14.22 12 14 11.78 14 11.5C14 11.22 14.22 11 14.5 11H15.5C15.78 11 16 11.22 16 11.5C16 11.78 15.78 12 15.5 12Z",
    fill: "currentColor"
  })));
}, "IconPointOfSale");
import FZ from "classnames";
var TZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPolicy } from '@aws-amplify/ui-react'; \u2192 import { MdPolicy } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM19 11C19 12.85 18.49 14.65 17.62 16.21L16.17 14.76C17.46 12.82 17.24 10.18 15.53 8.47C13.58 6.52 10.41 6.52 8.46 8.47C6.51 10.42 6.51 13.59 8.46 15.54C10.17 17.25 12.81 17.46 14.75 16.18L16.47 17.9C15.28 19.32 13.74 20.41 12 20.94C7.98 19.69 5 15.52 5 11V6.3L12 3.19L19 6.3V11ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z",
    fill: "currentColor"
  })));
}, "IconPolicy");
import AZ from "classnames";
var EZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPoll } from '@aws-amplify/ui-react'; \u2192 import { MdPoll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z",
    fill: "currentColor"
  })));
}, "IconPoll");
import OZ from "classnames";

var _Z = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPolymer } from '@aws-amplify/ui-react'; \u2192 import { MdPolymer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 4H15L7.11 16.63L4.5 12L9 4H5L0.5 12L5 20H9L16.89 7.37L19.5 12L15 20H19L23.5 12L19 4Z",
    fill: "currentColor"
  })));
}, "IconPolymer");

import GZ from "classnames";
var UZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPool } from '@aws-amplify/ui-react'; \u2192 import { MdPool } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 8.00016L6.75 11.2502C7.06 11.3702 7.31 11.5202 7.52 11.6402C7.89 11.8702 8.11 12.0002 8.67 12.0002C9.23 12.0002 9.45 11.8702 9.82 11.6402C10.28 11.3702 10.9 11.0002 12.01 11.0002C13.12 11.0002 13.74 11.3702 14.19 11.6402C14.56 11.8602 14.79 12.0002 15.34 12.0002C15.89 12.0002 16.12 11.8702 16.49 11.6402C16.61 11.5702 16.75 11.4902 16.9 11.4102L10.48 5.00016C8.93 3.45016 7.5 2.99016 5 3.00016V5.50016C6.82 5.49016 7.89 5.89016 9 7.00016L10 8.00016ZM22 16.5002H21.98H22ZM5.35 15.5002C5.9 15.5002 6.13 15.6402 6.5 15.8602C6.95 16.1302 7.57 16.5002 8.68 16.5002C9.79 16.5002 10.41 16.1302 10.86 15.8602C11.23 15.6302 11.45 15.5002 12.01 15.5002C12.56 15.5002 12.79 15.6402 13.16 15.8602C13.61 16.1302 14.23 16.5002 15.34 16.5002C16.45 16.5002 17.07 16.1302 17.52 15.8602C17.89 15.6302 18.11 15.5002 18.67 15.5002C19.22 15.5002 19.45 15.6402 19.82 15.8602C20.27 16.1302 20.88 16.4902 21.98 16.5002V14.5002C21.43 14.5002 21.2 14.3602 20.83 14.1402C20.38 13.8702 19.76 13.5002 18.65 13.5002C17.54 13.5002 16.92 13.8702 16.47 14.1402C16.1 14.3702 15.87 14.5002 15.32 14.5002C14.77 14.5002 14.54 14.3602 14.17 14.1402C13.72 13.8702 13.1 13.5002 11.99 13.5002C10.88 13.5002 10.26 13.8702 9.81 14.1402C9.44 14.3702 9.22 14.5002 8.66 14.5002C8.11 14.5002 7.88 14.3602 7.51 14.1402C7.06 13.8702 6.44 13.5002 5.33 13.5002C4.22 13.5002 3.6 13.8702 3.15 14.1402C2.78 14.3702 2.56 14.5002 2 14.5002V16.5002C3.11 16.5002 3.73 16.1302 4.2 15.8602C4.57 15.6302 4.8 15.5002 5.35 15.5002ZM18.67 18.0002C17.56 18.0002 16.94 18.3702 16.49 18.6402C16.12 18.8702 15.89 19.0002 15.34 19.0002C14.79 19.0002 14.56 18.8602 14.19 18.6402C13.74 18.3702 13.12 18.0002 12.01 18.0002C10.9 18.0002 10.28 18.3702 9.82 18.6402C9.45 18.8702 9.23 19.0002 8.67 19.0002C8.11 19.0002 7.89 18.8702 7.52 18.6402C7.07 18.3702 6.45 18.0002 5.34 18.0002C4.23 18.0002 3.61 18.3702 3.15 18.6402C2.78 18.8702 2.56 19.0002 2 19.0002V21.0002C3.11 21.0002 3.73 20.6302 4.19 20.3602C4.56 20.1302 4.79 20.0002 5.34 20.0002C5.89 20.0002 6.12 20.1302 6.49 20.3602C6.94 20.6302 7.56 21.0002 8.67 21.0002C9.78 21.0002 10.4 20.6302 10.86 20.3602C11.23 20.1302 11.45 20.0002 12.01 20.0002C12.56 20.0002 12.79 20.1402 13.16 20.3602C13.61 20.6302 14.23 21.0002 15.34 21.0002C16.45 21.0002 17.06 20.6302 17.52 20.3602C17.89 20.1302 18.11 20.0002 18.67 20.0002C19.22 20.0002 19.45 20.1402 19.82 20.3602C20.27 20.6302 20.89 21.0002 22 21.0002V19.0002C21.44 19.0002 21.22 18.8702 20.85 18.6402C20.4 18.3702 19.78 18.0002 18.67 18.0002Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M16.5 8C17.8807 8 19 6.88071 19 5.5C19 4.11929 17.8807 3 16.5 3C15.1193 3 14 4.11929 14 5.5C14 6.88071 15.1193 8 16.5 8Z",
    fill: "black"
  })));
}, "IconPool");
import zZ from "classnames";
var XZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPortableWifiOff } from '@aws-amplify/ui-react'; \u2192 import { MdPortableWifiOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3.42 2.36L2.01 3.78L4.1 5.87C2.79 7.57 2 9.69 2 12C2 15.7 4.01 18.92 6.99 20.65L7.99 18.92C5.61 17.53 4 14.96 4 12C4 10.24 4.57 8.62 5.53 7.31L6.96 8.75C6.36 9.68 6 10.8 6 12C6 14.22 7.21 16.15 9 17.19L10 15.45C8.81 14.75 8 13.48 8 12C8 11.35 8.17 10.75 8.44 10.21L10.02 11.79L10 12C10 13.1 10.9 14 12 14L12.21 13.98L19.73 21.5L21.14 20.09L3.42 2.36ZM17.71 13.82C17.89 13.25 18 12.63 18 12C18 8.69 15.31 6 12 6C11.37 6 10.75 6.11 10.18 6.29L11.9 8.01C11.93 8.01 11.96 8 12 8C14.21 8 16 9.79 16 12C16 12.04 15.99 12.07 15.99 12.11L17.71 13.82ZM12 4C16.42 4 20 7.58 20 12C20 13.2 19.71 14.32 19.23 15.35L20.72 16.84C21.53 15.4 22 13.76 22 12C22 6.48 17.52 2 12 2C10.24 2 8.6 2.48 7.16 3.28L8.64 4.76C9.66 4.28 10.8 4 12 4Z",
    fill: "currentColor"
  })));
}, "IconPortableWifiOff");
import KZ from "classnames";
var qZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPortrait } from '@aws-amplify/ui-react'; \u2192 import { MdPortrait } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 12C13.65 12 15 10.65 15 9C15 7.35 13.65 6 12 6C10.35 6 9 7.35 9 9C9 10.65 10.35 12 12 12ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM18 16.58C18 14.08 14.03 13 12 13C9.97 13 6 14.08 6 16.58V18H18V16.58ZM8.48 16C9.22 15.49 10.71 15 12 15C13.29 15 14.78 15.49 15.52 16H8.48ZM19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconPortrait");
import QZ from "classnames";
var JZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPostAdd } from '@aws-amplify/ui-react'; \u2192 import { MdPostAdd } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QZ(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 19.22H5V7H12V5H5C3.9 5 3 5.9 3 7V19C3 20.1 3.9 21 5 21H17C18.1 21 19 20.1 19 19V12H17V19.22Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M19 2H17V5H14C14.01 5.01 14 7 14 7H17V9.99C17.01 10 19 9.99 19 9.99V7H22V5H19V2Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 9H7V11H15V9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7 12V14H15V12H12H7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 15H7V17H15V15Z",
    fill: "black"
  })));
}, "IconPostAdd");
import $Z from "classnames";
var RZ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPowerInput } from '@aws-amplify/ui-react'; \u2192 import { MdPowerInput } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $Z(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 9V11H21V9H2ZM2 15H7V13H2V15ZM9 15H14V13H9V15ZM16 15H21V13H16V15Z",
    fill: "currentColor"
  })));
}, "IconPowerInput");
import eB from "classnames";
var oB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPowerOff } from '@aws-amplify/ui-react'; \u2192 import { MdPowerOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.99996 3H7.99996V4.88L9.99996 6.88V3ZM16 9V12.88L17.8 14.68L18 14.48V9C18 7.9 17.1 7 16 7V3H14V7H10.12L12.12 9H16ZM4.11996 3.84L2.70996 5.25L5.99996 8.54V14.5L9.49996 18V21H14.5V18L14.98 17.52L19.45 21.99L20.86 20.58L4.11996 3.84ZM12.5 17.17V19H11.5V17.17L7.99996 13.65V10.54L13.57 16.11L12.5 17.17V17.17Z",
    fill: "currentColor"
  })));
}, "IconPowerOff");
import tB from "classnames";
var rB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPowerSettingsNew } from '@aws-amplify/ui-react'; \u2192 import { MdPowerSettingsNew } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 3H11V13H13V3ZM17.83 5.17L16.41 6.59C17.99 7.86 19 9.81 19 12C19 15.87 15.87 19 12 19C8.13 19 5 15.87 5 12C5 9.81 6.01 7.86 7.58 6.58L6.17 5.17C4.23 6.82 3 9.26 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 9.26 19.77 6.82 17.83 5.17Z",
    fill: "currentColor"
  })));
}, "IconPowerSettingsNew");
import iB from "classnames";
var sB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPower } from '@aws-amplify/ui-react'; \u2192 import { MdPower } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 9V13.66L12.5 17.17V19H11.5V17.17L8 13.65V9H16ZM16 3H14V7H10V3H8V7H7.99C6.9 6.99 6 7.89 6 8.98V14.5L9.5 18V21H14.5V18L18 14.49V9C18 7.9 17.1 7 16 7V3Z",
    fill: "currentColor"
  })));
}, "IconPower");
import aB from "classnames";
var nB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPrecisionManufacturing } from '@aws-amplify/ui-react'; \u2192 import { MdPrecisionManufacturing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.93 8.34994L16.33 10.0299L14 7.69994V6.29994L16.33 3.96994L19.93 5.64994C20.31 5.82994 20.75 5.65994 20.93 5.28994C21.11 4.90994 20.94 4.46994 20.57 4.28994L16.65 2.45994C16.27 2.27994 15.82 2.35994 15.52 2.65994L13.78 4.39994C13.6 4.15994 13.32 3.99994 13 3.99994C12.45 3.99994 12 4.44994 12 4.99994V5.99994H8.82C8.4 4.83994 7.3 3.99994 6 3.99994C4.34 3.99994 3 5.33994 3 6.99994C3 8.09994 3.6 9.04994 4.48 9.57994L7.08 17.9999H6C4.9 17.9999 4 18.8999 4 19.9999V20.9999H17V19.9999C17 18.8999 16.1 17.9999 15 17.9999H13.38L8.41 8.76994C8.58 8.52994 8.72 8.27994 8.82 7.99994H12V8.99994C12 9.54994 12.45 9.99994 13 9.99994C13.32 9.99994 13.6 9.83994 13.78 9.59994L15.52 11.3399C15.82 11.6399 16.27 11.7199 16.65 11.5399L20.57 9.70994C20.95 9.52994 21.11 9.08994 20.93 8.70994C20.75 8.33994 20.31 8.16994 19.93 8.34994ZM6 7.99994C5.45 7.99994 5 7.54994 5 6.99994C5 6.44994 5.45 5.99994 6 5.99994C6.55 5.99994 7 6.44994 7 6.99994C7 7.54994 6.55 7.99994 6 7.99994ZM11.11 17.9999H9.17L6.71 9.99994H6.81L11.11 17.9999Z",
    fill: "currentColor"
  })));
}, "IconPrecisionManufacturing");
import mB from "classnames";
var cB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPregnantWoman } from '@aws-amplify/ui-react'; \u2192 import { MdPregnantWoman } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 4C9 2.89 9.89 2 11 2C12.11 2 13 2.89 13 4C13 5.11 12.11 6 11 6C9.89 6 9 5.11 9 4ZM16 13C15.99 11.66 15.17 10.49 14 10C14 8.34 12.66 7 11 7C9.34 7 8 8.34 8 10V17H10V22H13V17H16V13Z",
    fill: "currentColor"
  })));
}, "IconPregnantWoman");
import lB from "classnames";
var pB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPresentToAll } from '@aws-amplify/ui-react'; \u2192 import { MdPresentToAll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.89 3 1 3.89 1 5V19C1 20.11 1.89 21 3 21H21C22.11 21 23 20.11 23 19V5C23 3.89 22.11 3 21 3ZM21 19.02H3V4.98H21V19.02ZM10 12H8L12 8L16 12H14V16H10V12Z",
    fill: "currentColor"
  })));
}, "IconPresentToAll");
import hB from "classnames";
var fB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPreview } from '@aws-amplify/ui-react'; \u2192 import { MdPreview } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V7H19V19ZM12 10.5C13.84 10.5 15.48 11.46 16.34 13C15.48 14.54 13.84 15.5 12 15.5C10.16 15.5 8.52 14.54 7.66 13C8.52 11.46 10.16 10.5 12 10.5ZM12 9C9.27 9 6.94 10.66 6 13C6.94 15.34 9.27 17 12 17C14.73 17 17.06 15.34 18 13C17.06 10.66 14.73 9 12 9ZM12 14.5C11.17 14.5 10.5 13.83 10.5 13C10.5 12.17 11.17 11.5 12 11.5C12.83 11.5 13.5 12.17 13.5 13C13.5 13.83 12.83 14.5 12 14.5Z",
    fill: "currentColor"
  })));
}, "IconPreview");
import CB from "classnames";
var gB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPrintDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdPrintDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1.41 1.6001L0 3.0101L5 8.0001C3.34 8.0001 2 9.3401 2 11.0001V17.0001H6V21.0001H18L20.95 23.9601L22.36 22.5501L1.41 1.6001ZM6 15.0001H4V11.0001C4 10.4501 4.45 10.0001 5 10.0001H7L10 13.0001H6V15.0001ZM8 19.0001V15.0001H12L16 19.0001H8ZM8 5.0001H16V8.0001H10.66L12.66 10.0001H19C19.55 10.0001 20 10.4501 20 11.0001V15.0001L18 15.0101V13.0001H15.66L19.66 17.0001H22V11.0001C22 9.3401 20.66 8.0001 19 8.0001H18V3.0001H6V3.3601L8 5.3601V5.0001Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18 12.5098C18.5523 12.5098 19 12.0621 19 11.5098C19 10.9575 18.5523 10.5098 18 10.5098C17.4477 10.5098 17 10.9575 17 11.5098C17 12.0621 17.4477 12.5098 18 12.5098Z",
    fill: "black"
  })));
}, "IconPrintDisabled");
import uB from "classnames";
var wB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPrint } from '@aws-amplify/ui-react'; \u2192 import { MdPrint } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 8H18V3H6V8H5C3.34 8 2 9.34 2 11V17H6V21H18V17H22V11C22 9.34 20.66 8 19 8ZM8 5H16V8H8V5ZM16 17V19H8V15H16V17ZM18 15V13H6V15H4V11C4 10.45 4.45 10 5 10H19C19.55 10 20 10.45 20 11V15H18Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18 12.5C18.5523 12.5 19 12.0523 19 11.5C19 10.9477 18.5523 10.5 18 10.5C17.4477 10.5 17 10.9477 17 11.5C17 12.0523 17.4477 12.5 18 12.5Z",
    fill: "black"
  })));
}, "IconPrint");
import dB from "classnames";
var VB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPriorityHigh } from '@aws-amplify/ui-react'; \u2192 import { MdPriorityHigh } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10 3H14V15H10V3Z",
    fill: "black"
  })));
}, "IconPriorityHigh");
import HB from "classnames";
var MB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPrivacyTip } from '@aws-amplify/ui-react'; \u2192 import { MdPrivacyTip } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 3.19L19 6.3V11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19ZM12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z",
    fill: "currentColor"
  })));
}, "IconPrivacyTip");
import xB from "classnames";
var IB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPsychology } from '@aws-amplify/ui-react'; \u2192 import { MdPsychology } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.8201 7.22L14.8201 7.62C14.6101 7.46 14.3901 7.33 14.1501 7.23L14.0001 6.17C13.9801 6.07 13.9001 6 13.8001 6H12.2001C12.1001 6 12.0201 6.07 12.0101 6.17L11.8601 7.23C11.6201 7.33 11.3901 7.46 11.1901 7.62L10.1901 7.22C10.1001 7.19 9.99005 7.22 9.95005 7.31L9.15005 8.69C9.10005 8.78 9.12005 8.89 9.20005 8.95L10.0501 9.61C10.0201 9.73 10.0001 9.87 10.0001 10C10.0001 10.13 10.0101 10.26 10.0301 10.39L9.19005 11.05C9.11005 11.11 9.09005 11.22 9.14005 11.3L9.94005 12.69C9.99005 12.78 10.0901 12.81 10.1901 12.78L11.1801 12.38C11.3901 12.54 11.6101 12.67 11.8601 12.77L12.0001 13.83C12.0201 13.93 12.1001 14 12.2001 14H13.8001C13.9001 14 13.9801 13.93 14.0001 13.83L14.1501 12.77C14.3901 12.67 14.6201 12.54 14.8201 12.38L15.8101 12.78C15.9001 12.82 16.0101 12.78 16.0501 12.69L16.8501 11.3C16.9001 11.21 16.8801 11.11 16.8001 11.05L15.9701 10.39C15.9901 10.26 16.0001 10.13 16.0001 10C16.0001 9.86 15.9901 9.73 15.9701 9.61L16.8201 8.95C16.9001 8.89 16.9201 8.78 16.8701 8.69L16.0701 7.31C16.0201 7.22 15.9101 7.19 15.8201 7.22ZM13.0001 11.43C12.2101 11.43 11.5701 10.79 11.5701 10C11.5701 9.21 12.2101 8.57 13.0001 8.57C13.7901 8.57 14.4301 9.21 14.4301 10C14.4301 10.79 13.7901 11.43 13.0001 11.43Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M19.9398 9.06C19.5098 5.79 16.7098 3.2 13.4098 3.01C13.2698 3 13.1398 3 12.9998 3C9.46985 3 6.56985 5.61 6.07985 9L4.14985 12.48C3.73985 13.14 4.21985 14 4.99985 14H5.99985V16C5.99985 17.1 6.89985 18 7.99985 18H8.99985V21H15.9998V16.32C18.6198 15.07 20.3498 12.24 19.9398 9.06ZM14.8898 14.63L13.9998 15.05V19H10.9998V16H7.99985V12H6.69985L8.02985 9.67C8.20985 7.06 10.3498 5 12.9998 5C15.7598 5 17.9998 7.24 17.9998 10C17.9998 12.09 16.7098 13.88 14.8898 14.63Z",
    fill: "black"
  })));
}, "IconPsychology");
import LB from "classnames";
var vB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPublicOff } from '@aws-amplify/ui-react'; \u2192 import { MdPublicOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.0001 8.17L6.49014 3.66C8.07014 2.61 9.96014 2 12.0001 2C17.5201 2 22.0001 6.48 22.0001 12C22.0001 14.04 21.3901 15.93 20.3401 17.51L18.8801 16.05C19.5901 14.87 20.0001 13.48 20.0001 12C20.0001 8.65 17.9301 5.78 15.0001 4.59V5C15.0001 6.1 14.1001 7 13.0001 7H11.0001V8.17ZM21.1901 21.19L19.7801 22.6L17.5101 20.33C15.9301 21.39 14.0401 22 12.0001 22C6.48014 22 2.00014 17.52 2.00014 12C2.00014 9.96 2.61014 8.07 3.66014 6.49L1.39014 4.22L2.80014 2.81L21.1901 21.19ZM11.0001 18C9.90014 18 9.00014 17.1 9.00014 16V15L4.21014 10.21C4.08014 10.79 4.00014 11.38 4.00014 12C4.00014 16.08 7.05014 19.44 11.0001 19.93V18Z",
    fill: "currentColor"
  })));
}, "IconPublicOff");
import NB from "classnames";
var yB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPublic } from '@aws-amplify/ui-react'; \u2192 import { MdPublic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 11.39 4.08 10.79 4.21 10.22L8.99 15V16C8.99 17.1 9.89 18 10.99 18V19.93C7.06 19.43 4 16.07 4 12ZM17.89 17.4C17.63 16.59 16.89 16 15.99 16H14.99V13C14.99 12.45 14.54 12 13.99 12H7.99V10H9.99C10.54 10 10.99 9.55 10.99 9V7H12.99C14.09 7 14.99 6.1 14.99 5V4.59C17.92 5.77 20 8.65 20 12C20 14.08 19.19 15.98 17.89 17.4Z",
    fill: "currentColor"
  })));
}, "IconPublic");
import bB from "classnames";
var ZB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPublish } from '@aws-amplify/ui-react'; \u2192 import { MdPublish } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 4H19V6H5V4ZM5 14H9V20H15V14H19L12 7L5 14ZM13 12V18H11V12H9.83L12 9.83L14.17 12H13Z",
    fill: "currentColor"
  })));
}, "IconPublish");
import BB from "classnames";
var WB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPublishedWithChanges } from '@aws-amplify/ui-react'; \u2192 import { MdPublishedWithChanges } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.6 19.4998H21V21.4998H15V15.4998H17V18.2298C18.83 16.7598 20 14.5198 20 11.9998C20 7.9298 16.94 4.5598 13 4.0698V2.0498C18.05 2.5498 22 6.8098 22 11.9998C22 14.9898 20.68 17.6698 18.6 19.4998ZM4 11.9998C4 9.4798 5.17 7.2298 7 5.7698V8.4998H9V2.4998H3V4.4998H5.4C3.32 6.3298 2 9.0098 2 11.9998C2 17.1898 5.95 21.4498 11 21.9498V19.9298C7.06 19.4398 4 16.0698 4 11.9998ZM16.24 8.1098L10.58 13.7698L7.75 10.9398L6.34 12.3498L10.58 16.5898L17.65 9.5198L16.24 8.1098Z",
    fill: "currentColor"
  })));
}, "IconPublishedWithChanges");
import kB from "classnames";
var DB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconPushPin } from '@aws-amplify/ui-react'; \u2192 import { MdPushPin } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 4V9C14 10.12 14.37 11.16 15 12H9C9.65 11.14 10 10.1 10 9V4H14ZM17 2H7C6.45 2 6 2.45 6 3C6 3.55 6.45 4 7 4H8V9C8 10.66 6.66 12 5 12V14H10.97V21L11.97 22L12.97 21V14H19V12C17.34 12 16 10.66 16 9V4H17C17.55 4 18 3.55 18 3C18 2.45 17.55 2 17 2Z",
    fill: "currentColor"
  })));
}, "IconPushPin");
import PB from "classnames";
var SB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconQrCodeScanner } from '@aws-amplify/ui-react'; \u2192 import { MdQrCodeScanner } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.5 6.5V9.5H6.5V6.5H9.5ZM11 5H5V11H11V5ZM9.5 14.5V17.5H6.5V14.5H9.5ZM11 13H5V19H11V13ZM17.5 6.5V9.5H14.5V6.5H17.5ZM19 5H13V11H19V5ZM13 13H14.5V14.5H13V13ZM14.5 14.5H16V16H14.5V14.5ZM16 13H17.5V14.5H16V13ZM13 16H14.5V17.5H13V16ZM14.5 17.5H16V19H14.5V17.5ZM16 16H17.5V17.5H16V16ZM17.5 14.5H19V16H17.5V14.5ZM17.5 17.5H19V19H17.5V17.5ZM22 7H20V4H17V2H22V7ZM22 22V17H20V20H17V22H22ZM2 22H7V20H4V17H2V22ZM2 2V7H4V4H7V2H2Z",
    fill: "currentColor"
  })));
}, "IconQrCodeScanner");
import jB from "classnames";
var YB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconQrCode } from '@aws-amplify/ui-react'; \u2192 import { MdQrCode } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 11H11V3H3V11ZM5 5H9V9H5V5Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M3 21H11V13H3V21ZM5 15H9V19H5V15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 3V11H21V3H13ZM19 9H15V5H19V9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M21 19H19V21H21V19Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 13H13V15H15V13Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17 15H15V17H17V15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 17H13V19H15V17Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17 19H15V21H17V19Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19 17H17V19H19V17Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M19 13H17V15H19V13Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M21 15H19V17H21V15Z",
    fill: "black"
  })));
}, "IconQrCode");
import FB from "classnames";
var TB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconQueryBuilder } from '@aws-amplify/ui-react'; \u2192 import { MdQueryBuilder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z",
    fill: "currentColor"
  })));
}, "IconQueryBuilder");
import AB from "classnames";
var EB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconQuestionAnswer } from '@aws-amplify/ui-react'; \u2192 import { MdQuestionAnswer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 4V11H5.17L4.58 11.59L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z",
    fill: "currentColor"
  })));
}, "IconQuestionAnswer");
import OB from "classnames";

var _B = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconQueueMusic } from '@aws-amplify/ui-react'; \u2192 import { MdQueueMusic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 6H17V14.18C16.69 14.07 16.35 14 16 14C14.34 14 13 15.34 13 17C13 18.66 14.34 20 16 20C17.66 20 19 18.66 19 17V8H22V6ZM15 6H3V8H15V6ZM15 10H3V12H15V10ZM11 14H3V16H11V14ZM15 17C15 16.45 15.45 16 16 16C16.55 16 17 16.45 17 17C17 17.55 16.55 18 16 18C15.45 18 15 17.55 15 17Z",
    fill: "currentColor"
  })));
}, "IconQueueMusic");

import GB from "classnames";
var UB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconQueuePlayNext } from '@aws-amplify/ui-react'; \u2192 import { MdQueuePlayNext } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H18V17H3V5H21V13H23V5C23 3.89 22.1 3 21 3ZM13 10V7H11V10H8V12H11V15H13V12H16V10H13ZM24 18L19.5 22.5L18 21L21 18L18 15L19.5 13.5L24 18Z",
    fill: "currentColor"
  })));
}, "IconQueuePlayNext");
import zB from "classnames";
var XB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconQueue } from '@aws-amplify/ui-react'; \u2192 import { MdQueue } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM13 15H15V11H19V9H15V5H13V9H9V11H13V15Z",
    fill: "currentColor"
  })));
}, "IconQueue");
import KB from "classnames";
var qB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconQuickreply } from '@aws-amplify/ui-react'; \u2192 import { MdQuickreply } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 17.17V4H20V10H22V4C22 2.9 21.1 2 20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H15V16H5.17L4 17.17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M22.5 16H20.3L22 12H17V18H19V23L22.5 16Z",
    fill: "black"
  })));
}, "IconQuickreply");
import QB from "classnames";
var JB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRadioButtonChecked } from '@aws-amplify/ui-react'; \u2192 import { MdRadioButtonChecked } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QB(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z",
    fill: "black"
  })));
}, "IconRadioButtonChecked");
import $B from "classnames";
var RB = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRadioButtonUnchecked } from '@aws-amplify/ui-react'; \u2192 import { MdRadioButtonUnchecked } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $B(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconRadioButtonUnchecked");
import eW from "classnames";
var oW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRadio } from '@aws-amplify/ui-react'; \u2192 import { MdRadio } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H8.3L16.56 2.66L15.88 1L3.24 6.15C2.51 6.43 2 7.17 2 8V20C2 21.1 2.89 22 4 22H20C21.11 22 22 21.1 22 20V8C22 6.89 21.11 6 20 6ZM20 8V11H18V9H16V11H4V8H20ZM4 20V13H20V20H4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8 18.98C9.38071 18.98 10.5 17.8607 10.5 16.48C10.5 15.0993 9.38071 13.98 8 13.98C6.61929 13.98 5.5 15.0993 5.5 16.48C5.5 17.8607 6.61929 18.98 8 18.98Z",
    fill: "black"
  })));
}, "IconRadio");
import tW from "classnames";
var rW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRateReview } from '@aws-amplify/ui-react'; \u2192 import { MdRateReview } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4.58 16.59L4 17.17V4H20V16ZM10.5 14H18V12H12.5L10.5 14ZM14.36 8.13C14.56 7.93 14.56 7.62 14.36 7.42L12.59 5.65C12.39 5.45 12.08 5.45 11.88 5.65L6 11.53V14H8.47L14.36 8.13Z",
    fill: "currentColor"
  })));
}, "IconRateReview");
import iW from "classnames";
var sW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReadMore } from '@aws-amplify/ui-react'; \u2192 import { MdReadMore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 7H13V9H22V7Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M22 15H13V17H22V15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M22 11H16V13H22V11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 12L8 7V11H2V13H8V17L13 12Z",
    fill: "black"
  })));
}, "IconReadMore");
import aW from "classnames";
var nW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReceiptLong } from '@aws-amplify/ui-react'; \u2192 import { MdReceiptLong } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2V16H3V19C3 20.66 4.34 22 6 22H18C19.66 22 21 20.66 21 19V2L19.5 3.5ZM15 20H6C5.45 20 5 19.55 5 19V18H15V20ZM19 19C19 19.55 18.55 20 18 20C17.45 20 17 19.55 17 19V16H8V5H19V19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15 7H9V9H15V7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18 7H16V9H18V7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 10H9V12H15V10Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18 10H16V12H18V10Z",
    fill: "black"
  })));
}, "IconReceiptLong");
import mW from "classnames";
var cW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReceipt } from '@aws-amplify/ui-react'; \u2192 import { MdReceipt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5ZM19 19.09H5V4.91H19V19.09ZM6 15H18V17H6V15ZM6 11H18V13H6V11ZM6 7H18V9H6V7Z",
    fill: "currentColor"
  })));
}, "IconReceipt");
import lW from "classnames";
var pW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRecentActors } from '@aws-amplify/ui-react'; \u2192 import { MdRecentActors } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 5H23V19H21V5ZM17 5H19V19H17V5ZM14 5H2C1.45 5 1 5.45 1 6V18C1 18.55 1.45 19 2 19H14C14.55 19 15 18.55 15 18V6C15 5.45 14.55 5 14 5ZM13 17H3V7H13V17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.00005 11.8902C9.077 11.8902 9.95005 11.0172 9.95005 9.94023C9.95005 8.86328 9.077 7.99023 8.00005 7.99023C6.92309 7.99023 6.05005 8.86328 6.05005 9.94023C6.05005 11.0172 6.92309 11.8902 8.00005 11.8902Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11.89 15.3499C11.89 14.0499 9.29999 13.3999 7.99999 13.3999C6.69999 13.3999 4.10999 14.0499 4.10999 15.3499V15.9999H11.89V15.3499Z",
    fill: "black"
  })));
}, "IconRecentActors");
import hW from "classnames";
var fW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRecordVoiceOver } from '@aws-amplify/ui-react'; \u2192 import { MdRecordVoiceOver } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 13C11.21 13 13 11.21 13 9C13 6.79 11.21 5 9 5C6.79 5 5 6.79 5 9C5 11.21 6.79 13 9 13ZM9 7C10.1 7 11 7.9 11 9C11 10.1 10.1 11 9 11C7.9 11 7 10.1 7 9C7 7.9 7.9 7 9 7ZM9 15C6.33 15 1 16.34 1 19V21H17V19C17 16.34 11.67 15 9 15ZM3 19C3.22 18.28 6.31 17 9 17C11.7 17 14.8 18.29 15 19H3ZM15.08 7.05C15.92 8.23 15.92 9.76 15.08 10.94L16.76 12.63C18.78 10.61 18.78 7.56 16.76 5.36L15.08 7.05V7.05ZM20.07 2L18.44 3.63C21.21 6.65 21.21 11.19 18.44 14.37L20.07 16C23.97 12.11 23.98 6.05 20.07 2Z",
    fill: "currentColor"
  })));
}, "IconRecordVoiceOver");
import CW from "classnames";
var gW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRedeem } from '@aws-amplify/ui-react'; \u2192 import { MdRedeem } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H17.82C17.93 5.69 18 5.35 18 5C18 3.34 16.66 2 15 2C13.95 2 13.04 2.54 12.5 3.35L12 4.02L11.5 3.34C10.96 2.54 10.05 2 9 2C7.34 2 6 3.34 6 5C6 5.35 6.07 5.69 6.18 6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM15 4C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4ZM9 4C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6C8.45 6 8 5.55 8 5C8 4.45 8.45 4 9 4ZM20 19H4V17H20V19ZM20 14H4V8H9.08L7 10.83L8.62 12L11 8.76L12 7.4L13 8.76L15.38 12L17 10.83L14.92 8H20V14Z",
    fill: "currentColor"
  })));
}, "IconRedeem");
import uW from "classnames";
var wW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRedo } from '@aws-amplify/ui-react'; \u2192 import { MdRedo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8C6.85004 8 2.92004 11.03 1.54004 15.22L3.90004 16C4.95004 12.81 7.95004 10.5 11.5 10.5C13.45 10.5 15.23 11.22 16.62 12.38L13 16H22V7L18.4 10.6Z",
    fill: "currentColor"
  })));
}, "IconRedo");
import dW from "classnames";
var VW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReduceCapacity } from '@aws-amplify/ui-react'; \u2192 import { MdReduceCapacity } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 4C16 2.9 16.9 2 18 2C19.1 2 20 2.9 20 4C20 5.1 19.1 6 18 6C16.9 6 16 5.1 16 4ZM20.78 7.58C19.93 7.21 18.99 7 18 7C17.33 7 16.69 7.1 16.08 7.28C16.66 7.83 17 8.6 17 9.43V10H22V9.43C22 8.62 21.52 7.9 20.78 7.58ZM6 6C7.1 6 8 5.1 8 4C8 2.9 7.1 2 6 2C4.9 2 4 2.9 4 4C4 5.1 4.9 6 6 6ZM7.92 7.28C7.31 7.1 6.67 7 6 7C5.01 7 4.07 7.21 3.22 7.58C2.48 7.9 2 8.62 2 9.43V10H7V9.43C7 8.6 7.34 7.83 7.92 7.28ZM10 4C10 2.9 10.9 2 12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4ZM16 10H8V9.43C8 8.62 8.48 7.9 9.22 7.58C10.07 7.21 11.01 7 12 7C12.99 7 13.93 7.21 14.78 7.58C15.52 7.9 16 8.62 16 9.43V10ZM15 16C15 14.9 15.9 14 17 14C18.1 14 19 14.9 19 16C19 17.1 18.1 18 17 18C15.9 18 15 17.1 15 16ZM21 22H13V21.43C13 20.62 13.48 19.9 14.22 19.58C15.07 19.21 16.01 19 17 19C17.99 19 18.93 19.21 19.78 19.58C20.52 19.9 21 20.62 21 21.43V22ZM5 16C5 14.9 5.9 14 7 14C8.1 14 9 14.9 9 16C9 17.1 8.1 18 7 18C5.9 18 5 17.1 5 16ZM11 22H3V21.43C3 20.62 3.48 19.9 4.22 19.58C5.07 19.21 6.01 19 7 19C7.99 19 8.93 19.21 9.78 19.58C10.52 19.9 11 20.62 11 21.43V22ZM12.75 13V11H11.25V13H9L12 16L15 13H12.75Z",
    fill: "currentColor"
  })));
}, "IconReduceCapacity");
import HW from "classnames";
var MW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRefresh } from '@aws-amplify/ui-react'; \u2192 import { MdRefresh } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.6498 6.35C16.1998 4.9 14.2098 4 11.9998 4C7.57977 4 4.00977 7.58 4.00977 12C4.00977 16.42 7.57977 20 11.9998 20C15.7298 20 18.8398 17.45 19.7298 14H17.6498C16.8298 16.33 14.6098 18 11.9998 18C8.68977 18 5.99977 15.31 5.99977 12C5.99977 8.69 8.68977 6 11.9998 6C13.6598 6 15.1398 6.69 16.2198 7.78L12.9998 11H19.9998V4L17.6498 6.35Z",
    fill: "currentColor"
  })));
}, "IconRefresh");
import xW from "classnames";
var IW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRemoveCircleOutline } from '@aws-amplify/ui-react'; \u2192 import { MdRemoveCircleOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 11V13H17V11H7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "currentColor"
  })));
}, "IconRemoveCircleOutline");
import LW from "classnames";
var vW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRemoveCircle } from '@aws-amplify/ui-react'; \u2192 import { MdRemoveCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H7V11H17V13Z",
    fill: "currentColor"
  })));
}, "IconRemoveCircle");
import NW from "classnames";
var yW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRemoveFromQueue } from '@aws-amplify/ui-react'; \u2192 import { MdRemoveFromQueue } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.89 3 1 3.89 1 5V17C1 18.1 1.89 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.89 22.1 3 21 3ZM21 17H3V5H21V17ZM16 10V12H8V10H16Z",
    fill: "currentColor"
  })));
}, "IconRemoveFromQueue");
import bW from "classnames";
var ZW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRemoveRedEye } from '@aws-amplify/ui-react'; \u2192 import { MdRemoveRedEye } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.8 17.5 12 17.5C8.2 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z",
    fill: "currentColor"
  })));
}, "IconRemoveRedEye");
import BW from "classnames";
var WW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRemoveShoppingCart } from '@aws-amplify/ui-react'; \u2192 import { MdRemoveShoppingCart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_38169)"
  }, e.createElement("path", {
    d: "M1.41 1.12988L0 2.53988L4.39 6.92988L6.6 11.5899L5.25 14.0399C5.09 14.3199 5 14.6499 5 14.9999C5 16.0999 5.9 16.9999 7 16.9999H14.46L15.84 18.3799C15.34 18.7399 15.01 19.3299 15.01 19.9999C15.01 21.0999 15.9 21.9999 17 21.9999C17.67 21.9999 18.26 21.6699 18.62 21.1599L21.46 23.9999L22.87 22.5899L1.41 1.12988ZM7 14.9999L8.1 12.9999H10.46L12.46 14.9999H7ZM20 3.99988H7.12L9.12 5.99988H18.31L15.55 10.9999H14.11L16.05 12.9399C16.59 12.7999 17.04 12.4499 17.3 11.9699L20.88 5.47988C21.25 4.81988 20.76 3.99988 20 3.99988ZM7 17.9999C5.9 17.9999 5.01 18.8999 5.01 19.9999C5.01 21.0999 5.9 21.9999 7 21.9999C8.1 21.9999 9 21.0999 9 19.9999C9 18.8999 8.1 17.9999 7 17.9999Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_38169"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconRemoveShoppingCart");
import kW from "classnames";
var Pt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 13H5V11H19V13Z",
    fill: "currentColor"
  })));
}, "IconRemove");
import DW from "classnames";
var PW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReorder } from '@aws-amplify/ui-react'; \u2192 import { MdReorder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 15H21V13H3V15ZM3 19H21V17H3V19ZM3 11H21V9H3V11ZM3 5V7H21V5H3Z",
    fill: "currentColor"
  })));
}, "IconReorder");
import SW from "classnames";
var jW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRepeatOne } from '@aws-amplify/ui-react'; \u2192 import { MdRepeatOne } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17ZM13 15V9H12L10 10V11H11.5V15H13Z",
    fill: "currentColor"
  })));
}, "IconRepeatOne");
import YW from "classnames";
var FW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRepeat } from '@aws-amplify/ui-react'; \u2192 import { MdRepeat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17Z",
    fill: "currentColor"
  })));
}, "IconRepeat");
import TW from "classnames";
var AW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReplay_10 } from '@aws-amplify/ui-react'; \u2192 import { MdReplay_10 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 5V1L6.98999 6L11.99 11V7C15.3 7 17.99 9.69 17.99 13C17.99 16.31 15.3 19 11.99 19C8.67999 19 5.98999 16.31 5.98999 13H3.98999C3.98999 17.42 7.56999 21 11.99 21C16.41 21 19.99 17.42 19.99 13C19.99 8.58 16.41 5 11.99 5V5ZM10.89 16H10.04V12.74L9.02999 13.05V12.36L10.8 11.73H10.89V16ZM15.17 14.24C15.17 14.56 15.14 14.84 15.07 15.06C15 15.28 14.9 15.48 14.78 15.63C14.66 15.78 14.5 15.89 14.33 15.96C14.16 16.03 13.96 16.06 13.74 16.06C13.52 16.06 13.33 16.03 13.15 15.96C12.97 15.89 12.82 15.78 12.69 15.63C12.56 15.48 12.46 15.29 12.39 15.06C12.32 14.83 12.28 14.56 12.28 14.24V13.5C12.28 13.18 12.31 12.9 12.38 12.68C12.45 12.46 12.55 12.26 12.67 12.11C12.79 11.96 12.95 11.85 13.12 11.78C13.29 11.71 13.49 11.68 13.71 11.68C13.93 11.68 14.12 11.71 14.3 11.78C14.48 11.85 14.63 11.96 14.76 12.11C14.89 12.26 14.99 12.45 15.06 12.68C15.13 12.91 15.17 13.18 15.17 13.5V14.24V14.24ZM14.32 13.38C14.32 13.19 14.31 13.03 14.28 12.9C14.25 12.77 14.21 12.67 14.16 12.59C14.11 12.51 14.05 12.45 13.97 12.42C13.89 12.39 13.81 12.37 13.72 12.37C13.63 12.37 13.54 12.39 13.47 12.42C13.4 12.45 13.33 12.51 13.28 12.59C13.23 12.67 13.19 12.77 13.16 12.9C13.13 13.03 13.12 13.19 13.12 13.38V14.35C13.12 14.54 13.13 14.7 13.16 14.83C13.19 14.96 13.23 15.07 13.28 15.15C13.33 15.23 13.39 15.29 13.47 15.32C13.55 15.35 13.63 15.37 13.72 15.37C13.81 15.37 13.9 15.35 13.97 15.32C14.04 15.29 14.11 15.23 14.16 15.15C14.21 15.07 14.25 14.96 14.27 14.83C14.29 14.7 14.31 14.54 14.31 14.35V13.38H14.32Z",
    fill: "currentColor"
  })));
}, "IconReplay_10");
import EW from "classnames";
var OW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReplay_30 } from '@aws-amplify/ui-react'; \u2192 import { MdReplay_30 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5V1L7 6L12 11V7C15.31 7 18 9.69 18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13H4C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13C20 8.58 16.42 5 12 5ZM9.56 13.49H10.01C10.22 13.49 10.38 13.44 10.49 13.33C10.6 13.22 10.65 13.08 10.65 12.9C10.65 12.82 10.64 12.75 10.61 12.68C10.58 12.61 10.55 12.56 10.5 12.51C10.45 12.46 10.39 12.42 10.32 12.4C10.25 12.38 10.16 12.36 10.07 12.36C9.99 12.36 9.92 12.37 9.85 12.39C9.78 12.41 9.72 12.44 9.67 12.49C9.62 12.54 9.58 12.58 9.55 12.64C9.52 12.7 9.5 12.77 9.5 12.84H8.65C8.65 12.66 8.69 12.5 8.76 12.36C8.83 12.22 8.93 12.09 9.06 11.99C9.19 11.89 9.33 11.81 9.5 11.76C9.67 11.71 9.85 11.68 10.04 11.68C10.25 11.68 10.45 11.71 10.63 11.76C10.81 11.81 10.96 11.89 11.09 11.99C11.22 12.09 11.32 12.22 11.39 12.37C11.46 12.52 11.5 12.7 11.5 12.9C11.5 12.99 11.49 13.08 11.46 13.17C11.43 13.26 11.39 13.34 11.33 13.42C11.27 13.5 11.21 13.57 11.13 13.64C11.05 13.71 10.96 13.76 10.85 13.81C11.09 13.9 11.27 14.02 11.39 14.2C11.51 14.38 11.57 14.58 11.57 14.81C11.57 15.01 11.53 15.19 11.45 15.34C11.37 15.49 11.27 15.63 11.13 15.73C10.99 15.83 10.84 15.92 10.65 15.97C10.46 16.02 10.27 16.05 10.05 16.05C9.87 16.05 9.69 16.03 9.52 15.98C9.35 15.93 9.19 15.86 9.06 15.75C8.93 15.64 8.81 15.52 8.73 15.37C8.65 15.22 8.61 15.03 8.61 14.82H9.46C9.46 14.9 9.48 14.97 9.51 15.04C9.54 15.11 9.58 15.16 9.64 15.21C9.7 15.26 9.76 15.3 9.84 15.32C9.92 15.34 10 15.36 10.09 15.36C10.19 15.36 10.28 15.35 10.36 15.32C10.44 15.29 10.51 15.25 10.56 15.2C10.61 15.15 10.66 15.09 10.69 15.02C10.72 14.95 10.73 14.87 10.73 14.78C10.73 14.67 10.71 14.57 10.68 14.49C10.65 14.41 10.6 14.34 10.54 14.29C10.48 14.24 10.41 14.2 10.32 14.18C10.23 14.16 10.14 14.14 10.03 14.14H9.56V13.49V13.49ZM15.3 14.24C15.3 14.56 15.27 14.84 15.2 15.06C15.13 15.28 15.03 15.48 14.91 15.63C14.79 15.78 14.63 15.89 14.46 15.96C14.29 16.03 14.09 16.06 13.87 16.06C13.65 16.06 13.46 16.03 13.28 15.96C13.1 15.89 12.95 15.78 12.82 15.63C12.69 15.48 12.59 15.29 12.52 15.06C12.45 14.83 12.41 14.56 12.41 14.24V13.5C12.41 13.18 12.44 12.9 12.51 12.68C12.58 12.46 12.68 12.26 12.8 12.11C12.92 11.96 13.08 11.85 13.25 11.78C13.42 11.71 13.62 11.68 13.84 11.68C14.06 11.68 14.25 11.71 14.43 11.78C14.61 11.85 14.76 11.96 14.89 12.11C15.02 12.26 15.12 12.45 15.19 12.68C15.26 12.91 15.3 13.18 15.3 13.5V14.24V14.24ZM14.45 13.38C14.45 13.19 14.44 13.03 14.41 12.9C14.38 12.77 14.34 12.67 14.29 12.59C14.24 12.51 14.18 12.45 14.1 12.42C14.02 12.39 13.94 12.37 13.85 12.37C13.76 12.37 13.67 12.39 13.6 12.42C13.53 12.45 13.46 12.51 13.41 12.59C13.36 12.67 13.32 12.77 13.29 12.9C13.26 13.03 13.25 13.19 13.25 13.38V14.35C13.25 14.54 13.26 14.7 13.29 14.83C13.32 14.96 13.36 15.07 13.41 15.15C13.46 15.23 13.52 15.29 13.6 15.32C13.68 15.35 13.76 15.37 13.85 15.37C13.94 15.37 14.03 15.35 14.1 15.32C14.17 15.29 14.24 15.23 14.29 15.15C14.34 15.07 14.38 14.96 14.4 14.83C14.43 14.7 14.44 14.54 14.44 14.35V13.38H14.45Z",
    fill: "currentColor"
  })));
}, "IconReplay_30");
import _W from "classnames";
var GW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReplay_5 } from '@aws-amplify/ui-react'; \u2192 import { MdReplay_5 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _W(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5V1L7 6L12 11V7C15.31 7 18 9.69 18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13H4C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13C20 8.58 16.42 5 12 5ZM10.69 13.9L10.94 11.73H13.33V12.44H11.63L11.52 13.36C11.55 13.34 11.59 13.33 11.63 13.31C11.67 13.29 11.72 13.27 11.78 13.26C11.84 13.25 11.9 13.23 11.96 13.22C12.02 13.21 12.09 13.2 12.16 13.2C12.37 13.2 12.55 13.23 12.71 13.3C12.87 13.37 13.01 13.46 13.12 13.58C13.23 13.7 13.32 13.85 13.37 14.03C13.42 14.21 13.46 14.41 13.46 14.63C13.46 14.82 13.43 15 13.37 15.17C13.31 15.34 13.22 15.49 13.1 15.62C12.98 15.75 12.83 15.86 12.65 15.93C12.47 16 12.26 16.05 12.01 16.05C11.83 16.05 11.65 16.02 11.48 15.97C11.31 15.92 11.16 15.83 11.02 15.73C10.88 15.63 10.78 15.49 10.7 15.34C10.62 15.19 10.57 15.01 10.57 14.81H11.41C11.43 14.99 11.49 15.13 11.6 15.22C11.71 15.31 11.85 15.37 12.02 15.37C12.13 15.37 12.22 15.35 12.29 15.31C12.36 15.27 12.43 15.21 12.47 15.14C12.51 15.07 12.55 14.99 12.58 14.89C12.61 14.79 12.61 14.69 12.61 14.58C12.61 14.47 12.6 14.37 12.57 14.27C12.54 14.17 12.5 14.1 12.44 14.03C12.38 13.96 12.31 13.91 12.23 13.88C12.15 13.85 12.04 13.83 11.93 13.83C11.85 13.83 11.78 13.84 11.73 13.85C11.68 13.86 11.62 13.88 11.58 13.9C11.54 13.92 11.5 13.95 11.46 13.97C11.42 13.99 11.39 14.03 11.36 14.06L10.69 13.9V13.9Z",
    fill: "currentColor"
  })));
}, "IconReplay_5");
import UW from "classnames";
var zW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReplay } from '@aws-amplify/ui-react'; \u2192 import { MdReplay } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5V1L7 6L12 11V7C15.31 7 18 9.69 18 13C18 16.31 15.31 19 12 19C8.69 19 6 16.31 6 13H4C4 17.42 7.58 21 12 21C16.42 21 20 17.42 20 13C20 8.58 16.42 5 12 5Z",
    fill: "currentColor"
  })));
}, "IconReplay");
import XW from "classnames";
var KW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReplyAll } from '@aws-amplify/ui-react'; \u2192 import { MdReplyAll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 8V5L0 12L7 19V16L3 12L7 8ZM13 9V5L6 12L13 19V14.9C18 14.9 21.5 16.5 24 20C23 15 20 10 13 9Z",
    fill: "currentColor"
  })));
}, "IconReplyAll");
import qW from "classnames";
var QW = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReply } from '@aws-amplify/ui-react'; \u2192 import { MdReply } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 9V5L3 12L10 19V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z",
    fill: "currentColor"
  })));
}, "IconReply");
import JW from "classnames";
var $W = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReportGmailerrorred } from '@aws-amplify/ui-react'; \u2192 import { MdReportGmailerrorred } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5H14.9L19 9.1V14.9V14.9Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11 7H13V14H11V7Z",
    fill: "black"
  })));
}, "IconReportGmailerrorred");
import RW from "classnames";
var ek = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReportOff } from '@aws-amplify/ui-react'; \u2192 import { MdReportOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RW(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.09997 5H14.9L19 9.1V14.9L18.78 15.12L20.2 16.53L21 15.73V8.27L15.73 3H8.26997L7.46997 3.8L8.87997 5.22L9.09997 5Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13 9.33008V7.00008H11V7.33008L13 9.33008ZM2.41 1.58008L1 2.99008L4.64 6.63008L3 8.27008V15.7301L8.27 21.0001H15.73L17.37 19.3601L21.01 23.0001L22.42 21.5901L2.41 1.58008ZM14.9 19.0001H9.1L5 14.9001V9.10008L6.05 8.05008L15.95 17.9501L14.9 19.0001Z",
    fill: "black"
  })));
}, "IconReportOff");
import ok from "classnames";
var tk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReportProblem } from '@aws-amplify/ui-react'; \u2192 import { MdReportProblem } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ok(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z",
    fill: "currentColor"
  })));
}, "IconReportProblem");
import rk from "classnames";
var ik = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconReport } from '@aws-amplify/ui-react'; \u2192 import { MdReport } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3ZM19 14.9L14.9 19H9.1L5 14.9V9.1L9.1 5H14.9L19 9.1V14.9V14.9Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11 7H13V14H11V7Z",
    fill: "black"
  })));
}, "IconReport");
import sk from "classnames";
var ak = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRequestPage } from '@aws-amplify/ui-react'; \u2192 import { MdRequestPage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13.17 4L18 8.83V20H6V4H13.17ZM14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM15 11H11V12H14C14.55 12 15 12.45 15 13V16C15 16.55 14.55 17 14 17H13V18H11V17H9V15H13V14H10C9.45 14 9 13.55 9 13V10C9 9.45 9.45 9 10 9H11V8H13V9H15V11Z",
    fill: "currentColor"
  })));
}, "IconRequestPage");
import nk from "classnames";
var mk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRequestQuote } from '@aws-amplify/ui-react'; \u2192 import { MdRequestQuote } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM6 20V4H13V8H18V20H6ZM11 19H13V18H14C14.55 18 15 17.55 15 17V14C15 13.45 14.55 13 14 13H11V12H15V10H13V9H11V10H10C9.45 10 9 10.45 9 11V14C9 14.55 9.45 15 10 15H13V16H9V18H11V19Z",
    fill: "currentColor"
  })));
}, "IconRequestQuote");
import ck from "classnames";
var lk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRestaurantMenu } from '@aws-amplify/ui-react'; \u2192 import { MdRestaurantMenu } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ck(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.10023 13.34L10.9302 10.51L3.91023 3.49996C2.35023 5.05996 2.35023 7.58996 3.91023 9.15996L8.10023 13.34V13.34ZM14.8802 11.53C16.4102 12.24 18.5602 11.74 20.1502 10.15C22.0602 8.23996 22.4302 5.49996 20.9602 4.02996C19.5002 2.56996 16.7602 2.92996 14.8402 4.83996C13.2502 6.42996 12.7502 8.57996 13.4602 10.11L3.70023 19.87L5.11023 21.28L12.0002 14.41L18.8802 21.29L20.2902 19.88L13.4102 13L14.8802 11.53V11.53Z",
    fill: "currentColor"
  })));
}, "IconRestaurantMenu");
import pk from "classnames";
var hk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRestaurant } from '@aws-amplify/ui-react'; \u2192 import { MdRestaurant } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 6V14H19V22H21V2C18.24 2 16 4.24 16 6ZM11 9H9V2H7V9H5V2H3V9C3 11.21 4.79 13 7 13V22H9V13C11.21 13 13 11.21 13 9V2H11V9Z",
    fill: "currentColor"
  })));
}, "IconRestaurant");
import fk from "classnames";
var Ck = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRestoreFromTrash } from '@aws-amplify/ui-react'; \u2192 import { MdRestoreFromTrash } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5ZM6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 14V9H16V19H8V14ZM10 18H14V14H16L12 10L8 14H10V18Z",
    fill: "currentColor"
  })));
}, "IconRestoreFromTrash");
import gk from "classnames";
var uk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRestorePage } from '@aws-amplify/ui-react'; \u2192 import { MdRestorePage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13.17L18 8.83V20ZM8.45 10.57L7.28 9.4V13H10.88L9.44 11.56C9.96 10.55 11.02 9.85 12.23 9.85C13.97 9.85 15.38 11.26 15.38 13C15.38 14.74 13.97 16.15 12.23 16.15C11.16 16.15 10.21 15.61 9.65 14.8H8.1C8.79 16.38 10.38 17.5 12.22 17.5C14.7 17.5 16.72 15.48 16.72 13C16.72 10.52 14.7 8.5 12.22 8.5C10.63 8.5 9.25 9.33 8.45 10.57V10.57Z",
    fill: "currentColor"
  })));
}, "IconRestorePage");
import wk from "classnames";
var dk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRestore } from '@aws-amplify/ui-react'; \u2192 import { MdRestore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 3C8.03 3 4 7.03 4 12H1L5 15.99L9 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.07 19 9.32 18.21 8.06 16.94L6.64 18.36C8.27 19.99 10.51 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.25 15.52L17.02 14.24L13.5 12.15V8H12Z",
    fill: "currentColor"
  })));
}, "IconRestore");
import Vk from "classnames";
var Hk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRingVolume } from '@aws-amplify/ui-react'; \u2192 import { MdRingVolume } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Vk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23.71 16.67C20.66 13.78 16.54 12 12 12C7.46 12 3.34 13.78 0.29 16.67C0.11 16.85 0 17.1 0 17.38C0 17.66 0.11 17.91 0.29 18.09L2.77 20.57C2.95 20.75 3.2 20.86 3.48 20.86C3.75 20.86 4 20.75 4.18 20.58C4.97 19.84 5.87 19.22 6.84 18.73C7.17 18.57 7.4 18.23 7.4 17.83V14.73C8.85 14.25 10.4 14 12 14C13.6 14 15.15 14.25 16.6 14.72V17.82C16.6 18.21 16.83 18.56 17.16 18.72C18.14 19.21 19.03 19.84 19.82 20.57C20 20.75 20.25 20.85 20.52 20.85C20.8 20.85 21.05 20.74 21.23 20.56L23.71 18.08C23.89 17.9 24 17.65 24 17.37C24 17.1 23.89 16.85 23.71 16.67V16.67ZM5.4 17.23C4.74 17.6 4.11 18.03 3.53 18.5L2.46 17.43C3.37 16.68 4.36 16.04 5.41 15.53V17.23H5.4ZM20.47 18.49C19.88 18.01 19.26 17.59 18.6 17.22V15.52C19.64 16.03 20.63 16.67 21.54 17.42L20.47 18.49ZM21.16 6.26L19.75 4.85L16.19 8.4L17.6 9.81C17.6 9.81 21.05 6.29 21.16 6.26V6.26ZM11 2H13V7H11V2ZM6.4 9.81L7.81 8.4L4.26 4.84L2.84 6.26C2.95 6.29 6.4 9.81 6.4 9.81V9.81Z",
    fill: "currentColor"
  })));
}, "IconRingVolume");
import Mk from "classnames";
var xk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRoofing } from '@aws-amplify/ui-react'; \u2192 import { MdRoofing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Mk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 18H11V16H13V18ZM15 14H9V20H15V14ZM19 9.3V4H16V6.6L12 3L2 12H5L12 5.69L19 12H22L19 9.3Z",
    fill: "currentColor"
  })));
}, "IconRoofing");
import Ik from "classnames";
var Lk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRoomPreferences } from '@aws-amplify/ui-react'; \u2192 import { MdRoomPreferences } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ik(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.69 16.37L22.83 15.37L21.83 13.64L20.38 14.13C20.06 13.86 19.7 13.65 19.3 13.5L19 12H17L16.7 13.49C16.3 13.64 15.94 13.85 15.62 14.12L14.17 13.63L13.17 15.36L14.31 16.36C14.23 16.86 14.23 17.12 14.31 17.62L13.17 18.62L14.17 20.35L15.62 19.86C15.94 20.13 16.3 20.34 16.7 20.49L17 22H19L19.3 20.51C19.7 20.36 20.06 20.15 20.38 19.88L21.83 20.37L22.83 18.64L21.69 17.64C21.77 17.13 21.77 16.87 21.69 16.37ZM18 19C16.9 19 16 18.1 16 17C16 15.9 16.9 15 18 15C19.1 15 20 15.9 20 17C20 18.1 19.1 19 18 19ZM19 4V10H17V6H15V12H13V5H7V19H12V21H3V19H5V3H15V4H19ZM12 13H10V11H12V13Z",
    fill: "currentColor"
  })));
}, "IconRoomPreferences");
import vk from "classnames";
var Nk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRoomService } from '@aws-amplify/ui-react'; \u2192 import { MdRoomService } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.98 17H2V19H22V17H18.98ZM21 16C20.73 11.93 17.75 8.6 13.84 7.79C13.94 7.55 14 7.28 14 7C14 5.9 13.1 5 12 5C10.9 5 10 5.9 10 7C10 7.28 10.06 7.55 10.16 7.79C6.25 8.6 3.27 11.93 3 16H21ZM12 9.58C14.95 9.58 17.47 11.41 18.5 13.99H5.5C6.53 11.41 9.05 9.58 12 9.58Z",
    fill: "currentColor"
  })));
}, "IconRoomService");
import yk from "classnames";
var bk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRoom } from '@aws-amplify/ui-react'; \u2192 import { MdRoom } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.92 16.21 7 11.85 7 9Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z",
    fill: "black"
  })));
}, "IconRoom");
import Zk from "classnames";
var Bk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRotate_90DegreesCcw } from '@aws-amplify/ui-react'; \u2192 import { MdRotate_90DegreesCcw } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Zk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.34011 6.40977L0.860107 12.8998L7.35011 19.3798L13.8401 12.8998L7.34011 6.40977V6.40977ZM3.69011 12.8998L7.35011 9.23977L11.0001 12.8998L7.34011 16.5598L3.69011 12.8998V12.8998ZM19.3601 6.63977C17.6101 4.87977 15.3001 3.99977 13.0001 3.99977V0.759766L8.76011 4.99977L13.0001 9.23977V5.99977C14.7901 5.99977 16.5801 6.67977 17.9501 8.04977C20.6801 10.7798 20.6801 15.2198 17.9501 17.9498C16.5801 19.3198 14.7901 19.9998 13.0001 19.9998C12.0301 19.9998 11.0601 19.7898 10.1601 19.3898L8.67011 20.8798C10.0201 21.6198 11.5101 21.9998 13.0001 21.9998C15.3001 21.9998 17.6101 21.1198 19.3601 19.3598C22.8801 15.8498 22.8801 10.1498 19.3601 6.63977V6.63977Z",
    fill: "currentColor"
  })));
}, "IconRotate_90DegreesCcw");
import Wk from "classnames";
var kk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRotateLeft } from '@aws-amplify/ui-react'; \u2192 import { MdRotateLeft } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Wk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.11007 8.53L5.70007 7.11C4.80007 8.27 4.24007 9.61 4.07007 11H6.09007C6.23007 10.13 6.58007 9.28 7.11007 8.53V8.53ZM6.09007 13H4.07007C4.24007 14.39 4.79007 15.73 5.69007 16.89L7.10007 15.47C6.58007 14.72 6.23007 13.88 6.09007 13V13ZM7.10007 18.32C8.26007 19.22 9.61007 19.76 11.0001 19.93V17.9C10.1301 17.75 9.29007 17.41 8.54007 16.87L7.10007 18.32ZM13.0001 4.07V1L8.45007 5.55L13.0001 10V6.09C15.8401 6.57 18.0001 9.03 18.0001 12C18.0001 14.97 15.8401 17.43 13.0001 17.91V19.93C16.9501 19.44 20.0001 16.08 20.0001 12C20.0001 7.92 16.9501 4.56 13.0001 4.07Z",
    fill: "currentColor"
  })));
}, "IconRotateLeft");
import Dk from "classnames";
var Pk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRotateRight } from '@aws-amplify/ui-react'; \u2192 import { MdRotateRight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Dk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.55 5.55L11 1V4.07C7.06 4.56 4 7.92 4 12C4 16.08 7.05 19.44 11 19.93V17.91C8.16 17.43 6 14.97 6 12C6 9.03 8.16 6.57 11 6.09V10L15.55 5.55ZM19.93 11C19.76 9.61 19.21 8.27 18.31 7.11L16.89 8.53C17.43 9.28 17.77 10.13 17.91 11H19.93ZM13 17.9V19.92C14.39 19.75 15.74 19.21 16.9 18.31L15.46 16.87C14.71 17.41 13.87 17.76 13 17.9ZM16.89 15.48L18.31 16.89C19.21 15.73 19.76 14.39 19.93 13H17.91C17.77 13.87 17.43 14.72 16.89 15.48V15.48Z",
    fill: "currentColor"
  })));
}, "IconRotateRight");
import Sk from "classnames";
var jk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRoundedCorner } from '@aws-amplify/ui-react'; \u2192 import { MdRoundedCorner } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Sk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 19H21V21H19V19ZM19 17H21V15H19V17ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM3 5H5V3H3V5ZM7 5H9V3H7V5ZM15 21H17V19H15V21ZM11 21H13V19H11V21ZM15 21H17V19H15V21ZM7 21H9V19H7V21ZM3 21H5V19H3V21ZM21 8C21 5.24 18.76 3 16 3H11V5H16C17.65 5 19 6.35 19 8V13H21V8Z",
    fill: "currentColor"
  })));
}, "IconRoundedCorner");
import Yk from "classnames";
var Fk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRouter } from '@aws-amplify/ui-react'; \u2192 import { MdRouter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Yk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 4.2C17.5 4.2 19 4.8 20.2 5.9L21 5.1C19.6 3.7 17.8 3 16 3C14.2 3 12.4 3.7 11 5.1L11.8 5.9C13 4.8 14.5 4.2 16 4.2ZM12.7 6.7L13.5 7.5C14.2 6.8 15.1 6.5 16 6.5C16.9 6.5 17.8 6.8 18.5 7.5L19.3 6.7C18.4 5.8 17.2 5.3 16 5.3C14.8 5.3 13.6 5.8 12.7 6.7V6.7ZM19 13H17V9H15V13H5C3.9 13 3 13.9 3 15V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V15C21 13.9 20.1 13 19 13ZM19 19H5V15H19V19ZM6 16H8V18H6V16ZM9.5 16H11.5V18H9.5V16ZM13 16H15V18H13V16Z",
    fill: "currentColor"
  })));
}, "IconRouter");
import Tk from "classnames";
var Ak = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRowing } from '@aws-amplify/ui-react'; \u2192 import { MdRowing } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Tk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.5 14.5L4 19L5.5 20.5L9 17H11L8.5 14.5ZM15 1C13.9 1 13 1.9 13 3C13 4.1 13.9 5 15 5C16.1 5 17 4.1 17 3C17 1.9 16.1 1 15 1ZM21 21.01L18 24L15.01 20.99V19.5L7.91 12.41C7.6 12.46 7.3 12.48 7 12.48V10.32C8.66 10.35 10.61 9.45 11.67 8.28L13.07 6.73C13.26 6.52 13.5 6.35 13.76 6.23C14.05 6.09 14.38 6 14.72 6H14.75C15.99 6.01 17 7.02 17 8.26V14.01C17 14.85 16.65 15.62 16.08 16.17L12.5 12.59V10.32C11.87 10.84 11.07 11.34 10.21 11.71L16.5 18H18L21 21.01V21.01Z",
    fill: "currentColor"
  })));
}, "IconRowing");
import Ek from "classnames";
var Ok = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRssFeed } from '@aws-amplify/ui-react'; \u2192 import { MdRssFeed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Ek(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.18 20.0001C7.38398 20.0001 8.36 19.0241 8.36 17.8201C8.36 16.6162 7.38398 15.6401 6.18 15.6401C4.97602 15.6401 4 16.6162 4 17.8201C4 19.0241 4.97602 20.0001 6.18 20.0001Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M4 4.43994V7.26994C11.03 7.26994 16.73 12.9699 16.73 19.9999H19.56C19.56 11.4099 12.59 4.43994 4 4.43994V4.43994ZM4 10.0999V12.9299C7.9 12.9299 11.07 16.0999 11.07 19.9999H13.9C13.9 14.5299 9.47 10.0999 4 10.0999V10.0999Z",
    fill: "black"
  })));
}, "IconRssFeed");
import _k from "classnames";
var Gk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRuleFolder } from '@aws-amplify/ui-react'; \u2192 import { MdRuleFolder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _k(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.83 16L5 13.17L6.41 11.76L7.82 13.17L11.36 9.63L12.77 11.04L7.83 16ZM17.41 13L19 14.59L17.59 16L16 14.41L14.41 16L13 14.59L14.59 13L13 11.41L14.41 10L16 11.59L17.59 10L19 11.41L17.41 13ZM20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18Z",
    fill: "currentColor"
  })));
}, "IconRuleFolder");
import Uk from "classnames";
var zk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRule } from '@aws-amplify/ui-react'; \u2192 import { MdRule } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Uk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.54 11.0002L13 7.46018L14.41 6.05018L16.53 8.17018L20.77 3.93018L22.18 5.34018L16.54 11.0002ZM11 7.00018H2V9.00018H11V7.00018ZM21 13.4102L19.59 12.0002L17 14.5902L14.41 12.0002L13 13.4102L15.59 16.0002L13 18.5902L14.41 20.0002L17 17.4102L19.59 20.0002L21 18.5902L18.41 16.0002L21 13.4102ZM11 15.0002H2V17.0002H11V15.0002Z",
    fill: "currentColor"
  })));
}, "IconRule");
import Xk from "classnames";
var Kk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRunCircle } from '@aws-amplify/ui-react'; \u2192 import { MdRunCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Xk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M13.5401 8.96976C13.3101 8.49976 12.7801 8.25976 12.2801 8.43976L9.0001 9.64976V11.9998H10.0001V10.3498L11.5401 9.77976L10.5801 14.6698L7.8001 14.0998L7.6001 15.0798L11.3601 15.8498L11.8801 13.2098L13.0001 14.4198V17.9998H14.0001V14.0298L12.6801 12.5898L13.0901 10.2398C13.9901 11.4598 15.3001 11.9998 16.0001 11.9998V10.9998C15.5901 10.9998 14.3701 10.6698 13.5401 8.96976Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13.5 8C14.0523 8 14.5 7.55228 14.5 7C14.5 6.44772 14.0523 6 13.5 6C12.9477 6 12.5 6.44772 12.5 7C12.5 7.55228 12.9477 8 13.5 8Z",
    fill: "black"
  })));
}, "IconRunCircle");
import qk from "classnames";
var Qk = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconRvHookup } from '@aws-amplify/ui-react'; \u2192 import { MdRvHookup } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 17V11C20 9.9 19.1 9 18 9H7V7L4 10L7 13V11H11V14H4V17C4 18.1 4.9 19 6 19H8C8 20.66 9.34 22 11 22C12.66 22 14 20.66 14 19H22V17H20ZM11 20C10.45 20 10 19.55 10 19C10 18.45 10.45 18 11 18C11.55 18 12 18.45 12 19C12 19.55 11.55 20 11 20ZM18 14H14V11H18V14ZM17 2V4H9V6H17V8L20 5L17 2Z",
    fill: "currentColor"
  })));
}, "IconRvHookup");
import Jk from "classnames";
var $k = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSanitizer } from '@aws-amplify/ui-react'; \u2192 import { MdSanitizer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Jk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 6.5C15.5 5.66 17 4 17 4C17 4 18.5 5.66 18.5 6.5C18.5 7.33 17.83 8 17 8C16.17 8 15.5 7.33 15.5 6.5ZM19.5 15C20.88 15 22 13.88 22 12.5C22 10.83 19.5 8 19.5 8C19.5 8 17 10.83 17 12.5C17 13.88 18.12 15 19.5 15ZM13 14H11V12H9V14H7V16H9V18H11V16H13V14ZM16 12V20C16 21.1 15.1 22 14 22H6C4.9 22 4 21.1 4 20V12C4 9.03 6.16 6.57 9 6.09V4H7V2H13C14.13 2 15.15 2.39 15.99 3.01L14.56 4.44C14.1 4.17 13.57 4 13 4H11V6.09C13.84 6.57 16 9.03 16 12ZM14 12C14 9.79 12.21 8 10 8C7.79 8 6 9.79 6 12V20H14V12Z",
    fill: "currentColor"
  })));
}, "IconSanitizer");
import Rk from "classnames";
var eD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSatellite } from '@aws-amplify/ui-react'; \u2192 import { MdSatellite } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Rk(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM8.57 6H6V8.58C7.42 8.58 8.57 7.42 8.57 6ZM12 6H10.29C10.29 8.36 8.37 10.29 6 10.29V12C9.32 12 12 9.31 12 6ZM14.14 11.86L11.14 15.73L9 13.15L6 17H18L14.14 11.86Z",
    fill: "currentColor"
  })));
}, "IconSatellite");
import oD from "classnames";
var tD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSaveAlt } from '@aws-amplify/ui-react'; \u2192 import { MdSaveAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 12V19H5V12H3V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V12H19ZM13 12.67L15.59 10.09L17 11.5L12 16.5L7 11.5L8.41 10.09L11 12.67V3H13V12.67Z",
    fill: "currentColor"
  })));
}, "IconSaveAlt");
import rD from "classnames";
var iD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSave } from '@aws-amplify/ui-react'; \u2192 import { MdSave } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM19 19H5V5H16.17L19 7.83V19ZM12 12C10.34 12 9 13.34 9 15C9 16.66 10.34 18 12 18C13.66 18 15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6H15V10H6V6Z",
    fill: "currentColor"
  })));
}, "IconSave");
import sD from "classnames";
var aD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScanner } from '@aws-amplify/ui-react'; \u2192 import { MdScanner } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.8 10.7L4.2 5L3.5 6.9L17.6 12H5C3.9 12 3 12.9 3 14V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V12.5C21 11.7 20.5 10.9 19.8 10.7ZM19 18H5V14H19V18ZM6 15H8V17H6V15ZM10 15H18V17H10V15Z",
    fill: "currentColor"
  })));
}, "IconScanner");
import nD from "classnames";
var mD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScatterPlot } from '@aws-amplify/ui-react'; \u2192 import { MdScatterPlot } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 18C4.79 18 3 16.21 3 14C3 11.79 4.79 10 7 10C9.21 10 11 11.79 11 14C11 16.21 9.21 18 7 18ZM7 12C5.9 12 5 12.9 5 14C5 15.1 5.9 16 7 16C8.1 16 9 15.1 9 14C9 12.9 8.1 12 7 12ZM11 10C8.79 10 7 8.21 7 6C7 3.79 8.79 2 11 2C13.21 2 15 3.79 15 6C15 8.21 13.21 10 11 10ZM11 4C9.9 4 9 4.9 9 6C9 7.1 9.9 8 11 8C12.1 8 13 7.1 13 6C13 4.9 12.1 4 11 4ZM16.6 21.6C14.39 21.6 12.6 19.81 12.6 17.6C12.6 15.39 14.39 13.6 16.6 13.6C18.81 13.6 20.6 15.39 20.6 17.6C20.6 19.81 18.81 21.6 16.6 21.6ZM16.6 15.6C15.5 15.6 14.6 16.5 14.6 17.6C14.6 18.7 15.5 19.6 16.6 19.6C17.7 19.6 18.6 18.7 18.6 17.6C18.6 16.5 17.7 15.6 16.6 15.6Z",
    fill: "currentColor"
  })));
}, "IconScatterPlot");
import cD from "classnames";
var lD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSchedule } from '@aws-amplify/ui-react'; \u2192 import { MdSchedule } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z",
    fill: "currentColor"
  })));
}, "IconSchedule");
import pD from "classnames";
var hD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSchool } from '@aws-amplify/ui-react'; \u2192 import { MdSchool } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 3L1 9L5 11.18V17.18L12 21L19 17.18V11.18L21 10.09V17H23V9L12 3ZM18.82 9L12 12.72L5.18 9L12 5.28L18.82 9ZM17 15.99L12 18.72L7 15.99V12.27L12 15L17 12.27V15.99Z",
    fill: "currentColor"
  })));
}, "IconSchool");
import fD from "classnames";
var CD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScience } from '@aws-amplify/ui-react'; \u2192 import { MdScience } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13.0002 11.33L18.0002 18H6.00018L11.0002 11.33V6H13.0002V11.33ZM15.9602 4H8.04018C7.62018 4 7.39018 4.48 7.65018 4.81L9.00018 6.5V10.67L3.20018 18.4C2.71018 19.06 3.18018 20 4.00018 20H20.0002C20.8202 20 21.2902 19.06 20.8002 18.4L15.0002 10.67V6.5L16.3502 4.81C16.6102 4.48 16.3802 4 15.9602 4Z",
    fill: "currentColor"
  })));
}, "IconScience");
import gD from "classnames";
var uD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScore } from '@aws-amplify/ui-react'; \u2192 import { MdScore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5L9 15L13 19L19 13V19ZM19 10.5L13 16.5L9 12.5L5 16.5V5H19V10.5ZM13.5 9V6H12V12H13.5V9ZM17.2 12L15.2 9L17.2 6H15.5L13.5 9L15.5 12H17.2ZM11 10.5H8.5V9.75H11V6H7V7.5H9.5V8.25H7V12H11V10.5Z",
    fill: "currentColor"
  })));
}, "IconScore");
import wD from "classnames";
var dD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScreenLockLandscape } from '@aws-amplify/ui-react'; \u2192 import { MdScreenLockLandscape } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 5H3C1.9 5 1 5.9 1 7V17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5ZM19 17H5V7H19V17ZM10 16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11V10C14 8.89 13.1 8 12 8C10.89 8 10 8.9 10 10V11C9.45 11 9 11.45 9 12V15C9 15.55 9.45 16 10 16ZM10.8 10C10.8 9.34 11.34 8.8 12 8.8C12.66 8.8 13.2 9.34 13.2 10V11H10.8V10V10Z",
    fill: "currentColor"
  })));
}, "IconScreenLockLandscape");
import VD from "classnames";
var HD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScreenLockPortrait } from '@aws-amplify/ui-react'; \u2192 import { MdScreenLockPortrait } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 16H14C14.55 16 15 15.55 15 15V12C15 11.45 14.55 11 14 11V10C14 8.89 13.1 8 12 8C10.89 8 10 8.9 10 10V11C9.45 11 9 11.45 9 12V15C9 15.55 9.45 16 10 16ZM10.8 10C10.8 9.34 11.34 8.8 12 8.8C12.66 8.8 13.2 9.34 13.2 10V11H10.8V10V10ZM17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 19H7V5H17V19Z",
    fill: "currentColor"
  })));
}, "IconScreenLockPortrait");
import MD from "classnames";
var xD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScreenLockRotation } from '@aws-amplify/ui-react'; \u2192 import { MdScreenLockRotation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: MD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22.3 13.77L19.73 11.2L18.32 12.61L20.5401 14.83L14.88 20.49L3.56005 9.17L9.22005 3.51L11.32 5.61L12.73 4.2L10.28 1.75C9.69005 1.16 8.74005 1.16 8.16005 1.75L1.80005 8.11C1.21005 8.7 1.21005 9.65 1.80005 10.23L13.82 22.25C14.41 22.84 15.36 22.84 15.94 22.25L22.3 15.89C22.89 15.3 22.89 14.35 22.3 13.77ZM7.52005 21.48C4.25005 19.94 1.91005 16.76 1.55005 13H0.0500488C0.560049 19.16 5.71005 24 12 24L12.66 23.97L8.85005 20.15L7.52005 21.48V21.48ZM15.05 10H20.05C20.6 10 21.05 9.55 21.05 9V5C21.05 4.45 20.6 4 20.05 4V3.5C20.05 2.12 18.93 1 17.55 1C16.17 1 15.05 2.12 15.05 3.5V4C14.5 4 14.05 4.45 14.05 5V9C14.05 9.55 14.5 10 15.05 10ZM15.85 3.5C15.85 2.56 16.61 1.8 17.55 1.8C18.49 1.8 19.25 2.56 19.25 3.5V4H15.85V3.5V3.5Z",
    fill: "currentColor"
  })));
}, "IconScreenLockRotation");
import ID from "classnames";
var LD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScreenRotation } from '@aws-amplify/ui-react'; \u2192 import { MdScreenRotation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ID(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.48 2.52C19.75 4.07 22.0901 7.24 22.4501 11H23.9501C23.4401 4.84 18.29 0 12 0L11.34 0.03L15.15 3.84L16.48 2.52V2.52ZM10.23 1.75C9.64005 1.16 8.69005 1.16 8.11005 1.75L1.75005 8.11C1.16005 8.7 1.16005 9.65 1.75005 10.23L13.77 22.25C14.36 22.84 15.31 22.84 15.89 22.25L22.25 15.89C22.84 15.3 22.84 14.35 22.25 13.77L10.23 1.75ZM14.83 21.19L2.81005 9.17L9.17005 2.81L21.1901 14.83L14.83 21.19V21.19ZM7.52005 21.48C4.25005 19.94 1.91005 16.76 1.55005 13H0.0500488C0.560049 19.16 5.71005 24 12 24L12.66 23.97L8.85005 20.16L7.52005 21.48V21.48Z",
    fill: "currentColor"
  })));
}, "IconScreenRotation");
import vD from "classnames";
var ND = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconScreenShare } from '@aws-amplify/ui-react'; \u2192 import { MdScreenShare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 18C21.1 18 21.99 17.1 21.99 16L22 6C22 4.89 21.1 4 20 4H4C2.89 4 2 4.89 2 6V16C2 17.1 2.89 18 4 18H0V20H24V18H20ZM4 16V6H20V16.01L4 16ZM13 9.13C9.11 9.67 7.56 12.33 7 15C8.39 13.13 10.22 12.28 13 12.28V14.47L17 10.73L13 7V9.13Z",
    fill: "currentColor"
  })));
}, "IconScreenShare");
import yD from "classnames";
var bD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSdCardAlert } from '@aws-amplify/ui-react'; \u2192 import { MdSdCardAlert } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 2H10L4.02 8L4 20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H6V8.83L10.83 4H18V20ZM11 15H13V17H11V15ZM11 8H13V13H11V8Z",
    fill: "currentColor"
  })));
}, "IconSdCardAlert");
import ZD from "classnames";
var BD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSdCard } from '@aws-amplify/ui-react'; \u2192 import { MdSdCard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 20H6V8.83L10.83 4H18V20ZM9 7H11V11H9V7ZM12 7H14V11H12V7ZM15 7H17V11H15V7Z",
    fill: "currentColor"
  })));
}, "IconSdCard");
import WD from "classnames";
var kD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSdStorage } from '@aws-amplify/ui-react'; \u2192 import { MdSdStorage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 4V20H6V8.83L10.83 4H18ZM18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 7H11V11H9V7ZM12 7H14V11H12V7ZM15 7H17V11H15V7Z",
    fill: "currentColor"
  })));
}, "IconSdStorage");
import DD from "classnames";
var PD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSearchOff } from '@aws-amplify/ui-react'; \u2192 import { MdSearchOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.50001 3C6.08001 3 3.28001 5.64 3.03001 9H5.05001C5.30001 6.75 7.18001 5 9.50001 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.50001 14C9.33001 14 9.17001 13.97 9.00001 13.95V15.97C9.17001 15.99 9.33001 16 9.50001 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M6.47001 10.8198L4.00001 13.2898L1.53001 10.8198L0.820007 11.5298L3.29001 13.9998L0.820007 16.4698L1.53001 17.1798L4.00001 14.7098L6.47001 17.1798L7.18001 16.4698L4.71001 13.9998L7.18001 11.5298L6.47001 10.8198Z",
    fill: "black"
  })));
}, "IconSearchOff");
import SD from "classnames";
var St = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z",
    fill: "currentColor"
  })));
}, "IconSearch");
import jD from "classnames";
var YD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSecurity } from '@aws-amplify/ui-react'; \u2192 import { MdSecurity } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z",
    fill: "currentColor"
  })));
}, "IconSecurity");
import FD from "classnames";
var TD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSelectAll } from '@aws-amplify/ui-react'; \u2192 import { MdSelectAll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5H5V3C3.9 3 3 3.9 3 5ZM3 13H5V11H3V13ZM7 21H9V19H7V21ZM3 9H5V7H3V9ZM13 3H11V5H13V3ZM19 3V5H21C21 3.9 20.1 3 19 3ZM5 21V19H3C3 20.1 3.9 21 5 21ZM3 17H5V15H3V17ZM9 3H7V5H9V3ZM11 21H13V19H11V21ZM19 13H21V11H19V13ZM19 21C20.1 21 21 20.1 21 19H19V21ZM19 9H21V7H19V9ZM19 17H21V15H19V17ZM15 21H17V19H15V21ZM15 5H17V3H15V5ZM7 17H17V7H7V17ZM9 9H15V15H9V9Z",
    fill: "currentColor"
  })));
}, "IconSelectAll");
import AD from "classnames";
var ED = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSelfImprovement } from '@aws-amplify/ui-react'; \u2192 import { MdSelfImprovement } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M21 16V14C18.76 14 16.84 13.04 15.4 11.32L14.06 9.72C13.68 9.26 13.12 9 12.53 9H11.48C10.89 9 10.33 9.26 9.95 9.72L8.61 11.32C7.16 13.04 5.24 14 3 14V16C5.77 16 8.19 14.83 10 12.75V15L6.12 16.55C5.45 16.82 5 17.48 5 18.21C5 19.2 5.8 20 6.79 20H9V19.5C9 18.12 10.12 17 11.5 17H14.5C14.78 17 15 17.22 15 17.5C15 17.78 14.78 18 14.5 18H11.5C10.67 18 10 18.67 10 19.5V20H17.21C18.2 20 19 19.2 19 18.21C19 17.48 18.55 16.82 17.88 16.55L14 15V12.75C15.81 14.83 18.23 16 21 16Z",
    fill: "black"
  })));
}, "IconSelfImprovement");
import OD from "classnames";

var _D = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSend } from '@aws-amplify/ui-react'; \u2192 import { MdSend } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4.01 6.03L11.52 9.25L4 8.25L4.01 6.03V6.03ZM11.51 14.75L4 17.97V15.75L11.51 14.75V14.75ZM2.01 3L2 10L17 12L2 14L2.01 21L23 12L2.01 3Z",
    fill: "currentColor"
  })));
}, "IconSend");

import GD from "classnames";
var UD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSensorDoor } from '@aws-amplify/ui-react'; \u2192 import { MdSensorDoor } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 4V20H6V4H18ZM18 2H6C4.9 2 4 2.9 4 4V22H20V4C20 2.9 19.1 2 18 2ZM15.5 10.5C14.67 10.5 14 11.17 14 12C14 12.83 14.67 13.5 15.5 13.5C16.33 13.5 17 12.83 17 12C17 11.17 16.33 10.5 15.5 10.5Z",
    fill: "currentColor"
  })));
}, "IconSensorDoor");
import zD from "classnames";
var XD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSensorWindow } from '@aws-amplify/ui-react'; \u2192 import { MdSensorWindow } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 4V11H14V10H10V11H6V4H18ZM6 20V13H18V20H6Z",
    fill: "currentColor"
  })));
}, "IconSensorWindow");
import KD from "classnames";
var qD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSentimentDissatisfied } from '@aws-amplify/ui-react'; \u2192 import { MdSentimentDissatisfied } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 14C9.67 14 7.68 15.45 6.88 17.5H8.55C9.24 16.31 10.52 15.5 12 15.5C13.48 15.5 14.75 16.31 15.45 17.5H17.12C16.32 15.45 14.33 14 12 14V14ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "black"
  })));
}, "IconSentimentDissatisfied");
import QD from "classnames";
var JD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSentimentNeutral } from '@aws-amplify/ui-react'; \u2192 import { MdSentimentNeutral } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QD(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 14H15V15.5H9V14Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "black"
  })));
}, "IconSentimentNeutral");
import $D from "classnames";
var RD = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSentimentSatisfiedAlt } from '@aws-amplify/ui-react'; \u2192 import { MdSentimentSatisfiedAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $D(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 16C10.52 16 9.25 15.19 8.55 14H6.88C7.68 16.05 9.67 17.5 12 17.5C14.33 17.5 16.32 16.05 17.12 14H15.45C14.76 15.19 13.48 16 12 16ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "black"
  })));
}, "IconSentimentSatisfiedAlt");
import eP from "classnames";
var oP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSentimentSatisfied } from '@aws-amplify/ui-react'; \u2192 import { MdSentimentSatisfied } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 16C10.52 16 9.25 15.19 8.55 14H6.88C7.68 16.05 9.67 17.5 12 17.5C14.33 17.5 16.32 16.05 17.12 14H15.45C14.75 15.19 13.48 16 12 16ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    fill: "black"
  })));
}, "IconSentimentSatisfied");
import tP from "classnames";
var rP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSentimentVeryDissatisfied } from '@aws-amplify/ui-react'; \u2192 import { MdSentimentVeryDissatisfied } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 13.5C9.67 13.5 7.69 14.96 6.89 17H17.11C16.31 14.96 14.33 13.5 12 13.5ZM7.82 12L8.88 10.94L9.94 12L11 10.94L9.94 9.88L11 8.82L9.94 7.76L8.88 8.82L7.82 7.76L6.76 8.82L7.82 9.88L6.76 10.94L7.82 12ZM11.99 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 11.99 22C17.51 22 22 17.53 22 12C22 6.47 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM16.18 7.76L15.12 8.82L14.06 7.76L13 8.82L14.06 9.88L13 10.94L14.06 12L15.12 10.94L16.18 12L17.24 10.94L16.18 9.88L17.24 8.82L16.18 7.76Z",
    fill: "currentColor"
  })));
}, "IconSentimentVeryDissatisfied");
import iP from "classnames";
var sP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSentimentVerySatisfied } from '@aws-amplify/ui-react'; \u2192 import { MdSentimentVerySatisfied } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 11.99 22C17.51 22 22 17.53 22 12C22 6.47 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM13 9.94L14.06 11L15.12 9.94L16.18 11L17.24 9.94L15.12 7.82L13 9.94ZM8.88 9.94L9.94 11L11 9.94L8.88 7.82L6.76 9.94L7.82 11L8.88 9.94V9.94ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z",
    fill: "currentColor"
  })));
}, "IconSentimentVerySatisfied");
import aP from "classnames";
var nP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSetMeal } from '@aws-amplify/ui-react'; \u2192 import { MdSetMeal } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.05 17.56L3.08 18.5L3 17L20.98 16.06L21.05 17.56ZM21 19.48H3V20.98H21V19.48ZM23 13V4C23 2.9 22.1 2 21 2H3C1.9 2 1 2.9 1 4V13C1 14.1 1.9 15 3 15H21C22.1 15 23 14.1 23 13ZM21 13H3V4H21V13ZM20 6C18.32 6 16.96 6.98 16.79 8.23C16.15 7.5 14.06 5.5 10.25 5.5C5.58 5.5 3.5 8.5 3.5 8.5C3.5 8.5 5.58 11.5 10.25 11.5C14.06 11.5 16.15 9.5 16.79 8.77C16.96 10.02 18.32 11 20 11V6Z",
    fill: "currentColor"
  })));
}, "IconSetMeal");
import mP from "classnames";
var cP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsApplications } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsApplications } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.21 13.97L7.41 16.04C7.49 16.17 7.64 16.22 7.78 16.17L9.27 15.57C9.58 15.81 9.91 16.01 10.28 16.16L10.5 17.75C10.53 17.89 10.65 18 10.8 18H13.2C13.35 18 13.47 17.89 13.5 17.74L13.72 16.15C14.08 16 14.42 15.8 14.73 15.56L16.22 16.16C16.36 16.21 16.51 16.16 16.59 16.03L17.79 13.96C17.87 13.83 17.83 13.67 17.72 13.57L16.45 12.58C16.48 12.39 16.49 12.19 16.49 12C16.49 11.8 16.47 11.61 16.45 11.41L17.72 10.42C17.83 10.33 17.87 10.16 17.79 10.03L16.59 7.96C16.51 7.83 16.36 7.78 16.22 7.83L14.73 8.43C14.42 8.19 14.09 7.99 13.72 7.84L13.5 6.25C13.47 6.11 13.35 6 13.2 6H10.8C10.65 6 10.53 6.11 10.5 6.26L10.28 7.85C9.92 8 9.57 8.19 9.27 8.43L7.78 7.83C7.64 7.78 7.49 7.83 7.41 7.96L6.21 10.03C6.13 10.16 6.17 10.32 6.28 10.42L7.55 11.41C7.52 11.61 7.5 11.8 7.5 12C7.5 12.2 7.52 12.39 7.54 12.59L6.27 13.58C6.16 13.68 6.13 13.84 6.21 13.97ZM12 10.29C12.94 10.29 13.71 11.06 13.71 12C13.71 12.94 12.94 13.71 12 13.71C11.06 13.71 10.29 12.94 10.29 12C10.29 11.06 11.06 10.29 12 10.29ZM19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconSettingsApplications");
import lP from "classnames";
var pP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsBackupRestore } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsBackupRestore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12ZM12 3C7.03 3 3 7.03 3 12H0L4 16L8 12H5C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19C10.49 19 9.09 18.51 7.94 17.7L6.52 19.14C8.04 20.3 9.94 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3Z",
    fill: "currentColor"
  })));
}, "IconSettingsBackupRestore");
import hP from "classnames";
var fP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsBluetooth } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsBluetooth } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 24H13V22H11V24ZM7 24H9V22H7V24ZM15 24H17V22H15V24ZM17.71 5.71L12 0H11V7.59L6.41 3L5 4.41L10.59 10L5 15.59L6.41 17L11 12.41V20H12L17.71 14.29L13.41 10L17.71 5.71V5.71ZM13 3.83L14.88 5.71L13 7.59V3.83ZM14.88 14.29L13 16.17V12.41L14.88 14.29V14.29Z",
    fill: "currentColor"
  })));
}, "IconSettingsBluetooth");
import CP from "classnames";
var gP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsBrightness } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsBrightness } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01V19.01ZM8 16H10.5L12 17.5L13.5 16H16V13.5L17.5 12L16 10.5V8H13.5L12 6.5L10.5 8H8V10.5L6.5 12L8 13.5V16ZM12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15V9Z",
    fill: "currentColor"
  })));
}, "IconSettingsBrightness");
import uP from "classnames";
var wP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsCell } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsCell } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 22H9V24H7V22ZM11 22H13V24H11V22ZM15 22H17V24H15V22ZM16 0.01L8 0C6.9 0 6 0.9 6 2V18C6 19.1 6.9 20 8 20H16C17.1 20 18 19.1 18 18V2C18 0.9 17.1 0.01 16 0.01V0.01ZM16 18H8V17H16V18ZM16 15H8V5H16V15ZM16 3H8V2H16V3Z",
    fill: "currentColor"
  })));
}, "IconSettingsCell");
import dP from "classnames";
var VP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsEthernet } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsEthernet } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.77 6.75998L6.23 5.47998L0.82 12L6.23 18.52L7.77 17.24L3.42 12L7.77 6.75998ZM7 13H9V11H7V13ZM17 11H15V13H17V11ZM11 13H13V11H11V13ZM17.77 5.47998L16.23 6.75998L20.58 12L16.23 17.24L17.77 18.52L23.18 12L17.77 5.47998Z",
    fill: "currentColor"
  })));
}, "IconSettingsEthernet");
import HP from "classnames";
var MP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsInputAntenna } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsInputAntenna } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5C8.13 5 5 8.13 5 12H7C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12H19C19 8.13 15.87 5 12 5ZM13 14.29C13.88 13.9 14.5 13.03 14.5 12C14.5 10.62 13.38 9.5 12 9.5C10.62 9.5 9.5 10.62 9.5 12C9.5 13.02 10.12 13.9 11 14.29V17.59L7.59 21L9 22.41L12 19.41L15 22.41L16.41 21L13 17.59V14.29ZM12 1C5.93 1 1 5.93 1 12H3C3 7.03 7.03 3 12 3C16.97 3 21 7.03 21 12H23C23 5.93 18.07 1 12 1Z",
    fill: "currentColor"
  })));
}, "IconSettingsInputAntenna");
import xP from "classnames";
var IP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsInputComponent } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsInputComponent } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 2C5 1.45 4.55 1 4 1C3.45 1 3 1.45 3 2V6H1V16C1 17.3 1.84 18.4 3 18.82V23H5V18.82C6.16 18.4 7 17.3 7 16V6H5V2ZM4 17C3.45 17 3 16.55 3 16V14H5V16C5 16.55 4.55 17 4 17ZM3 12V8H5V12H3ZM13 2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V6H9V16C9 17.3 9.84 18.4 11 18.82V23H13V18.82C14.16 18.4 15 17.3 15 16V6H13V2ZM12 17C11.45 17 11 16.55 11 16V14H13V16C13 16.55 12.55 17 12 17ZM11 12V8H13V12H11ZM21 6V2C21 1.45 20.55 1 20 1C19.45 1 19 1.45 19 2V6H17V16C17 17.3 17.84 18.4 19 18.82V23H21V18.82C22.16 18.4 23 17.3 23 16V6H21ZM20 17C19.45 17 19 16.55 19 16V14H21V16C21 16.55 20.55 17 20 17ZM19 12V8H21V12H19Z",
    fill: "currentColor"
  })));
}, "IconSettingsInputComponent");
import LP from "classnames";
var vP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsInputComposite } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsInputComposite } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 2C5 1.45 4.55 1 4 1C3.45 1 3 1.45 3 2V6H1V16C1 17.3 1.84 18.4 3 18.82V23H5V18.82C6.16 18.4 7 17.3 7 16V6H5V2ZM4 17C3.45 17 3 16.55 3 16V14H5V16C5 16.55 4.55 17 4 17ZM3 12V8H5V12H3ZM13 2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2V6H9V16C9 17.3 9.84 18.4 11 18.82V23H13V18.82C14.16 18.4 15 17.3 15 16V6H13V2ZM12 17C11.45 17 11 16.55 11 16V14H13V16C13 16.55 12.55 17 12 17ZM11 12V8H13V12H11ZM21 6V2C21 1.45 20.55 1 20 1C19.45 1 19 1.45 19 2V6H17V16C17 17.3 17.84 18.4 19 18.82V23H21V18.82C22.16 18.4 23 17.3 23 16V6H21ZM20 17C19.45 17 19 16.55 19 16V14H21V16C21 16.55 20.55 17 20 17ZM19 12V8H21V12H19Z",
    fill: "currentColor"
  })));
}, "IconSettingsInputComposite");
import NP from "classnames";
var yP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsInputHdmi } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsInputHdmi } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 7V4C18 2.9 17.1 2 16 2H8C6.9 2 6 2.9 6 4V7H5V13L8 19V22H16V19L19 13V7H18ZM8 4H16V7H13.99V5H12.99V7H11V5H10V7H8V4ZM17 12.53L14 18.53V20H10V18.53L7 12.53V9H17V12.53Z",
    fill: "currentColor"
  })));
}, "IconSettingsInputHdmi");
import bP from "classnames";
var ZP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsInputSvideo } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsInputSvideo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 11.5C8 10.67 7.33 10 6.5 10C5.67 10 5 10.67 5 11.5C5 12.33 5.67 13 6.5 13C7.33 13 8 12.33 8 11.5ZM15 6.5C15 5.67 14.33 5 13.5 5H10.5C9.67 5 9 5.67 9 6.5C9 7.33 9.67 8 10.5 8H13.5C14.33 8 15 7.33 15 6.5ZM8.5 15C7.67 15 7 15.67 7 16.5C7 17.33 7.67 18 8.5 18C9.33 18 10 17.33 10 16.5C10 15.67 9.33 15 8.5 15ZM12 1C5.93 1 1 5.93 1 12C1 18.07 5.93 23 12 23C18.07 23 23 18.07 23 12C23 5.93 18.07 1 12 1ZM12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21ZM17.5 10C16.67 10 16 10.67 16 11.5C16 12.33 16.67 13 17.5 13C18.33 13 19 12.33 19 11.5C19 10.67 18.33 10 17.5 10ZM15.5 15C14.67 15 14 15.67 14 16.5C14 17.33 14.67 18 15.5 18C16.33 18 17 17.33 17 16.5C17 15.67 16.33 15 15.5 15Z",
    fill: "currentColor"
  })));
}, "IconSettingsInputSvideo");
import BP from "classnames";
var WP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsOverscan } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsOverscan } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.01 5.5L10 8H14L12.01 5.5ZM18 10V14L20.5 12.01L18 10ZM6 10L3.5 12.01L6 14V10ZM14 16H10L12.01 18.5L14 16ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01V19.01Z",
    fill: "currentColor"
  })));
}, "IconSettingsOverscan");
import kP from "classnames";
var DP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsPhone } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsPhone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 9H13V11H11V9ZM15 9H17V11H15V9ZM20 15.5C18.75 15.5 17.55 15.3 16.43 14.93C16.33 14.9 16.22 14.88 16.12 14.88C15.86 14.88 15.61 14.98 15.41 15.17L13.21 17.37C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.58C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.5C21 15.95 20.55 15.5 20 15.5ZM5.03 5H6.53C6.6 5.88 6.75 6.75 6.99 7.59L5.79 8.8C5.38 7.59 5.12 6.32 5.03 5V5ZM19 18.97C17.68 18.88 16.4 18.62 15.2 18.21L16.4 17.01C17.25 17.25 18.12 17.4 19 17.46V18.97ZM19 9H21V11H19V9Z",
    fill: "currentColor"
  })));
}, "IconSettingsPhone");
import PP from "classnames";
var SP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsPower } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsPower } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 24H9V22H7V24ZM11 24H13V22H11V24ZM13 2H11V12H13V2ZM16.56 4.44L15.11 5.89C16.84 6.94 18 8.83 18 11C18 14.31 15.31 17 12 17C8.69 17 6 14.31 6 11C6 8.83 7.16 6.94 8.88 5.88L7.44 4.44C5.36 5.88 4 8.28 4 11C4 15.42 7.58 19 12 19C16.42 19 20 15.42 20 11C20 8.28 18.64 5.88 16.56 4.44V4.44ZM15 24H17V22H15V24Z",
    fill: "currentColor"
  })));
}, "IconSettingsPower");
import jP from "classnames";
var YP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsRemote } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsRemote } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 9H9C8.45 9 8 9.45 8 10V22C8 22.55 8.45 23 9 23H15C15.55 23 16 22.55 16 22V10C16 9.45 15.55 9 15 9ZM14 21H10V11H14V21Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 14C12.5523 14 13 13.5523 13 13C13 12.4477 12.5523 12 12 12C11.4477 12 11 12.4477 11 13C11 13.5523 11.4477 14 12 14Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7.05 6.05L8.46 7.46C9.37 6.56 10.62 6 12 6C13.38 6 14.63 6.56 15.54 7.46L16.95 6.05C15.68 4.78 13.93 4 12 4C10.07 4 8.32 4.78 7.05 6.05ZM12 0C8.96 0 6.21 1.23 4.22 3.22L5.63 4.63C7.26 3.01 9.51 2 12 2C14.49 2 16.74 3.01 18.36 4.64L19.77 3.23C17.79 1.23 15.04 0 12 0Z",
    fill: "black"
  })));
}, "IconSettingsRemote");
import FP from "classnames";
var TP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsSystemDaydream } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsSystemDaydream } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 17H9C6.79 17 5 15.21 5 13C5 11.07 6.36 9.44 8.22 9.08C9.04 7.8 10.47 7 12 7C13.95 7 15.66 8.28 16.26 10.09C17.84 10.45 19 11.84 19 13.5C19 15.43 17.43 17 15.5 17ZM8.74 11.02C7.74 11.15 7 11.99 7 13C7 14.1 7.9 15 9 15H15.5C16.33 15 17 14.33 17 13.5C17 12.67 16.33 12 15.5 12H14.63L14.46 11.14C14.29 9.92 13.23 9 12 9C11.04 9 10.16 9.57 9.74 10.45L9.47 11.02H8.74ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19.01H3V4.99H21V19.01V19.01Z",
    fill: "currentColor"
  })));
}, "IconSettingsSystemDaydream");
import AP from "classnames";
var EP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettingsVoice } from '@aws-amplify/ui-react'; \u2192 import { MdSettingsVoice } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 22H9V24H7V22ZM12 13C13.66 13 15 11.66 15 10V4C15 2.34 13.66 1 12 1C10.34 1 9 2.34 9 4V10C9 11.66 10.34 13 12 13ZM11 4C11 3.45 11.45 3 12 3C12.55 3 13 3.45 13 4V10C13 10.56 12.56 11 12 11C11.45 11 11 10.55 11 10V4ZM11 22H13V24H11V22ZM15 22H17V24H15V22ZM19 10H17.3C17.3 13 14.76 15.1 12 15.1C9.24 15.1 6.7 13 6.7 10H5C5 13.41 7.72 16.23 11 16.72V20H13V16.72C16.28 16.23 19 13.41 19 10Z",
    fill: "currentColor"
  })));
}, "IconSettingsVoice");
import OP from "classnames";

var _P = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSettings } from '@aws-amplify/ui-react'; \u2192 import { MdSettings } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.57 5.11 19.4 5.02 19.22 5.02C19.16 5.02 19.1 5.03 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H9.99999C9.74999 2 9.53999 2.18 9.50999 2.42L9.12999 5.07C8.51999 5.32 7.95999 5.66 7.43999 6.05L4.94999 5.05C4.88999 5.03 4.82999 5.02 4.76999 5.02C4.59999 5.02 4.42999 5.11 4.33999 5.27L2.33999 8.73C2.20999 8.95 2.26999 9.22 2.45999 9.37L4.56999 11.02C4.52999 11.34 4.49999 11.67 4.49999 12C4.49999 12.33 4.52999 12.66 4.56999 12.98L2.45999 14.63C2.26999 14.78 2.21999 15.05 2.33999 15.27L4.33999 18.73C4.42999 18.89 4.59999 18.98 4.77999 18.98C4.83999 18.98 4.89999 18.97 4.94999 18.95L7.43999 17.95C7.95999 18.35 8.51999 18.68 9.12999 18.93L9.50999 21.58C9.53999 21.82 9.74999 22 9.99999 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.11 18.97 19.17 18.98 19.23 18.98C19.4 18.98 19.57 18.89 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98V12.98ZM17.45 11.27C17.49 11.58 17.5 11.79 17.5 12C17.5 12.21 17.48 12.43 17.45 12.73L17.31 13.86L18.2 14.56L19.28 15.4L18.58 16.61L17.31 16.1L16.27 15.68L15.37 16.36C14.94 16.68 14.53 16.92 14.12 17.09L13.06 17.52L12.9 18.65L12.7 20H11.3L11.11 18.65L10.95 17.52L9.88999 17.09C9.45999 16.91 9.05999 16.68 8.65999 16.38L7.74999 15.68L6.68999 16.11L5.41999 16.62L4.71999 15.41L5.79999 14.57L6.68999 13.87L6.54999 12.74C6.51999 12.43 6.49999 12.2 6.49999 12C6.49999 11.8 6.51999 11.57 6.54999 11.27L6.68999 10.14L5.79999 9.44L4.71999 8.6L5.41999 7.39L6.68999 7.9L7.72999 8.32L8.62999 7.64C9.05999 7.32 9.46999 7.08 9.87999 6.91L10.94 6.48L11.1 5.35L11.3 4H12.69L12.88 5.35L13.04 6.48L14.1 6.91C14.53 7.09 14.93 7.32 15.33 7.62L16.24 8.32L17.3 7.89L18.57 7.38L19.27 8.59L18.2 9.44L17.31 10.14L17.45 11.27ZM12 8C9.78999 8 7.99999 9.79 7.99999 12C7.99999 14.21 9.78999 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 9.99999 13.1 9.99999 12C9.99999 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z",
    fill: "currentColor"
  })));
}, "IconSettings");

import GP from "classnames";
var UP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShare } from '@aws-amplify/ui-react'; \u2192 import { MdShare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08ZM18 4C18.55 4 19 4.45 19 5C19 5.55 18.55 6 18 6C17.45 6 17 5.55 17 5C17 4.45 17.45 4 18 4ZM6 13C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11C6.55 11 7 11.45 7 12C7 12.55 6.55 13 6 13ZM18 20.02C17.45 20.02 17 19.57 17 19.02C17 18.47 17.45 18.02 18 18.02C18.55 18.02 19 18.47 19 19.02C19 19.57 18.55 20.02 18 20.02Z",
    fill: "currentColor"
  })));
}, "IconShare");
import zP from "classnames";
var XP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShopTwo } from '@aws-amplify/ui-react'; \u2192 import { MdShopTwo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 9H1V20C1 21.11 1.89 22 3 22H17C18.11 22 19 21.11 19 20H3V9ZM18 5V3C18 1.89 17.11 1 16 1H12C10.89 1 10 1.89 10 3V5H5V16C5 17.11 5.89 18 7 18H21C22.11 18 23 17.11 23 16V5H18ZM12 3H16V5H12V3ZM21 16H7V7H21V16ZM12 15L17.5 11L12 8V15Z",
    fill: "currentColor"
  })));
}, "IconShopTwo");
import KP from "classnames";
var qP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShop } from '@aws-amplify/ui-react'; \u2192 import { MdShop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 6V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H2V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V6H16ZM10 4H14V6H10V4ZM20 19H4V8H20V19ZM9 18L16.5 13L9 9V18Z",
    fill: "currentColor"
  })));
}, "IconShop");
import QP from "classnames";
var JP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShoppingBag } from '@aws-amplify/ui-react'; \u2192 import { MdShoppingBag } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QP(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 6H16C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6H6C4.9 6 4 6.9 4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8C20 6.9 19.1 6 18 6ZM12 4C13.1 4 14 4.9 14 6H10C10 4.9 10.9 4 12 4ZM18 20H6V8H8V10C8 10.55 8.45 11 9 11C9.55 11 10 10.55 10 10V8H14V10C14 10.55 14.45 11 15 11C15.55 11 16 10.55 16 10V8H18V20Z",
    fill: "currentColor"
  })));
}, "IconShoppingBag");
import $P from "classnames";
var RP = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShoppingBasket } from '@aws-amplify/ui-react'; \u2192 import { MdShoppingBasket } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $P(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 9.00002H17.21L12.83 2.44002C12.64 2.16002 12.32 2.02002 12 2.02002C11.68 2.02002 11.36 2.16002 11.17 2.45002L6.79 9.00002H2C1.45 9.00002 1 9.45002 1 10C1 10.09 1.01 10.18 1.04 10.27L3.58 19.54C3.81 20.38 4.58 21 5.5 21H18.5C19.42 21 20.19 20.38 20.43 19.54L22.97 10.27L23 10C23 9.45002 22.55 9.00002 22 9.00002ZM12 4.80002L14.8 9.00002H9.2L12 4.80002ZM18.5 19L5.51 19.01L3.31 11H20.7L18.5 19ZM12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13Z",
    fill: "currentColor"
  })));
}, "IconShoppingBasket");
import eS from "classnames";
var oS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShoppingCart } from '@aws-amplify/ui-react'; \u2192 import { MdShoppingCart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z",
    fill: "currentColor"
  })));
}, "IconShoppingCart");
import tS from "classnames";
var rS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShortText } from '@aws-amplify/ui-react'; \u2192 import { MdShortText } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 9H20V11H4V9ZM4 13H14V15H4V13Z",
    fill: "currentColor"
  })));
}, "IconShortText");
import iS from "classnames";
var sS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShowChart } from '@aws-amplify/ui-react'; \u2192 import { MdShowChart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3.5 18.4898L9.5 12.4798L13.5 16.4798L22 6.91977L20.59 5.50977L13.5 13.4798L9.5 9.47976L2 16.9898L3.5 18.4898Z",
    fill: "currentColor"
  })));
}, "IconShowChart");
import aS from "classnames";
var nS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShuffle } from '@aws-amplify/ui-react'; \u2192 import { MdShuffle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.59 9.17L5.41 4L4 5.41L9.17 10.58L10.59 9.17ZM14.5 4L16.54 6.04L4 18.59L5.41 20L17.96 7.46L20 9.5V4H14.5ZM14.83 13.41L13.42 14.82L16.55 17.95L14.5 20H20V14.5L17.96 16.54L14.83 13.41V13.41Z",
    fill: "currentColor"
  })));
}, "IconShuffle");
import mS from "classnames";
var cS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconShutterSpeed } from '@aws-amplify/ui-react'; \u2192 import { MdShutterSpeed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 1H9V3H15V1ZM19.03 7.39L20.45 5.97C20.02 5.46 19.55 4.98 19.04 4.56L17.62 5.98C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13C3 17.97 7.02 22 12 22C16.98 22 21 17.97 21 13C21 10.88 20.26 8.93 19.03 7.39ZM12 20C8.13 20 5 16.87 5 13C5 9.13 8.13 6 12 6C15.87 6 19 9.13 19 13C19 16.87 15.87 20 12 20ZM11.68 15H6.35C6.92 16.62 8.17 17.92 9.76 18.56L9.65 18.5L11.68 15ZM17.65 11C17.08 9.4 15.87 8.11 14.31 7.46L12.26 11H17.65ZM10.61 18.83C11.06 18.94 11.52 19 12 19C13.34 19 14.57 18.55 15.57 17.81L13.46 13.91L10.61 18.83V18.83ZM7.55 8.99C6.59 10.05 6 11.46 6 13C6 13.34 6.04 13.67 6.09 14H10.81L7.55 8.99ZM16.34 17.13C17.37 16.06 18 14.6 18 13C18 12.66 17.96 12.33 17.91 12H13.57L16.34 17.13V17.13ZM13.33 7.15C12.9 7.06 12.46 7 12 7C10.6 7 9.31 7.49 8.29 8.29L10.61 11.85L13.33 7.15V7.15Z",
    fill: "currentColor"
  })));
}, "IconShutterSpeed");
import lS from "classnames";
var pS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSick } from '@aws-amplify/ui-react'; \u2192 import { MdSick } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.32018 10.56L8.38018 9.5L7.32018 8.44L8.38018 7.38L10.5002 9.5L8.38018 11.62L7.32018 10.56ZM4.50018 9C4.53018 9 4.55018 9.01 4.58018 9.01C5.77018 6.07 8.64018 4 12.0002 4C14.1902 4 16.1602 4.88 17.6102 6.3C17.7602 5.7 18.0602 5.01 18.4202 4.34C16.6802 2.88 14.4402 2 11.9902 2C7.11018 2 3.05018 5.51 2.18018 10.14C2.74018 9.44 3.59018 9 4.50018 9ZM21.0002 10.5C20.5802 10.5 20.1802 10.41 19.8102 10.28C19.9302 10.83 20.0002 11.41 20.0002 12C20.0002 16.42 16.4202 20 12.0002 20C8.64018 20 5.77018 17.93 4.58018 14.99C4.55018 14.99 4.53018 15 4.50018 15C3.98018 15 3.46018 14.86 3.00018 14.6C2.68018 14.42 2.41018 14.18 2.18018 13.9C3.07018 18.51 7.11018 22 11.9802 22C17.5202 22 22.0002 17.52 22.0002 12C22.0002 11.45 21.9402 10.91 21.8602 10.38C21.5802 10.45 21.3002 10.5 21.0002 10.5ZM21.0002 3C21.0002 3 19.0002 5.9 19.0002 7C19.0002 8.1 19.9002 9 21.0002 9C22.1002 9 23.0002 8.1 23.0002 7C23.0002 5.9 21.0002 3 21.0002 3ZM15.6202 7.38L13.5002 9.5L15.6202 11.62L16.6802 10.56L15.6202 9.5L16.6802 8.44L15.6202 7.38ZM8.56018 17C9.25018 15.81 10.5302 15 12.0002 15C13.4702 15 14.7502 15.81 15.4402 17H17.1202C16.3202 14.95 14.3302 13.5 12.0002 13.5C11.1302 13.5 10.3002 13.7 9.57018 14.07L5.99018 12C5.99018 11.48 5.73018 10.98 5.25018 10.71C4.53018 10.3 3.62018 10.54 3.20018 11.26C2.79018 11.98 3.03018 12.89 3.75018 13.31C4.23018 13.59 4.80018 13.56 5.24018 13.31L8.21018 15.03C7.64018 15.56 7.18018 16.24 6.88018 17H8.56018Z",
    fill: "currentColor"
  })));
}, "IconSick");
import hS from "classnames";
var fS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalCellular_4Bar } from '@aws-amplify/ui-react'; \u2192 import { MdSignalCellular_4Bar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 22H22V2L2 22Z",
    fill: "currentColor"
  })));
}, "IconSignalCellular_4Bar");
import CS from "classnames";
var gS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalCellularAlt } from '@aws-amplify/ui-react'; \u2192 import { MdSignalCellularAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 4H20V20H17V4ZM5 14H8V20H5V14ZM11 9H14V20H11V9Z",
    fill: "currentColor"
  })));
}, "IconSignalCellularAlt");
import uS from "classnames";
var wS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalCellularConnectedNoInternet_4Bar } from '@aws-amplify/ui-react'; \u2192 import { MdSignalCellularConnectedNoInternet_4Bar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 18H22V10H20V18ZM20 22H22V20H20V22ZM2 22H18V8H22V2L2 22Z",
    fill: "currentColor"
  })));
}, "IconSignalCellularConnectedNoInternet_4Bar");
import dS from "classnames";
var VS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalCellularNoSim } from '@aws-amplify/ui-react'; \u2192 import { MdSignalCellularNoSim } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10.83 5H17V14.11L19 16.11V5C19 3.9 18.1 3 17 3H10L7.94 5.06L9.36 6.48L10.83 5ZM21.26 21.21L3.79 3.74L2.38 5.15L5 7.77V19C5 20.11 5.9 21 7 21H18.23L19.85 22.62L21.26 21.21V21.21ZM7 19V9.79L16.23 19H7Z",
    fill: "currentColor"
  })));
}, "IconSignalCellularNoSim");
import HS from "classnames";
var MS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalCellularNull } from '@aws-amplify/ui-react'; \u2192 import { MdSignalCellularNull } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6.83V20H6.83L20 6.83ZM22 2L2 22H22V2Z",
    fill: "currentColor"
  })));
}, "IconSignalCellularNull");
import xS from "classnames";
var IS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalCellularOff } from '@aws-amplify/ui-react'; \u2192 import { MdSignalCellularOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 1L12.69 9.31L21 17.61V1ZM4.91 4.36L3.5 5.77L9.86 12.14L1 21H18.73L20.73 23L22.14 21.59L4.91 4.36Z",
    fill: "currentColor"
  })));
}, "IconSignalCellularOff");
import LS from "classnames";
var vS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalWifi_4BarLock } from '@aws-amplify/ui-react'; \u2192 import { MdSignalWifi_4BarLock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.5 9.5C20.86 9.5 21.21 9.54 21.55 9.61L23.64 7C23.19 6.66 18.71 3 12 3C5.27999 3 0.809985 6.66 0.359985 7L12 21.5L15.5 17.14V14.5C15.5 11.7 17.7 9.5 20.5 9.5ZM23 16V14.5C23 13.1 21.9 12 20.5 12C19.1 12 18 13.1 18 14.5V16C17.5 16 17 16.5 17 17V21C17 21.5 17.5 22 18 22H23C23.5 22 24 21.5 24 21V17C24 16.5 23.5 16 23 16ZM22 16H19V14.5C19 13.7 19.7 13 20.5 13C21.3 13 22 13.7 22 14.5V16Z",
    fill: "currentColor"
  })));
}, "IconSignalWifi_4BarLock");
import NS from "classnames";
var yS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalWifi_4Bar } from '@aws-amplify/ui-react'; \u2192 import { MdSignalWifi_4Bar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.01 21.49L23.64 7C23.19 6.66 18.71 3 12 3C5.27999 3 0.809985 6.66 0.359985 7L11.99 21.49L12 21.5L12.01 21.49V21.49Z",
    fill: "currentColor"
  })));
}, "IconSignalWifi_4Bar");
import bS from "classnames";
var ZS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSignalWifiOff } from '@aws-amplify/ui-react'; \u2192 import { MdSignalWifiOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23.64 7.00006C23.19 6.66006 18.71 3.00006 12 3.00006C10.68 3.00006 9.44999 3.14006 8.30999 3.38006L18.43 13.5001L23.64 7.00006ZM3.40999 1.31006L1.99999 2.72006L4.04999 4.77006C1.90999 5.76006 0.589985 6.82006 0.359985 7.00006L12 21.5001L15.91 16.6301L19.23 19.9501L20.64 18.5401L3.40999 1.31006Z",
    fill: "currentColor"
  })));
}, "IconSignalWifiOff");
import BS from "classnames";
var WS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSimCard } from '@aws-amplify/ui-react'; \u2192 import { MdSimCard } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM18 4V20H6V8.83L10.83 4H18ZM7 17H9V19H7V17ZM15 17H17V19H15V17ZM7 11H9V15H7V11ZM11 15H13V19H11V15ZM11 11H13V13H11V11ZM15 11H17V15H15V11Z",
    fill: "currentColor"
  })));
}, "IconSimCard");
import kS from "classnames";
var DS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSingleBed } from '@aws-amplify/ui-react'; \u2192 import { MdSingleBed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 12C20 10.9 19.1 10 18 10V7C18 5.9 17.1 5 16 5H8C6.9 5 6 5.9 6 7V10C4.9 10 4 10.9 4 12V17H5.33L6 19H7L7.67 17H16.34L17 19H18L18.67 17H20V12ZM16 10H13V7H16V10ZM8 7H11V10H8V7ZM6 12H18V15H6V12Z",
    fill: "currentColor"
  })));
}, "IconSingleBed");
import PS from "classnames";
var SS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSkipNext } from '@aws-amplify/ui-react'; \u2192 import { MdSkipNext } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 18L14.5 12L6 6V18ZM8 9.86L11.03 12L8 14.14V9.86ZM16 6H18V18H16V6Z",
    fill: "currentColor"
  })));
}, "IconSkipNext");
import jS from "classnames";
var YS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSkipPrevious } from '@aws-amplify/ui-react'; \u2192 import { MdSkipPrevious } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 6H8V18H6V6ZM9.5 12L18 18V6L9.5 12ZM16 14.14L12.97 12L16 9.86V14.14Z",
    fill: "currentColor"
  })));
}, "IconSkipPrevious");
import FS from "classnames";
var TS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSlideshow } from '@aws-amplify/ui-react'; \u2192 import { MdSlideshow } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M10 8V16L15 12L10 8ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z",
    fill: "currentColor"
  })));
}, "IconSlideshow");
import AS from "classnames";
var ES = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSlowMotionVideo } from '@aws-amplify/ui-react'; \u2192 import { MdSlowMotionVideo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13.05 9.7898L10 7.4998V16.4998L13.05 14.2098L16 11.9998L13.05 9.7898ZM13.05 9.7898L10 7.4998V16.4998L13.05 14.2098L16 11.9998L13.05 9.7898ZM13.05 9.7898L10 7.4998V16.4998L13.05 14.2098L16 11.9998L13.05 9.7898ZM11 4.0698V2.0498C8.99005 2.2498 7.16005 3.0498 5.68005 4.2598L7.10005 5.6898C8.21005 4.8298 9.54005 4.2498 11 4.0698ZM5.69005 7.0998L4.26005 5.6798C3.05005 7.1598 2.25005 8.9898 2.05005 10.9998H4.07005C4.25005 9.5398 4.83005 8.2098 5.69005 7.0998ZM4.07005 12.9998H2.05005C2.25005 15.0098 3.05005 16.8398 4.26005 18.3198L5.69005 16.8898C4.83005 15.7898 4.25005 14.4598 4.07005 12.9998V12.9998ZM5.68005 19.7398C7.16005 20.9498 9.00005 21.7498 11 21.9498V19.9298C9.54005 19.7498 8.21005 19.1698 7.10005 18.3098L5.68005 19.7398V19.7398ZM22 11.9998C22 17.1598 18.08 21.4198 13.05 21.9498V19.9298C16.97 19.4098 20 16.0498 20 11.9998C20 7.9498 16.97 4.5898 13.05 4.0698V2.0498C18.08 2.5798 22 6.8398 22 11.9998Z",
    fill: "currentColor"
  })));
}, "IconSlowMotionVideo");
import OS from "classnames";

var _S = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSmartButton } from '@aws-amplify/ui-react'; \u2192 import { MdSmartButton } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 9V15C22 16.1 21.1 17 20 17H19V15H20V9H4V15H10V17H4C2.9 17 2 16.1 2 15V9C2 7.9 2.9 7 4 7H20C21.1 7 22 7.9 22 9ZM14.5 19L15.59 16.59L18 15.5L15.59 14.41L14.5 12L13.41 14.41L11 15.5L13.41 16.59L14.5 19ZM17 14L17.62 12.62L19 12L17.62 11.38L17 10L16.38 11.38L15 12L16.38 12.62L17 14ZM14.5 19L15.59 16.59L18 15.5L15.59 14.41L14.5 12L13.41 14.41L11 15.5L13.41 16.59L14.5 19ZM17 14L17.62 12.62L19 12L17.62 11.38L17 10L16.38 11.38L15 12L16.38 12.62L17 14Z",
    fill: "currentColor"
  })));
}, "IconSmartButton");

import GS from "classnames";
var US = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSmartphone } from '@aws-amplify/ui-react'; \u2192 import { MdSmartphone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7V5H17V19Z",
    fill: "currentColor"
  })));
}, "IconSmartphone");
import zS from "classnames";
var XS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSmokeFree } from '@aws-amplify/ui-react'; \u2192 import { MdSmokeFree } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.5 13.0002H22V16.0002H20.5V13.0002ZM18 13.0002H19.5V16.0002H18V13.0002ZM17 13.0002H14.66L17 15.3402V13.0002ZM14.5 8.6502H16.03C17.08 8.6502 18 9.3902 18 10.7002V12.0002H19.5V10.3602C19.5 8.5502 17.9 7.2002 16.03 7.2002H14.5C13.48 7.2002 12.65 6.2202 12.65 5.2002C12.65 4.1802 13.48 3.4502 14.5 3.4502V1.9502C12.65 1.9502 11.15 3.4502 11.15 5.3002C11.15 7.1502 12.65 8.6502 14.5 8.6502V8.6502ZM18.85 4.7302C19.47 4.1202 19.85 3.2802 19.85 2.3502H18.35C18.35 3.3702 17.52 4.2002 16.5 4.2002V5.7002C18.74 5.7002 20.5 7.5302 20.5 9.7702V12.0002H22V9.7602C22 7.5402 20.72 5.6202 18.85 4.7302V4.7302ZM3.41 4.5902L2 6.0002L9 13.0002H2V16.0002H12L19 23.0002L20.41 21.5902L3.41 4.5902Z",
    fill: "currentColor"
  })));
}, "IconSmokeFree");
import KS from "classnames";
var qS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSmokingRooms } from '@aws-amplify/ui-react'; \u2192 import { MdSmokingRooms } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 16H19.5V19H18V16ZM2 16H17V19H2V16ZM16.03 10.2H14.5C13.48 10.2 12.65 9.22 12.65 8.2C12.65 7.18 13.48 6.45 14.5 6.45V4.95C12.65 4.95 11.15 6.45 11.15 8.3C11.15 10.15 12.65 11.65 14.5 11.65H16.03C17.08 11.65 18 12.39 18 13.7V15H19.5V13.36C19.5 11.55 17.9 10.2 16.03 10.2ZM20.5 16H22V19H20.5V16ZM18.85 7.73C19.47 7.12 19.85 6.28 19.85 5.35C19.85 3.5 18.35 2 16.5 2V3.5C17.52 3.5 18.35 4.33 18.35 5.35C18.35 6.37 17.52 7.2 16.5 7.2V8.7C18.74 8.7 20.5 10.53 20.5 12.77V15H22V12.76C22 10.54 20.72 8.62 18.85 7.73V7.73Z",
    fill: "currentColor"
  })));
}, "IconSmokingRooms");
import QS from "classnames";
var JS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSmsFailed } from '@aws-amplify/ui-react'; \u2192 import { MdSmsFailed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QS(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM11 12H13V14H11V12ZM11 6H13V10H11V6Z",
    fill: "currentColor"
  })));
}, "IconSmsFailed");
import $S from "classnames";
var RS = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSms } from '@aws-amplify/ui-react'; \u2192 import { MdSms } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $S(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM7 9H9V11H7V9ZM15 9H17V11H15V9ZM11 9H13V11H11V9Z",
    fill: "currentColor"
  })));
}, "IconSms");
import ej from "classnames";
var oj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSnippetFolder } from '@aws-amplify/ui-react'; \u2192 import { MdSnippetFolder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ej(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM17.5 12.12V15.5H14.5V10.5H15.88L17.5 12.12ZM13 9V17H19V11.5L16.5 9H13Z",
    fill: "currentColor"
  })));
}, "IconSnippetFolder");
import tj from "classnames";
var rj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSnooze } from '@aws-amplify/ui-react'; \u2192 import { MdSnooze } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.00003 11.0001H12.63L9.00003 15.2001V17.0001H15V15.0001H11.37L15 10.8001V9.00006H9.00003V11.0001ZM16.056 3.34606L17.338 1.81106L21.945 5.66106L20.665 7.20106L16.056 3.34606ZM3.33603 7.19006L2.05603 5.65406L6.66203 1.81006L7.94203 3.34606L3.33603 7.19006ZM12 6.00006C15.86 6.00006 19 9.14006 19 13.0001C19 16.8601 15.86 20.0001 12 20.0001C8.14003 20.0001 5.00003 16.8601 5.00003 13.0001C5.00003 9.14006 8.14003 6.00006 12 6.00006ZM12 4.00006C7.03003 4.00006 3.00003 8.03006 3.00003 13.0001C3.00003 17.9701 7.03003 22.0001 12 22.0001C16.97 22.0001 21 17.9701 21 13.0001C21 8.03006 16.97 4.00006 12 4.00006Z",
    fill: "currentColor"
  })));
}, "IconSnooze");
import ij from "classnames";
var sj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSoap } from '@aws-amplify/ui-react'; \u2192 import { MdSoap } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ij(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.25 6C14.66 6 15 6.34 15 6.75C15 7.16 14.66 7.5 14.25 7.5C13.84 7.5 13.5 7.16 13.5 6.75C13.5 6.34 13.84 6 14.25 6ZM14.25 4.5C13.01 4.5 12 5.51 12 6.75C12 7.99 13.01 9 14.25 9C15.49 9 16.5 7.99 16.5 6.75C16.5 5.51 15.49 4.5 14.25 4.5ZM20 5.5C20.28 5.5 20.5 5.72 20.5 6C20.5 6.28 20.28 6.5 20 6.5C19.72 6.5 19.5 6.28 19.5 6C19.5 5.72 19.72 5.5 20 5.5ZM20 4C18.9 4 18 4.9 18 6C18 7.1 18.9 8 20 8C21.1 8 22 7.1 22 6C22 4.9 21.1 4 20 4ZM16.5 1C15.67 1 15 1.67 15 2.5C15 3.33 15.67 4 16.5 4C17.33 4 18 3.33 18 2.5C18 1.67 17.33 1 16.5 1ZM20.75 16C21.44 16 22 15.44 22 14.75C22 14.06 21.44 13.5 20.75 13.5H12V12.5H18.75C19.44 12.5 20 11.94 20 11.25C20 10.58 19.47 10.05 18.82 10.01L8.87 10L10.35 7.4C10.44 7.23 10.49 7.06 10.49 6.86C10.49 6.6 10.4 6.36 10.23 6.16L9.12 5L1.94 11.8C1.34 12.36 1 13.15 1 13.97V20C1 21.66 2.34 23 4 23H17.75C18.44 23 19 22.44 19 21.75C19 21.06 18.44 20.5 17.75 20.5H12V19.5H19.75C20.44 19.5 21 18.94 21 18.25C21 17.56 20.44 17 19.75 17H12V16H20.75ZM10 21H4C3.45 21 3 20.55 3 20V14C3 13.61 3.23 13.36 3.36 13.25L7 9.87V12H10V21Z",
    fill: "currentColor"
  })));
}, "IconSoap");
import aj from "classnames";
var nj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSortByAlpha } from '@aws-amplify/ui-react'; \u2192 import { MdSortByAlpha } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.94 4.6598H10.22L12.58 2.2998L14.94 4.6598V4.6598ZM10.25 19.3698H14.91L12.58 21.6998L10.25 19.3698V19.3698ZM6.09998 6.2698L1.59998 17.7298H3.43998L4.35998 15.2798H9.46998L10.39 17.7298H12.23L7.73998 6.2698H6.09998ZM4.96998 13.6398L6.90998 8.4598L8.84998 13.6398H4.96998ZM15.73 16.1398H21.85V17.7298H13.32V16.4398L19.24 7.8798H13.36V6.2798H21.66V7.5398L15.73 16.1398V16.1398Z",
    fill: "currentColor"
  })));
}, "IconSortByAlpha");
import mj from "classnames";
var cj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSort } from '@aws-amplify/ui-react'; \u2192 import { MdSort } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z",
    fill: "currentColor"
  })));
}, "IconSort");
import lj from "classnames";
var pj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSource } from '@aws-amplify/ui-react'; \u2192 import { MdSource } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM18 12H6V10H18V12ZM14 16H6V14H14V16Z",
    fill: "currentColor"
  })));
}, "IconSource");
import hj from "classnames";
var fj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSouthEast } from '@aws-amplify/ui-react'; \u2192 import { MdSouthEast } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 9H17V15.59L5.41 4L4 5.41L15.59 17H9V19H19V9Z",
    fill: "currentColor"
  })));
}, "IconSouthEast");
import Cj from "classnames";
var gj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSouthWest } from '@aws-amplify/ui-react'; \u2192 import { MdSouthWest } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Cj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 19V17H8.41L20 5.41L18.59 4L7 15.59V9H5V19H15Z",
    fill: "currentColor"
  })));
}, "IconSouthWest");
import uj from "classnames";
var wj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSouth } from '@aws-amplify/ui-react'; \u2192 import { MdSouth } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 15L17.59 13.59L13 18.17V2H11V18.17L6.41 13.58L5 15L12 22L19 15Z",
    fill: "currentColor"
  })));
}, "IconSouth");
import dj from "classnames";
var Vj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpa } from '@aws-amplify/ui-react'; \u2192 import { MdSpa } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.49 9.63C15.31 6.84 14.18 4.12 12.06 2C9.92 4.14 8.74 6.86 8.51 9.63C9.79 10.31 10.97 11.19 12 12.26C13.03 11.2 14.21 10.32 15.49 9.63V9.63ZM12.05 5.19C12.68 6.22 13.12 7.37 13.35 8.57C12.88 8.87 12.44 9.2 12.01 9.55C11.59 9.21 11.14 8.88 10.68 8.58C10.93 7.38 11.39 6.23 12.05 5.19V5.19ZM12 15.45C11.18 14.2 10.14 13.11 8.94 12.25C8.81 12.16 8.67 12.09 8.54 11.99C8.67 12.08 8.81 12.16 8.93 12.24C6.98 10.83 4.59 10 2 10C2 15.32 5.36 19.82 10.03 21.49C10.66 21.72 11.32 21.89 12 22C12.68 21.88 13.33 21.71 13.97 21.49C18.64 19.82 22 15.32 22 10C17.82 10 14.15 12.17 12 15.45ZM13.32 19.6C12.88 19.75 12.44 19.87 11.99 19.97C11.55 19.88 11.12 19.76 10.71 19.61C7.42 18.43 5.01 15.62 4.26 12.26C5.36 12.52 6.41 12.97 7.38 13.59L7.36 13.6C7.49 13.69 7.62 13.78 7.75 13.85L7.82 13.89C8.81 14.61 9.66 15.5 10.33 16.54L12 19.1L13.67 16.55C14.36 15.5 15.22 14.6 16.2 13.89L16.27 13.84C16.36 13.79 16.45 13.73 16.54 13.67L16.53 13.65C17.51 13 18.6 12.52 19.74 12.25C18.99 15.62 16.59 18.43 13.32 19.6V19.6ZM8.99 12.28C8.97 12.27 8.95 12.25 8.94 12.24C8.94 12.24 8.95 12.24 8.95 12.25C8.96 12.26 8.97 12.27 8.99 12.28V12.28Z",
    fill: "currentColor"
  })));
}, "IconSpa");
import Hj from "classnames";
var Mj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpaceBar } from '@aws-amplify/ui-react'; \u2192 import { MdSpaceBar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Hj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 9V13H6V9H4V15H20V9H18Z",
    fill: "currentColor"
  })));
}, "IconSpaceBar");
import xj from "classnames";
var Ij = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpeakerGroup } from '@aws-amplify/ui-react'; \u2192 import { MdSpeakerGroup } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.2 1H9.8C8.81 1 8 1.81 8 2.8V17.2C8 18.19 8.81 18.99 9.8 18.99L18.2 19C19.19 19 20 18.19 20 17.2V2.8C20 1.81 19.19 1 18.2 1V1ZM18 17L10 16.99V3H18V17ZM14 8C15.1 8 16 7.11 16 6C16 4.89 15.1 4 14 4C12.9 4 12 4.89 12 6C12 7.11 12.9 8 14 8ZM14 16C15.93 16 17.5 14.43 17.5 12.5C17.5 10.57 15.93 9 14 9C12.07 9 10.5 10.57 10.5 12.5C10.5 14.43 12.07 16 14 16ZM14 11C14.83 11 15.5 11.67 15.5 12.5C15.5 13.33 14.83 14 14 14C13.17 14 12.5 13.33 12.5 12.5C12.5 11.67 13.17 11 14 11ZM6 5H4V21C4 22.1 4.89 23 6 23H16V21H6V5Z",
    fill: "currentColor"
  })));
}, "IconSpeakerGroup");
import Lj from "classnames";
var vj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpeakerNotesOff } from '@aws-amplify/ui-react'; \u2192 import { MdSpeakerNotesOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Lj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 3.99984V15.9998H18.66L20.57 17.9098C21.39 17.6598 22 16.8998 22 15.9998V3.99984C22 2.89984 21.1 1.99984 20 1.99984H4.66L6.66 3.99984H20ZM6 11.9998H8V13.9998H6V11.9998ZM18 8.99984H11.66L13.66 10.9998H18V8.99984ZM18 5.99984H10V7.33984L10.66 7.99984H18V5.99984ZM1.41 1.58984L0 2.99984L2.01 5.00984L2 21.9998L6 17.9998H15L20.73 23.7298L22.14 22.3198L1.41 1.58984ZM5.17 15.9998L4 17.1698V6.99984L6 8.99984V10.9998H8L13 15.9998H5.17Z",
    fill: "currentColor"
  })));
}, "IconSpeakerNotesOff");
import Nj from "classnames";
var yj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpeakerNotes } from '@aws-amplify/ui-react'; \u2192 import { MdSpeakerNotes } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Nj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4.58 16.59L4 17.17V4H20V16ZM6 12H8V14H6V12ZM6 9H8V11H6V9ZM6 6H8V8H6V6ZM10 12H15V14H10V12ZM10 9H18V11H10V9ZM10 6H18V8H10V6Z",
    fill: "currentColor"
  })));
}, "IconSpeakerNotes");
import bj from "classnames";
var Zj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpeakerPhone } from '@aws-amplify/ui-react'; \u2192 import { MdSpeakerPhone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 7.07L8.43 8.5C9.34 7.59 10.61 7.02 12 7.02C13.39 7.02 14.66 7.59 15.57 8.5L17 7.07C15.72 5.79 13.95 5 12 5C10.05 5 8.28 5.79 7 7.07ZM12 1C8.98 1 6.24 2.23 4.25 4.21L5.66 5.62C7.28 4 9.53 3 12 3C14.47 3 16.72 4 18.34 5.62L19.75 4.21C17.76 2.23 15.02 1 12 1ZM14.86 10.01L9.14 10C8.51 10 8 10.51 8 11.14V20.85C8 21.48 8.51 21.99 9.14 21.99H14.85C15.48 21.99 15.99 21.48 15.99 20.85V11.14C16 10.51 15.49 10.01 14.86 10.01V10.01ZM15 20H9V12H15V20Z",
    fill: "currentColor"
  })));
}, "IconSpeakerPhone");
import Bj from "classnames";
var Wj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpeaker } from '@aws-amplify/ui-react'; \u2192 import { MdSpeaker } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Bj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 2H7C5.9 2 5 2.9 5 4V20C5 21.1 5.9 21.99 7 21.99L17 22C18.1 22 19 21.1 19 20V4C19 2.9 18.1 2 17 2ZM7 20V4H17V20H7ZM12 9C13.1 9 14 8.1 14 7C14 5.9 13.1 5 12 5C10.89 5 10 5.9 10 7C10 8.1 10.89 9 12 9ZM12 11C9.79 11 8 12.79 8 15C8 17.21 9.79 19 12 19C14.21 19 16 17.21 16 15C16 12.79 14.21 11 12 11ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17Z",
    fill: "currentColor"
  })));
}, "IconSpeaker");
import kj from "classnames";
var Dj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpeed } from '@aws-amplify/ui-react'; \u2192 import { MdSpeed } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.38 8.57012L19.15 10.4201C19.7432 11.6032 20.0336 12.915 19.9952 14.2378C19.9568 15.5607 19.5908 16.8534 18.93 18.0001H5.06999C4.21116 16.5102 3.85528 14.7832 4.05513 13.0752C4.25497 11.3671 4.9999 9.76895 6.17947 8.51755C7.35904 7.26615 8.91046 6.42816 10.6037 6.12782C12.297 5.82747 14.042 6.08076 15.58 6.85012L17.43 5.62012C15.5465 4.41234 13.3123 3.87113 11.0849 4.08306C8.85744 4.29499 6.76543 5.24782 5.14348 6.78913C3.52153 8.33045 2.46335 10.3712 2.13821 12.5849C1.81306 14.7987 2.23974 17.0575 3.34999 19.0001C3.5245 19.3024 3.77508 19.5537 4.07682 19.7292C4.37856 19.9046 4.72096 19.998 5.06999 20.0001H18.92C19.2724 20.0015 19.6189 19.9098 19.9245 19.7342C20.2301 19.5586 20.4838 19.3053 20.66 19.0001C21.5814 17.404 22.0438 15.5844 21.9961 13.7421C21.9485 11.8998 21.3926 10.1064 20.39 8.56012L20.38 8.57012Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10.59 15.4099C10.7757 15.5959 10.9963 15.7434 11.2391 15.844C11.4819 15.9447 11.7422 15.9965 12.005 15.9965C12.2678 15.9965 12.5281 15.9447 12.7709 15.844C13.0137 15.7434 13.2342 15.5959 13.42 15.4099L19.08 6.91992L10.59 12.5799C10.404 12.7657 10.2565 12.9862 10.1559 13.229C10.0552 13.4718 10.0034 13.7321 10.0034 13.9949C10.0034 14.2578 10.0552 14.518 10.1559 14.7608C10.2565 15.0036 10.404 15.2242 10.59 15.4099V15.4099Z",
    fill: "black"
  })));
}, "IconSpeed");
import Pj from "classnames";
var Sj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSpellcheck } from '@aws-amplify/ui-react'; \u2192 import { MdSpellcheck } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Pj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.45 16H14.54L9.43 3H7.57L2.46 16H4.55L5.67 13H11.31L12.45 16ZM6.43 11L8.5 5.48L10.57 11H6.43ZM21.59 11.59L13.5 19.68L9.83 16L8.42 17.41L13.51 22.5L23 13L21.59 11.59Z",
    fill: "currentColor"
  })));
}, "IconSpellcheck");
import jj from "classnames";
var Yj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsBar } from '@aws-amplify/ui-react'; \u2192 import { MdSportsBar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 19H8V12.37C9.26 12.03 10.11 11.1 10.77 10.38C11.6 9.47002 12.08 9.00002 13 9.00002H15V19ZM10 2.02002C8.11 2.02002 6.49 3.13002 5.73 4.73002C4.15 5.26002 3 6.74002 3 8.50002C3 10.36 4.28 11.91 6 12.36V21H17V19H19C20.1 19 21 18.1 21 17V11C21 9.90002 20.1 9.00002 19 9.00002H17.44C17.79 8.41002 18 7.73002 18 7.00002C18 4.79002 16.21 3.00002 14 3.00002C13.66 3.00002 13.34 3.05002 13.02 3.13002C12.2 2.45002 11.16 2.02002 10 2.02002ZM7 10.5C5.9 10.5 5 9.60002 5 8.50002C5 7.65002 5.55 6.90002 6.37 6.62002L7.17 6.35002L7.53 5.59002C8 4.62002 8.94 4.02002 10 4.02002C10.79 4.02002 11.39 4.37002 11.74 4.67002L12.52 5.32002C12.52 5.32002 13.16 5.00002 13.99 5.00002C15.09 5.00002 15.99 5.90002 15.99 7.00002H12.99C9.67 7.00002 9.15 10.5 7 10.5ZM17 17V11H19V17H17Z",
    fill: "currentColor"
  })));
}, "IconSportsBar");
import Fj from "classnames";
var Tj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsBaseball } from '@aws-amplify/ui-react'; \u2192 import { MdSportsBaseball } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Fj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM5.61 16.78C4.6 15.45 4 13.8 4 12C4 10.2 4.6 8.55 5.61 7.22C7.06 8.31 8 10.05 8 12C8 13.95 7.06 15.69 5.61 16.78ZM12 20C10.11 20 8.37 19.34 7 18.24C8.83 16.77 10 14.53 10 12C10 9.47 8.83 7.23 7 5.76C8.37 4.66 10.11 4 12 4C13.89 4 15.63 4.66 17 5.76C15.17 7.23 14 9.47 14 12C14 14.53 15.17 16.77 17 18.24C15.63 19.34 13.89 20 12 20ZM18.39 16.78C16.94 15.69 16 13.95 16 12C16 10.05 16.94 8.31 18.39 7.22C19.4 8.55 20 10.2 20 12C20 13.8 19.4 15.45 18.39 16.78Z",
    fill: "currentColor"
  })));
}, "IconSportsBaseball");
import Aj from "classnames";
var Ej = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsBasketball } from '@aws-amplify/ui-react'; \u2192 import { MdSportsBasketball } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Aj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM5.23 7.75C6.1 8.62 6.7 9.74 6.91 11H4.07C4.22 9.82 4.63 8.72 5.23 7.75ZM4.07 13H6.91C6.7 14.26 6.1 15.38 5.23 16.25C4.63 15.28 4.22 14.18 4.07 13ZM11 19.93C9.27 19.71 7.71 18.93 6.51 17.79C7.81 16.55 8.7 14.88 8.93 13H11V19.93ZM11 11H8.93C8.69 9.12 7.81 7.44 6.5 6.2C7.71 5.06 9.27 4.29 11 4.07V11ZM19.93 11H17.09C17.3 9.74 17.9 8.62 18.77 7.75C19.37 8.72 19.78 9.82 19.93 11ZM13 4.07C14.73 4.29 16.29 5.06 17.5 6.2C16.19 7.44 15.31 9.12 15.07 11H13V4.07ZM13 19.93V13H15.07C15.31 14.88 16.19 16.55 17.49 17.79C16.29 18.93 14.73 19.71 13 19.93ZM18.77 16.25C17.9 15.39 17.31 14.26 17.09 13H19.93C19.78 14.18 19.37 15.28 18.77 16.25Z",
    fill: "currentColor"
  })));
}, "IconSportsBasketball");
import Oj from "classnames";

var _j = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsCricket } from '@aws-amplify/ui-react'; \u2192 import { MdSportsCricket } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Oj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.0401 12.79L6.54006 4.29C6.35006 4.1 6.09006 4 5.83006 4C5.57006 4 5.32006 4.1 5.13006 4.29L2.29006 7.13C1.90006 7.52 1.90006 8.16 2.29006 8.55L10.7901 17.05C10.9901 17.25 11.2401 17.34 11.5001 17.34C11.7601 17.34 12.0101 17.24 12.2101 17.05L15.0401 14.22C15.4301 13.82 15.4301 13.18 15.0401 12.79ZM11.5001 14.92L4.41006 7.83L5.83006 6.41L12.9201 13.5L11.5001 14.92Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15.7555 16.3421L14.3413 17.7563L18.5839 21.9989L19.9981 20.5847L15.7555 16.3421Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18.5 2C16.57 2 15 3.57 15 5.5C15 7.43 16.57 9 18.5 9C20.43 9 22 7.43 22 5.5C22 3.57 20.43 2 18.5 2ZM18.5 7C17.67 7 17 6.33 17 5.5C17 4.67 17.67 4 18.5 4C19.33 4 20 4.67 20 5.5C20 6.33 19.33 7 18.5 7Z",
    fill: "black"
  })));
}, "IconSportsCricket");

import Gj from "classnames";
var Uj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsEsports } from '@aws-amplify/ui-react'; \u2192 import { MdSportsEsports } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Gj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.5798 16.09L20.4898 8.43C20.2098 6.46 18.5198 5 16.5298 5H7.46982C5.47982 5 3.78982 6.46 3.50982 8.43L2.41982 16.09C2.19982 17.63 3.38982 19 4.93982 19C5.61982 19 6.25982 18.73 6.73982 18.25L8.99982 16H14.9998L17.2498 18.25C17.7298 18.73 18.3798 19 19.0498 19C20.6098 19 21.7998 17.63 21.5798 16.09ZM19.4798 16.81C19.3998 16.9 19.2698 17 19.0598 17C18.9098 17 18.7698 16.94 18.6698 16.84L15.8298 14H8.16982L5.32982 16.84C5.22982 16.94 5.08982 17 4.93982 17C4.72982 17 4.59982 16.9 4.51982 16.81C4.43982 16.72 4.35982 16.58 4.38982 16.37L5.47982 8.71C5.62982 7.74 6.47982 7 7.46982 7H16.5298C17.5198 7 18.3698 7.74 18.5098 8.72L19.5998 16.38C19.6298 16.58 19.5498 16.72 19.4798 16.81Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9 8H8V10H6V11H8V13H9V11H11V10H9V8Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M17 13C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11C16.4477 11 16 11.4477 16 12C16 12.5523 16.4477 13 17 13Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10Z",
    fill: "black"
  })));
}, "IconSportsEsports");
import zj from "classnames";
var Xj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsFootball } from '@aws-amplify/ui-react'; \u2192 import { MdSportsFootball } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.3098 3.69C19.9898 3.36 18.3698 3 16.2598 3C13.2298 3 9.16983 3.75 6.45983 6.46C1.86983 11.05 2.89983 19.52 3.68983 20.31C4.00983 20.64 5.62983 21 7.73983 21C10.7698 21 14.8298 20.25 17.5398 17.54C22.1298 12.95 21.0998 4.48 20.3098 3.69ZM7.73983 19C6.59983 19 5.71983 18.88 5.20983 18.77C5.02983 17.98 4.90983 16.56 5.03983 14.94L9.04983 18.95C8.52983 18.99 8.07983 19 7.73983 19ZM16.1298 16.13C14.7998 17.46 13.0698 18.18 11.4698 18.57L5.42983 12.53C5.84983 10.85 6.58983 9.16 7.87983 7.88C9.19983 6.56 10.9298 5.84 12.5198 5.45L18.5698 11.5C18.1498 13.17 17.3998 14.85 16.1298 16.13ZM18.9598 9.09L14.9298 5.06C15.4498 5.01 15.9098 5 16.2598 5C17.3998 5 18.2798 5.12 18.7898 5.23C18.9698 6.02 19.0898 7.45 18.9598 9.09Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M14.0997 8.49987L8.49951 14.1001L9.89957 15.5002L15.4998 9.89992L14.0997 8.49987Z",
    fill: "black"
  })));
}, "IconSportsFootball");
import Kj from "classnames";
var qj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsGolf } from '@aws-amplify/ui-react'; \u2192 import { MdSportsGolf } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Kj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 16C15.87 16 19 12.87 19 9C19 5.13 15.87 2 12 2C8.13 2 5 5.13 5 9C5 12.87 8.13 16 12 16ZM12 4C14.76 4 17 6.24 17 9C17 11.76 14.76 14 12 14C9.24 14 7 11.76 7 9C7 6.24 9.24 4 12 4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14 9C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7C13.4477 7 13 7.44772 13 8C13 8.55228 13.4477 9 14 9Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6C11 6.55228 11.4477 7 12 7Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M7 19H9C10.1 19 11 19.9 11 21V22H13V21C13 19.9 13.9 19 15 19H17V17H7V19Z",
    fill: "black"
  })));
}, "IconSportsGolf");
import Qj from "classnames";
var Jj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsHandball } from '@aws-amplify/ui-react'; \u2192 import { MdSportsHandball } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Qj(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.2698 6.00026C13.7198 6.95026 14.0498 8.18026 14.9998 8.73026C15.9498 9.28026 17.1798 8.95026 17.7298 8.00026C18.2798 7.05026 17.9498 5.82026 16.9998 5.27026C16.0498 4.72026 14.8198 5.05026 14.2698 6.00026Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15.8398 10.4103C15.8398 10.4103 14.2098 9.47033 13.2398 8.91033C10.8598 7.53033 10.0398 4.47033 11.4198 2.09033L9.68976 1.09033C8.09976 3.83033 8.59977 7.21033 10.6598 9.40033L5.50977 18.3203L7.23977 19.3203L8.73977 16.7203L10.4698 17.7203L7.46977 22.9203L9.19977 23.9203L15.4898 13.0303C16.6298 14.5803 16.8198 16.7203 15.7998 18.4903L17.5298 19.4903C19.1298 16.7403 18.8098 12.9103 15.8398 10.4103Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12.7497 3.80014C13.4697 4.21014 14.3797 3.97014 14.7997 3.25014C15.2097 2.53014 14.9697 1.62014 14.2497 1.20014C13.5297 0.790143 12.6197 1.03014 12.1997 1.75014C11.7897 2.47014 12.0297 3.39014 12.7497 3.80014Z",
    fill: "black"
  })));
}, "IconSportsHandball");
import $j from "classnames";
var Rj = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsHockey } from '@aws-amplify/ui-react'; \u2192 import { MdSportsHockey } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $j(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 17V20H4V16H3C2.45 16 2 16.45 2 17Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9 16.0001H5V20.0001L9.69 19.9901C10.07 19.9901 10.41 19.7801 10.58 19.4401L11.45 17.5401L9.86 14.0601L9 16.0001Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M21.71 16.29C21.53 16.11 21.28 16 21 16H20V20H22V17C22 16.72 21.89 16.47 21.71 16.29Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M13.6001 12.84L17.6501 4H14.3001L12.5401 7.97L12.0501 9.07L12.0001 9.21L9.7001 4H6.3501L10.4001 12.84L11.9201 16.16L12.0001 16.34L13.4201 19.44C13.5901 19.78 13.9301 19.99 14.3101 19.99L19.0001 20V16H15.0001L13.6001 12.84Z",
    fill: "black"
  })));
}, "IconSportsHockey");
import eY from "classnames";
var oY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsKabaddi } from '@aws-amplify/ui-react'; \u2192 import { MdSportsKabaddi } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_42228)"
  }, e.createElement("path", {
    d: "M16.5 4.37988C17.6046 4.37988 18.5 3.48445 18.5 2.37988C18.5 1.27531 17.6046 0.379883 16.5 0.379883C15.3954 0.379883 14.5 1.27531 14.5 2.37988C14.5 3.48445 15.3954 4.37988 16.5 4.37988Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M23.9996 11.8799V7.17989L18.9496 5.03989C17.9796 4.62989 16.8596 4.97989 16.2996 5.87989L15.2996 7.47989C14.6296 8.65989 13.3896 9.53989 11.8896 9.79989L11.9496 9.85989C12.6396 10.5499 13.4696 10.9299 14.4096 11.0299C15.2096 10.6099 15.9296 10.0499 16.4996 9.38989L17.0996 12.3899L15.9396 13.4899L14.9996 14.3799V15.1399V21.8799H16.9996V15.8799L19.0996 13.8799L20.8996 21.8799H22.9996L20.8196 10.8799L20.1996 7.77989L21.9996 8.47989V11.8799H23.9996V11.8799Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M10.29 8.08967C10.51 8.23967 10.76 8.32967 11.01 8.37967C11.14 8.39967 11.26 8.41967 11.39 8.41967C11.52 8.41967 11.65 8.40967 11.77 8.37967C11.9 8.35967 12.02 8.31967 12.14 8.26967C12.38 8.16967 12.61 8.02967 12.8 7.82967C13.29 7.33967 13.47 6.65967 13.35 6.02967C13.28 5.65967 13.1 5.28967 12.8 4.99967C12.61 4.80967 12.38 4.65967 12.14 4.55967C12.02 4.50967 11.9 4.46967 11.77 4.44967C11.64 4.42967 11.52 4.40967 11.39 4.40967C11.27 4.40967 11.16 4.41967 11.04 4.43967C10.9 4.45967 10.76 4.49967 10.63 4.54967C10.4 4.65967 10.17 4.80967 9.97996 4.99967C9.67996 5.28967 9.49996 5.65967 9.42996 6.02967C9.30996 6.65967 9.48996 7.33967 9.97996 7.82967C10.07 7.92967 10.18 8.00967 10.29 8.08967Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11.2398 10.56L9.2398 8.55998C9.1398 8.45998 9.0398 8.37998 8.9298 8.29998C8.7098 8.15998 8.4598 8.05998 8.2098 8.01998C8.0798 7.98998 7.9598 7.97998 7.8298 7.97998C7.3198 7.97998 6.8098 8.17998 6.4198 8.56998L3.0798 11.91C2.6698 12.32 2.4598 12.89 2.4998 13.45C2.4998 13.63 2.5398 13.82 2.6098 14L3.6798 16.95L0.0498047 20.58L1.4598 22L5.6998 17.76V15.54L6.9998 16.75V21.88H8.9998V15.88L6.8798 13.76L9.2398 11.4L9.9498 12.11C11.2398 13.37 12.9198 14.15 14.9798 14.15L14.8398 12.08C13.3398 12.06 12.1398 11.46 11.2398 10.56Z",
    fill: "black"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_42228"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconSportsKabaddi");
import tY from "classnames";
var rY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsMma } from '@aws-amplify/ui-react'; \u2192 import { MdSportsMma } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 20C7 20.55 7.45 21 8 21H16C16.55 21 17 20.55 17 20V17H7V20Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18 7C17.45 7 17 7.45 17 8V5C17 3.9 16.1 3 15 3H7C5.9 3 5 3.9 5 5V10.8C5 10.93 5.01 11.06 5.04 11.19L5.84 15.19C5.93 15.66 6.34 15.99 6.82 15.99H17C17.55 15.99 18.09 15.55 18.2 15.01L18.97 11.18C18.99 11.06 19 10.93 19 10.8V9V8C19 7.45 18.55 7 18 7ZM17 10.6C17 10.73 16.36 14 16.36 14H7.64C7.64 14 7 10.74 7 10.6V5H15V10H17V10.6Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M14 7H8V10H14V7Z",
    fill: "black"
  })));
}, "IconSportsMma");
import iY from "classnames";
var sY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsMotorsports } from '@aws-amplify/ui-react'; \u2192 import { MdSportsMotorsports } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.96 11.22C21.57 7.01 17.76 4 13.56 4C13.37 4 13.18 4.01 12.99 4.02C2 4.74 2 17.2 2 17.2V18C2 19.1 2.9 20 4 20H14C18.67 20 22.41 15.99 21.96 11.22ZM5.26 11.56C5.83 10.27 6.54 9.21 7.4 8.37L11.02 9.9C11.62 10.15 12 10.73 12 11.38C12 12.27 11.28 12.99 10.39 12.99H4.72C4.87 12.53 5.04 12.05 5.26 11.56ZM18.44 16.04C17.3 17.29 15.68 18 14 18H4V17.2C4 17.18 4.01 16.28 4.24 15H10.39C12.38 15 14 13.38 14 11.39C14 9.94 13.13 8.63 11.8 8.07L9.3 7.01C10.4 6.44 11.67 6.11 13.12 6.02C13.27 6 13.42 6 13.56 6C16.87 6 19.69 8.37 19.97 11.41C20.13 13.13 19.59 14.77 18.44 16.04Z",
    fill: "currentColor"
  })));
}, "IconSportsMotorsports");
import aY from "classnames";
var nY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsRugby } from '@aws-amplify/ui-react'; \u2192 import { MdSportsRugby } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.4898 3.51004C19.9298 2.95004 18.3398 2.54004 16.3298 2.54004C13.2498 2.54004 9.17976 3.50004 6.34976 6.33004C1.65976 11.03 2.09976 19.07 3.50976 20.49C4.06976 21.05 5.65976 21.46 7.66976 21.46C10.7498 21.46 14.8198 20.5 17.6498 17.67C22.3398 12.97 21.8998 4.93004 20.4898 3.51004ZM5.70976 18.29C6.33976 16.4 7.86976 13.3 10.5798 10.59C13.2598 7.91004 16.3598 6.36004 18.2798 5.71004C17.6498 7.60004 16.1198 10.7 13.3998 13.41C10.7398 16.09 7.63976 17.64 5.70976 18.29ZM7.75976 7.76004C10.3998 5.12004 14.0998 4.64004 15.7898 4.57004C13.7398 5.51004 11.3298 7.03004 9.17976 9.18004C7.01976 11.34 5.50976 13.76 4.56976 15.81C4.65976 13.33 5.43976 10.07 7.75976 7.76004ZM16.2398 16.24C13.5998 18.88 9.89976 19.36 8.20976 19.43C10.2598 18.49 12.6698 16.97 14.8198 14.82C16.9798 12.66 18.4898 10.24 19.4398 8.19004C19.3398 10.67 18.5598 13.93 16.2398 16.24Z",
    fill: "currentColor"
  })));
}, "IconSportsRugby");
import mY from "classnames";
var cY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsSoccer } from '@aws-amplify/ui-react'; \u2192 import { MdSportsSoccer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 5.3L14.35 4.35C16.17 4.91 17.72 6.11 18.73 7.69L18.34 9.03L16.99 9.49L13 6.7V5.3ZM9.65 4.35L11 5.3V6.7L7.01 9.49L5.66 9.03L5.27 7.69C6.28 6.12 7.83 4.92 9.65 4.35ZM7.08 17.11L5.94 17.21C4.73 15.81 4 13.99 4 12C4 11.88 4.01 11.77 4.02 11.65L5.02 10.92L6.4 11.4L7.86 15.74L7.08 17.11ZM14.5 19.59C13.71 19.85 12.87 20 12 20C11.13 20 10.29 19.85 9.5 19.59L8.81 18.1L9.45 17H14.56L15.2 18.11L14.5 19.59ZM14.27 15H9.73L8.38 10.98L12 8.44L15.63 10.98L14.27 15ZM18.06 17.21L16.92 17.11L16.13 15.74L17.59 11.4L18.98 10.93L19.98 11.66C19.99 11.77 20 11.88 20 12C20 13.99 19.27 15.81 18.06 17.21Z",
    fill: "currentColor"
  })));
}, "IconSportsSoccer");
import lY from "classnames";
var pY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsTennis } from '@aws-amplify/ui-react'; \u2192 import { MdSportsTennis } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.5198 2.4902C17.1798 0.150202 12.8998 0.620202 9.96984 3.5502C8.36984 5.1502 7.44984 7.4202 7.42984 9.0102C7.40984 10.5902 7.68984 12.9002 6.07984 14.5102L1.83984 18.7502L3.25984 20.1702L7.49984 15.9302C9.10984 14.3202 11.4198 14.6002 12.9998 14.5802C14.5798 14.5602 16.8598 13.6402 18.4598 12.0402C21.3798 9.1102 21.8598 4.8302 19.5198 2.4902ZM10.3198 11.6802C8.78984 10.1502 9.26984 7.0702 11.3798 4.9602C13.4898 2.8502 16.5598 2.3702 18.0998 3.9002C19.6298 5.4302 19.1498 8.5102 17.0398 10.6202C14.9298 12.7302 11.8598 13.2102 10.3198 11.6802Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18 17C18.53 17 19.04 17.21 19.41 17.59C20.19 18.37 20.19 19.64 19.41 20.42C19.04 20.79 18.53 21 18 21C17.47 21 16.96 20.79 16.59 20.41C15.81 19.63 15.81 18.36 16.59 17.58C16.96 17.21 17.47 17 18 17ZM18 15C16.98 15 15.95 15.39 15.17 16.17C13.61 17.73 13.61 20.26 15.17 21.83C15.95 22.61 16.98 23 18 23C19.02 23 20.05 22.61 20.83 21.83C22.39 20.27 22.39 17.74 20.83 16.17C20.05 15.39 19.02 15 18 15Z",
    fill: "black"
  })));
}, "IconSportsTennis");
import hY from "classnames";
var fY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSportsVolleyball } from '@aws-amplify/ui-react'; \u2192 import { MdSportsVolleyball } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 4.07C16.07 4.45 18.57 6.59 19.54 9.43L13 5.65V4.07ZM8 5.08C9.18 4.39 11.33 4.02 11 4.06V11.41L8 13.14V5.08ZM4.63 15.1C4.23 14.14 4 13.1 4 12C4 9.98 4.76 8.14 6 6.73V14.31L4.63 15.1ZM5.64 16.83L12 13.15L15 14.88L8.02 18.91C7.09 18.38 6.28 17.68 5.64 16.83ZM12 20C11.46 20 10.93 19.94 10.42 19.84L17 16.04L18.36 16.82C16.9 18.75 14.6 20 12 20ZM13 11.42V7.96L20 12.01C20 13.11 19.77 14.15 19.37 15.1L13 11.42Z",
    fill: "currentColor"
  })));
}, "IconSportsVolleyball");
import CY from "classnames";
var gY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSports } from '@aws-amplify/ui-react'; \u2192 import { MdSports } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.23 6C9.57 6 8.01 6.66 6.87 7.73C6.54 6.73 5.61 6 4.5 6C3.12 6 2 7.12 2 8.5C2 9.88 3.12 11 4.5 11C4.71 11 4.91 10.97 5.11 10.92C5.06 11.17 5.02 11.43 5.01 11.7C4.83 15.38 7.96 18.38 11.69 17.97C14.24 17.69 16.37 15.71 16.88 13.2C17.03 12.49 17.03 11.8 16.94 11.14C16.85 10.54 17.32 10.01 17.93 10.01H22V6H11.23ZM4.5 9C4.22 9 4 8.78 4 8.5C4 8.22 4.22 8 4.5 8C4.78 8 5 8.22 5 8.5C5 8.78 4.78 9 4.5 9ZM11 15C9.34 15 8 13.66 8 12C8 10.34 9.34 9 11 9C12.66 9 14 10.34 14 12C14 13.66 12.66 15 11 15Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M11 14C12.1046 14 13 13.1046 13 12C13 10.8954 12.1046 10 11 10C9.89543 10 9 10.8954 9 12C9 13.1046 9.89543 14 11 14Z",
    fill: "black"
  })));
}, "IconSports");
import uY from "classnames";
var wY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSquareFoot } from '@aws-amplify/ui-react'; \u2192 import { MdSquareFoot } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.66 17.66L16.6 18.72L15.89 18.01L16.95 16.95L15.01 15.01L13.95 16.07L13.24 15.36L14.3 14.3L12.36 12.36L11.3 13.42L10.59 12.71L11.65 11.65L9.7 9.7L8.64 10.76L7.93 10.05L8.99 8.99L7.05 7.05L5.99 8.11L5.28 7.4L6.34 6.34L4 4V18C4 19.1 4.9 20 6 20H20L17.66 17.66ZM7 17V11.24L12.76 17H7Z",
    fill: "currentColor"
  })));
}, "IconSquareFoot");
import dY from "classnames";
var VY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStackedLineChart } from '@aws-amplify/ui-react'; \u2192 import { MdStackedLineChart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 19.9898L9.5 12.4798L13.5 16.4798L20.59 8.50977L22 9.91977L13.5 19.4798L9.5 15.4798L3.5 21.4898L2 19.9898ZM3.5 15.4898L9.5 9.47976L13.5 13.4798L22 3.91977L20.59 2.50977L13.5 10.4798L9.5 6.47977L2 13.9898L3.5 15.4898Z",
    fill: "currentColor"
  })));
}, "IconStackedLineChart");
import HY from "classnames";
var MY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStairs } from '@aws-amplify/ui-react'; \u2192 import { MdStairs } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM18 6H13.58V9.33H11V12.66H8.42V16H6V18H10.42V14.67H13V11.34H15.58V8H18V6Z",
    fill: "currentColor"
  })));
}, "IconStairs");
import xY from "classnames";
var IY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStarBorderPurple500 } from '@aws-amplify/ui-react'; \u2192 import { MdStarBorderPurple500 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 9.24L14.81 8.62L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.55 13.97L22 9.24ZM12 15.4L8.24 17.67L9.24 13.39L5.92 10.51L10.3 10.13L12 6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z",
    fill: "currentColor"
  })));
}, "IconStarBorderPurple500");
import LY from "classnames";
var vY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStarBorder } from '@aws-amplify/ui-react'; \u2192 import { MdStarBorder } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 9.24L14.81 8.62L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.55 13.97L22 9.24ZM12 15.4L8.24 17.67L9.24 13.39L5.92 10.51L10.3 10.13L12 6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z",
    fill: "currentColor"
  })));
}, "IconStarBorder");
import NY from "classnames";
var yY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStarHalf } from '@aws-amplify/ui-react'; \u2192 import { MdStarHalf } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 9.24L14.81 8.62L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.55 13.97L22 9.24ZM12 15.4V6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z",
    fill: "currentColor"
  })));
}, "IconStarHalf");
import bY from "classnames";
var ZY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStarOutline } from '@aws-amplify/ui-react'; \u2192 import { MdStarOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 9.24L14.81 8.62L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.55 13.97L22 9.24ZM12 15.4L8.24 17.67L9.24 13.39L5.92 10.51L10.3 10.13L12 6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z",
    fill: "currentColor"
  })));
}, "IconStarOutline");
import BY from "classnames";
var WY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStarPurple500 } from '@aws-amplify/ui-react'; \u2192 import { MdStarPurple500 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z",
    fill: "currentColor"
  })));
}, "IconStarPurple500");
import kY from "classnames";
var DY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStarRate } from '@aws-amplify/ui-react'; \u2192 import { MdStarRate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 8.89L12.94 12H15.76L13.49 13.62L14.42 16.63L12 14.79L9.58 16.63L10.51 13.62L8.24 12H11.06L12 8.89ZM12 2L9.58 10H2L8.17 14.41L5.83 22L12 17.31L18.18 22L15.83 14.41L22 10H14.42L12 2Z",
    fill: "currentColor"
  })));
}, "IconStarRate");
import PY from "classnames";
var jt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z",
    fill: "currentColor"
  })));
}, "IconStar");
import SY from "classnames";
var jY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStars } from '@aws-amplify/ui-react'; \u2192 import { MdStars } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM19.47 9.16L14.46 8.73L12.46 4.02C15.67 4.21 18.37 6.29 19.47 9.16ZM14.4 15.42L12 13.98L9.61 15.42L10.24 12.7L8.13 10.87L10.91 10.63L12 8.06L13.09 10.62L15.87 10.86L13.76 12.69L14.4 15.42V15.42ZM11.54 4.02L9.54 8.74L4.52 9.17C5.62 6.29 8.32 4.2 11.54 4.02V4.02ZM4 12C4 11.36 4.08 10.74 4.23 10.14L8.02 13.42L6.91 18.17C5.13 16.7 4 14.48 4 12ZM7.84 18.82L12 16.31L16.16 18.81C14.94 19.56 13.52 20 11.99 20C10.47 20 9.05 19.56 7.84 18.82ZM17.09 18.17L15.98 13.42L19.77 10.14C19.91 10.73 20 11.36 20 12C20 14.48 18.86 16.7 17.09 18.17Z",
    fill: "currentColor"
  })));
}, "IconStars");
import YY from "classnames";
var FY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStayCurrentLandscape } from '@aws-amplify/ui-react'; \u2192 import { MdStayCurrentLandscape } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1.01 7L1 17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5H3C1.9 5 1.01 5.9 1.01 7ZM19 7V17H5V7H19Z",
    fill: "currentColor"
  })));
}, "IconStayCurrentLandscape");
import TY from "classnames";
var AY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStayCurrentPortrait } from '@aws-amplify/ui-react'; \u2192 import { MdStayCurrentPortrait } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 1.01L7.00001 1C5.90001 1 5.01001 1.9 5.01001 3V21C5.01001 22.1 5.90001 23 7.00001 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7.00001V5H17V19Z",
    fill: "currentColor"
  })));
}, "IconStayCurrentPortrait");
import EY from "classnames";
var OY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStayPrimaryLandscape } from '@aws-amplify/ui-react'; \u2192 import { MdStayPrimaryLandscape } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1.01 7L1 17C1 18.1 1.9 19 3 19H21C22.1 19 23 18.1 23 17V7C23 5.9 22.1 5 21 5H3C1.9 5 1.01 5.9 1.01 7ZM19 7V17H5V7H19Z",
    fill: "currentColor"
  })));
}, "IconStayPrimaryLandscape");
import _Y from "classnames";
var GY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStayPrimaryPortrait } from '@aws-amplify/ui-react'; \u2192 import { MdStayPrimaryPortrait } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _Y(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 1.01L7.00001 1C5.90001 1 5.01001 1.9 5.01001 3V21C5.01001 22.1 5.90001 23 7.00001 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7.00001V5H17V19Z",
    fill: "currentColor"
  })));
}, "IconStayPrimaryPortrait");
import UY from "classnames";
var zY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStickyNote_2 } from '@aws-amplify/ui-react'; \u2192 import { MdStickyNote_2 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V14H14V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H15L21 15V5C21 3.9 20.1 3 19 3ZM12 14H7V12H12V14ZM17 10H7V8H17V10Z",
    fill: "currentColor"
  })));
}, "IconStickyNote_2");
import XY from "classnames";
var KY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStopCircle } from '@aws-amplify/ui-react'; \u2192 import { MdStopCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 8H8V16H16V8Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
    fill: "black"
  })));
}, "IconStopCircle");
import qY from "classnames";
var QY = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStopScreenShare } from '@aws-amplify/ui-react'; \u2192 import { MdStopScreenShare } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.79 17.9998L23.79 19.9998H24V17.9998H21.79ZM1.11 2.97982L2.66 4.53982C2.25 4.90982 2 5.42982 2 6.01982V15.9998C2 17.0998 2.9 17.9998 4.01 17.9998H0V19.9998H18.13L20.84 22.7098L22.25 21.2998L2.52 1.56982L1.11 2.97982ZM4 6.01982H4.13L9.08 10.9498C7.94 12.0698 7.31 13.5198 7 14.9998C7.96 13.7098 9.13 12.9198 10.67 12.5398L14.13 16.0198H4V6.01982ZM20 6.01982V16.2098L21.3 17.5098C21.72 17.1398 22 16.6198 22 16.0198V6.01982C22 4.90982 21.1 4.01982 20 4.01982H7.8L9.8 6.01982H20V6.01982ZM12.93 9.14982L15.72 11.9298L17 10.7298L13 6.99982V9.12982L12.93 9.14982Z",
    fill: "currentColor"
  })));
}, "IconStopScreenShare");
import JY from "classnames";
var $Y = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStop } from '@aws-amplify/ui-react'; \u2192 import { MdStop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 8V16H8V8H16ZM18 6H6V18H18V6Z",
    fill: "currentColor"
  })));
}, "IconStop");
import RY from "classnames";
var eF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStorage } from '@aws-amplify/ui-react'; \u2192 import { MdStorage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RY(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 20H22V16H2V20ZM4 17H6V19H4V17ZM2 4V8H22V4H2ZM6 7H4V5H6V7ZM2 14H22V10H2V14ZM4 11H6V13H4V11Z",
    fill: "currentColor"
  })));
}, "IconStorage");
import oF from "classnames";
var tF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStoreMallDirectory } from '@aws-amplify/ui-react'; \u2192 import { MdStoreMallDirectory } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.36 9L18.96 12H5.04L5.64 9H18.36ZM20 4H4V6H20V4ZM20 7H4L3 12V14H4V20H14V14H18V20H20V14H21V12L20 7ZM6 18V14H12V18H6Z",
    fill: "currentColor"
  })));
}, "IconStoreMallDirectory");
import rF from "classnames";
var iF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStore } from '@aws-amplify/ui-react'; \u2192 import { MdStore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.36 9L18.96 12H5.04L5.64 9H18.36ZM20 4H4V6H20V4ZM20 7H4L3 12V14H4V20H14V14H18V20H20V14H21V12L20 7ZM6 18V14H12V18H6Z",
    fill: "currentColor"
  })));
}, "IconStore");
import sF from "classnames";
var aF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStorefront } from '@aws-amplify/ui-react'; \u2192 import { MdStorefront } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.9 8.89L20.85 4.52C20.63 3.62 19.85 3 18.94 3H5.05001C4.15001 3 3.36001 3.63 3.15001 4.52L2.10001 8.89C1.86001 9.91 2.08001 10.95 2.72001 11.77C2.80001 11.88 2.91001 11.96 3.00001 12.06V19C3.00001 20.1 3.90001 21 5.00001 21H19C20.1 21 21 20.1 21 19V12.06C21.09 11.97 21.2 11.88 21.28 11.78C21.92 10.96 22.15 9.91 21.9 8.89ZM18.91 4.99L19.96 9.36C20.06 9.78 19.97 10.2 19.71 10.53C19.57 10.71 19.27 11 18.77 11C18.16 11 17.63 10.51 17.56 9.86L16.98 5L18.91 4.99ZM13 5H14.96L15.5 9.52C15.55 9.91 15.43 10.3 15.17 10.59C14.95 10.85 14.63 11 14.22 11C13.55 11 13 10.41 13 9.69V5ZM8.49001 9.52L9.04001 5H11V9.69C11 10.41 10.45 11 9.71001 11C9.37001 11 9.06001 10.85 8.82001 10.59C8.57001 10.3 8.45001 9.91 8.49001 9.52ZM4.04001 9.36L5.05001 5H7.02001L6.44001 9.86C6.36001 10.51 5.84001 11 5.23001 11C4.74001 11 4.43001 10.71 4.30001 10.53C4.03001 10.21 3.94001 9.78 4.04001 9.36ZM5.00001 19V12.97C5.08001 12.98 5.15001 13 5.23001 13C6.10001 13 6.89001 12.64 7.47001 12.05C8.07001 12.65 8.87001 13 9.78001 13C10.65 13 11.43 12.64 12.01 12.07C12.6 12.64 13.4 13 14.3 13C15.14 13 15.94 12.65 16.54 12.05C17.12 12.64 17.91 13 18.78 13C18.86 13 18.93 12.98 19.01 12.97V19H5.00001Z",
    fill: "currentColor"
  })));
}, "IconStorefront");
import nF from "classnames";
var mF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStraighten } from '@aws-amplify/ui-react'; \u2192 import { MdStraighten } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H5V12H7V8H9V12H11V8H13V12H15V8H17V12H19V8H21V16Z",
    fill: "currentColor"
  })));
}, "IconStraighten");
import cF from "classnames";
var lF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStreetview } from '@aws-amplify/ui-react'; \u2192 import { MdStreetview } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.56 14.33C12.22 14.6 12 15.03 12 15.5V21H19C20.1 21 21 20.1 21 19V13.02C20.06 12.69 19.05 12.5 18 12.5C15.97 12.5 14.07 13.2 12.56 14.33V14.33Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18 11C20.7614 11 23 8.76142 23 6C23 3.23858 20.7614 1 18 1C15.2386 1 13 3.23858 13 6C13 8.76142 15.2386 11 18 11Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M11.5 6C11.5 4.92 11.77 3.9 12.24 3H5C3.9 3 3 3.9 3 5V19C3 19.55 3.23 20.05 3.59 20.41L13.41 10.59C12.23 9.42 11.5 7.8 11.5 6Z",
    fill: "black"
  })));
}, "IconStreetview");
import pF from "classnames";
var hF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStrikethroughS } from '@aws-amplify/ui-react'; \u2192 import { MdStrikethroughS } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.24 8.75C6.98 8.27 6.85 7.72 6.85 7.08C6.85 6.47 6.98 5.92 7.25 5.41C7.51 4.91 7.88 4.48 8.36 4.12C8.84 3.77 9.41 3.49 10.06 3.29C10.72 3.1 11.45 3 12.24 3C13.05 3 13.78 3.11 14.45 3.34C15.11 3.56 15.68 3.88 16.14 4.28C16.61 4.68 16.97 5.16 17.22 5.71C17.47 6.26 17.6 6.86 17.6 7.52H14.59C14.59 7.21 14.54 6.93 14.44 6.67C14.35 6.4 14.2 6.18 14 5.99C13.8 5.8 13.55 5.66 13.25 5.55C12.95 5.45 12.59 5.39 12.19 5.39C11.8 5.39 11.45 5.43 11.16 5.52C10.87 5.61 10.63 5.73 10.44 5.88C10.25 6.04 10.1 6.22 10 6.43C9.9 6.64 9.85 6.86 9.85 7.09C9.85 7.57 10.1 7.97 10.59 8.3C10.97 8.55 11.36 8.78 12 9H7.39C7.34 8.92 7.28 8.83 7.24 8.75V8.75ZM21 12V10H3V12H12.62C12.8 12.07 13.02 12.14 13.17 12.2C13.54 12.37 13.83 12.54 14.04 12.71C14.25 12.88 14.39 13.07 14.47 13.28C14.54 13.48 14.58 13.71 14.58 13.97C14.58 14.2 14.53 14.42 14.44 14.63C14.35 14.83 14.21 15.01 14.02 15.16C13.83 15.31 13.6 15.42 13.31 15.51C13.02 15.59 12.68 15.64 12.3 15.64C11.87 15.64 11.47 15.6 11.12 15.51C10.77 15.42 10.46 15.28 10.21 15.09C9.96 14.9 9.76 14.65 9.62 14.34C9.48 14.03 9.37 13.58 9.37 13.13H6.4C6.4 13.68 6.48 14.26 6.64 14.71C6.8 15.16 7.01 15.56 7.29 15.92C7.57 16.27 7.89 16.58 8.27 16.84C8.64 17.1 9.05 17.32 9.49 17.49C9.93 17.66 10.39 17.79 10.87 17.88C11.35 17.96 11.83 18.01 12.31 18.01C13.11 18.01 13.84 17.92 14.49 17.73C15.14 17.54 15.7 17.28 16.16 16.94C16.62 16.6 16.98 16.17 17.23 15.67C17.48 15.17 17.61 14.6 17.61 13.96C17.61 13.36 17.51 12.82 17.3 12.35C17.25 12.24 17.19 12.12 17.13 12.02H21V12Z",
    fill: "currentColor"
  })));
}, "IconStrikethroughS");
import fF from "classnames";
var CF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStroller } from '@aws-amplify/ui-react'; \u2192 import { MdStroller } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 20C18 21.1 17.1 22 16 22C14.9 22 14 21.1 14 20C14 18.9 14.9 18 16 18C17.1 18 18 18.9 18 20ZM6 18C4.9 18 4 18.9 4 20C4 21.1 4.9 22 6 22C7.1 22 8 21.1 8 20C8 18.9 7.1 18 6 18ZM15 8.66L9.6 15H15V8.66ZM18.65 3C20.52 3 22 4.56 22 6.48V7H20V6.48C20 5.66 19.42 5 18.65 5C17.97 5 17.58 5.59 17 6.27V15C17 16.1 16.1 17 15 17H7.43C6.58 17 6.12 16 6.67 15.35L15.47 5.03C16.11 4.27 16.99 3 18.65 3ZM10 5C9.35 5 8.71 5.09 8.09 5.27L9.49 6.67L10.86 5.06C10.58 5.02 10.29 5 10 5ZM10 3C11.56 3 13.03 3.4 14.3 4.1L9.6 9.61L4.72 4.72C6.21 3.64 8.03 3 10 3Z",
    fill: "currentColor"
  })));
}, "IconStroller");
import gF from "classnames";
var uF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconStyle } from '@aws-amplify/ui-react'; \u2192 import { MdStyle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2.5301 19.65L3.8701 20.21V11.18L1.4401 17.04C1.0301 18.06 1.5201 19.23 2.5301 19.65V19.65ZM22.0301 15.95L17.0701 3.98C16.7601 3.23 16.0301 2.77 15.2601 2.75C15.0001 2.75 14.7301 2.79 14.4701 2.9L7.1001 5.95C6.3501 6.26 5.8901 6.98 5.8701 7.75C5.8601 8.02 5.9101 8.29 6.0201 8.55L10.9801 20.52C11.2901 21.28 12.0301 21.74 12.8101 21.75C13.0701 21.75 13.3301 21.7 13.5801 21.6L20.9401 18.55C21.9601 18.13 22.4501 16.96 22.0301 15.95V15.95ZM12.8301 19.75L7.8701 7.79L15.2201 4.75H15.2301L20.1801 16.7L12.8301 19.75V19.75Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M11 10C11.5523 10 12 9.55228 12 9C12 8.44772 11.5523 8 11 8C10.4477 8 10 8.44772 10 9C10 9.55228 10.4477 10 11 10Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M5.87988 19.7502C5.87988 20.8502 6.77988 21.7502 7.87988 21.7502H9.32988L5.87988 13.4102V19.7502Z",
    fill: "black"
  })));
}, "IconStyle");
import wF from "classnames";
var dF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSubdirectoryArrowLeft } from '@aws-amplify/ui-react'; \u2192 import { MdSubdirectoryArrowLeft } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 9L12.42 10.42L8.83 14H18V4H20V16H8.83L12.42 19.58L11 21L5 15L11 9Z",
    fill: "currentColor"
  })));
}, "IconSubdirectoryArrowLeft");
import VF from "classnames";
var HF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSubdirectoryArrowRight } from '@aws-amplify/ui-react'; \u2192 import { MdSubdirectoryArrowRight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 15L13 21L11.58 19.58L15.17 16H4V4H6V14H15.17L11.58 10.42L13 9L19 15Z",
    fill: "currentColor"
  })));
}, "IconSubdirectoryArrowRight");
import MF from "classnames";
var xF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSubject } from '@aws-amplify/ui-react'; \u2192 import { MdSubject } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: MF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 17H4V19H14V17ZM20 9H4V11H20V9ZM4 15H20V13H4V15ZM4 5V7H20V5H4Z",
    fill: "currentColor"
  })));
}, "IconSubject");
import IF from "classnames";
var LF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSubscript } from '@aws-amplify/ui-react'; \u2192 import { MdSubscript } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: IF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.9999 18H19.9999V19H22.9999V20H18.9999V18C18.9999 17.45 19.4499 17 19.9999 17H21.9999V16H18.9999V15H21.9999C22.5499 15 22.9999 15.45 22.9999 16V17C22.9999 17.55 22.5499 18 21.9999 18ZM5.87988 18H8.53988L11.9399 12.58H12.0599L15.4599 18H18.1199L13.4699 10.73L17.8099 4H15.1299L12.0599 8.99H11.9399L8.84988 4H6.18988L10.5099 10.73L5.87988 18Z",
    fill: "currentColor"
  })));
}, "IconSubscript");
import vF from "classnames";
var NF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSubscriptions } from '@aws-amplify/ui-react'; \u2192 import { MdSubscriptions } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H20V8H4V6ZM6 2H18V4H6V2ZM20 10H4C2.9 10 2 10.9 2 12V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V12C22 10.9 21.1 10 20 10ZM20 20H4V12H20V20ZM10 12.73V19.26L16 16L10 12.73Z",
    fill: "currentColor"
  })));
}, "IconSubscriptions");
import yF from "classnames";
var bF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSubtitlesOff } from '@aws-amplify/ui-react'; \u2192 import { MdSubtitlesOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H6.83002L8.83002 6H20V17.17L21.76 18.93C21.91 18.65 22 18.34 22 18V6C22 4.9 21.1 4 20 4Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M18 10H12.83L14.83 12H18V10Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M1.04001 3.8702L2.24001 5.0702C2.09001 5.3502 2.00001 5.6602 2.00001 6.0002V18.0002C2.00001 19.1002 2.90001 20.0002 4.00001 20.0002H17.17L20.13 22.9602L21.54 21.5502L2.45001 2.4502L1.04001 3.8702ZM4.00001 6.8302L7.17001 10.0002H6.00001V12.0002H8.00001V10.8302L11.17 14.0002H6.00001V16.0002H13.17L15.17 18.0002H4.00001V6.8302Z",
    fill: "black"
  })));
}, "IconSubtitlesOff");
import ZF from "classnames";
var BF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSubtitles } from '@aws-amplify/ui-react'; \u2192 import { MdSubtitles } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18ZM6 10H8V12H6V10ZM6 14H14V16H6V14ZM16 14H18V16H16V14ZM10 10H18V12H10V10Z",
    fill: "currentColor"
  })));
}, "IconSubtitles");
import WF from "classnames";
var kF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSubway } from '@aws-amplify/ui-react'; \u2192 import { MdSubway } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.8 2.8C16 2.09 13.86 2 12 2C10.14 2 8 2.09 6.2 2.8C3.53 3.84 2 6.05 2 8.86V22H22V8.86C22 6.05 20.47 3.84 17.8 2.8ZM9.17 20L10.67 18.5H13.33L14.83 20H9.17ZM7.01 14V9H17.01V14H7.01V14ZM16.5 16C16.5 16.55 16.05 17 15.5 17C14.95 17 14.5 16.55 14.5 16C14.5 15.45 14.95 15 15.5 15C16.05 15 16.5 15.45 16.5 16ZM8.5 15C9.05 15 9.5 15.45 9.5 16C9.5 16.55 9.05 17 8.5 17C7.95 17 7.5 16.55 7.5 16C7.5 15.45 7.95 15 8.5 15ZM20 20H16.5V19.62L15.35 18.46C16.84 18.29 18 17.04 18 15.5V9C18 6.37 15 6 12 6C9 6 6 6.37 6 9V15.5C6 17.04 7.16 18.29 8.65 18.46L7.5 19.62V20H4V8.86C4 6.86 5.01 5.41 6.93 4.66C8.41 4.08 10.32 4 12 4C13.68 4 15.59 4.08 17.07 4.66C18.99 5.41 20 6.86 20 8.86V20Z",
    fill: "currentColor"
  })));
}, "IconSubway");
import DF from "classnames";
var PF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSuperscript } from '@aws-amplify/ui-react'; \u2192 import { MdSuperscript } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.9999 7H19.9999V8H22.9999V9H18.9999V7C18.9999 6.45 19.4499 6 19.9999 6H21.9999V5H18.9999V4H21.9999C22.5499 4 22.9999 4.45 22.9999 5V6C22.9999 6.55 22.5499 7 21.9999 7ZM5.87988 20H8.53988L11.9399 14.58H12.0599L15.4599 20H18.1199L13.4699 12.73L17.8099 6H15.1299L12.0599 10.99H11.9399L8.84988 6H6.18988L10.5099 12.73L5.87988 20Z",
    fill: "currentColor"
  })));
}, "IconSuperscript");
import SF from "classnames";
var jF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSupervisedUserCircle } from '@aws-amplify/ui-react'; \u2192 import { MdSupervisedUserCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.5 9.99977C12.5 8.34977 11.15 6.99977 9.49999 6.99977C7.84999 6.99977 6.49999 8.34977 6.49999 9.99977C6.49999 11.6498 7.84999 12.9998 9.49999 12.9998C11.15 12.9998 12.5 11.6498 12.5 9.99977ZM9.49999 10.9998C8.94999 10.9998 8.49999 10.5498 8.49999 9.99977C8.49999 9.44977 8.94999 8.99977 9.49999 8.99977C10.05 8.99977 10.5 9.44977 10.5 9.99977C10.5 10.5498 10.05 10.9998 9.49999 10.9998ZM16 12.9998C17.11 12.9998 18 12.1098 18 10.9998C18 9.88977 17.11 8.99977 16 8.99977C14.89 8.99977 13.99 9.88977 14 10.9998C14 12.1098 14.89 12.9998 16 12.9998ZM11.99 2.00977C6.46999 2.00977 1.98999 6.48977 1.98999 12.0098C1.98999 17.5298 6.46999 22.0098 11.99 22.0098C17.51 22.0098 21.99 17.5298 21.99 12.0098C21.99 6.48977 17.51 2.00977 11.99 2.00977V2.00977ZM5.83999 17.1198C6.51999 16.5798 8.10999 16.0098 9.49999 16.0098C9.56999 16.0098 9.64999 16.0198 9.72999 16.0198C9.96999 15.3798 10.4 14.7298 11.03 14.1598C10.47 14.0598 9.93999 13.9998 9.49999 13.9998C8.19999 13.9998 6.10999 14.4498 4.76999 15.4298C4.26999 14.3898 3.98999 13.2298 3.98999 11.9998C3.98999 7.58977 7.57999 3.99977 11.99 3.99977C16.4 3.99977 19.99 7.58977 19.99 11.9998C19.99 13.1998 19.72 14.3398 19.24 15.3698C18.24 14.7798 16.88 14.4998 16 14.4998C14.48 14.4998 11.5 15.3098 11.5 17.1998V19.9798C9.22999 19.8498 7.20999 18.7698 5.83999 17.1198V17.1198Z",
    fill: "currentColor"
  })));
}, "IconSupervisedUserCircle");
import YF from "classnames";
var FF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSupervisorAccount } from '@aws-amplify/ui-react'; \u2192 import { MdSupervisorAccount } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM9.05 17H4.77C5.76 16.5 7.47 16 9 16C9.11 16 9.23 16.01 9.34 16.01C9.68 15.28 10.27 14.68 10.98 14.2C10.25 14.07 9.56 14 9 14C6.66 14 2 15.17 2 17.5V19H9V17.5C9 17.33 9.02 17.16 9.05 17ZM16.5 14.5C14.66 14.5 11 15.51 11 17.5V19H22V17.5C22 15.51 18.34 14.5 16.5 14.5ZM17.71 12.68C18.47 12.25 19 11.44 19 10.5C19 9.12 17.88 8 16.5 8C15.12 8 14 9.12 14 10.5C14 11.44 14.53 12.25 15.29 12.68C15.65 12.88 16.06 13 16.5 13C16.94 13 17.35 12.88 17.71 12.68Z",
    fill: "currentColor"
  })));
}, "IconSupervisorAccount");
import TF from "classnames";
var AF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSupportAgent } from '@aws-amplify/ui-react'; \u2192 import { MdSupportAgent } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 12.22C21 6.73 16.74 3 12 3C7.31 3 3 6.65 3 12.28C2.4 12.62 2 13.26 2 14V16C2 17.1 2.9 18 4 18H5V11.9C5 8.03 8.13 4.9 12 4.9C15.87 4.9 19 8.03 19 11.9V19H11V21H19C20.1 21 21 20.1 21 19V17.78C21.59 17.47 22 16.86 22 16.14V13.84C22 13.14 21.59 12.53 21 12.22Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M9 14C9.55228 14 10 13.5523 10 13C10 12.4477 9.55228 12 9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18 11.03C17.52 8.18 15.04 6 12.05 6C9.01997 6 5.75997 8.51 6.01997 12.45C8.48997 11.44 10.35 9.24 10.88 6.56C12.19 9.19 14.88 11 18 11.03Z",
    fill: "black"
  })));
}, "IconSupportAgent");
import EF from "classnames";
var OF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSupport } from '@aws-amplify/ui-react'; \u2192 import { MdSupport } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM19.46 9.12L16.68 10.27C16.17 8.91 15.1 7.83 13.73 7.33L14.88 4.55C16.98 5.35 18.65 7.02 19.46 9.12ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15ZM9.13 4.54L10.3 7.32C8.92 7.82 7.83 8.91 7.32 10.29L4.54 9.13C5.35 7.02 7.02 5.35 9.13 4.54ZM4.54 14.87L7.32 13.72C7.83 15.1 8.91 16.18 10.29 16.68L9.12 19.46C7.02 18.65 5.35 16.98 4.54 14.87ZM14.88 19.46L13.73 16.68C15.1 16.17 16.18 15.09 16.68 13.71L19.46 14.88C18.65 16.98 16.98 18.65 14.88 19.46Z",
    fill: "currentColor"
  })));
}, "IconSupport");
import _F from "classnames";
var GF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSurroundSound } from '@aws-amplify/ui-react'; \u2192 import { MdSurroundSound } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _F(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M8.29 15.7098C7.27 14.6898 6.75 13.3498 6.75 11.9998C6.75 10.6498 7.27 9.3098 8.28 8.2798L7.05 7.0498C5.68 8.4098 5 10.2098 5 11.9998C5 13.7898 5.68 15.5898 7.06 16.9398L8.29 15.7098Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 15.5C13.93 15.5 15.5 13.93 15.5 12C15.5 10.07 13.93 8.5 12 8.5C10.07 8.5 8.5 10.07 8.5 12C8.5 13.93 10.07 15.5 12 15.5ZM12 10.5C12.83 10.5 13.5 11.17 13.5 12C13.5 12.83 12.83 13.5 12 13.5C11.17 13.5 10.5 12.83 10.5 12C10.5 11.17 11.17 10.5 12 10.5Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M15.72 15.7201L16.95 16.9501C18.32 15.5901 19 13.7901 19 12.0001C19 10.2101 18.32 8.41006 16.94 7.06006L15.71 8.29006C16.73 9.31006 17.25 10.6501 17.25 12.0001C17.25 13.3501 16.73 14.6901 15.72 15.7201Z",
    fill: "black"
  })));
}, "IconSurroundSound");
import UF from "classnames";
var zF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwapCalls } from '@aws-amplify/ui-react'; \u2192 import { MdSwapCalls } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 4L14 8H17V15C17 16.1 16.1 17 15 17C13.9 17 13 16.1 13 15V8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8V15H2L6 19L10 15H7V8C7 6.9 7.9 6 9 6C10.1 6 11 6.9 11 8V15C11 17.21 12.79 19 15 19C17.21 19 19 17.21 19 15V8H22L18 4Z",
    fill: "currentColor"
  })));
}, "IconSwapCalls");
import XF from "classnames";
var KF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwapHoriz } from '@aws-amplify/ui-react'; \u2192 import { MdSwapHoriz } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z",
    fill: "currentColor"
  })));
}, "IconSwapHoriz");
import qF from "classnames";
var QF = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwapHorizontalCircle } from '@aws-amplify/ui-react'; \u2192 import { MdSwapHorizontalCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM15 6.5V9H11V11H15V13.5L18.5 10L15 6.5ZM9 10.5L5.5 14L9 17.5V15H13V13H9V10.5Z",
    fill: "currentColor"
  })));
}, "IconSwapHorizontalCircle");
import JF from "classnames";
var $F = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwapVert } from '@aws-amplify/ui-react'; \u2192 import { MdSwapVert } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 17.01V10H14V17.01H11L15 21L19 17.01H16V17.01ZM9 3L5 6.99H8V14H10V6.99H13L9 3ZM16 17.01V10H14V17.01H11L15 21L19 17.01H16ZM9 3L5 6.99H8V14H10V6.99H13L9 3Z",
    fill: "currentColor"
  })));
}, "IconSwapVert");
import RF from "classnames";
var eT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwapVerticalCircle } from '@aws-amplify/ui-react'; \u2192 import { MdSwapVerticalCircle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RF(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM6.5 9L10 5.5L13.5 9H11V13H9V9H6.5ZM17.5 15L14 18.5L10.5 15H13V11H15V15H17.5Z",
    fill: "currentColor"
  })));
}, "IconSwapVerticalCircle");
import oT from "classnames";
var tT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwitchCamera } from '@aws-amplify/ui-react'; \u2192 import { MdSwitchCamera } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H16.83L15 2H9L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM9.88 4H14.12L15.95 6H20V18H4V6H8.05",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15 11H9V8.5L5.5 12L9 15.5V13H15V15.5L18.5 12L15 8.5V11Z",
    fill: "black"
  })));
}, "IconSwitchCamera");
import rT from "classnames";
var iT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwitchLeft } from '@aws-amplify/ui-react'; \u2192 import { MdSwitchLeft } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.5 8.62V15.38L5.12 12L8.5 8.62ZM10 5L3 12L10 19V5ZM14 5V19L21 12L14 5Z",
    fill: "currentColor"
  })));
}, "IconSwitchLeft");
import sT from "classnames";
var aT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwitchRight } from '@aws-amplify/ui-react'; \u2192 import { MdSwitchRight } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_41339)"
  }, e.createElement("path", {
    d: "M15.5 15.38V8.62L18.88 12L15.5 15.38ZM14 19L21 12L14 5V19ZM10 19V5L3 12L10 19Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_41339"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconSwitchRight");
import nT from "classnames";
var mT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSwitchVideo } from '@aws-amplify/ui-react'; \u2192 import { MdSwitchVideo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 13H12V15L15 12L12 9V11H8V9L5 12L8 15V13ZM18 9.5V6C18 5.45 17.55 5 17 5H3C2.45 5 2 5.45 2 6V18C2 18.55 2.45 19 3 19H17C17.55 19 18 18.55 18 18V14.5L22 18.5V5.5L18 9.5ZM16 17H4V7H16V17Z",
    fill: "currentColor"
  })));
}, "IconSwitchVideo");
import cT from "classnames";
var lT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSyncAlt } from '@aws-amplify/ui-react'; \u2192 import { MdSyncAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 8L18 4V7H3V9H18V12L22 8Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M2 16L6 20V17H21V15H6V12L2 16Z",
    fill: "black"
  })));
}, "IconSyncAlt");
import pT from "classnames";
var hT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSyncDisabled } from '@aws-amplify/ui-react'; \u2192 import { MdSyncDisabled } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.99986 6.35V4.26C9.33986 4.43 8.70986 4.69 8.11986 5.01L9.61986 6.51C9.74986 6.46 9.86986 6.4 9.99986 6.35V6.35ZM19.9999 12C19.9999 9.79 19.0899 7.8 17.6399 6.36L19.9999 4H13.9999V10L16.2399 7.76C17.3199 8.85 17.9999 10.34 17.9999 12C17.9999 12.85 17.8099 13.65 17.4899 14.38L18.9899 15.88C19.6299 14.74 19.9999 13.41 19.9999 12ZM4.26986 4L2.85986 5.41L5.21986 7.77C4.44986 8.99 3.99986 10.44 3.99986 12C3.99986 14.21 4.90986 16.2 6.35986 17.64L3.99986 20H9.99986V14L7.75986 16.24C6.67986 15.15 5.99986 13.66 5.99986 12C5.99986 11 6.24986 10.06 6.67986 9.23L14.7599 17.31C14.5099 17.44 14.2599 17.55 13.9999 17.65V19.74C14.7999 19.53 15.5499 19.2 16.2299 18.78L18.8099 21.36L20.2199 19.95L4.26986 4Z",
    fill: "currentColor"
  })));
}, "IconSyncDisabled");
import fT from "classnames";
var CT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSyncProblem } from '@aws-amplify/ui-react'; \u2192 import { MdSyncProblem } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 12C3 14.21 3.91 16.2 5.36 17.64L3 20H9V14L6.76 16.24C5.68 15.15 5 13.66 5 12C5 9.39 6.67 7.17 9 6.35V4.26C5.55 5.15 3 8.27 3 12ZM11 17H13V15H11V17ZM21 4H15V10L17.24 7.76C18.32 8.85 19 10.34 19 12C19 14.61 17.33 16.83 15 17.65V19.74C18.45 18.85 21 15.73 21 12C21 9.79 20.09 7.8 18.64 6.36L21 4ZM11 13H13V7H11V13Z",
    fill: "currentColor"
  })));
}, "IconSyncProblem");
import gT from "classnames";
var uT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSync } from '@aws-amplify/ui-react'; \u2192 import { MdSync } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_41512)"
  }, e.createElement("path", {
    d: "M12 4V1L8 5L12 9V6C15.31 6 18 8.69 18 12C18 13.01 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 10.99 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 16.42 7.58 20 12 20V23L16 19L12 15V18Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_41512"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconSync");
import wT from "classnames";
var dT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSystemUpdateAlt } from '@aws-amplify/ui-react'; \u2192 import { MdSystemUpdateAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 16L16 12H13V3H11V12H8L12 16ZM21 3H15V4.99H21V19.02H3V4.99H9V3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM12 16L16 12H13V3H11V12H8L12 16ZM21 3H15V4.99H21V19.02H3V4.99H9V3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3Z",
    fill: "currentColor"
  })));
}, "IconSystemUpdateAlt");
import VT from "classnames";
var HT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconSystemUpdate } from '@aws-amplify/ui-react'; \u2192 import { MdSystemUpdate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 1.01L7 1C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1.01 17 1.01ZM17 19H7V5H17V19ZM16 13H13V8H11V13H8L12 17L16 13Z",
    fill: "currentColor"
  })));
}, "IconSystemUpdate");
import MT from "classnames";
var xT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTabUnselected } from '@aws-amplify/ui-react'; \u2192 import { MdTabUnselected } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: MT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1 9H3V7H1V9ZM1 13H3V11H1V13ZM1 5H3V3C1.9 3 1 3.9 1 5ZM9 21H11V19H9V21ZM1 17H3V15H1V17ZM3 21V19H1C1 20.1 1.9 21 3 21ZM21 3H13V9H23V5C23 3.9 22.1 3 21 3ZM21 17H23V15H21V17ZM9 5H11V3H9V5ZM5 21H7V19H5V21ZM5 5H7V3H5V5ZM21 21C22.1 21 23 20.1 23 19H21V21ZM21 13H23V11H21V13ZM13 21H15V19H13V21ZM17 21H19V19H17V21Z",
    fill: "currentColor"
  })));
}, "IconTabUnselected");
import IT from "classnames";
var LT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTab } from '@aws-amplify/ui-react'; \u2192 import { MdTab } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: IT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H13V9H21V19Z",
    fill: "currentColor"
  })));
}, "IconTab");
import vT from "classnames";
var NT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTableChart } from '@aws-amplify/ui-react'; \u2192 import { MdTableChart } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM20 5V8H5V5H20ZM15 19H10V10H15V19ZM5 10H8V19H5V10ZM17 19V10H20V19H17Z",
    fill: "currentColor"
  })));
}, "IconTableChart");
import yT from "classnames";
var bT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTableRows } from '@aws-amplify/ui-react'; \u2192 import { MdTableRows } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 2H2V22H22V2ZM4 8V4H20V8H4ZM4 14V10H20V14H4ZM4 20V16H20V20H4Z",
    fill: "currentColor"
  })));
}, "IconTableRows");
import ZT from "classnames";
var BT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTableView } from '@aws-amplify/ui-react'; \u2192 import { MdTableView } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 7H9C7.9 7 7 7.9 7 9V19C7 20.1 7.9 21 9 21H19C20.1 21 21 20.1 21 19V9C21 7.9 20.1 7 19 7ZM19 9V11H9V9H19ZM13 15V13H15V15H13ZM15 17V19H13V17H15ZM11 15H9V13H11V15ZM17 13H19V15H17V13ZM9 17H11V19H9V17ZM17 19V17H19V19H17ZM6 17H5C3.9 17 3 16.1 3 15V5C3 3.9 3.9 3 5 3H15C16.1 3 17 3.9 17 5V6H15V5H5V15H6V17Z",
    fill: "currentColor"
  })));
}, "IconTableView");
import WT from "classnames";
var kT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTabletAndroid } from '@aws-amplify/ui-react'; \u2192 import { MdTabletAndroid } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 0H6C4.34 0 3 1.34 3 3V21C3 22.66 4.34 24 6 24H18C19.66 24 21 22.66 21 21V3C21 1.34 19.66 0 18 0ZM14 22H10V21H14V22ZM19.25 19H4.75V3H19.25V19Z",
    fill: "currentColor"
  })));
}, "IconTabletAndroid");
import DT from "classnames";
var PT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTabletMac } from '@aws-amplify/ui-react'; \u2192 import { MdTabletMac } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.5 0H4.5C3.12 0 2 1.12 2 2.5V21.5C2 22.88 3.12 24 4.5 24H18.5C19.88 24 21 22.88 21 21.5V2.5C21 1.12 19.88 0 18.5 0ZM11.5 23C10.67 23 10 22.33 10 21.5C10 20.67 10.67 20 11.5 20C12.33 20 13 20.67 13 21.5C13 22.33 12.33 23 11.5 23ZM19 19H4V3H19V19Z",
    fill: "currentColor"
  })));
}, "IconTabletMac");
import ST from "classnames";
var jT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTablet } from '@aws-amplify/ui-react'; \u2192 import { MdTablet } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ST(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H21C22.1 20 22.99 19.1 22.99 18L23 6C23 4.9 22.1 4 21 4ZM19 18H5V6H19V18Z",
    fill: "currentColor"
  })));
}, "IconTablet");
import YT from "classnames";
var FT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTagFaces } from '@aws-amplify/ui-react'; \u2192 import { MdTagFaces } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM15.5 11C16.33 11 17 10.33 17 9.5C17 8.67 16.33 8 15.5 8C14.67 8 14 8.67 14 9.5C14 10.33 14.67 11 15.5 11ZM8.5 11C9.33 11 10 10.33 10 9.5C10 8.67 9.33 8 8.5 8C7.67 8 7 8.67 7 9.5C7 10.33 7.67 11 8.5 11ZM12 17.5C14.33 17.5 16.31 16.04 17.11 14H6.89C7.69 16.04 9.67 17.5 12 17.5Z",
    fill: "currentColor"
  })));
}, "IconTagFaces");
import TT from "classnames";
var AT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTapAndPlay } from '@aws-amplify/ui-react'; \u2192 import { MdTapAndPlay } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 16V18C4.76 18 7 20.24 7 23H9C9 19.13 5.87 16 2 16ZM2 20V23H5C5 21.34 3.66 20 2 20ZM2 12V14C6.97 14 11 18.03 11 23H13C13 16.92 8.08 12 2 12ZM17 1.01L7 1C5.9 1 5 1.9 5 3V10.37C5.69 10.53 6.36 10.74 7 11.01V5H17V18H13.97C14.49 19.25 14.81 20.59 14.92 22H17C18.1 22 19 21.1 19 20V3C19 1.9 18.1 1.01 17 1.01Z",
    fill: "currentColor"
  })));
}, "IconTapAndPlay");
import ET from "classnames";
var OT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTapas } from '@aws-amplify/ui-react'; \u2192 import { MdTapas } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ET(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 10V1H14V10C14 11.86 15.28 13.41 17 13.86V21H15V23H21V21H19V13.86C20.72 13.41 22 11.86 22 10ZM20 3V6H16V3H20ZM16 10V8H20V10C20 11.1 19.1 12 18 12C16.9 12 16 11.1 16 10ZM10 9H8V8H10C11.38 8 12.5 6.88 12.5 5.5C12.5 4.12 11.38 3 10 3H8V1H6V3H4C2.62 3 1.5 4.12 1.5 5.5C1.5 6.88 2.62 8 4 8H6V9H4C2.62 9 1.5 10.12 1.5 11.5C1.5 12.88 2.62 14 4 14H6V23H8V14H10C11.38 14 12.5 12.88 12.5 11.5C12.5 10.12 11.38 9 10 9ZM4 6C3.72 6 3.5 5.78 3.5 5.5C3.5 5.22 3.72 5 4 5H10C10.28 5 10.5 5.22 10.5 5.5C10.5 5.78 10.28 6 10 6H4ZM10 12H4C3.72 12 3.5 11.78 3.5 11.5C3.5 11.22 3.72 11 4 11H10C10.28 11 10.5 11.22 10.5 11.5C10.5 11.78 10.28 12 10 12Z",
    fill: "currentColor"
  })));
}, "IconTapas");
import _T from "classnames";
var GT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTerrain } from '@aws-amplify/ui-react'; \u2192 import { MdTerrain } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _T(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 6L9.78 11.63L11.03 13.3L14 9.33L19 16H10.54L6.53 10.63L1 18H23L14 6ZM5 16L6.52 13.97L8.04 16H5Z",
    fill: "currentColor"
  })));
}, "IconTerrain");
import UT from "classnames";
var zT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextFields } from '@aws-amplify/ui-react'; \u2192 import { MdTextFields } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2.5 4V7H7.5V19H10.5V7H15.5V4H2.5ZM21.5 9H12.5V12H15.5V19H18.5V12H21.5V9Z",
    fill: "currentColor"
  })));
}, "IconTextFields");
import XT from "classnames";
var KT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextFormat } from '@aws-amplify/ui-react'; \u2192 import { MdTextFormat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 17V19H19V17H5ZM9.5 12.8H14.5L15.4 15H17.5L12.75 4H11.25L6.5 15H8.6L9.5 12.8ZM12 5.98L13.87 11H10.13L12 5.98Z",
    fill: "currentColor"
  })));
}, "IconTextFormat");
import qT from "classnames";
var QT = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextRotateUp } from '@aws-amplify/ui-react'; \u2192 import { MdTextRotateUp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 4L15 7H17V20H19V7H21L18 4ZM11.8 15.5V10.5L14 9.6V7.5L3 12.25V13.75L14 18.5V16.4L11.8 15.5V15.5ZM4.98 13L10 11.13V14.87L4.98 13Z",
    fill: "currentColor"
  })));
}, "IconTextRotateUp");
import JT from "classnames";
var $T = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextRotateVertical } from '@aws-amplify/ui-react'; \u2192 import { MdTextRotateVertical } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.75 5H14.25L9.5 16H11.6L12.5 13.8H17.5L18.4 16H20.5L15.75 5ZM13.13 12L15 6.98L16.87 12H13.13V12ZM6 20L9 17H7V4H5V17H3L6 20Z",
    fill: "currentColor"
  })));
}, "IconTextRotateVertical");
import RT from "classnames";
var eA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextRotationAngledown } from '@aws-amplify/ui-react'; \u2192 import { MdTextRotationAngledown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RT(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 21V16.76L13.59 18.17L4.39 8.98L2.98 10.39L12.17 19.58L10.76 21H15ZM11.25 8.48L14.79 12.02L13.87 14.21L15.35 15.69L19.77 4.55L18.71 3.5L7.57 7.92L9.06 9.4L11.25 8.48ZM17.84 5.43L15.61 10.3L12.97 7.66L17.84 5.43V5.43Z",
    fill: "currentColor"
  })));
}, "IconTextRotationAngledown");
import oA from "classnames";
var tA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextRotationAngleup } from '@aws-amplify/ui-react'; \u2192 import { MdTextRotationAngleup } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.76 8.99998L18.17 10.41L8.98 19.6L10.39 21.01L19.58 11.82L21 13.24V8.99998H16.76V8.99998ZM8.48 12.75L12.02 9.20998L14.21 10.13L15.69 8.64998L4.56 4.22998L3.5 5.28998L7.92 16.43L9.4 14.95L8.48 12.75V12.75ZM7.66 11.03L5.43 6.15998L10.3 8.38998L7.66 11.03V11.03Z",
    fill: "currentColor"
  })));
}, "IconTextRotationAngleup");
import rA from "classnames";
var iA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextRotationDown } from '@aws-amplify/ui-react'; \u2192 import { MdTextRotationDown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 20L9 17H7V4H5V17H3L6 20ZM12.2 8.5V13.5L10 14.4V16.5L21 11.75V10.25L10 5.5V7.6L12.2 8.5ZM19.02 11L14 12.87V9.13L19.02 11Z",
    fill: "currentColor"
  })));
}, "IconTextRotationDown");
import sA from "classnames";
var aA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextRotationNone } from '@aws-amplify/ui-react'; \u2192 import { MdTextRotationNone } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 18L18 15V17H5V19H18V21L21 18ZM9.5 11.8H14.5L15.4 14H17.5L12.75 3H11.25L6.5 14H8.6L9.5 11.8ZM12 4.98L13.87 10H10.13L12 4.98Z",
    fill: "currentColor"
  })));
}, "IconTextRotationNone");
import nA from "classnames";
var mA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextSnippet } from '@aws-amplify/ui-react'; \u2192 import { MdTextSnippet } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.17 5L19 9.83V19H5V5H14.17ZM14.17 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V9.83C21 9.3 20.79 8.79 20.41 8.42L15.58 3.59C15.21 3.21 14.7 3 14.17 3ZM7 15H17V17H7V15ZM7 11H17V13H7V11ZM7 7H14V9H7V7Z",
    fill: "currentColor"
  })));
}, "IconTextSnippet");
import cA from "classnames";
var lA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTextsms } from '@aws-amplify/ui-react'; \u2192 import { MdTextsms } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16ZM7 9H9V11H7V9ZM11 9H13V11H11V9ZM15 9H17V11H15V9Z",
    fill: "currentColor"
  })));
}, "IconTextsms");
import pA from "classnames";
var hA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTexture } from '@aws-amplify/ui-react'; \u2192 import { MdTexture } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.51 3.08L3.08 19.51C3.17 19.85 3.35 20.16 3.59 20.41C3.84 20.65 4.15 20.83 4.49 20.92L20.93 4.49C20.74 3.8 20.2 3.26 19.51 3.08V3.08ZM11.88 3L3 11.88V14.71L14.71 3H11.88ZM5 3C3.9 3 3 3.9 3 5V7L7 3H5ZM19 21C19.55 21 20.05 20.78 20.41 20.41C20.78 20.05 21 19.55 21 19V17L17 21H19ZM9.29 21H12.12L21 12.12V9.29L9.29 21Z",
    fill: "currentColor"
  })));
}, "IconTexture");
import fA from "classnames";
var CA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTheaters } from '@aws-amplify/ui-react'; \u2192 import { MdTheaters } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 3V5H16V3H8V5H6V3H4V21H6V19H8V21H16V19H18V21H20V3H18ZM8 17H6V15H8V17ZM8 13H6V11H8V13ZM8 9H6V7H8V9ZM14 19H10V5H14V19ZM18 17H16V15H18V17ZM18 13H16V11H18V13ZM18 9H16V7H18V9Z",
    fill: "currentColor"
  })));
}, "IconTheaters");
import gA from "classnames";
var uA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconThermostat } from '@aws-amplify/ui-react'; \u2192 import { MdThermostat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 13V5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5V13C7.79 13.91 7 15.37 7 17C7 19.76 9.24 22 12 22C14.76 22 17 19.76 17 17C17 15.37 16.21 13.91 15 13ZM11 5C11 4.45 11.45 4 12 4C12.55 4 13 4.45 13 5H12V6H13V8H12V9H13V11H11V5Z",
    fill: "currentColor"
  })));
}, "IconThermostat");
import wA from "classnames";
var dA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconThumbDownAlt } from '@aws-amplify/ui-react'; \u2192 import { MdThumbDownAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 3H6C5.17 3 4.46 3.5 4.16 4.22L1.14 11.27C1.05 11.5 1 11.74 1 12V14C1 15.1 1.9 16 3 16H9.31L8.36 20.57L8.33 20.89C8.33 21.3 8.5 21.68 8.77 21.95L9.83 23L16.41 16.41C16.78 16.05 17 15.55 17 15V5C17 3.9 16.1 3 15 3ZM15 15L10.66 19.34L11.77 14H3V12L6 5H15V15ZM19 3H23V15H19V3Z",
    fill: "currentColor"
  })));
}, "IconThumbDownAlt");
import VA from "classnames";
var HA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconThumbDown } from '@aws-amplify/ui-react'; \u2192 import { MdThumbDown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 3H6C5.17 3 4.46 3.5 4.16 4.22L1.14 11.27C1.05 11.5 1 11.74 1 12V14C1 15.1 1.9 16 3 16H9.31L8.36 20.57L8.33 20.89C8.33 21.3 8.5 21.68 8.77 21.95L9.83 23L16.42 16.41C16.78 16.05 17 15.55 17 15V5C17 3.9 16.1 3 15 3ZM15 15L10.66 19.34L12 14H3V12L6 5H15V15ZM19 3H23V15H19V3Z",
    fill: "currentColor"
  })));
}, "IconThumbDown");
import MA from "classnames";
var xA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconThumbUpAlt } from '@aws-amplify/ui-react'; \u2192 import { MdThumbUpAlt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: MA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 8H14.69L15.64 3.43L15.67 3.11C15.67 2.7 15.5 2.32 15.23 2.05L14.17 1L7.59 7.59C7.22 7.95 7 8.45 7 9V19C7 20.1 7.9 21 9 21H18C18.83 21 19.54 20.5 19.84 19.78L22.86 12.73C22.95 12.5 23 12.26 23 12V10C23 8.9 22.1 8 21 8ZM21 12L18 19H9V9L13.34 4.66L12.23 10H21V12ZM1 9H5V21H1V9Z",
    fill: "currentColor"
  })));
}, "IconThumbUpAlt");
import IA from "classnames";
var LA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconThumbUp } from '@aws-amplify/ui-react'; \u2192 import { MdThumbUp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: IA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 21H18C18.83 21 19.54 20.5 19.84 19.78L22.86 12.73C22.95 12.5 23 12.26 23 12V10C23 8.9 22.1 8 21 8H14.69L15.64 3.43L15.67 3.11C15.67 2.7 15.5 2.32 15.23 2.05L14.17 1L7.58 7.59C7.22 7.95 7 8.45 7 9V19C7 20.1 7.9 21 9 21ZM9 9L13.34 4.66L12 10H21V12L18 19H9V9ZM1 9H5V21H1V9Z",
    fill: "currentColor"
  })));
}, "IconThumbUp");
import vA from "classnames";
var NA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconThumbsUpDown } from '@aws-amplify/ui-react'; \u2192 import { MdThumbsUpDown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C12 5.45 11.55 5 11 5H5.82L6.48 1.82L6.5 1.59C6.5 1.28 6.37 1 6.17 0.79L5.38 0L0.44 4.94C0.17 5.21 0 5.59 0 6V12.5C0 13.33 0.67 14 1.5 14H8.25C8.87 14 9.4 13.62 9.63 13.09L11.89 7.8C11.96 7.63 12 7.44 12 7.25V6V6ZM10 7.13L7.92 12H2V6.21L3.93 4.28L3.36 7H10V7.13ZM22.5 10H15.75C15.13 10 14.6 10.38 14.37 10.91L12.11 16.2C12.04 16.37 12 16.56 12 16.75V18C12 18.55 12.45 19 13 19H18.18L17.52 22.18L17.5 22.42C17.5 22.73 17.63 23.01 17.83 23.22L18.62 24L23.56 19.06C23.83 18.79 24 18.41 24 18V11.5C24 10.67 23.33 10 22.5 10ZM22 17.79L20.07 19.72L20.64 17H14V16.87L16.08 12H22V17.79Z",
    fill: "currentColor"
  })));
}, "IconThumbsUpDown");
import yA from "classnames";
var bA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTimeToLeave } from '@aws-amplify/ui-react'; \u2192 import { MdTimeToLeave } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3 11V19C3 19.55 3.45 20 4 20H5C5.55 20 6 19.55 6 19V18H18V19C18 19.55 18.45 20 19 20H20C20.55 20 21 19.55 21 19V11L18.92 5.01ZM6.85 6H17.14L18.18 9H5.81L6.85 6ZM19 16H5V11.34L5.12 11H18.89L19 11.34V16Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.5 15C8.32843 15 9 14.3284 9 13.5C9 12.6716 8.32843 12 7.5 12C6.67157 12 6 12.6716 6 13.5C6 14.3284 6.67157 15 7.5 15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M16.5 15C17.3284 15 18 14.3284 18 13.5C18 12.6716 17.3284 12 16.5 12C15.6716 12 15 12.6716 15 13.5C15 14.3284 15.6716 15 16.5 15Z",
    fill: "black"
  })));
}, "IconTimeToLeave");
import ZA from "classnames";
var BA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTimelapse } from '@aws-amplify/ui-react'; \u2192 import { MdTimelapse } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.24 7.75023C15.07 6.58023 13.54 5.99023 12 5.99023V11.9902L7.76 16.2302C10.1 18.5702 13.9 18.5702 16.25 16.2302C18.59 13.8902 18.59 10.0902 16.24 7.75023ZM12 1.99023C6.48 1.99023 2 6.47023 2 11.9902C2 17.5102 6.48 21.9902 12 21.9902C17.52 21.9902 22 17.5102 22 11.9902C22 6.47023 17.52 1.99023 12 1.99023V1.99023ZM12 19.9902C7.58 19.9902 4 16.4102 4 11.9902C4 7.57023 7.58 3.99023 12 3.99023C16.42 3.99023 20 7.57023 20 11.9902C20 16.4102 16.42 19.9902 12 19.9902Z",
    fill: "currentColor"
  })));
}, "IconTimelapse");
import WA from "classnames";
var kA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTimeline } from '@aws-amplify/ui-react'; \u2192 import { MdTimeline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23 8C23 9.1 22.1 10 21 10C20.82 10 20.65 9.98 20.49 9.93L16.93 13.48C16.98 13.64 17 13.82 17 14C17 15.1 16.1 16 15 16C13.9 16 13 15.1 13 14C13 13.82 13.02 13.64 13.07 13.48L10.52 10.93C10.36 10.98 10.18 11 10 11C9.82 11 9.64 10.98 9.48 10.93L4.93 15.49C4.98 15.65 5 15.82 5 16C5 17.1 4.1 18 3 18C1.9 18 1 17.1 1 16C1 14.9 1.9 14 3 14C3.18 14 3.35 14.02 3.51 14.07L8.07 9.52C8.02 9.36 8 9.18 8 9C8 7.9 8.9 7 10 7C11.1 7 12 7.9 12 9C12 9.18 11.98 9.36 11.93 9.52L14.48 12.07C14.64 12.02 14.82 12 15 12C15.18 12 15.36 12.02 15.52 12.07L19.07 8.51C19.02 8.35 19 8.18 19 8C19 6.9 19.9 6 21 6C22.1 6 23 6.9 23 8Z",
    fill: "currentColor"
  })));
}, "IconTimeline");
import DA from "classnames";
var PA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTimer_10 } from '@aws-amplify/ui-react'; \u2192 import { MdTimer_10 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_40636)"
  }, e.createElement("path", {
    d: "M-0.0100098 7.7199V9.3999L2.98999 8.3999V17.9999H4.98999V5.9999H4.73999L-0.0100098 7.7199ZM23.77 14.3699C23.63 14.0899 23.42 13.8399 23.14 13.6299C22.86 13.4199 22.53 13.2399 22.13 13.0999C21.73 12.9599 21.28 12.8299 20.78 12.7199C20.43 12.6499 20.14 12.5699 19.91 12.4899C19.68 12.4099 19.5 12.3299 19.36 12.2399C19.22 12.1499 19.13 12.0499 19.08 11.9399C19.03 11.8299 19 11.6999 19 11.5499C19 11.4099 19.03 11.2699 19.09 11.1399C19.15 11.0099 19.24 10.8899 19.36 10.7999C19.48 10.6999 19.63 10.6199 19.81 10.5599C19.99 10.4999 20.21 10.4699 20.45 10.4699C20.7 10.4699 20.92 10.5099 21.11 10.5799C21.3 10.6499 21.46 10.7499 21.59 10.8699C21.72 10.9899 21.81 11.1299 21.88 11.2899C21.94 11.4499 21.98 11.6099 21.98 11.7799H23.93C23.93 11.3899 23.85 11.0299 23.69 10.6899C23.53 10.3499 23.3 10.0599 23 9.8099C22.7 9.5599 22.34 9.3699 21.91 9.2199C21.48 9.0699 20.99 8.9999 20.45 8.9999C19.94 8.9999 19.47 9.0699 19.06 9.2099C18.65 9.3499 18.29 9.5399 18 9.7799C17.71 10.0199 17.49 10.2999 17.33 10.6199C17.17 10.9399 17.1 11.2699 17.1 11.6299C17.1 11.9899 17.18 12.3199 17.33 12.5899C17.48 12.8699 17.69 13.1099 17.97 13.3199C18.24 13.5299 18.57 13.6999 18.95 13.8499C19.33 13.9899 19.76 14.1099 20.22 14.2099C20.61 14.2899 20.93 14.3799 21.17 14.4699C21.41 14.5599 21.6 14.6599 21.74 14.7599C21.87 14.8599 21.96 14.9799 22.01 15.0999C22.06 15.2199 22.08 15.3499 22.08 15.4899C22.08 15.8099 21.95 16.0599 21.68 16.2599C21.41 16.4599 21.02 16.5499 20.51 16.5499C20.29 16.5499 20.08 16.5299 19.87 16.4699C19.66 16.4199 19.47 16.3399 19.31 16.2299C19.14 16.1199 19.01 15.9699 18.9 15.7899C18.79 15.6099 18.73 15.3799 18.72 15.1199H16.83C16.83 15.4799 16.91 15.8299 17.07 16.1699C17.23 16.5099 17.46 16.8199 17.77 17.0999C18.08 17.3699 18.46 17.5899 18.92 17.7599C19.38 17.9299 19.9 18.0099 20.5 18.0099C21.03 18.0099 21.51 17.9499 21.94 17.8199C22.37 17.6899 22.74 17.5099 23.05 17.2799C23.36 17.0499 23.59 16.7699 23.76 16.4499C23.93 16.1299 24.01 15.7799 24.01 15.3899C23.99 14.9899 23.92 14.6499 23.77 14.3699V14.3699ZM13.81 7.0499C13.47 6.6499 13.06 6.3499 12.58 6.1699C12.11 5.9899 11.57 5.8999 10.99 5.8999C10.41 5.8999 9.87999 5.9899 9.39999 6.1699C8.91999 6.3499 8.50999 6.6399 8.16999 7.0499C7.82999 7.4599 7.56999 7.9799 7.37999 8.6399C7.19999 9.2899 7.09999 10.0899 7.09999 11.0299V12.9499C7.09999 13.8899 7.18999 14.6899 7.37999 15.3399C7.56999 15.9999 7.82999 16.5299 8.17999 16.9399C8.51999 17.3499 8.92999 17.6499 9.40999 17.8299C9.88999 18.0099 10.42 18.1099 11 18.1099C11.59 18.1099 12.12 18.0199 12.59 17.8299C13.07 17.6499 13.47 17.3499 13.81 16.9399C14.15 16.5299 14.41 15.9999 14.59 15.3399C14.77 14.6899 14.87 13.8899 14.87 12.9499V11.0299C14.87 10.0899 14.78 9.2899 14.59 8.6399C14.41 7.9799 14.15 7.4499 13.81 7.0499ZM12.89 13.2199C12.89 13.8199 12.85 14.3299 12.77 14.7499C12.69 15.1699 12.57 15.5099 12.41 15.7699C12.25 16.0299 12.05 16.2199 11.82 16.3399C11.59 16.4599 11.31 16.5199 11 16.5199C10.7 16.5199 10.42 16.4599 10.18 16.3399C9.93999 16.2199 9.73999 16.0299 9.57999 15.7699C9.41999 15.5099 9.28999 15.1699 9.19999 14.7499C9.10999 14.3299 9.06999 13.8199 9.06999 13.2199V10.7199C9.06999 10.1199 9.10999 9.6099 9.19999 9.1999C9.28999 8.7899 9.40999 8.4599 9.57999 8.1999C9.73999 7.9499 9.93999 7.7699 10.18 7.6499C10.42 7.5399 10.69 7.4799 10.99 7.4799C11.3 7.4799 11.57 7.5399 11.8 7.6499C12.04 7.7599 12.24 7.9399 12.4 8.1999C12.56 8.4499 12.69 8.7799 12.77 9.1899C12.85 9.5999 12.9 10.1099 12.9 10.7099V13.2199H12.89V13.2199Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_40636"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconTimer_10");
import SA from "classnames";
var jA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTimer_3 } from '@aws-amplify/ui-react'; \u2192 import { MdTimer_3 } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.6099 12.9699C11.4499 12.7299 11.2499 12.5099 10.9899 12.3199C10.7399 12.1299 10.4299 11.9699 10.0599 11.8399C10.3599 11.6999 10.6299 11.5399 10.8599 11.3399C11.0899 11.1399 11.2799 10.9299 11.4299 10.6999C11.5799 10.4699 11.6999 10.2399 11.7699 9.9899C11.8499 9.7499 11.8799 9.4999 11.8799 9.2599C11.8799 8.7099 11.7899 8.2199 11.5999 7.7999C11.4199 7.3799 11.1599 7.0299 10.8199 6.7399C10.4899 6.4599 10.0899 6.2399 9.61994 6.0999C9.16994 5.9699 8.64994 5.8999 8.08994 5.8999C7.53994 5.8999 7.02994 5.9799 6.56994 6.1399C6.09994 6.3099 5.69994 6.5399 5.36994 6.8299C5.03994 7.1199 4.76994 7.4599 4.58994 7.8599C4.38994 8.2499 4.29994 8.6899 4.29994 9.1499H6.27994C6.27994 8.8899 6.32994 8.6599 6.41994 8.4599C6.50994 8.2599 6.63994 8.0799 6.79994 7.9399C6.96994 7.7999 7.15994 7.6899 7.37994 7.6099C7.59994 7.5299 7.83994 7.4899 8.10994 7.4899C8.71994 7.4899 9.16994 7.6499 9.46994 7.9599C9.76994 8.2699 9.90994 8.7099 9.90994 9.2799C9.90994 9.5499 9.86994 9.7999 9.78994 10.0199C9.70994 10.2399 9.57994 10.4299 9.40994 10.5899C9.23994 10.7499 9.02994 10.8699 8.77994 10.9599C8.52994 11.0499 8.22994 11.0899 7.88994 11.0899H6.71994V12.6599H7.89994C8.23994 12.6599 8.53994 12.6999 8.80994 12.7699C9.07994 12.8499 9.30994 12.9599 9.49994 13.1199C9.68994 13.2799 9.83994 13.4799 9.93994 13.7299C10.0399 13.9699 10.0999 14.2699 10.0999 14.5999C10.0999 15.2199 9.91994 15.6899 9.56994 16.0199C9.21994 16.3499 8.72994 16.5099 8.11994 16.5099C7.82994 16.5099 7.55994 16.4699 7.31994 16.3799C7.07994 16.2999 6.87994 16.1799 6.70994 16.0199C6.53994 15.8599 6.40994 15.6799 6.31994 15.4599C6.22994 15.2399 6.17994 14.9999 6.17994 14.7399H4.18994C4.18994 15.2899 4.29994 15.7699 4.50994 16.1899C4.71994 16.6099 5.00994 16.9599 5.36994 17.2399C5.72994 17.5199 6.13994 17.7299 6.60994 17.8699C7.07994 18.0099 7.56994 18.0799 8.08994 18.0799C8.65994 18.0799 9.17994 17.9999 9.66994 17.8499C10.1599 17.6999 10.5799 17.4699 10.9299 17.1699C11.2899 16.8699 11.5699 16.5099 11.7699 16.0699C11.9699 15.6399 12.0699 15.1399 12.0699 14.5899C12.0699 14.2999 12.0299 14.0099 11.9599 13.7299C11.8799 13.4799 11.7699 13.2199 11.6099 12.9699V12.9699ZM20.8699 14.3699C20.7299 14.0899 20.5199 13.8399 20.2399 13.6299C19.9599 13.4199 19.6299 13.2399 19.2299 13.0999C18.8299 12.9599 18.3799 12.8299 17.8799 12.7199C17.5299 12.6499 17.2399 12.5699 17.0099 12.4899C16.7799 12.4099 16.5999 12.3299 16.4599 12.2399C16.3199 12.1499 16.2299 12.0499 16.1799 11.9399C16.1299 11.8299 16.0999 11.6999 16.0999 11.5499C16.0999 11.3999 16.1299 11.2699 16.1899 11.1399C16.2499 11.0099 16.3399 10.8899 16.4599 10.7999C16.5799 10.6999 16.7299 10.6199 16.9099 10.5599C17.0899 10.4999 17.3099 10.4699 17.5499 10.4699C17.7999 10.4699 18.0199 10.5099 18.2099 10.5799C18.3999 10.6499 18.5599 10.7499 18.6899 10.8699C18.8199 10.9899 18.9099 11.1299 18.9799 11.2899C19.0399 11.4499 19.0799 11.6099 19.0799 11.7799H21.0299C21.0299 11.3899 20.9499 11.0299 20.7899 10.6899C20.6299 10.3499 20.3999 10.0599 20.0999 9.8099C19.7999 9.5599 19.4399 9.3699 19.0099 9.2199C18.5799 9.0699 18.0899 8.9999 17.5499 8.9999C17.0399 8.9999 16.5699 9.0699 16.1599 9.2099C15.7499 9.3499 15.3899 9.5399 15.0999 9.7799C14.8099 10.0199 14.5899 10.2999 14.4299 10.6199C14.2699 10.9399 14.1999 11.2699 14.1999 11.6299C14.1999 11.9899 14.2799 12.3099 14.4299 12.5899C14.5799 12.8699 14.7999 13.1099 15.0699 13.3199C15.3399 13.5299 15.6699 13.6999 16.0499 13.8499C16.4299 13.9899 16.8599 14.1099 17.3199 14.2099C17.7099 14.2899 18.0299 14.3799 18.2699 14.4699C18.5099 14.5599 18.6999 14.6599 18.8399 14.7599C18.9699 14.8599 19.0599 14.9799 19.1099 15.0999C19.1599 15.2199 19.1799 15.3499 19.1799 15.4899C19.1799 15.8099 19.0499 16.0599 18.7799 16.2599C18.5099 16.4599 18.1199 16.5499 17.6099 16.5499C17.3899 16.5499 17.1799 16.5299 16.9699 16.4699C16.7599 16.4199 16.5699 16.3399 16.4099 16.2299C16.2399 16.1199 16.1099 15.9699 15.9999 15.7899C15.8899 15.6099 15.8299 15.3799 15.8199 15.1199H13.9299C13.9299 15.4799 14.0099 15.8299 14.1699 16.1699C14.3299 16.5099 14.5599 16.8199 14.8699 17.0999C15.1799 17.3699 15.5599 17.5899 16.0199 17.7599C16.4799 17.9299 16.9999 18.0099 17.5999 18.0099C18.1299 18.0099 18.6099 17.9499 19.0399 17.8199C19.4699 17.6899 19.8399 17.5099 20.1499 17.2799C20.4599 17.0499 20.6899 16.7699 20.8599 16.4499C21.0299 16.1299 21.1099 15.7799 21.1099 15.3899C21.0899 14.9899 21.0199 14.6499 20.8699 14.3699V14.3699Z",
    fill: "currentColor"
  })));
}, "IconTimer_3");
import YA from "classnames";
var FA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTimerOff } from '@aws-amplify/ui-react'; \u2192 import { MdTimerOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 8V8.86L13 10.86V8H11ZM9 1H15V3H9V1ZM12 6C15.87 6 19 9.13 19 13C19 14.12 18.73 15.18 18.26 16.12L19.73 17.59C20.53 16.25 21 14.68 21 13C21 10.88 20.26 8.93 19.03 7.39L20.45 5.97C20.02 5.46 19.55 4.98 19.04 4.56L17.62 5.98C16.07 4.74 14.12 4 12 4C10.32 4 8.75 4.47 7.41 5.27L8.88 6.74C9.82 6.27 10.88 6 12 6V6ZM3.16 3.86L1.75 5.27L4.5 8.02C3.56 9.45 3 11.16 3 13C3 17.97 7.02 22 12 22C13.84 22 15.55 21.45 16.98 20.5L19.48 23L20.89 21.59L3.16 3.86ZM12 20C8.13 20 5 16.87 5 13C5 11.71 5.35 10.51 5.96 9.48L15.53 19.05C14.49 19.65 13.29 20 12 20V20Z",
    fill: "currentColor"
  })));
}, "IconTimerOff");
import TA from "classnames";
var AA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTimer } from '@aws-amplify/ui-react'; \u2192 import { MdTimer } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.0701 1.00977H9.07007V3.00977H15.0701V1.00977V1.00977ZM11.0701 14.0098H13.0701V8.00977H11.0701V14.0098ZM19.1001 7.38977L20.5201 5.96977C20.0901 5.45977 19.6201 4.97977 19.1101 4.55977L17.6901 5.97977C16.1401 4.73977 14.1901 3.99977 12.0701 3.99977C7.10007 3.99977 3.07007 8.02977 3.07007 12.9998C3.07007 17.9698 7.09007 21.9998 12.0701 21.9998C17.0501 21.9998 21.0701 17.9698 21.0701 12.9998C21.0701 10.8898 20.3301 8.93977 19.1001 7.38977ZM12.0701 20.0098C8.20007 20.0098 5.07007 16.8798 5.07007 13.0098C5.07007 9.13977 8.20007 6.00977 12.0701 6.00977C15.9401 6.00977 19.0701 9.13977 19.0701 13.0098C19.0701 16.8798 15.9401 20.0098 12.0701 20.0098Z",
    fill: "currentColor"
  })));
}, "IconTimer");
import EA from "classnames";
var OA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTitle } from '@aws-amplify/ui-react'; \u2192 import { MdTitle } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5 4V7H10.5V19H13.5V7H19V4H5Z",
    fill: "currentColor"
  })));
}, "IconTitle");
import _A from "classnames";
var GA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconToc } from '@aws-amplify/ui-react'; \u2192 import { MdToc } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _A(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 9H17V7H3V9ZM3 13H17V11H3V13ZM3 17H17V15H3V17ZM19 17H21V15H19V17ZM19 7V9H21V7H19ZM19 13H21V11H19V13Z",
    fill: "currentColor"
  })));
}, "IconToc");
import UA from "classnames";
var zA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconToday } from '@aws-amplify/ui-react'; \u2192 import { MdToday } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H18V1H16V3H8V1H6V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V9H19V19ZM19 7H5V5H19V7ZM7 11H12V16H7V11Z",
    fill: "currentColor"
  })));
}, "IconToday");
import XA from "classnames";
var KA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconToggleOff } from '@aws-amplify/ui-react'; \u2192 import { MdToggleOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 6H7C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18H17C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM17 16H7C4.79 16 3 14.21 3 12C3 9.79 4.79 8 7 8H17C19.21 8 21 9.79 21 12C21 14.21 19.21 16 17 16ZM7 9C5.34 9 4 10.34 4 12C4 13.66 5.34 15 7 15C8.66 15 10 13.66 10 12C10 10.34 8.66 9 7 9Z",
    fill: "currentColor"
  })));
}, "IconToggleOff");
import qA from "classnames";
var QA = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconToggleOn } from '@aws-amplify/ui-react'; \u2192 import { MdToggleOn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 6H7C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18H17C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM17 16H7C4.79 16 3 14.21 3 12C3 9.79 4.79 8 7 8H17C19.21 8 21 9.79 21 12C21 14.21 19.21 16 17 16ZM17 9C15.34 9 14 10.34 14 12C14 13.66 15.34 15 17 15C18.66 15 20 13.66 20 12C20 10.34 18.66 9 17 9Z",
    fill: "currentColor"
  })));
}, "IconToggleOn");
import JA from "classnames";
var $A = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconToll } from '@aws-amplify/ui-react'; \u2192 import { MdToll } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 4C10.58 4 7 7.58 7 12C7 16.42 10.58 20 15 20C19.42 20 23 16.42 23 12C23 7.58 19.42 4 15 4ZM15 18C11.69 18 9 15.31 9 12C9 8.69 11.69 6 15 6C18.31 6 21 8.69 21 12C21 15.31 18.31 18 15 18ZM3 12C3 9.39 4.67 7.17 7 6.35V4.26C3.55 5.15 1 8.27 1 12C1 15.73 3.55 18.85 7 19.74V17.65C4.67 16.83 3 14.61 3 12V12Z",
    fill: "currentColor"
  })));
}, "IconToll");
import RA from "classnames";
var eE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTonality } from '@aws-amplify/ui-react'; \u2192 import { MdTonality } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RA(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.06 19.44 4 16.08 4 12C4 7.92 7.05 4.56 11 4.07V19.93ZM13 4.07C14.03 4.2 15 4.52 15.87 5H13V4.07ZM13 7H18.24C18.49 7.31 18.72 7.65 18.92 8H13V7ZM13 10H19.74C19.82 10.33 19.89 10.66 19.93 11H13V10ZM13 19.93V19H15.87C15 19.48 14.03 19.8 13 19.93ZM18.24 17H13V16H18.92C18.72 16.35 18.49 16.69 18.24 17V17ZM19.74 14H13V13H19.93C19.89 13.34 19.82 13.67 19.74 14Z",
    fill: "currentColor"
  })));
}, "IconTonality");
import oE from "classnames";
var tE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTopic } from '@aws-amplify/ui-react'; \u2192 import { MdTopic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H12L10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20.77C21.45 20 22 19.44 22 18.77V8C22 6.9 21.1 6 20 6ZM20 18H4V6H9.17L11.17 8H20V18ZM18 12H6V10H18V12ZM14 16H6V14H14V16Z",
    fill: "currentColor"
  })));
}, "IconTopic");
import rE from "classnames";
var iE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTouchApp } from '@aws-amplify/ui-react'; \u2192 import { MdTouchApp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.19 12.44L14.95 10.82C16.24 9.82 17.07 8.26 17.07 6.5C17.07 3.47 14.6 1 11.57 1C8.54 1 6.07 3.47 6.07 6.5C6.07 8.63 7.29 10.48 9.07 11.39V14.65C6.92 14.19 7.05 14.21 6.81 14.21C6.28 14.21 5.78 14.42 5.4 14.8L4 16.22L9.09 21.31C9.52 21.75 10.12 22 10.74 22H17.04C18.02 22 18.85 21.3 19.01 20.33L19.81 15.62C20.03 14.32 19.38 13.04 18.19 12.44ZM17.84 15.29L17.04 20H10.74C10.65 20 10.57 19.96 10.5 19.9L6.82 16.22L11.07 17.11V6.5C11.07 6.22 11.29 6 11.57 6C11.85 6 12.07 6.22 12.07 6.5V12.5H13.83L17.29 14.23C17.69 14.43 17.91 14.86 17.84 15.29ZM8.07 6.5C8.07 4.57 9.64 3 11.57 3C13.5 3 15.07 4.57 15.07 6.5C15.07 7.45 14.69 8.31 14.07 8.94V6.5C14.07 5.12 12.95 4 11.57 4C10.19 4 9.07 5.12 9.07 6.5V8.94C8.45 8.31 8.07 7.45 8.07 6.5Z",
    fill: "currentColor"
  })));
}, "IconTouchApp");
import sE from "classnames";
var aE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTour } from '@aws-amplify/ui-react'; \u2192 import { MdTour } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 4H13H12H7V2H5V4V14V22H7V14H11H12H21L19 9L21 4ZM17.14 9.74L18.04 12H12H11H7V6H12H13H18.05L17.15 8.26L16.85 9L17.14 9.74ZM14 9C14 10.1 13.1 11 12 11C10.9 11 10 10.1 10 9C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9Z",
    fill: "currentColor"
  })));
}, "IconTour");
import nE from "classnames";
var mE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconToys } from '@aws-amplify/ui-react'; \u2192 import { MdToys } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 23H11V16.43C9.93 17.4 8.52 18 7 18C3.75 18 1 15.25 1 12V11H7.57C6.6 9.93 6 8.52 6 7C6 3.75 8.75 1 12 1H13V7.57C14.07 6.6 15.48 6 17 6C20.25 6 23 8.75 23 12V13H16.43C17.4 14.07 18 15.48 18 17C18 20.25 15.25 23 12 23ZM13 13.13V20.87C14.7 20.41 16 18.83 16 17C16 15.17 14.7 13.59 13 13.13V13.13ZM3.13 13C3.59 14.7 5.17 16 7 16C8.83 16 10.41 14.7 10.87 13H3.13ZM13.13 11H20.87C20.41 9.3 18.82 8 17 8C15.18 8 13.59 9.3 13.13 11V11ZM11 3.13C9.3 3.59 8 5.18 8 7C8 8.82 9.3 10.41 11 10.87V3.13Z",
    fill: "currentColor"
  })));
}, "IconToys");
import cE from "classnames";
var lE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTrackChanges } from '@aws-amplify/ui-react'; \u2192 import { MdTrackChanges } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19.07 4.93L17.66 6.34C19.1 7.79 20 9.79 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.92 7.05 4.56 11 4.07V6.09C8.16 6.57 6 9.03 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 10.34 17.33 8.84 16.24 7.76L14.83 9.17C15.55 9.9 16 10.9 16 12C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12C8 10.14 9.28 8.59 11 8.14V10.28C10.4 10.63 10 11.26 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 11.26 13.6 10.62 13 10.28V2H12C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 9.24 20.88 6.74 19.07 4.93Z",
    fill: "currentColor"
  })));
}, "IconTrackChanges");
import pE from "classnames";
var hE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTraffic } from '@aws-amplify/ui-react'; \u2192 import { MdTraffic } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 10H17V8.86C18.72 8.41 20 6.86 20 5H17V4C17 3.45 16.55 3 16 3H8C7.45 3 7 3.45 7 4V5H4C4 6.86 5.28 8.41 7 8.86V10H4C4 11.86 5.28 13.41 7 13.86V15H4C4 16.86 5.28 18.41 7 18.86V20C7 20.55 7.45 21 8 21H16C16.55 21 17 20.55 17 20V18.86C18.72 18.41 20 16.86 20 15H17V13.86C18.72 13.41 20 11.86 20 10ZM15 19H9V5H15V19ZM12 18C12.83 18 13.5 17.33 13.5 16.5C13.5 15.67 12.83 15 12 15C11.17 15 10.5 15.67 10.5 16.5C10.5 17.33 11.17 18 12 18ZM12 13.5C12.83 13.5 13.5 12.83 13.5 12C13.5 11.17 12.83 10.5 12 10.5C11.17 10.5 10.5 11.17 10.5 12C10.5 12.83 11.17 13.5 12 13.5ZM12 9C12.83 9 13.5 8.33 13.5 7.5C13.5 6.67 12.83 6 12 6C11.17 6 10.5 6.67 10.5 7.5C10.5 8.33 11.17 9 12 9Z",
    fill: "currentColor"
  })));
}, "IconTraffic");
import fE from "classnames";
var CE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTrain } from '@aws-amplify/ui-react'; \u2192 import { MdTrain } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8.5 16C9.32843 16 10 15.3284 10 14.5C10 13.6716 9.32843 13 8.5 13C7.67157 13 7 13.6716 7 14.5C7 15.3284 7.67157 16 8.5 16Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15.5 16C16.3284 16 17 15.3284 17 14.5C17 13.6716 16.3284 13 15.5 13C14.6716 13 14 13.6716 14 14.5C14 15.3284 14.6716 16 15.5 16Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M12 2C8 2 4 2.5 4 6V15.5C4 17.43 5.57 19 7.5 19L6 20.5V21H8L10 19H14L16 21H18V20.5L16.5 19C18.43 19 20 17.43 20 15.5V6C20 2.5 16 2 12 2ZM12 4C15.51 4 16.96 4.48 17.57 5H6.43C7.04 4.48 8.49 4 12 4ZM6 7H11V10H6V7ZM18 15.5C18 16.33 17.33 17 16.5 17H7.5C6.67 17 6 16.33 6 15.5V12H18V15.5ZM18 10H13V7H18V10Z",
    fill: "black"
  })));
}, "IconTrain");
import gE from "classnames";
var uE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTram } from '@aws-amplify/ui-react'; \u2192 import { MdTram } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M13 5L13.75 3.5H17V2H7V3.5H11.75L11 5C7.87 5.09 5 5.73 5 8.5V17C5 18.5 6.11 19.73 7.55 19.95L6 21.5V22H8L10 20H14L16 22H18V21.5L16.45 19.95H16.44H16.45C17.89 19.73 19 18.5 19 17V8.5C19 5.73 16.13 5.09 13 5ZM11.03 7H12.97C15.72 7.08 16.59 7.58 16.87 8H7.13C7.41 7.58 8.28 7.08 11.03 7ZM10.85 17.95H7.74C7.3 17.84 7 17.45 7 17V16H10.89C10.65 16.27 10.5 16.61 10.5 17C10.5 17.36 10.63 17.69 10.85 17.95ZM17 17C17 17.45 16.7 17.84 16.26 17.95H13.15C13.37 17.69 13.5 17.36 13.5 17C13.5 16.61 13.35 16.27 13.11 16H17V17ZM17 14H7V10H17V14Z",
    fill: "currentColor"
  })));
}, "IconTram");
import wE from "classnames";
var dE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTransferWithinAStation } from '@aws-amplify/ui-react'; \u2192 import { MdTransferWithinAStation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.49 15.5V13.75L14 16.25L16.49 18.75V17H22V15.5H16.49V15.5ZM19.51 19.75H14V21.25H19.51V23L22 20.5L19.51 18V19.75V19.75ZM9.5 5.5C10.6 5.5 11.5 4.6 11.5 3.5C11.5 2.4 10.6 1.5 9.5 1.5C8.4 1.5 7.5 2.4 7.5 3.5C7.5 4.6 8.4 5.5 9.5 5.5ZM5.75 8.9L3 23H5.1L6.85 15L9 17V23H11V15.45L8.95 13.4L9.55 10.4C10.85 12 12.8 13 15 13V11C13.15 11 11.55 10 10.65 8.55L9.7 6.95C9.35 6.35 8.7 6 8 6C7.75 6 7.5 6.05 7.25 6.15L2 8.3V13H4V9.65L5.75 8.9Z",
    fill: "currentColor"
  })));
}, "IconTransferWithinAStation");
import VE from "classnames";
var HE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTransform } from '@aws-amplify/ui-react'; \u2192 import { MdTransform } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 18V16H8V4H10L7 1L4 4H6V6H2V8H6V16C6 17.1 6.9 18 8 18H16V20H14L17 23L20 20H18V18H22ZM10 8H16V14H18V8C18 6.9 17.1 6 16 6H10V8Z",
    fill: "currentColor"
  })));
}, "IconTransform");
import ME from "classnames";
var xE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTransitEnterexit } from '@aws-amplify/ui-react'; \u2192 import { MdTransitEnterexit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ME(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 18H6V8H9V12.77L15.98 6L18 8.03L11.15 15H16V18Z",
    fill: "currentColor"
  })));
}, "IconTransitEnterexit");
import IE from "classnames";
var LE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTranslate } from '@aws-amplify/ui-react'; \u2192 import { MdTranslate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: IE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.87 15.07L10.33 12.56L10.36 12.53C12.1 10.59 13.34 8.36 14.07 6H17V4H10V2H8V4H1V5.99H12.17C11.5 7.92 10.44 9.75 9 11.35C8.07 10.32 7.3 9.19 6.69 8H4.69C5.42 9.63 6.42 11.17 7.67 12.56L2.58 17.58L4 19L9 14L12.11 17.11L12.87 15.07ZM18.5 10H16.5L12 22H14L15.12 19H19.87L21 22H23L18.5 10ZM15.88 17L17.5 12.67L19.12 17H15.88V17Z",
    fill: "currentColor"
  })));
}, "IconTranslate");
import vE from "classnames";
var NE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTrendingDown } from '@aws-amplify/ui-react'; \u2192 import { MdTrendingDown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 18L18.29 15.71L13.41 10.83L9.41 14.83L2 7.41L3.41 6L9.41 12L13.41 8L19.71 14.29L22 12V18H16Z",
    fill: "currentColor"
  })));
}, "IconTrendingDown");
import yE from "classnames";
var bE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTrendingFlat } from '@aws-amplify/ui-react'; \u2192 import { MdTrendingFlat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 12L18 8V11H3V13H18V16L22 12Z",
    fill: "currentColor"
  })));
}, "IconTrendingFlat");
import ZE from "classnames";
var BE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTrendingUp } from '@aws-amplify/ui-react'; \u2192 import { MdTrendingUp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z",
    fill: "currentColor"
  })));
}, "IconTrendingUp");
import WE from "classnames";
var kE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTripOrigin } from '@aws-amplify/ui-react'; \u2192 import { MdTripOrigin } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM12 18C15.31 18 18 15.31 18 12C18 8.69 15.31 6 12 6C8.69 6 6 8.69 6 12C6 15.31 8.69 18 12 18Z",
    fill: "currentColor"
  })));
}, "IconTripOrigin");
import DE from "classnames";
var PE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTty } from '@aws-amplify/ui-react'; \u2192 import { MdTty } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.0002 6H14.0002V4H16.0002V6ZM18.0002 7H16.0002V9H18.0002V7ZM19.0002 9H21.0002V7H19.0002V9ZM19.0002 4H17.0002V6H19.0002V4ZM15.0002 7H13.0002V9H15.0002V7ZM19.0002 10H17.0002V12H19.0002V10ZM16.0002 10H14.0002V12H16.0002V10ZM13.0002 4H11.0002V6H13.0002V4ZM20.0002 15.82V19.97C20.0002 20.53 19.5302 21 18.9702 20.97C16.0802 20.8 13.3702 19.94 11.0002 18.57C8.27017 16.99 6.01017 14.73 4.43017 12C3.05017 9.63 2.20017 6.92 2.03017 4.03C2.00017 3.47 2.47017 3 3.03017 3H7.18017C7.66017 3 8.07017 3.34 8.16017 3.8L8.90017 7.48C8.97017 7.81 8.86017 8.15 8.63017 8.38L6.10017 10.9C7.53017 13.4 9.60017 15.47 12.1002 16.9L14.6202 14.38C14.8602 14.14 15.2002 14.04 15.5202 14.11L19.1902 14.84C19.6602 14.93 20.0002 15.34 20.0002 15.82ZM5.18017 8.99L6.83017 7.34L6.36017 5H4.13017C4.30017 6.37 4.66017 7.71 5.18017 8.99ZM18.0002 16.64L15.6602 16.17L14.0102 17.82C15.2902 18.34 16.6402 18.69 18.0002 18.87V16.64ZM20.0002 4V6H22.0002V4H20.0002ZM20.0002 12H22.0002V10H20.0002V12ZM13.0002 10H11.0002V12H13.0002V10Z",
    fill: "currentColor"
  })));
}, "IconTty");
import SE from "classnames";
var jE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTune } from '@aws-amplify/ui-react'; \u2192 import { MdTune } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 17V19H9V17H3ZM3 5V7H13V5H3ZM13 21V19H21V17H13V15H11V21H13ZM7 9V11H3V13H7V15H9V9H7ZM21 13V11H11V13H21ZM15 9H17V7H21V5H17V3H15V9Z",
    fill: "currentColor"
  })));
}, "IconTune");
import YE from "classnames";
var FE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTurnedInNot } from '@aws-amplify/ui-react'; \u2192 import { MdTurnedInNot } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z",
    fill: "currentColor"
  })));
}, "IconTurnedInNot");
import TE from "classnames";
var AE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTurnedIn } from '@aws-amplify/ui-react'; \u2192 import { MdTurnedIn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 3H7C5.9 3 5.01 3.9 5.01 5L5 21L12 18L19 21V5C19 3.9 18.1 3 17 3Z",
    fill: "currentColor"
  })));
}, "IconTurnedIn");
import EE from "classnames";
var OE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTvOff } from '@aws-amplify/ui-react'; \u2192 import { MdTvOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 7V17.88L22.85 19.73C22.94 19.5 23 19.26 23 19V7C23 5.89 22.11 5 21 5H13.42L16.71 1.7L16 1L12 5L8 1L7.3 1.7L10.58 5H8.12L10.12 7H21ZM20.46 23L21.72 21.73L20.46 22.99V23ZM2.41 2.13L2.27 2.27L1 3.54L2.53 5.07C1.65 5.28 1 6.06 1 7V19C1 20.1 1.9 21 3 21H18.46L20.45 22.99L21.71 21.73L21.86 21.58L2.41 2.13ZM3 19V7H4.46L16.46 19H3Z",
    fill: "currentColor"
  })));
}, "IconTvOff");
import _E from "classnames";
var GE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTv } from '@aws-amplify/ui-react'; \u2192 import { MdTv } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _E(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 22.99 18.1 22.99 17L23 5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z",
    fill: "currentColor"
  })));
}, "IconTv");
import UE from "classnames";
var zE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconTwoWheeler } from '@aws-amplify/ui-react'; \u2192 import { MdTwoWheeler } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4.17 11C4.12 11 4.06 11 4 11H4.17ZM13.41 5H9V7H12.59L14.59 9H11L7 11L5 9H0V11H4C1.79 11 0 12.79 0 15C0 17.21 1.79 19 4 19C6.21 19 8 17.21 8 15L10 17H13L16.49 10.9L17.5 11.91C16.59 12.64 16 13.75 16 15C16 17.21 17.79 19 20 19C22.21 19 24 17.21 24 15C24 12.79 22.21 11 20 11C19.82 11 19.64 11.03 19.47 11.05L17.41 9H20V6L16.28 7.86L13.41 5ZM20 17C18.9 17 18 16.1 18 15C18 13.9 18.9 13 20 13C21.1 13 22 13.9 22 15C22 16.1 21.1 17 20 17ZM4 17C2.9 17 2 16.1 2 15C2 13.9 2.9 13 4 13C5.1 13 6 13.9 6 15C6 16.1 5.1 17 4 17Z",
    fill: "currentColor"
  })));
}, "IconTwoWheeler");
import XE from "classnames";
var KE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUmbrella } from '@aws-amplify/ui-react'; \u2192 import { MdUmbrella } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.5 6.92L13 5.77V3.88V3.4C13 3.14 13.22 2.92 13.5 2.92C13.78 2.92 14 3.13 14 3.4V4H16V3.4C16 2.07 14.88 1 13.5 1C12.12 1 11 2.07 11 3.4V3.88V5.77L9.5 6.92L6 6.07L11.05 21.32C11.2 21.77 11.6 22 12 22C12.4 22 12.8 21.77 12.95 21.31L18 6.07L14.5 6.92ZM13.28 8.5L14.04 9.08L14.96 8.85L13 14.8V8.29L13.28 8.5ZM9.96 9.09L10.72 8.51L11 8.29V14.8L9.03 8.86L9.96 9.09Z",
    fill: "currentColor"
  })));
}, "IconUmbrella");
import qE from "classnames";
var QE = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUnarchive } from '@aws-amplify/ui-react'; \u2192 import { MdUnarchive } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.54 5.23L19.15 3.55C18.88 3.21 18.47 3 18 3H6C5.53 3 5.12 3.21 4.84 3.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V6.5C21 6.02 20.83 5.57 20.54 5.23ZM6.24 5H17.76L18.59 6H5.42L6.24 5ZM5 19V8H19V19H5ZM8 14H10.55V17H13.45V14H16L12 10L8 14Z",
    fill: "currentColor"
  })));
}, "IconUnarchive");
import JE from "classnames";
var $E = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUndo } from '@aws-amplify/ui-react'; \u2192 import { MdUndo } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.5 8C9.85 8 7.45 8.99 5.6 10.6L2 7V16H11L7.38 12.38C8.77 11.22 10.54 10.5 12.5 10.5C16.04 10.5 19.05 12.81 20.1 16L22.47 15.22C21.08 11.03 17.15 8 12.5 8Z",
    fill: "currentColor"
  })));
}, "IconUndo");
import RE from "classnames";
var eO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUnfoldLess } from '@aws-amplify/ui-react'; \u2192 import { MdUnfoldLess } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RE(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.41016 18.59L8.83016 20L12.0002 16.83L15.1702 20L16.5802 18.59L12.0002 14L7.41016 18.59ZM16.5902 5.41L15.1702 4L12.0002 7.17L8.83016 4L7.41016 5.41L12.0002 10L16.5902 5.41Z",
    fill: "currentColor"
  })));
}, "IconUnfoldLess");
import oO from "classnames";
var tO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUnfoldMore } from '@aws-amplify/ui-react'; \u2192 import { MdUnfoldMore } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: oO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12.0002 5.83L15.1702 9L16.5802 7.59L12.0002 3L7.41016 7.59L8.83016 9L12.0002 5.83ZM12.0002 18.17L8.83016 15L7.42016 16.41L12.0002 21L16.5902 16.41L15.1702 15L12.0002 18.17Z",
    fill: "currentColor"
  })));
}, "IconUnfoldMore");
import rO from "classnames";
var iO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUnpublished } from '@aws-amplify/ui-react'; \u2192 import { MdUnpublished } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: rO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7.94 5.12L6.49 3.66C8.07 2.61 9.96 2 12 2C17.52 2 22 6.48 22 12C22 14.04 21.39 15.93 20.34 17.51L18.88 16.05C19.59 14.86 20 13.48 20 12C20 7.59 16.41 4 12 4C10.52 4 9.14 4.41 7.94 5.12ZM17.66 9.53L16.25 8.12L13.6 10.77L15.01 12.18L17.66 9.53ZM19.78 22.61L17.51 20.34C15.93 21.39 14.04 22 12 22C6.48 22 2 17.52 2 12C2 9.96 2.61 8.07 3.66 6.49L1.39 4.22L2.8 2.81L21.18 21.19L19.78 22.61ZM16.06 18.88L12.18 15L10.59 16.59L6.35 12.35L7.76 10.94L10.59 13.77L10.77 13.59L5.12 7.94C4.41 9.14 4 10.52 4 12C4 16.41 7.59 20 12 20C13.48 20 14.86 19.59 16.06 18.88Z",
    fill: "currentColor"
  })));
}, "IconUnpublished");
import sO from "classnames";
var aO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUnsubscribe } from '@aws-amplify/ui-react'; \u2192 import { MdUnsubscribe } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: sO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.99 14.04V5C20.99 3.9 20.09 3 18.99 3H5C3.9 3 3 3.9 3 5V15C3 16.1 3.9 17 5 17H15.05C15.33 18.92 17.15 20.35 19.23 19.93C20.57 19.66 21.66 18.56 21.93 17.22C22.18 15.98 21.77 14.83 20.99 14.04ZM18.99 5L12 8.5L5 5H18.99V5ZM15.35 15H5V7L12 10.5L19 7V13.05C18.84 13.03 18.67 13 18.5 13C17.11 13 15.91 13.82 15.35 15V15ZM20.5 17H16.5V16H20.5V17Z",
    fill: "currentColor"
  })));
}, "IconUnsubscribe");
import nO from "classnames";
var mO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUpdate } from '@aws-amplify/ui-react'; \u2192 import { MdUpdate } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: nO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11 8V13L15.25 15.52L16.02 14.24L12.5 12.15V8H11ZM21 10V3L18.36 5.64C16.74 4.01 14.49 3 12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12H19C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5C13.93 5 15.68 5.79 16.95 7.05L14 10H21Z",
    fill: "currentColor"
  })));
}, "IconUpdate");
import cO from "classnames";
var lO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUpgrade } from '@aws-amplify/ui-react'; \u2192 import { MdUpgrade } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: cO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 18V20H8V18H16ZM11 7.99V16H13V7.99H16L12 4L8 7.99H11Z",
    fill: "currentColor"
  })));
}, "IconUpgrade");
import pO from "classnames";
var hO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUpload } from '@aws-amplify/ui-react'; \u2192 import { MdUpload } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: pO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 16H15V10H19L12 3L5 10H9V16ZM12 5.83L14.17 8H13V14H11V8H9.83L12 5.83ZM5 18H19V20H5V18Z",
    fill: "currentColor"
  })));
}, "IconUpload");
import fO from "classnames";
var CO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconUsb } from '@aws-amplify/ui-react'; \u2192 import { MdUsb } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: fO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 7V11H16V13H13V5H15L12 1L8.99999 5H11V13H7.99999V10.93C8.69999 10.56 9.19999 9.85 9.19999 9C9.19999 7.79 8.20999 6.8 6.99999 6.8C5.78999 6.8 4.79999 7.79 4.79999 9C4.79999 9.85 5.29999 10.56 5.99999 10.93V13C5.99999 14.11 6.88999 15 7.99999 15H11V18.05C10.29 18.42 9.79999 19.15 9.79999 20C9.79999 21.22 10.79 22.2 12 22.2C13.21 22.2 14.2 21.22 14.2 20C14.2 19.15 13.71 18.42 13 18.05V15H16C17.11 15 18 14.11 18 13V11H19V7H15Z",
    fill: "currentColor"
  })));
}, "IconUsb");
import gO from "classnames";
var uO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVerifiedUser } from '@aws-amplify/ui-react'; \u2192 import { MdVerifiedUser } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: gO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM19 11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19L19 6.3V11ZM7.41 11.59L6 13L10 17L18 9L16.59 7.58L10 14.17L7.41 11.59Z",
    fill: "currentColor"
  })));
}, "IconVerifiedUser");
import wO from "classnames";
var dO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVerified } from '@aws-amplify/ui-react'; \u2192 import { MdVerified } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: wO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M23 11.99L20.56 9.2L20.9 5.51L17.29 4.69L15.4 1.5L12 2.96L8.6 1.5L6.71 4.69L3.1 5.5L3.44 9.2L1 11.99L3.44 14.78L3.1 18.48L6.71 19.3L8.6 22.5L12 21.03L15.4 22.49L17.29 19.3L20.9 18.48L20.56 14.79L23 11.99ZM19.05 13.47L18.49 14.12L18.57 14.97L18.75 16.92L16.85 17.35L16.01 17.54L15.57 18.28L14.58 19.96L12.8 19.19L12 18.85L11.21 19.19L9.43 19.96L8.44 18.29L8 17.55L7.16 17.36L5.26 16.93L5.44 14.97L5.52 14.12L4.96 13.47L3.67 12L4.96 10.52L5.52 9.87L5.43 9.01L5.25 7.07L7.15 6.64L7.99 6.45L8.43 5.71L9.42 4.03L11.2 4.8L12 5.14L12.79 4.8L14.57 4.03L15.56 5.71L16 6.45L16.84 6.64L18.74 7.07L18.56 9.02L18.48 9.87L19.04 10.52L20.33 11.99L19.05 13.47Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M10.09 13.7501L7.77001 11.4201L6.29001 12.9101L10.09 16.7201L17.43 9.36012L15.95 7.87012L10.09 13.7501Z",
    fill: "black"
  })));
}, "IconVerified");
import VO from "classnames";
var HO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVerticalAlignBottom } from '@aws-amplify/ui-react'; \u2192 import { MdVerticalAlignBottom } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: VO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 13H13V3H11V13H8L12 17L16 13ZM4 19V21H20V19H4Z",
    fill: "currentColor"
  })));
}, "IconVerticalAlignBottom");
import MO from "classnames";
var xO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVerticalAlignCenter } from '@aws-amplify/ui-react'; \u2192 import { MdVerticalAlignCenter } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: MO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 19H11V23H13V19H16L12 15L8 19ZM16 5H13V1H11V5H8L12 9L16 5ZM4 11V13H20V11H4Z",
    fill: "currentColor"
  })));
}, "IconVerticalAlignCenter");
import IO from "classnames";
var LO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVerticalAlignTop } from '@aws-amplify/ui-react'; \u2192 import { MdVerticalAlignTop } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: IO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M8 11H11V21H13V11H16L12 7L8 11ZM4 3V5H20V3H4Z",
    fill: "currentColor"
  })));
}, "IconVerticalAlignTop");
import vO from "classnames";
var NO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVerticalSplit } from '@aws-amplify/ui-react'; \u2192 import { MdVerticalSplit } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: vO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 13H11V15H3V13ZM3 17H11V19H3V17ZM3 9H11V11H3V9ZM3 5H11V7H3V5ZM19 7V17H15V7H19ZM21 5H13V19H21V5Z",
    fill: "currentColor"
  })));
}, "IconVerticalSplit");
import yO from "classnames";
var bO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVibration } from '@aws-amplify/ui-react'; \u2192 import { MdVibration } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: yO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M0 15H2V9H0V15ZM3 17H5V7H3V17ZM22 9V15H24V9H22ZM19 17H21V7H19V17ZM16.5 3H7.5C6.67 3 6 3.67 6 4.5V19.5C6 20.33 6.67 21 7.5 21H16.5C17.33 21 18 20.33 18 19.5V4.5C18 3.67 17.33 3 16.5 3ZM16 19H8V5H16V19Z",
    fill: "currentColor"
  })));
}, "IconVibration");
import ZO from "classnames";
var BO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVideoCall } from '@aws-amplify/ui-react'; \u2192 import { MdVideoCall } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: ZO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5ZM15 16H5V8H15V16ZM9 15H11V13H13V11H11V9H9V11H7V13H9V15Z",
    fill: "currentColor"
  })));
}, "IconVideoCall");
import WO from "classnames";
var kO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVideoLabel } from '@aws-amplify/ui-react'; \u2192 import { MdVideoLabel } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: WO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 16H3V5H21V16Z",
    fill: "currentColor"
  })));
}, "IconVideoLabel");
import DO from "classnames";
var PO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVideoLibrary } from '@aws-amplify/ui-react'; \u2192 import { MdVideoLibrary } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: DO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM12 5.5V14.5L18 10L12 5.5Z",
    fill: "currentColor"
  })));
}, "IconVideoLibrary");
import SO from "classnames";
var jO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVideoSettings } from '@aws-amplify/ui-react'; \u2192 import { MdVideoSettings } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: SO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 6H21V11H23V6C23 4.9 22.1 4 21 4H3C1.9 4 1 4.9 1 6V18C1 19.1 1.9 20 3 20H12V18H3V6Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M15 12L9 8V16L15 12Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M22.71 18.43C22.74 18.14 22.75 17.85 22.72 17.57L23.79 16.72C23.89 16.64 23.91 16.51 23.85 16.4L22.82 14.61C22.76 14.5 22.63 14.46 22.51 14.5L21.23 15C21 14.83 20.75 14.69 20.48 14.58L20.28 13.22C20.26 13.09 20.16 13 20.03 13H17.96C17.84 13 17.73 13.09 17.71 13.21L17.51 14.57C17.25 14.68 17 14.83 16.77 14.99L15.49 14.49C15.37 14.44 15.24 14.49 15.18 14.6L14.15 16.39C14.09 16.5 14.11 16.63 14.21 16.71L15.28 17.57C15.25 17.86 15.24 18.15 15.27 18.43L14.2 19.28C14.1 19.36 14.08 19.49 14.14 19.6L15.17 21.39C15.23 21.5 15.36 21.54 15.48 21.5L16.75 21C16.98 21.17 17.23 21.31 17.5 21.42L17.7 22.78C17.72 22.9 17.82 22.99 17.95 22.99H20.02C20.14 22.99 20.25 22.9 20.27 22.78L20.47 21.42C20.73 21.31 20.98 21.16 21.21 21L22.49 21.5C22.61 21.55 22.74 21.5 22.8 21.39L23.83 19.6C23.89 19.49 23.87 19.36 23.77 19.28L22.71 18.43ZM19 19.5C18.17 19.5 17.5 18.83 17.5 18C17.5 17.17 18.17 16.5 19 16.5C19.83 16.5 20.5 17.17 20.5 18C20.5 18.83 19.83 19.5 19 19.5Z",
    fill: "black"
  })));
}, "IconVideoSettings");
import YO from "classnames";
var FO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVideocamOff } from '@aws-amplify/ui-react'; \u2192 import { MdVideocamOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: YO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.56 7.99986L7.56 5.99986L3.41 1.85986L2 3.26986L4.73 5.99986H4C3.45 5.99986 3 6.44986 3 6.99986V16.9999C3 17.5499 3.45 17.9999 4 17.9999H16C16.21 17.9999 16.39 17.9199 16.55 17.8199L19.73 20.9999L21.14 19.5899L12.28 10.7299L9.56 7.99986ZM5 15.9999V7.99986H6.73L14.73 15.9999H5ZM15 7.99986V10.6099L21 16.6099V6.49986L17 10.4999V6.99986C17 6.44986 16.55 5.99986 16 5.99986H10.39L12.39 7.99986H15Z",
    fill: "currentColor"
  })));
}, "IconVideocamOff");
import TO from "classnames";
var AO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVideocam } from '@aws-amplify/ui-react'; \u2192 import { MdVideocam } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: TO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 8V16H5V8H15ZM16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6Z",
    fill: "currentColor"
  })));
}, "IconVideocam");
import EO from "classnames";
var OO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVideogameAsset } from '@aws-amplify/ui-react'; \u2192 import { MdVideogameAsset } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: EO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 6H3C1.9 6 1 6.9 1 8V16C1 17.1 1.9 18 3 18H21C22.1 18 23 17.1 23 16V8C23 6.9 22.1 6 21 6ZM21 16H3V8H21V16ZM6 15H8V13H10V11H8V9H6V11H4V13H6V15Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M14.5 15C15.3284 15 16 14.3284 16 13.5C16 12.6716 15.3284 12 14.5 12C13.6716 12 13 12.6716 13 13.5C13 14.3284 13.6716 15 14.5 15Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M18.5 12C19.3284 12 20 11.3284 20 10.5C20 9.67157 19.3284 9 18.5 9C17.6716 9 17 9.67157 17 10.5C17 11.3284 17.6716 12 18.5 12Z",
    fill: "black"
  })));
}, "IconVideogameAsset");
import _O from "classnames";
var GO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewAgenda } from '@aws-amplify/ui-react'; \u2192 import { MdViewAgenda } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: _O(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 5V9H4V5H19ZM19 15V19H4V15H19ZM20 3H3C2.45 3 2 3.45 2 4V10C2 10.55 2.45 11 3 11H20C20.55 11 21 10.55 21 10V4C21 3.45 20.55 3 20 3ZM20 13H3C2.45 13 2 13.45 2 14V20C2 20.55 2.45 21 3 21H20C20.55 21 21 20.55 21 20V14C21 13.45 20.55 13 20 13Z",
    fill: "currentColor"
  })));
}, "IconViewAgenda");
import UO from "classnames";
var zO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewArray } from '@aws-amplify/ui-react'; \u2192 import { MdViewArray } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: UO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 7V16H10V7H15ZM21 5H18V18H21V5ZM17 5H8V18H17V5ZM7 5H4V18H7V5Z",
    fill: "currentColor"
  })));
}, "IconViewArray");
import XO from "classnames";
var KO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewCarousel } from '@aws-amplify/ui-react'; \u2192 import { MdViewCarousel } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: XO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 6H6V17H2V6ZM7 19H17V4H7V19ZM9 6H15V17H9V6ZM18 6H22V17H18V6Z",
    fill: "currentColor"
  })));
}, "IconViewCarousel");
import qO from "classnames";
var QO = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewColumn } from '@aws-amplify/ui-react'; \u2192 import { MdViewColumn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: qO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 5V18H21V5H4ZM14 7V16H11V7H14ZM6 7H9V16H6V7ZM19 16H16V7H19V16Z",
    fill: "currentColor"
  })));
}, "IconViewColumn");
import JO from "classnames";
var $O = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewComfy } from '@aws-amplify/ui-react'; \u2192 import { MdViewComfy } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: JO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5V19H22V5H3ZM20 9H17.75V7H20V9ZM9.25 11H11.5V13H9.25V11ZM7.25 13H5V11H7.25V13ZM11.5 9H9.25V7H11.5V9ZM13.5 7H15.75V9H13.5V7ZM11.5 15V17H9.25V15H11.5ZM13.5 15H15.75V17H13.5V15ZM13.5 13V11H15.75V13H13.5ZM17.75 11H20V13H17.75V11ZM7.25 7V9H5V7H7.25ZM5 15H7.25V17H5V15ZM17.75 17V15H20V17H17.75Z",
    fill: "currentColor"
  })));
}, "IconViewComfy");
import RO from "classnames";
var e_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewCompact } from '@aws-amplify/ui-react'; \u2192 import { MdViewCompact } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: RO(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5V19H22V5H3ZM5 7H20V11H5V7ZM5 17V13H9V17H5ZM11 17V13H20V17H11Z",
    fill: "currentColor"
  })));
}, "IconViewCompact");
import o_ from "classnames";
var t_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewDay } from '@aws-amplify/ui-react'; \u2192 import { MdViewDay } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: o_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 18H2V20H21V18ZM19 10V14H4V10H19ZM20 8H3C2.45 8 2 8.45 2 9V15C2 15.55 2.45 16 3 16H20C20.55 16 21 15.55 21 15V9C21 8.45 20.55 8 20 8ZM21 4H2V6H21V4Z",
    fill: "currentColor"
  })));
}, "IconViewDay");
import r_ from "classnames";
var i_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewHeadline } from '@aws-amplify/ui-react'; \u2192 import { MdViewHeadline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: r_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 15H20V13H4V15ZM4 19H20V17H4V19ZM4 11H20V9H4V11ZM4 5V7H20V5H4Z",
    fill: "currentColor"
  })));
}, "IconViewHeadline");
import s_ from "classnames";
var a_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewList } from '@aws-amplify/ui-react'; \u2192 import { MdViewList } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: s_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 5V19H20V5H3ZM7 7V9H5V7H7ZM5 13V11H7V13H5ZM5 15H7V17H5V15ZM18 17H9V15H18V17ZM18 13H9V11H18V13ZM18 9H9V7H18V9Z",
    fill: "currentColor"
  })));
}, "IconViewList");
import n_ from "classnames";
var m_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewModule } from '@aws-amplify/ui-react'; \u2192 import { MdViewModule } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: n_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 5V18H21V5H4ZM14 7V10.5H11V7H14ZM6 7H9V10.5H6V7ZM6 16V12.5H9V16H6ZM11 16V12.5H14V16H11ZM19 16H16V12.5H19V16ZM16 10.5V7H19V10.5H16Z",
    fill: "currentColor"
  })));
}, "IconViewModule");
import c_ from "classnames";
var l_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewQuilt } from '@aws-amplify/ui-react'; \u2192 import { MdViewQuilt } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: c_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 5V18H21V5H4ZM6 16V7H9V16H6ZM11 16V12.5H14V16H11ZM19 16H16V12.5H19V16ZM11 10.5V7H19V10.5H11Z",
    fill: "currentColor"
  })));
}, "IconViewQuilt");
import p_ from "classnames";
var h_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewSidebar } from '@aws-amplify/ui-react'; \u2192 import { MdViewSidebar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: p_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M2 4V20H22V4H2ZM20 8.67H17.5V6H20V8.67ZM17.5 10.67H20V13.34H17.5V10.67ZM4 6H15.5V18H4V6ZM17.5 18V15.33H20V18H17.5Z",
    fill: "currentColor"
  })));
}, "IconViewSidebar");
import f_ from "classnames";
var C_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewStream } from '@aws-amplify/ui-react'; \u2192 import { MdViewStream } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: f_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 6V18H21V6H4ZM19 16H6V13H19V16ZM6 11V8H19V11H6Z",
    fill: "currentColor"
  })));
}, "IconViewStream");
import g_ from "classnames";
var u_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconViewWeek } from '@aws-amplify/ui-react'; \u2192 import { MdViewWeek } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: g_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 4H3C2.45 4 2 4.45 2 5V19C2 19.55 2.45 20 3 20H21C21.55 20 22 19.55 22 19V5C22 4.45 21.55 4 21 4ZM8 18H4V6H8V18ZM14 18H10V6H14V18ZM20 18H16V6H20V18Z",
    fill: "currentColor"
  })));
}, "IconViewWeek");
import w_ from "classnames";
var d_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVignette } from '@aws-amplify/ui-react'; \u2192 import { MdVignette } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: w_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 5V19H3V5H21ZM21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM12 8C15.25 8 18 9.83 18 12C18 14.17 15.25 16 12 16C8.75 16 6 14.17 6 12C6 9.83 8.75 8 12 8ZM12 6C7.58 6 4 8.69 4 12C4 15.31 7.58 18 12 18C16.42 18 20 15.31 20 12C20 8.69 16.42 6 12 6Z",
    fill: "currentColor"
  })));
}, "IconVignette");
import V_ from "classnames";
var Yt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: V_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6.0002C15.79 6.0002 19.17 8.1302 20.82 11.5002C20.23 12.7202 19.4 13.7702 18.41 14.6202L19.82 16.0302C21.21 14.8002 22.31 13.2602 23 11.5002C21.27 7.1102 17 4.0002 12 4.0002C10.73 4.0002 9.51 4.2002 8.36 4.5702L10.01 6.2202C10.66 6.0902 11.32 6.0002 12 6.0002ZM10.93 7.14019L13 9.2102C13.57 9.4602 14.03 9.9202 14.28 10.4902L16.35 12.5602C16.43 12.2202 16.49 11.8602 16.49 11.4902C16.5 9.0102 14.48 7.0002 12 7.0002C11.63 7.0002 11.28 7.05019 10.93 7.14019ZM2.01 3.8702L4.69 6.5502C3.06 7.8302 1.77 9.5302 1 11.5002C2.73 15.8902 7 19.0002 12 19.0002C13.52 19.0002 14.98 18.7102 16.32 18.1802L19.74 21.6002L21.15 20.1902L3.42 2.4502L2.01 3.8702ZM9.51 11.3702L12.12 13.9802C12.08 13.9902 12.04 14.0002 12 14.0002C10.62 14.0002 9.5 12.8802 9.5 11.5002C9.5 11.4502 9.51 11.4202 9.51 11.3702V11.3702ZM6.11 7.97019L7.86 9.7202C7.63 10.2702 7.5 10.8702 7.5 11.5002C7.5 13.9802 9.52 16.0002 12 16.0002C12.63 16.0002 13.23 15.8702 13.77 15.6402L14.75 16.6202C13.87 16.8602 12.95 17.0002 12 17.0002C8.21 17.0002 4.83 14.8702 3.18 11.5002C3.88 10.0702 4.9 8.89019 6.11 7.97019Z",
    fill: "currentColor"
  })));
}, "IconVisibilityOff");
import H_ from "classnames";
var Ft = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: H_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z",
    fill: "currentColor"
  })));
}, "IconVisibility");
import M_ from "classnames";
var x_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVoiceChat } from '@aws-amplify/ui-react'; \u2192 import { MdVoiceChat } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: M_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16ZM14 10.6L17 13V7L14 9.4V7H7V13H14V10.6Z",
    fill: "currentColor"
  })));
}, "IconVoiceChat");
import I_ from "classnames";
var L_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVoiceOverOff } from '@aws-amplify/ui-react'; \u2192 import { MdVoiceOverOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: I_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.76 5.36L15.08 7.05C15.88 8.18 15.91 9.63 15.17 10.79L16.87 12.49C18.77 10.47 18.74 7.51 16.76 5.36ZM20.07 2L18.44 3.63C21.16 6.6 21.2 11.02 18.58 14.19L20.22 15.83C23.96 11.94 23.93 5.99 20.07 2V2ZM9.43 5.04L12.96 8.57C12.76 6.71 11.29 5.24 9.43 5.04V5.04ZM4.41 2.86L3 4.27L5.62 6.89C5.23 7.5 5 8.22 5 9C5 11.21 6.79 13 9 13C9.78 13 10.5 12.77 11.11 12.38L15.51 16.78C13.74 15.6 10.78 15 9 15C6.33 15 1 16.34 1 19V21H17V19C17 18.63 16.89 18.3 16.71 17.98L19.73 21L21.14 19.59L4.41 2.86ZM3 19C3.22 18.28 6.31 17 9 17C11.7 17 14.8 18.29 15 19H3ZM9 11C7.9 11 7 10.1 7 9C7 8.78 7.04 8.58 7.11 8.38L9.62 10.89C9.42 10.96 9.22 11 9 11V11Z",
    fill: "currentColor"
  })));
}, "IconVoiceOverOff");
import v_ from "classnames";
var N_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVoicemail } from '@aws-amplify/ui-react'; \u2192 import { MdVoicemail } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: v_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.5 6C15.46 6 13 8.46 13 11.5C13 12.83 13.47 14.05 14.26 15H9.74C10.53 14.05 11 12.83 11 11.5C11 8.46 8.54 6 5.5 6C2.46 6 0 8.46 0 11.5C0 14.54 2.46 17 5.5 17H18.5C21.54 17 24 14.54 24 11.5C24 8.46 21.54 6 18.5 6ZM5.5 15C3.57 15 2 13.43 2 11.5C2 9.57 3.57 8 5.5 8C7.43 8 9 9.57 9 11.5C9 13.43 7.43 15 5.5 15ZM18.5 15C16.57 15 15 13.43 15 11.5C15 9.57 16.57 8 18.5 8C20.43 8 22 9.57 22 11.5C22 13.43 20.43 15 18.5 15Z",
    fill: "currentColor"
  })));
}, "IconVoicemail");
import y_ from "classnames";
var b_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVolumeDown } from '@aws-amplify/ui-react'; \u2192 import { MdVolumeDown } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: y_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16 7.97V16.02C17.48 15.29 18.5 13.77 18.5 12C18.5 10.23 17.48 8.71 16 7.97ZM5 9V15H9L14 20V4L9 9H5ZM12 8.83V15.17L9.83 13H7V11H9.83L12 8.83Z",
    fill: "currentColor"
  })));
}, "IconVolumeDown");
import Z_ from "classnames";
var B_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVolumeMute } from '@aws-amplify/ui-react'; \u2192 import { MdVolumeMute } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Z_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 8.83V15.17L11.83 13H9V11H11.83L14 8.83ZM16 4L11 9H7V15H11L16 20V4Z",
    fill: "currentColor"
  })));
}, "IconVolumeMute");
import W_ from "classnames";
var k_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVolumeOff } from '@aws-amplify/ui-react'; \u2192 import { MdVolumeOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: W_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4.34005 2.93018L2.93005 4.34018L7.29005 8.70018L7.00005 9.00018H3.00005V15.0002H7.00005L12.0001 20.0002V13.4102L16.1801 17.5902C15.5301 18.0802 14.8001 18.4702 14.0001 18.7002V20.7602C15.3401 20.4602 16.5701 19.8402 17.6101 19.0102L19.6601 21.0602L21.0701 19.6502L4.34005 2.93018ZM10.0001 15.1702L7.83005 13.0002H5.00005V11.0002H7.83005L8.71005 10.1202L10.0001 11.4102V15.1702ZM19.0001 12.0002C19.0001 12.8202 18.8501 13.6102 18.5901 14.3402L20.1201 15.8702C20.6801 14.7002 21.0001 13.3902 21.0001 12.0002C21.0001 7.72018 18.0101 4.14018 14.0001 3.23018V5.29018C16.8901 6.15018 19.0001 8.83018 19.0001 12.0002ZM12.0001 4.00018L10.1201 5.88018L12.0001 7.76018V4.00018ZM16.5001 12.0002C16.5001 10.2302 15.4801 8.71018 14.0001 7.97018V9.76018L16.4801 12.2402C16.4901 12.1602 16.5001 12.0802 16.5001 12.0002Z",
    fill: "currentColor"
  })));
}, "IconVolumeOff");
import D_ from "classnames";
var P_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVolumeUp } from '@aws-amplify/ui-react'; \u2192 import { MdVolumeUp } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: D_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3 8.99998V15H7L12 20V3.99998L7 8.99998H3ZM10 8.82998V15.17L7.83 13H5V11H7.83L10 8.82998ZM16.5 12C16.5 10.23 15.48 8.70998 14 7.96998V16.02C15.48 15.29 16.5 13.77 16.5 12ZM14 3.22998V5.28998C16.89 6.14998 19 8.82998 19 12C19 15.17 16.89 17.85 14 18.71V20.77C18.01 19.86 21 16.28 21 12C21 7.71998 18.01 4.13998 14 3.22998V3.22998Z",
    fill: "currentColor"
  })));
}, "IconVolumeUp");
import S_ from "classnames";
var j_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVpnKey } from '@aws-amplify/ui-react'; \u2192 import { MdVpnKey } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: S_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M22 19H16V15H13.32C12.18 17.42 9.72 19 7 19C3.14 19 0 15.86 0 12C0 8.14 3.14 5 7 5C9.72 5 12.17 6.58 13.32 9H24V15H22V19ZM18 17H20V13H22V11H11.94L11.71 10.33C11.01 8.34 9.11 7 7 7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17C9.11 17 11.01 15.66 11.71 13.67L11.94 13H18V17ZM7 15C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9C8.65 9 10 10.35 10 12C10 13.65 8.65 15 7 15ZM7 11C6.45 11 6 11.45 6 12C6 12.55 6.45 13 7 13C7.55 13 8 12.55 8 12C8 11.45 7.55 11 7 11Z",
    fill: "currentColor"
  })));
}, "IconVpnKey");
import Y_ from "classnames";
var F_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconVpnLock } from '@aws-amplify/ui-react'; \u2192 import { MdVpnLock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Y_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18.92 12C18.96 12.33 19 12.66 19 13C19 15.08 18.2 16.97 16.9 18.39C16.64 17.58 15.9 17 15 17H14V14C14 13.45 13.55 13 13 13H7V11H9C9.55 11 10 10.55 10 10V8H12C13.1 8 14 7.1 14 6V3.46C13.05 3.16 12.05 3 11 3C5.48 3 1 7.48 1 13C1 18.52 5.48 23 11 23C16.52 23 21 18.52 21 13C21 12.66 20.98 12.33 20.95 12H18.92V12ZM10 20.93C6.05 20.44 3 17.08 3 13C3 12.38 3.08 11.79 3.21 11.21L8 16V17C8 18.1 8.9 19 10 19V20.93ZM22 4V3.5C22 2.12 20.88 1 19.5 1C18.12 1 17 2.12 17 3.5V4C16.45 4 16 4.45 16 5V9C16 9.55 16.45 10 17 10H22C22.55 10 23 9.55 23 9V5C23 4.45 22.55 4 22 4ZM21 4H18V3.5C18 2.67 18.67 2 19.5 2C20.33 2 21 2.67 21 3.5V4Z",
    fill: "currentColor"
  })));
}, "IconVpnLock");
import T_ from "classnames";
var A_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWallpaper } from '@aws-amplify/ui-react'; \u2192 import { MdWallpaper } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: T_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 4H11V2H4C2.9 2 2 2.9 2 4V11H4V4ZM10 13L6 18H18L15 14L12.97 16.71L10 13ZM17 8.5C17 7.67 16.33 7 15.5 7C14.67 7 14 7.67 14 8.5C14 9.33 14.67 10 15.5 10C16.33 10 17 9.33 17 8.5ZM20 2H13V4H20V11H22V4C22 2.9 21.1 2 20 2ZM20 20H13V22H20C21.1 22 22 21.1 22 20V13H20V20ZM4 13H2V20C2 21.1 2.9 22 4 22H11V20H4V13Z",
    fill: "currentColor"
  })));
}, "IconWallpaper");
import E_ from "classnames";
var O_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWarningAmber } from '@aws-amplify/ui-react'; \u2192 import { MdWarningAmber } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: E_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z",
    fill: "currentColor"
  })));
}, "IconWarningAmber");
import __ from "classnames";
var Tt = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: __(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z",
    fill: "currentColor"
  })));
}, "IconWarning");
import G_ from "classnames";
var U_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWash } from '@aws-amplify/ui-react'; \u2192 import { MdWash } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: G_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20.75 16C21.44 16 22 15.44 22 14.75C22 14.06 21.44 13.5 20.75 13.5H12V12.5H18.75C19.44 12.5 20 11.94 20 11.25C20 10.58 19.47 10.05 18.82 10.01L8.87 10L10.35 7.4C10.44 7.23 10.49 7.06 10.49 6.86C10.49 6.6 10.4 6.36 10.23 6.16L9.12 5L1.94 11.8C1.34 12.36 1 13.15 1 13.97V20C1 21.66 2.34 23 4 23H17.75C18.44 23 19 22.44 19 21.75C19 21.06 18.44 20.5 17.75 20.5H12V19.5H19.75C20.44 19.5 21 18.94 21 18.25C21 17.56 20.44 17 19.75 17H12V16H20.75ZM10 21H4C3.45 21 3 20.55 3 20V14C3 13.61 3.23 13.36 3.36 13.25L7 9.87V12H10V21ZM13.5 9C14.33 9 15 8.33 15 7.5C15 6.66 13.5 5 13.5 5C13.5 5 12 6.66 12 7.5C12 8.33 12.67 9 13.5 9ZM18.5 1C18.5 1 16 3.83 16 5.5C16 6.88 17.12 8 18.5 8C19.88 8 21 6.88 21 5.5C21 3.83 18.5 1 18.5 1ZM18.5 6.5C17.95 6.5 17.5 6.05 17.5 5.5C17.5 5.1 17.93 4.28 18.5 3.45C19.07 4.28 19.5 5.1 19.5 5.5C19.5 6.05 19.05 6.5 18.5 6.5Z",
    fill: "currentColor"
  })));
}, "IconWash");
import z_ from "classnames";
var X_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWatchLater } from '@aws-amplify/ui-react'; \u2192 import { MdWatchLater } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: z_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.2 16.2L17 14.9L12.5 12.2V7Z",
    fill: "currentColor"
  })));
}, "IconWatchLater");
import K_ from "classnames";
var q_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWatch } from '@aws-amplify/ui-react'; \u2192 import { MdWatch } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: K_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14.31 2L14.72 4.48C13.87 4.17 12.96 4 12 4C11.05 4 10.13 4.17 9.29 4.47L9.7 2H14.31V2ZM14.72 19.52L14.31 22H9.7L9.29 19.53C10.13 19.83 11.05 20 12 20C12.96 20 13.87 19.83 14.72 19.52V19.52ZM16 0H8L7.05 5.73C5.19 7.19 4 9.45 4 12C4 14.55 5.19 16.81 7.05 18.27L8 24H16L16.96 18.27C18.81 16.81 20 14.54 20 12C20 9.46 18.81 7.19 16.96 5.73L16 0ZM12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18Z",
    fill: "currentColor"
  })));
}, "IconWatch");
import Q_ from "classnames";
var J_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWaterDamage } from '@aws-amplify/ui-react'; \u2192 import { MdWaterDamage } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: Q_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 3L2 12H5V20H19V12H22L12 3ZM7 18V10.19L12 5.69L17 10.19V18H7ZM14 14C14 15.1 13.1 16 12 16C10.9 16 10 15.1 10 14C10 12.9 12 10 12 10C12 10 14 12.9 14 14Z",
    fill: "currentColor"
  })));
}, "IconWaterDamage");
import $_ from "classnames";
var R_ = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWaves } from '@aws-amplify/ui-react'; \u2192 import { MdWaves } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $_(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17 16.9902C15.65 16.9902 14.8 17.4102 14.05 17.7902C13.4 18.1202 12.87 18.3902 12 18.3902C11.1 18.3902 10.6 18.1402 9.95 17.7902C9.2 17.4102 8.38 16.9902 7 16.9902C5.62 16.9902 4.8 17.4102 4.05 17.7902C3.4 18.1202 2.88 18.3902 2 18.3902V20.3402C3.35 20.3402 4.2 19.9202 4.95 19.5402C5.6 19.2102 6.12 18.9402 7 18.9402C7.88 18.9402 8.4 19.1902 9.05 19.5402C9.8 19.9202 10.62 20.3402 12 20.3402C13.38 20.3402 14.2 19.9202 14.95 19.5402C15.6 19.2102 16.13 18.9402 17 18.9402C17.9 18.9402 18.4 19.1902 19.05 19.5402C19.8 19.9202 20.63 20.3402 22 20.3402V18.3902C21.1 18.3902 20.6 18.1402 19.95 17.7902C19.2 17.4102 18.35 16.9902 17 16.9902ZM17 12.5402C15.65 12.5402 14.8 12.9702 14.05 13.3402C13.4 13.6602 12.87 13.9402 12 13.9402C11.1 13.9402 10.6 13.6902 9.95 13.3402C9.2 12.9602 8.38 12.5402 7 12.5402C5.62 12.5402 4.8 12.9702 4.05 13.3402C3.4 13.6602 2.88 13.9402 2 13.9402V15.8902C3.35 15.8902 4.2 15.4602 4.95 15.0902C5.6 14.7402 6.1 14.4902 7 14.4902C7.9 14.4902 8.4 14.7402 9.05 15.0902C9.8 15.4702 10.62 15.8902 12 15.8902C13.38 15.8902 14.2 15.4602 14.95 15.0902C15.6 14.7402 16.1 14.4902 17 14.4902C17.9 14.4902 18.4 14.7402 19.05 15.0902C19.8 15.4702 20.63 15.8902 22 15.8902V13.9402C21.1 13.9402 20.6 13.6902 19.95 13.3402C19.2 12.9602 18.35 12.5402 17 12.5402ZM19.95 4.46016C19.2 4.08016 18.37 3.66016 17 3.66016C15.63 3.66016 14.8 4.08016 14.05 4.46016C13.4 4.78016 12.87 5.06016 12 5.06016C11.1 5.06016 10.6 4.81016 9.95 4.46016C9.2 4.09016 8.38 3.66016 7 3.66016C5.62 3.66016 4.8 4.08016 4.05 4.46016C3.4 4.79016 2.88 5.06016 2 5.06016V6.99016C3.35 6.99016 4.2 6.56016 4.95 6.19016C5.6 5.86016 6.12 5.59016 7 5.59016C7.88 5.59016 8.4 5.84016 9.05 6.19016C9.8 6.57016 10.62 6.99016 12 6.99016C13.38 6.99016 14.2 6.56016 14.95 6.19016C15.6 5.87016 16.13 5.59016 17 5.59016C17.9 5.59016 18.4 5.84016 19.05 6.19016C19.8 6.57016 20.63 6.99016 22 6.99016V5.04016C21.1 5.04016 20.6 4.79016 19.95 4.46016V4.46016ZM17 8.09016C15.65 8.09016 14.8 8.52016 14.05 8.89016C13.4 9.24016 12.9 9.49016 12 9.49016C11.1 9.49016 10.6 9.24016 9.95 8.89016C9.2 8.51016 8.38 8.09016 7 8.09016C5.62 8.09016 4.8 8.52016 4.05 8.89016C3.4 9.24016 2.9 9.49016 2 9.49016V11.4402C3.35 11.4402 4.2 11.0102 4.95 10.6402C5.6 10.3202 6.13 10.0402 7 10.0402C7.87 10.0402 8.4 10.2902 9.05 10.6402C9.8 11.0202 10.62 11.4402 12 11.4402C13.38 11.4402 14.2 11.0102 14.95 10.6402C15.6 10.3202 16.13 10.0402 17 10.0402C17.9 10.0402 18.4 10.2902 19.05 10.6402C19.8 11.0202 20.63 11.4402 22 11.4402V9.49016C21.1 9.49016 20.6 9.24016 19.95 8.89016C19.2 8.51016 18.35 8.09016 17 8.09016Z",
    fill: "currentColor"
  })));
}, "IconWaves");
import eG from "classnames";
var oG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWbAuto } from '@aws-amplify/ui-react'; \u2192 import { MdWbAuto } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M7 7L3.8 16H5.7L6.4 14H9.6L10.3 16H12.2L9 7H7ZM6.85 12.65L8 9L9.15 12.65H6.85V12.65ZM22 7L20.8 13.29L19.3 7H17.7L16.21 13.29L15 7H14.24L14.23 7.01C12.76 5.18 10.53 4 8 4C3.58 4 0 7.58 0 12C0 16.42 3.58 20 8 20C10.96 20 13.55 18.39 14.93 16C14.96 15.94 14.98 15.88 15.01 15.82C15.06 15.74 15.1 15.65 15.15 15.57L15.25 16H17L18.5 9.9L20 16H21.75L23.8 7H22ZM13.37 14.67C12.38 16.64 10.35 18 8 18C4.69 18 2 15.31 2 12C2 8.69 4.69 6 8 6C11.31 6 14 8.69 14 12C14 12.96 13.77 13.86 13.37 14.67Z",
    fill: "currentColor"
  })));
}, "IconWbAuto");
import tG from "classnames";
var rG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWbCloudy } from '@aws-amplify/ui-react'; \u2192 import { MdWbCloudy } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_40666)"
  }, e.createElement("path", {
    d: "M12.01 6C14.62 6 16.9 7.86 17.41 10.43L17.71 11.93L19.23 12.04C20.79 12.15 22.01 13.45 22.01 15C22.01 16.65 20.66 18 19.01 18H6.01001C3.80001 18 2.01001 16.21 2.01001 14C2.01001 11.95 3.54001 10.24 5.57001 10.03L6.64001 9.92L7.14001 8.97C8.08001 7.14 9.95001 6 12.01 6ZM12.01 4C9.12001 4 6.60001 5.64 5.35001 8.04C2.35001 8.36 0.0100098 10.91 0.0100098 14C0.0100098 17.31 2.70001 20 6.01001 20H19.01C21.77 20 24.01 17.76 24.01 15C24.01 12.36 21.96 10.22 19.37 10.04C18.68 6.59 15.65 4 12.01 4Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_40666"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconWbCloudy");
import iG from "classnames";
var sG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWbIncandescent } from '@aws-amplify/ui-react'; \u2192 import { MdWbIncandescent } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M3.55 19.0898L4.96 20.4998L6.75 18.6998L5.34 17.2898L3.55 19.0898ZM11 19.9998H13V22.9998H11V19.9998ZM1 10.9998H4V12.9998H1V10.9998ZM13 4.0498V8.0098L14 8.5898C15.24 9.3098 16 10.6298 16 12.0498C16 14.2598 14.21 16.0498 12 16.0498C9.79 16.0498 8 14.2598 8 12.0498C8 10.6298 8.77 9.3098 10 8.5898L11 8.0098V4.0498H13ZM15 2.0498H9V6.85981C7.21 7.89981 6 9.8298 6 12.0498C6 15.3598 8.69 18.0498 12 18.0498C15.31 18.0498 18 15.3598 18 12.0498C18 9.8298 16.79 7.89981 15 6.85981V2.0498ZM20 10.9998H23V12.9998H20V10.9998ZM17.24 18.7098L19.03 20.5098L20.44 19.0998L18.64 17.3098L17.24 18.7098Z",
    fill: "currentColor"
  })));
}, "IconWbIncandescent");
import aG from "classnames";
var nG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWbIridescent } from '@aws-amplify/ui-react'; \u2192 import { MdWbIridescent } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M5.00005 15H19V9H5.00005V15ZM7.00005 11H17V13H7.00005V11ZM11 1H13V4H11V1ZM20.46 5.01L19.04 3.6L17.25 5.39L18.66 6.8L20.46 5.01ZM11 20H13V23H11V20ZM17.24 18.71L19.03 20.51L20.4501 19.09L18.65 17.3L17.24 18.71ZM4.96005 3.595L6.74805 5.385L5.34005 6.79L3.55305 5.003L4.96005 3.595ZM3.55005 19.08L4.96005 20.5L6.75005 18.7L5.34005 17.29L3.55005 19.08Z",
    fill: "currentColor"
  })));
}, "IconWbIridescent");
import mG from "classnames";
var cG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWbSunny } from '@aws-amplify/ui-react'; \u2192 import { MdWbSunny } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: mG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6.76 4.8398L4.96 3.0498L3.55 4.4598L5.34 6.2498L6.76 4.8398ZM1 10.4998H4V12.4998H1V10.4998ZM11 0.549805H13V3.4998H11V0.549805ZM19.04 3.0448L20.448 4.4518L18.658 6.2418L17.251 4.8338L19.04 3.0448ZM17.24 18.1598L19.03 19.9598L20.44 18.5498L18.64 16.7598L17.24 18.1598ZM20 10.4998H23V12.4998H20V10.4998ZM12 5.4998C8.69 5.4998 6 8.1898 6 11.4998C6 14.8098 8.69 17.4998 12 17.4998C15.31 17.4998 18 14.8098 18 11.4998C18 8.1898 15.31 5.4998 12 5.4998ZM12 15.4998C9.79 15.4998 8 13.7098 8 11.4998C8 9.2898 9.79 7.4998 12 7.4998C14.21 7.4998 16 9.2898 16 11.4998C16 13.7098 14.21 15.4998 12 15.4998ZM11 19.4998H13V22.4498H11V19.4998ZM3.55 18.5398L4.96 19.9498L6.75 18.1498L5.34 16.7398L3.55 18.5398Z",
    fill: "currentColor"
  })));
}, "IconWbSunny");
import lG from "classnames";
var pG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWc } from '@aws-amplify/ui-react'; \u2192 import { MdWc } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: lG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("g", {
    "clip-path": "url(#clip0_1020_41544)"
  }, e.createElement("path", {
    d: "M5.5 22V14.5H4V9C4 7.9 4.9 7 6 7H9C10.1 7 11 7.9 11 9V14.5H9.5V22H5.5ZM18 22V16H21L18.46 8.37C18.18 7.55 17.42 7 16.56 7H16.44C15.58 7 14.81 7.55 14.54 8.37L12 16H15V22H18ZM7.5 6C8.61 6 9.5 5.11 9.5 4C9.5 2.89 8.61 2 7.5 2C6.39 2 5.5 2.89 5.5 4C5.5 5.11 6.39 6 7.5 6ZM16.5 6C17.61 6 18.5 5.11 18.5 4C18.5 2.89 17.61 2 16.5 2C15.39 2 14.5 2.89 14.5 4C14.5 5.11 15.39 6 16.5 6Z",
    fill: "currentColor"
  })), e.createElement("defs", null, e.createElement("clipPath", {
    id: "clip0_1020_41544"
  }, e.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  })))));
}, "IconWc");
import hG from "classnames";
var fG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWebAsset } from '@aws-amplify/ui-react'; \u2192 import { MdWebAsset } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: hG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM19 18H5V8H19V18Z",
    fill: "currentColor"
  })));
}, "IconWebAsset");
import CG from "classnames";
var gG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWeb } from '@aws-amplify/ui-react'; \u2192 import { MdWeb } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: CG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM4 9H14.5V12.5H4V9ZM4 14.5H14.5V18H4V14.5ZM20 18H16.5V9H20V18Z",
    fill: "currentColor"
  })));
}, "IconWeb");
import uG from "classnames";
var wG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWeekend } from '@aws-amplify/ui-react'; \u2192 import { MdWeekend } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: uG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 9V7C21 5.35 19.65 4 18 4H6C4.35 4 3 5.35 3 7V9C1.35 9 0 10.35 0 12V17C0 18.65 1.35 20 3 20H21C22.65 20 24 18.65 24 17V12C24 10.35 22.65 9 21 9ZM5 7C5 6.45 5.45 6 6 6H18C18.55 6 19 6.45 19 7V9.78C18.39 10.33 18 11.12 18 12V14H6V12C6 11.12 5.61 10.33 5 9.78V7ZM22 17C22 17.55 21.55 18 21 18H3C2.45 18 2 17.55 2 17V12C2 11.45 2.45 11 3 11C3.55 11 4 11.45 4 12V16H20V12C20 11.45 20.45 11 21 11C21.55 11 22 11.45 22 12V17Z",
    fill: "currentColor"
  })));
}, "IconWeekend");
import dG from "classnames";
var VG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWest } from '@aws-amplify/ui-react'; \u2192 import { MdWest } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: dG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9 19L10.41 17.59L5.83 13H22V11H5.83L10.42 6.41L9 5L2 12L9 19Z",
    fill: "currentColor"
  })));
}, "IconWest");
import HG from "classnames";
var MG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWhatshot } from '@aws-amplify/ui-react'; \u2192 import { MdWhatshot } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: HG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M11.57 13.1599C10.21 13.4399 9.4 14.3199 9.4 15.5699C9.4 16.9099 10.51 17.9899 11.89 17.9899C13.94 17.9899 15.6 16.3299 15.6 14.2799C15.6 13.2099 15.45 12.1599 15.14 11.1599C14.35 12.2299 12.94 12.8799 11.57 13.1599ZM13.5 0.669922C13.5 0.669922 14.24 3.31992 14.24 5.46992C14.24 7.52992 12.89 9.19992 10.83 9.19992C8.76 9.19992 7.2 7.52992 7.2 5.46992L7.23 5.10992C5.21 7.50992 4 10.6199 4 13.9999C4 18.4199 7.58 21.9999 12 21.9999C16.42 21.9999 20 18.4199 20 13.9999C20 8.60992 17.41 3.79992 13.5 0.669922ZM12 19.9999C8.69 19.9999 6 17.3099 6 13.9999C6 12.4699 6.3 10.9599 6.86 9.56992C7.87 10.5799 9.27 11.1999 10.83 11.1999C13.49 11.1999 15.58 9.36992 16.11 6.76992C17.34 8.96992 18 11.4399 18 13.9999C18 17.3099 15.31 19.9999 12 19.9999Z",
    fill: "currentColor"
  })));
}, "IconWhatshot");
import xG from "classnames";
var IG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWheelchairPickup } from '@aws-amplify/ui-react'; \u2192 import { MdWheelchairPickup } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: xG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4.5 4C4.5 2.89 5.39 2 6.5 2C7.61 2 8.5 2.89 8.5 4C8.5 5.11 7.61 6 6.5 6C5.39 6 4.5 5.11 4.5 4ZM10 10.95V9C10 7.9 9.1 7 8 7H5C3.9 7 3 7.9 3 9V15H5V22H8.5V21.89C7.26 20.63 6.5 18.9 6.5 17C6.5 14.42 7.91 12.16 10 10.95ZM16.5 17C16.5 18.65 15.15 20 13.5 20C11.85 20 10.5 18.65 10.5 17C10.5 15.89 11.11 14.94 12 14.42V12.26C9.98 12.9 8.5 14.77 8.5 17C8.5 19.76 10.74 22 13.5 22C16.26 22 18.5 19.76 18.5 17H16.5ZM19.54 14H15V8H13V16H18.46L20.93 19.71L22.59 18.6L19.54 14Z",
    fill: "currentColor"
  })));
}, "IconWheelchairPickup");
import LG from "classnames";
var vG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWhereToVote } from '@aws-amplify/ui-react'; \u2192 import { MdWhereToVote } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: LG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 1C7.59 1 4 4.59 4 9C4 14.57 10.96 22.34 11.26 22.67L12 23.49L12.74 22.67C13.04 22.34 20 14.57 20 9C20 4.59 16.41 1 12 1ZM12 20.47C9.82 17.86 6 12.54 6 9C6 5.69 8.69 3 12 3C15.31 3 18 5.69 18 9C18 12.83 13.75 18.36 12 20.47ZM10.47 11.17L8.71 9.4L7.29 10.82L10.47 14L16.48 7.99L15.07 6.57L10.47 11.17Z",
    fill: "currentColor"
  })));
}, "IconWhereToVote");
import NG from "classnames";
var yG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWidgets } from '@aws-amplify/ui-react'; \u2192 import { MdWidgets } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: NG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.66 4.51994L19.49 7.34994L16.66 10.1799L13.83 7.34994L16.66 4.51994V4.51994ZM9 4.99994V8.99994H5V4.99994H9ZM19 14.9999V18.9999H15V14.9999H19ZM9 14.9999V18.9999H5V14.9999H9ZM16.66 1.68994L11 7.33994L16.66 12.9999L22.32 7.33994L16.66 1.68994ZM11 2.99994H3V10.9999H11V2.99994ZM21 12.9999H13V20.9999H21V12.9999ZM11 12.9999H3V20.9999H11V12.9999Z",
    fill: "currentColor"
  })));
}, "IconWidgets");
import bG from "classnames";
var ZG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWifiCalling } from '@aws-amplify/ui-react'; \u2192 import { MdWifiCalling } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: bG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.33 14.9 16.22 14.89 16.12 14.89C15.86 14.89 15.61 14.99 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51ZM5.03 5H6.53C6.6 5.89 6.75 6.76 6.99 7.59L5.79 8.79C5.38 7.59 5.12 6.32 5.03 5ZM19 18.97C17.68 18.88 16.41 18.62 15.2 18.22L16.39 17.03C17.24 17.27 18.11 17.42 18.99 17.48V18.97H19Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M22 4.95C21.79 4.78 19.67 3 16.5 3C13.32 3 11.21 4.78 11 4.95L16.5 12L22 4.95Z",
    fill: "black"
  })));
}, "IconWifiCalling");
import BG from "classnames";
var WG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWifiLock } from '@aws-amplify/ui-react'; \u2192 import { MdWifiLock } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: BG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21.31 9.58L24 6C20.66 3.49 16.5 2 12 2C7.5 2 3.34 3.49 0 6L12 22L15.5 17.33V14.5C15.5 11.74 17.74 9.5 20.5 9.5C20.78 9.5 21.05 9.54 21.31 9.58ZM23 16V14.5C23 13.12 21.88 12 20.5 12C19.12 12 18 13.12 18 14.5V16C17.45 16 17 16.45 17 17V21C17 21.55 17.45 22 18 22H23C23.55 22 24 21.55 24 21V17C24 16.45 23.55 16 23 16ZM22 16H19V14.5C19 13.67 19.67 13 20.5 13C21.33 13 22 13.67 22 14.5V16Z",
    fill: "currentColor"
  })));
}, "IconWifiLock");
import kG from "classnames";
var DG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWifiOff } from '@aws-amplify/ui-react'; \u2192 import { MdWifiOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: kG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M21 11.0001L23 9.00014C19.27 5.27014 14.13 3.85014 9.3 4.69014L11.88 7.27014C15.18 7.25014 18.49 8.49014 21 11.0001ZM19 13.0001C17.92 11.9201 16.64 11.1501 15.28 10.6701L18.3 13.6901L19 13.0001ZM9 17.0001L12 20.0001L15 17.0001C13.35 15.3401 10.66 15.3401 9 17.0001ZM3.41 1.64014L2 3.05014L5.05 6.10014C3.59 6.83014 2.22 7.79014 1 9.00014L3 11.0001C4.23 9.77014 5.65 8.84014 7.17 8.22014L9.41 10.4601C7.79 10.8901 6.27 11.7401 5 13.0001L7 15.0001C8.35 13.6501 10.11 12.9601 11.89 12.9401L18.97 20.0201L20.38 18.6101L3.41 1.64014Z",
    fill: "currentColor"
  })));
}, "IconWifiOff");
import PG from "classnames";
var SG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWifiProtectedSetup } from '@aws-amplify/ui-react'; \u2192 import { MdWifiProtectedSetup } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: PG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M16.71 5.29L19 3H11V11L13.3 8.7C15.27 10.16 16.55 12.48 16.55 15.12C16.55 16.43 16.23 17.66 15.67 18.75C18 17.23 19.55 14.61 19.55 11.62C19.55 9.1 18.44 6.85 16.71 5.29Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M7.45999 8.88C7.45999 7.57 7.77999 6.34 8.33999 5.25C5.99999 6.77 4.45999 9.39 4.45999 12.38C4.45999 14.9 5.55999 17.15 7.29999 18.71L4.99999 21H13V13L10.7 15.3C8.73999 13.84 7.45999 11.52 7.45999 8.88Z",
    fill: "black"
  })));
}, "IconWifiProtectedSetup");
import jG from "classnames";
var YG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWifiTethering } from '@aws-amplify/ui-react'; \u2192 import { MdWifiTethering } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: jG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M12 11C10.9 11 10 11.9 10 13C10 14.1 10.9 15 12 15C13.1 15 14 14.1 14 13C14 11.9 13.1 11 12 11ZM18 13C18 9.69 15.31 7 12 7C8.69 7 6 9.69 6 13C6 15.22 7.21 17.15 9 18.19L10 16.45C8.81 15.75 8 14.48 8 13C8 10.79 9.79 9 12 9C14.21 9 16 10.79 16 13C16 14.48 15.19 15.75 14 16.45L15 18.19C16.79 17.15 18 15.22 18 13ZM12 3C6.48 3 2 7.48 2 13C2 16.7 4.01 19.92 6.99 21.65L7.99 19.92C5.61 18.53 4 15.96 4 13C4 8.58 7.58 5 12 5C16.42 5 20 8.58 20 13C20 15.96 18.39 18.53 16 19.92L17 21.65C19.99 19.92 22 16.7 22 13C22 7.48 17.52 3 12 3V3Z",
    fill: "currentColor"
  })));
}, "IconWifiTethering");
import FG from "classnames";
var TG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWifi } from '@aws-amplify/ui-react'; \u2192 import { MdWifi } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: FG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M1 8.99977L3 10.9998C7.97 6.02977 16.03 6.02977 21 10.9998L23 8.99977C16.93 2.92977 7.08 2.92977 1 8.99977ZM9 16.9998L12 19.9998L15 16.9998C13.35 15.3398 10.66 15.3398 9 16.9998ZM5 12.9998L7 14.9998C9.76 12.2398 14.24 12.2398 17 14.9998L19 12.9998C15.14 9.13977 8.87 9.13977 5 12.9998Z",
    fill: "currentColor"
  })));
}, "IconWifi");
import AG from "classnames";
var EG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWineBar } from '@aws-amplify/ui-react'; \u2192 import { MdWineBar } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: AG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M6 3V9C6 11.97 8.16 14.43 11 14.91V19H8V21H16V19H13V14.91C15.84 14.43 18 11.97 18 9V3H6ZM12 13C10.14 13 8.59 11.72 8.14 10H15.86C15.41 11.72 13.86 13 12 13ZM16 8H8V5H16V8Z",
    fill: "currentColor"
  })));
}, "IconWineBar");
import OG from "classnames";

var _G = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWorkOff } from '@aws-amplify/ui-react'; \u2192 import { MdWorkOff } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: OG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M9.99999 3.99984H14V5.99984H10.4L12.4 7.99984H20V15.5998L22 17.5998V7.99984C22 6.88984 21.11 5.99984 20 5.99984H16V3.99984C16 2.88984 15.11 1.99984 14 1.99984H9.99999C9.00999 1.99984 8.19999 2.69984 8.03999 3.63984L9.99999 5.59984V3.99984ZM3.39999 1.83984L1.98999 3.24984L4.73999 5.99984H3.99999C2.88999 5.99984 2.00999 6.88984 2.00999 7.99984L1.99999 18.9998C1.99999 20.1098 2.88999 20.9998 3.99999 20.9998H19.74L21.74 22.9998L23.15 21.5898L3.39999 1.83984ZM3.99999 18.9998V7.99984H6.73999L17.74 18.9998H3.99999Z",
    fill: "currentColor"
  })));
}, "IconWorkOff");

import GG from "classnames";
var UG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWorkOutline } from '@aws-amplify/ui-react'; \u2192 import { MdWorkOutline } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: GG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M14 6V4H10V6H14ZM4 8V19H20V8H4ZM20 6C21.11 6 22 6.89 22 8V19C22 20.11 21.11 21 20 21H4C2.89 21 2 20.11 2 19L2.01 8C2.01 6.89 2.89 6 4 6H8V4C8 2.89 8.89 2 10 2H14C15.11 2 16 2.89 16 4V6H20Z",
    fill: "currentColor"
  })));
}, "IconWorkOutline");
import zG from "classnames";
var XG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWork } from '@aws-amplify/ui-react'; \u2192 import { MdWork } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: zG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM14 6H10V4H14V6Z",
    fill: "currentColor"
  })));
}, "IconWork");
import KG from "classnames";
var qG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWrapText } from '@aws-amplify/ui-react'; \u2192 import { MdWrapText } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: KG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M4 19H10V17H4V19ZM20 5H4V7H20V5ZM17 11H4V13H17.25C18.35 13 19.25 13.9 19.25 15C19.25 16.1 18.35 17 17.25 17H15V15L12 18L15 21V19H17C19.21 19 21 17.21 21 15C21 12.79 19.21 11 17 11Z",
    fill: "currentColor"
  })));
}, "IconWrapText");
import QG from "classnames";
var JG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWrongLocation } from '@aws-amplify/ui-react'; \u2192 import { MdWrongLocation } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: QG(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M18 11C18 11.07 18 11.13 18 11.2C18 13.54 16.05 16.64 12 20.34C7.95 16.64 6 13.55 6 11.2C6 7.57 8.65 5 12 5C12.34 5 12.68 5.03 13 5.08V3.06C12.67 3.02 12.34 3 12 3C7.8 3 4 6.22 4 11.2C4 14.52 6.67 18.45 12 23C17.33 18.45 20 14.52 20 11.2C20 11.13 20 11.07 20 11H18Z",
    fill: "currentColor"
  }), e.createElement("path", {
    d: "M12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13Z",
    fill: "black"
  }), e.createElement("path", {
    d: "M22.54 2.87996L21.12 1.45996L19 3.58996L16.88 1.45996L15.46 2.87996L17.59 4.99996L15.46 7.11996L16.88 8.53996L19 6.40996L21.12 8.53996L22.54 7.11996L20.41 4.99996L22.54 2.87996Z",
    fill: "black"
  })));
}, "IconWrongLocation");
import $G from "classnames";
var RG = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconWysiwyg } from '@aws-amplify/ui-react'; \u2192 import { MdWysiwyg } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: $G(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM19 19H5V7H19V19ZM17 12H7V10H17V12ZM13 16H7V14H13V16Z",
    fill: "currentColor"
  })));
}, "IconWysiwyg");
import eU from "classnames";
var oU = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconYoutubeSearchedFor } from '@aws-amplify/ui-react'; \u2192 import { MdYoutubeSearchedFor } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: eU(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M17.01 14H16.21L15.94 13.73C16.92 12.59 17.51 11.12 17.51 9.5C17.51 5.91 14.6 3 11.01 3C7.42 3 4.51 6 4.51 9.5H2L5.84 13.5L10 9.5H6.51C6.51 7 8.53 5 11.01 5C13.49 5 15.51 7.01 15.51 9.5C15.51 11.98 13.49 14 11.01 14C10.36 14 9.75 13.86 9.19 13.62L7.71 15.1C8.68 15.67 9.8 16 11.01 16C12.62 16 14.09 15.41 15.23 14.43L15.5 14.7V15.49L20.51 20.48L22 19L17.01 14V14Z",
    fill: "currentColor"
  })));
}, "IconYoutubeSearchedFor");
import tU from "classnames";
var rU = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconZoomIn } from '@aws-amplify/ui-react'; \u2192 import { MdZoomIn } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: tU(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14ZM10 7H9V9H7V10H9V12H10V10H12V9H10V7Z",
    fill: "currentColor"
  })));
}, "IconZoomIn");
import iU from "classnames";
var sU = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconZoomOutMap } from '@aws-amplify/ui-react'; \u2192 import { MdZoomOutMap } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: iU(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z",
    fill: "currentColor"
  })));
}, "IconZoomOutMap");
import aU from "classnames";
var nU = s(function (t) {
  var o = t,
      r = o.className,
      i = m(o, ["className"]);
  return l({
    shouldWarn: !0,
    message: "Built-in icons are being deprecated in the next major release. You can use the react-icons (https://react-icons.github.io/react-icons) package with the Material Icon set in place of these icons or any other React Icon library.\nimport { IconZoomOut } from '@aws-amplify/ui-react'; \u2192 import { MdZoomOut } from 'react-icons/md';"
  }), e.createElement(c, n({
    as: "span",
    width: "1em",
    height: "1em",
    className: aU(a.Icon, r)
  }, i), e.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.createElement("path", {
    d: "M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14ZM7 9H12V10H7V9Z",
    fill: "currentColor"
  })));
}, "IconZoomOut");
var At = s(function (_ref12) {
  var t = _ref12.variation;

  switch (t) {
    case "info":
      return Ue.createElement(kt, {
        className: a.AlertIcon
      });

    case "error":
      return Ue.createElement(Wt, {
        className: a.AlertIcon
      });

    case "warning":
      return Ue.createElement(Tt, {
        className: a.AlertIcon
      });

    case "success":
      return Ue.createElement(yt, {
        className: a.AlertIcon
      });

    default:
      return null;
  }
}, "AlertIcon");
At.displayName = "AlertIcon";
var cU = s(function (V, d) {
  var H = V,
      t = H.buttonRef,
      r = H.children,
      i = H.className,
      _H$hasIcon = H.hasIcon,
      o = _H$hasIcon === void 0 ? !0 : _H$hasIcon,
      f = H.heading,
      _H$isDismissible = H.isDismissible,
      C = _H$isDismissible === void 0 ? !1 : _H$isDismissible,
      g = H.onDismiss,
      u = H.variation,
      w = m(H, ["buttonRef", "children", "className", "hasIcon", "heading", "isDismissible", "onDismiss", "variation"]);

  var _s1$useState = s1.useState(!1),
      _s1$useState2 = _slicedToArray(_s1$useState, 2),
      M = _s1$useState2[0],
      x = _s1$useState2[1],
      L = s1.useCallback(function () {
    x(!M), O(g) && g();
  }, [x, g, M]);

  return !M && s1.createElement(I, n({
    className: mU(a.Alert, i),
    "data-variation": u,
    ref: d
  }, w), o && s1.createElement(At, {
    variation: u
  }), s1.createElement(c, {
    role: "alert",
    flex: "1"
  }, f && s1.createElement(c, {
    className: a.AlertHeading
  }, f), s1.createElement(c, {
    className: a.AlertBody
  }, r)), C && s1.createElement(Z, {
    variation: "link",
    className: a.AlertDismiss,
    onClick: L,
    ref: t
  }, s1.createElement(_e, null)));
}, "AlertPrimitive"),
    Ve = s1.forwardRef(cU);
Ve.displayName = "Alert";
import * as co from "react";
import lU from "classnames";
var pU = s(function (g, C) {
  var u = g,
      t = u.className,
      r = u.children,
      i = u.variation,
      o = u.size,
      f = m(u, ["className", "children", "variation", "size"]);
  return co.createElement(c, n({
    as: "span",
    className: lU(a.Badge, t),
    "data-variation": i,
    "data-size": o,
    ref: C
  }, f), r);
}, "BadgePrimitive"),
    lo = co.forwardRef(pU);
lo.displayName = "Badge";
import * as y1 from "react";
import hU from "classnames";
var fU = s(function (u, g) {
  var w = u,
      t = w.className,
      r = w.children,
      _w$role = w.role,
      i = _w$role === void 0 ? "group" : _w$role,
      o = w.size,
      f = w.variation,
      C = m(w, ["className", "children", "role", "size", "variation"]);
  return y1.createElement(I, n({
    className: hU(a.ButtonGroup, t),
    role: i,
    ref: g
  }, C), y1.Children.map(r, function (d) {
    return y1.isValidElement(d) ? y1.cloneElement(d, {
      size: o,
      variation: f
    }) : d;
  }));
}, "ButtonGroupPrimitive"),
    He = y1.forwardRef(fU);
He.displayName = "ButtonGroup";
import CU from "classnames";
import * as po from "react";
var gU = s(function (C, f) {
  var g = C,
      t = g.className,
      r = g.children,
      i = g.variation,
      o = m(g, ["className", "children", "variation"]);
  return po.createElement(c, n({
    className: CU(a.Card, t),
    "data-variation": i,
    ref: f
  }, o), r);
}, "CardPrimitive"),
    ho = po.forwardRef(gU);
ho.displayName = "Card";
import * as Ie from "react";
import kU from "classnames";
import * as H1 from "react";
import xU from "classnames";
import * as fo from "react";
import uU from "classnames";
var wU = s(function (E, k) {
  var _ = E,
      t = _.autoComplete,
      r = _.checked,
      i = _.className,
      o = _.defaultChecked,
      f = _.defaultValue,
      C = _.id,
      g = _.isDisabled,
      u = _.isReadOnly,
      w = _.isRequired,
      d = _.size,
      _$type = _.type,
      V = _$type === void 0 ? "text" : _$type,
      _$hasError = _.hasError,
      H = _$hasError === void 0 ? !1 : _$hasError,
      M = _.value,
      x = _.variation,
      L = _.onBlur,
      v = _.onChange,
      b = _.onCopy,
      y = _.onCut,
      D = _.onFocus,
      B = _.onInput,
      P = _.onPaste,
      S = _.onSelect,
      j = _.onWheel,
      W = m(_, ["autoComplete", "checked", "className", "defaultChecked", "defaultValue", "id", "isDisabled", "isReadOnly", "isRequired", "size", "type", "hasError", "value", "variation", "onBlur", "onChange", "onCopy", "onCut", "onFocus", "onInput", "onPaste", "onSelect", "onWheel"]);
  return fo.createElement(c, n({
    "aria-invalid": H,
    as: "input",
    autoComplete: t,
    checked: r,
    className: uU(a.Input, a.FieldGroupControl, i),
    "data-size": d,
    "data-variation": x,
    defaultChecked: o,
    defaultValue: f,
    isDisabled: g,
    id: C,
    onBlur: L,
    onChange: v,
    onCopy: b,
    onCut: y,
    onFocus: D,
    onInput: B,
    onPaste: P,
    onSelect: S,
    onWheel: j,
    readOnly: u,
    ref: k,
    required: w,
    type: V,
    value: M
  }, W));
}, "InputPrimitive"),
    C1 = fo.forwardRef(wU);
C1.displayName = "Input";
import * as Co from "react";
import dU from "classnames";
var VU = s(function (u, g) {
  var w = u,
      _w$as = w.as,
      t = _w$as === void 0 ? "p" : _w$as,
      r = w.className,
      i = w.children,
      o = w.isTruncated,
      f = w.variation,
      C = m(w, ["as", "className", "children", "isTruncated", "variation"]);
  return Co.createElement(c, n({
    as: t,
    className: dU(a.Text, r),
    "data-truncate": o,
    "data-variation": f,
    ref: g
  }, C), i);
}, "TextPrimitive"),
    G = Co.forwardRef(VU);
G.displayName = "Text";
import { useState as dr } from "react";
var Vr = s(function (t, r) {
  var _dr = dr(t),
      _dr2 = _slicedToArray(_dr, 2),
      i = _dr2[0],
      o = _dr2[1],
      _dr3 = dr(!1),
      _dr4 = _slicedToArray(_dr3, 2),
      f = _dr4[0],
      C = _dr4[1];

  return {
    dataChecked: i,
    dataFocus: f,
    onBlur: s(function () {
      C(!1);
    }, "onBlur"),
    onChange: s(function (d) {
      o(d.target.checked), O(r) && r(d);
    }, "onChange"),
    onFocus: s(function () {
      C(!0);
    }, "onFocus"),
    setDataChecked: o
  };
}, "useCheckbox");
import * as go from "react";
import HU from "classnames";
var MU = s(function (C, f) {
  var g = C,
      _g$as = g.as,
      t = _g$as === void 0 ? "span" : _g$as,
      r = g.children,
      i = g.className,
      o = m(g, ["as", "children", "className"]);
  return go.createElement(c, n({
    as: t,
    className: HU(a.VisuallyHidden, i),
    ref: f
  }, o), r);
}, "VisuallyHiddenPrimitive"),
    e1 = go.forwardRef(MU);
e1.displayName = "VisuallyHidden";
import * as Hr from "react";
var Me = s(function (t, r) {
  return Hr.useMemo(function () {
    return t && r ? "".concat(t, "-").concat(r) : void 0;
  }, [t, r]);
}, "useTestId");
var IU = s(function (x, M) {
  var L = x,
      t = L.checked,
      r = L.className,
      i = L.defaultChecked,
      o = L.hasError,
      f = L.isDisabled,
      C = L.label,
      g = L.labelHidden,
      u = L.labelPosition,
      w = L.onChange,
      d = L.size,
      V = L.testId,
      H = m(L, ["checked", "className", "defaultChecked", "hasError", "isDisabled", "label", "labelHidden", "labelPosition", "onChange", "size", "testId"]);

  var _J = J(H),
      v = _J.baseStyleProps,
      b = _J.flexContainerStyleProps,
      y = _J.rest,
      D = t !== void 0 ? t : i,
      _Vr = Vr(D, w),
      B = _Vr.dataChecked,
      P = _Vr.dataFocus,
      S = _Vr.onBlur,
      j = _Vr.onChange,
      W = _Vr.onFocus,
      k = _Vr.setDataChecked;

  H1.useEffect(function () {
    t !== void 0 && t !== B && k(t);
  }, [t, B, k]);

  var E = Me(V, a.CheckboxButton),
      _ = Me(V, a.CheckboxIcon),
      z = Me(V, a.CheckboxLabel);

  return H1.createElement(I, n(n({
    as: "label",
    className: xU(a.Checkbox, r),
    "data-disabled": f,
    "data-label-position": u,
    testId: V
  }, v), b), H1.createElement(e1, null, H1.createElement(C1, n({
    checked: t,
    className: a.CheckboxInput,
    defaultChecked: i,
    isDisabled: f,
    onBlur: S,
    onChange: j,
    onFocus: W,
    ref: M,
    type: "checkbox"
  }, y))), C && !g && H1.createElement(G, {
    as: "span",
    className: a.CheckboxLabel,
    "data-disabled": f,
    testId: z
  }, C), H1.createElement(I, {
    "aria-hidden": "true",
    as: "span",
    className: a.CheckboxButton,
    "data-checked": B,
    "data-disabled": f,
    "data-focus": P,
    "data-error": o,
    testId: E
  }, H1.createElement(bt, {
    className: a.CheckboxIcon,
    "data-checked": B,
    "data-disabled": f,
    "data-testid": _,
    size: d
  })));
}, "CheckboxPrimitive"),
    uo = H1.forwardRef(IU);
uo.displayName = "Checkbox";
import * as ze from "react";
import * as wo from "react";
import LU from "classnames";
var vU = s(function (g, C) {
  var u = g,
      t = u.className,
      r = u.children,
      _u$isVisible = u.isVisible,
      i = _u$isVisible === void 0 ? !0 : _u$isVisible,
      _u$excludeFromTabOrde = u.excludeFromTabOrder,
      o = _u$excludeFromTabOrde === void 0 ? !1 : _u$excludeFromTabOrde,
      f = m(u, ["className", "children", "isVisible", "excludeFromTabOrder"]);
  return i ? wo.createElement(c, n({
    className: LU(a.FieldGroupIcon, t),
    ref: C,
    tabIndex: o ? -1 : void 0
  }, f), r) : null;
}, "FieldGroupIconPrimitive"),
    xe = wo.forwardRef(vU);
xe.displayName = "FieldGroupIcon";
import * as Vo from "react";
import NU from "classnames";
var yU = s(function (f, o) {
  var C = f,
      t = C.children,
      r = C.className,
      i = m(C, ["children", "className"]);
  return Vo.createElement(xe, n({
    as: Z,
    className: NU(a.FieldGroupIconButton, r),
    ref: o
  }, i), t);
}, "FieldGroupIconButtonPrimitive"),
    M1 = Vo.forwardRef(yU);
M1.displayName = "FieldGroupIconButton";
var bU = i1.Fields.ariaLabel.clearField,
    ZU = s(function (t, r) {
  return ze.createElement(M1, n({
    ariaLabel: bU,
    ref: r
  }, t), ze.createElement(_e, {
    size: t.size
  }));
}, "FieldClearButtonPrimitive"),
    Ho = ze.forwardRef(ZU);
Ho.displayName = "FieldClearButton";
import * as Mr from "react";
import BU from "classnames";
var WU = "qa-field-description",
    a1 = s(function (o) {
  var f = o,
      t = f.descriptiveText,
      r = f.labelHidden,
      i = m(f, ["descriptiveText", "labelHidden"]);
  return t ? Mr.createElement(G, n({
    "data-testid": WU,
    className: BU(a.FieldDescription, _defineProperty({}, a.VisuallyHidden, r))
  }, i), t) : null;
}, "FieldDescription");
a1.displayName = "FieldDescription";
import * as xr from "react";
var $ = s(function (o) {
  var f = o,
      t = f.errorMessage,
      r = f.hasError,
      i = m(f, ["errorMessage", "hasError"]);
  return r && t ? xr.createElement(G, n({
    className: a.FieldErrorMessage
  }, i), t) : null;
}, "FieldErrorMessage");
$.displayName = "FieldErrorMessage";
var DU = s(function (d, w) {
  var V = d,
      t = V.className,
      r = V.errorMessage,
      _V$hasError = V.hasError,
      i = _V$hasError === void 0 ? !1 : _V$hasError,
      _V$labelHidden = V.labelHidden,
      o = _V$labelHidden === void 0 ? !1 : _V$labelHidden,
      f = V.labelPosition,
      C = V.testId,
      g = V.size,
      u = m(V, ["className", "errorMessage", "hasError", "labelHidden", "labelPosition", "testId", "size"]);
  var H = Me(C, a.Checkbox);
  return Ie.createElement(I, {
    className: kU(a.Field, a.CheckboxField, t),
    "data-size": g,
    testId: C
  }, Ie.createElement(uo, n({
    hasError: i,
    labelHidden: o,
    testId: H,
    labelPosition: f,
    ref: w
  }, u)), Ie.createElement($, {
    hasError: i,
    errorMessage: r
  }));
}, "CheckboxFieldPrimitive"),
    Mo = Ie.forwardRef(DU);
Mo.displayName = "CheckboxField";
import rz from "classnames";
import iz from "lodash/debounce";
import * as n1 from "react";
import * as xo from "react";
import PU from "classnames";
var SU = s(function (f, o) {
  var C = f,
      t = C.className,
      r = C.children,
      i = m(C, ["className", "children"]);
  return xo.createElement(c, n({
    className: PU(a.Grid, t),
    ref: o
  }, i), r);
}, "GridPrimitive"),
    Le = xo.forwardRef(SU);
Le.displayName = "Grid";
import * as Xe from "react";
import TU from "classnames";
import Io, { useMemo as FU } from "react";
var Et = {
  PaginationItem: {
    PreviousItem: {
      ariaLabel: "Go to previous page"
    },
    NextItem: {
      ariaLabel: "Go to next page"
    }
  }
};
import * as Ir from "react";
var ve = "...",
    Lr = s(function (t, r) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return Ir.useMemo(function () {
    var f = Math.max(t, 1),
        C = Math.max(i, 1),
        g = Math.max(f, r),
        u = 1,
        w = g,
        d = 5 + 2 * C;
    if (g < d) return Ee(1, g);
    var V = Math.max(f - C, u),
        H = Math.min(f + C, w),
        M = V > 2,
        x = H < w - 1;

    if (M && !x) {
      var v = 3 + 2 * C,
          b = Ee(w - v + 1, w);
      return [u, ve].concat(_toConsumableArray(b));
    }

    if (!M && x) {
      var _v2 = 3 + 2 * C;

      return [].concat(_toConsumableArray(Ee(u, _v2)), [ve, w]);
    }

    var L = Ee(V, H);
    return [u, ve].concat(_toConsumableArray(L), [ve, w]);
  }, [t, r, i]);
}, "useRange");
import * as X from "react";
var jU = "current",
    YU = "ellipsis",
    Ne = s(function (u) {
  var w = u,
      t = w.type,
      r = w.page,
      i = w.currentPage,
      o = w.isDisabled,
      f = w.onClick,
      C = w.ariaLabel,
      g = m(w, ["type", "page", "currentPage", "isDisabled", "onClick", "ariaLabel"]);
  var d = X.useCallback(function () {
    f(r, i);
  }, [r, i, f]),
      V = X.useCallback(function () {
    f();
  }, [f]),
      H = X.useCallback(function () {
    f();
  }, [f]);

  switch (t) {
    case "page":
      return X.createElement(c, {
        as: "li"
      }, r === i ? X.createElement(I, n({
        as: "span",
        className: a.PaginationItemCurrent,
        testId: jU
      }, g), X.createElement(e1, null, "Current Page:"), r) : X.createElement(Z, n({
        className: a.PaginationItemButton,
        size: "small",
        variation: "link",
        onClick: d,
        ariaLabel: C
      }, g), r));

    case "next":
      return X.createElement(c, {
        as: "li"
      }, X.createElement(Z, n({
        className: a.PaginationItemButton,
        size: "small",
        variation: "link",
        isDisabled: o,
        onClick: H,
        ariaLabel: C
      }, g), X.createElement(Bt, {
        size: "large"
      })));

    case "previous":
      return X.createElement(c, {
        as: "li"
      }, X.createElement(Z, n({
        className: a.PaginationItemButton,
        size: "small",
        variation: "link",
        isDisabled: o,
        onClick: V,
        ariaLabel: C
      }, g), X.createElement(Zt, {
        size: "large"
      })));

    case "ellipsis":
      return X.createElement(c, {
        as: "li"
      }, X.createElement(I, n({
        as: "span",
        className: a.PaginationItemEllipsis,
        testId: YU
      }, g), "\u2026"));

    default:
  }

  return X.createElement(c, {
    as: "li"
  });
}, "PaginationItem");
Ne.displayName = "PaginationItem";
var vr = s(function (t, r, i, o, f, C) {
  var g = Io.createElement(Ne, {
    type: "previous",
    key: "previous",
    currentPage: t,
    onClick: f,
    isDisabled: t <= 1,
    ariaLabel: Et.PaginationItem.PreviousItem.ariaLabel
  }),
      u = Io.createElement(Ne, {
    type: "next",
    key: "next",
    currentPage: t,
    onClick: o,
    isDisabled: t >= r,
    ariaLabel: Et.PaginationItem.NextItem.ariaLabel
  }),
      w = Lr(t, r, i),
      d = FU(function () {
    return w.map(function (V, H) {
      return V === ve ? Io.createElement(Ne, {
        type: "ellipsis",
        key: H === 1 ? "start-ellipsis" : "end-ellipsis"
      }) : Io.createElement(Ne, {
        key: V,
        type: "page",
        page: V,
        currentPage: t,
        onClick: C,
        ariaLabel: "Go to page ".concat(V)
      });
    });
  }, [w, t, C]);
  return [g].concat(_toConsumableArray(d), [u]);
}, "usePaginationItems");
var AU = s(function (d, w) {
  var V = d,
      t = V.className,
      _V$currentPage = V.currentPage,
      r = _V$currentPage === void 0 ? 1 : _V$currentPage,
      i = V.totalPages,
      o = V.siblingCount,
      f = V.onNext,
      C = V.onPrevious,
      g = V.onChange,
      u = m(V, ["className", "currentPage", "totalPages", "siblingCount", "onNext", "onPrevious", "onChange"]);
  var H = vr(r, i, o, f, C, g);
  return Xe.createElement(c, n({
    as: "nav",
    className: TU(a.Pagination, t),
    ref: w
  }, u), Xe.createElement(I, {
    as: "ol",
    justifyContent: "center",
    alignItems: "center",
    gap: "inherit"
  }, H));
}, "PaginationPrimitive"),
    ye = Xe.forwardRef(AU);
ye.displayName = "Pagination";
import * as R1 from "react";
var Ke = s(function (t) {
  var _t$currentPage = t.currentPage,
      r = _t$currentPage === void 0 ? 1 : _t$currentPage,
      i = t.totalPages,
      _t$siblingCount = t.siblingCount,
      o = _t$siblingCount === void 0 ? 1 : _t$siblingCount;
  r = Math.max(r, 1), o = Math.max(o, 1), i = Math.max(r, i);

  var _R1$useState = R1.useState(r),
      _R1$useState2 = _slicedToArray(_R1$useState, 2),
      f = _R1$useState2[0],
      C = _R1$useState2[1];

  R1.useEffect(function () {
    return C(r);
  }, [r, i]);
  var g = R1.useCallback(function () {
    f < i && C(f + 1);
  }, [f, i]),
      u = R1.useCallback(function () {
    f > 1 && C(f - 1);
  }, [f]),
      w = R1.useCallback(function (d, V) {
    C(d);
  }, []);
  return {
    currentPage: f,
    totalPages: i,
    siblingCount: o,
    onNext: g,
    onPrevious: u,
    onChange: w
  };
}, "usePagination");
import oz from "classnames";
import * as Ze from "react";
import * as qe from "react";
var EU = i1.SearchField.ariaLabel.search,
    OU = s(function (t, r) {
  return qe.createElement(M1, n({
    ariaLabel: EU,
    className: a.SearchFieldSearch,
    ref: r,
    type: "submit"
  }, t), qe.createElement(St, {
    size: t.size
  }));
}, "SearchFieldButtonPrimitive"),
    Ot = qe.forwardRef(OU);
Ot.displayName = "SearchFieldButton";
import * as b1 from "react";
import $U from "classnames";
import * as Y1 from "react";
import _U from "classnames";
var GU = s(function (d, w) {
  var V = d,
      t = V.children,
      r = V.className,
      i = V.innerEndComponent,
      o = V.innerStartComponent,
      _V$orientation = V.orientation,
      f = _V$orientation === void 0 ? "horizontal" : _V$orientation,
      C = V.outerEndComponent,
      g = V.outerStartComponent,
      u = m(V, ["children", "className", "innerEndComponent", "innerStartComponent", "orientation", "outerEndComponent", "outerStartComponent"]);
  var H = o != null,
      M = i != null,
      x = H ? a.FieldGroupHasInnerStart : null,
      L = M ? a.FieldGroupHasInnerEnd : null;
  return Y1.createElement(I, n({
    className: _U(a.FieldGroup, x, L, r),
    "data-orientation": f,
    ref: w
  }, u), g && Y1.createElement(c, {
    className: a.FieldGroupOuterStart
  }, g), Y1.createElement(c, {
    className: a.FieldGroupFieldWrapper,
    "data-orientation": f
  }, o && Y1.createElement(c, {
    className: a.FieldGroupInnerStart
  }, o), t, i && Y1.createElement(c, {
    className: a.FieldGroupInnerEnd
  }, i)), C && Y1.createElement(c, {
    className: a.FieldGroupOuterEnd
  }, C));
}, "FieldGroupPrimitive"),
    ee = Y1.forwardRef(GU);
ee.displayName = "FieldGroup";
import * as Lo from "react";
import UU from "classnames";
var zU = s(function (C, f) {
  var g = C,
      t = g.children,
      r = g.className,
      i = g.visuallyHidden,
      o = m(g, ["children", "className", "visuallyHidden"]);
  return Lo.createElement(c, n({
    as: "label",
    className: UU(a.Label, r, _defineProperty({}, a.VisuallyHidden, i)),
    ref: f
  }, o), t);
}, "LabelPrimitive"),
    R = Lo.forwardRef(zU);
R.displayName = "Label";
var Nr = s(function (t) {
  return t.isMultiline;
}, "isTextAreaField"),
    yr = s(function (t) {
  return !t.isMultiline;
}, "isInputField"),
    br = s(function (t, r) {
  return !t.isMultiline;
}, "isInputRef"),
    Zr = s(function (t, r) {
  return t.isMultiline;
}, "isTextAreaRef");
import * as vo from "react";
import XU from "classnames";
var KU = s(function (w, u) {
  var d = w,
      t = d.className,
      r = d.isReadOnly,
      i = d.isRequired,
      o = d.size,
      _d$hasError = d.hasError,
      f = _d$hasError === void 0 ? !1 : _d$hasError,
      C = d.variation,
      g = m(d, ["className", "isReadOnly", "isRequired", "size", "hasError", "variation"]);
  return vo.createElement(c, n({
    "aria-invalid": f,
    as: "textarea",
    className: XU(a.Textarea, a.FieldGroupControl, t),
    "data-size": o,
    "data-variation": C,
    readOnly: r,
    ref: u,
    required: i
  }, g));
}, "TextAreaPrimitive"),
    be = vo.forwardRef(KU);
be.displayName = "TextArea";
import * as _t from "react";
import * as Br from "react";
var Wr = Boolean(globalThis == null ? void 0 : globalThis.document) ? Br.useLayoutEffect : function () {};

var qU = "amplify-id",
    QU = _t["useId".toString()] || function () {},
    JU = 0,
    Y = s(function (t) {
  var _t$useState = _t.useState(QU()),
      _t$useState2 = _slicedToArray(_t$useState, 2),
      r = _t$useState2[0],
      i = _t$useState2[1];

  return Wr(function () {
    t || i(function (o) {
      return o != null ? o : String(JU++);
    });
  }, [t]), t || (r ? "".concat(qU, "-").concat(r) : "");
}, "useStableId");

var RU = 3,
    kr = s(function (t, r) {
  var ae = t,
      i = ae.className,
      o = ae.descriptiveText,
      f = ae.errorMessage,
      _ae$hasError = ae.hasError,
      C = _ae$hasError === void 0 ? !1 : _ae$hasError,
      g = ae.id,
      u = ae.label,
      _ae$labelHidden = ae.labelHidden,
      w = _ae$labelHidden === void 0 ? !1 : _ae$labelHidden,
      d = ae.outerEndComponent,
      V = ae.outerStartComponent,
      H = ae.innerStartComponent,
      M = ae.innerEndComponent,
      x = ae.isMultiline,
      L = ae.type,
      v = ae.size,
      b = ae.testId,
      y = ae.bottom,
      D = ae.height,
      B = ae.left,
      P = ae.padding,
      S = ae.position,
      j = ae.right,
      W = ae.top,
      k = ae.width,
      E = m(ae, ["className", "descriptiveText", "errorMessage", "hasError", "id", "label", "labelHidden", "outerEndComponent", "outerStartComponent", "innerStartComponent", "innerEndComponent", "isMultiline", "type", "size", "testId", "bottom", "height", "left", "padding", "position", "right", "top", "width"]),
      _ = Y(g),
      z = Y(),
      l1 = o ? z : void 0,
      _J2 = J(E),
      p1 = _J2.flexContainerStyleProps,
      Q1 = _J2.baseStyleProps,
      J1 = _J2.rest;

  l({
    shouldWarn: t.isMultiline,
    message: "TextField isMultiLine prop will be deprecated in next major release of @aws-amplify/ui-react. Please use TextAreaField component instead."
  });
  var j1 = null;

  if (Nr(t)) {
    var h1 = t.rows;
    j1 = b1.createElement(be, n(n({
      "aria-describedby": l1,
      hasError: C,
      id: _,
      ref: Zr(t, r) ? r : void 0,
      rows: h1 != null ? h1 : RU,
      size: v
    }, Q1), J1));
  } else if (yr(t)) {
    var _t$type = t.type,
        _h2 = _t$type === void 0 ? "text" : _t$type;

    j1 = b1.createElement(C1, n(n({
      "aria-describedby": l1,
      hasError: C,
      id: _,
      ref: br(t, r) ? r : void 0,
      size: v,
      type: _h2
    }, Q1), J1));
  }

  return b1.createElement(I, n({
    className: $U(a.Field, a.TextField, i),
    bottom: y,
    "data-size": v,
    height: D,
    left: B,
    padding: P,
    position: S,
    right: j,
    testId: b,
    top: W,
    width: k
  }, p1), b1.createElement(R, {
    htmlFor: _,
    visuallyHidden: w
  }, u), b1.createElement(a1, {
    id: z,
    labelHidden: w,
    descriptiveText: o
  }), b1.createElement(ee, {
    outerStartComponent: V,
    outerEndComponent: d,
    innerStartComponent: H,
    innerEndComponent: M
  }, j1), b1.createElement($, {
    hasError: C,
    errorMessage: f
  }));
}, "TextFieldPrimitive"),
    g1 = b1.forwardRef(kr);
kr.displayName = "TextField";
import * as Z1 from "react";
import * as Dr from "react";
var Pr = s(function (_ref13) {
  var t = _ref13.externalRef,
      r = _ref13.internalRef;
  return Dr.useCallback(function (i) {
    typeof t == "function" ? t(i) : t != null && (t.current = i), r.current = i;
  }, []);
}, "useComposeRefsCallback");
var Sr = "Escape",
    jr = "Enter",
    ez = new Set([Sr, jr]),
    Yr = s(function (_ref14) {
  var t = _ref14.onSubmit,
      r = _ref14.onClear,
      i = _ref14.externalRef;

  var _Z1$useState = Z1.useState(""),
      _Z1$useState2 = _slicedToArray(_Z1$useState, 2),
      o = _Z1$useState2[0],
      f = _Z1$useState2[1],
      C = Z1.useRef(null),
      g = Pr({
    externalRef: i,
    internalRef: C
  }),
      u = Z1.useCallback(function () {
    var M;
    f(""), (M = C == null ? void 0 : C.current) == null || M.focus(), O(r) && r();
  }, [f, r]),
      w = Z1.useCallback(function (M) {
    O(t) && t(M);
  }, [t]),
      d = Z1.useCallback(function (M) {
    var x = M.key;
    !ez.has(x) || (M.preventDefault(), x === Sr ? u() : x === jr && w(o));
  }, [o, u, w]),
      V = Z1.useCallback(function (M) {
    f(M.target.value);
  }, [f]),
      H = Z1.useCallback(function () {
    w(o);
  }, [w, o]);

  return {
    value: o,
    onClearHandler: u,
    onKeyDown: d,
    onInput: V,
    onClick: H,
    composedRefs: g
  };
}, "useSearchField");
var tz = s(function (V, d) {
  var H = V,
      _H$autoComplete = H.autoComplete,
      t = _H$autoComplete === void 0 ? "off" : _H$autoComplete,
      r = H.className,
      _H$labelHidden = H.labelHidden,
      i = _H$labelHidden === void 0 ? !0 : _H$labelHidden,
      _H$name = H.name,
      o = _H$name === void 0 ? "q" : _H$name,
      f = H.onSubmit,
      C = H.onClear,
      g = H.searchButtonRef,
      u = H.size,
      w = m(H, ["autoComplete", "className", "labelHidden", "name", "onSubmit", "onClear", "searchButtonRef", "size"]);

  var _Yr = Yr({
    onSubmit: f,
    onClear: C,
    externalRef: d
  }),
      M = _Yr.value,
      x = _Yr.onClearHandler,
      L = _Yr.onInput,
      v = _Yr.onKeyDown,
      b = _Yr.onClick,
      y = _Yr.composedRefs;

  return Ze.createElement(g1, n({
    autoComplete: t,
    className: oz(a.SearchField, r),
    labelHidden: i,
    innerEndComponent: Ze.createElement(Ho, {
      excludeFromTabOrder: !0,
      isVisible: ge(M),
      onClick: x,
      size: u,
      variation: "link"
    }),
    isMultiline: !1,
    name: o,
    onInput: L,
    onKeyDown: v,
    outerEndComponent: Ze.createElement(Ot, {
      onClick: b,
      ref: g,
      size: u
    }),
    ref: y,
    size: u,
    value: M
  }, w));
}, "SearchFieldPrimitive"),
    Be = Ze.forwardRef(tz);
Be.displayName = "SearchField";
var Fr = s(function (t, r, i) {
  if (r < 1 || i < 1) return [];
  var o = (r - 1) * i;
  return t.slice(o, o + i);
}, "getItemsAtPage"),
    Gt = s(function (t, r) {
  return ge(t) ? t.toLowerCase().includes(r.toLowerCase()) : typeof t == "object" && t !== null ? Object.values(t).some(function (i) {
    return Gt(i, r);
  }) : !1;
}, "itemHasText"),
    Tr = s(function (t, r) {
  return Math.ceil(t / r);
}, "getPageCount");
var sz = 10,
    az = 300,
    nz = s(function (f) {
  var C = f,
      t = C.children,
      _C$direction = C.direction,
      r = _C$direction === void 0 ? "column" : _C$direction,
      i = C.items,
      o = m(C, ["children", "direction", "items"]);
  return n1.createElement(I, n({
    direction: r
  }, o), Array.isArray(i) ? i.map(t) : null);
}, "ListCollection"),
    mz = s(function (o) {
  var f = o,
      t = f.children,
      r = f.items,
      i = m(f, ["children", "items"]);
  return n1.createElement(Le, n({}, i), Array.isArray(r) ? r.map(t) : null);
}, "GridCollection"),
    No = s(function (V) {
  var H = V,
      t = H.className,
      r = H.isSearchable,
      i = H.isPaginated,
      o = H.items,
      _H$itemsPerPage = H.itemsPerPage,
      f = _H$itemsPerPage === void 0 ? sz : _H$itemsPerPage,
      _H$searchFilter = H.searchFilter,
      C = _H$searchFilter === void 0 ? Gt : _H$searchFilter,
      g = H.searchPlaceholder,
      _H$type = H.type,
      u = _H$type === void 0 ? "list" : _H$type,
      w = H.testId,
      d = m(H, ["className", "isSearchable", "isPaginated", "items", "itemsPerPage", "searchFilter", "searchPlaceholder", "type", "testId"]);

  var _n1$useState = n1.useState(),
      _n1$useState2 = _slicedToArray(_n1$useState, 2),
      M = _n1$useState2[0],
      x = _n1$useState2[1],
      L = n1.useCallback(iz(x, az), [x]);

  o = Array.isArray(o) ? o : [], r && ge(M) && (o = o.filter(function (y) {
    return C(y, M);
  }));
  var v = Ke({
    totalPages: Tr(o.length, f)
  });
  i && (o = Fr(o, v.currentPage, f));
  var b = u === "list" ? n1.createElement(nz, n({
    className: a.CollectionItems,
    items: o
  }, d)) : u === "grid" ? n1.createElement(mz, n({
    className: a.CollectionItems,
    items: o
  }, d)) : null;
  return n1.createElement(I, {
    testId: w,
    className: rz(a.Collection, t)
  }, r ? n1.createElement(I, {
    className: a.CollectionSearch
  }, n1.createElement(Be, {
    label: i1.Collection.SearchFieldLabel,
    placeholder: g,
    onChange: function onChange(y) {
      return L(y.target.value);
    },
    onClear: function onClear() {
      return x("");
    }
  })) : null, b, i ? n1.createElement(I, {
    className: a.CollectionPagination
  }, n1.createElement(ye, n({}, v))) : null);
}, "Collection");
No.displayName = "Collection";
import cz from "classnames";
import * as yo from "react";
var lz = s(function (g, C) {
  var u = g,
      t = u.className,
      _u$orientation = u.orientation,
      r = _u$orientation === void 0 ? "horizontal" : _u$orientation,
      i = u.size,
      o = u.label,
      f = m(u, ["className", "orientation", "size", "label"]);
  return yo.createElement(c, n({
    "aria-orientation": r,
    as: "hr",
    className: cz(a.Divider, t, o ? a.DividerLabel : null),
    "data-size": i,
    "data-label": o,
    ref: C
  }, f));
}, "DividerPrimitive"),
    Ce = yo.forwardRef(lz);
Ce.displayName = "Divider";
import * as Qe from "react";
import { Root as Ar } from "@radix-ui/react-accordion";
import Er from "classnames";
var pz = s(function (H, V) {
  var M = H,
      t = M.children,
      r = M.className,
      i = M.defaultValue,
      o = M.isCollapsible,
      f = M.onChange,
      C = M.onValueChange,
      g = M.testId,
      _M$type2 = M.type,
      u = _M$type2 === void 0 ? "single" : _M$type2,
      w = M.value,
      d = m(M, ["children", "className", "defaultValue", "isCollapsible", "onChange", "onValueChange", "testId", "type", "value"]);

  var _J3 = J(d),
      x = _J3.rest;

  return u === "multiple" ? Qe.createElement(Ar, n({
    className: Er(a.Expander, r),
    "data-testid": g,
    defaultValue: i,
    onValueChange: f,
    ref: V,
    type: u,
    value: w
  }, x), t) : Qe.createElement(Ar, n({
    className: Er(a.Expander, r),
    collapsible: o,
    "data-testid": g,
    defaultValue: i,
    onValueChange: f,
    ref: V,
    type: u,
    value: w
  }, x), t);
}, "ExpanderPrimitive"),
    bo = Qe.forwardRef(pz);
bo.displayName = "Expander";
import * as F1 from "react";
import { Item as hz, Header as fz, Trigger as Cz, Content as gz } from "@radix-ui/react-accordion";
import uz from "classnames";
var wz = "expander-item",
    dz = "expander-header",
    Vz = "expander-icon",
    Hz = "expander-content-text",
    Mz = s(function (C, f) {
  var g = C,
      t = g.children,
      r = g.className,
      i = g.title,
      o = m(g, ["children", "className", "title"]);

  var u = Y(),
      w = Y(),
      _J4 = J(o),
      d = _J4.rest;

  return F1.createElement(hz, n({
    className: uz(a.ExpanderItem, r),
    "data-testid": wz,
    ref: f
  }, d), F1.createElement(fz, {
    className: a.ExpanderHeader,
    "data-testid": dz
  }, F1.createElement(Cz, {
    "aria-controls": w,
    className: a.ExpanderTrigger,
    id: u
  }, i, F1.createElement(Ge, {
    "aria-hidden": !0,
    className: a.ExpanderIcon,
    "data-testid": Vz
  }))), F1.createElement(gz, {
    "aria-labelledby": u,
    className: a.ExpanderContent,
    id: w
  }, F1.createElement(c, {
    className: a.ExpanderContentText,
    testId: Hz
  }, t)));
}, "ExpanderItemPrimitive"),
    Zo = F1.forwardRef(Mz);
Zo.displayName = "ExpanderItem";
import * as Bo from "react";
import xz from "classnames";
var Iz = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6"
},
    Lz = s(function (C, f) {
  var g = C,
      t = g.className,
      r = g.children,
      _g$level = g.level,
      i = _g$level === void 0 ? 6 : _g$level,
      o = m(g, ["className", "children", "level"]);
  return Bo.createElement(c, n({
    as: Iz[i],
    className: xz(a.Heading, t),
    ref: f
  }, o), r);
}, "HeadingPrimitive"),
    U = Bo.forwardRef(Lz);
U.displayName = "Heading";
import * as Wo from "react";
import vz from "classnames";
var Nz = s(function (o, i) {
  var f = o,
      t = f.className,
      r = m(f, ["className"]);
  return Wo.createElement(c, n({
    as: "img",
    ref: i,
    className: vz(a.Image, t)
  }, r));
}, "ImagePrimitive"),
    ko = Wo.forwardRef(Nz);
ko.displayName = "Image";
import * as Do from "react";
import yz from "classnames";
var bz = s(function (u, g) {
  var w = u,
      _w$as2 = w.as,
      t = _w$as2 === void 0 ? "a" : _w$as2,
      r = w.children,
      i = w.className,
      o = w.isExternal,
      f = w.to,
      C = m(w, ["as", "children", "className", "isExternal", "to"]);
  return Do.createElement(c, n({
    as: t,
    className: yz(a.Link, i),
    ref: g,
    rel: o ? "noopener noreferrer" : void 0,
    target: o ? "_blank" : void 0,
    to: f
  }, C), r);
}, "LinkPrimitive"),
    Po = Do.forwardRef(bz);
Po.displayName = "Link";
import * as T1 from "react";
import Or from "classnames";
import { DropdownMenu as Bz, DropdownMenuTrigger as Wz, DropdownMenuContent as kz } from "@radix-ui/react-dropdown-menu";
import * as So from "react";
import Zz from "classnames";
var oe = So.forwardRef(function (L, x) {
  var v = L,
      t = v.ariaLabel,
      r = v.className,
      i = v.children,
      _v$isFullWidth = v.isFullWidth,
      o = _v$isFullWidth === void 0 ? !1 : _v$isFullWidth,
      f = v.isDisabled,
      C = v.isLoading,
      _v$loadingText = v.loadingText,
      g = _v$loadingText === void 0 ? "" : _v$loadingText,
      u = v.size,
      w = v.style,
      _v$type = v.type,
      d = _v$type === void 0 ? "button" : _v$type,
      V = v.variation,
      H = v.testId,
      M = m(v, ["ariaLabel", "className", "children", "isFullWidth", "isDisabled", "isLoading", "loadingText", "size", "style", "type", "variation", "testId"]);

  var _ao2 = ao(M, w),
      b = _ao2.propStyles,
      y = _ao2.nonStyleProps;

  return So.createElement("button", n({
    ref: x,
    className: Zz(a.Button, r),
    "data-fullwidth": o,
    "data-loading": C,
    "data-size": u,
    "data-variation": V,
    disabled: f || C,
    type: d,
    "data-testid": H,
    "aria-label": t,
    style: b
  }, y), i);
});
oe.displayName = "MenuButton";
var Dz = "amplify-menu-trigger-test-id",
    Pz = "amplify-menu-items-group-test-id",
    Sz = s(function (H, V) {
  var M = H,
      _M$menuAlign = M.menuAlign,
      t = _M$menuAlign === void 0 ? "start" : _M$menuAlign,
      r = M.children,
      i = M.className,
      o = M.isOpen,
      f = M.size,
      C = M.trigger,
      g = M.triggerClassName,
      u = M.ariaLabel,
      w = M.onOpenChange,
      d = m(M, ["menuAlign", "children", "className", "isOpen", "size", "trigger", "triggerClassName", "ariaLabel", "onOpenChange"]);
  return T1.createElement(Bz, {
    onOpenChange: w,
    open: o
  }, T1.createElement(Wz, {
    asChild: !0
  }, C != null ? C : T1.createElement(oe, {
    ariaLabel: u,
    size: f,
    testId: Dz,
    className: Or(a.MenuTrigger, g)
  }, T1.createElement(Dt, {
    size: f
  }))), T1.createElement(kz, {
    align: t
  }, T1.createElement(He, n({
    className: Or(a.MenuContent, i),
    ref: V,
    size: f,
    testId: Pz
  }, d), r)));
}, "MenuPrimitive"),
    jo = T1.forwardRef(Sz);
jo.displayName = "Menu";
import * as Je from "react";
import jz from "classnames";
import { DropdownMenuItem as Yz } from "@radix-ui/react-dropdown-menu";
var Fz = "amplify-menu-item-test-id",
    Yo = Je.forwardRef(function (C, f) {
  var g = C,
      t = g.children,
      r = g.className,
      i = g.variation,
      o = m(g, ["children", "className", "variation"]);
  return Je.createElement(Yz, {
    asChild: !0,
    ref: f
  }, Je.createElement(oe, $1(n({
    className: jz(a.MenuItem, r),
    testId: Fz
  }, o), {
    variation: "menu"
  }), t));
});
Yo.displayName = "MenuItem";
import Az from "classnames";
import * as A1 from "react";
import * as We from "react";
var _r = i1.ShowPasswordButton.ariaLabel,
    Tz = s(function (f, o) {
  var C = f,
      t = C.fieldType,
      r = C.size,
      i = m(C, ["fieldType", "size"]);
  return We.createElement(Z, n({
    ariaLabel: t === "password" ? _r.showPassword : _r.hidePassword,
    className: a.FieldShowPassword,
    ref: o,
    size: r
  }, i), t === "password" ? We.createElement(Ft, {
    size: r
  }) : We.createElement(Yt, {
    size: r
  }));
}, "ShowPasswordButtonPrimitive"),
    Ut = We.forwardRef(Tz);
Ut.displayName = "ShowPasswordButton";
var Ez = s(function (w, u) {
  var d = w,
      _d$autoComplete = d.autoComplete,
      t = _d$autoComplete === void 0 ? "current-password" : _d$autoComplete,
      r = d.label,
      i = d.className,
      _d$hideShowPassword = d.hideShowPassword,
      o = _d$hideShowPassword === void 0 ? !1 : _d$hideShowPassword,
      f = d.showPasswordButtonRef,
      C = d.size,
      g = m(d, ["autoComplete", "label", "className", "hideShowPassword", "showPasswordButtonRef", "size"]);

  var _A1$useState = A1.useState("password"),
      _A1$useState2 = _slicedToArray(_A1$useState, 2),
      V = _A1$useState2[0],
      H = _A1$useState2[1],
      M = A1.useCallback(function () {
    H(V === "password" ? "text" : "password");
  }, [H, V]);

  return A1.createElement(g1, n({
    autoComplete: t,
    isMultiline: !1,
    outerEndComponent: o ? null : A1.createElement(Ut, {
      fieldType: V,
      onClick: M,
      ref: f,
      size: C
    }),
    size: C,
    type: V,
    label: r,
    className: Az(a.PasswordField, i),
    ref: u
  }, g));
}, "PasswordFieldPrimitive"),
    ke = A1.forwardRef(Ez);
ke.displayName = "PasswordField";
import * as $e from "react";
import Qz from "classnames";
import * as ne from "react";
import Xz from "classnames";
import { countryDialCodes as Kz } from "@aws-amplify/ui";
import * as E1 from "react";
import Gz from "classnames";
import * as te from "react";
import Oz from "classnames";

var _z = s(function (v, L) {
  var b = v,
      t = b.autoComplete,
      r = b.className,
      i = b.size,
      o = b.variation,
      f = b.value,
      C = b.defaultValue,
      g = b.hasError,
      _b$icon = b.icon,
      u = _b$icon === void 0 ? te.createElement(Ge, null) : _b$icon,
      w = b.iconColor,
      d = b.children,
      V = b.placeholder,
      H = b.isDisabled,
      M = b.isRequired,
      x = m(b, ["autoComplete", "className", "size", "variation", "value", "defaultValue", "hasError", "icon", "iconColor", "children", "placeholder", "isDisabled", "isRequired"]);
  var y = "",
      D = f === void 0 && C === void 0 && V;
  return te.createElement(c, {
    className: a.SelectWrapper
  }, te.createElement(c, n({
    "aria-invalid": g,
    as: "select",
    autoComplete: t,
    value: f,
    defaultValue: D ? y : C,
    isDisabled: H,
    required: M,
    "data-size": i,
    "data-variation": o,
    className: Oz(a.Select, a.FieldGroupControl, r),
    ref: L
  }, x), V && te.createElement("option", {
    value: ""
  }, V), d), te.createElement(I, {
    className: a.SelectIconWrapper,
    color: w
  }, u));
}, "SelectPrimitive"),
    Fo = te.forwardRef(_z);

Fo.displayName = "Select";
var Uz = s(function (_ref15) {
  var t = _ref15.children,
      r = _ref15.options;
  return t ? ((r == null ? void 0 : r.length) && console.warn("Amplify UI: <SelectField> component  defaults to rendering children over `options`. When using the `options` prop, omit children."), t) : r == null ? void 0 : r.map(function (i, o) {
    return E1.createElement("option", {
      label: i,
      value: i,
      key: "".concat(i, "-").concat(o)
    }, i);
  });
}, "selectFieldChildren"),
    zz = s(function (t, r) {
  var P = t,
      i = P.children,
      o = P.className,
      f = P.descriptiveText,
      C = P.errorMessage,
      _P$hasError = P.hasError,
      g = _P$hasError === void 0 ? !1 : _P$hasError,
      u = P.id,
      w = P.label,
      _P$labelHidden = P.labelHidden,
      d = _P$labelHidden === void 0 ? !1 : _P$labelHidden,
      V = P.options,
      H = P.size,
      M = P.testId,
      x = m(P, ["children", "className", "descriptiveText", "errorMessage", "hasError", "id", "label", "labelHidden", "options", "size", "testId"]),
      L = Y(u),
      v = Y(),
      b = f ? v : void 0,
      _J5 = J(x),
      y = _J5.flexContainerStyleProps,
      D = _J5.baseStyleProps,
      B = _J5.rest;

  return E1.createElement(I, n(n({
    className: Gz(a.Field, a.SelectField, o),
    "data-size": H,
    testId: M
  }, D), y), E1.createElement(R, {
    htmlFor: L,
    visuallyHidden: d
  }, w), E1.createElement(a1, {
    id: v,
    labelHidden: d,
    descriptiveText: f
  }), E1.createElement(Fo, n({
    "aria-describedby": b,
    hasError: g,
    id: L,
    ref: r,
    size: H
  }, B), Uz({
    children: i,
    options: V
  })), E1.createElement($, {
    hasError: g,
    errorMessage: C
  }));
}, "SelectFieldPrimitive"),
    De = E1.forwardRef(zz);
De.displayName = "SelectField";
var qz = s(function (f, o) {
  var C = f,
      t = C.className,
      r = C.dialCodeList,
      i = m(C, ["className", "dialCodeList"]);
  var g = r != null ? r : Kz,
      u = ne.useMemo(function () {
    return g.map(function (w) {
      return ne.createElement("option", {
        key: w,
        value: w
      }, w);
    });
  }, [g]);
  return ne.createElement(De, n({
    autoComplete: "tel-country-code",
    className: Xz(a.CountryCodeSelect, t),
    labelHidden: !0,
    ref: o
  }, i), u);
}, "CountryCodeSelectPrimitive"),
    zt = ne.forwardRef(qz);
zt.displayName = "CountryCodeSelect";
var Jz = s(function (b, v) {
  var y = b,
      _y$autoComplete = y.autoComplete,
      t = _y$autoComplete === void 0 ? "tel-national" : _y$autoComplete,
      r = y.className,
      i = y.countryCodeName,
      _y$countryCodeLabel = y.countryCodeLabel,
      o = _y$countryCodeLabel === void 0 ? i1.CountryCodeSelect.ariaLabel : _y$countryCodeLabel,
      f = y.defaultCountryCode,
      C = y.hasError,
      g = y.isDisabled,
      u = y.onCountryCodeChange,
      w = y.onInput,
      d = y.size,
      V = y.type,
      H = y.variation,
      M = y.countryCodeRef,
      x = y.dialCodeList,
      L = m(y, ["autoComplete", "className", "countryCodeName", "countryCodeLabel", "defaultCountryCode", "hasError", "isDisabled", "onCountryCodeChange", "onInput", "size", "type", "variation", "countryCodeRef", "dialCodeList"]);
  return $e.createElement(g1, n({
    outerStartComponent: $e.createElement(zt, {
      defaultValue: f,
      dialCodeList: x,
      className: r,
      hasError: C,
      isDisabled: g,
      label: o,
      name: i,
      onChange: u,
      ref: M,
      size: d,
      variation: H
    }),
    autoComplete: t,
    className: Qz(a.PhoneNumberField, r),
    hasError: C,
    isDisabled: g,
    isMultiline: !1,
    onInput: w,
    ref: v,
    size: d,
    type: "tel",
    variation: H
  }, L));
}, "PhoneNumberFieldPrimitive"),
    Pe = $e.forwardRef(Jz);
Pe.displayName = "PhoneNumberField";
import * as me from "react";
import $z from "classnames";
var Rz = s(function (g, C) {
  var u = g,
      t = u.className,
      r = u.children,
      i = u.isLoaded,
      o = u.size,
      f = m(u, ["className", "children", "isLoaded", "size"]);
  return i ? me.createElement(me.Fragment, null, r) : me.createElement(c, n({
    className: $z(a.Placeholder, t),
    "data-size": o,
    ref: C
  }, f));
}, "PlaceholderPrimitive"),
    To = me.forwardRef(Rz);
To.displayName = "Placeholder";
import * as ce from "react";
import Ur from "classnames";
import eX, { useContext as oX } from "react";
var tX = {
  name: "default"
},
    Xt = eX.createContext(tX),
    Gr = s(function () {
  return oX(Xt);
}, "useRadioGroupContext");
var rX = s(function (y, b) {
  var D = y,
      t = D.children,
      r = D.className,
      i = D.id,
      o = D.isDisabled,
      f = D.testId,
      C = D.value,
      g = D.labelPosition,
      u = D.height,
      w = D.width,
      d = D.bottom,
      V = D.left,
      H = D.position,
      M = D.padding,
      x = D.right,
      L = D.top,
      v = m(D, ["children", "className", "id", "isDisabled", "testId", "value", "labelPosition", "height", "width", "bottom", "left", "position", "padding", "right", "top"]);

  var _Gr = Gr(),
      B = _Gr.currentValue,
      P = _Gr.defaultValue,
      S = _Gr.name,
      j = _Gr.hasError,
      W = _Gr.isGroupDisabled,
      k = _Gr.isRequired,
      E = _Gr.isReadOnly,
      _ = _Gr.onChange,
      z = _Gr.size,
      l1 = _Gr.labelPosition,
      p1 = W || o || E && P !== C,
      Q1 = B !== void 0 ? C === B : void 0,
      J1 = P !== void 0 ? C === P : void 0,
      j1 = g || l1;

  return ce.createElement(I, {
    as: "label",
    className: Ur(a.Radio, r),
    "data-disabled": p1,
    "data-label-position": j1,
    width: w,
    bottom: d,
    top: L,
    right: x,
    left: V,
    position: H,
    padding: M
  }, t && ce.createElement(G, {
    as: "span",
    className: a.RadioLabel,
    "data-disabled": p1
  }, t), ce.createElement(C1, n({
    checked: Q1,
    className: Ur(a.VisuallyHidden, a.RadioInput),
    defaultChecked: J1,
    hasError: j,
    id: i,
    isDisabled: p1,
    isReadOnly: E,
    isRequired: k,
    onChange: _,
    ref: b,
    type: "radio",
    name: S,
    value: C
  }, v)), ce.createElement(I, {
    "aria-hidden": "true",
    as: "span",
    className: a.RadioButton,
    "data-size": z,
    testId: f
  }));
}, "RadioPrimitive"),
    Se = ce.forwardRef(rX);
Se.displayName = "Radio";
import * as x1 from "react";
import iX from "classnames";
var sX = s(function (B, D) {
  var P = B,
      t = P.children,
      r = P.className,
      i = P.defaultValue,
      o = P.descriptiveText,
      f = P.errorMessage,
      _P$hasError2 = P.hasError,
      C = _P$hasError2 === void 0 ? !1 : _P$hasError2,
      g = P.id,
      u = P.isDisabled,
      w = P.isRequired,
      d = P.isReadOnly,
      V = P.label,
      _P$labelHidden2 = P.labelHidden,
      H = _P$labelHidden2 === void 0 ? !1 : _P$labelHidden2,
      M = P.labelPosition,
      x = P.onChange,
      L = P.name,
      v = P.size,
      b = P.value,
      y = m(P, ["children", "className", "defaultValue", "descriptiveText", "errorMessage", "hasError", "id", "isDisabled", "isRequired", "isReadOnly", "label", "labelHidden", "labelPosition", "onChange", "name", "size", "value"]);
  var S = Y(g),
      j = Y(),
      W = Y(),
      k = o ? W : void 0,
      E = x1.useMemo(function () {
    return {
      currentValue: b,
      defaultValue: i,
      hasError: C,
      isRequired: w,
      isReadOnly: d,
      isGroupDisabled: u,
      onChange: x,
      size: v,
      name: L,
      labelPosition: M
    };
  }, [i, C, u, w, d, x, v, L, b, M]);
  return x1.createElement(I, n({
    className: iX(a.Field, a.RadioGroupField, r),
    "data-size": v,
    ref: D
  }, y), x1.createElement(R, {
    id: j,
    visuallyHidden: H
  }, V), x1.createElement(a1, {
    id: W,
    labelHidden: H,
    descriptiveText: o
  }), x1.createElement(I, {
    "aria-describedby": k,
    "aria-labelledby": j,
    className: a.RadioGroup,
    id: S,
    role: "radiogroup"
  }, x1.createElement(Xt.Provider, {
    value: E
  }, t)), x1.createElement($, {
    hasError: C,
    errorMessage: f
  }));
}, "RadioGroupFieldPrimitive"),
    je = x1.forwardRef(sX);
je.displayName = "RadioGroupField";
import * as O1 from "react";
import nX from "classnames";
var zr = s(function (t, r) {
  return t <= r;
}, "isIconFilled"),
    Xr = s(function (t, r) {
  return t - 1 >= r;
}, "isIconEmpty"),
    Kr = s(function (t, r) {
  return t > r && t - 1 < r;
}, "isIconMixed");
import * as Kt from "react";
import aX from "classnames";
var Ao = s(function (_ref16) {
  var t = _ref16.icon,
      r = _ref16.fill,
      i = _ref16.className;
  return Kt.createElement(c, {
    as: "span",
    className: "amplify-rating-icon-container"
  }, Kt.createElement(c, {
    as: "span",
    className: aX(i),
    color: r
  }, t));
}, "RatingIcon");
Ao.displayName = "RatingIcon";
import qr from "classnames";
var qt = s(function (_ref17) {
  var t = _ref17.emptyColor,
      r = _ref17.emptyIcon,
      i = _ref17.fillColor,
      o = _ref17.fillIcon,
      f = _ref17.value;
  var C = "".concat(f % 1 * 100, "%");
  return e.createElement(c, {
    as: "span",
    className: "amplify-rating-icon-container"
  }, e.createElement(c, {
    as: "span",
    className: "amplify-rating-label"
  }, e.createElement(c, {
    as: "span",
    className: qr("amplify-rating-icon", "amplify-rating-icon-empty"),
    color: t
  }, r)), e.createElement(c, {
    as: "span",
    className: "amplify-rating-label",
    width: C
  }, e.createElement(c, {
    as: "span",
    className: qr("amplify-rating-icon", "amplify-rating-icon-filled"),
    color: i
  }, o)));
}, "RatingMixedIcon");
qt.displayName = "RatingMixedIcon";
var mX = 5,
    cX = 0,
    lX = s(function (V, d) {
  var H = V,
      t = H.className,
      r = H.emptyColor,
      i = H.emptyIcon,
      o = H.fillColor,
      _H$icon = H.icon,
      f = _H$icon === void 0 ? O1.createElement(jt, null) : _H$icon,
      _H$maxValue = H.maxValue,
      C = _H$maxValue === void 0 ? mX : _H$maxValue,
      g = H.size,
      _H$value = H.value,
      u = _H$value === void 0 ? cX : _H$value,
      w = m(H, ["className", "emptyColor", "emptyIcon", "fillColor", "icon", "maxValue", "size", "value"]);
  var M = new Array(Math.ceil(C)).fill(1).map(function (x, L) {
    var v = L + 1;
    if (zr(v, u)) return O1.createElement(Ao, {
      key: L.toString(),
      icon: f,
      fill: o,
      className: "amplify-rating-icon-filled"
    });
    if (Xr(v, u)) return O1.createElement(Ao, {
      key: L.toString(),
      icon: i || f,
      fill: r,
      className: "amplify-rating-icon-empty"
    });
    if (Kr(v, u)) return O1.createElement(qt, {
      key: L.toString(),
      fillIcon: f,
      emptyIcon: i || f,
      value: u,
      fillColor: o,
      emptyColor: r
    });
  });
  return O1.createElement(I, n({
    className: nX(a.Rating, t),
    "data-size": g,
    ref: d
  }, w), M, O1.createElement(e1, null, u, " out of ", C, " rating"));
}, "RatingPrimitive"),
    Eo = O1.forwardRef(lX);
Eo.displayName = "Rating";
import * as Oo from "react";
import pX from "classnames";

var hX = s(function (C, f) {
  var g = C,
      t = g.children,
      r = g.className,
      i = g.orientation,
      o = m(g, ["children", "className", "orientation"]);
  return Oo.createElement(c, n({
    className: pX(a.ScrollView, r),
    "data-orientation": i,
    ref: f
  }, o), t);
}, "ScrollViewPrimitive"),
    _o = Oo.forwardRef(hX);

_o.displayName = "ScrollView";
import Qr from "classnames";
import { Range as fX, Root as CX, Thumb as gX, Track as uX } from "@radix-ui/react-slider";
import * as K from "react";
var wX = "slider-label",
    dX = "slider-root",
    VX = "slider-track",
    HX = "slider-range",
    MX = s(function (E, k) {
  var _ = E,
      t = _.ariaValuetext,
      r = _.className,
      i = _.defaultValue,
      o = _.descriptiveText,
      f = _.emptyTrackColor,
      C = _.errorMessage,
      g = _.filledTrackColor,
      _$hasError2 = _.hasError,
      u = _$hasError2 === void 0 ? !1 : _$hasError2,
      w = _.id,
      d = _.isDisabled,
      _$isValueHidden = _.isValueHidden,
      V = _$isValueHidden === void 0 ? !1 : _$isValueHidden,
      H = _.label,
      _$labelHidden = _.labelHidden,
      M = _$labelHidden === void 0 ? !1 : _$labelHidden,
      x = _.onChange,
      _$orientation = _.orientation,
      L = _$orientation === void 0 ? "horizontal" : _$orientation,
      v = _.outerEndComponent,
      b = _.outerStartComponent,
      y = _.testId,
      D = _.thumbColor,
      B = _.trackSize,
      P = _.dir,
      S = _.value,
      j = _.size,
      W = m(_, ["ariaValuetext", "className", "defaultValue", "descriptiveText", "emptyTrackColor", "errorMessage", "filledTrackColor", "hasError", "id", "isDisabled", "isValueHidden", "label", "labelHidden", "onChange", "orientation", "outerEndComponent", "outerStartComponent", "testId", "thumbColor", "trackSize", "dir", "value", "size"]);

  var z = Y(w),
      l1 = Y(),
      p1 = Y(),
      Q1 = o ? p1 : void 0,
      _J6 = J(W),
      J1 = _J6.flexContainerStyleProps,
      j1 = _J6.baseStyleProps,
      ae = _J6.rest,
      h1 = S !== void 0,
      _K$useState = K.useState(h1 ? S : i),
      _K$useState2 = _slicedToArray(_K$useState, 2),
      ct = _K$useState2[0],
      lt = _K$useState2[1],
      pt = h1 ? [S] : void 0,
      ht = h1 ? void 0 : [i],
      ft = K.useCallback(function (Fe) {
    lt(Fe[0]), O(x) && x(Fe[0]);
  }, [x]),
      Ct = L === "vertical";

  return K.createElement(I, n(n({
    className: Qr(a.Field, a.SliderField),
    testId: y,
    "data-size": j
  }, j1), J1), K.createElement(R, {
    className: a.SliderFieldLabel,
    id: l1,
    testId: wX,
    visuallyHidden: M
  }, K.createElement(c, {
    as: "span"
  }, H), V ? null : K.createElement(c, {
    as: "span"
  }, ct)), K.createElement(a1, {
    id: p1,
    labelHidden: M,
    descriptiveText: o
  }), K.createElement(ee, {
    className: a.SliderFieldGroup,
    id: z,
    orientation: L,
    outerStartComponent: b,
    outerEndComponent: v
  }, K.createElement(CX, n({
    className: Qr(a.SliderFieldRoot, r),
    "data-testid": dX,
    disabled: d,
    defaultValue: ht,
    onValueChange: ft,
    orientation: L,
    ref: k,
    value: pt
  }, ae), K.createElement(uX, {
    className: a.SliderFieldTrack,
    "data-testid": VX,
    style: _defineProperty({
      backgroundColor: f
    }, "".concat(Ct ? "width" : "height"), B)
  }, K.createElement(fX, {
    className: a.SliderFieldRange,
    "data-testid": HX,
    style: {
      backgroundColor: g
    }
  })), K.createElement(gX, {
    "aria-describedby": Q1,
    "aria-labelledby": l1,
    "aria-valuetext": t,
    className: a.SliderFieldThumb,
    style: {
      backgroundColor: D
    }
  }))), K.createElement($, {
    hasError: u,
    errorMessage: C
  }));
}, "SliderFieldPrimitive"),
    Go = K.forwardRef(MX);
Go.displayName = "SliderField";
import * as o1 from "react";
import xX from "classnames";
import * as _1 from "react";
var Qt = s(function (t, r, i, o) {
  var f = (o - t) % i;
  return o = o - f + Math.round(f / i) * i, o = Math.max(t, o), o > r && (o = r - (r - t) % i), o;
}, "getCorrectSteppingValue"),
    Jr = s(function (_ref18) {
  var _ref18$defaultValue = _ref18.defaultValue,
      t = _ref18$defaultValue === void 0 ? 0 : _ref18$defaultValue,
      r = _ref18.value,
      _ref18$step = _ref18.step,
      i = _ref18$step === void 0 ? 1 : _ref18$step,
      _ref18$max = _ref18.max,
      o = _ref18$max === void 0 ? Number.MAX_SAFE_INTEGER : _ref18$max,
      _ref18$min = _ref18.min,
      f = _ref18$min === void 0 ? Number.MIN_SAFE_INTEGER : _ref18$min,
      C = _ref18.isDisabled,
      g = _ref18.isReadOnly,
      u = _ref18.onDecrease,
      w = _ref18.onIncrease,
      d = _ref18.onStepChange;
  var V = r !== void 0;
  o = Math.max(f, o);

  var _$useState = _1.useState(function () {
    return Qt(f, o, i, t);
  }),
      _$useState2 = _slicedToArray(_$useState, 2),
      H = _$useState2[0],
      M = _$useState2[1];

  V && (r = Qt(f, o, i, r));

  var x = V ? r : H,
      L = C || g || x + i > o,
      v = C || g || x - i < f,
      _$useState3 = _1.useState(x),
      _$useState4 = _slicedToArray(_$useState3, 2),
      b = _$useState4[0],
      y = _$useState4[1],
      D = _1.useCallback(function (W) {
    y(W.target.value);
  }, []),
      B = _1.useCallback(function (W) {
    var k = parseFloat(W.target.value);
    isNaN(k) || (k = Qt(f, o, i, k), V || M(k), O(d) && d(k), y(k));
  }, [f, o, i, V, d]),
      P = _1.useCallback(function () {
    V || M(x + i), O(d) && d(x + i), O(w) && w(), y(x + i);
  }, [i, x, V, w, d]),
      S = _1.useCallback(function () {
    V || M(x - i), O(d) && d(x - i), O(u) && u(), y(x - i);
  }, [i, x, V, u, d]),
      j = _1.useCallback(function (W) {
    W.currentTarget.blur();
  }, []);

  return {
    step: i,
    value: x,
    inputValue: b,
    handleDecrease: S,
    handleIncrease: P,
    handleOnBlur: B,
    handleOnChange: D,
    handleOnWheel: j,
    setInputValue: y,
    shouldDisableDecreaseButton: v,
    shouldDisableIncreaseButton: L
  };
}, "useStepper");
var IX = "decrease-icon",
    LX = "increase-icon",
    vX = s(function (t, r) {
  var rr = t,
      i = rr.className,
      o = rr.descriptiveText,
      f = rr.defaultValue,
      C = rr.errorMessage,
      _rr$hasError = rr.hasError,
      g = _rr$hasError === void 0 ? !1 : _rr$hasError,
      u = rr.id,
      w = rr.isDisabled,
      d = rr.isReadOnly,
      V = rr.isRequired,
      H = rr.label,
      _rr$labelHidden = rr.labelHidden,
      M = _rr$labelHidden === void 0 ? !1 : _rr$labelHidden,
      x = rr.onStepChange,
      L = rr.size,
      v = rr.variation,
      b = rr.testId,
      y = rr.bottom,
      D = rr.height,
      B = rr.left,
      P = rr.padding,
      S = rr.position,
      j = rr.right,
      W = rr.top,
      k = rr.width,
      E = rr.value,
      _ = m(rr, ["className", "descriptiveText", "defaultValue", "errorMessage", "hasError", "id", "isDisabled", "isReadOnly", "isRequired", "label", "labelHidden", "onStepChange", "size", "variation", "testId", "bottom", "height", "left", "padding", "position", "right", "top", "width", "value"]),
      z = Y(u),
      l1 = Y(),
      p1 = o ? l1 : void 0,
      _J7 = J(_),
      Q1 = _J7.baseStyleProps,
      J1 = _J7.flexContainerStyleProps,
      j1 = _J7.rest,
      _Jr = Jr(t),
      ae = _Jr.step,
      h1 = _Jr.value,
      ct = _Jr.inputValue,
      lt = _Jr.handleDecrease,
      pt = _Jr.handleIncrease,
      ht = _Jr.handleOnBlur,
      ft = _Jr.handleOnChange,
      Ct = _Jr.handleOnWheel,
      Fe = _Jr.setInputValue,
      Ii = _Jr.shouldDisableDecreaseButton,
      Li = _Jr.shouldDisableIncreaseButton;

  return o1.useEffect(function () {
    E !== void 0 && Fe(E);
  }, [E, Fe]), o1.createElement(I, n({
    className: xX(a.Field, a.StepperField, i),
    "data-size": L,
    "data-variation": v,
    testId: b,
    width: k,
    height: D,
    position: S,
    padding: P,
    top: W,
    right: j,
    left: B,
    bottom: y
  }, J1), o1.createElement(R, {
    htmlFor: z,
    visuallyHidden: M
  }, H), o1.createElement(a1, {
    id: l1,
    labelHidden: M,
    descriptiveText: o
  }), o1.createElement(ee, {
    outerStartComponent: o1.createElement(M1, {
      "aria-controls": z,
      ariaLabel: "".concat(i1.StepperField.ariaLabel.DecreaseTo, " ").concat(h1 - ae),
      className: a.StepperFieldButtonDecrease,
      "data-invalid": g,
      isDisabled: Ii,
      onClick: lt,
      size: L
    }, o1.createElement(Pt, {
      "data-testid": IX
    })),
    outerEndComponent: o1.createElement(M1, {
      "aria-controls": z,
      ariaLabel: "".concat(i1.StepperField.ariaLabel.IncreaseTo, " ").concat(h1 + ae),
      className: a.StepperFieldButtonIncrease,
      "data-invalid": g,
      isDisabled: Li,
      onClick: pt,
      size: L
    }, o1.createElement(Nt, {
      "data-testid": LX
    }))
  }, o1.createElement(C1, n(n({
    "aria-describedby": p1,
    className: a.StepperFieldInput,
    hasError: g,
    id: z,
    isDisabled: w,
    isReadOnly: d,
    isRequired: V,
    onBlur: ht,
    onChange: ft,
    onWheel: Ct,
    ref: r,
    size: L,
    variation: v,
    type: "number",
    value: ct
  }, Q1), j1))), o1.createElement($, {
    hasError: g,
    errorMessage: C
  }));
}, "StepperFieldPrimitive"),
    Uo = o1.forwardRef(vX);
Uo.displayName = "StepperField";
import * as B1 from "react";
import yX from "classnames";
import { useCallback as NX, useState as $r } from "react";
var Rr = s(function (t) {
  var r = t.onChange,
      i = t.isChecked,
      o = t.defaultChecked,
      f = t.isDisabled,
      C = typeof i != "undefined",
      _$r = $r(C ? i : o),
      _$r2 = _slicedToArray(_$r, 2),
      g = _$r2[0],
      u = _$r2[1],
      _$r3 = $r(!1),
      _$r4 = _slicedToArray(_$r3, 2),
      w = _$r4[0],
      d = _$r4[1],
      V = NX(function (H) {
    if (f) {
      H.preventDefault();
      return;
    }

    typeof r == "function" && r(H), u(H.target.checked);
  }, [r, f]);

  return C && g !== i && u(i), {
    isOn: g,
    changeHandler: V,
    isFocused: w,
    setIsFocused: d
  };
}, "useSwitch");
var bX = s(function (y, b) {
  var D = y,
      t = D.className,
      r = D.defaultChecked,
      i = D.id,
      o = D.isChecked,
      f = D.isDisabled,
      C = D.isLabelHidden,
      g = D.label,
      u = D.labelPosition,
      w = D.name,
      d = D.onChange,
      V = D.size,
      H = D.thumbColor,
      M = D.trackCheckedColor,
      x = D.trackColor,
      L = D.value,
      v = m(D, ["className", "defaultChecked", "id", "isChecked", "isDisabled", "isLabelHidden", "label", "labelPosition", "name", "onChange", "size", "thumbColor", "trackCheckedColor", "trackColor", "value"]);

  var _Rr = Rr({
    onChange: d,
    isChecked: o,
    defaultChecked: r,
    isDisabled: f
  }),
      B = _Rr.isOn,
      P = _Rr.changeHandler,
      S = _Rr.isFocused,
      j = _Rr.setIsFocused,
      W = Y(i),
      k = C ? e1 : c;

  return B1.createElement(I, n({
    className: yX(a.SwitchField, t),
    "data-size": V,
    "data-label-position": u,
    ref: b
  }, v), B1.createElement(e1, null, B1.createElement(C1, {
    role: "switch",
    type: "checkbox",
    id: W,
    onChange: P,
    disabled: f,
    name: w,
    checked: B,
    value: L,
    onFocus: function onFocus() {
      j(!0);
    },
    onBlur: function onBlur() {
      j(!1);
    }
  })), B1.createElement(R, {
    htmlFor: W,
    className: a.SwitchWrapper,
    "data-label-position": u
  }, B1.createElement(k, {
    as: "span",
    className: a.SwitchLabel
  }, g), B1.createElement(c, {
    as: "span",
    className: a.SwitchTrack,
    "data-checked": B,
    "data-disabled": f,
    "data-focused": S,
    backgroundColor: B ? M : x
  }, B1.createElement(c, {
    as: "span",
    className: a.SwitchThumb,
    "data-checked": B,
    "data-disabled": f,
    backgroundColor: H
  }))));
}, "SwitchFieldPrimitive"),
    zo = B1.forwardRef(bX);
zo.displayName = "SwitchField";
import * as Re from "react";
import ZX from "classnames";
var BX = s(function (w, u) {
  var d = w,
      t = d.caption,
      r = d.children,
      i = d.className,
      _d$highlightOnHover = d.highlightOnHover,
      o = _d$highlightOnHover === void 0 ? !1 : _d$highlightOnHover,
      f = d.size,
      C = d.variation,
      g = m(d, ["caption", "children", "className", "highlightOnHover", "size", "variation"]);
  return Re.createElement(c, n({
    as: "table",
    className: ZX(a.Table, i),
    "data-highlightonhover": o,
    "data-size": f,
    "data-variation": C,
    ref: u
  }, g), t && Re.createElement(c, {
    as: "caption",
    className: a.TableCaption
  }, t), r);
}, "TablePrimitive"),
    ei = Re.forwardRef(BX);
ei.displayName = "Table";
import * as Xo from "react";
import WX from "classnames";
var kX = s(function (f, o) {
  var C = f,
      t = C.children,
      r = C.className,
      i = m(C, ["children", "className"]);
  return Xo.createElement(c, n({
    as: "tbody",
    className: WX(a.TableBody, r),
    ref: o
  }, i), t);
}, "TableBodyPrimitive"),
    oi = Xo.forwardRef(kX);
oi.displayName = "TableBody";
import * as Ko from "react";
import DX from "classnames";
var PX = s(function (C, f) {
  var g = C,
      _g$as2 = g.as,
      t = _g$as2 === void 0 ? "td" : _g$as2,
      r = g.children,
      i = g.className,
      o = m(g, ["as", "children", "className"]);
  return Ko.createElement(c, n({
    as: t,
    className: DX(t === "td" ? a.TableTd : a.TableTh, i),
    ref: f
  }, o), r);
}, "TableCellPrimitive"),
    ti = Ko.forwardRef(PX);
ti.displayName = "TableCell";
import * as qo from "react";
import SX from "classnames";
var jX = s(function (f, o) {
  var C = f,
      t = C.children,
      r = C.className,
      i = m(C, ["children", "className"]);
  return qo.createElement(c, n({
    as: "tfoot",
    className: SX(a.TableFoot, r),
    ref: o
  }, i), t);
}, "TableFootPrimitive"),
    ri = qo.forwardRef(jX);
ri.displayName = "TableFoot";
import * as Qo from "react";
import YX from "classnames";
var FX = s(function (f, o) {
  var C = f,
      t = C.children,
      r = C.className,
      i = m(C, ["children", "className"]);
  return Qo.createElement(c, n({
    as: "thead",
    className: YX(a.TableHead, r),
    ref: o
  }, i), t);
}, "TableHeadPrimitive"),
    ii = Qo.forwardRef(FX);
ii.displayName = "TableHead";
import TX from "classnames";
import * as Jo from "react";
var AX = s(function (f, o) {
  var C = f,
      t = C.children,
      r = C.className,
      i = m(C, ["children", "className"]);
  return Jo.createElement(c, n({
    as: "tr",
    className: TX(a.TableRow, r),
    ref: o
  }, i), t);
}, "TableRowPrimitive"),
    si = Jo.forwardRef(AX);
si.displayName = "TableRow";
import ai from "classnames";
import { Root as EX, List as OX, Trigger as _X, Content as GX } from "@radix-ui/react-tabs";
import * as m1 from "react";
var ni = s(function (t) {
  return t !== null && typeof t == "object" && t.hasOwnProperty("props") && t.props.title != null;
}, "isTabsType"),
    UX = s(function (V, d) {
  var H = V,
      t = H.ariaLabel,
      r = H.children,
      i = H.className,
      _H$defaultIndex = H.defaultIndex,
      o = _H$defaultIndex === void 0 ? 0 : _H$defaultIndex,
      f = H.currentIndex,
      C = H.onChange,
      g = H.indicatorPosition,
      u = H.spacing,
      w = m(H, ["ariaLabel", "children", "className", "defaultIndex", "currentIndex", "onChange", "indicatorPosition", "spacing"]);
  var M = m1.Children.map(r, function (L) {
    return L === null ? {} : typeof L == "string" && /\s/.test(L) ? {} : ni(L) ? L.props : (console.warn("Amplify UI: <Tabs> component only accepts <TabItem> as children."), {});
  }),
      x = {
    defaultValue: o.toString(),
    value: f != null ? f.toString() : void 0,
    onValueChange: C
  };
  return m1.createElement(EX, n({}, x), m1.createElement(OX, {
    "aria-label": t
  }, m1.createElement(I, n({
    className: ai(a.Tabs, i),
    "data-indicator-position": g,
    ref: d
  }, w), m1.Children.map(r, function (L, v) {
    var _m1$cloneElement;

    return ni(L) ? m1.cloneElement(L, (_m1$cloneElement = {}, _defineProperty(_m1$cloneElement, "data-spacing", u), _defineProperty(_m1$cloneElement, "key", v), _defineProperty(_m1$cloneElement, "value", "".concat(v)), _m1$cloneElement)) : null;
  }))), M.map(function (L, v) {
    return m1.createElement(GX, {
      key: v,
      value: "".concat(v)
    }, L.children);
  }));
}, "TabsPrimitive"),
    zX = s(function (f, o) {
  var C = f,
      t = C.className,
      r = C.title,
      i = m(C, ["className", "title"]);
  return m1.createElement(c, n({
    as: _X,
    className: ai(a.TabItems, t),
    ref: o
  }, i), r);
}, "TabItemPrimitive"),
    Ye = m1.forwardRef(UX),
    le = m1.forwardRef(zX);
Ye.displayName = "Tabs";
le.displayName = "TabItem";
import * as re from "react";
import XX from "classnames";
var KX = 3,
    qX = s(function (t, r) {
  var z = t,
      i = z.className,
      o = z.descriptiveText,
      f = z.errorMessage,
      _z$hasError = z.hasError,
      C = _z$hasError === void 0 ? !1 : _z$hasError,
      g = z.id,
      u = z.label,
      _z$labelHidden = z.labelHidden,
      w = _z$labelHidden === void 0 ? !1 : _z$labelHidden,
      d = z.rows,
      V = z.size,
      H = z.testId,
      M = z.bottom,
      x = z.height,
      L = z.left,
      v = z.padding,
      b = z.position,
      y = z.right,
      D = z.top,
      B = z.width,
      P = m(z, ["className", "descriptiveText", "errorMessage", "hasError", "id", "label", "labelHidden", "rows", "size", "testId", "bottom", "height", "left", "padding", "position", "right", "top", "width"]),
      S = Y(g),
      j = Y(),
      W = o ? j : void 0,
      _J8 = J(P),
      k = _J8.flexContainerStyleProps,
      E = _J8.baseStyleProps,
      _ = _J8.rest;

  return re.createElement(I, n({
    className: XX(a.Field, a.TextAreaField, i),
    "data-size": V,
    height: x,
    testId: H,
    width: B,
    bottom: M,
    left: L,
    right: y,
    top: D,
    position: b,
    padding: v
  }, k), re.createElement(R, {
    htmlFor: S,
    visuallyHidden: w
  }, u), re.createElement(a1, {
    id: j,
    labelHidden: w,
    descriptiveText: o
  }), re.createElement(be, n(n({
    "aria-describedby": W,
    hasError: C,
    id: S,
    ref: r,
    rows: d != null ? d : KX,
    size: V
  }, E), _)), re.createElement($, {
    hasError: C,
    errorMessage: f
  }));
}, "TextAreaFieldPrimitive"),
    $o = re.forwardRef(qX);
$o.displayName = "TextAreaField";
import QX from "classnames";
import * as et from "react";
import * as Ro from "react";
var mi = s(function (_ref19) {
  var t = _ref19.isPressed,
      r = _ref19.defaultPressed,
      i = _ref19.onClick,
      o = _ref19.onChange,
      f = _ref19.value;

  var C = t !== void 0,
      _Ro$useState = Ro.useState(r),
      _Ro$useState2 = _slicedToArray(_Ro$useState, 2),
      g = _Ro$useState2[0],
      u = _Ro$useState2[1];

  t = C ? t : g;
  var w = Ro.useCallback(function (d) {
    O(i) && i(d), C || u(!g), C && O(o) && o(f);
  }, [C, i, o, g, f]);
  return {
    isPressed: t,
    handleClick: w
  };
}, "useToggleButton");
var JX = s(function (M, H) {
  var x = M,
      t = x.className,
      r = x.children,
      _x$defaultPressed = x.defaultPressed,
      i = _x$defaultPressed === void 0 ? !1 : _x$defaultPressed,
      o = x.isDisabled,
      f = x.isPressed,
      C = x.onChange,
      g = x.onClick,
      u = x.size,
      w = x.value,
      d = x.variation,
      V = m(x, ["className", "children", "defaultPressed", "isDisabled", "isPressed", "onChange", "onClick", "size", "value", "variation"]);

  var _mi = mi({
    isPressed: f,
    defaultPressed: i,
    onChange: C,
    onClick: g,
    value: w
  }),
      L = _mi.isPressed,
      v = _mi.handleClick;

  return et.createElement(Z, n({
    "aria-pressed": L,
    className: QX(a.ToggleButton, t),
    isDisabled: o,
    onClick: v,
    ref: H,
    size: u,
    type: "button",
    variation: d
  }, V), r);
}, "ToggleButtonPrimitive"),
    ot = et.forwardRef(JX);
ot.displayName = "ToggleButton";
import $X from "classnames";
import * as W1 from "react";
import * as Jt from "react";
var ci = s(function (t, r) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var f = Jt.useCallback(function (g) {
    if (!O(t) || !Array.isArray(r)) return;
    var u = r.indexOf(g),
        w;
    u >= 0 ? (w = _toConsumableArray(r), (!o || w.length > 1) && w.splice(u, 1)) : w = [].concat(_toConsumableArray(r), [g]), t(w);
  }, [t, r, o]),
      C = Jt.useCallback(function (g) {
    !O(t) || t(r === g && !o ? null : g);
  }, [t, r, o]);
  return i ? C : f;
}, "useToggleButtonGroup");
var RX = s(function (V, d) {
  var H = V,
      t = H.children,
      r = H.className,
      i = H.isExclusive,
      o = H.isSelectionRequired,
      f = H.onChange,
      C = H.size,
      g = H.value,
      u = H.variation,
      w = m(H, ["children", "className", "isExclusive", "isSelectionRequired", "onChange", "size", "value", "variation"]);
  var M = ci(f, g, i, o);
  return W1.createElement(I, n({
    className: $X(a.ToggleButtonGroup, r),
    ref: d,
    role: "group"
  }, w), W1.Children.map(t, function (x) {
    return W1.isValidElement(x) ? W1.cloneElement(x, {
      isPressed: i ? g === x.props.value : g.includes(x.props.value),
      onChange: M,
      size: C,
      variation: u
    }) : x;
  }));
}, "ToggleButtonGroupPrimitive"),
    tt = W1.forwardRef(RX);
tt.displayName = "ToggleButtonGroup";
import { translate as $t } from "@aws-amplify/ui";
var rt = s(function () {
  var _N5 = N(),
      t = _N5.isPending,
      r = _N5.toSignIn;

  return e.createElement(I, {
    direction: "column"
  }, e.createElement(Z, {
    isDisabled: t,
    type: "submit",
    variation: "primary",
    fontWeight: "normal",
    isLoading: t,
    loadingText: $t("Confirming")
  }, $t("Confirm")), e.createElement(Z, {
    onClick: r,
    type: "button",
    variation: "link",
    fontWeight: "normal",
    size: "small"
  }, $t("Back to Sign In")));
}, "ConfirmSignInFooter");
import { translate as pi } from "@aws-amplify/ui";
var ie = s(function (t) {
  var r = t.cancelButtonSendType,
      i = t.cancelButtonText,
      o = t.submitButtonText,
      _N6 = N(),
      f = _N6._send,
      C = _N6.isPending,
      g = C ? e.createElement(e.Fragment, null, pi("Submitting"), "\u2026") : e.createElement(e.Fragment, null, pi("Submit"));

  return e.createElement(I, {
    direction: "column"
  }, e.createElement(Z, {
    fontWeight: "normal",
    variation: "primary",
    isDisabled: C,
    type: "submit"
  }, o || g), e.createElement(Z, {
    onClick: function onClick() {
      return f({
        type: r
      });
    },
    type: "button",
    variation: "link",
    fontWeight: "normal",
    size: "small"
  }, i));
}, "TwoButtonSubmitFooter");
import { translate as eK } from "@aws-amplify/ui";
var q = s(function () {
  var _N7 = N(),
      t = _N7.error;

  return e.createElement(e.Fragment, null, t ? e.createElement(Ve, {
    variation: "error",
    isDismissible: !0
  }, eK(t)) : null);
}, "RemoteErrorMessage");
import { translate as Ci } from "@aws-amplify/ui";
import { translate as fi } from "@aws-amplify/ui";
import * as G1 from "react";
import { getSortedFormFields as rK } from "@aws-amplify/ui";
import { getErrors as tK } from "@aws-amplify/ui";
import { translate as oK } from "@aws-amplify/ui";
var it = s(function (_ref20) {
  var t = _ref20.errors;
  return (t == null ? void 0 : t.length) > 0 ? e.createElement(c, {
    "data-amplify-sign-up-errors": !0
  }, t.map(function (r, i) {
    return e.createElement(G, {
      key: r,
      role: "alert",
      variation: "error"
    }, oK(r));
  })) : null;
}, "ValidationErrors");

function hi(_ref21) {
  var t = _ref21.name,
      r = _ref21.formFieldOptions;

  var _N8 = N(),
      i = _N8.validationErrors,
      o = r.type,
      f = tK(i[t]),
      C = (f == null ? void 0 : f.length) > 0;

  return o === "tel" ? e.createElement(e.Fragment, null, e.createElement(Pe, {
    name: t,
    label: r.label,
    placeholder: r.placeholder,
    defaultCountryCode: r.dialCode,
    countryCodeName: "country_code",
    dialCodeList: r.dialCodeList,
    autoComplete: r.autocomplete,
    isRequired: r.isRequired,
    labelHidden: r.labelHidden,
    hasError: C
  }), e.createElement(it, {
    errors: f
  })) : o === "password" ? e.createElement(e.Fragment, null, e.createElement(ke, {
    name: t,
    label: r.label,
    autoComplete: r.autocomplete,
    placeholder: r.placeholder,
    isRequired: r.isRequired,
    labelHidden: r.labelHidden,
    hasError: C
  }), e.createElement(it, {
    errors: f
  })) : e.createElement(e.Fragment, null, e.createElement(g1, {
    name: t,
    label: r.label,
    placeholder: r.placeholder,
    autoComplete: r.autocomplete,
    isRequired: r.isRequired,
    labelHidden: r.labelHidden,
    hasError: C,
    type: o
  }), e.createElement(it, {
    errors: f
  }));
}

s(hi, "FormField");

function Q(_ref22) {
  var t = _ref22.route;

  var _N9 = N(function () {
    return [];
  }),
      r = _N9._state,
      i = G1.useRef(!1),
      o = G1.useMemo(function () {
    if (!i.current) return rK(t, r);
    i.current = !0;
  }, [t, r]);

  return G1.createElement(G1.Fragment, null, o.flatMap(function (_ref23) {
    var _ref24 = _slicedToArray(_ref23, 2),
        f = _ref24[0],
        C = _ref24[1];

    return G1.createElement(hi, {
      name: f,
      key: f,
      formFieldOptions: C
    });
  }));
}

s(Q, "FormFields");

function c1() {
  var _N10 = N(),
      t = _N10.hasValidationErrors,
      r = _N10.isPending,
      _T2 = T(),
      i = _T2.handleChange,
      o = _T2.handleBlur,
      f = _T2.handleSubmit,
      _A2 = A(),
      _A2$components$SignUp = _A2.components.SignUp,
      _A2$components$SignUp2 = _A2$components$SignUp.Header,
      C = _A2$components$SignUp2 === void 0 ? c1.Header : _A2$components$SignUp2,
      _A2$components$SignUp3 = _A2$components$SignUp.FormFields,
      g = _A2$components$SignUp3 === void 0 ? c1.FormFields : _A2$components$SignUp3,
      _A2$components$SignUp4 = _A2$components$SignUp.Footer,
      u = _A2$components$SignUp4 === void 0 ? c1.Footer : _A2$components$SignUp4;

  return e.createElement(c, null, e.createElement(C, null), e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-signup": "",
    method: "post",
    onChange: i,
    onSubmit: f,
    onBlur: o
  }, e.createElement(so, null), e.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: r
  }, e.createElement(I, {
    direction: "column"
  }, e.createElement(g, null), e.createElement(q, null)), e.createElement(Z, {
    isDisabled: t || r,
    isFullWidth: !0,
    type: "submit",
    variation: "primary",
    isLoading: r,
    loadingText: fi("Creating Account")
  }, fi("Create Account")))), e.createElement(u, null));
}

s(c1, "SignUp");

c1.Header = function () {
  return null;
};

c1.FormFields = function () {
  return e.createElement(Q, {
    route: "signUp"
  });
};

c1.Footer = function () {
  return null;
};

var gi = s(function (_ref25) {
  var t = _ref25.hideSignUp;

  var _N11 = N(),
      r = _N11.route,
      i = _N11.toSignIn,
      o = _N11.toSignUp;

  return e.createElement(e.Fragment, null, t ? e.createElement(c, {
    "data-amplify-router-content": ""
  }, r === "signIn" && e.createElement(u1, null)) : e.createElement(Ye, {
    indicatorPosition: "top",
    currentIndex: r === "signIn" ? 0 : 1,
    spacing: "equal",
    justifyContent: "center",
    onChange: function onChange() {
      return r === "signIn" ? o() : i();
    }
  }, e.createElement(le, {
    title: Ci("Sign In")
  }, e.createElement(c, {
    "data-amplify-router-content": ""
  }, r === "signIn" && e.createElement(u1, null))), e.createElement(le, {
    title: Ci("Create Account")
  }, e.createElement(c, {
    "data-amplify-router-content": ""
  }, r === "signUp" && e.createElement(c1, null)))));
}, "SignInSignUpTabs");

function u1() {
  var _N12 = N(),
      t = _N12.isPending,
      _T3 = T(),
      r = _T3.handleChange,
      i = _T3.handleSubmit,
      _A3 = A(),
      _A3$components$SignIn = _A3.components.SignIn,
      _A3$components$SignIn2 = _A3$components$SignIn.Header,
      o = _A3$components$SignIn2 === void 0 ? u1.Header : _A3$components$SignIn2,
      _A3$components$SignIn3 = _A3$components$SignIn.Footer,
      f = _A3$components$SignIn3 === void 0 ? u1.Footer : _A3$components$SignIn3;

  return t1.createElement(c, null, t1.createElement(o, null), t1.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-signin": "",
    method: "post",
    onSubmit: i,
    onChange: r
  }, t1.createElement(so, null), t1.createElement(I, {
    direction: "column"
  }, t1.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: t
  }, t1.createElement(e1, null, t1.createElement("legend", null, eo("Sign in"))), t1.createElement(Q, {
    route: "signIn"
  })), t1.createElement(q, null), t1.createElement(Z, {
    isDisabled: t,
    isFullWidth: !0,
    type: "submit",
    variation: "primary",
    isLoading: t,
    loadingText: eo("Signing in")
  }, eo("Sign in")))), t1.createElement(f, null));
}

s(u1, "SignIn");

u1.Header = function () {
  return null;
};

u1.Footer = function () {
  var _N13 = N(),
      t = _N13.toResetPassword,
      r = iK("Forgot your password? ") ? eo("Forgot your password? ") : eo("Forgot your password?");

  return t1.createElement(c, {
    "data-amplify-footer": ""
  }, t1.createElement(Z, {
    fontWeight: "normal",
    onClick: t,
    size: "small",
    variation: "link"
  }, r));
};

import { translate as st } from "@aws-amplify/ui";
var se = s(function () {
  var _N14 = N(),
      t = _N14.error,
      r = _N14.isPending,
      i = _N14.toSignIn,
      _T4 = T(),
      o = _T4.handleBlur,
      f = _T4.handleChange,
      C = _T4.handleSubmit,
      _A4 = A(),
      _A4$components$ForceN = _A4.components.ForceNewPassword.FormFields,
      g = _A4$components$ForceN === void 0 ? se.FormFields : _A4$components$ForceN;

  return e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-forcenewpassword": "",
    method: "post",
    onChange: f,
    onSubmit: C,
    onBlur: o
  }, e.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: r
  }, e.createElement(U, {
    level: 3
  }, st("Change Password")), e.createElement(g, null), t && e.createElement(G, {
    className: "forceNewPasswordErrorText",
    variation: "error"
  }, t), e.createElement(Z, {
    isDisabled: r,
    type: "submit",
    variation: "primary",
    isLoading: r,
    loadingText: st("Changing"),
    fontWeight: "normal"
  }, st("Change Password")), e.createElement(Z, {
    onClick: i,
    type: "button",
    fontWeight: "normal",
    variation: "link",
    size: "small"
  }, st("Back to Sign In"))));
}, "ForceNewPassword");

se.FormFields = function () {
  return e.createElement(Q, {
    route: "forceNewPassword"
  });
};

import sK from "qrcode";
import * as F from "react";
import { Auth as aK, Logger as nK } from "aws-amplify";
import { getActorState as ui, translate as Rt } from "@aws-amplify/ui";
var mK = new nK("SetupTOTP-logger"),
    I1 = s(function () {
  var P, S;

  var _N15 = N(),
      t = _N15._state,
      r = _N15.isPending,
      _T5 = T(),
      i = _T5.handleChange,
      o = _T5.handleSubmit,
      _A5 = A(),
      _A5$components$SetupT = _A5.components.SetupTOTP,
      _A5$components$SetupT2 = _A5$components$SetupT.Header,
      f = _A5$components$SetupT2 === void 0 ? I1.Header : _A5$components$SetupT2,
      _A5$components$SetupT3 = _A5$components$SetupT.Footer,
      C = _A5$components$SetupT3 === void 0 ? I1.Footer : _A5$components$SetupT3,
      _F$useState = F.useState(!0),
      _F$useState2 = _slicedToArray(_F$useState, 2),
      g = _F$useState2[0],
      u = _F$useState2[1],
      _F$useState3 = F.useState(),
      _F$useState4 = _slicedToArray(_F$useState3, 2),
      w = _F$useState4[0],
      d = _F$useState4[1],
      _F$useState5 = F.useState("COPY"),
      _F$useState6 = _slicedToArray(_F$useState5, 2),
      V = _F$useState6[0],
      H = _F$useState6[1],
      _F$useState7 = F.useState(""),
      _F$useState8 = _slicedToArray(_F$useState7, 2),
      M = _F$useState8[0],
      x = _F$useState8[1],
      L = ui(t),
      v = L.context.user,
      b = (S = (P = ui(t).context) == null ? void 0 : P.formFields) == null ? void 0 : S.setupTOTP,
      y = b == null ? void 0 : b.QR,
      D = s( /*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(j) {
      var W, k, E, _, z, l1, p1;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return aK.setupTOTP(j);

            case 3:
              E = _context.sent;
              x(E);
              _ = (W = y == null ? void 0 : y.totpIssuer) != null ? W : "AWSCognito";
              z = (k = y == null ? void 0 : y.totpUsername) != null ? k : j.username;
              l1 = "otpauth://totp/".concat(_, ":").concat(z, "?secret=").concat(E, "&issuer=").concat(_);
              _context.next = 10;
              return sK.toDataURL(l1);

            case 10:
              p1 = _context.sent;
              d(p1);
              _context.next = 17;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](0);
              mK.error(_context.t0);

            case 17:
              _context.prev = 17;
              u(!1);
              return _context.finish(17);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 14, 17, 20]]);
    }));

    return function (_x2) {
      return _ref26.apply(this, arguments);
    };
  }(), "generateQRCode");

  F.useEffect(function () {
    !v || D(v);
  }, [v]);
  var B = s(function () {
    navigator.clipboard.writeText(M), H(Rt("COPIED"));
  }, "copyText");
  return F.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-setup-totp": "",
    method: "post",
    onChange: i,
    onSubmit: o
  }, F.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: r
  }, F.createElement(f, null), F.createElement(I, {
    direction: "column"
  }, g ? F.createElement("p", null, Rt("Loading"), "\u2026") : F.createElement("img", {
    "data-amplify-qrcode": !0,
    src: w,
    alt: "qr code",
    width: "228",
    height: "228"
  }), F.createElement(I, {
    "data-amplify-copy": !0
  }, F.createElement("div", null, M), F.createElement(I, {
    "data-amplify-copy-svg": !0,
    onClick: B
  }, F.createElement("div", {
    "data-amplify-copy-tooltip": !0
  }, V), F.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, F.createElement("path", {
    d: "M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
  })))), F.createElement(Q, {
    route: "setupTOTP"
  }), F.createElement(q, null)), F.createElement(rt, null), F.createElement(C, null)));
}, "SetupTOTP");

I1.Header = function () {
  return F.createElement(U, {
    level: 3
  }, Rt("Setup TOTP"));
};

I1.Footer = function () {
  return null;
};

import * as k1 from "react";
import { AuthChallengeNames as wi, getActorState as cK, translate as er } from "@aws-amplify/ui";
var U1 = s(function () {
  var _N16 = N(),
      t = _N16.isPending,
      _T6 = T(),
      r = _T6.handleChange,
      i = _T6.handleSubmit,
      _A6 = A(),
      _A6$components$Confir = _A6.components.ConfirmSignIn,
      _A6$components$Confir2 = _A6$components$Confir.Header,
      o = _A6$components$Confir2 === void 0 ? U1.Header : _A6$components$Confir2,
      _A6$components$Confir3 = _A6$components$Confir.Footer,
      f = _A6$components$Confir3 === void 0 ? U1.Footer : _A6$components$Confir3;

  return k1.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-confirmsignin": "",
    method: "post",
    onChange: r,
    onSubmit: i
  }, k1.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: t
  }, k1.createElement(o, null), k1.createElement(I, {
    direction: "column"
  }, k1.createElement(Q, {
    route: "confirmSignIn"
  }), k1.createElement(q, null)), k1.createElement(rt, null), k1.createElement(f, null)));
}, "ConfirmSignIn");

function lK() {
  var _N17 = N(),
      t = _N17._state,
      r = cK(t),
      i = r.context.challengeName,
      o;

  switch (i) {
    case wi.SMS_MFA:
      o = er("Confirm SMS Code");
      break;

    case wi.SOFTWARE_TOKEN_MFA:
      o = er("Confirm TOTP Code");
      break;

    default:
      throw new Error("".concat(er("Unexpected challengeName encountered in ConfirmSignIn:"), " ").concat(i));
  }

  return k1.createElement(U, {
    level: 3
  }, o);
}

s(lK, "Header");
U1.Header = lK;

U1.Footer = function () {
  return null;
};

import * as D1 from "react";
import { translate as di } from "@aws-amplify/ui";
var z1 = s(function () {
  var _N18 = N(),
      t = _N18.isPending,
      _T7 = T(),
      r = _T7.handleChange,
      i = _T7.handleSubmit,
      _A7 = A(),
      _A7$components$Confir = _A7.components.ConfirmVerifyUser,
      _A7$components$Confir2 = _A7$components$Confir.Header,
      o = _A7$components$Confir2 === void 0 ? z1.Header : _A7$components$Confir2,
      _A7$components$Confir3 = _A7$components$Confir.Footer,
      f = _A7$components$Confir3 === void 0 ? z1.Footer : _A7$components$Confir3;

  return D1.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-confirmverifyuser": "",
    method: "post",
    onChange: r,
    onSubmit: i
  }, D1.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: t
  }, D1.createElement(o, null), D1.createElement(I, {
    direction: "column"
  }, D1.createElement(Q, {
    route: "confirmVerifyUser"
  })), D1.createElement(q, null), D1.createElement(ie, {
    cancelButtonText: di("Skip"),
    cancelButtonSendType: "SKIP"
  }), D1.createElement(f, null)));
}, "ConfirmVerifyUser");

z1.Header = function () {
  return D1.createElement(U, {
    level: 3
  }, di("Account recovery requires verified contact information"));
};

z1.Footer = function () {
  return null;
};

import { defaultFormFieldOptions as pK, censorAllButFirstAndLast as hK, censorPhoneNumber as fK, getActorContext as CK, translate as oo } from "@aws-amplify/ui";
var gK = s(function (t, r) {
  var i = oo(t),
      o = r;
  if (t === "Phone Number") o = fK(r);else if (t === "Email") {
    var f = r.split("@");
    o = "".concat(hK(f[0]), "@").concat(f[1]);
  }
  return "".concat(i, ": ").concat(o);
}, "censorContactInformation"),
    uK = s(function (t) {
  var r = [];

  for (var _i2 = 0, _Object$entries = Object.entries(t); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        i = _Object$entries$_i[0],
        o = _Object$entries$_i[1];

    var f = e.createElement(Se, {
      name: "unverifiedAttr",
      value: i,
      key: i
    }, gK(pK[i].label, o));
    r.push(f);
  }

  return r;
}, "generateRadioGroup"),
    X1 = s(function () {
  var _A8 = A(),
      _A8$components$Verify = _A8.components.VerifyUser,
      _A8$components$Verify2 = _A8$components$Verify.Header,
      t = _A8$components$Verify2 === void 0 ? X1.Header : _A8$components$Verify2,
      _A8$components$Verify3 = _A8$components$Verify.Footer,
      r = _A8$components$Verify3 === void 0 ? X1.Footer : _A8$components$Verify3,
      _N19 = N(),
      i = _N19._state,
      o = _N19.isPending,
      _T8 = T(),
      f = _T8.handleChange,
      C = _T8.handleSubmit,
      g = CK(i),
      u = o ? e.createElement(e.Fragment, null, "Verifying\u2026") : e.createElement(e.Fragment, null, oo("Verify")),
      w = e.createElement(je, {
    label: oo("Verify Contact"),
    labelHidden: !0,
    name: "verify_context",
    isDisabled: o
  }, uK(g.unverifiedAttributes));

  return e.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-verifyuser": "",
    method: "post",
    onChange: f,
    onSubmit: C
  }, e.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: o
  }, e.createElement(t, null), w, e.createElement(q, null), e.createElement(ie, {
    cancelButtonText: oo("Skip"),
    cancelButtonSendType: "SKIP",
    submitButtonText: u
  }), e.createElement(r, null)));
}, "VerifyUser");

X1.Header = function () {
  return e.createElement(U, {
    level: 3
  }, oo("Account recovery requires verified contact information"));
};

X1.Footer = function () {
  return null;
};

import * as P1 from "react";
import { translate as Vi } from "@aws-amplify/ui";
var K1 = s(function () {
  var _N20 = N(),
      t = _N20.isPending,
      _T9 = T(),
      r = _T9.handleBlur,
      i = _T9.handleChange,
      o = _T9.handleSubmit,
      _A9 = A(),
      _A9$components$Confir = _A9.components.ConfirmResetPassword,
      _A9$components$Confir2 = _A9$components$Confir.Header,
      f = _A9$components$Confir2 === void 0 ? K1.Header : _A9$components$Confir2,
      _A9$components$Confir3 = _A9$components$Confir.Footer,
      C = _A9$components$Confir3 === void 0 ? K1.Footer : _A9$components$Confir3;

  return P1.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-confirmresetpassword": "",
    method: "post",
    onSubmit: o,
    onChange: i,
    onBlur: r
  }, P1.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: t
  }, P1.createElement(f, null), P1.createElement(I, {
    direction: "column"
  }, P1.createElement(Q, {
    route: "confirmResetPassword"
  })), P1.createElement(q, null), P1.createElement(ie, {
    cancelButtonSendType: "RESEND",
    cancelButtonText: Vi("Resend Code")
  }), P1.createElement(C, null)));
}, "ConfirmResetPassword");

K1.Header = function () {
  var t = Vi("Reset your password");
  return P1.createElement(U, {
    level: 3
  }, t);
};

K1.Footer = function () {
  return null;
};

import * as r1 from "react";
import { translate as at } from "@aws-amplify/ui";
var L1 = s(function () {
  var _N21 = N(),
      t = _N21.isPending,
      _T10 = T(),
      r = _T10.handleChange,
      i = _T10.handleSubmit,
      _A10 = A(),
      _A10$components$Reset = _A10.components.ResetPassword,
      _A10$components$Reset2 = _A10$components$Reset.Header,
      o = _A10$components$Reset2 === void 0 ? L1.Header : _A10$components$Reset2,
      _A10$components$Reset3 = _A10$components$Reset.Footer,
      f = _A10$components$Reset3 === void 0 ? L1.Footer : _A10$components$Reset3;

  return r1.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-resetpassword": "",
    method: "post",
    onChange: r,
    onSubmit: i
  }, r1.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: t
  }, r1.createElement(o, null), r1.createElement(I, {
    direction: "column"
  }, r1.createElement(Q, {
    route: "resetPassword"
  })), r1.createElement(q, null), r1.createElement(ie, {
    cancelButtonText: at("Back to Sign In"),
    cancelButtonSendType: "SIGN_IN",
    submitButtonText: t ? r1.createElement(r1.Fragment, null, at("Sending"), "\u2026") : r1.createElement(r1.Fragment, null, at("Send code"))
  }), r1.createElement(f, null)));
}, "ResetPassword");

L1.Header = function () {
  return r1.createElement(U, {
    level: 3
  }, at("Reset your password"));
};

L1.Footer = function () {
  return null;
};

var nt = {
  Header: function Header() {
    return null;
  },
  SignIn: {
    Header: u1.Header,
    Footer: u1.Footer
  },
  SignUp: {
    Header: c1.Header,
    FormFields: c1.FormFields,
    Footer: c1.Footer
  },
  ConfirmSignUp: {
    Header: q1.Header,
    Footer: q1.Footer
  },
  SetupTOTP: {
    Header: I1.Header,
    Footer: I1.Footer
  },
  ConfirmResetPassword: {
    Header: K1.Header,
    Footer: K1.Footer
  },
  ConfirmSignIn: {
    Header: U1.Header,
    Footer: U1.Footer
  },
  VerifyUser: {
    Header: X1.Header,
    Footer: X1.Footer
  },
  ConfirmVerifyUser: {
    Header: z1.Header,
    Footer: z1.Footer
  },
  ForceNewPassword: {
    FormFields: se.FormFields
  },
  ResetPassword: {
    Header: L1.Header,
    Footer: L1.Footer
  },
  Footer: function Footer() {
    return null;
  }
};
var or = mt.createContext({
  components: n({}, nt)
}),
    A = s(function () {
  return mt.useContext(or);
}, "useCustomComponents");

function q1() {
  var _N22 = N(),
      t = _N22.isPending,
      r = _N22.resendCode,
      _N22$codeDeliveryDeta = _N22.codeDeliveryDetails;

  _N22$codeDeliveryDeta = _N22$codeDeliveryDeta === void 0 ? {} : _N22$codeDeliveryDeta;

  var i = _N22$codeDeliveryDeta.DeliveryMedium,
      o = _N22$codeDeliveryDeta.Destination,
      _T11 = T(),
      f = _T11.handleChange,
      C = _T11.handleSubmit,
      _A11 = A(),
      _A11$components$Confi = _A11.components.ConfirmSignUp,
      _A11$components$Confi2 = _A11$components$Confi.Header,
      g = _A11$components$Confi2 === void 0 ? q1.Header : _A11$components$Confi2,
      _A11$components$Confi3 = _A11$components$Confi.Footer,
      u = _A11$components$Confi3 === void 0 ? q1.Footer : _A11$components$Confi3,
      w = v1("Your code is on the way. To log in, enter the code we emailed to"),
      d = v1("Your code is on the way. To log in, enter the code we texted to"),
      V = v1("Your code is on the way. To log in, enter the code we sent you. It may take a minute to arrive."),
      H = v1("It may take a minute to arrive."),
      M = i === "EMAIL" ? "".concat(w, " ").concat(o, ". ").concat(H) : i === "SMS" ? "".concat(d, " ").concat(o, ". ").concat(H) : v1("".concat(V));

  return w1.createElement("form", {
    "data-amplify-form": "",
    "data-amplify-authenticator-confirmsignup": "",
    method: "post",
    onChange: f,
    onSubmit: C
  }, w1.createElement("fieldset", {
    style: {
      display: "flex",
      flexDirection: "column"
    },
    className: "amplify-flex",
    disabled: t
  }, w1.createElement(g, null), w1.createElement(I, {
    direction: "column"
  }, w1.createElement(G, {
    style: {
      marginBottom: "1rem"
    }
  }, M), w1.createElement(Q, {
    route: "confirmSignUp"
  }), w1.createElement(q, null), w1.createElement(Z, {
    variation: "primary",
    isDisabled: t,
    type: "submit",
    loadingText: v1("Confirming"),
    isLoading: t,
    fontWeight: "normal"
  }, v1("Confirm")), w1.createElement(Z, {
    onClick: r,
    type: "button",
    fontWeight: "normal"
  }, v1("Resend Code"))), w1.createElement(u, null)));
}

s(q1, "ConfirmSignUp");

q1.Header = function () {
  var _N23 = N(),
      _N23$codeDeliveryDeta = _N23.codeDeliveryDetails;

  _N23$codeDeliveryDeta = _N23$codeDeliveryDeta === void 0 ? {} : _N23$codeDeliveryDeta;
  var t = _N23$codeDeliveryDeta.DeliveryMedium,
      r = _N23$codeDeliveryDeta.Destination,
      i = t === "EMAIL" ? v1("We Emailed You") : t === "SMS" ? v1("We Texted You") : v1("We Sent A Code");
  return w1.createElement(U, {
    level: 3,
    style: {
      fontSize: "1.5rem"
    }
  }, i);
};

q1.Footer = function () {
  return null;
};

var wK = s(function (t) {
  return t === "signIn" || "signUp";
}, "hasTabs");

function Hi(_ref27) {
  var t = _ref27.children,
      r = _ref27.className,
      _ref27$variation = _ref27.variation,
      i = _ref27$variation === void 0 ? "default" : _ref27$variation,
      o = _ref27.hideSignUp;

  var _N24 = N(),
      f = _N24.route,
      C = _N24.signOut,
      g = _N24.user,
      _A12 = A(),
      _A12$components = _A12.components,
      u = _A12$components.Header,
      w = _A12$components.Footer;

  return ["authenticated", "signOut"].includes(f) ? t ? t({
    signOut: C,
    user: g
  }) : null : e.createElement(e.Fragment, null, e.createElement(c, {
    className: r,
    "data-amplify-authenticator": "",
    "data-variation": i
  }, e.createElement(c, {
    "data-amplify-container": ""
  }, e.createElement(u, null), e.createElement(c, {
    "data-amplify-router": "",
    "data-amplify-router-content": wK(f) ? void 0 : ""
  }, function () {
    switch (f) {
      case "idle":
      case "setup":
        return null;

      case "confirmSignUp":
        return e.createElement(q1, null);

      case "confirmSignIn":
        return e.createElement(U1, null);

      case "setupTOTP":
        return e.createElement(I1, null);

      case "signIn":
      case "signUp":
        return e.createElement(gi, {
          hideSignUp: o
        });

      case "forceNewPassword":
        return e.createElement(se, null);

      case "resetPassword":
        return e.createElement(L1, null);

      case "confirmResetPassword":
        return e.createElement(K1, null);

      case "verifyUser":
        return e.createElement(X1, null);

      case "confirmVerifyUser":
        return e.createElement(z1, null);

      default:
        return console.warn("Unhandled Authenicator route \u2013\xA0please open an issue: ", f), null;
    }
  }()), e.createElement(w, null))));
}

s(Hi, "Router");

function dK(i) {
  var o = i,
      t = o.children,
      r = m(o, ["children"]);

  var _N25 = N(),
      f = _N25._send,
      C = _N25.route,
      g = d1.useRef(!1);

  return d1.useEffect(function () {
    !g.current && C === "idle" && (f({
      type: "INIT",
      data: r
    }), g.current = !0);
  }, [f, C, r]), d1.createElement(d1.Fragment, null, t);
}

s(dK, "InitMachine");

function S1(_ref28) {
  var t = _ref28.children,
      r = _ref28.className,
      i = _ref28.components,
      o = _ref28.initialState,
      f = _ref28.loginMechanisms,
      C = _ref28.services,
      g = _ref28.signUpAttributes,
      u = _ref28.socialProviders,
      w = _ref28.variation,
      d = _ref28.hideSignUp,
      V = _ref28.formFields;
  var H = n(n({}, nt), i),
      M = {
    initialState: o,
    loginMechanisms: f,
    services: C,
    signUpAttributes: g,
    socialProviders: u,
    formFields: V
  };
  return d1.createElement(wt, null, d1.createElement(or.Provider, {
    value: {
      components: H
    }
  }, d1.createElement(dK, n({}, M), d1.createElement(Hi, {
    className: r,
    children: t,
    variation: w,
    hideSignUp: d
  }))));
}

s(S1, "Authenticator");
S1.Provider = wt;
S1.ResetPassword = L1;
S1.SetupTOTP = I1;
S1.SignIn = u1;
S1.SignUp = c1;
S1.ForceNewPassword = se;
import * as tr from "react";

function Mi(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _r$variation = r.variation,
      i = _r$variation === void 0 ? "modal" : _r$variation;
  return s(function (f) {
    return tr.createElement(S1, n({
      variation: i
    }, r), function (C) {
      return tr.createElement(t, n(n({}, f), C));
    });
  }, "WrappedWithAuthenticator");
}

s(Mi, "withAuthenticator");
import { defaultTheme as DVo, createTheme as PVo, translations as SVo } from "@aws-amplify/ui";
export { Ve as Alert, Zi as AmplifyProvider, S1 as Authenticator, lo as Badge, Z as Button, He as ButtonGroup, ho as Card, Mo as CheckboxField, No as Collection, a as ComponentClassNames, Vt as ComponentClassObject, Ae as ComponentPropsToStylePropsMap, Ei as ComponentPropsToStylePropsMapKeys, Ce as Divider, bo as Expander, Zo as ExpanderItem, xe as FieldGroupIcon, M1 as FieldGroupIconButton, I as Flex, Le as Grid, U as Heading, fe as Icon, fs as Icon360, gs as Icon3dRotation, ws as Icon4k, Vs as Icon5g, Ms as Icon6FtApart, Is as IconAcUnit, vs as IconAccessAlarm, ys as IconAccessAlarms, Zs as IconAccessTime, Ds as IconAccessibility, Ws as IconAccessibilityNew, Ys as IconAccessible, Ss as IconAccessibleForward, Es as IconAccountBalance, Ts as IconAccountBalanceWallet, _s as IconAccountBox, Us as IconAccountCircle, Xs as IconAccountTree, qs as IconAdUnits, Js as IconAdb, Nt as IconAdd, Rs as IconAddAPhoto, oa as IconAddAlarm, ra as IconAddAlert, sa as IconAddBox, na as IconAddBusiness, pa as IconAddCircle, ca as IconAddCircleOutline, fa as IconAddComment, ga as IconAddIcCall, Va as IconAddLocation, wa as IconAddLocationAlt, Ma as IconAddPhotoAlternate, Ia as IconAddRoad, va as IconAddShoppingCart, ya as IconAddTask, Za as IconAddToHomeScreen, Wa as IconAddToPhotos, Da as IconAddToQueue, ja as IconAddchart, Fa as IconAdjust, Aa as IconAdminPanelSettings, Oa as IconAgriculture, za as IconAirlineSeatFlat, Ga as IconAirlineSeatFlatAngled, Ka as IconAirlineSeatIndividualSuite, Qa as IconAirlineSeatLegroomExtra, $a as IconAirlineSeatLegroomNormal, en as IconAirlineSeatLegroomReduced, tn as IconAirlineSeatReclineExtra, sn as IconAirlineSeatReclineNormal, nn as IconAirplanemodeActive, cn as IconAirplanemodeInactive, pn as IconAirplay, fn as IconAirportShuttle, Mn as IconAlarm, gn as IconAlarmAdd, wn as IconAlarmOff, Vn as IconAlarmOn, In as IconAlbum, vn as IconAllInbox, yn as IconAllInclusive, Zn as IconAllOut, Wn as IconAltRoute, Dn as IconAlternateEmail, Sn as IconAmpStories, Yn as IconAnalytics, Tn as IconAnchor, En as IconAndroid, _n as IconAnnouncement, Un as IconApartment, Xn as IconApi, qn as IconAppBlocking, Jn as IconAppSettingsAlt, Rn as IconApps, o2 as IconArchitecture, r2 as IconArchive, n2 as IconArrowBack, s2 as IconArrowBackIos, c2 as IconArrowCircleDown, p2 as IconArrowCircleUp, f2 as IconArrowDownward, w2 as IconArrowDropDown, g2 as IconArrowDropDownCircle, V2 as IconArrowDropUp, I2 as IconArrowForward, M2 as IconArrowForwardIos, v2 as IconArrowLeft, Z2 as IconArrowRight, y2 as IconArrowRightAlt, W2 as IconArrowUpward, D2 as IconArtTrack, S2 as IconArticle, Y2 as IconAspectRatio, T2 as IconAssessment, J2 as IconAssignment, E2 as IconAssignmentInd, _2 as IconAssignmentLate, U2 as IconAssignmentReturn, X2 as IconAssignmentReturned, q2 as IconAssignmentTurnedIn, om as IconAssistant, R2 as IconAssistantPhoto, rm as IconAtm, sm as IconAttachEmail, nm as IconAttachFile, cm as IconAttachMoney, pm as IconAttachment, fm as IconAttribution, gm as IconAudiotrack, wm as IconAutoDelete, Vm as IconAutorenew, Mm as IconAvTimer, Im as IconBabyChangingStation, vm as IconBackpack, ym as IconBackspace, Wm as IconBackup, Zm as IconBackupTable, Dm as IconBallot, Sm as IconBarChart, Ym as IconBatchPrediction, Tm as IconBathtub, Em as IconBatteryAlert, _m as IconBatteryChargingFull, Um as IconBatteryFull, Xm as IconBatteryStd, qm as IconBatteryUnknown, Jm as IconBeachAccess, Rm as IconBedtime, oc as IconBeenhere, rc as IconBento, sc as IconBikeScooter, nc as IconBiotech, cc as IconBlock, Vc as IconBluetooth, pc as IconBluetoothAudio, fc as IconBluetoothConnected, gc as IconBluetoothDisabled, wc as IconBluetoothSearching, Mc as IconBlurCircular, Ic as IconBlurLinear, vc as IconBlurOff, yc as IconBlurOn, Wc as IconBook, Zc as IconBookOnline, Sc as IconBookmark, Dc as IconBookmarkBorder, Yc as IconBookmarks, Tc as IconBorderAll, Ec as IconBorderBottom, _c as IconBorderClear, Uc as IconBorderHorizontal, Xc as IconBorderInner, qc as IconBorderLeft, Jc as IconBorderOuter, Rc as IconBorderRight, o9 as IconBorderStyle, r9 as IconBorderTop, s9 as IconBorderVertical, n9 as IconBrandingWatermark, I9 as IconBrightnessAuto, v9 as IconBrightnessHigh, y9 as IconBrightnessLow, Z9 as IconBrightnessMedium, c9 as IconBrightness_1, p9 as IconBrightness_2, f9 as IconBrightness_3, g9 as IconBrightness_4, w9 as IconBrightness_5, V9 as IconBrightness_6, M9 as IconBrightness_7, W9 as IconBrokenImage, D9 as IconBrowserNotSupported, S9 as IconBrush, Y9 as IconBubbleChart, T9 as IconBugReport, _9 as IconBuild, E9 as IconBuildCircle, U9 as IconBurstMode, q9 as IconBusiness, X9 as IconBusinessCenter, J9 as IconCached, R9 as IconCake, o0 as IconCalculate, r0 as IconCalendarToday, s0 as IconCalendarViewDay, I0 as IconCall, n0 as IconCallEnd, c0 as IconCallMade, p0 as IconCallMerge, g0 as IconCallMissed, f0 as IconCallMissedOutgoing, w0 as IconCallReceived, V0 as IconCallSplit, M0 as IconCallToAction, S0 as IconCamera, v0 as IconCameraAlt, y0 as IconCameraEnhance, Z0 as IconCameraFront, W0 as IconCameraRear, D0 as IconCameraRoll, Y0 as IconCampaign, _0 as IconCancel, T0 as IconCancelPresentation, E0 as IconCancelScheduleSend, U0 as IconCardGiftcard, X0 as IconCardMembership, q0 as IconCardTravel, J0 as IconCarpenter, R0 as IconCasino, sl as IconCast, ol as IconCastConnected, rl as IconCastForEducation, nl as IconCategory, cl as IconCenterFocusStrong, pl as IconCenterFocusWeak, fl as IconChangeHistory, gl as IconChargingStation, Ml as IconChat, Vl as IconChatBubble, wl as IconChatBubbleOutline, bt as IconCheck, vl as IconCheckBox, Il as IconCheckBoxOutlineBlank, yt as IconCheckCircle, yl as IconCheckCircleOutline, Wl as IconCheckroom, Zt as IconChevronLeft, Bt as IconChevronRight, Sl as IconChildCare, Yl as IconChildFriendly, Tl as IconChromeReaderMode, El as IconClass, _l as IconCleanHands, Ul as IconCleaningServices, ql as IconClear, Xl as IconClearAll, _e as IconClose, Jl as IconCloseFullscreen, tp as IconClosedCaption, ep as IconClosedCaptionDisabled, up as IconCloud, ip as IconCloudCircle, ap as IconCloudDone, mp as IconCloudDownload, lp as IconCloudOff, hp as IconCloudQueue, Cp as IconCloudUpload, dp as IconCode, xp as IconCollections, Hp as IconCollectionsBookmark, Lp as IconColorLens, Np as IconColorize, Bp as IconComment, bp as IconCommentBank, kp as IconCommute, jp as IconCompare, Pp as IconCompareArrows, Fp as IconCompassCalibration, Ap as IconComputer, Op as IconConfirmationNumber, Gp as IconConnectWithoutContact, zp as IconConstruction, Kp as IconContactMail, Qp as IconContactPage, $p as IconContactPhone, e5 as IconContactSupport, t5 as IconContactless, i5 as IconContacts, a5 as IconContentCopy, m5 as IconContentCut, l5 as IconContentPaste, h5 as IconControlCamera, u5 as IconControlPoint, C5 as IconControlPointDuplicate, d5 as IconCopyright, H5 as IconCoronavirus, x5 as IconCorporateFare, L5 as IconCountertops, b5 as IconCreate, N5 as IconCreateNewFolder, B5 as IconCreditCard, e4 as IconCrop, A5 as IconCropDin, O5 as IconCropFree, G5 as IconCropLandscape, z5 as IconCropOriginal, K5 as IconCropPortrait, Q5 as IconCropRotate, $5 as IconCropSquare, k5 as IconCrop_16_9, P5 as IconCrop_3_2, j5 as IconCrop_5_4, F5 as IconCrop_7_5, t4 as IconDashboard, i4 as IconDataUsage, a4 as IconDateRange, m4 as IconDeck, l4 as IconDehaze, d4 as IconDelete, h4 as IconDeleteForever, C4 as IconDeleteOutline, u4 as IconDeleteSweep, H4 as IconDepartureBoard, x4 as IconDescription, L4 as IconDesignServices, N4 as IconDesktopAccessDisabled, b4 as IconDesktopMac, B4 as IconDesktopWindows, k4 as IconDetails, P4 as IconDeveloperBoard, j4 as IconDeveloperMode, F4 as IconDeviceHub, A4 as IconDeviceUnknown, G4 as IconDevices, O4 as IconDevicesOther, z4 as IconDialerSip, K4 as IconDialpad, uh as IconDirections, Q4 as IconDirectionsBike, $4 as IconDirectionsBoat, eh as IconDirectionsBus, th as IconDirectionsCar, ih as IconDirectionsOff, ah as IconDirectionsRailway, mh as IconDirectionsRun, lh as IconDirectionsSubway, hh as IconDirectionsTransit, Ch as IconDirectionsWalk, dh as IconDisabledByDefault, Hh as IconDiscFull, xh as IconDns, Bh as IconDoDisturb, Lh as IconDoDisturbAlt, Nh as IconDoDisturbOff, bh as IconDoDisturbOn, kh as IconDoNotStep, Ph as IconDoNotTouch, jh as IconDock, Oh as IconDomain, Fh as IconDomainDisabled, Ah as IconDomainVerification, Kh as IconDone, Gh as IconDoneAll, zh as IconDoneOutline, Qh as IconDonutLarge, $h as IconDonutSmall, e3 as IconDoubleArrow, i3 as IconDownload, t3 as IconDownloadDone, a3 as IconDrafts, m3 as IconDragHandle, l3 as IconDragIndicator, h3 as IconDriveEta, C3 as IconDry, u3 as IconDuo, d3 as IconDvr, H3 as IconDynamicFeed, x3 as IconDynamicForm, L3 as IconEast, N3 as IconEco, P3 as IconEdit, b3 as IconEditAttributes, B3 as IconEditLocation, k3 as IconEditRoad, j3 as IconEject, F3 as IconElderly, A3 as IconElectricBike, O3 as IconElectricCar, G3 as IconElectricMoped, z3 as IconElectricScooter, K3 as IconElectricalServices, Q3 as IconElevator, $3 as IconEmail, e8 as IconEmojiEmotions, t8 as IconEmojiEvents, i8 as IconEmojiFlags, a8 as IconEmojiFoodBeverage, m8 as IconEmojiNature, l8 as IconEmojiObjects, h8 as IconEmojiPeople, C8 as IconEmojiSymbols, u8 as IconEmojiTransportation, d8 as IconEngineering, H8 as IconEnhancedEncryption, x8 as IconEqualizer, Wt as IconError, L8 as IconErrorOutline, Z8 as IconEscalator, y8 as IconEscalatorWarning, D8 as IconEuro, W8 as IconEuroSymbol, S8 as IconEvStation, U8 as IconEvent, Y8 as IconEventAvailable, T8 as IconEventBusy, E8 as IconEventNote, _8 as IconEventSeat, X8 as IconExitToApp, q8 as IconExpandLess, Ge as IconExpandMore, $8 as IconExplicit, t7 as IconExplore, e7 as IconExploreOff, C7 as IconExposure, i7 as IconExposureNeg_1, a7 as IconExposureNeg_2, m7 as IconExposurePlus_1, l7 as IconExposurePlus_2, h7 as IconExposureZero, u7 as IconExtension, H7 as IconFace, d7 as IconFaceUnlock, x7 as IconFacebook, L7 as IconFactCheck, N7 as IconFamilyRestroom, b7 as IconFastForward, B7 as IconFastRewind, k7 as IconFastfood, j7 as IconFavorite, P7 as IconFavoriteBorder, F7 as IconFeaturedPlayList, A7 as IconFeaturedVideo, O7 as IconFeedback, G7 as IconFence, z7 as IconFiberDvr, K7 as IconFiberManualRecord, Q7 as IconFiberNew, $7 as IconFiberPin, e6 as IconFiberSmartRecord, t6 as IconFileCopy, G6 as IconFilter, L6 as IconFilterAlt, N6 as IconFilterBAndW, b6 as IconFilterCenterFocus, B6 as IconFilterDrama, k6 as IconFilterFrames, P6 as IconFilterHdr, j6 as IconFilterList, F6 as IconFilterNone, A6 as IconFilterTiltShift, O6 as IconFilterVintage, i6 as IconFilter_1, a6 as IconFilter_2, m6 as IconFilter_3, l6 as IconFilter_4, h6 as IconFilter_5, C6 as IconFilter_6, u6 as IconFilter_7, d6 as IconFilter_8, x6 as IconFilter_9, H6 as IconFilter_9Plus, z6 as IconFindInPage, K6 as IconFindReplace, Q6 as IconFingerprint, $6 as IconFireExtinguisher, ef as IconFireplace, tf as IconFirstPage, sf as IconFitnessCenter, nf as IconFlag, cf as IconFlaky, pf as IconFlare, ff as IconFlashAuto, gf as IconFlashOff, wf as IconFlashOn, If as IconFlight, Vf as IconFlightLand, Mf as IconFlightTakeoff, Df as IconFlip, vf as IconFlipCameraAndroid, yf as IconFlipCameraIos, Zf as IconFlipToBack, Wf as IconFlipToFront, Ef as IconFolder, Sf as IconFolderOpen, Yf as IconFolderShared, Tf as IconFolderSpecial, _f as IconFollowTheSigns, Uf as IconFontDownload, Xf as IconFoodBank, qf as IconFormatAlignCenter, Jf as IconFormatAlignJustify, Rf as IconFormatAlignLeft, oC as IconFormatAlignRight, rC as IconFormatBold, sC as IconFormatClear, nC as IconFormatColorReset, cC as IconFormatIndentDecrease, pC as IconFormatIndentIncrease, fC as IconFormatItalic, gC as IconFormatLineSpacing, wC as IconFormatListBulleted, MC as IconFormatListNumbered, VC as IconFormatListNumberedRtl, IC as IconFormatPaint, vC as IconFormatQuote, yC as IconFormatShapes, ZC as IconFormatSize, WC as IconFormatStrikethrough, DC as IconFormatTextdirectionLToR, SC as IconFormatTextdirectionRToL, YC as IconFormatUnderlined, TC as IconForum, qC as IconForward, XC as IconForwardToInbox, EC as IconForward_10, _C as IconForward_30, UC as IconForward_5, JC as IconFoundation, RC as IconFreeBreakfast, rg as IconFullscreen, og as IconFullscreenExit, sg as IconFunctions, ng as IconGTranslate, cg as IconGamepad, pg as IconGames, fg as IconGavel, gg as IconGesture, wg as IconGetApp, Vg as IconGif, Mg as IconGolfCourse, Ig as IconGpsFixed, vg as IconGpsNotFixed, yg as IconGpsOff, Zg as IconGrade, Wg as IconGradient, Dg as IconGrading, Sg as IconGrain, Yg as IconGraphicEq, Tg as IconGrass, Eg as IconGridOff, _g as IconGridOn, qg as IconGroup, Ug as IconGroupAdd, Xg as IconGroupWork, Jg as IconGroups, Rg as IconHandyman, ou as IconHd, ru as IconHdrOff, su as IconHdrOn, nu as IconHdrStrong, cu as IconHdrWeak, fu as IconHeadset, pu as IconHeadsetMic, gu as IconHealing, Vu as IconHearing, wu as IconHearingDisabled, Mu as IconHeight, yu as IconHelp, Iu as IconHelpCenter, vu as IconHelpOutline, Zu as IconHighQuality, Su as IconHighlight, Wu as IconHighlightAlt, Du as IconHighlightOff, Eu as IconHistory, Yu as IconHistoryEdu, Tu as IconHistoryToggleOff, Xu as IconHome, _u as IconHomeRepairService, Uu as IconHomeWork, qu as IconHorizontalRule, Ju as IconHorizontalSplit, Ru as IconHotTub, ow as IconHotel, rw as IconHourglassBottom, sw as IconHourglassDisabled, nw as IconHourglassEmpty, cw as IconHourglassFull, pw as IconHourglassTop, gw as IconHouse, fw as IconHouseSiding, ww as IconHowToReg, Vw as IconHowToVote, Mw as IconHttp, Iw as IconHttps, vw as IconHvac, Dw as IconImage, yw as IconImageAspectRatio, Zw as IconImageNotSupported, Ww as IconImageSearch, Sw as IconImportContacts, Yw as IconImportExport, Tw as IconImportantDevices, Ew as IconInbox, _w as IconIndeterminateCheckBox, kt as IconInfo, zw as IconInput, Qw as IconInsertChart, Kw as IconInsertChartOutlined, $w as IconInsertComment, ed as IconInsertDriveFile, td as IconInsertEmoticon, id as IconInsertInvitation, ad as IconInsertLink, md as IconInsertPhoto, ld as IconInsights, hd as IconIntegrationInstructions, ud as IconInvertColors, Cd as IconInvertColorsOff, dd as IconIso, Ad as IconKeyboard, Hd as IconKeyboardArrowDown, xd as IconKeyboardArrowLeft, Ld as IconKeyboardArrowRight, Nd as IconKeyboardArrowUp, bd as IconKeyboardBackspace, Bd as IconKeyboardCapslock, kd as IconKeyboardHide, Pd as IconKeyboardReturn, jd as IconKeyboardTab, Fd as IconKeyboardVoice, Od as IconKingBed, Gd as IconKitchen, Qd as IconLabel, zd as IconLabelImportant, Kd as IconLabelOff, $d as IconLandscape, eV as IconLanguage, mV as IconLaptop, tV as IconLaptopChromebook, iV as IconLaptopMac, aV as IconLaptopWindows, lV as IconLastPage, hV as IconLaunch, uV as IconLayers, CV as IconLayersClear, dV as IconLeaderboard, HV as IconLeakAdd, xV as IconLeakRemove, LV as IconLegendToggle, NV as IconLens, BV as IconLibraryAdd, bV as IconLibraryAddCheck, kV as IconLibraryBooks, PV as IconLibraryMusic, jV as IconLightbulb, FV as IconLineStyle, AV as IconLineWeight, OV as IconLinearScale, zV as IconLink, GV as IconLinkOff, KV as IconLinkedCamera, $V as IconList, QV as IconListAlt, eH as IconLiveHelp, tH as IconLiveTv, iH as IconLocalActivity, aH as IconLocalAirport, mH as IconLocalAtm, lH as IconLocalBar, hH as IconLocalCafe, CH as IconLocalCarWash, uH as IconLocalConvenienceStore, dH as IconLocalDining, HH as IconLocalDrink, xH as IconLocalFireDepartment, LH as IconLocalFlorist, NH as IconLocalGasStation, bH as IconLocalGroceryStore, BH as IconLocalHospital, kH as IconLocalHotel, PH as IconLocalLaundryService, jH as IconLocalLibrary, FH as IconLocalMall, AH as IconLocalMovies, OH as IconLocalOffer, GH as IconLocalParking, zH as IconLocalPharmacy, KH as IconLocalPhone, QH as IconLocalPizza, $H as IconLocalPlay, eM as IconLocalPolice, tM as IconLocalPostOffice, iM as IconLocalPrintshop, aM as IconLocalSee, mM as IconLocalShipping, lM as IconLocalTaxi, hM as IconLocationCity, CM as IconLocationDisabled, uM as IconLocationOff, dM as IconLocationOn, HM as IconLocationSearching, LM as IconLock, xM as IconLockOpen, NM as IconLogin, AM as IconLooks, jM as IconLooksOne, FM as IconLooksTwo, bM as IconLooks_3, BM as IconLooks_4, kM as IconLooks_5, PM as IconLooks_6, OM as IconLoop, GM as IconLoupe, zM as IconLowPriority, KM as IconLoyalty, QM as IconLuggage, ex as IconMail, $M as IconMailOutline, tx as IconMap, ix as IconMapsUgc, ax as IconMarkChatRead, mx as IconMarkChatUnread, lx as IconMarkEmailRead, hx as IconMarkEmailUnread, ux as IconMarkunread, Cx as IconMarkunreadMailbox, dx as IconMasks, Hx as IconMaximize, xx as IconMediation, Lx as IconMedicalServices, Nx as IconMeetingRoom, bx as IconMemory, Dt as IconMenu, Bx as IconMenuBook, kx as IconMenuOpen, Sx as IconMergeType, Yx as IconMessage, _x as IconMic, Tx as IconMicNone, Ex as IconMicOff, Ux as IconMicrowave, Xx as IconMilitaryTech, qx as IconMinimize, Jx as IconMiscellaneousServices, Rx as IconMissedVideoCall, oI as IconMms, rI as IconMobileFriendly, sI as IconMobileOff, nI as IconMobileScreenShare, pI as IconMode, cI as IconModeComment, fI as IconModelTraining, gI as IconMonetizationOn, MI as IconMoney, VI as IconMoneyOff, wI as IconMoneyOffCsred, II as IconMonochromePhotos, yI as IconMood, vI as IconMoodBad, ZI as IconMoped, YI as IconMore, WI as IconMoreHoriz, DI as IconMoreTime, SI as IconMoreVert, TI as IconMotionPhotosOn, EI as IconMotionPhotosPause, _I as IconMotionPhotosPaused, UI as IconMouse, XI as IconMoveToInbox, RI as IconMovie, qI as IconMovieCreation, JI as IconMovieFilter, oL as IconMultilineChart, rL as IconMultipleStop, sL as IconMuseum, nL as IconMusicNote, cL as IconMusicOff, pL as IconMusicVideo, fL as IconMyLocation, gL as IconNat, VL as IconNature, wL as IconNaturePeople, ML as IconNavigateBefore, IL as IconNavigateNext, vL as IconNavigation, ZL as IconNearMe, yL as IconNearMeDisabled, WL as IconNetworkCheck, DL as IconNetworkLocked, SL as IconNewReleases, YL as IconNextPlan, TL as IconNextWeek, EL as IconNfc, _L as IconNightShelter, UL as IconNightsStay, XL as IconNoBackpack, qL as IconNoCell, JL as IconNoDrinks, ov as IconNoEncryption, RL as IconNoEncryptionGmailerrorred, rv as IconNoFlash, sv as IconNoFood, nv as IconNoLuggage, cv as IconNoMeals, pv as IconNoMeetingRoom, fv as IconNoPhotography, gv as IconNoSim, wv as IconNoStroller, Vv as IconNoTransfer, vv as IconNorth, Mv as IconNorthEast, Iv as IconNorthWest, yv as IconNotAccessible, Zv as IconNotInterested, Wv as IconNotListedLocation, Dv as IconNotStarted, Yv as IconNote, Sv as IconNoteAdd, Tv as IconNotes, Ev as IconNotificationImportant, Jv as IconNotifications, _v as IconNotificationsActive, Uv as IconNotificationsNone, Xv as IconNotificationsOff, qv as IconNotificationsPaused, Rv as IconOfflineBolt, oN as IconOfflinePin, rN as IconOndemandVideo, sN as IconOnlinePrediction, nN as IconOpacity, cN as IconOpenInBrowser, pN as IconOpenInFull, fN as IconOpenInNew, gN as IconOpenWith, wN as IconOutbond, VN as IconOutdoorGrill, MN as IconOutlet, IN as IconOutlinedFlag, vN as IconPages, yN as IconPageview, ZN as IconPalette, WN as IconPanTool, EN as IconPanorama, DN as IconPanoramaFishEye, SN as IconPanoramaHorizontal, YN as IconPanoramaVertical, TN as IconPanoramaWideAngle, _N as IconPartyMode, JN as IconPause, UN as IconPauseCircleFilled, XN as IconPauseCircleOutline, qN as IconPausePresentation, RN as IconPayment, oy as IconPayments, ry as IconPedalBike, ny as IconPending, sy as IconPendingActions, fy as IconPeople, cy as IconPeopleAlt, py as IconPeopleOutline, gy as IconPermCameraMic, wy as IconPermContactCalendar, Vy as IconPermDataSetting, My as IconPermDeviceInformation, Iy as IconPermIdentity, vy as IconPermMedia, yy as IconPermPhoneMsg, Zy as IconPermScanWifi, qy as IconPerson, Sy as IconPersonAdd, Wy as IconPersonAddAlt_1, Dy as IconPersonAddDisabled, Yy as IconPersonOutline, Ey as IconPersonPin, Ty as IconPersonPinCircle, Uy as IconPersonRemove, _y as IconPersonRemoveAlt_1, Xy as IconPersonSearch, Jy as IconPersonalVideo, ob as IconPestControl, Ry as IconPestControlRodent, rb as IconPets, yb as IconPhone, sb as IconPhoneAndroid, nb as IconPhoneBluetoothSpeaker, cb as IconPhoneCallback, pb as IconPhoneDisabled, fb as IconPhoneEnabled, gb as IconPhoneForwarded, wb as IconPhoneInTalk, Vb as IconPhoneIphone, Mb as IconPhoneLocked, Ib as IconPhoneMissed, vb as IconPhonePaused, Tb as IconPhonelink, Zb as IconPhonelinkErase, Wb as IconPhonelinkLock, Db as IconPhonelinkOff, Sb as IconPhonelinkRing, Yb as IconPhonelinkSetup, oZ as IconPhoto, Eb as IconPhotoAlbum, _b as IconPhotoCamera, Ub as IconPhotoFilter, Xb as IconPhotoLibrary, qb as IconPhotoSizeSelectActual, Jb as IconPhotoSizeSelectLarge, Rb as IconPhotoSizeSelectSmall, rZ as IconPictureAsPdf, nZ as IconPictureInPicture, sZ as IconPictureInPictureAlt, pZ as IconPieChart, cZ as IconPieChartOutline, fZ as IconPinDrop, gZ as IconPlace, wZ as IconPlagiarism, VZ as IconPlayArrow, MZ as IconPlayCircleFilled, IZ as IconPlayCircleOutline, vZ as IconPlayForWork, ZZ as IconPlaylistAdd, yZ as IconPlaylistAddCheck, WZ as IconPlaylistPlay, DZ as IconPlumbing, SZ as IconPlusOne, YZ as IconPointOfSale, TZ as IconPolicy, EZ as IconPoll, _Z as IconPolymer, UZ as IconPool, XZ as IconPortableWifiOff, qZ as IconPortrait, JZ as IconPostAdd, sB as IconPower, RZ as IconPowerInput, oB as IconPowerOff, rB as IconPowerSettingsNew, nB as IconPrecisionManufacturing, cB as IconPregnantWoman, pB as IconPresentToAll, fB as IconPreview, wB as IconPrint, gB as IconPrintDisabled, VB as IconPriorityHigh, MB as IconPrivacyTip, IB as IconPsychology, yB as IconPublic, vB as IconPublicOff, ZB as IconPublish, WB as IconPublishedWithChanges, DB as IconPushPin, YB as IconQrCode, SB as IconQrCodeScanner, TB as IconQueryBuilder, EB as IconQuestionAnswer, XB as IconQueue, _B as IconQueueMusic, UB as IconQueuePlayNext, qB as IconQuickreply, oW as IconRadio, JB as IconRadioButtonChecked, RB as IconRadioButtonUnchecked, rW as IconRateReview, sW as IconReadMore, cW as IconReceipt, nW as IconReceiptLong, pW as IconRecentActors, fW as IconRecordVoiceOver, gW as IconRedeem, wW as IconRedo, VW as IconReduceCapacity, MW as IconRefresh, Pt as IconRemove, vW as IconRemoveCircle, IW as IconRemoveCircleOutline, yW as IconRemoveFromQueue, ZW as IconRemoveRedEye, WW as IconRemoveShoppingCart, PW as IconReorder, FW as IconRepeat, jW as IconRepeatOne, zW as IconReplay, AW as IconReplay_10, OW as IconReplay_30, GW as IconReplay_5, QW as IconReply, KW as IconReplyAll, ik as IconReport, $W as IconReportGmailerrorred, ek as IconReportOff, tk as IconReportProblem, ak as IconRequestPage, mk as IconRequestQuote, hk as IconRestaurant, lk as IconRestaurantMenu, dk as IconRestore, Ck as IconRestoreFromTrash, uk as IconRestorePage, Hk as IconRingVolume, xk as IconRoofing, bk as IconRoom, Lk as IconRoomPreferences, Nk as IconRoomService, kk as IconRotateLeft, Pk as IconRotateRight, Bk as IconRotate_90DegreesCcw, jk as IconRoundedCorner, Fk as IconRouter, Ak as IconRowing, Ok as IconRssFeed, zk as IconRule, Gk as IconRuleFolder, Kk as IconRunCircle, Qk as IconRvHookup, $k as IconSanitizer, eD as IconSatellite, iD as IconSave, tD as IconSaveAlt, aD as IconScanner, mD as IconScatterPlot, lD as IconSchedule, hD as IconSchool, CD as IconScience, uD as IconScore, dD as IconScreenLockLandscape, HD as IconScreenLockPortrait, xD as IconScreenLockRotation, LD as IconScreenRotation, ND as IconScreenShare, BD as IconSdCard, bD as IconSdCardAlert, kD as IconSdStorage, St as IconSearch, PD as IconSearchOff, YD as IconSecurity, TD as IconSelectAll, ED as IconSelfImprovement, _D as IconSend, UD as IconSensorDoor, XD as IconSensorWindow, qD as IconSentimentDissatisfied, JD as IconSentimentNeutral, oP as IconSentimentSatisfied, RD as IconSentimentSatisfiedAlt, rP as IconSentimentVeryDissatisfied, sP as IconSentimentVerySatisfied, nP as IconSetMeal, _P as IconSettings, cP as IconSettingsApplications, pP as IconSettingsBackupRestore, fP as IconSettingsBluetooth, gP as IconSettingsBrightness, wP as IconSettingsCell, VP as IconSettingsEthernet, MP as IconSettingsInputAntenna, IP as IconSettingsInputComponent, vP as IconSettingsInputComposite, yP as IconSettingsInputHdmi, ZP as IconSettingsInputSvideo, WP as IconSettingsOverscan, DP as IconSettingsPhone, SP as IconSettingsPower, YP as IconSettingsRemote, TP as IconSettingsSystemDaydream, EP as IconSettingsVoice, UP as IconShare, qP as IconShop, XP as IconShopTwo, JP as IconShoppingBag, RP as IconShoppingBasket, oS as IconShoppingCart, rS as IconShortText, sS as IconShowChart, nS as IconShuffle, cS as IconShutterSpeed, pS as IconSick, gS as IconSignalCellularAlt, wS as IconSignalCellularConnectedNoInternet_4Bar, VS as IconSignalCellularNoSim, MS as IconSignalCellularNull, IS as IconSignalCellularOff, fS as IconSignalCellular_4Bar, ZS as IconSignalWifiOff, yS as IconSignalWifi_4Bar, vS as IconSignalWifi_4BarLock, WS as IconSimCard, DS as IconSingleBed, SS as IconSkipNext, YS as IconSkipPrevious, TS as IconSlideshow, ES as IconSlowMotionVideo, _S as IconSmartButton, US as IconSmartphone, XS as IconSmokeFree, qS as IconSmokingRooms, RS as IconSms, JS as IconSmsFailed, oj as IconSnippetFolder, rj as IconSnooze, sj as IconSoap, cj as IconSort, nj as IconSortByAlpha, pj as IconSource, wj as IconSouth, fj as IconSouthEast, gj as IconSouthWest, Vj as IconSpa, Mj as IconSpaceBar, Wj as IconSpeaker, Ij as IconSpeakerGroup, yj as IconSpeakerNotes, vj as IconSpeakerNotesOff, Zj as IconSpeakerPhone, Dj as IconSpeed, Sj as IconSpellcheck, gY as IconSports, Yj as IconSportsBar, Tj as IconSportsBaseball, Ej as IconSportsBasketball, _j as IconSportsCricket, Uj as IconSportsEsports, Xj as IconSportsFootball, qj as IconSportsGolf, Jj as IconSportsHandball, Rj as IconSportsHockey, oY as IconSportsKabaddi, rY as IconSportsMma, sY as IconSportsMotorsports, nY as IconSportsRugby, cY as IconSportsSoccer, pY as IconSportsTennis, fY as IconSportsVolleyball, wY as IconSquareFoot, VY as IconStackedLineChart, MY as IconStairs, jt as IconStar, vY as IconStarBorder, IY as IconStarBorderPurple500, yY as IconStarHalf, ZY as IconStarOutline, WY as IconStarPurple500, DY as IconStarRate, jY as IconStars, FY as IconStayCurrentLandscape, AY as IconStayCurrentPortrait, OY as IconStayPrimaryLandscape, GY as IconStayPrimaryPortrait, zY as IconStickyNote_2, $Y as IconStop, KY as IconStopCircle, QY as IconStopScreenShare, eF as IconStorage, iF as IconStore, tF as IconStoreMallDirectory, aF as IconStorefront, mF as IconStraighten, lF as IconStreetview, hF as IconStrikethroughS, CF as IconStroller, uF as IconStyle, dF as IconSubdirectoryArrowLeft, HF as IconSubdirectoryArrowRight, xF as IconSubject, LF as IconSubscript, NF as IconSubscriptions, BF as IconSubtitles, bF as IconSubtitlesOff, kF as IconSubway, PF as IconSuperscript, jF as IconSupervisedUserCircle, FF as IconSupervisorAccount, OF as IconSupport, AF as IconSupportAgent, GF as IconSurroundSound, zF as IconSwapCalls, KF as IconSwapHoriz, QF as IconSwapHorizontalCircle, $F as IconSwapVert, eT as IconSwapVerticalCircle, tT as IconSwitchCamera, iT as IconSwitchLeft, aT as IconSwitchRight, mT as IconSwitchVideo, uT as IconSync, lT as IconSyncAlt, hT as IconSyncDisabled, CT as IconSyncProblem, HT as IconSystemUpdate, dT as IconSystemUpdateAlt, LT as IconTab, xT as IconTabUnselected, NT as IconTableChart, bT as IconTableRows, BT as IconTableView, jT as IconTablet, kT as IconTabletAndroid, PT as IconTabletMac, FT as IconTagFaces, AT as IconTapAndPlay, OT as IconTapas, GT as IconTerrain, zT as IconTextFields, KT as IconTextFormat, QT as IconTextRotateUp, $T as IconTextRotateVertical, eA as IconTextRotationAngledown, tA as IconTextRotationAngleup, iA as IconTextRotationDown, aA as IconTextRotationNone, mA as IconTextSnippet, lA as IconTextsms, hA as IconTexture, CA as IconTheaters, uA as IconThermostat, HA as IconThumbDown, dA as IconThumbDownAlt, LA as IconThumbUp, xA as IconThumbUpAlt, NA as IconThumbsUpDown, bA as IconTimeToLeave, BA as IconTimelapse, kA as IconTimeline, AA as IconTimer, FA as IconTimerOff, PA as IconTimer_10, jA as IconTimer_3, OA as IconTitle, GA as IconToc, zA as IconToday, KA as IconToggleOff, QA as IconToggleOn, $A as IconToll, eE as IconTonality, tE as IconTopic, iE as IconTouchApp, aE as IconTour, mE as IconToys, lE as IconTrackChanges, hE as IconTraffic, CE as IconTrain, uE as IconTram, dE as IconTransferWithinAStation, HE as IconTransform, xE as IconTransitEnterexit, LE as IconTranslate, NE as IconTrendingDown, bE as IconTrendingFlat, BE as IconTrendingUp, kE as IconTripOrigin, PE as IconTty, jE as IconTune, AE as IconTurnedIn, FE as IconTurnedInNot, GE as IconTv, OE as IconTvOff, zE as IconTwoWheeler, KE as IconUmbrella, QE as IconUnarchive, $E as IconUndo, eO as IconUnfoldLess, tO as IconUnfoldMore, iO as IconUnpublished, aO as IconUnsubscribe, mO as IconUpdate, lO as IconUpgrade, hO as IconUpload, CO as IconUsb, dO as IconVerified, uO as IconVerifiedUser, HO as IconVerticalAlignBottom, xO as IconVerticalAlignCenter, LO as IconVerticalAlignTop, NO as IconVerticalSplit, bO as IconVibration, BO as IconVideoCall, kO as IconVideoLabel, PO as IconVideoLibrary, jO as IconVideoSettings, AO as IconVideocam, FO as IconVideocamOff, OO as IconVideogameAsset, GO as IconViewAgenda, zO as IconViewArray, KO as IconViewCarousel, QO as IconViewColumn, $O as IconViewComfy, e_ as IconViewCompact, t_ as IconViewDay, i_ as IconViewHeadline, a_ as IconViewList, m_ as IconViewModule, l_ as IconViewQuilt, h_ as IconViewSidebar, C_ as IconViewStream, u_ as IconViewWeek, d_ as IconVignette, Ft as IconVisibility, Yt as IconVisibilityOff, x_ as IconVoiceChat, L_ as IconVoiceOverOff, N_ as IconVoicemail, b_ as IconVolumeDown, B_ as IconVolumeMute, k_ as IconVolumeOff, P_ as IconVolumeUp, j_ as IconVpnKey, F_ as IconVpnLock, A_ as IconWallpaper, Tt as IconWarning, O_ as IconWarningAmber, U_ as IconWash, q_ as IconWatch, X_ as IconWatchLater, J_ as IconWaterDamage, R_ as IconWaves, oG as IconWbAuto, rG as IconWbCloudy, sG as IconWbIncandescent, nG as IconWbIridescent, cG as IconWbSunny, pG as IconWc, gG as IconWeb, fG as IconWebAsset, wG as IconWeekend, VG as IconWest, MG as IconWhatshot, IG as IconWheelchairPickup, vG as IconWhereToVote, yG as IconWidgets, TG as IconWifi, ZG as IconWifiCalling, WG as IconWifiLock, DG as IconWifiOff, SG as IconWifiProtectedSetup, YG as IconWifiTethering, EG as IconWineBar, XG as IconWork, _G as IconWorkOff, UG as IconWorkOutline, qG as IconWrapText, JG as IconWrongLocation, RG as IconWysiwyg, oU as IconYoutubeSearchedFor, rU as IconZoomIn, nU as IconZoomOut, sU as IconZoomOutMap, ko as Image, Po as Link, ue as Loader, jo as Menu, oe as MenuButton, Yo as MenuItem, ye as Pagination, ke as PasswordField, Pe as PhoneNumberField, To as Placeholder, Se as Radio, je as RadioGroupField, Eo as Rating, _o as ScrollView, Be as SearchField, De as SelectField, i1 as SharedText, Go as SliderField, Uo as StepperField, zo as SwitchField, le as TabItem, ei as Table, oi as TableBody, ti as TableCell, ri as TableFoot, ii as TableHead, si as TableRow, Ye as Tabs, G as Text, $o as TextAreaField, g1 as TextField, ot as ToggleButton, tt as ToggleButtonGroup, c as View, e1 as VisuallyHidden, xi as components, PVo as createTheme, DVo as defaultTheme, li as primitives, SVo as translations, zi as useAmplify, N as useAuthenticator, Ke as usePagination, Ht as useTheme, Mi as withAuthenticator };